(function () {
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire984b"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire984b"] = parcelRequire;
}
parcelRequire.register("3vtib", function(module, exports) {

module.exports = (parcelRequire("17nTN"));

});
parcelRequire.register("17nTN", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $1o4IC = parcelRequire("1o4IC");

var $evY07 = parcelRequire("evY07");

var $akViX = parcelRequire("akViX");

var $25qme = parcelRequire("25qme");

var $0d08fbbf58b0d8eb$var$_promise = $3Npdz((parcelRequire("bCWDe")));

var $0d08fbbf58b0d8eb$var$_decode = $3Npdz((parcelRequire("7CFxK")));

var $0d08fbbf58b0d8eb$var$_encode = $3Npdz((parcelRequire("gM4ym")));

var $0d08fbbf58b0d8eb$var$_CoreManager = $3Npdz((parcelRequire("465CW")));

var $0d08fbbf58b0d8eb$var$_CryptoController = $3Npdz((parcelRequire("7jja0")));

var $0d08fbbf58b0d8eb$var$_EventuallyQueue = $3Npdz((parcelRequire("3gAuF")));

var $0d08fbbf58b0d8eb$var$_InstallationController = $3Npdz((parcelRequire("eqNh5")));

var $0d08fbbf58b0d8eb$var$ParseOp = $0d08fbbf58b0d8eb$var$_interopRequireWildcard((parcelRequire("1WcLm")));

var $0d08fbbf58b0d8eb$var$_RESTController = $3Npdz((parcelRequire("hBLOK")));
function $0d08fbbf58b0d8eb$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof $25qme !== "function") return null;
    var cacheBabelInterop = new $25qme();
    var cacheNodeInterop = new $25qme();
    return ($0d08fbbf58b0d8eb$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $0d08fbbf58b0d8eb$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $akViX(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $0d08fbbf58b0d8eb$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = $evY07 && $1o4IC ? $1o4IC(obj, key) : null;
        if (desc && (desc.get || desc.set)) $evY07(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */ /**
 * Contains all Parse API classes and functions.
 *
 * @static
 * @global
 * @class
 * @hideconstructor
 */ var $0d08fbbf58b0d8eb$var$Parse = {
    /**
   * Call this method first to set up your authentication tokens for Parse.
   *
   * @param {string} applicationId Your Parse Application ID.
   * @param {string} [javaScriptKey] Your Parse JavaScript Key (Not needed for parse-server)
   * @param {string} [masterKey] Your Parse Master Key. (Node.js only!)
   * @static
   */ initialize: function(applicationId, javaScriptKey) {
        if ($0d08fbbf58b0d8eb$var$_CoreManager.default.get("IS_NODE") && true) /* eslint-disable no-console */ console.log("It looks like you're using the browser version of the SDK in a node.js environment. You should require('parse/node') instead.");
        $0d08fbbf58b0d8eb$var$Parse._initialize(applicationId, javaScriptKey);
    },
    _initialize: function(applicationId, javaScriptKey, masterKey) {
        $0d08fbbf58b0d8eb$var$_CoreManager.default.set("APPLICATION_ID", applicationId);
        $0d08fbbf58b0d8eb$var$_CoreManager.default.set("JAVASCRIPT_KEY", javaScriptKey);
        $0d08fbbf58b0d8eb$var$_CoreManager.default.set("MASTER_KEY", masterKey);
        $0d08fbbf58b0d8eb$var$_CoreManager.default.set("USE_MASTER_KEY", false);
    },
    /**
   * Call this method to set your AsyncStorage engine
   * Starting Parse@1.11, the ParseSDK do not provide a React AsyncStorage as the ReactNative module
   * is not provided at a stable path and changes over versions.
   *
   * @param {AsyncStorage} storage a react native async storage.
   * @static
   */ setAsyncStorage: function(storage) {
        $0d08fbbf58b0d8eb$var$_CoreManager.default.setAsyncStorage(storage);
    },
    /**
   * Call this method to set your LocalDatastoreStorage engine
   * If using React-Native use {@link Parse.setAsyncStorage Parse.setAsyncStorage()}
   *
   * @param {LocalDatastoreController} controller a data storage.
   * @static
   */ setLocalDatastoreController: function(controller) {
        $0d08fbbf58b0d8eb$var$_CoreManager.default.setLocalDatastoreController(controller);
    },
    /**
   * Returns information regarding the current server's health
   *
   * @returns {Promise}
   * @static
   */ getServerHealth: function() {
        return $0d08fbbf58b0d8eb$var$_CoreManager.default.getRESTController().request("GET", "health");
    },
    /**
   * @member {string} Parse.applicationId
   * @static
   */ set applicationId (value){
        $0d08fbbf58b0d8eb$var$_CoreManager.default.set("APPLICATION_ID", value);
    },
    get applicationId () {
        return $0d08fbbf58b0d8eb$var$_CoreManager.default.get("APPLICATION_ID");
    },
    /**
   * @member {string} Parse.javaScriptKey
   * @static
   */ set javaScriptKey (value){
        $0d08fbbf58b0d8eb$var$_CoreManager.default.set("JAVASCRIPT_KEY", value);
    },
    get javaScriptKey () {
        return $0d08fbbf58b0d8eb$var$_CoreManager.default.get("JAVASCRIPT_KEY");
    },
    /**
   * @member {string} Parse.masterKey
   * @static
   */ set masterKey (value){
        $0d08fbbf58b0d8eb$var$_CoreManager.default.set("MASTER_KEY", value);
    },
    get masterKey () {
        return $0d08fbbf58b0d8eb$var$_CoreManager.default.get("MASTER_KEY");
    },
    /**
   * @member {string} Parse.serverURL
   * @static
   */ set serverURL (value){
        $0d08fbbf58b0d8eb$var$_CoreManager.default.set("SERVER_URL", value);
    },
    get serverURL () {
        return $0d08fbbf58b0d8eb$var$_CoreManager.default.get("SERVER_URL");
    },
    /**
   * @member {string} Parse.serverAuthToken
   * @static
   */ set serverAuthToken (value){
        $0d08fbbf58b0d8eb$var$_CoreManager.default.set("SERVER_AUTH_TOKEN", value);
    },
    get serverAuthToken () {
        return $0d08fbbf58b0d8eb$var$_CoreManager.default.get("SERVER_AUTH_TOKEN");
    },
    /**
   * @member {string} Parse.serverAuthType
   * @static
   */ set serverAuthType (value){
        $0d08fbbf58b0d8eb$var$_CoreManager.default.set("SERVER_AUTH_TYPE", value);
    },
    get serverAuthType () {
        return $0d08fbbf58b0d8eb$var$_CoreManager.default.get("SERVER_AUTH_TYPE");
    },
    /**
   * @member {string} Parse.liveQueryServerURL
   * @static
   */ set liveQueryServerURL (value){
        $0d08fbbf58b0d8eb$var$_CoreManager.default.set("LIVEQUERY_SERVER_URL", value);
    },
    get liveQueryServerURL () {
        return $0d08fbbf58b0d8eb$var$_CoreManager.default.get("LIVEQUERY_SERVER_URL");
    },
    /**
   * @member {string} Parse.encryptedUser
   * @static
   */ set encryptedUser (value){
        $0d08fbbf58b0d8eb$var$_CoreManager.default.set("ENCRYPTED_USER", value);
    },
    get encryptedUser () {
        return $0d08fbbf58b0d8eb$var$_CoreManager.default.get("ENCRYPTED_USER");
    },
    /**
   * @member {string} Parse.secret
   * @static
   */ set secret (value){
        $0d08fbbf58b0d8eb$var$_CoreManager.default.set("ENCRYPTED_KEY", value);
    },
    get secret () {
        return $0d08fbbf58b0d8eb$var$_CoreManager.default.get("ENCRYPTED_KEY");
    },
    /**
   * @member {boolean} Parse.idempotency
   * @static
   */ set idempotency (value){
        $0d08fbbf58b0d8eb$var$_CoreManager.default.set("IDEMPOTENCY", value);
    },
    get idempotency () {
        return $0d08fbbf58b0d8eb$var$_CoreManager.default.get("IDEMPOTENCY");
    },
    /**
   * @member {boolean} Parse.allowCustomObjectId
   * @static
   */ set allowCustomObjectId (value){
        $0d08fbbf58b0d8eb$var$_CoreManager.default.set("ALLOW_CUSTOM_OBJECT_ID", value);
    },
    get allowCustomObjectId () {
        return $0d08fbbf58b0d8eb$var$_CoreManager.default.get("ALLOW_CUSTOM_OBJECT_ID");
    }
};

$0d08fbbf58b0d8eb$var$Parse.ACL = (parcelRequire("9HvHn")).default;

$0d08fbbf58b0d8eb$var$Parse.Analytics = (parcelRequire("i6I5N"));

$0d08fbbf58b0d8eb$var$Parse.AnonymousUtils = (parcelRequire("9Fxsf")).default;

$0d08fbbf58b0d8eb$var$Parse.Cloud = (parcelRequire("7M26W"));

$0d08fbbf58b0d8eb$var$Parse.CLP = (parcelRequire("2wtte")).default;

$0d08fbbf58b0d8eb$var$Parse.CoreManager = (parcelRequire("465CW"));

$0d08fbbf58b0d8eb$var$Parse.Config = (parcelRequire("bIIcS")).default;

$0d08fbbf58b0d8eb$var$Parse.Error = (parcelRequire("3HQSG")).default;
$0d08fbbf58b0d8eb$var$Parse.EventuallyQueue = $0d08fbbf58b0d8eb$var$_EventuallyQueue.default;

$0d08fbbf58b0d8eb$var$Parse.FacebookUtils = (parcelRequire("9X9a0")).default;

$0d08fbbf58b0d8eb$var$Parse.File = (parcelRequire("gf3Ge")).default;

$0d08fbbf58b0d8eb$var$Parse.GeoPoint = (parcelRequire("5vhig")).default;

$0d08fbbf58b0d8eb$var$Parse.Polygon = (parcelRequire("dkxwb")).default;

$0d08fbbf58b0d8eb$var$Parse.Installation = (parcelRequire("9QDBo")).default;

$0d08fbbf58b0d8eb$var$Parse.LocalDatastore = (parcelRequire("fkiJv"));

$0d08fbbf58b0d8eb$var$Parse.Object = (parcelRequire("2HIpX")).default;
$0d08fbbf58b0d8eb$var$Parse.Op = {
    Set: $0d08fbbf58b0d8eb$var$ParseOp.SetOp,
    Unset: $0d08fbbf58b0d8eb$var$ParseOp.UnsetOp,
    Increment: $0d08fbbf58b0d8eb$var$ParseOp.IncrementOp,
    Add: $0d08fbbf58b0d8eb$var$ParseOp.AddOp,
    Remove: $0d08fbbf58b0d8eb$var$ParseOp.RemoveOp,
    AddUnique: $0d08fbbf58b0d8eb$var$ParseOp.AddUniqueOp,
    Relation: $0d08fbbf58b0d8eb$var$ParseOp.RelationOp
};

$0d08fbbf58b0d8eb$var$Parse.Push = (parcelRequire("jNOW9"));

$0d08fbbf58b0d8eb$var$Parse.Query = (parcelRequire("eJCLn")).default;

$0d08fbbf58b0d8eb$var$Parse.Relation = (parcelRequire("4Glkc")).default;

$0d08fbbf58b0d8eb$var$Parse.Role = (parcelRequire("62sYC")).default;

$0d08fbbf58b0d8eb$var$Parse.Schema = (parcelRequire("fz5kg")).default;

$0d08fbbf58b0d8eb$var$Parse.Session = (parcelRequire("afk0M")).default;

$0d08fbbf58b0d8eb$var$Parse.Storage = (parcelRequire("7Zbj0"));

$0d08fbbf58b0d8eb$var$Parse.User = (parcelRequire("8mqMW")).default;

$0d08fbbf58b0d8eb$var$Parse.LiveQuery = (parcelRequire("3ErMa")).default;

$0d08fbbf58b0d8eb$var$Parse.LiveQueryClient = (parcelRequire("ktcBb")).default;

$0d08fbbf58b0d8eb$var$Parse.IndexedDB = (parcelRequire("ekY3G"));
$0d08fbbf58b0d8eb$var$Parse._request = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return $0d08fbbf58b0d8eb$var$_CoreManager.default.getRESTController().request.apply(null, args);
};
$0d08fbbf58b0d8eb$var$Parse._ajax = function() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    return $0d08fbbf58b0d8eb$var$_CoreManager.default.getRESTController().ajax.apply(null, args);
}; // We attempt to match the signatures of the legacy versions of these methods
$0d08fbbf58b0d8eb$var$Parse._decode = function(_, value1) {
    return (0, $0d08fbbf58b0d8eb$var$_decode.default)(value1);
};
$0d08fbbf58b0d8eb$var$Parse._encode = function(value1, _, disallowObjects) {
    return (0, $0d08fbbf58b0d8eb$var$_encode.default)(value1, disallowObjects);
};
$0d08fbbf58b0d8eb$var$Parse._getInstallationId = function() {
    return $0d08fbbf58b0d8eb$var$_CoreManager.default.getInstallationController().currentInstallationId();
};
/**
 * Enable pinning in your application.
 * This must be called after `Parse.initialize` in your application.
 *
 * @param [polling] Allow pinging the server /health endpoint. Default true
 * @param [ms] Milliseconds to ping the server. Default 2000ms
 * @static
 */ $0d08fbbf58b0d8eb$var$Parse.enableLocalDatastore = function() {
    var polling = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var ms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2000;
    if (!$0d08fbbf58b0d8eb$var$Parse.applicationId) {
        console.log("'enableLocalDataStore' must be called after 'initialize'");
        return;
    }
    if (!$0d08fbbf58b0d8eb$var$Parse.LocalDatastore.isEnabled) {
        $0d08fbbf58b0d8eb$var$Parse.LocalDatastore.isEnabled = true;
        if (polling) $0d08fbbf58b0d8eb$var$_EventuallyQueue.default.poll(ms);
    }
};
/**
 * Flag that indicates whether Local Datastore is enabled.
 *
 * @static
 * @returns {boolean}
 */ $0d08fbbf58b0d8eb$var$Parse.isLocalDatastoreEnabled = function() {
    return $0d08fbbf58b0d8eb$var$Parse.LocalDatastore.isEnabled;
};
/**
 * Gets all contents from Local Datastore
 *
 * <pre>
 * await Parse.dumpLocalDatastore();
 * </pre>
 *
 * @static
 * @returns {object}
 */ $0d08fbbf58b0d8eb$var$Parse.dumpLocalDatastore = function() {
    if (!$0d08fbbf58b0d8eb$var$Parse.LocalDatastore.isEnabled) {
        console.log("Parse.enableLocalDatastore() must be called first"); // eslint-disable-line no-console
        return $0d08fbbf58b0d8eb$var$_promise.default.resolve({});
    } else return $0d08fbbf58b0d8eb$var$Parse.LocalDatastore._getAllContents();
};
/**
 * Enable the current user encryption.
 * This must be called before login any user.
 *
 * @static
 */ $0d08fbbf58b0d8eb$var$Parse.enableEncryptedUser = function() {
    $0d08fbbf58b0d8eb$var$Parse.encryptedUser = true;
};
/**
 * Flag that indicates whether Encrypted User is enabled.
 *
 * @static
 * @returns {boolean}
 */ $0d08fbbf58b0d8eb$var$Parse.isEncryptedUserEnabled = function() {
    return $0d08fbbf58b0d8eb$var$Parse.encryptedUser;
};
$0d08fbbf58b0d8eb$var$_CoreManager.default.setCryptoController($0d08fbbf58b0d8eb$var$_CryptoController.default);
$0d08fbbf58b0d8eb$var$_CoreManager.default.setInstallationController($0d08fbbf58b0d8eb$var$_InstallationController.default);
$0d08fbbf58b0d8eb$var$_CoreManager.default.setRESTController($0d08fbbf58b0d8eb$var$_RESTController.default);
// For legacy requires, of the form `var Parse = require('parse').Parse`
$0d08fbbf58b0d8eb$var$Parse.Parse = $0d08fbbf58b0d8eb$var$Parse;
module.exports = $0d08fbbf58b0d8eb$var$Parse;

});
parcelRequire.register("3Npdz", function(module, exports) {
function $2c3982718ebec362$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $2c3982718ebec362$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("1o4IC", function(module, exports) {

module.exports = (parcelRequire("3h5Yc"));

});
parcelRequire.register("3h5Yc", function(module, exports) {

var $9VOHU = parcelRequire("9VOHU");
module.exports = $9VOHU;

});
parcelRequire.register("9VOHU", function(module, exports) {
parcelRequire("23hVh");

var $envPC = parcelRequire("envPC");
var $73b0c55414a54382$var$Object = $envPC.Object;
var $73b0c55414a54382$var$getOwnPropertyDescriptor = module.exports = function getOwnPropertyDescriptor(it, key) {
    return $73b0c55414a54382$var$Object.getOwnPropertyDescriptor(it, key);
};
if ($73b0c55414a54382$var$Object.getOwnPropertyDescriptor.sham) $73b0c55414a54382$var$getOwnPropertyDescriptor.sham = true;

});
parcelRequire.register("23hVh", function(module, exports) {

var $g2B3u = parcelRequire("g2B3u");

var $avKuJ = parcelRequire("avKuJ");

var $1YJYD = parcelRequire("1YJYD");

var $6IpKK = parcelRequire("6IpKK");
var $17e9c3b408d079a6$require$nativeGetOwnPropertyDescriptor = $6IpKK.f;

var $99D40 = parcelRequire("99D40");
var $17e9c3b408d079a6$var$FORCED = !$99D40 || $avKuJ(function() {
    $17e9c3b408d079a6$require$nativeGetOwnPropertyDescriptor(1);
});
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$g2B3u({
    target: "Object",
    stat: true,
    forced: $17e9c3b408d079a6$var$FORCED,
    sham: !$99D40
}, {
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
        return $17e9c3b408d079a6$require$nativeGetOwnPropertyDescriptor($1YJYD(it), key);
    }
});

});
parcelRequire.register("g2B3u", function(module, exports) {
"use strict";

var $6gFRb = parcelRequire("6gFRb");

var $9YGjW = parcelRequire("9YGjW");

var $fCzmA = parcelRequire("fCzmA");

var $6kYHq = parcelRequire("6kYHq");

var $6IpKK = parcelRequire("6IpKK");
var $bad993a78813b25a$require$getOwnPropertyDescriptor = $6IpKK.f;

var $uEW8O = parcelRequire("uEW8O");

var $envPC = parcelRequire("envPC");

var $2B9V4 = parcelRequire("2B9V4");

var $l3ouT = parcelRequire("l3ouT");

var $dydfX = parcelRequire("dydfX");
var $bad993a78813b25a$var$wrapConstructor = function(NativeConstructor) {
    var Wrapper = function(a, b, c) {
        if (this instanceof Wrapper) {
            switch(arguments.length){
                case 0:
                    return new NativeConstructor();
                case 1:
                    return new NativeConstructor(a);
                case 2:
                    return new NativeConstructor(a, b);
            }
            return new NativeConstructor(a, b, c);
        }
        return $9YGjW(NativeConstructor, this, arguments);
    };
    Wrapper.prototype = NativeConstructor.prototype;
    return Wrapper;
};
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ module.exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var PROTO = options.proto;
    var nativeSource = GLOBAL ? $6gFRb : STATIC ? $6gFRb[TARGET] : ($6gFRb[TARGET] || {}).prototype;
    var target = GLOBAL ? $envPC : $envPC[TARGET] || $l3ouT($envPC, TARGET, {})[TARGET];
    var targetPrototype = target.prototype;
    var FORCED, USE_NATIVE, VIRTUAL_PROTOTYPE;
    var key, sourceProperty, targetProperty, nativeProperty, resultProperty, descriptor;
    for(key in source){
        FORCED = $uEW8O(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contains in native
        USE_NATIVE = !FORCED && nativeSource && $dydfX(nativeSource, key);
        targetProperty = target[key];
        if (USE_NATIVE) {
            if (options.dontCallGetSet) {
                descriptor = $bad993a78813b25a$require$getOwnPropertyDescriptor(nativeSource, key);
                nativeProperty = descriptor && descriptor.value;
            } else nativeProperty = nativeSource[key];
        }
        // export native or implementation
        sourceProperty = USE_NATIVE && nativeProperty ? nativeProperty : source[key];
        if (USE_NATIVE && typeof targetProperty == typeof sourceProperty) continue;
        // bind methods to global for calling from export context
        if (options.bind && USE_NATIVE) resultProperty = $2B9V4(sourceProperty, $6gFRb);
        else if (options.wrap && USE_NATIVE) resultProperty = $bad993a78813b25a$var$wrapConstructor(sourceProperty);
        else if (PROTO && $6kYHq(sourceProperty)) resultProperty = $fCzmA(sourceProperty);
        else resultProperty = sourceProperty;
        // add a flag to not completely full polyfills
        if (options.sham || sourceProperty && sourceProperty.sham || targetProperty && targetProperty.sham) $l3ouT(resultProperty, "sham", true);
        $l3ouT(target, key, resultProperty);
        if (PROTO) {
            VIRTUAL_PROTOTYPE = TARGET + "Prototype";
            if (!$dydfX($envPC, VIRTUAL_PROTOTYPE)) $l3ouT($envPC, VIRTUAL_PROTOTYPE, {});
            // export virtual prototype methods
            $l3ouT($envPC[VIRTUAL_PROTOTYPE], key, sourceProperty);
            // export real prototype methods
            if (options.real && targetPrototype && (FORCED || !targetPrototype[key])) $l3ouT(targetPrototype, key, sourceProperty);
        }
    }
};

});
parcelRequire.register("6gFRb", function(module, exports) {
var $4904b4928044d138$var$check = function(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports = // eslint-disable-next-line es/no-global-this -- safe
$4904b4928044d138$var$check(typeof globalThis == "object" && globalThis) || $4904b4928044d138$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$4904b4928044d138$var$check(typeof self == "object" && self) || $4904b4928044d138$var$check(typeof $parcel$global == "object" && $parcel$global) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || module.exports || Function("return this")();

});

parcelRequire.register("9YGjW", function(module, exports) {

var $ag2S4 = parcelRequire("ag2S4");
var $743a8ba35b958003$var$FunctionPrototype = Function.prototype;
var $743a8ba35b958003$var$apply = $743a8ba35b958003$var$FunctionPrototype.apply;
var $743a8ba35b958003$var$call = $743a8ba35b958003$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-reflect -- safe
module.exports = typeof Reflect == "object" && Reflect.apply || ($ag2S4 ? $743a8ba35b958003$var$call.bind($743a8ba35b958003$var$apply) : function() {
    return $743a8ba35b958003$var$call.apply($743a8ba35b958003$var$apply, arguments);
});

});
parcelRequire.register("ag2S4", function(module, exports) {

var $avKuJ = parcelRequire("avKuJ");
module.exports = !$avKuJ(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});

});
parcelRequire.register("avKuJ", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};

});



parcelRequire.register("fCzmA", function(module, exports) {

var $1SBP2 = parcelRequire("1SBP2");

var $7tcts = parcelRequire("7tcts");
module.exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($1SBP2(fn) === "Function") return $7tcts(fn);
};

});
parcelRequire.register("1SBP2", function(module, exports) {

var $7tcts = parcelRequire("7tcts");
var $15e82c4ad10ac9ca$var$toString = $7tcts({}.toString);
var $15e82c4ad10ac9ca$var$stringSlice = $7tcts("".slice);
module.exports = function(it) {
    return $15e82c4ad10ac9ca$var$stringSlice($15e82c4ad10ac9ca$var$toString(it), 8, -1);
};

});
parcelRequire.register("7tcts", function(module, exports) {

var $ag2S4 = parcelRequire("ag2S4");
var $5704eaf54e92890e$var$FunctionPrototype = Function.prototype;
var $5704eaf54e92890e$var$call = $5704eaf54e92890e$var$FunctionPrototype.call;
var $5704eaf54e92890e$var$uncurryThisWithBind = $ag2S4 && $5704eaf54e92890e$var$FunctionPrototype.bind.bind($5704eaf54e92890e$var$call, $5704eaf54e92890e$var$call);
module.exports = $ag2S4 ? $5704eaf54e92890e$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $5704eaf54e92890e$var$call.apply(fn, arguments);
    };
};

});



parcelRequire.register("6kYHq", function(module, exports) {

var $18Ywb = parcelRequire("18Ywb");
var $49d3b1f45754d4d8$var$documentAll = $18Ywb.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = $18Ywb.IS_HTMLDDA ? function(argument) {
    return typeof argument == "function" || argument === $49d3b1f45754d4d8$var$documentAll;
} : function(argument) {
    return typeof argument == "function";
};

});
parcelRequire.register("18Ywb", function(module, exports) {
var $0d557b6cafc87a00$var$documentAll = typeof document == "object" && document.all;
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var $0d557b6cafc87a00$var$IS_HTMLDDA = typeof $0d557b6cafc87a00$var$documentAll == "undefined" && $0d557b6cafc87a00$var$documentAll !== undefined;
module.exports = {
    all: $0d557b6cafc87a00$var$documentAll,
    IS_HTMLDDA: $0d557b6cafc87a00$var$IS_HTMLDDA
};

});


parcelRequire.register("6IpKK", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $4e3ad4267b3c4762$export$2d1720544b23b823; }, function (v) { return $4e3ad4267b3c4762$export$2d1720544b23b823 = v; });
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $4e3ad4267b3c4762$export$2d1720544b23b823;

var $99D40 = parcelRequire("99D40");

var $5qecd = parcelRequire("5qecd");

var $lqqOI = parcelRequire("lqqOI");

var $88IDB = parcelRequire("88IDB");

var $1YJYD = parcelRequire("1YJYD");

var $xDFpu = parcelRequire("xDFpu");

var $dydfX = parcelRequire("dydfX");

var $lqkHi = parcelRequire("lqkHi");
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $4e3ad4267b3c4762$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$4e3ad4267b3c4762$export$2d1720544b23b823 = $99D40 ? $4e3ad4267b3c4762$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $1YJYD(O);
    P = $xDFpu(P);
    if ($lqkHi) try {
        return $4e3ad4267b3c4762$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($dydfX(O, P)) return $88IDB(!$5qecd($lqqOI.f, O, P), O[P]);
};

});
parcelRequire.register("99D40", function(module, exports) {

var $avKuJ = parcelRequire("avKuJ");
// Detect IE8's incomplete defineProperty implementation
module.exports = !$avKuJ(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] != 7;
});

});

parcelRequire.register("5qecd", function(module, exports) {

var $ag2S4 = parcelRequire("ag2S4");
var $3f2a647f2f63c955$var$call = Function.prototype.call;
module.exports = $ag2S4 ? $3f2a647f2f63c955$var$call.bind($3f2a647f2f63c955$var$call) : function() {
    return $3f2a647f2f63c955$var$call.apply($3f2a647f2f63c955$var$call, arguments);
};

});

parcelRequire.register("lqqOI", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $f990d3f681a96096$export$2d1720544b23b823; }, function (v) { return $f990d3f681a96096$export$2d1720544b23b823 = v; });
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $f990d3f681a96096$export$2d1720544b23b823;
"use strict";
var $f990d3f681a96096$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $f990d3f681a96096$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $f990d3f681a96096$var$NASHORN_BUG = $f990d3f681a96096$var$getOwnPropertyDescriptor && !$f990d3f681a96096$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$f990d3f681a96096$export$2d1720544b23b823 = $f990d3f681a96096$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $f990d3f681a96096$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $f990d3f681a96096$var$$propertyIsEnumerable;

});

parcelRequire.register("88IDB", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});

parcelRequire.register("1YJYD", function(module, exports) {
// toObject with fallback for non-array-like ES3 strings

var $5LLAg = parcelRequire("5LLAg");

var $dfvEY = parcelRequire("dfvEY");
module.exports = function(it) {
    return $5LLAg($dfvEY(it));
};

});
parcelRequire.register("5LLAg", function(module, exports) {

var $7tcts = parcelRequire("7tcts");

var $avKuJ = parcelRequire("avKuJ");

var $1SBP2 = parcelRequire("1SBP2");
var $433640b34b9ef5d9$var$$Object = Object;
var $433640b34b9ef5d9$var$split = $7tcts("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = $avKuJ(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$433640b34b9ef5d9$var$$Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $1SBP2(it) == "String" ? $433640b34b9ef5d9$var$split(it, "") : $433640b34b9ef5d9$var$$Object(it);
} : $433640b34b9ef5d9$var$$Object;

});

parcelRequire.register("dfvEY", function(module, exports) {

var $9PkDw = parcelRequire("9PkDw");
var $9a553c0e8058247e$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function(it) {
    if ($9PkDw(it)) throw $9a553c0e8058247e$var$$TypeError("Can't call method on " + it);
    return it;
};

});
parcelRequire.register("9PkDw", function(module, exports) {
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function(it) {
    return it === null || it === undefined;
};

});



parcelRequire.register("xDFpu", function(module, exports) {

var $aQeIE = parcelRequire("aQeIE");

var $jpBNa = parcelRequire("jpBNa");
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function(argument) {
    var key = $aQeIE(argument, "string");
    return $jpBNa(key) ? key : key + "";
};

});
parcelRequire.register("aQeIE", function(module, exports) {

var $5qecd = parcelRequire("5qecd");

var $atGHr = parcelRequire("atGHr");

var $jpBNa = parcelRequire("jpBNa");

var $6aj4C = parcelRequire("6aj4C");

var $h8kne = parcelRequire("h8kne");

var $bpQhg = parcelRequire("bpQhg");
var $7e4a2da08a13d255$var$$TypeError = TypeError;
var $7e4a2da08a13d255$var$TO_PRIMITIVE = $bpQhg("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function(input, pref) {
    if (!$atGHr(input) || $jpBNa(input)) return input;
    var exoticToPrim = $6aj4C(input, $7e4a2da08a13d255$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $5qecd(exoticToPrim, input, pref);
        if (!$atGHr(result) || $jpBNa(result)) return result;
        throw $7e4a2da08a13d255$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $h8kne(input, pref);
};

});
parcelRequire.register("atGHr", function(module, exports) {

var $6kYHq = parcelRequire("6kYHq");

var $18Ywb = parcelRequire("18Ywb");
var $7a0dbc1518400ac2$var$documentAll = $18Ywb.all;
module.exports = $18Ywb.IS_HTMLDDA ? function(it) {
    return typeof it == "object" ? it !== null : $6kYHq(it) || it === $7a0dbc1518400ac2$var$documentAll;
} : function(it) {
    return typeof it == "object" ? it !== null : $6kYHq(it);
};

});

parcelRequire.register("jpBNa", function(module, exports) {

var $bTXoK = parcelRequire("bTXoK");

var $6kYHq = parcelRequire("6kYHq");

var $5L8hR = parcelRequire("5L8hR");

var $6oGDE = parcelRequire("6oGDE");
var $e21daad551cdb096$var$$Object = Object;
module.exports = $6oGDE ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $bTXoK("Symbol");
    return $6kYHq($Symbol) && $5L8hR($Symbol.prototype, $e21daad551cdb096$var$$Object(it));
};

});
parcelRequire.register("bTXoK", function(module, exports) {

var $envPC = parcelRequire("envPC");

var $6gFRb = parcelRequire("6gFRb");

var $6kYHq = parcelRequire("6kYHq");
var $8aa2e7fb8d81f3e2$var$aFunction = function(variable) {
    return $6kYHq(variable) ? variable : undefined;
};
module.exports = function(namespace, method) {
    return arguments.length < 2 ? $8aa2e7fb8d81f3e2$var$aFunction($envPC[namespace]) || $8aa2e7fb8d81f3e2$var$aFunction($6gFRb[namespace]) : $envPC[namespace] && $envPC[namespace][method] || $6gFRb[namespace] && $6gFRb[namespace][method];
};

});
parcelRequire.register("envPC", function(module, exports) {
module.exports = {};

});


parcelRequire.register("5L8hR", function(module, exports) {

var $7tcts = parcelRequire("7tcts");
module.exports = $7tcts({}.isPrototypeOf);

});

parcelRequire.register("6oGDE", function(module, exports) {
/* eslint-disable es/no-symbol -- required for testing */ 
var $3o1J0 = parcelRequire("3o1J0");
module.exports = $3o1J0 && !Symbol.sham && typeof Symbol.iterator == "symbol";

});
parcelRequire.register("3o1J0", function(module, exports) {
/* eslint-disable es/no-symbol -- required for testing */ 
var $dOZLy = parcelRequire("dOZLy");

var $avKuJ = parcelRequire("avKuJ");

var $6gFRb = parcelRequire("6gFRb");
var $2774f3882d27fc98$var$$String = $6gFRb.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !$avKuJ(function() {
    var symbol = Symbol();
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$2774f3882d27fc98$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $dOZLy && $dOZLy < 41;
});

});
parcelRequire.register("dOZLy", function(module, exports) {

var $6gFRb = parcelRequire("6gFRb");

var $jGeXI = parcelRequire("jGeXI");
var $a0ffdb565abc7d4b$var$process = $6gFRb.process;
var $a0ffdb565abc7d4b$var$Deno = $6gFRb.Deno;
var $a0ffdb565abc7d4b$var$versions = $a0ffdb565abc7d4b$var$process && $a0ffdb565abc7d4b$var$process.versions || $a0ffdb565abc7d4b$var$Deno && $a0ffdb565abc7d4b$var$Deno.version;
var $a0ffdb565abc7d4b$var$v8 = $a0ffdb565abc7d4b$var$versions && $a0ffdb565abc7d4b$var$versions.v8;
var $a0ffdb565abc7d4b$var$match, $a0ffdb565abc7d4b$var$version;
if ($a0ffdb565abc7d4b$var$v8) {
    $a0ffdb565abc7d4b$var$match = $a0ffdb565abc7d4b$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $a0ffdb565abc7d4b$var$version = $a0ffdb565abc7d4b$var$match[0] > 0 && $a0ffdb565abc7d4b$var$match[0] < 4 ? 1 : +($a0ffdb565abc7d4b$var$match[0] + $a0ffdb565abc7d4b$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$a0ffdb565abc7d4b$var$version && $jGeXI) {
    $a0ffdb565abc7d4b$var$match = $jGeXI.match(/Edge\/(\d+)/);
    if (!$a0ffdb565abc7d4b$var$match || $a0ffdb565abc7d4b$var$match[1] >= 74) {
        $a0ffdb565abc7d4b$var$match = $jGeXI.match(/Chrome\/(\d+)/);
        if ($a0ffdb565abc7d4b$var$match) $a0ffdb565abc7d4b$var$version = +$a0ffdb565abc7d4b$var$match[1];
    }
}
module.exports = $a0ffdb565abc7d4b$var$version;

});
parcelRequire.register("jGeXI", function(module, exports) {
module.exports = typeof navigator != "undefined" && String(navigator.userAgent) || "";

});





parcelRequire.register("6aj4C", function(module, exports) {

var $aZpni = parcelRequire("aZpni");

var $9PkDw = parcelRequire("9PkDw");
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function(V, P) {
    var func = V[P];
    return $9PkDw(func) ? undefined : $aZpni(func);
};

});
parcelRequire.register("aZpni", function(module, exports) {

var $6kYHq = parcelRequire("6kYHq");

var $4ubrU = parcelRequire("4ubrU");
var $800348cc917915dd$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
module.exports = function(argument) {
    if ($6kYHq(argument)) return argument;
    throw $800348cc917915dd$var$$TypeError($4ubrU(argument) + " is not a function");
};

});
parcelRequire.register("4ubrU", function(module, exports) {
var $3442d84de2ed9a52$var$$String = String;
module.exports = function(argument) {
    try {
        return $3442d84de2ed9a52$var$$String(argument);
    } catch (error) {
        return "Object";
    }
};

});



parcelRequire.register("h8kne", function(module, exports) {

var $5qecd = parcelRequire("5qecd");

var $6kYHq = parcelRequire("6kYHq");

var $atGHr = parcelRequire("atGHr");
var $c792fccad7ce5e74$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function(input, pref) {
    var fn, val;
    if (pref === "string" && $6kYHq(fn = input.toString) && !$atGHr(val = $5qecd(fn, input))) return val;
    if ($6kYHq(fn = input.valueOf) && !$atGHr(val = $5qecd(fn, input))) return val;
    if (pref !== "string" && $6kYHq(fn = input.toString) && !$atGHr(val = $5qecd(fn, input))) return val;
    throw $c792fccad7ce5e74$var$$TypeError("Can't convert object to primitive value");
};

});

parcelRequire.register("bpQhg", function(module, exports) {

var $6gFRb = parcelRequire("6gFRb");

var $ldYIf = parcelRequire("ldYIf");

var $dydfX = parcelRequire("dydfX");

var $6ZR4P = parcelRequire("6ZR4P");

var $3o1J0 = parcelRequire("3o1J0");

var $6oGDE = parcelRequire("6oGDE");
var $84fa94b6884d06ed$var$Symbol = $6gFRb.Symbol;
var $84fa94b6884d06ed$var$WellKnownSymbolsStore = $ldYIf("wks");
var $84fa94b6884d06ed$var$createWellKnownSymbol = $6oGDE ? $84fa94b6884d06ed$var$Symbol["for"] || $84fa94b6884d06ed$var$Symbol : $84fa94b6884d06ed$var$Symbol && $84fa94b6884d06ed$var$Symbol.withoutSetter || $6ZR4P;
module.exports = function(name) {
    if (!$dydfX($84fa94b6884d06ed$var$WellKnownSymbolsStore, name)) $84fa94b6884d06ed$var$WellKnownSymbolsStore[name] = $3o1J0 && $dydfX($84fa94b6884d06ed$var$Symbol, name) ? $84fa94b6884d06ed$var$Symbol[name] : $84fa94b6884d06ed$var$createWellKnownSymbol("Symbol." + name);
    return $84fa94b6884d06ed$var$WellKnownSymbolsStore[name];
};

});
parcelRequire.register("ldYIf", function(module, exports) {

var $2EepY = parcelRequire("2EepY");

var $9P8Mi = parcelRequire("9P8Mi");
(module.exports = function(key, value) {
    return $9P8Mi[key] || ($9P8Mi[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.31.0",
    mode: $2EepY ? "pure" : "global",
    copyright: "\xa9 2014-2023 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.31.0/LICENSE",
    source: "https://github.com/zloirock/core-js"
});

});
parcelRequire.register("2EepY", function(module, exports) {
module.exports = true;

});

parcelRequire.register("9P8Mi", function(module, exports) {

var $6gFRb = parcelRequire("6gFRb");

var $dJlDM = parcelRequire("dJlDM");
var $726faf99fc7f8d52$var$SHARED = "__core-js_shared__";
var $726faf99fc7f8d52$var$store = $6gFRb[$726faf99fc7f8d52$var$SHARED] || $dJlDM($726faf99fc7f8d52$var$SHARED, {});
module.exports = $726faf99fc7f8d52$var$store;

});
parcelRequire.register("dJlDM", function(module, exports) {

var $6gFRb = parcelRequire("6gFRb");
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $9ff043b513baeece$var$defineProperty = Object.defineProperty;
module.exports = function(key, value) {
    try {
        $9ff043b513baeece$var$defineProperty($6gFRb, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $6gFRb[key] = value;
    }
    return value;
};

});



parcelRequire.register("dydfX", function(module, exports) {

var $7tcts = parcelRequire("7tcts");

var $bVwvx = parcelRequire("bVwvx");
var $9dd8bbc3fac749c7$var$hasOwnProperty = $7tcts({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
    return $9dd8bbc3fac749c7$var$hasOwnProperty($bVwvx(it), key);
};

});
parcelRequire.register("bVwvx", function(module, exports) {

var $dfvEY = parcelRequire("dfvEY");
var $8aee3be82460a55d$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function(argument) {
    return $8aee3be82460a55d$var$$Object($dfvEY(argument));
};

});


parcelRequire.register("6ZR4P", function(module, exports) {

var $7tcts = parcelRequire("7tcts");
var $51819c90a96f672a$var$id = 0;
var $51819c90a96f672a$var$postfix = Math.random();
var $51819c90a96f672a$var$toString = $7tcts(1.0.toString);
module.exports = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $51819c90a96f672a$var$toString(++$51819c90a96f672a$var$id + $51819c90a96f672a$var$postfix, 36);
};

});




parcelRequire.register("lqkHi", function(module, exports) {

var $99D40 = parcelRequire("99D40");

var $avKuJ = parcelRequire("avKuJ");

var $gLicj = parcelRequire("gLicj");
// Thanks to IE8 for its funny defineProperty
module.exports = !$99D40 && !$avKuJ(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($gLicj("div"), "a", {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRequire.register("gLicj", function(module, exports) {

var $6gFRb = parcelRequire("6gFRb");

var $atGHr = parcelRequire("atGHr");
var $c33f26cc74cf7a1b$var$document = $6gFRb.document;
// typeof document.createElement is 'object' in old IE
var $c33f26cc74cf7a1b$var$EXISTS = $atGHr($c33f26cc74cf7a1b$var$document) && $atGHr($c33f26cc74cf7a1b$var$document.createElement);
module.exports = function(it) {
    return $c33f26cc74cf7a1b$var$EXISTS ? $c33f26cc74cf7a1b$var$document.createElement(it) : {};
};

});



parcelRequire.register("uEW8O", function(module, exports) {

var $avKuJ = parcelRequire("avKuJ");

var $6kYHq = parcelRequire("6kYHq");
var $05c28ea4fd230846$var$replacement = /#|\.prototype\./;
var $05c28ea4fd230846$var$isForced = function(feature, detection) {
    var value = $05c28ea4fd230846$var$data[$05c28ea4fd230846$var$normalize(feature)];
    return value == $05c28ea4fd230846$var$POLYFILL ? true : value == $05c28ea4fd230846$var$NATIVE ? false : $6kYHq(detection) ? $avKuJ(detection) : !!detection;
};
var $05c28ea4fd230846$var$normalize = $05c28ea4fd230846$var$isForced.normalize = function(string) {
    return String(string).replace($05c28ea4fd230846$var$replacement, ".").toLowerCase();
};
var $05c28ea4fd230846$var$data = $05c28ea4fd230846$var$isForced.data = {};
var $05c28ea4fd230846$var$NATIVE = $05c28ea4fd230846$var$isForced.NATIVE = "N";
var $05c28ea4fd230846$var$POLYFILL = $05c28ea4fd230846$var$isForced.POLYFILL = "P";
module.exports = $05c28ea4fd230846$var$isForced;

});

parcelRequire.register("2B9V4", function(module, exports) {

var $fCzmA = parcelRequire("fCzmA");

var $aZpni = parcelRequire("aZpni");

var $ag2S4 = parcelRequire("ag2S4");
var $1e46bb44dd6df8bb$var$bind = $fCzmA($fCzmA.bind);
// optional / simple context binding
module.exports = function(fn, that) {
    $aZpni(fn);
    return that === undefined ? fn : $ag2S4 ? $1e46bb44dd6df8bb$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};

});

parcelRequire.register("l3ouT", function(module, exports) {

var $99D40 = parcelRequire("99D40");

var $14MWq = parcelRequire("14MWq");

var $88IDB = parcelRequire("88IDB");
module.exports = $99D40 ? function(object, key, value) {
    return $14MWq.f(object, key, $88IDB(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRequire.register("14MWq", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $0c8c20eab339d01d$export$2d1720544b23b823; }, function (v) { return $0c8c20eab339d01d$export$2d1720544b23b823 = v; });
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $0c8c20eab339d01d$export$2d1720544b23b823;

var $99D40 = parcelRequire("99D40");

var $lqkHi = parcelRequire("lqkHi");

var $ku6Bt = parcelRequire("ku6Bt");

var $lalRy = parcelRequire("lalRy");

var $xDFpu = parcelRequire("xDFpu");
var $0c8c20eab339d01d$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $0c8c20eab339d01d$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $0c8c20eab339d01d$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $0c8c20eab339d01d$var$ENUMERABLE = "enumerable";
var $0c8c20eab339d01d$var$CONFIGURABLE = "configurable";
var $0c8c20eab339d01d$var$WRITABLE = "writable";
$0c8c20eab339d01d$export$2d1720544b23b823 = $99D40 ? $ku6Bt ? function defineProperty(O, P, Attributes) {
    $lalRy(O);
    P = $xDFpu(P);
    $lalRy(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $0c8c20eab339d01d$var$WRITABLE in Attributes && !Attributes[$0c8c20eab339d01d$var$WRITABLE]) {
        var current = $0c8c20eab339d01d$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$0c8c20eab339d01d$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $0c8c20eab339d01d$var$CONFIGURABLE in Attributes ? Attributes[$0c8c20eab339d01d$var$CONFIGURABLE] : current[$0c8c20eab339d01d$var$CONFIGURABLE],
                enumerable: $0c8c20eab339d01d$var$ENUMERABLE in Attributes ? Attributes[$0c8c20eab339d01d$var$ENUMERABLE] : current[$0c8c20eab339d01d$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $0c8c20eab339d01d$var$$defineProperty(O, P, Attributes);
} : $0c8c20eab339d01d$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $lalRy(O);
    P = $xDFpu(P);
    $lalRy(Attributes);
    if ($lqkHi) try {
        return $0c8c20eab339d01d$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw $0c8c20eab339d01d$var$$TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRequire.register("ku6Bt", function(module, exports) {

var $99D40 = parcelRequire("99D40");

var $avKuJ = parcelRequire("avKuJ");
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = $99D40 && $avKuJ(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype != 42;
});

});

parcelRequire.register("lalRy", function(module, exports) {

var $atGHr = parcelRequire("atGHr");
var $f68b7d9ebc3d6d7f$var$$String = String;
var $f68b7d9ebc3d6d7f$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
module.exports = function(argument) {
    if ($atGHr(argument)) return argument;
    throw $f68b7d9ebc3d6d7f$var$$TypeError($f68b7d9ebc3d6d7f$var$$String(argument) + " is not an object");
};

});








parcelRequire.register("evY07", function(module, exports) {

module.exports = (parcelRequire("dKDYY"));

});
parcelRequire.register("dKDYY", function(module, exports) {

var $8vIVg = parcelRequire("8vIVg");
module.exports = $8vIVg;

});
parcelRequire.register("8vIVg", function(module, exports) {
parcelRequire("ee1Uk");

var $envPC = parcelRequire("envPC");
var $632410ab79c2e1e6$var$Object = $envPC.Object;
var $632410ab79c2e1e6$var$defineProperty = module.exports = function defineProperty(it, key, desc) {
    return $632410ab79c2e1e6$var$Object.defineProperty(it, key, desc);
};
if ($632410ab79c2e1e6$var$Object.defineProperty.sham) $632410ab79c2e1e6$var$defineProperty.sham = true;

});
parcelRequire.register("ee1Uk", function(module, exports) {

var $g2B3u = parcelRequire("g2B3u");

var $99D40 = parcelRequire("99D40");

var $14MWq = parcelRequire("14MWq");
var $a5b3da4da038e963$require$defineProperty = $14MWq.f;
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
// eslint-disable-next-line es/no-object-defineproperty -- safe
$g2B3u({
    target: "Object",
    stat: true,
    forced: Object.defineProperty !== $a5b3da4da038e963$require$defineProperty,
    sham: !$99D40
}, {
    defineProperty: $a5b3da4da038e963$require$defineProperty
});

});




parcelRequire.register("akViX", function(module, exports) {

var $iqC1p = parcelRequire("iqC1p");

var $67yTq = parcelRequire("67yTq");
function $7868393159d938b4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return module.exports = $7868393159d938b4$var$_typeof = "function" == typeof $iqC1p && "symbol" == typeof $67yTq ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof $iqC1p && obj.constructor === $iqC1p && obj !== $iqC1p.prototype ? "symbol" : typeof obj;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $7868393159d938b4$var$_typeof(obj);
}
module.exports = $7868393159d938b4$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("iqC1p", function(module, exports) {

module.exports = (parcelRequire("2iCHC"));

});
parcelRequire.register("2iCHC", function(module, exports) {

module.exports = (parcelRequire("g5B4g"));

});
parcelRequire.register("g5B4g", function(module, exports) {

var $dHEXv = parcelRequire("dHEXv");
parcelRequire("jOpIF");
parcelRequire("aEapL");
parcelRequire("ys3nK");
parcelRequire("fqyTF");
parcelRequire("lpRwj");
parcelRequire("gEMKW");
parcelRequire("g5IpD");
parcelRequire("4Vj0e");
parcelRequire("8xGvE");
parcelRequire("cYpG9");
module.exports = $dHEXv;

});
parcelRequire.register("dHEXv", function(module, exports) {

var $02Urn = parcelRequire("02Urn");
parcelRequire("01jxO");
parcelRequire("sHpoB");
parcelRequire("ky9hd");
module.exports = $02Urn;

});
parcelRequire.register("02Urn", function(module, exports) {

var $8TIPH = parcelRequire("8TIPH");
parcelRequire("4YdnW");
module.exports = $8TIPH;

});
parcelRequire.register("8TIPH", function(module, exports) {
parcelRequire("iJ6bK");
parcelRequire("edOxo");
parcelRequire("bolJ5");
parcelRequire("bwsEU");
parcelRequire("lqry7");
parcelRequire("b9IYC");
parcelRequire("3f1Jg");
parcelRequire("76AZ9");
parcelRequire("dNrE3");
parcelRequire("bU5Iy");
parcelRequire("6AQAi");
parcelRequire("ahmgJ");
parcelRequire("1UjGm");
parcelRequire("5fkQV");
parcelRequire("2WkWp");
parcelRequire("XOxyg");
parcelRequire("73DT6");
parcelRequire("2ml6C");
parcelRequire("2MMp1");
parcelRequire("g7LDH");

var $envPC = parcelRequire("envPC");
module.exports = $envPC.Symbol;

});
parcelRequire.register("iJ6bK", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $avKuJ = parcelRequire("avKuJ");

var $6BgtM = parcelRequire("6BgtM");

var $atGHr = parcelRequire("atGHr");

var $bVwvx = parcelRequire("bVwvx");

var $25Yeh = parcelRequire("25Yeh");

var $1KUkA = parcelRequire("1KUkA");

var $4mEJZ = parcelRequire("4mEJZ");

var $YzIa0 = parcelRequire("YzIa0");

var $jS11O = parcelRequire("jS11O");

var $bpQhg = parcelRequire("bpQhg");

var $dOZLy = parcelRequire("dOZLy");
var $0384aa3d5a96b5c7$var$IS_CONCAT_SPREADABLE = $bpQhg("isConcatSpreadable");
// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var $0384aa3d5a96b5c7$var$IS_CONCAT_SPREADABLE_SUPPORT = $dOZLy >= 51 || !$avKuJ(function() {
    var array = [];
    array[$0384aa3d5a96b5c7$var$IS_CONCAT_SPREADABLE] = false;
    return array.concat()[0] !== array;
});
var $0384aa3d5a96b5c7$var$isConcatSpreadable = function(O) {
    if (!$atGHr(O)) return false;
    var spreadable = O[$0384aa3d5a96b5c7$var$IS_CONCAT_SPREADABLE];
    return spreadable !== undefined ? !!spreadable : $6BgtM(O);
};
var $0384aa3d5a96b5c7$var$FORCED = !$0384aa3d5a96b5c7$var$IS_CONCAT_SPREADABLE_SUPPORT || !$jS11O("concat");
// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$g2B3u({
    target: "Array",
    proto: true,
    arity: 1,
    forced: $0384aa3d5a96b5c7$var$FORCED
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    concat: function concat(arg) {
        var O = $bVwvx(this);
        var A = $YzIa0(O, 0);
        var n = 0;
        var i, k, length, len, E;
        for(i = -1, length = arguments.length; i < length; i++){
            E = i === -1 ? O : arguments[i];
            if ($0384aa3d5a96b5c7$var$isConcatSpreadable(E)) {
                len = $25Yeh(E);
                $1KUkA(n + len);
                for(k = 0; k < len; k++, n++)if (k in E) $4mEJZ(A, n, E[k]);
            } else {
                $1KUkA(n + 1);
                $4mEJZ(A, n++, E);
            }
        }
        A.length = n;
        return A;
    }
});

});
parcelRequire.register("6BgtM", function(module, exports) {

var $1SBP2 = parcelRequire("1SBP2");
// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
    return $1SBP2(argument) == "Array";
};

});

parcelRequire.register("25Yeh", function(module, exports) {

var $5zf2j = parcelRequire("5zf2j");
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function(obj) {
    return $5zf2j(obj.length);
};

});
parcelRequire.register("5zf2j", function(module, exports) {

var $5flhu = parcelRequire("5flhu");
var $40dbe2843e58d072$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function(argument) {
    return argument > 0 ? $40dbe2843e58d072$var$min($5flhu(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

});
parcelRequire.register("5flhu", function(module, exports) {

var $2EOKi = parcelRequire("2EOKi");
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $2EOKi(number);
};

});
parcelRequire.register("2EOKi", function(module, exports) {
var $1ef6ae3e699ed728$var$ceil = Math.ceil;
var $1ef6ae3e699ed728$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $1ef6ae3e699ed728$var$floor : $1ef6ae3e699ed728$var$ceil)(n);
};

});




parcelRequire.register("1KUkA", function(module, exports) {
var $1475c8824c7052fa$var$$TypeError = TypeError;
var $1475c8824c7052fa$var$MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991
module.exports = function(it) {
    if (it > $1475c8824c7052fa$var$MAX_SAFE_INTEGER) throw $1475c8824c7052fa$var$$TypeError("Maximum allowed index exceeded");
    return it;
};

});

parcelRequire.register("4mEJZ", function(module, exports) {
"use strict";

var $xDFpu = parcelRequire("xDFpu");

var $14MWq = parcelRequire("14MWq");

var $88IDB = parcelRequire("88IDB");
module.exports = function(object, key, value) {
    var propertyKey = $xDFpu(key);
    if (propertyKey in object) $14MWq.f(object, propertyKey, $88IDB(0, value));
    else object[propertyKey] = value;
};

});

parcelRequire.register("YzIa0", function(module, exports) {

var $6Hctp = parcelRequire("6Hctp");
// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function(originalArray, length) {
    return new ($6Hctp(originalArray))(length === 0 ? 0 : length);
};

});
parcelRequire.register("6Hctp", function(module, exports) {

var $6BgtM = parcelRequire("6BgtM");

var $3BUS6 = parcelRequire("3BUS6");

var $atGHr = parcelRequire("atGHr");

var $bpQhg = parcelRequire("bpQhg");
var $4e006f2826bfb300$var$SPECIES = $bpQhg("species");
var $4e006f2826bfb300$var$$Array = Array;
// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function(originalArray) {
    var C;
    if ($6BgtM(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if ($3BUS6(C) && (C === $4e006f2826bfb300$var$$Array || $6BgtM(C.prototype))) C = undefined;
        else if ($atGHr(C)) {
            C = C[$4e006f2826bfb300$var$SPECIES];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? $4e006f2826bfb300$var$$Array : C;
};

});
parcelRequire.register("3BUS6", function(module, exports) {

var $7tcts = parcelRequire("7tcts");

var $avKuJ = parcelRequire("avKuJ");

var $6kYHq = parcelRequire("6kYHq");

var $3mH0O = parcelRequire("3mH0O");

var $bTXoK = parcelRequire("bTXoK");

var $JLKZp = parcelRequire("JLKZp");
var $2a10f14beaaf3bb5$var$noop = function() {};
var $2a10f14beaaf3bb5$var$empty = [];
var $2a10f14beaaf3bb5$var$construct = $bTXoK("Reflect", "construct");
var $2a10f14beaaf3bb5$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $2a10f14beaaf3bb5$var$exec = $7tcts($2a10f14beaaf3bb5$var$constructorRegExp.exec);
var $2a10f14beaaf3bb5$var$INCORRECT_TO_STRING = !$2a10f14beaaf3bb5$var$constructorRegExp.exec($2a10f14beaaf3bb5$var$noop);
var $2a10f14beaaf3bb5$var$isConstructorModern = function isConstructor(argument) {
    if (!$6kYHq(argument)) return false;
    try {
        $2a10f14beaaf3bb5$var$construct($2a10f14beaaf3bb5$var$noop, $2a10f14beaaf3bb5$var$empty, argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $2a10f14beaaf3bb5$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$6kYHq(argument)) return false;
    switch($3mH0O(argument)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $2a10f14beaaf3bb5$var$INCORRECT_TO_STRING || !!$2a10f14beaaf3bb5$var$exec($2a10f14beaaf3bb5$var$constructorRegExp, $JLKZp(argument));
    } catch (error) {
        return true;
    }
};
$2a10f14beaaf3bb5$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !$2a10f14beaaf3bb5$var$construct || $avKuJ(function() {
    var called;
    return $2a10f14beaaf3bb5$var$isConstructorModern($2a10f14beaaf3bb5$var$isConstructorModern.call) || !$2a10f14beaaf3bb5$var$isConstructorModern(Object) || !$2a10f14beaaf3bb5$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $2a10f14beaaf3bb5$var$isConstructorLegacy : $2a10f14beaaf3bb5$var$isConstructorModern;

});
parcelRequire.register("3mH0O", function(module, exports) {

var $b8vNt = parcelRequire("b8vNt");

var $6kYHq = parcelRequire("6kYHq");

var $1SBP2 = parcelRequire("1SBP2");

var $bpQhg = parcelRequire("bpQhg");
var $2734ca75890ec4ed$var$TO_STRING_TAG = $bpQhg("toStringTag");
var $2734ca75890ec4ed$var$$Object = Object;
// ES3 wrong here
var $2734ca75890ec4ed$var$CORRECT_ARGUMENTS = $1SBP2(function() {
    return arguments;
}()) == "Arguments";
// fallback for IE11 Script Access Denied error
var $2734ca75890ec4ed$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
module.exports = $b8vNt ? $1SBP2 : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $2734ca75890ec4ed$var$tryGet(O = $2734ca75890ec4ed$var$$Object(it), $2734ca75890ec4ed$var$TO_STRING_TAG)) == "string" ? tag : $2734ca75890ec4ed$var$CORRECT_ARGUMENTS ? $1SBP2(O) : (result = $1SBP2(O)) == "Object" && $6kYHq(O.callee) ? "Arguments" : result;
};

});
parcelRequire.register("b8vNt", function(module, exports) {

var $bpQhg = parcelRequire("bpQhg");
var $0217a178ea08cd60$var$TO_STRING_TAG = $bpQhg("toStringTag");
var $0217a178ea08cd60$var$test = {};
$0217a178ea08cd60$var$test[$0217a178ea08cd60$var$TO_STRING_TAG] = "z";
module.exports = String($0217a178ea08cd60$var$test) === "[object z]";

});


parcelRequire.register("JLKZp", function(module, exports) {

var $7tcts = parcelRequire("7tcts");

var $6kYHq = parcelRequire("6kYHq");

var $9P8Mi = parcelRequire("9P8Mi");
var $08993f9bbd2711f2$var$functionToString = $7tcts(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$6kYHq($9P8Mi.inspectSource)) $9P8Mi.inspectSource = function(it) {
    return $08993f9bbd2711f2$var$functionToString(it);
};
module.exports = $9P8Mi.inspectSource;

});




parcelRequire.register("jS11O", function(module, exports) {

var $avKuJ = parcelRequire("avKuJ");

var $bpQhg = parcelRequire("bpQhg");

var $dOZLy = parcelRequire("dOZLy");
var $e773dba8f894fc19$var$SPECIES = $bpQhg("species");
module.exports = function(METHOD_NAME) {
    // We can't use this feature detection in V8 since it causes
    // deoptimization and serious performance degradation
    // https://github.com/zloirock/core-js/issues/677
    return $dOZLy >= 51 || !$avKuJ(function() {
        var array = [];
        var constructor = array.constructor = {};
        constructor[$e773dba8f894fc19$var$SPECIES] = function() {
            return {
                foo: 1
            };
        };
        return array[METHOD_NAME](Boolean).foo !== 1;
    });
};

});


parcelRequire.register("edOxo", function(module, exports) {
// empty

});

parcelRequire.register("bolJ5", function(module, exports) {
// TODO: Remove this module from `core-js@4` since it's split to modules listed below
parcelRequire("iRgQu");
parcelRequire("ieQFj");
parcelRequire("d2OFe");
parcelRequire("3zJKl");
parcelRequire("2L2oR");

});
parcelRequire.register("iRgQu", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $6gFRb = parcelRequire("6gFRb");

var $5qecd = parcelRequire("5qecd");

var $7tcts = parcelRequire("7tcts");

var $2EepY = parcelRequire("2EepY");

var $99D40 = parcelRequire("99D40");

var $3o1J0 = parcelRequire("3o1J0");

var $avKuJ = parcelRequire("avKuJ");

var $dydfX = parcelRequire("dydfX");

var $5L8hR = parcelRequire("5L8hR");

var $lalRy = parcelRequire("lalRy");

var $1YJYD = parcelRequire("1YJYD");

var $xDFpu = parcelRequire("xDFpu");

var $eG0jW = parcelRequire("eG0jW");

var $88IDB = parcelRequire("88IDB");

var $2oTKI = parcelRequire("2oTKI");

var $lfsGJ = parcelRequire("lfsGJ");

var $7uHlQ = parcelRequire("7uHlQ");

var $lr024 = parcelRequire("lr024");

var $fZ8lI = parcelRequire("fZ8lI");

var $6IpKK = parcelRequire("6IpKK");

var $14MWq = parcelRequire("14MWq");

var $aYYr7 = parcelRequire("aYYr7");

var $lqqOI = parcelRequire("lqqOI");

var $87keX = parcelRequire("87keX");

var $1oUoQ = parcelRequire("1oUoQ");

var $ldYIf = parcelRequire("ldYIf");

var $bu4oO = parcelRequire("bu4oO");

var $7ULBd = parcelRequire("7ULBd");

var $6ZR4P = parcelRequire("6ZR4P");

var $bpQhg = parcelRequire("bpQhg");

var $eWaJP = parcelRequire("eWaJP");

var $hwCSP = parcelRequire("hwCSP");

var $f8xWH = parcelRequire("f8xWH");

var $a5xog = parcelRequire("a5xog");

var $CWMD0 = parcelRequire("CWMD0");

var $lB6H8 = parcelRequire("lB6H8");
var $dbaa3e70ee8e2dc4$require$$forEach = $lB6H8.forEach;
var $dbaa3e70ee8e2dc4$var$HIDDEN = $bu4oO("hidden");
var $dbaa3e70ee8e2dc4$var$SYMBOL = "Symbol";
var $dbaa3e70ee8e2dc4$var$PROTOTYPE = "prototype";
var $dbaa3e70ee8e2dc4$var$setInternalState = $CWMD0.set;
var $dbaa3e70ee8e2dc4$var$getInternalState = $CWMD0.getterFor($dbaa3e70ee8e2dc4$var$SYMBOL);
var $dbaa3e70ee8e2dc4$var$ObjectPrototype = Object[$dbaa3e70ee8e2dc4$var$PROTOTYPE];
var $dbaa3e70ee8e2dc4$var$$Symbol = $6gFRb.Symbol;
var $dbaa3e70ee8e2dc4$var$SymbolPrototype = $dbaa3e70ee8e2dc4$var$$Symbol && $dbaa3e70ee8e2dc4$var$$Symbol[$dbaa3e70ee8e2dc4$var$PROTOTYPE];
var $dbaa3e70ee8e2dc4$var$TypeError = $6gFRb.TypeError;
var $dbaa3e70ee8e2dc4$var$QObject = $6gFRb.QObject;
var $dbaa3e70ee8e2dc4$var$nativeGetOwnPropertyDescriptor = $6IpKK.f;
var $dbaa3e70ee8e2dc4$var$nativeDefineProperty = $14MWq.f;
var $dbaa3e70ee8e2dc4$var$nativeGetOwnPropertyNames = $lr024.f;
var $dbaa3e70ee8e2dc4$var$nativePropertyIsEnumerable = $lqqOI.f;
var $dbaa3e70ee8e2dc4$var$push = $7tcts([].push);
var $dbaa3e70ee8e2dc4$var$AllSymbols = $ldYIf("symbols");
var $dbaa3e70ee8e2dc4$var$ObjectPrototypeSymbols = $ldYIf("op-symbols");
var $dbaa3e70ee8e2dc4$var$WellKnownSymbolsStore = $ldYIf("wks");
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var $dbaa3e70ee8e2dc4$var$USE_SETTER = !$dbaa3e70ee8e2dc4$var$QObject || !$dbaa3e70ee8e2dc4$var$QObject[$dbaa3e70ee8e2dc4$var$PROTOTYPE] || !$dbaa3e70ee8e2dc4$var$QObject[$dbaa3e70ee8e2dc4$var$PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var $dbaa3e70ee8e2dc4$var$setSymbolDescriptor = $99D40 && $avKuJ(function() {
    return $2oTKI($dbaa3e70ee8e2dc4$var$nativeDefineProperty({}, "a", {
        get: function() {
            return $dbaa3e70ee8e2dc4$var$nativeDefineProperty(this, "a", {
                value: 7
            }).a;
        }
    })).a != 7;
}) ? function(O, P, Attributes) {
    var ObjectPrototypeDescriptor = $dbaa3e70ee8e2dc4$var$nativeGetOwnPropertyDescriptor($dbaa3e70ee8e2dc4$var$ObjectPrototype, P);
    if (ObjectPrototypeDescriptor) delete $dbaa3e70ee8e2dc4$var$ObjectPrototype[P];
    $dbaa3e70ee8e2dc4$var$nativeDefineProperty(O, P, Attributes);
    if (ObjectPrototypeDescriptor && O !== $dbaa3e70ee8e2dc4$var$ObjectPrototype) $dbaa3e70ee8e2dc4$var$nativeDefineProperty($dbaa3e70ee8e2dc4$var$ObjectPrototype, P, ObjectPrototypeDescriptor);
} : $dbaa3e70ee8e2dc4$var$nativeDefineProperty;
var $dbaa3e70ee8e2dc4$var$wrap = function(tag, description) {
    var symbol = $dbaa3e70ee8e2dc4$var$AllSymbols[tag] = $2oTKI($dbaa3e70ee8e2dc4$var$SymbolPrototype);
    $dbaa3e70ee8e2dc4$var$setInternalState(symbol, {
        type: $dbaa3e70ee8e2dc4$var$SYMBOL,
        tag: tag,
        description: description
    });
    if (!$99D40) symbol.description = description;
    return symbol;
};
var $dbaa3e70ee8e2dc4$var$$defineProperty = function defineProperty(O, P, Attributes) {
    if (O === $dbaa3e70ee8e2dc4$var$ObjectPrototype) $dbaa3e70ee8e2dc4$var$$defineProperty($dbaa3e70ee8e2dc4$var$ObjectPrototypeSymbols, P, Attributes);
    $lalRy(O);
    var key = $xDFpu(P);
    $lalRy(Attributes);
    if ($dydfX($dbaa3e70ee8e2dc4$var$AllSymbols, key)) {
        if (!Attributes.enumerable) {
            if (!$dydfX(O, $dbaa3e70ee8e2dc4$var$HIDDEN)) $dbaa3e70ee8e2dc4$var$nativeDefineProperty(O, $dbaa3e70ee8e2dc4$var$HIDDEN, $88IDB(1, {}));
            O[$dbaa3e70ee8e2dc4$var$HIDDEN][key] = true;
        } else {
            if ($dydfX(O, $dbaa3e70ee8e2dc4$var$HIDDEN) && O[$dbaa3e70ee8e2dc4$var$HIDDEN][key]) O[$dbaa3e70ee8e2dc4$var$HIDDEN][key] = false;
            Attributes = $2oTKI(Attributes, {
                enumerable: $88IDB(0, false)
            });
        }
        return $dbaa3e70ee8e2dc4$var$setSymbolDescriptor(O, key, Attributes);
    }
    return $dbaa3e70ee8e2dc4$var$nativeDefineProperty(O, key, Attributes);
};
var $dbaa3e70ee8e2dc4$var$$defineProperties = function defineProperties(O, Properties) {
    $lalRy(O);
    var properties = $1YJYD(Properties);
    var keys = $lfsGJ(properties).concat($dbaa3e70ee8e2dc4$var$$getOwnPropertySymbols(properties));
    $dbaa3e70ee8e2dc4$require$$forEach(keys, function(key) {
        if (!$99D40 || $5qecd($dbaa3e70ee8e2dc4$var$$propertyIsEnumerable, properties, key)) $dbaa3e70ee8e2dc4$var$$defineProperty(O, key, properties[key]);
    });
    return O;
};
var $dbaa3e70ee8e2dc4$var$$create = function create(O, Properties) {
    return Properties === undefined ? $2oTKI(O) : $dbaa3e70ee8e2dc4$var$$defineProperties($2oTKI(O), Properties);
};
var $dbaa3e70ee8e2dc4$var$$propertyIsEnumerable = function propertyIsEnumerable(V) {
    var P = $xDFpu(V);
    var enumerable = $5qecd($dbaa3e70ee8e2dc4$var$nativePropertyIsEnumerable, this, P);
    if (this === $dbaa3e70ee8e2dc4$var$ObjectPrototype && $dydfX($dbaa3e70ee8e2dc4$var$AllSymbols, P) && !$dydfX($dbaa3e70ee8e2dc4$var$ObjectPrototypeSymbols, P)) return false;
    return enumerable || !$dydfX(this, P) || !$dydfX($dbaa3e70ee8e2dc4$var$AllSymbols, P) || $dydfX(this, $dbaa3e70ee8e2dc4$var$HIDDEN) && this[$dbaa3e70ee8e2dc4$var$HIDDEN][P] ? enumerable : true;
};
var $dbaa3e70ee8e2dc4$var$$getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
    var it = $1YJYD(O);
    var key = $xDFpu(P);
    if (it === $dbaa3e70ee8e2dc4$var$ObjectPrototype && $dydfX($dbaa3e70ee8e2dc4$var$AllSymbols, key) && !$dydfX($dbaa3e70ee8e2dc4$var$ObjectPrototypeSymbols, key)) return;
    var descriptor = $dbaa3e70ee8e2dc4$var$nativeGetOwnPropertyDescriptor(it, key);
    if (descriptor && $dydfX($dbaa3e70ee8e2dc4$var$AllSymbols, key) && !($dydfX(it, $dbaa3e70ee8e2dc4$var$HIDDEN) && it[$dbaa3e70ee8e2dc4$var$HIDDEN][key])) descriptor.enumerable = true;
    return descriptor;
};
var $dbaa3e70ee8e2dc4$var$$getOwnPropertyNames = function getOwnPropertyNames(O) {
    var names = $dbaa3e70ee8e2dc4$var$nativeGetOwnPropertyNames($1YJYD(O));
    var result = [];
    $dbaa3e70ee8e2dc4$require$$forEach(names, function(key) {
        if (!$dydfX($dbaa3e70ee8e2dc4$var$AllSymbols, key) && !$dydfX($7ULBd, key)) $dbaa3e70ee8e2dc4$var$push(result, key);
    });
    return result;
};
var $dbaa3e70ee8e2dc4$var$$getOwnPropertySymbols = function(O) {
    var IS_OBJECT_PROTOTYPE = O === $dbaa3e70ee8e2dc4$var$ObjectPrototype;
    var names = $dbaa3e70ee8e2dc4$var$nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? $dbaa3e70ee8e2dc4$var$ObjectPrototypeSymbols : $1YJYD(O));
    var result = [];
    $dbaa3e70ee8e2dc4$require$$forEach(names, function(key) {
        if ($dydfX($dbaa3e70ee8e2dc4$var$AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || $dydfX($dbaa3e70ee8e2dc4$var$ObjectPrototype, key))) $dbaa3e70ee8e2dc4$var$push(result, $dbaa3e70ee8e2dc4$var$AllSymbols[key]);
    });
    return result;
};
// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!$3o1J0) {
    $dbaa3e70ee8e2dc4$var$$Symbol = function Symbol() {
        if ($5L8hR($dbaa3e70ee8e2dc4$var$SymbolPrototype, this)) throw $dbaa3e70ee8e2dc4$var$TypeError("Symbol is not a constructor");
        var description = !arguments.length || arguments[0] === undefined ? undefined : $eG0jW(arguments[0]);
        var tag = $6ZR4P(description);
        var setter = function(value) {
            if (this === $dbaa3e70ee8e2dc4$var$ObjectPrototype) $5qecd(setter, $dbaa3e70ee8e2dc4$var$ObjectPrototypeSymbols, value);
            if ($dydfX(this, $dbaa3e70ee8e2dc4$var$HIDDEN) && $dydfX(this[$dbaa3e70ee8e2dc4$var$HIDDEN], tag)) this[$dbaa3e70ee8e2dc4$var$HIDDEN][tag] = false;
            $dbaa3e70ee8e2dc4$var$setSymbolDescriptor(this, tag, $88IDB(1, value));
        };
        if ($99D40 && $dbaa3e70ee8e2dc4$var$USE_SETTER) $dbaa3e70ee8e2dc4$var$setSymbolDescriptor($dbaa3e70ee8e2dc4$var$ObjectPrototype, tag, {
            configurable: true,
            set: setter
        });
        return $dbaa3e70ee8e2dc4$var$wrap(tag, description);
    };
    $dbaa3e70ee8e2dc4$var$SymbolPrototype = $dbaa3e70ee8e2dc4$var$$Symbol[$dbaa3e70ee8e2dc4$var$PROTOTYPE];
    $87keX($dbaa3e70ee8e2dc4$var$SymbolPrototype, "toString", function toString() {
        return $dbaa3e70ee8e2dc4$var$getInternalState(this).tag;
    });
    $87keX($dbaa3e70ee8e2dc4$var$$Symbol, "withoutSetter", function(description) {
        return $dbaa3e70ee8e2dc4$var$wrap($6ZR4P(description), description);
    });
    $lqqOI.f = $dbaa3e70ee8e2dc4$var$$propertyIsEnumerable;
    $14MWq.f = $dbaa3e70ee8e2dc4$var$$defineProperty;
    $aYYr7.f = $dbaa3e70ee8e2dc4$var$$defineProperties;
    $6IpKK.f = $dbaa3e70ee8e2dc4$var$$getOwnPropertyDescriptor;
    $7uHlQ.f = $lr024.f = $dbaa3e70ee8e2dc4$var$$getOwnPropertyNames;
    $fZ8lI.f = $dbaa3e70ee8e2dc4$var$$getOwnPropertySymbols;
    $eWaJP.f = function(name) {
        return $dbaa3e70ee8e2dc4$var$wrap($bpQhg(name), name);
    };
    if ($99D40) {
        // https://github.com/tc39/proposal-Symbol-description
        $1oUoQ($dbaa3e70ee8e2dc4$var$SymbolPrototype, "description", {
            configurable: true,
            get: function description() {
                return $dbaa3e70ee8e2dc4$var$getInternalState(this).description;
            }
        });
        if (!$2EepY) $87keX($dbaa3e70ee8e2dc4$var$ObjectPrototype, "propertyIsEnumerable", $dbaa3e70ee8e2dc4$var$$propertyIsEnumerable, {
            unsafe: true
        });
    }
}
$g2B3u({
    global: true,
    constructor: true,
    wrap: true,
    forced: !$3o1J0,
    sham: !$3o1J0
}, {
    Symbol: $dbaa3e70ee8e2dc4$var$$Symbol
});
$dbaa3e70ee8e2dc4$require$$forEach($lfsGJ($dbaa3e70ee8e2dc4$var$WellKnownSymbolsStore), function(name) {
    $hwCSP(name);
});
$g2B3u({
    target: $dbaa3e70ee8e2dc4$var$SYMBOL,
    stat: true,
    forced: !$3o1J0
}, {
    useSetter: function() {
        $dbaa3e70ee8e2dc4$var$USE_SETTER = true;
    },
    useSimple: function() {
        $dbaa3e70ee8e2dc4$var$USE_SETTER = false;
    }
});
$g2B3u({
    target: "Object",
    stat: true,
    forced: !$3o1J0,
    sham: !$99D40
}, {
    // `Object.create` method
    // https://tc39.es/ecma262/#sec-object.create
    create: $dbaa3e70ee8e2dc4$var$$create,
    // `Object.defineProperty` method
    // https://tc39.es/ecma262/#sec-object.defineproperty
    defineProperty: $dbaa3e70ee8e2dc4$var$$defineProperty,
    // `Object.defineProperties` method
    // https://tc39.es/ecma262/#sec-object.defineproperties
    defineProperties: $dbaa3e70ee8e2dc4$var$$defineProperties,
    // `Object.getOwnPropertyDescriptor` method
    // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
    getOwnPropertyDescriptor: $dbaa3e70ee8e2dc4$var$$getOwnPropertyDescriptor
});
$g2B3u({
    target: "Object",
    stat: true,
    forced: !$3o1J0
}, {
    // `Object.getOwnPropertyNames` method
    // https://tc39.es/ecma262/#sec-object.getownpropertynames
    getOwnPropertyNames: $dbaa3e70ee8e2dc4$var$$getOwnPropertyNames
});
// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
$f8xWH();
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
$a5xog($dbaa3e70ee8e2dc4$var$$Symbol, $dbaa3e70ee8e2dc4$var$SYMBOL);
$7ULBd[$dbaa3e70ee8e2dc4$var$HIDDEN] = true;

});
parcelRequire.register("eG0jW", function(module, exports) {

var $3mH0O = parcelRequire("3mH0O");
var $aaf53c9e39ce3ca8$var$$String = String;
module.exports = function(argument) {
    if ($3mH0O(argument) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
    return $aaf53c9e39ce3ca8$var$$String(argument);
};

});

parcelRequire.register("2oTKI", function(module, exports) {
/* global ActiveXObject -- old IE, WSH */ 
var $lalRy = parcelRequire("lalRy");

var $aYYr7 = parcelRequire("aYYr7");

var $7Di5X = parcelRequire("7Di5X");

var $7ULBd = parcelRequire("7ULBd");

var $ajZzW = parcelRequire("ajZzW");

var $gLicj = parcelRequire("gLicj");

var $bu4oO = parcelRequire("bu4oO");
var $1bf911f6a844a6e4$var$GT = ">";
var $1bf911f6a844a6e4$var$LT = "<";
var $1bf911f6a844a6e4$var$PROTOTYPE = "prototype";
var $1bf911f6a844a6e4$var$SCRIPT = "script";
var $1bf911f6a844a6e4$var$IE_PROTO = $bu4oO("IE_PROTO");
var $1bf911f6a844a6e4$var$EmptyConstructor = function() {};
var $1bf911f6a844a6e4$var$scriptTag = function(content) {
    return $1bf911f6a844a6e4$var$LT + $1bf911f6a844a6e4$var$SCRIPT + $1bf911f6a844a6e4$var$GT + content + $1bf911f6a844a6e4$var$LT + "/" + $1bf911f6a844a6e4$var$SCRIPT + $1bf911f6a844a6e4$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $1bf911f6a844a6e4$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($1bf911f6a844a6e4$var$scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $1bf911f6a844a6e4$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $gLicj("iframe");
    var JS = "java" + $1bf911f6a844a6e4$var$SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    $ajZzW.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($1bf911f6a844a6e4$var$scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $1bf911f6a844a6e4$var$activeXDocument;
var $1bf911f6a844a6e4$var$NullProtoObject = function() {
    try {
        $1bf911f6a844a6e4$var$activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    $1bf911f6a844a6e4$var$NullProtoObject = typeof document != "undefined" ? document.domain && $1bf911f6a844a6e4$var$activeXDocument ? $1bf911f6a844a6e4$var$NullProtoObjectViaActiveX($1bf911f6a844a6e4$var$activeXDocument) // old IE
     : $1bf911f6a844a6e4$var$NullProtoObjectViaIFrame() : $1bf911f6a844a6e4$var$NullProtoObjectViaActiveX($1bf911f6a844a6e4$var$activeXDocument); // WSH
    var length = $7Di5X.length;
    while(length--)delete $1bf911f6a844a6e4$var$NullProtoObject[$1bf911f6a844a6e4$var$PROTOTYPE][$7Di5X[length]];
    return $1bf911f6a844a6e4$var$NullProtoObject();
};
$7ULBd[$1bf911f6a844a6e4$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $1bf911f6a844a6e4$var$EmptyConstructor[$1bf911f6a844a6e4$var$PROTOTYPE] = $lalRy(O);
        result = new $1bf911f6a844a6e4$var$EmptyConstructor();
        $1bf911f6a844a6e4$var$EmptyConstructor[$1bf911f6a844a6e4$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$1bf911f6a844a6e4$var$IE_PROTO] = O;
    } else result = $1bf911f6a844a6e4$var$NullProtoObject();
    return Properties === undefined ? result : $aYYr7.f(result, Properties);
};

});
parcelRequire.register("aYYr7", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $7fee636981d2fc3d$export$2d1720544b23b823; }, function (v) { return $7fee636981d2fc3d$export$2d1720544b23b823 = v; });
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var $7fee636981d2fc3d$export$2d1720544b23b823;

var $99D40 = parcelRequire("99D40");

var $ku6Bt = parcelRequire("ku6Bt");

var $14MWq = parcelRequire("14MWq");

var $lalRy = parcelRequire("lalRy");

var $1YJYD = parcelRequire("1YJYD");

var $lfsGJ = parcelRequire("lfsGJ");
$7fee636981d2fc3d$export$2d1720544b23b823 = $99D40 && !$ku6Bt ? Object.defineProperties : function defineProperties(O, Properties) {
    $lalRy(O);
    var props = $1YJYD(Properties);
    var keys = $lfsGJ(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$14MWq.f(O, key = keys[index++], props[key]);
    return O;
};

});
parcelRequire.register("lfsGJ", function(module, exports) {

var $arfAX = parcelRequire("arfAX");

var $7Di5X = parcelRequire("7Di5X");
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
    return $arfAX(O, $7Di5X);
};

});
parcelRequire.register("arfAX", function(module, exports) {

var $7tcts = parcelRequire("7tcts");

var $dydfX = parcelRequire("dydfX");

var $1YJYD = parcelRequire("1YJYD");

var $gehei = parcelRequire("gehei");
var $799885d906971b7f$require$indexOf = $gehei.indexOf;

var $7ULBd = parcelRequire("7ULBd");
var $799885d906971b7f$var$push = $7tcts([].push);
module.exports = function(object, names) {
    var O = $1YJYD(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$dydfX($7ULBd, key) && $dydfX(O, key) && $799885d906971b7f$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($dydfX(O, key = names[i++])) ~$799885d906971b7f$require$indexOf(result, key) || $799885d906971b7f$var$push(result, key);
    return result;
};

});
parcelRequire.register("gehei", function(module, exports) {

var $1YJYD = parcelRequire("1YJYD");

var $5LbRx = parcelRequire("5LbRx");

var $25Yeh = parcelRequire("25Yeh");
// `Array.prototype.{ indexOf, includes }` methods implementation
var $bd0b5193ca169669$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $1YJYD($this);
        var length = $25Yeh(O);
        var index = $5LbRx(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
module.exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $bd0b5193ca169669$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $bd0b5193ca169669$var$createMethod(false)
};

});
parcelRequire.register("5LbRx", function(module, exports) {

var $5flhu = parcelRequire("5flhu");
var $431a8b300d8b6931$var$max = Math.max;
var $431a8b300d8b6931$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function(index, length) {
    var integer = $5flhu(index);
    return integer < 0 ? $431a8b300d8b6931$var$max(integer + length, 0) : $431a8b300d8b6931$var$min(integer, length);
};

});


parcelRequire.register("7ULBd", function(module, exports) {
module.exports = {};

});


parcelRequire.register("7Di5X", function(module, exports) {
// IE8- don't enum bug keys
module.exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];

});



parcelRequire.register("ajZzW", function(module, exports) {

var $bTXoK = parcelRequire("bTXoK");
module.exports = $bTXoK("document", "documentElement");

});

parcelRequire.register("bu4oO", function(module, exports) {

var $ldYIf = parcelRequire("ldYIf");

var $6ZR4P = parcelRequire("6ZR4P");
var $85c5e8a7796eade6$var$keys = $ldYIf("keys");
module.exports = function(key) {
    return $85c5e8a7796eade6$var$keys[key] || ($85c5e8a7796eade6$var$keys[key] = $6ZR4P(key));
};

});


parcelRequire.register("7uHlQ", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $574cf667c3101c74$export$2d1720544b23b823; }, function (v) { return $574cf667c3101c74$export$2d1720544b23b823 = v; });
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $574cf667c3101c74$export$2d1720544b23b823;

var $arfAX = parcelRequire("arfAX");

var $7Di5X = parcelRequire("7Di5X");
var $574cf667c3101c74$var$hiddenKeys = $7Di5X.concat("length", "prototype");
$574cf667c3101c74$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $arfAX(O, $574cf667c3101c74$var$hiddenKeys);
};

});

parcelRequire.register("lr024", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $f9ac2502832763bf$export$2d1720544b23b823; }, function (v) { return $f9ac2502832763bf$export$2d1720544b23b823 = v; });
/* eslint-disable es/no-object-getownpropertynames -- safe */ // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $f9ac2502832763bf$export$2d1720544b23b823;

var $1SBP2 = parcelRequire("1SBP2");

var $1YJYD = parcelRequire("1YJYD");

var $7uHlQ = parcelRequire("7uHlQ");
var $f9ac2502832763bf$require$$getOwnPropertyNames = $7uHlQ.f;

var $ecLmr = parcelRequire("ecLmr");
var $f9ac2502832763bf$var$windowNames = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $f9ac2502832763bf$var$getWindowNames = function(it) {
    try {
        return $f9ac2502832763bf$require$$getOwnPropertyNames(it);
    } catch (error) {
        return $ecLmr($f9ac2502832763bf$var$windowNames);
    }
};
$f9ac2502832763bf$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $f9ac2502832763bf$var$windowNames && $1SBP2(it) == "Window" ? $f9ac2502832763bf$var$getWindowNames(it) : $f9ac2502832763bf$require$$getOwnPropertyNames($1YJYD(it));
};

});
parcelRequire.register("ecLmr", function(module, exports) {

var $5LbRx = parcelRequire("5LbRx");

var $25Yeh = parcelRequire("25Yeh");

var $4mEJZ = parcelRequire("4mEJZ");
var $a576ec96b597ba91$var$$Array = Array;
var $a576ec96b597ba91$var$max = Math.max;
module.exports = function(O, start, end) {
    var length = $25Yeh(O);
    var k = $5LbRx(start, length);
    var fin = $5LbRx(end === undefined ? length : end, length);
    var result = $a576ec96b597ba91$var$$Array($a576ec96b597ba91$var$max(fin - k, 0));
    for(var n = 0; k < fin; k++, n++)$4mEJZ(result, n, O[k]);
    result.length = n;
    return result;
};

});


parcelRequire.register("fZ8lI", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $ba3307853bda91f2$export$2d1720544b23b823; }, function (v) { return $ba3307853bda91f2$export$2d1720544b23b823 = v; });
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $ba3307853bda91f2$export$2d1720544b23b823;
$ba3307853bda91f2$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});

parcelRequire.register("87keX", function(module, exports) {

var $l3ouT = parcelRequire("l3ouT");
module.exports = function(target, key, value, options) {
    if (options && options.enumerable) target[key] = value;
    else $l3ouT(target, key, value);
    return target;
};

});

parcelRequire.register("1oUoQ", function(module, exports) {

var $14MWq = parcelRequire("14MWq");
module.exports = function(target, name, descriptor) {
    return $14MWq.f(target, name, descriptor);
};

});

parcelRequire.register("eWaJP", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $adfecfd352bd4325$export$2d1720544b23b823; }, function (v) { return $adfecfd352bd4325$export$2d1720544b23b823 = v; });
var $adfecfd352bd4325$export$2d1720544b23b823;

var $bpQhg = parcelRequire("bpQhg");
$adfecfd352bd4325$export$2d1720544b23b823 = $bpQhg;

});

parcelRequire.register("hwCSP", function(module, exports) {

var $envPC = parcelRequire("envPC");

var $dydfX = parcelRequire("dydfX");

var $eWaJP = parcelRequire("eWaJP");

var $14MWq = parcelRequire("14MWq");
var $cc23963f55ee547f$require$defineProperty = $14MWq.f;
module.exports = function(NAME) {
    var Symbol = $envPC.Symbol || ($envPC.Symbol = {});
    if (!$dydfX(Symbol, NAME)) $cc23963f55ee547f$require$defineProperty(Symbol, NAME, {
        value: $eWaJP.f(NAME)
    });
};

});

parcelRequire.register("f8xWH", function(module, exports) {

var $5qecd = parcelRequire("5qecd");

var $bTXoK = parcelRequire("bTXoK");

var $bpQhg = parcelRequire("bpQhg");

var $87keX = parcelRequire("87keX");
module.exports = function() {
    var Symbol = $bTXoK("Symbol");
    var SymbolPrototype = Symbol && Symbol.prototype;
    var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
    var TO_PRIMITIVE = $bpQhg("toPrimitive");
    if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    // eslint-disable-next-line no-unused-vars -- required for .length
    $87keX(SymbolPrototype, TO_PRIMITIVE, function(hint) {
        return $5qecd(valueOf, this);
    }, {
        arity: 1
    });
};

});

parcelRequire.register("a5xog", function(module, exports) {

var $b8vNt = parcelRequire("b8vNt");

var $14MWq = parcelRequire("14MWq");
var $758445a04a9c6f6e$require$defineProperty = $14MWq.f;

var $l3ouT = parcelRequire("l3ouT");

var $dydfX = parcelRequire("dydfX");

var $31Sjd = parcelRequire("31Sjd");

var $bpQhg = parcelRequire("bpQhg");
var $758445a04a9c6f6e$var$TO_STRING_TAG = $bpQhg("toStringTag");
module.exports = function(it, TAG, STATIC, SET_METHOD) {
    if (it) {
        var target = STATIC ? it : it.prototype;
        if (!$dydfX(target, $758445a04a9c6f6e$var$TO_STRING_TAG)) $758445a04a9c6f6e$require$defineProperty(target, $758445a04a9c6f6e$var$TO_STRING_TAG, {
            configurable: true,
            value: TAG
        });
        if (SET_METHOD && !$b8vNt) $l3ouT(target, "toString", $31Sjd);
    }
};

});
parcelRequire.register("31Sjd", function(module, exports) {
"use strict";

var $b8vNt = parcelRequire("b8vNt");

var $3mH0O = parcelRequire("3mH0O");
// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = $b8vNt ? ({}).toString : function toString() {
    return "[object " + $3mH0O(this) + "]";
};

});


parcelRequire.register("CWMD0", function(module, exports) {

var $guBvM = parcelRequire("guBvM");

var $6gFRb = parcelRequire("6gFRb");

var $atGHr = parcelRequire("atGHr");

var $l3ouT = parcelRequire("l3ouT");

var $dydfX = parcelRequire("dydfX");

var $9P8Mi = parcelRequire("9P8Mi");

var $bu4oO = parcelRequire("bu4oO");

var $7ULBd = parcelRequire("7ULBd");
var $075125de414c0fa2$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $075125de414c0fa2$var$TypeError = $6gFRb.TypeError;
var $075125de414c0fa2$var$WeakMap = $6gFRb.WeakMap;
var $075125de414c0fa2$var$set, $075125de414c0fa2$var$get, $075125de414c0fa2$var$has;
var $075125de414c0fa2$var$enforce = function(it) {
    return $075125de414c0fa2$var$has(it) ? $075125de414c0fa2$var$get(it) : $075125de414c0fa2$var$set(it, {});
};
var $075125de414c0fa2$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$atGHr(it) || (state = $075125de414c0fa2$var$get(it)).type !== TYPE) throw $075125de414c0fa2$var$TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($guBvM || $9P8Mi.state) {
    var $075125de414c0fa2$var$store = $9P8Mi.state || ($9P8Mi.state = new $075125de414c0fa2$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $075125de414c0fa2$var$store.get = $075125de414c0fa2$var$store.get;
    $075125de414c0fa2$var$store.has = $075125de414c0fa2$var$store.has;
    $075125de414c0fa2$var$store.set = $075125de414c0fa2$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $075125de414c0fa2$var$set = function(it, metadata) {
        if ($075125de414c0fa2$var$store.has(it)) throw $075125de414c0fa2$var$TypeError($075125de414c0fa2$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $075125de414c0fa2$var$store.set(it, metadata);
        return metadata;
    };
    $075125de414c0fa2$var$get = function(it) {
        return $075125de414c0fa2$var$store.get(it) || {};
    };
    $075125de414c0fa2$var$has = function(it) {
        return $075125de414c0fa2$var$store.has(it);
    };
} else {
    var $075125de414c0fa2$var$STATE = $bu4oO("state");
    $7ULBd[$075125de414c0fa2$var$STATE] = true;
    $075125de414c0fa2$var$set = function(it, metadata) {
        if ($dydfX(it, $075125de414c0fa2$var$STATE)) throw $075125de414c0fa2$var$TypeError($075125de414c0fa2$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $l3ouT(it, $075125de414c0fa2$var$STATE, metadata);
        return metadata;
    };
    $075125de414c0fa2$var$get = function(it) {
        return $dydfX(it, $075125de414c0fa2$var$STATE) ? it[$075125de414c0fa2$var$STATE] : {};
    };
    $075125de414c0fa2$var$has = function(it) {
        return $dydfX(it, $075125de414c0fa2$var$STATE);
    };
}
module.exports = {
    set: $075125de414c0fa2$var$set,
    get: $075125de414c0fa2$var$get,
    has: $075125de414c0fa2$var$has,
    enforce: $075125de414c0fa2$var$enforce,
    getterFor: $075125de414c0fa2$var$getterFor
};

});
parcelRequire.register("guBvM", function(module, exports) {

var $6gFRb = parcelRequire("6gFRb");

var $6kYHq = parcelRequire("6kYHq");
var $c01c8bb499b3d0f1$var$WeakMap = $6gFRb.WeakMap;
module.exports = $6kYHq($c01c8bb499b3d0f1$var$WeakMap) && /native code/.test(String($c01c8bb499b3d0f1$var$WeakMap));

});


parcelRequire.register("lB6H8", function(module, exports) {

var $2B9V4 = parcelRequire("2B9V4");

var $7tcts = parcelRequire("7tcts");

var $5LLAg = parcelRequire("5LLAg");

var $bVwvx = parcelRequire("bVwvx");

var $25Yeh = parcelRequire("25Yeh");

var $YzIa0 = parcelRequire("YzIa0");
var $fb923f20d9cd022f$var$push = $7tcts([].push);
// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var $fb923f20d9cd022f$var$createMethod = function(TYPE) {
    var IS_MAP = TYPE == 1;
    var IS_FILTER = TYPE == 2;
    var IS_SOME = TYPE == 3;
    var IS_EVERY = TYPE == 4;
    var IS_FIND_INDEX = TYPE == 6;
    var IS_FILTER_REJECT = TYPE == 7;
    var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that, specificCreate) {
        var O = $bVwvx($this);
        var self = $5LLAg(O);
        var boundFunction = $2B9V4(callbackfn, that);
        var length = $25Yeh(self);
        var index = 0;
        var create = specificCreate || $YzIa0;
        var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
        var value, result;
        for(; length > index; index++)if (NO_HOLES || index in self) {
            value = self[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
                if (IS_MAP) target[index] = result; // map
                else if (result) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return value; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        $fb923f20d9cd022f$var$push(target, value); // filter
                }
                else switch(TYPE){
                    case 4:
                        return false; // every
                    case 7:
                        $fb923f20d9cd022f$var$push(target, value); // filterReject
                }
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
};
module.exports = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: $fb923f20d9cd022f$var$createMethod(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: $fb923f20d9cd022f$var$createMethod(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: $fb923f20d9cd022f$var$createMethod(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: $fb923f20d9cd022f$var$createMethod(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: $fb923f20d9cd022f$var$createMethod(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: $fb923f20d9cd022f$var$createMethod(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: $fb923f20d9cd022f$var$createMethod(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: $fb923f20d9cd022f$var$createMethod(7)
};

});


parcelRequire.register("ieQFj", function(module, exports) {

var $g2B3u = parcelRequire("g2B3u");

var $bTXoK = parcelRequire("bTXoK");

var $dydfX = parcelRequire("dydfX");

var $eG0jW = parcelRequire("eG0jW");

var $ldYIf = parcelRequire("ldYIf");

var $f6BFI = parcelRequire("f6BFI");
var $d472630d6c32e671$var$StringToSymbolRegistry = $ldYIf("string-to-symbol-registry");
var $d472630d6c32e671$var$SymbolToStringRegistry = $ldYIf("symbol-to-string-registry");
// `Symbol.for` method
// https://tc39.es/ecma262/#sec-symbol.for
$g2B3u({
    target: "Symbol",
    stat: true,
    forced: !$f6BFI
}, {
    "for": function(key) {
        var string = $eG0jW(key);
        if ($dydfX($d472630d6c32e671$var$StringToSymbolRegistry, string)) return $d472630d6c32e671$var$StringToSymbolRegistry[string];
        var symbol = $bTXoK("Symbol")(string);
        $d472630d6c32e671$var$StringToSymbolRegistry[string] = symbol;
        $d472630d6c32e671$var$SymbolToStringRegistry[symbol] = string;
        return symbol;
    }
});

});
parcelRequire.register("f6BFI", function(module, exports) {

var $3o1J0 = parcelRequire("3o1J0");
/* eslint-disable es/no-symbol -- safe */ module.exports = $3o1J0 && !!Symbol["for"] && !!Symbol.keyFor;

});


parcelRequire.register("d2OFe", function(module, exports) {

var $g2B3u = parcelRequire("g2B3u");

var $dydfX = parcelRequire("dydfX");

var $jpBNa = parcelRequire("jpBNa");

var $4ubrU = parcelRequire("4ubrU");

var $ldYIf = parcelRequire("ldYIf");

var $f6BFI = parcelRequire("f6BFI");
var $97f2c31cca577346$var$SymbolToStringRegistry = $ldYIf("symbol-to-string-registry");
// `Symbol.keyFor` method
// https://tc39.es/ecma262/#sec-symbol.keyfor
$g2B3u({
    target: "Symbol",
    stat: true,
    forced: !$f6BFI
}, {
    keyFor: function keyFor(sym) {
        if (!$jpBNa(sym)) throw TypeError($4ubrU(sym) + " is not a symbol");
        if ($dydfX($97f2c31cca577346$var$SymbolToStringRegistry, sym)) return $97f2c31cca577346$var$SymbolToStringRegistry[sym];
    }
});

});

parcelRequire.register("3zJKl", function(module, exports) {

var $g2B3u = parcelRequire("g2B3u");

var $bTXoK = parcelRequire("bTXoK");

var $9YGjW = parcelRequire("9YGjW");

var $5qecd = parcelRequire("5qecd");

var $7tcts = parcelRequire("7tcts");

var $avKuJ = parcelRequire("avKuJ");

var $6kYHq = parcelRequire("6kYHq");

var $jpBNa = parcelRequire("jpBNa");

var $74qJH = parcelRequire("74qJH");

var $74SbV = parcelRequire("74SbV");

var $3o1J0 = parcelRequire("3o1J0");
var $29a8204ef3e132fb$var$$String = String;
var $29a8204ef3e132fb$var$$stringify = $bTXoK("JSON", "stringify");
var $29a8204ef3e132fb$var$exec = $7tcts(/./.exec);
var $29a8204ef3e132fb$var$charAt = $7tcts("".charAt);
var $29a8204ef3e132fb$var$charCodeAt = $7tcts("".charCodeAt);
var $29a8204ef3e132fb$var$replace = $7tcts("".replace);
var $29a8204ef3e132fb$var$numberToString = $7tcts(1.0.toString);
var $29a8204ef3e132fb$var$tester = /[\uD800-\uDFFF]/g;
var $29a8204ef3e132fb$var$low = /^[\uD800-\uDBFF]$/;
var $29a8204ef3e132fb$var$hi = /^[\uDC00-\uDFFF]$/;
var $29a8204ef3e132fb$var$WRONG_SYMBOLS_CONVERSION = !$3o1J0 || $avKuJ(function() {
    var symbol = $bTXoK("Symbol")();
    // MS Edge converts symbol values to JSON as {}
    return $29a8204ef3e132fb$var$$stringify([
        symbol
    ]) != "[null]" || $29a8204ef3e132fb$var$$stringify({
        a: symbol
    }) != "{}" || $29a8204ef3e132fb$var$$stringify(Object(symbol)) != "{}";
});
// https://github.com/tc39/proposal-well-formed-stringify
var $29a8204ef3e132fb$var$ILL_FORMED_UNICODE = $avKuJ(function() {
    return $29a8204ef3e132fb$var$$stringify("\uDF06\uD834") !== '"\udf06\ud834"' || $29a8204ef3e132fb$var$$stringify("\uDEAD") !== '"\udead"';
});
var $29a8204ef3e132fb$var$stringifyWithSymbolsFix = function(it, replacer) {
    var args = $74qJH(arguments);
    var $replacer = $74SbV(replacer);
    if (!$6kYHq($replacer) && (it === undefined || $jpBNa(it))) return; // IE8 returns string on undefined
    args[1] = function(key, value) {
        // some old implementations (like WebKit) could pass numbers as keys
        if ($6kYHq($replacer)) value = $5qecd($replacer, this, $29a8204ef3e132fb$var$$String(key), value);
        if (!$jpBNa(value)) return value;
    };
    return $9YGjW($29a8204ef3e132fb$var$$stringify, null, args);
};
var $29a8204ef3e132fb$var$fixIllFormed = function(match, offset, string) {
    var prev = $29a8204ef3e132fb$var$charAt(string, offset - 1);
    var next = $29a8204ef3e132fb$var$charAt(string, offset + 1);
    if ($29a8204ef3e132fb$var$exec($29a8204ef3e132fb$var$low, match) && !$29a8204ef3e132fb$var$exec($29a8204ef3e132fb$var$hi, next) || $29a8204ef3e132fb$var$exec($29a8204ef3e132fb$var$hi, match) && !$29a8204ef3e132fb$var$exec($29a8204ef3e132fb$var$low, prev)) return "\\u" + $29a8204ef3e132fb$var$numberToString($29a8204ef3e132fb$var$charCodeAt(match, 0), 16);
    return match;
};
if ($29a8204ef3e132fb$var$$stringify) // `JSON.stringify` method
// https://tc39.es/ecma262/#sec-json.stringify
$g2B3u({
    target: "JSON",
    stat: true,
    arity: 3,
    forced: $29a8204ef3e132fb$var$WRONG_SYMBOLS_CONVERSION || $29a8204ef3e132fb$var$ILL_FORMED_UNICODE
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
        var args = $74qJH(arguments);
        var result = $9YGjW($29a8204ef3e132fb$var$WRONG_SYMBOLS_CONVERSION ? $29a8204ef3e132fb$var$stringifyWithSymbolsFix : $29a8204ef3e132fb$var$$stringify, null, args);
        return $29a8204ef3e132fb$var$ILL_FORMED_UNICODE && typeof result == "string" ? $29a8204ef3e132fb$var$replace(result, $29a8204ef3e132fb$var$tester, $29a8204ef3e132fb$var$fixIllFormed) : result;
    }
});

});
parcelRequire.register("74qJH", function(module, exports) {

var $7tcts = parcelRequire("7tcts");
module.exports = $7tcts([].slice);

});

parcelRequire.register("74SbV", function(module, exports) {

var $7tcts = parcelRequire("7tcts");

var $6BgtM = parcelRequire("6BgtM");

var $6kYHq = parcelRequire("6kYHq");

var $1SBP2 = parcelRequire("1SBP2");

var $eG0jW = parcelRequire("eG0jW");
var $5272f16565a6e87d$var$push = $7tcts([].push);
module.exports = function(replacer) {
    if ($6kYHq(replacer)) return replacer;
    if (!$6BgtM(replacer)) return;
    var rawLength = replacer.length;
    var keys = [];
    for(var i = 0; i < rawLength; i++){
        var element = replacer[i];
        if (typeof element == "string") $5272f16565a6e87d$var$push(keys, element);
        else if (typeof element == "number" || $1SBP2(element) == "Number" || $1SBP2(element) == "String") $5272f16565a6e87d$var$push(keys, $eG0jW(element));
    }
    var keysLength = keys.length;
    var root = true;
    return function(key, value) {
        if (root) {
            root = false;
            return value;
        }
        if ($6BgtM(this)) return value;
        for(var j = 0; j < keysLength; j++)if (keys[j] === key) return value;
    };
};

});


parcelRequire.register("2L2oR", function(module, exports) {

var $g2B3u = parcelRequire("g2B3u");

var $3o1J0 = parcelRequire("3o1J0");

var $avKuJ = parcelRequire("avKuJ");

var $fZ8lI = parcelRequire("fZ8lI");

var $bVwvx = parcelRequire("bVwvx");
// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var $2021d5209a2d2f9b$var$FORCED = !$3o1J0 || $avKuJ(function() {
    $fZ8lI.f(1);
});
// `Object.getOwnPropertySymbols` method
// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
$g2B3u({
    target: "Object",
    stat: true,
    forced: $2021d5209a2d2f9b$var$FORCED
}, {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        var $getOwnPropertySymbols = $fZ8lI.f;
        return $getOwnPropertySymbols ? $getOwnPropertySymbols($bVwvx(it)) : [];
    }
});

});


parcelRequire.register("bwsEU", function(module, exports) {

var $hwCSP = parcelRequire("hwCSP");
// `Symbol.asyncIterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.asynciterator
$hwCSP("asyncIterator");

});

parcelRequire.register("lqry7", function(module, exports) {
// empty

});

parcelRequire.register("b9IYC", function(module, exports) {

var $hwCSP = parcelRequire("hwCSP");
// `Symbol.hasInstance` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.hasinstance
$hwCSP("hasInstance");

});

parcelRequire.register("3f1Jg", function(module, exports) {

var $hwCSP = parcelRequire("hwCSP");
// `Symbol.isConcatSpreadable` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.isconcatspreadable
$hwCSP("isConcatSpreadable");

});

parcelRequire.register("76AZ9", function(module, exports) {

var $hwCSP = parcelRequire("hwCSP");
// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
$hwCSP("iterator");

});

parcelRequire.register("dNrE3", function(module, exports) {

var $hwCSP = parcelRequire("hwCSP");
// `Symbol.match` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.match
$hwCSP("match");

});

parcelRequire.register("bU5Iy", function(module, exports) {

var $hwCSP = parcelRequire("hwCSP");
// `Symbol.matchAll` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.matchall
$hwCSP("matchAll");

});

parcelRequire.register("6AQAi", function(module, exports) {

var $hwCSP = parcelRequire("hwCSP");
// `Symbol.replace` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.replace
$hwCSP("replace");

});

parcelRequire.register("ahmgJ", function(module, exports) {

var $hwCSP = parcelRequire("hwCSP");
// `Symbol.search` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.search
$hwCSP("search");

});

parcelRequire.register("1UjGm", function(module, exports) {

var $hwCSP = parcelRequire("hwCSP");
// `Symbol.species` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.species
$hwCSP("species");

});

parcelRequire.register("5fkQV", function(module, exports) {

var $hwCSP = parcelRequire("hwCSP");
// `Symbol.split` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.split
$hwCSP("split");

});

parcelRequire.register("2WkWp", function(module, exports) {

var $hwCSP = parcelRequire("hwCSP");

var $f8xWH = parcelRequire("f8xWH");
// `Symbol.toPrimitive` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.toprimitive
$hwCSP("toPrimitive");
// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
$f8xWH();

});

parcelRequire.register("XOxyg", function(module, exports) {

var $bTXoK = parcelRequire("bTXoK");

var $hwCSP = parcelRequire("hwCSP");

var $a5xog = parcelRequire("a5xog");
// `Symbol.toStringTag` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.tostringtag
$hwCSP("toStringTag");
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
$a5xog($bTXoK("Symbol"), "Symbol");

});

parcelRequire.register("73DT6", function(module, exports) {

var $hwCSP = parcelRequire("hwCSP");
// `Symbol.unscopables` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.unscopables
$hwCSP("unscopables");

});

parcelRequire.register("2ml6C", function(module, exports) {

var $6gFRb = parcelRequire("6gFRb");

var $a5xog = parcelRequire("a5xog");
// JSON[@@toStringTag] property
// https://tc39.es/ecma262/#sec-json-@@tostringtag
$a5xog($6gFRb.JSON, "JSON", true);

});

parcelRequire.register("2MMp1", function(module, exports) {
// empty

});

parcelRequire.register("g7LDH", function(module, exports) {
// empty

});


parcelRequire.register("4YdnW", function(module, exports) {
parcelRequire("4IarS");

var $atWWG = parcelRequire("atWWG");

var $6gFRb = parcelRequire("6gFRb");

var $3mH0O = parcelRequire("3mH0O");

var $l3ouT = parcelRequire("l3ouT");

var $3DGb6 = parcelRequire("3DGb6");

var $bpQhg = parcelRequire("bpQhg");
var $39e726027ac2f01c$var$TO_STRING_TAG = $bpQhg("toStringTag");
for(var $39e726027ac2f01c$var$COLLECTION_NAME in $atWWG){
    var $39e726027ac2f01c$var$Collection = $6gFRb[$39e726027ac2f01c$var$COLLECTION_NAME];
    var $39e726027ac2f01c$var$CollectionPrototype = $39e726027ac2f01c$var$Collection && $39e726027ac2f01c$var$Collection.prototype;
    if ($39e726027ac2f01c$var$CollectionPrototype && $3mH0O($39e726027ac2f01c$var$CollectionPrototype) !== $39e726027ac2f01c$var$TO_STRING_TAG) $l3ouT($39e726027ac2f01c$var$CollectionPrototype, $39e726027ac2f01c$var$TO_STRING_TAG, $39e726027ac2f01c$var$COLLECTION_NAME);
    $3DGb6[$39e726027ac2f01c$var$COLLECTION_NAME] = $3DGb6.Array;
}

});
parcelRequire.register("4IarS", function(module, exports) {
"use strict";

var $1YJYD = parcelRequire("1YJYD");

var $7lCJ1 = parcelRequire("7lCJ1");

var $3DGb6 = parcelRequire("3DGb6");

var $CWMD0 = parcelRequire("CWMD0");

var $14MWq = parcelRequire("14MWq");
var $36e3605ff0e52a66$require$defineProperty = $14MWq.f;

var $1o5CL = parcelRequire("1o5CL");

var $7FHs8 = parcelRequire("7FHs8");

var $2EepY = parcelRequire("2EepY");

var $99D40 = parcelRequire("99D40");
var $36e3605ff0e52a66$var$ARRAY_ITERATOR = "Array Iterator";
var $36e3605ff0e52a66$var$setInternalState = $CWMD0.set;
var $36e3605ff0e52a66$var$getInternalState = $CWMD0.getterFor($36e3605ff0e52a66$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = $1o5CL(Array, "Array", function(iterated, kind) {
    $36e3605ff0e52a66$var$setInternalState(this, {
        type: $36e3605ff0e52a66$var$ARRAY_ITERATOR,
        target: $1YJYD(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $36e3605ff0e52a66$var$getInternalState(this);
    var target = state.target;
    var kind = state.kind;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = undefined;
        return $7FHs8(undefined, true);
    }
    if (kind == "keys") return $7FHs8(index, false);
    if (kind == "values") return $7FHs8(target[index], false);
    return $7FHs8([
        index,
        target[index]
    ], false);
}, "values");
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $36e3605ff0e52a66$var$values = $3DGb6.Arguments = $3DGb6.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$7lCJ1("keys");
$7lCJ1("values");
$7lCJ1("entries");
// V8 ~ Chrome 45- bug
if (!$2EepY && $99D40 && $36e3605ff0e52a66$var$values.name !== "values") try {
    $36e3605ff0e52a66$require$defineProperty($36e3605ff0e52a66$var$values, "name", {
        value: "values"
    });
} catch (error) {}

});
parcelRequire.register("7lCJ1", function(module, exports) {
module.exports = function() {};

});

parcelRequire.register("3DGb6", function(module, exports) {
module.exports = {};

});

parcelRequire.register("1o5CL", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $5qecd = parcelRequire("5qecd");

var $2EepY = parcelRequire("2EepY");

var $eh9MI = parcelRequire("eh9MI");

var $6kYHq = parcelRequire("6kYHq");

var $haRps = parcelRequire("haRps");

var $gk5OL = parcelRequire("gk5OL");

var $bV0bE = parcelRequire("bV0bE");

var $a5xog = parcelRequire("a5xog");

var $l3ouT = parcelRequire("l3ouT");

var $87keX = parcelRequire("87keX");

var $bpQhg = parcelRequire("bpQhg");

var $3DGb6 = parcelRequire("3DGb6");

var $5bDBv = parcelRequire("5bDBv");
var $102c652fe025047b$var$PROPER_FUNCTION_NAME = $eh9MI.PROPER;
var $102c652fe025047b$var$CONFIGURABLE_FUNCTION_NAME = $eh9MI.CONFIGURABLE;
var $102c652fe025047b$var$IteratorPrototype = $5bDBv.IteratorPrototype;
var $102c652fe025047b$var$BUGGY_SAFARI_ITERATORS = $5bDBv.BUGGY_SAFARI_ITERATORS;
var $102c652fe025047b$var$ITERATOR = $bpQhg("iterator");
var $102c652fe025047b$var$KEYS = "keys";
var $102c652fe025047b$var$VALUES = "values";
var $102c652fe025047b$var$ENTRIES = "entries";
var $102c652fe025047b$var$returnThis = function() {
    return this;
};
module.exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $haRps(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$102c652fe025047b$var$BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $102c652fe025047b$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $102c652fe025047b$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $102c652fe025047b$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + " Iterator";
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$102c652fe025047b$var$ITERATOR] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$102c652fe025047b$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME == "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $gk5OL(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!$2EepY && $gk5OL(CurrentIteratorPrototype) !== $102c652fe025047b$var$IteratorPrototype) {
                if ($bV0bE) $bV0bE(CurrentIteratorPrototype, $102c652fe025047b$var$IteratorPrototype);
                else if (!$6kYHq(CurrentIteratorPrototype[$102c652fe025047b$var$ITERATOR])) $87keX(CurrentIteratorPrototype, $102c652fe025047b$var$ITERATOR, $102c652fe025047b$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $a5xog(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if ($2EepY) $3DGb6[TO_STRING_TAG] = $102c652fe025047b$var$returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($102c652fe025047b$var$PROPER_FUNCTION_NAME && DEFAULT == $102c652fe025047b$var$VALUES && nativeIterator && nativeIterator.name !== $102c652fe025047b$var$VALUES) {
        if (!$2EepY && $102c652fe025047b$var$CONFIGURABLE_FUNCTION_NAME) $l3ouT(IterablePrototype, "name", $102c652fe025047b$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $5qecd(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($102c652fe025047b$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($102c652fe025047b$var$KEYS),
            entries: getIterationMethod($102c652fe025047b$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($102c652fe025047b$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $87keX(IterablePrototype, KEY, methods[KEY]);
        } else $g2B3u({
            target: NAME,
            proto: true,
            forced: $102c652fe025047b$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if ((!$2EepY || FORCED) && IterablePrototype[$102c652fe025047b$var$ITERATOR] !== defaultIterator) $87keX(IterablePrototype, $102c652fe025047b$var$ITERATOR, defaultIterator, {
        name: DEFAULT
    });
    $3DGb6[NAME] = defaultIterator;
    return methods;
};

});
parcelRequire.register("eh9MI", function(module, exports) {

var $99D40 = parcelRequire("99D40");

var $dydfX = parcelRequire("dydfX");
var $a64a3e3f2c51ff9b$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $a64a3e3f2c51ff9b$var$getDescriptor = $99D40 && Object.getOwnPropertyDescriptor;
var $a64a3e3f2c51ff9b$var$EXISTS = $dydfX($a64a3e3f2c51ff9b$var$FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var $a64a3e3f2c51ff9b$var$PROPER = $a64a3e3f2c51ff9b$var$EXISTS && (function something() {}).name === "something";
var $a64a3e3f2c51ff9b$var$CONFIGURABLE = $a64a3e3f2c51ff9b$var$EXISTS && (!$99D40 || $99D40 && $a64a3e3f2c51ff9b$var$getDescriptor($a64a3e3f2c51ff9b$var$FunctionPrototype, "name").configurable);
module.exports = {
    EXISTS: $a64a3e3f2c51ff9b$var$EXISTS,
    PROPER: $a64a3e3f2c51ff9b$var$PROPER,
    CONFIGURABLE: $a64a3e3f2c51ff9b$var$CONFIGURABLE
};

});

parcelRequire.register("haRps", function(module, exports) {
"use strict";

var $5bDBv = parcelRequire("5bDBv");
var $c80cccde509e61e1$require$IteratorPrototype = $5bDBv.IteratorPrototype;

var $2oTKI = parcelRequire("2oTKI");

var $88IDB = parcelRequire("88IDB");

var $a5xog = parcelRequire("a5xog");

var $3DGb6 = parcelRequire("3DGb6");
var $c80cccde509e61e1$var$returnThis = function() {
    return this;
};
module.exports = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + " Iterator";
    IteratorConstructor.prototype = $2oTKI($c80cccde509e61e1$require$IteratorPrototype, {
        next: $88IDB(+!ENUMERABLE_NEXT, next)
    });
    $a5xog(IteratorConstructor, TO_STRING_TAG, false, true);
    $3DGb6[TO_STRING_TAG] = $c80cccde509e61e1$var$returnThis;
    return IteratorConstructor;
};

});
parcelRequire.register("5bDBv", function(module, exports) {
"use strict";

var $avKuJ = parcelRequire("avKuJ");

var $6kYHq = parcelRequire("6kYHq");

var $atGHr = parcelRequire("atGHr");

var $2oTKI = parcelRequire("2oTKI");

var $gk5OL = parcelRequire("gk5OL");

var $87keX = parcelRequire("87keX");

var $bpQhg = parcelRequire("bpQhg");

var $2EepY = parcelRequire("2EepY");
var $3c6cb35ba2b93807$var$ITERATOR = $bpQhg("iterator");
var $3c6cb35ba2b93807$var$BUGGY_SAFARI_ITERATORS = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $3c6cb35ba2b93807$var$IteratorPrototype, $3c6cb35ba2b93807$var$PrototypeOfArrayIteratorPrototype, $3c6cb35ba2b93807$var$arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    $3c6cb35ba2b93807$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!("next" in $3c6cb35ba2b93807$var$arrayIterator)) $3c6cb35ba2b93807$var$BUGGY_SAFARI_ITERATORS = true;
    else {
        $3c6cb35ba2b93807$var$PrototypeOfArrayIteratorPrototype = $gk5OL($gk5OL($3c6cb35ba2b93807$var$arrayIterator));
        if ($3c6cb35ba2b93807$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $3c6cb35ba2b93807$var$IteratorPrototype = $3c6cb35ba2b93807$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $3c6cb35ba2b93807$var$NEW_ITERATOR_PROTOTYPE = !$atGHr($3c6cb35ba2b93807$var$IteratorPrototype) || $avKuJ(function() {
    var test = {};
    // FF44- legacy iterators case
    return $3c6cb35ba2b93807$var$IteratorPrototype[$3c6cb35ba2b93807$var$ITERATOR].call(test) !== test;
});
if ($3c6cb35ba2b93807$var$NEW_ITERATOR_PROTOTYPE) $3c6cb35ba2b93807$var$IteratorPrototype = {};
else if ($2EepY) $3c6cb35ba2b93807$var$IteratorPrototype = $2oTKI($3c6cb35ba2b93807$var$IteratorPrototype);
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$6kYHq($3c6cb35ba2b93807$var$IteratorPrototype[$3c6cb35ba2b93807$var$ITERATOR])) $87keX($3c6cb35ba2b93807$var$IteratorPrototype, $3c6cb35ba2b93807$var$ITERATOR, function() {
    return this;
});
module.exports = {
    IteratorPrototype: $3c6cb35ba2b93807$var$IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: $3c6cb35ba2b93807$var$BUGGY_SAFARI_ITERATORS
};

});
parcelRequire.register("gk5OL", function(module, exports) {

var $dydfX = parcelRequire("dydfX");

var $6kYHq = parcelRequire("6kYHq");

var $bVwvx = parcelRequire("bVwvx");

var $bu4oO = parcelRequire("bu4oO");

var $7YztP = parcelRequire("7YztP");
var $be2306e7fa22b30a$var$IE_PROTO = $bu4oO("IE_PROTO");
var $be2306e7fa22b30a$var$$Object = Object;
var $be2306e7fa22b30a$var$ObjectPrototype = $be2306e7fa22b30a$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = $7YztP ? $be2306e7fa22b30a$var$$Object.getPrototypeOf : function(O) {
    var object = $bVwvx(O);
    if ($dydfX(object, $be2306e7fa22b30a$var$IE_PROTO)) return object[$be2306e7fa22b30a$var$IE_PROTO];
    var constructor = object.constructor;
    if ($6kYHq(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $be2306e7fa22b30a$var$$Object ? $be2306e7fa22b30a$var$ObjectPrototype : null;
};

});
parcelRequire.register("7YztP", function(module, exports) {

var $avKuJ = parcelRequire("avKuJ");
module.exports = !$avKuJ(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});

});




parcelRequire.register("bV0bE", function(module, exports) {
/* eslint-disable no-proto -- safe */ 
var $9ShNe = parcelRequire("9ShNe");

var $lalRy = parcelRequire("lalRy");

var $iRpiP = parcelRequire("iRpiP");
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $9ShNe(Object.prototype, "__proto__", "set");
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $lalRy(O);
        $iRpiP(proto);
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);

});
parcelRequire.register("9ShNe", function(module, exports) {

var $7tcts = parcelRequire("7tcts");

var $aZpni = parcelRequire("aZpni");
module.exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $7tcts($aZpni(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};

});

parcelRequire.register("iRpiP", function(module, exports) {

var $6kYHq = parcelRequire("6kYHq");
var $dbb0cdd3c37e84fa$var$$String = String;
var $dbb0cdd3c37e84fa$var$$TypeError = TypeError;
module.exports = function(argument) {
    if (typeof argument == "object" || $6kYHq(argument)) return argument;
    throw $dbb0cdd3c37e84fa$var$$TypeError("Can't set " + $dbb0cdd3c37e84fa$var$$String(argument) + " as a prototype");
};

});



parcelRequire.register("7FHs8", function(module, exports) {
// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
module.exports = function(value, done) {
    return {
        value: value,
        done: done
    };
};

});


parcelRequire.register("atWWG", function(module, exports) {
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};

});



parcelRequire.register("01jxO", function(module, exports) {

var $bpQhg = parcelRequire("bpQhg");

var $14MWq = parcelRequire("14MWq");
var $003f41369d11e155$require$defineProperty = $14MWq.f;
var $003f41369d11e155$var$METADATA = $bpQhg("metadata");
var $003f41369d11e155$var$FunctionPrototype = Function.prototype;
// Function.prototype[@@metadata]
// https://github.com/tc39/proposal-decorator-metadata
if ($003f41369d11e155$var$FunctionPrototype[$003f41369d11e155$var$METADATA] === undefined) $003f41369d11e155$require$defineProperty($003f41369d11e155$var$FunctionPrototype, $003f41369d11e155$var$METADATA, {
    value: null
});

});

parcelRequire.register("sHpoB", function(module, exports) {

var $hwCSP = parcelRequire("hwCSP");
// `Symbol.dispose` well-known symbol
// https://github.com/tc39/proposal-explicit-resource-management
$hwCSP("dispose");

});

parcelRequire.register("ky9hd", function(module, exports) {
// TODO: Remove from `core-js@4`

var $hwCSP = parcelRequire("hwCSP");
// `Symbol.metadata` well-known symbol
// https://github.com/tc39/proposal-decorators
$hwCSP("metadata");

});


parcelRequire.register("jOpIF", function(module, exports) {

var $hwCSP = parcelRequire("hwCSP");
// `Symbol.asyncDispose` well-known symbol
// https://github.com/tc39/proposal-async-explicit-resource-management
$hwCSP("asyncDispose");

});

parcelRequire.register("aEapL", function(module, exports) {

var $g2B3u = parcelRequire("g2B3u");

var $302n7 = parcelRequire("302n7");
// `Symbol.isRegisteredSymbol` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-isregisteredsymbol
$g2B3u({
    target: "Symbol",
    stat: true
}, {
    isRegisteredSymbol: $302n7
});

});
parcelRequire.register("302n7", function(module, exports) {

var $bTXoK = parcelRequire("bTXoK");

var $7tcts = parcelRequire("7tcts");
var $22f3362b6ba0c5a0$var$Symbol = $bTXoK("Symbol");
var $22f3362b6ba0c5a0$var$keyFor = $22f3362b6ba0c5a0$var$Symbol.keyFor;
var $22f3362b6ba0c5a0$var$thisSymbolValue = $7tcts($22f3362b6ba0c5a0$var$Symbol.prototype.valueOf);
// `Symbol.isRegisteredSymbol` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-isregisteredsymbol
module.exports = $22f3362b6ba0c5a0$var$Symbol.isRegisteredSymbol || function isRegisteredSymbol(value) {
    try {
        return $22f3362b6ba0c5a0$var$keyFor($22f3362b6ba0c5a0$var$thisSymbolValue(value)) !== undefined;
    } catch (error) {
        return false;
    }
};

});


parcelRequire.register("ys3nK", function(module, exports) {

var $g2B3u = parcelRequire("g2B3u");

var $VHz6F = parcelRequire("VHz6F");
// `Symbol.isWellKnownSymbol` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-iswellknownsymbol
// We should patch it for newly added well-known symbols. If it's not required, this module just will not be injected
$g2B3u({
    target: "Symbol",
    stat: true,
    forced: true
}, {
    isWellKnownSymbol: $VHz6F
});

});
parcelRequire.register("VHz6F", function(module, exports) {

var $ldYIf = parcelRequire("ldYIf");

var $bTXoK = parcelRequire("bTXoK");

var $7tcts = parcelRequire("7tcts");

var $jpBNa = parcelRequire("jpBNa");

var $bpQhg = parcelRequire("bpQhg");
var $0ad71e2236aaa072$var$Symbol = $bTXoK("Symbol");
var $0ad71e2236aaa072$var$$isWellKnownSymbol = $0ad71e2236aaa072$var$Symbol.isWellKnownSymbol;
var $0ad71e2236aaa072$var$getOwnPropertyNames = $bTXoK("Object", "getOwnPropertyNames");
var $0ad71e2236aaa072$var$thisSymbolValue = $7tcts($0ad71e2236aaa072$var$Symbol.prototype.valueOf);
var $0ad71e2236aaa072$var$WellKnownSymbolsStore = $ldYIf("wks");
for(var $0ad71e2236aaa072$var$i = 0, $0ad71e2236aaa072$var$symbolKeys = $0ad71e2236aaa072$var$getOwnPropertyNames($0ad71e2236aaa072$var$Symbol), $0ad71e2236aaa072$var$symbolKeysLength = $0ad71e2236aaa072$var$symbolKeys.length; $0ad71e2236aaa072$var$i < $0ad71e2236aaa072$var$symbolKeysLength; $0ad71e2236aaa072$var$i++)// some old engines throws on access to some keys like `arguments` or `caller`
try {
    var $0ad71e2236aaa072$var$symbolKey = $0ad71e2236aaa072$var$symbolKeys[$0ad71e2236aaa072$var$i];
    if ($jpBNa($0ad71e2236aaa072$var$Symbol[$0ad71e2236aaa072$var$symbolKey])) $bpQhg($0ad71e2236aaa072$var$symbolKey);
} catch (error) {}
// `Symbol.isWellKnownSymbol` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-iswellknownsymbol
// We should patch it for newly added well-known symbols. If it's not required, this module just will not be injected
module.exports = function isWellKnownSymbol(value) {
    if ($0ad71e2236aaa072$var$$isWellKnownSymbol && $0ad71e2236aaa072$var$$isWellKnownSymbol(value)) return true;
    try {
        var symbol = $0ad71e2236aaa072$var$thisSymbolValue(value);
        for(var j = 0, keys = $0ad71e2236aaa072$var$getOwnPropertyNames($0ad71e2236aaa072$var$WellKnownSymbolsStore), keysLength = keys.length; j < keysLength; j++){
            if ($0ad71e2236aaa072$var$WellKnownSymbolsStore[keys[j]] == symbol) return true;
        }
    } catch (error) {}
    return false;
};

});


parcelRequire.register("fqyTF", function(module, exports) {

var $hwCSP = parcelRequire("hwCSP");
// `Symbol.matcher` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
$hwCSP("matcher");

});

parcelRequire.register("lpRwj", function(module, exports) {

var $hwCSP = parcelRequire("hwCSP");
// `Symbol.observable` well-known symbol
// https://github.com/tc39/proposal-observable
$hwCSP("observable");

});

parcelRequire.register("gEMKW", function(module, exports) {

var $g2B3u = parcelRequire("g2B3u");

var $302n7 = parcelRequire("302n7");
// `Symbol.isRegistered` method
// obsolete version of https://tc39.es/proposal-symbol-predicates/#sec-symbol-isregisteredsymbol
$g2B3u({
    target: "Symbol",
    stat: true,
    name: "isRegisteredSymbol"
}, {
    isRegistered: $302n7
});

});

parcelRequire.register("g5IpD", function(module, exports) {

var $g2B3u = parcelRequire("g2B3u");

var $VHz6F = parcelRequire("VHz6F");
// `Symbol.isWellKnown` method
// obsolete version of https://tc39.es/proposal-symbol-predicates/#sec-symbol-iswellknownsymbol
// We should patch it for newly added well-known symbols. If it's not required, this module just will not be injected
$g2B3u({
    target: "Symbol",
    stat: true,
    name: "isWellKnownSymbol",
    forced: true
}, {
    isWellKnown: $VHz6F
});

});

parcelRequire.register("4Vj0e", function(module, exports) {

var $hwCSP = parcelRequire("hwCSP");
// `Symbol.metadataKey` well-known symbol
// https://github.com/tc39/proposal-decorator-metadata
$hwCSP("metadataKey");

});

parcelRequire.register("8xGvE", function(module, exports) {
// TODO: remove from `core-js@4`

var $hwCSP = parcelRequire("hwCSP");
// `Symbol.patternMatch` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
$hwCSP("patternMatch");

});

parcelRequire.register("cYpG9", function(module, exports) {
// TODO: remove from `core-js@4`

var $hwCSP = parcelRequire("hwCSP");
$hwCSP("replaceAll");

});




parcelRequire.register("67yTq", function(module, exports) {

module.exports = (parcelRequire("bgor0"));

});
parcelRequire.register("bgor0", function(module, exports) {

module.exports = (parcelRequire("g446w"));

});
parcelRequire.register("g446w", function(module, exports) {

var $9bnm0 = parcelRequire("9bnm0");
module.exports = $9bnm0;

});
parcelRequire.register("9bnm0", function(module, exports) {

var $e4ehx = parcelRequire("e4ehx");
module.exports = $e4ehx;

});
parcelRequire.register("e4ehx", function(module, exports) {

var $7VISW = parcelRequire("7VISW");
parcelRequire("4YdnW");
module.exports = $7VISW;

});
parcelRequire.register("7VISW", function(module, exports) {
parcelRequire("4IarS");
parcelRequire("edOxo");
parcelRequire("5cfBr");
parcelRequire("76AZ9");

var $eWaJP = parcelRequire("eWaJP");
module.exports = $eWaJP.f("iterator");

});
parcelRequire.register("5cfBr", function(module, exports) {
"use strict";

var $98h1l = parcelRequire("98h1l");
var $3c8a2d24a6ccea2f$require$charAt = $98h1l.charAt;

var $eG0jW = parcelRequire("eG0jW");

var $CWMD0 = parcelRequire("CWMD0");

var $1o5CL = parcelRequire("1o5CL");

var $7FHs8 = parcelRequire("7FHs8");
var $3c8a2d24a6ccea2f$var$STRING_ITERATOR = "String Iterator";
var $3c8a2d24a6ccea2f$var$setInternalState = $CWMD0.set;
var $3c8a2d24a6ccea2f$var$getInternalState = $CWMD0.getterFor($3c8a2d24a6ccea2f$var$STRING_ITERATOR);
// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
$1o5CL(String, "String", function(iterated) {
    $3c8a2d24a6ccea2f$var$setInternalState(this, {
        type: $3c8a2d24a6ccea2f$var$STRING_ITERATOR,
        string: $eG0jW(iterated),
        index: 0
    });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
    var state = $3c8a2d24a6ccea2f$var$getInternalState(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return $7FHs8(undefined, true);
    point = $3c8a2d24a6ccea2f$require$charAt(string, index);
    state.index += point.length;
    return $7FHs8(point, false);
});

});
parcelRequire.register("98h1l", function(module, exports) {

var $7tcts = parcelRequire("7tcts");

var $5flhu = parcelRequire("5flhu");

var $eG0jW = parcelRequire("eG0jW");

var $dfvEY = parcelRequire("dfvEY");
var $6a62105893f7101d$var$charAt = $7tcts("".charAt);
var $6a62105893f7101d$var$charCodeAt = $7tcts("".charCodeAt);
var $6a62105893f7101d$var$stringSlice = $7tcts("".slice);
var $6a62105893f7101d$var$createMethod = function(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = $eG0jW($dfvEY($this));
        var position = $5flhu(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? "" : undefined;
        first = $6a62105893f7101d$var$charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = $6a62105893f7101d$var$charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? $6a62105893f7101d$var$charAt(S, position) : first : CONVERT_TO_STRING ? $6a62105893f7101d$var$stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
module.exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $6a62105893f7101d$var$createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $6a62105893f7101d$var$createMethod(true)
};

});









parcelRequire.register("25qme", function(module, exports) {

module.exports = (parcelRequire("lmMkP"));

});
parcelRequire.register("lmMkP", function(module, exports) {

var $gdg7g = parcelRequire("gdg7g");
parcelRequire("4YdnW");
module.exports = $gdg7g;

});
parcelRequire.register("gdg7g", function(module, exports) {
parcelRequire("4IarS");
parcelRequire("edOxo");
parcelRequire("cevjr");

var $envPC = parcelRequire("envPC");
module.exports = $envPC.WeakMap;

});
parcelRequire.register("cevjr", function(module, exports) {
// TODO: Remove this module from `core-js@4` since it's replaced to module below
parcelRequire("bWaV6");

});
parcelRequire.register("bWaV6", function(module, exports) {
"use strict";

var $6GLAg = parcelRequire("6GLAg");

var $6gFRb = parcelRequire("6gFRb");

var $7tcts = parcelRequire("7tcts");

var $lgLDw = parcelRequire("lgLDw");

var $kBX5g = parcelRequire("kBX5g");

var $7naRP = parcelRequire("7naRP");

var $jX5ak = parcelRequire("jX5ak");

var $atGHr = parcelRequire("atGHr");

var $CWMD0 = parcelRequire("CWMD0");
var $8b0d94f8d74d0eaf$require$enforceInternalState = $CWMD0.enforce;

var $avKuJ = parcelRequire("avKuJ");

var $guBvM = parcelRequire("guBvM");
var $8b0d94f8d74d0eaf$var$$Object = Object;
// eslint-disable-next-line es/no-array-isarray -- safe
var $8b0d94f8d74d0eaf$var$isArray = Array.isArray;
// eslint-disable-next-line es/no-object-isextensible -- safe
var $8b0d94f8d74d0eaf$var$isExtensible = $8b0d94f8d74d0eaf$var$$Object.isExtensible;
// eslint-disable-next-line es/no-object-isfrozen -- safe
var $8b0d94f8d74d0eaf$var$isFrozen = $8b0d94f8d74d0eaf$var$$Object.isFrozen;
// eslint-disable-next-line es/no-object-issealed -- safe
var $8b0d94f8d74d0eaf$var$isSealed = $8b0d94f8d74d0eaf$var$$Object.isSealed;
// eslint-disable-next-line es/no-object-freeze -- safe
var $8b0d94f8d74d0eaf$var$freeze = $8b0d94f8d74d0eaf$var$$Object.freeze;
// eslint-disable-next-line es/no-object-seal -- safe
var $8b0d94f8d74d0eaf$var$seal = $8b0d94f8d74d0eaf$var$$Object.seal;
var $8b0d94f8d74d0eaf$var$FROZEN = {};
var $8b0d94f8d74d0eaf$var$SEALED = {};
var $8b0d94f8d74d0eaf$var$IS_IE11 = !$6gFRb.ActiveXObject && "ActiveXObject" in $6gFRb;
var $8b0d94f8d74d0eaf$var$InternalWeakMap;
var $8b0d94f8d74d0eaf$var$wrapper = function(init) {
    return function WeakMap() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
};
// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $8b0d94f8d74d0eaf$var$$WeakMap = $7naRP("WeakMap", $8b0d94f8d74d0eaf$var$wrapper, $jX5ak);
var $8b0d94f8d74d0eaf$var$WeakMapPrototype = $8b0d94f8d74d0eaf$var$$WeakMap.prototype;
var $8b0d94f8d74d0eaf$var$nativeSet = $7tcts($8b0d94f8d74d0eaf$var$WeakMapPrototype.set);
// Chakra Edge bug: adding frozen arrays to WeakMap unfreeze them
var $8b0d94f8d74d0eaf$var$hasMSEdgeFreezingBug = function() {
    return $6GLAg && $avKuJ(function() {
        var frozenArray = $8b0d94f8d74d0eaf$var$freeze([]);
        $8b0d94f8d74d0eaf$var$nativeSet(new $8b0d94f8d74d0eaf$var$$WeakMap(), frozenArray, 1);
        return !$8b0d94f8d74d0eaf$var$isFrozen(frozenArray);
    });
};
// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if ($guBvM) {
    if ($8b0d94f8d74d0eaf$var$IS_IE11) {
        $8b0d94f8d74d0eaf$var$InternalWeakMap = $jX5ak.getConstructor($8b0d94f8d74d0eaf$var$wrapper, "WeakMap", true);
        $kBX5g.enable();
        var $8b0d94f8d74d0eaf$var$nativeDelete = $7tcts($8b0d94f8d74d0eaf$var$WeakMapPrototype["delete"]);
        var $8b0d94f8d74d0eaf$var$nativeHas = $7tcts($8b0d94f8d74d0eaf$var$WeakMapPrototype.has);
        var $8b0d94f8d74d0eaf$var$nativeGet = $7tcts($8b0d94f8d74d0eaf$var$WeakMapPrototype.get);
        $lgLDw($8b0d94f8d74d0eaf$var$WeakMapPrototype, {
            "delete": function(key) {
                if ($atGHr(key) && !$8b0d94f8d74d0eaf$var$isExtensible(key)) {
                    var state = $8b0d94f8d74d0eaf$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $8b0d94f8d74d0eaf$var$InternalWeakMap();
                    return $8b0d94f8d74d0eaf$var$nativeDelete(this, key) || state.frozen["delete"](key);
                }
                return $8b0d94f8d74d0eaf$var$nativeDelete(this, key);
            },
            has: function has(key) {
                if ($atGHr(key) && !$8b0d94f8d74d0eaf$var$isExtensible(key)) {
                    var state = $8b0d94f8d74d0eaf$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $8b0d94f8d74d0eaf$var$InternalWeakMap();
                    return $8b0d94f8d74d0eaf$var$nativeHas(this, key) || state.frozen.has(key);
                }
                return $8b0d94f8d74d0eaf$var$nativeHas(this, key);
            },
            get: function get(key) {
                if ($atGHr(key) && !$8b0d94f8d74d0eaf$var$isExtensible(key)) {
                    var state = $8b0d94f8d74d0eaf$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $8b0d94f8d74d0eaf$var$InternalWeakMap();
                    return $8b0d94f8d74d0eaf$var$nativeHas(this, key) ? $8b0d94f8d74d0eaf$var$nativeGet(this, key) : state.frozen.get(key);
                }
                return $8b0d94f8d74d0eaf$var$nativeGet(this, key);
            },
            set: function set(key, value) {
                if ($atGHr(key) && !$8b0d94f8d74d0eaf$var$isExtensible(key)) {
                    var state = $8b0d94f8d74d0eaf$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $8b0d94f8d74d0eaf$var$InternalWeakMap();
                    $8b0d94f8d74d0eaf$var$nativeHas(this, key) ? $8b0d94f8d74d0eaf$var$nativeSet(this, key, value) : state.frozen.set(key, value);
                } else $8b0d94f8d74d0eaf$var$nativeSet(this, key, value);
                return this;
            }
        });
    // Chakra Edge frozen keys fix
    } else if ($8b0d94f8d74d0eaf$var$hasMSEdgeFreezingBug()) $lgLDw($8b0d94f8d74d0eaf$var$WeakMapPrototype, {
        set: function set(key, value) {
            var arrayIntegrityLevel;
            if ($8b0d94f8d74d0eaf$var$isArray(key)) {
                if ($8b0d94f8d74d0eaf$var$isFrozen(key)) arrayIntegrityLevel = $8b0d94f8d74d0eaf$var$FROZEN;
                else if ($8b0d94f8d74d0eaf$var$isSealed(key)) arrayIntegrityLevel = $8b0d94f8d74d0eaf$var$SEALED;
            }
            $8b0d94f8d74d0eaf$var$nativeSet(this, key, value);
            if (arrayIntegrityLevel == $8b0d94f8d74d0eaf$var$FROZEN) $8b0d94f8d74d0eaf$var$freeze(key);
            if (arrayIntegrityLevel == $8b0d94f8d74d0eaf$var$SEALED) $8b0d94f8d74d0eaf$var$seal(key);
            return this;
        }
    });
}

});
parcelRequire.register("6GLAg", function(module, exports) {

var $avKuJ = parcelRequire("avKuJ");
module.exports = !$avKuJ(function() {
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
    return Object.isExtensible(Object.preventExtensions({}));
});

});

parcelRequire.register("lgLDw", function(module, exports) {

var $87keX = parcelRequire("87keX");
module.exports = function(target, src, options) {
    for(var key in src)if (options && options.unsafe && target[key]) target[key] = src[key];
    else $87keX(target, key, src[key], options);
    return target;
};

});

parcelRequire.register("kBX5g", function(module, exports) {

var $g2B3u = parcelRequire("g2B3u");

var $7tcts = parcelRequire("7tcts");

var $7ULBd = parcelRequire("7ULBd");

var $atGHr = parcelRequire("atGHr");

var $dydfX = parcelRequire("dydfX");

var $14MWq = parcelRequire("14MWq");
var $f015183192d97b70$require$defineProperty = $14MWq.f;

var $7uHlQ = parcelRequire("7uHlQ");

var $lr024 = parcelRequire("lr024");

var $gVVQr = parcelRequire("gVVQr");

var $6ZR4P = parcelRequire("6ZR4P");

var $6GLAg = parcelRequire("6GLAg");
var $f015183192d97b70$var$REQUIRED = false;
var $f015183192d97b70$var$METADATA = $6ZR4P("meta");
var $f015183192d97b70$var$id = 0;
var $f015183192d97b70$var$setMetadata = function(it) {
    $f015183192d97b70$require$defineProperty(it, $f015183192d97b70$var$METADATA, {
        value: {
            objectID: "O" + $f015183192d97b70$var$id++,
            weakData: {} // weak collections IDs
        }
    });
};
var $f015183192d97b70$var$fastKey = function(it, create) {
    // return a primitive with prefix
    if (!$atGHr(it)) return typeof it == "symbol" ? it : (typeof it == "string" ? "S" : "P") + it;
    if (!$dydfX(it, $f015183192d97b70$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$gVVQr(it)) return "F";
        // not necessary to add metadata
        if (!create) return "E";
        // add missing metadata
        $f015183192d97b70$var$setMetadata(it);
    // return object ID
    }
    return it[$f015183192d97b70$var$METADATA].objectID;
};
var $f015183192d97b70$var$getWeakData = function(it, create) {
    if (!$dydfX(it, $f015183192d97b70$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$gVVQr(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $f015183192d97b70$var$setMetadata(it);
    // return the store of weak collections IDs
    }
    return it[$f015183192d97b70$var$METADATA].weakData;
};
// add metadata on freeze-family methods calling
var $f015183192d97b70$var$onFreeze = function(it) {
    if ($6GLAg && $f015183192d97b70$var$REQUIRED && $gVVQr(it) && !$dydfX(it, $f015183192d97b70$var$METADATA)) $f015183192d97b70$var$setMetadata(it);
    return it;
};
var $f015183192d97b70$var$enable = function() {
    $f015183192d97b70$var$meta.enable = function() {};
    $f015183192d97b70$var$REQUIRED = true;
    var getOwnPropertyNames = $7uHlQ.f;
    var splice = $7tcts([].splice);
    var test = {};
    test[$f015183192d97b70$var$METADATA] = 1;
    // prevent exposing of metadata key
    if (getOwnPropertyNames(test).length) {
        $7uHlQ.f = function(it) {
            var result = getOwnPropertyNames(it);
            for(var i = 0, length = result.length; i < length; i++)if (result[i] === $f015183192d97b70$var$METADATA) {
                splice(result, i, 1);
                break;
            }
            return result;
        };
        $g2B3u({
            target: "Object",
            stat: true,
            forced: true
        }, {
            getOwnPropertyNames: $lr024.f
        });
    }
};
var $f015183192d97b70$var$meta = module.exports = {
    enable: $f015183192d97b70$var$enable,
    fastKey: $f015183192d97b70$var$fastKey,
    getWeakData: $f015183192d97b70$var$getWeakData,
    onFreeze: $f015183192d97b70$var$onFreeze
};
$7ULBd[$f015183192d97b70$var$METADATA] = true;

});
parcelRequire.register("gVVQr", function(module, exports) {

var $avKuJ = parcelRequire("avKuJ");

var $atGHr = parcelRequire("atGHr");

var $1SBP2 = parcelRequire("1SBP2");

var $ftR9r = parcelRequire("ftR9r");
// eslint-disable-next-line es/no-object-isextensible -- safe
var $c53ed6f9946dad74$var$$isExtensible = Object.isExtensible;
var $c53ed6f9946dad74$var$FAILS_ON_PRIMITIVES = $avKuJ(function() {
    $c53ed6f9946dad74$var$$isExtensible(1);
});
// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
module.exports = $c53ed6f9946dad74$var$FAILS_ON_PRIMITIVES || $ftR9r ? function isExtensible(it) {
    if (!$atGHr(it)) return false;
    if ($ftR9r && $1SBP2(it) == "ArrayBuffer") return false;
    return $c53ed6f9946dad74$var$$isExtensible ? $c53ed6f9946dad74$var$$isExtensible(it) : true;
} : $c53ed6f9946dad74$var$$isExtensible;

});
parcelRequire.register("ftR9r", function(module, exports) {
// FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it

var $avKuJ = parcelRequire("avKuJ");
module.exports = $avKuJ(function() {
    if (typeof ArrayBuffer == "function") {
        var buffer = new ArrayBuffer(8);
        // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
        if (Object.isExtensible(buffer)) Object.defineProperty(buffer, "a", {
            value: 8
        });
    }
});

});



parcelRequire.register("7naRP", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $6gFRb = parcelRequire("6gFRb");

var $kBX5g = parcelRequire("kBX5g");

var $avKuJ = parcelRequire("avKuJ");

var $l3ouT = parcelRequire("l3ouT");

var $gSzFI = parcelRequire("gSzFI");

var $1SdiW = parcelRequire("1SdiW");

var $6kYHq = parcelRequire("6kYHq");

var $atGHr = parcelRequire("atGHr");

var $a5xog = parcelRequire("a5xog");

var $14MWq = parcelRequire("14MWq");
var $55e31c65aae37076$require$defineProperty = $14MWq.f;

var $lB6H8 = parcelRequire("lB6H8");
var $55e31c65aae37076$require$forEach = $lB6H8.forEach;

var $99D40 = parcelRequire("99D40");

var $CWMD0 = parcelRequire("CWMD0");
var $55e31c65aae37076$var$setInternalState = $CWMD0.set;
var $55e31c65aae37076$var$internalStateGetterFor = $CWMD0.getterFor;
module.exports = function(CONSTRUCTOR_NAME, wrapper, common) {
    var IS_MAP = CONSTRUCTOR_NAME.indexOf("Map") !== -1;
    var IS_WEAK = CONSTRUCTOR_NAME.indexOf("Weak") !== -1;
    var ADDER = IS_MAP ? "set" : "add";
    var NativeConstructor = $6gFRb[CONSTRUCTOR_NAME];
    var NativePrototype = NativeConstructor && NativeConstructor.prototype;
    var exported = {};
    var Constructor;
    if (!$99D40 || !$6kYHq(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !$avKuJ(function() {
        new NativeConstructor().entries().next();
    }))) {
        // create collection constructor
        Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
        $kBX5g.enable();
    } else {
        Constructor = wrapper(function(target, iterable) {
            $55e31c65aae37076$var$setInternalState($1SdiW(target, Prototype), {
                type: CONSTRUCTOR_NAME,
                collection: new NativeConstructor()
            });
            if (iterable != undefined) $gSzFI(iterable, target[ADDER], {
                that: target,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = $55e31c65aae37076$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        $55e31c65aae37076$require$forEach([
            "add",
            "clear",
            "delete",
            "forEach",
            "get",
            "has",
            "set",
            "keys",
            "values",
            "entries"
        ], function(KEY) {
            var IS_ADDER = KEY == "add" || KEY == "set";
            if (KEY in NativePrototype && !(IS_WEAK && KEY == "clear")) $l3ouT(Prototype, KEY, function(a, b) {
                var collection = getInternalState(this).collection;
                if (!IS_ADDER && IS_WEAK && !$atGHr(a)) return KEY == "get" ? undefined : false;
                var result = collection[KEY](a === 0 ? 0 : a, b);
                return IS_ADDER ? this : result;
            });
        });
        IS_WEAK || $55e31c65aae37076$require$defineProperty(Prototype, "size", {
            configurable: true,
            get: function() {
                return getInternalState(this).collection.size;
            }
        });
    }
    $a5xog(Constructor, CONSTRUCTOR_NAME, false, true);
    exported[CONSTRUCTOR_NAME] = Constructor;
    $g2B3u({
        global: true,
        forced: true
    }, exported);
    if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
    return Constructor;
};

});
parcelRequire.register("gSzFI", function(module, exports) {

var $2B9V4 = parcelRequire("2B9V4");

var $5qecd = parcelRequire("5qecd");

var $lalRy = parcelRequire("lalRy");

var $4ubrU = parcelRequire("4ubrU");

var $hUYot = parcelRequire("hUYot");

var $25Yeh = parcelRequire("25Yeh");

var $5L8hR = parcelRequire("5L8hR");

var $9AQvs = parcelRequire("9AQvs");

var $dZGy8 = parcelRequire("dZGy8");

var $gJ4Z0 = parcelRequire("gJ4Z0");
var $c49d5c2c1a64dbb7$var$$TypeError = TypeError;
var $c49d5c2c1a64dbb7$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $c49d5c2c1a64dbb7$var$ResultPrototype = $c49d5c2c1a64dbb7$var$Result.prototype;
module.exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_RECORD = !!(options && options.IS_RECORD);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $2B9V4(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) $gJ4Z0(iterator, "normal", condition);
        return new $c49d5c2c1a64dbb7$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $lalRy(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator;
    else if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $dZGy8(iterable);
        if (!iterFn) throw $c49d5c2c1a64dbb7$var$$TypeError($4ubrU(iterable) + " is not iterable");
        // optimisation for array iterators
        if ($hUYot(iterFn)) {
            for(index = 0, length = $25Yeh(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $5L8hR($c49d5c2c1a64dbb7$var$ResultPrototype, result)) return result;
            }
            return new $c49d5c2c1a64dbb7$var$Result(false);
        }
        iterator = $9AQvs(iterable, iterFn);
    }
    next = IS_RECORD ? iterable.next : iterator.next;
    while(!(step = $5qecd(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $gJ4Z0(iterator, "throw", error);
        }
        if (typeof result == "object" && result && $5L8hR($c49d5c2c1a64dbb7$var$ResultPrototype, result)) return result;
    }
    return new $c49d5c2c1a64dbb7$var$Result(false);
};

});
parcelRequire.register("hUYot", function(module, exports) {

var $bpQhg = parcelRequire("bpQhg");

var $3DGb6 = parcelRequire("3DGb6");
var $d0b68397a6c05bf1$var$ITERATOR = $bpQhg("iterator");
var $d0b68397a6c05bf1$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
module.exports = function(it) {
    return it !== undefined && ($3DGb6.Array === it || $d0b68397a6c05bf1$var$ArrayPrototype[$d0b68397a6c05bf1$var$ITERATOR] === it);
};

});

parcelRequire.register("9AQvs", function(module, exports) {

var $5qecd = parcelRequire("5qecd");

var $aZpni = parcelRequire("aZpni");

var $lalRy = parcelRequire("lalRy");

var $4ubrU = parcelRequire("4ubrU");

var $dZGy8 = parcelRequire("dZGy8");
var $6fc034882ce9508b$var$$TypeError = TypeError;
module.exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $dZGy8(argument) : usingIterator;
    if ($aZpni(iteratorMethod)) return $lalRy($5qecd(iteratorMethod, argument));
    throw $6fc034882ce9508b$var$$TypeError($4ubrU(argument) + " is not iterable");
};

});
parcelRequire.register("dZGy8", function(module, exports) {

var $3mH0O = parcelRequire("3mH0O");

var $6aj4C = parcelRequire("6aj4C");

var $9PkDw = parcelRequire("9PkDw");

var $3DGb6 = parcelRequire("3DGb6");

var $bpQhg = parcelRequire("bpQhg");
var $a301fa56ce12e685$var$ITERATOR = $bpQhg("iterator");
module.exports = function(it) {
    if (!$9PkDw(it)) return $6aj4C(it, $a301fa56ce12e685$var$ITERATOR) || $6aj4C(it, "@@iterator") || $3DGb6[$3mH0O(it)];
};

});


parcelRequire.register("gJ4Z0", function(module, exports) {

var $5qecd = parcelRequire("5qecd");

var $lalRy = parcelRequire("lalRy");

var $6aj4C = parcelRequire("6aj4C");
module.exports = function(iterator, kind, value) {
    var innerResult, innerError;
    $lalRy(iterator);
    try {
        innerResult = $6aj4C(iterator, "return");
        if (!innerResult) {
            if (kind === "throw") throw value;
            return value;
        }
        innerResult = $5qecd(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === "throw") throw value;
    if (innerError) throw innerResult;
    $lalRy(innerResult);
    return value;
};

});


parcelRequire.register("1SdiW", function(module, exports) {

var $5L8hR = parcelRequire("5L8hR");
var $15d52794df62b59e$var$$TypeError = TypeError;
module.exports = function(it, Prototype) {
    if ($5L8hR(Prototype, it)) return it;
    throw $15d52794df62b59e$var$$TypeError("Incorrect invocation");
};

});


parcelRequire.register("jX5ak", function(module, exports) {
"use strict";

var $7tcts = parcelRequire("7tcts");

var $lgLDw = parcelRequire("lgLDw");

var $kBX5g = parcelRequire("kBX5g");
var $e86788c3844b92aa$require$getWeakData = $kBX5g.getWeakData;

var $1SdiW = parcelRequire("1SdiW");

var $lalRy = parcelRequire("lalRy");

var $9PkDw = parcelRequire("9PkDw");

var $atGHr = parcelRequire("atGHr");

var $gSzFI = parcelRequire("gSzFI");

var $lB6H8 = parcelRequire("lB6H8");

var $dydfX = parcelRequire("dydfX");

var $CWMD0 = parcelRequire("CWMD0");
var $e86788c3844b92aa$var$setInternalState = $CWMD0.set;
var $e86788c3844b92aa$var$internalStateGetterFor = $CWMD0.getterFor;
var $e86788c3844b92aa$var$find = $lB6H8.find;
var $e86788c3844b92aa$var$findIndex = $lB6H8.findIndex;
var $e86788c3844b92aa$var$splice = $7tcts([].splice);
var $e86788c3844b92aa$var$id = 0;
// fallback for uncaught frozen keys
var $e86788c3844b92aa$var$uncaughtFrozenStore = function(state) {
    return state.frozen || (state.frozen = new $e86788c3844b92aa$var$UncaughtFrozenStore());
};
var $e86788c3844b92aa$var$UncaughtFrozenStore = function() {
    this.entries = [];
};
var $e86788c3844b92aa$var$findUncaughtFrozen = function(store, key) {
    return $e86788c3844b92aa$var$find(store.entries, function(it) {
        return it[0] === key;
    });
};
$e86788c3844b92aa$var$UncaughtFrozenStore.prototype = {
    get: function(key) {
        var entry = $e86788c3844b92aa$var$findUncaughtFrozen(this, key);
        if (entry) return entry[1];
    },
    has: function(key) {
        return !!$e86788c3844b92aa$var$findUncaughtFrozen(this, key);
    },
    set: function(key, value) {
        var entry = $e86788c3844b92aa$var$findUncaughtFrozen(this, key);
        if (entry) entry[1] = value;
        else this.entries.push([
            key,
            value
        ]);
    },
    "delete": function(key) {
        var index = $e86788c3844b92aa$var$findIndex(this.entries, function(it) {
            return it[0] === key;
        });
        if (~index) $e86788c3844b92aa$var$splice(this.entries, index, 1);
        return !!~index;
    }
};
module.exports = {
    getConstructor: function(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var Constructor = wrapper(function(that, iterable) {
            $1SdiW(that, Prototype);
            $e86788c3844b92aa$var$setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                id: $e86788c3844b92aa$var$id++,
                frozen: undefined
            });
            if (!$9PkDw(iterable)) $gSzFI(iterable, that[ADDER], {
                that: that,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = $e86788c3844b92aa$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function(that, key, value) {
            var state = getInternalState(that);
            var data = $e86788c3844b92aa$require$getWeakData($lalRy(key), true);
            if (data === true) $e86788c3844b92aa$var$uncaughtFrozenStore(state).set(key, value);
            else data[state.id] = value;
            return that;
        };
        $lgLDw(Prototype, {
            // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
            // https://tc39.es/ecma262/#sec-weakset.prototype.delete
            "delete": function(key) {
                var state = getInternalState(this);
                if (!$atGHr(key)) return false;
                var data = $e86788c3844b92aa$require$getWeakData(key);
                if (data === true) return $e86788c3844b92aa$var$uncaughtFrozenStore(state)["delete"](key);
                return data && $dydfX(data, state.id) && delete data[state.id];
            },
            // `{ WeakMap, WeakSet }.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.has
            // https://tc39.es/ecma262/#sec-weakset.prototype.has
            has: function has(key) {
                var state = getInternalState(this);
                if (!$atGHr(key)) return false;
                var data = $e86788c3844b92aa$require$getWeakData(key);
                if (data === true) return $e86788c3844b92aa$var$uncaughtFrozenStore(state).has(key);
                return data && $dydfX(data, state.id);
            }
        });
        $lgLDw(Prototype, IS_MAP ? {
            // `WeakMap.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.get
            get: function get(key) {
                var state = getInternalState(this);
                if ($atGHr(key)) {
                    var data = $e86788c3844b92aa$require$getWeakData(key);
                    if (data === true) return $e86788c3844b92aa$var$uncaughtFrozenStore(state).get(key);
                    return data ? data[state.id] : undefined;
                }
            },
            // `WeakMap.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.set
            set: function set(key, value) {
                return define(this, key, value);
            }
        } : {
            // `WeakSet.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-weakset.prototype.add
            add: function add(value) {
                return define(this, value, true);
            }
        });
        return Constructor;
    }
};

});






parcelRequire.register("bCWDe", function(module, exports) {

module.exports = (parcelRequire("dJORH"));

});
parcelRequire.register("dJORH", function(module, exports) {

var $5njoC = parcelRequire("5njoC");
parcelRequire("4YdnW");
module.exports = $5njoC;

});
parcelRequire.register("5njoC", function(module, exports) {
parcelRequire("6LlS9");
parcelRequire("4IarS");
parcelRequire("edOxo");
parcelRequire("4xcc1");
parcelRequire("6pPnA");
parcelRequire("dTGrZ");
parcelRequire("gNC4x");
parcelRequire("5cfBr");

var $envPC = parcelRequire("envPC");
module.exports = $envPC.Promise;

});
parcelRequire.register("6LlS9", function(module, exports) {
// TODO: Remove this module from `core-js@4` since it's replaced to module below
parcelRequire("eH1sQ");

});
parcelRequire.register("eH1sQ", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $5L8hR = parcelRequire("5L8hR");

var $gk5OL = parcelRequire("gk5OL");

var $bV0bE = parcelRequire("bV0bE");

var $e2yZ2 = parcelRequire("e2yZ2");

var $2oTKI = parcelRequire("2oTKI");

var $l3ouT = parcelRequire("l3ouT");

var $88IDB = parcelRequire("88IDB");

var $hDVJi = parcelRequire("hDVJi");

var $lVUCw = parcelRequire("lVUCw");

var $gSzFI = parcelRequire("gSzFI");

var $dXD4b = parcelRequire("dXD4b");

var $bpQhg = parcelRequire("bpQhg");
var $ab2637a17628a3c4$var$TO_STRING_TAG = $bpQhg("toStringTag");
var $ab2637a17628a3c4$var$$Error = Error;
var $ab2637a17628a3c4$var$push = [].push;
var $ab2637a17628a3c4$var$$AggregateError = function AggregateError(errors, message /* , options */ ) {
    var isInstance = $5L8hR($ab2637a17628a3c4$var$AggregateErrorPrototype, this);
    var that;
    if ($bV0bE) that = $bV0bE($ab2637a17628a3c4$var$$Error(), isInstance ? $gk5OL(this) : $ab2637a17628a3c4$var$AggregateErrorPrototype);
    else {
        that = isInstance ? this : $2oTKI($ab2637a17628a3c4$var$AggregateErrorPrototype);
        $l3ouT(that, $ab2637a17628a3c4$var$TO_STRING_TAG, "Error");
    }
    if (message !== undefined) $l3ouT(that, "message", $dXD4b(message));
    $lVUCw(that, $ab2637a17628a3c4$var$$AggregateError, that.stack, 1);
    if (arguments.length > 2) $hDVJi(that, arguments[2]);
    var errorsArray = [];
    $gSzFI(errors, $ab2637a17628a3c4$var$push, {
        that: errorsArray
    });
    $l3ouT(that, "errors", errorsArray);
    return that;
};
if ($bV0bE) $bV0bE($ab2637a17628a3c4$var$$AggregateError, $ab2637a17628a3c4$var$$Error);
else $e2yZ2($ab2637a17628a3c4$var$$AggregateError, $ab2637a17628a3c4$var$$Error, {
    name: true
});
var $ab2637a17628a3c4$var$AggregateErrorPrototype = $ab2637a17628a3c4$var$$AggregateError.prototype = $2oTKI($ab2637a17628a3c4$var$$Error.prototype, {
    constructor: $88IDB(1, $ab2637a17628a3c4$var$$AggregateError),
    message: $88IDB(1, ""),
    name: $88IDB(1, "AggregateError")
});
// `AggregateError` constructor
// https://tc39.es/ecma262/#sec-aggregate-error-constructor
$g2B3u({
    global: true,
    constructor: true,
    arity: 2
}, {
    AggregateError: $ab2637a17628a3c4$var$$AggregateError
});

});
parcelRequire.register("e2yZ2", function(module, exports) {

var $dydfX = parcelRequire("dydfX");

var $56H6d = parcelRequire("56H6d");

var $6IpKK = parcelRequire("6IpKK");

var $14MWq = parcelRequire("14MWq");
module.exports = function(target, source, exceptions) {
    var keys = $56H6d(source);
    var defineProperty = $14MWq.f;
    var getOwnPropertyDescriptor = $6IpKK.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$dydfX(target, key) && !(exceptions && $dydfX(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};

});
parcelRequire.register("56H6d", function(module, exports) {

var $bTXoK = parcelRequire("bTXoK");

var $7tcts = parcelRequire("7tcts");

var $7uHlQ = parcelRequire("7uHlQ");

var $fZ8lI = parcelRequire("fZ8lI");

var $lalRy = parcelRequire("lalRy");
var $3b7ef1e27a6bd6ae$var$concat = $7tcts([].concat);
// all object keys, includes non-enumerable and symbols
module.exports = $bTXoK("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $7uHlQ.f($lalRy(it));
    var getOwnPropertySymbols = $fZ8lI.f;
    return getOwnPropertySymbols ? $3b7ef1e27a6bd6ae$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};

});


parcelRequire.register("hDVJi", function(module, exports) {

var $atGHr = parcelRequire("atGHr");

var $l3ouT = parcelRequire("l3ouT");
// `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
module.exports = function(O, options) {
    if ($atGHr(options) && "cause" in options) $l3ouT(O, "cause", options.cause);
};

});

parcelRequire.register("lVUCw", function(module, exports) {

var $l3ouT = parcelRequire("l3ouT");

var $5vF5S = parcelRequire("5vF5S");

var $7HE7z = parcelRequire("7HE7z");
// non-standard V8
var $ff7ad777e4db25af$var$captureStackTrace = Error.captureStackTrace;
module.exports = function(error, C, stack, dropEntries) {
    if ($7HE7z) {
        if ($ff7ad777e4db25af$var$captureStackTrace) $ff7ad777e4db25af$var$captureStackTrace(error, C);
        else $l3ouT(error, "stack", $5vF5S(stack, dropEntries));
    }
};

});
parcelRequire.register("5vF5S", function(module, exports) {

var $7tcts = parcelRequire("7tcts");
var $402fb963035a1db4$var$$Error = Error;
var $402fb963035a1db4$var$replace = $7tcts("".replace);
var $402fb963035a1db4$var$TEST = function(arg) {
    return String($402fb963035a1db4$var$$Error(arg).stack);
}("zxcasd");
// eslint-disable-next-line redos/no-vulnerable -- safe
var $402fb963035a1db4$var$V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var $402fb963035a1db4$var$IS_V8_OR_CHAKRA_STACK = $402fb963035a1db4$var$V8_OR_CHAKRA_STACK_ENTRY.test($402fb963035a1db4$var$TEST);
module.exports = function(stack, dropEntries) {
    if ($402fb963035a1db4$var$IS_V8_OR_CHAKRA_STACK && typeof stack == "string" && !$402fb963035a1db4$var$$Error.prepareStackTrace) while(dropEntries--)stack = $402fb963035a1db4$var$replace(stack, $402fb963035a1db4$var$V8_OR_CHAKRA_STACK_ENTRY, "");
    return stack;
};

});

parcelRequire.register("7HE7z", function(module, exports) {

var $avKuJ = parcelRequire("avKuJ");

var $88IDB = parcelRequire("88IDB");
module.exports = !$avKuJ(function() {
    var error = Error("a");
    if (!("stack" in error)) return true;
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty(error, "stack", $88IDB(1, 7));
    return error.stack !== 7;
});

});


parcelRequire.register("dXD4b", function(module, exports) {

var $eG0jW = parcelRequire("eG0jW");
module.exports = function(argument, $default) {
    return argument === undefined ? arguments.length < 2 ? "" : $default : $eG0jW(argument);
};

});



parcelRequire.register("4xcc1", function(module, exports) {
// TODO: Remove this module from `core-js@4` since it's split to modules listed below
parcelRequire("jYTEi");
parcelRequire("9W36b");
parcelRequire("6M4P9");
parcelRequire("6z029");
parcelRequire("dwOa2");
parcelRequire("92mPa");

});
parcelRequire.register("jYTEi", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $2EepY = parcelRequire("2EepY");

var $jfyLo = parcelRequire("jfyLo");

var $6gFRb = parcelRequire("6gFRb");

var $5qecd = parcelRequire("5qecd");

var $87keX = parcelRequire("87keX");

var $bV0bE = parcelRequire("bV0bE");

var $a5xog = parcelRequire("a5xog");

var $gnIxM = parcelRequire("gnIxM");

var $aZpni = parcelRequire("aZpni");

var $6kYHq = parcelRequire("6kYHq");

var $atGHr = parcelRequire("atGHr");

var $1SdiW = parcelRequire("1SdiW");

var $jt3ct = parcelRequire("jt3ct");

var $aW7Fi = parcelRequire("aW7Fi");
var $e8bec9a5cfdc3566$require$task = $aW7Fi.set;

var $ctNZy = parcelRequire("ctNZy");

var $1BLQP = parcelRequire("1BLQP");

var $e3FYA = parcelRequire("e3FYA");

var $57XA5 = parcelRequire("57XA5");

var $CWMD0 = parcelRequire("CWMD0");

var $2wRdN = parcelRequire("2wRdN");

var $ju2Lt = parcelRequire("ju2Lt");

var $l394u = parcelRequire("l394u");
var $e8bec9a5cfdc3566$var$PROMISE = "Promise";
var $e8bec9a5cfdc3566$var$FORCED_PROMISE_CONSTRUCTOR = $ju2Lt.CONSTRUCTOR;
var $e8bec9a5cfdc3566$var$NATIVE_PROMISE_REJECTION_EVENT = $ju2Lt.REJECTION_EVENT;
var $e8bec9a5cfdc3566$var$NATIVE_PROMISE_SUBCLASSING = $ju2Lt.SUBCLASSING;
var $e8bec9a5cfdc3566$var$getInternalPromiseState = $CWMD0.getterFor($e8bec9a5cfdc3566$var$PROMISE);
var $e8bec9a5cfdc3566$var$setInternalState = $CWMD0.set;
var $e8bec9a5cfdc3566$var$NativePromisePrototype = $2wRdN && $2wRdN.prototype;
var $e8bec9a5cfdc3566$var$PromiseConstructor = $2wRdN;
var $e8bec9a5cfdc3566$var$PromisePrototype = $e8bec9a5cfdc3566$var$NativePromisePrototype;
var $e8bec9a5cfdc3566$var$TypeError = $6gFRb.TypeError;
var $e8bec9a5cfdc3566$var$document = $6gFRb.document;
var $e8bec9a5cfdc3566$var$process = $6gFRb.process;
var $e8bec9a5cfdc3566$var$newPromiseCapability = $l394u.f;
var $e8bec9a5cfdc3566$var$newGenericPromiseCapability = $e8bec9a5cfdc3566$var$newPromiseCapability;
var $e8bec9a5cfdc3566$var$DISPATCH_EVENT = !!($e8bec9a5cfdc3566$var$document && $e8bec9a5cfdc3566$var$document.createEvent && $6gFRb.dispatchEvent);
var $e8bec9a5cfdc3566$var$UNHANDLED_REJECTION = "unhandledrejection";
var $e8bec9a5cfdc3566$var$REJECTION_HANDLED = "rejectionhandled";
var $e8bec9a5cfdc3566$var$PENDING = 0;
var $e8bec9a5cfdc3566$var$FULFILLED = 1;
var $e8bec9a5cfdc3566$var$REJECTED = 2;
var $e8bec9a5cfdc3566$var$HANDLED = 1;
var $e8bec9a5cfdc3566$var$UNHANDLED = 2;
var $e8bec9a5cfdc3566$var$Internal, $e8bec9a5cfdc3566$var$OwnPromiseCapability, $e8bec9a5cfdc3566$var$PromiseWrapper, $e8bec9a5cfdc3566$var$nativeThen;
// helpers
var $e8bec9a5cfdc3566$var$isThenable = function(it) {
    var then;
    return $atGHr(it) && $6kYHq(then = it.then) ? then : false;
};
var $e8bec9a5cfdc3566$var$callReaction = function(reaction, state) {
    var value = state.value;
    var ok = state.state == $e8bec9a5cfdc3566$var$FULFILLED;
    var handler = ok ? reaction.ok : reaction.fail;
    var resolve = reaction.resolve;
    var reject = reaction.reject;
    var domain = reaction.domain;
    var result, then, exited;
    try {
        if (handler) {
            if (!ok) {
                if (state.rejection === $e8bec9a5cfdc3566$var$UNHANDLED) $e8bec9a5cfdc3566$var$onHandleUnhandled(state);
                state.rejection = $e8bec9a5cfdc3566$var$HANDLED;
            }
            if (handler === true) result = value;
            else {
                if (domain) domain.enter();
                result = handler(value); // can throw
                if (domain) {
                    domain.exit();
                    exited = true;
                }
            }
            if (result === reaction.promise) reject($e8bec9a5cfdc3566$var$TypeError("Promise-chain cycle"));
            else if (then = $e8bec9a5cfdc3566$var$isThenable(result)) $5qecd(then, result, resolve, reject);
            else resolve(result);
        } else reject(value);
    } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
    }
};
var $e8bec9a5cfdc3566$var$notify = function(state, isReject) {
    if (state.notified) return;
    state.notified = true;
    $ctNZy(function() {
        var reactions = state.reactions;
        var reaction;
        while(reaction = reactions.get())$e8bec9a5cfdc3566$var$callReaction(reaction, state);
        state.notified = false;
        if (isReject && !state.rejection) $e8bec9a5cfdc3566$var$onUnhandled(state);
    });
};
var $e8bec9a5cfdc3566$var$dispatchEvent = function(name, promise, reason) {
    var event, handler;
    if ($e8bec9a5cfdc3566$var$DISPATCH_EVENT) {
        event = $e8bec9a5cfdc3566$var$document.createEvent("Event");
        event.promise = promise;
        event.reason = reason;
        event.initEvent(name, false, true);
        $6gFRb.dispatchEvent(event);
    } else event = {
        promise: promise,
        reason: reason
    };
    if (!$e8bec9a5cfdc3566$var$NATIVE_PROMISE_REJECTION_EVENT && (handler = $6gFRb["on" + name])) handler(event);
    else if (name === $e8bec9a5cfdc3566$var$UNHANDLED_REJECTION) $1BLQP("Unhandled promise rejection", reason);
};
var $e8bec9a5cfdc3566$var$onUnhandled = function(state) {
    $5qecd($e8bec9a5cfdc3566$require$task, $6gFRb, function() {
        var promise = state.facade;
        var value = state.value;
        var IS_UNHANDLED = $e8bec9a5cfdc3566$var$isUnhandled(state);
        var result;
        if (IS_UNHANDLED) {
            result = $e3FYA(function() {
                if ($jfyLo) $e8bec9a5cfdc3566$var$process.emit("unhandledRejection", value, promise);
                else $e8bec9a5cfdc3566$var$dispatchEvent($e8bec9a5cfdc3566$var$UNHANDLED_REJECTION, promise, value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            state.rejection = $jfyLo || $e8bec9a5cfdc3566$var$isUnhandled(state) ? $e8bec9a5cfdc3566$var$UNHANDLED : $e8bec9a5cfdc3566$var$HANDLED;
            if (result.error) throw result.value;
        }
    });
};
var $e8bec9a5cfdc3566$var$isUnhandled = function(state) {
    return state.rejection !== $e8bec9a5cfdc3566$var$HANDLED && !state.parent;
};
var $e8bec9a5cfdc3566$var$onHandleUnhandled = function(state) {
    $5qecd($e8bec9a5cfdc3566$require$task, $6gFRb, function() {
        var promise = state.facade;
        if ($jfyLo) $e8bec9a5cfdc3566$var$process.emit("rejectionHandled", promise);
        else $e8bec9a5cfdc3566$var$dispatchEvent($e8bec9a5cfdc3566$var$REJECTION_HANDLED, promise, state.value);
    });
};
var $e8bec9a5cfdc3566$var$bind = function(fn, state, unwrap) {
    return function(value) {
        fn(state, value, unwrap);
    };
};
var $e8bec9a5cfdc3566$var$internalReject = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    state.value = value;
    state.state = $e8bec9a5cfdc3566$var$REJECTED;
    $e8bec9a5cfdc3566$var$notify(state, true);
};
var $e8bec9a5cfdc3566$var$internalResolve = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    try {
        if (state.facade === value) throw $e8bec9a5cfdc3566$var$TypeError("Promise can't be resolved itself");
        var then = $e8bec9a5cfdc3566$var$isThenable(value);
        if (then) $ctNZy(function() {
            var wrapper = {
                done: false
            };
            try {
                $5qecd(then, value, $e8bec9a5cfdc3566$var$bind($e8bec9a5cfdc3566$var$internalResolve, wrapper, state), $e8bec9a5cfdc3566$var$bind($e8bec9a5cfdc3566$var$internalReject, wrapper, state));
            } catch (error) {
                $e8bec9a5cfdc3566$var$internalReject(wrapper, error, state);
            }
        });
        else {
            state.value = value;
            state.state = $e8bec9a5cfdc3566$var$FULFILLED;
            $e8bec9a5cfdc3566$var$notify(state, false);
        }
    } catch (error) {
        $e8bec9a5cfdc3566$var$internalReject({
            done: false
        }, error, state);
    }
};
// constructor polyfill
if ($e8bec9a5cfdc3566$var$FORCED_PROMISE_CONSTRUCTOR) {
    // 25.4.3.1 Promise(executor)
    $e8bec9a5cfdc3566$var$PromiseConstructor = function Promise(executor) {
        $1SdiW(this, $e8bec9a5cfdc3566$var$PromisePrototype);
        $aZpni(executor);
        $5qecd($e8bec9a5cfdc3566$var$Internal, this);
        var state = $e8bec9a5cfdc3566$var$getInternalPromiseState(this);
        try {
            executor($e8bec9a5cfdc3566$var$bind($e8bec9a5cfdc3566$var$internalResolve, state), $e8bec9a5cfdc3566$var$bind($e8bec9a5cfdc3566$var$internalReject, state));
        } catch (error) {
            $e8bec9a5cfdc3566$var$internalReject(state, error);
        }
    };
    $e8bec9a5cfdc3566$var$PromisePrototype = $e8bec9a5cfdc3566$var$PromiseConstructor.prototype;
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    $e8bec9a5cfdc3566$var$Internal = function Promise(executor) {
        $e8bec9a5cfdc3566$var$setInternalState(this, {
            type: $e8bec9a5cfdc3566$var$PROMISE,
            done: false,
            notified: false,
            parent: false,
            reactions: new $57XA5(),
            rejection: false,
            state: $e8bec9a5cfdc3566$var$PENDING,
            value: undefined
        });
    };
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    $e8bec9a5cfdc3566$var$Internal.prototype = $87keX($e8bec9a5cfdc3566$var$PromisePrototype, "then", function then(onFulfilled, onRejected) {
        var state = $e8bec9a5cfdc3566$var$getInternalPromiseState(this);
        var reaction = $e8bec9a5cfdc3566$var$newPromiseCapability($jt3ct(this, $e8bec9a5cfdc3566$var$PromiseConstructor));
        state.parent = true;
        reaction.ok = $6kYHq(onFulfilled) ? onFulfilled : true;
        reaction.fail = $6kYHq(onRejected) && onRejected;
        reaction.domain = $jfyLo ? $e8bec9a5cfdc3566$var$process.domain : undefined;
        if (state.state == $e8bec9a5cfdc3566$var$PENDING) state.reactions.add(reaction);
        else $ctNZy(function() {
            $e8bec9a5cfdc3566$var$callReaction(reaction, state);
        });
        return reaction.promise;
    });
    $e8bec9a5cfdc3566$var$OwnPromiseCapability = function() {
        var promise = new $e8bec9a5cfdc3566$var$Internal();
        var state = $e8bec9a5cfdc3566$var$getInternalPromiseState(promise);
        this.promise = promise;
        this.resolve = $e8bec9a5cfdc3566$var$bind($e8bec9a5cfdc3566$var$internalResolve, state);
        this.reject = $e8bec9a5cfdc3566$var$bind($e8bec9a5cfdc3566$var$internalReject, state);
    };
    $l394u.f = $e8bec9a5cfdc3566$var$newPromiseCapability = function(C) {
        return C === $e8bec9a5cfdc3566$var$PromiseConstructor || C === $e8bec9a5cfdc3566$var$PromiseWrapper ? new $e8bec9a5cfdc3566$var$OwnPromiseCapability(C) : $e8bec9a5cfdc3566$var$newGenericPromiseCapability(C);
    };
    if (!$2EepY && $6kYHq($2wRdN) && $e8bec9a5cfdc3566$var$NativePromisePrototype !== Object.prototype) {
        $e8bec9a5cfdc3566$var$nativeThen = $e8bec9a5cfdc3566$var$NativePromisePrototype.then;
        if (!$e8bec9a5cfdc3566$var$NATIVE_PROMISE_SUBCLASSING) // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
        $87keX($e8bec9a5cfdc3566$var$NativePromisePrototype, "then", function then(onFulfilled, onRejected) {
            var that = this;
            return new $e8bec9a5cfdc3566$var$PromiseConstructor(function(resolve, reject) {
                $5qecd($e8bec9a5cfdc3566$var$nativeThen, that, resolve, reject);
            }).then(onFulfilled, onRejected);
        // https://github.com/zloirock/core-js/issues/640
        }, {
            unsafe: true
        });
        // make `.constructor === Promise` work for native promise-based APIs
        try {
            delete $e8bec9a5cfdc3566$var$NativePromisePrototype.constructor;
        } catch (error) {}
        // make `instanceof Promise` work for native promise-based APIs
        if ($bV0bE) $bV0bE($e8bec9a5cfdc3566$var$NativePromisePrototype, $e8bec9a5cfdc3566$var$PromisePrototype);
    }
}
$g2B3u({
    global: true,
    constructor: true,
    wrap: true,
    forced: $e8bec9a5cfdc3566$var$FORCED_PROMISE_CONSTRUCTOR
}, {
    Promise: $e8bec9a5cfdc3566$var$PromiseConstructor
});
$a5xog($e8bec9a5cfdc3566$var$PromiseConstructor, $e8bec9a5cfdc3566$var$PROMISE, false, true);
$gnIxM($e8bec9a5cfdc3566$var$PROMISE);

});
parcelRequire.register("jfyLo", function(module, exports) {

var $6qd2L = parcelRequire("6qd2L");

var $1SBP2 = parcelRequire("1SBP2");
module.exports = typeof $6qd2L != "undefined" && $1SBP2($6qd2L) == "process";

});
parcelRequire.register("6qd2L", function(module, exports) {
// shim for using process in browser
var $4acf49f6c3e67aec$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $4acf49f6c3e67aec$var$cachedSetTimeout;
var $4acf49f6c3e67aec$var$cachedClearTimeout;
function $4acf49f6c3e67aec$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $4acf49f6c3e67aec$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        else $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        else $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    }
})();
function $4acf49f6c3e67aec$var$runTimeout(fun) {
    if ($4acf49f6c3e67aec$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedSetTimeout === $4acf49f6c3e67aec$var$defaultSetTimout || !$4acf49f6c3e67aec$var$cachedSetTimeout) && setTimeout) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $4acf49f6c3e67aec$var$runClearTimeout(marker) {
    if ($4acf49f6c3e67aec$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedClearTimeout === $4acf49f6c3e67aec$var$defaultClearTimeout || !$4acf49f6c3e67aec$var$cachedClearTimeout) && clearTimeout) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $4acf49f6c3e67aec$var$queue = [];
var $4acf49f6c3e67aec$var$draining = false;
var $4acf49f6c3e67aec$var$currentQueue;
var $4acf49f6c3e67aec$var$queueIndex = -1;
function $4acf49f6c3e67aec$var$cleanUpNextTick() {
    if (!$4acf49f6c3e67aec$var$draining || !$4acf49f6c3e67aec$var$currentQueue) return;
    $4acf49f6c3e67aec$var$draining = false;
    if ($4acf49f6c3e67aec$var$currentQueue.length) $4acf49f6c3e67aec$var$queue = $4acf49f6c3e67aec$var$currentQueue.concat($4acf49f6c3e67aec$var$queue);
    else $4acf49f6c3e67aec$var$queueIndex = -1;
    if ($4acf49f6c3e67aec$var$queue.length) $4acf49f6c3e67aec$var$drainQueue();
}
function $4acf49f6c3e67aec$var$drainQueue() {
    if ($4acf49f6c3e67aec$var$draining) return;
    var timeout = $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$cleanUpNextTick);
    $4acf49f6c3e67aec$var$draining = true;
    var len = $4acf49f6c3e67aec$var$queue.length;
    while(len){
        $4acf49f6c3e67aec$var$currentQueue = $4acf49f6c3e67aec$var$queue;
        $4acf49f6c3e67aec$var$queue = [];
        while(++$4acf49f6c3e67aec$var$queueIndex < len)if ($4acf49f6c3e67aec$var$currentQueue) $4acf49f6c3e67aec$var$currentQueue[$4acf49f6c3e67aec$var$queueIndex].run();
        $4acf49f6c3e67aec$var$queueIndex = -1;
        len = $4acf49f6c3e67aec$var$queue.length;
    }
    $4acf49f6c3e67aec$var$currentQueue = null;
    $4acf49f6c3e67aec$var$draining = false;
    $4acf49f6c3e67aec$var$runClearTimeout(timeout);
}
$4acf49f6c3e67aec$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $4acf49f6c3e67aec$var$queue.push(new $4acf49f6c3e67aec$var$Item(fun, args));
    if ($4acf49f6c3e67aec$var$queue.length === 1 && !$4acf49f6c3e67aec$var$draining) $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$drainQueue);
};
// v8 likes predictible objects
function $4acf49f6c3e67aec$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$4acf49f6c3e67aec$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$4acf49f6c3e67aec$var$process.title = "browser";
$4acf49f6c3e67aec$var$process.browser = true;
$4acf49f6c3e67aec$var$process.env = {};
$4acf49f6c3e67aec$var$process.argv = [];
$4acf49f6c3e67aec$var$process.version = ""; // empty string to avoid regexp issues
$4acf49f6c3e67aec$var$process.versions = {};
function $4acf49f6c3e67aec$var$noop() {}
$4acf49f6c3e67aec$var$process.on = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.addListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.once = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.off = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeAllListeners = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.emit = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependOnceListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.listeners = function(name) {
    return [];
};
$4acf49f6c3e67aec$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$4acf49f6c3e67aec$var$process.cwd = function() {
    return "/";
};
$4acf49f6c3e67aec$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$4acf49f6c3e67aec$var$process.umask = function() {
    return 0;
};

});


parcelRequire.register("gnIxM", function(module, exports) {
"use strict";

var $bTXoK = parcelRequire("bTXoK");

var $1oUoQ = parcelRequire("1oUoQ");

var $bpQhg = parcelRequire("bpQhg");

var $99D40 = parcelRequire("99D40");
var $bed158ca58b85152$var$SPECIES = $bpQhg("species");
module.exports = function(CONSTRUCTOR_NAME) {
    var Constructor = $bTXoK(CONSTRUCTOR_NAME);
    if ($99D40 && Constructor && !Constructor[$bed158ca58b85152$var$SPECIES]) $1oUoQ(Constructor, $bed158ca58b85152$var$SPECIES, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};

});

parcelRequire.register("jt3ct", function(module, exports) {

var $lalRy = parcelRequire("lalRy");

var $f3ZOd = parcelRequire("f3ZOd");

var $9PkDw = parcelRequire("9PkDw");

var $bpQhg = parcelRequire("bpQhg");
var $e2c3353e402da252$var$SPECIES = $bpQhg("species");
// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function(O, defaultConstructor) {
    var C = $lalRy(O).constructor;
    var S;
    return C === undefined || $9PkDw(S = $lalRy(C)[$e2c3353e402da252$var$SPECIES]) ? defaultConstructor : $f3ZOd(S);
};

});
parcelRequire.register("f3ZOd", function(module, exports) {

var $3BUS6 = parcelRequire("3BUS6");

var $4ubrU = parcelRequire("4ubrU");
var $af7714cbbda200f7$var$$TypeError = TypeError;
// `Assert: IsConstructor(argument) is true`
module.exports = function(argument) {
    if ($3BUS6(argument)) return argument;
    throw $af7714cbbda200f7$var$$TypeError($4ubrU(argument) + " is not a constructor");
};

});


parcelRequire.register("aW7Fi", function(module, exports) {

var $6gFRb = parcelRequire("6gFRb");

var $9YGjW = parcelRequire("9YGjW");

var $2B9V4 = parcelRequire("2B9V4");

var $6kYHq = parcelRequire("6kYHq");

var $dydfX = parcelRequire("dydfX");

var $avKuJ = parcelRequire("avKuJ");

var $ajZzW = parcelRequire("ajZzW");

var $74qJH = parcelRequire("74qJH");

var $gLicj = parcelRequire("gLicj");

var $acL92 = parcelRequire("acL92");

var $huJoc = parcelRequire("huJoc");

var $jfyLo = parcelRequire("jfyLo");
var $7f65444694775b4e$var$set = $6gFRb.setImmediate;
var $7f65444694775b4e$var$clear = $6gFRb.clearImmediate;
var $7f65444694775b4e$var$process = $6gFRb.process;
var $7f65444694775b4e$var$Dispatch = $6gFRb.Dispatch;
var $7f65444694775b4e$var$Function = $6gFRb.Function;
var $7f65444694775b4e$var$MessageChannel = $6gFRb.MessageChannel;
var $7f65444694775b4e$var$String = $6gFRb.String;
var $7f65444694775b4e$var$counter = 0;
var $7f65444694775b4e$var$queue = {};
var $7f65444694775b4e$var$ONREADYSTATECHANGE = "onreadystatechange";
var $7f65444694775b4e$var$$location, $7f65444694775b4e$var$defer, $7f65444694775b4e$var$channel, $7f65444694775b4e$var$port;
$avKuJ(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $7f65444694775b4e$var$$location = $6gFRb.location;
});
var $7f65444694775b4e$var$run = function(id) {
    if ($dydfX($7f65444694775b4e$var$queue, id)) {
        var fn = $7f65444694775b4e$var$queue[id];
        delete $7f65444694775b4e$var$queue[id];
        fn();
    }
};
var $7f65444694775b4e$var$runner = function(id) {
    return function() {
        $7f65444694775b4e$var$run(id);
    };
};
var $7f65444694775b4e$var$eventListener = function(event) {
    $7f65444694775b4e$var$run(event.data);
};
var $7f65444694775b4e$var$globalPostMessageDefer = function(id) {
    // old engines have not location.origin
    $6gFRb.postMessage($7f65444694775b4e$var$String(id), $7f65444694775b4e$var$$location.protocol + "//" + $7f65444694775b4e$var$$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$7f65444694775b4e$var$set || !$7f65444694775b4e$var$clear) {
    $7f65444694775b4e$var$set = function setImmediate(handler) {
        $acL92(arguments.length, 1);
        var fn = $6kYHq(handler) ? handler : $7f65444694775b4e$var$Function(handler);
        var args = $74qJH(arguments, 1);
        $7f65444694775b4e$var$queue[++$7f65444694775b4e$var$counter] = function() {
            $9YGjW(fn, undefined, args);
        };
        $7f65444694775b4e$var$defer($7f65444694775b4e$var$counter);
        return $7f65444694775b4e$var$counter;
    };
    $7f65444694775b4e$var$clear = function clearImmediate(id) {
        delete $7f65444694775b4e$var$queue[id];
    };
    // Node.js 0.8-
    if ($jfyLo) $7f65444694775b4e$var$defer = function(id) {
        $7f65444694775b4e$var$process.nextTick($7f65444694775b4e$var$runner(id));
    };
    else if ($7f65444694775b4e$var$Dispatch && $7f65444694775b4e$var$Dispatch.now) $7f65444694775b4e$var$defer = function(id) {
        $7f65444694775b4e$var$Dispatch.now($7f65444694775b4e$var$runner(id));
    };
    else if ($7f65444694775b4e$var$MessageChannel && !$huJoc) {
        $7f65444694775b4e$var$channel = new $7f65444694775b4e$var$MessageChannel();
        $7f65444694775b4e$var$port = $7f65444694775b4e$var$channel.port2;
        $7f65444694775b4e$var$channel.port1.onmessage = $7f65444694775b4e$var$eventListener;
        $7f65444694775b4e$var$defer = $2B9V4($7f65444694775b4e$var$port.postMessage, $7f65444694775b4e$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($6gFRb.addEventListener && $6kYHq($6gFRb.postMessage) && !$6gFRb.importScripts && $7f65444694775b4e$var$$location && $7f65444694775b4e$var$$location.protocol !== "file:" && !$avKuJ($7f65444694775b4e$var$globalPostMessageDefer)) {
        $7f65444694775b4e$var$defer = $7f65444694775b4e$var$globalPostMessageDefer;
        $6gFRb.addEventListener("message", $7f65444694775b4e$var$eventListener, false);
    // IE8-
    } else if ($7f65444694775b4e$var$ONREADYSTATECHANGE in $gLicj("script")) $7f65444694775b4e$var$defer = function(id) {
        $ajZzW.appendChild($gLicj("script"))[$7f65444694775b4e$var$ONREADYSTATECHANGE] = function() {
            $ajZzW.removeChild(this);
            $7f65444694775b4e$var$run(id);
        };
    };
    else $7f65444694775b4e$var$defer = function(id) {
        setTimeout($7f65444694775b4e$var$runner(id), 0);
    };
}
module.exports = {
    set: $7f65444694775b4e$var$set,
    clear: $7f65444694775b4e$var$clear
};

});
parcelRequire.register("acL92", function(module, exports) {
var $76df9853b399a62a$var$$TypeError = TypeError;
module.exports = function(passed, required) {
    if (passed < required) throw $76df9853b399a62a$var$$TypeError("Not enough arguments");
    return passed;
};

});

parcelRequire.register("huJoc", function(module, exports) {

var $jGeXI = parcelRequire("jGeXI");
// eslint-disable-next-line redos/no-vulnerable -- safe
module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test($jGeXI);

});


parcelRequire.register("ctNZy", function(module, exports) {

var $6gFRb = parcelRequire("6gFRb");

var $2B9V4 = parcelRequire("2B9V4");

var $6IpKK = parcelRequire("6IpKK");
var $915ef8c6c2812fe0$require$getOwnPropertyDescriptor = $6IpKK.f;

var $aW7Fi = parcelRequire("aW7Fi");
var $915ef8c6c2812fe0$require$macrotask = $aW7Fi.set;

var $57XA5 = parcelRequire("57XA5");

var $huJoc = parcelRequire("huJoc");

var $3LpF5 = parcelRequire("3LpF5");

var $01tz6 = parcelRequire("01tz6");

var $jfyLo = parcelRequire("jfyLo");
var $915ef8c6c2812fe0$var$MutationObserver = $6gFRb.MutationObserver || $6gFRb.WebKitMutationObserver;
var $915ef8c6c2812fe0$var$document = $6gFRb.document;
var $915ef8c6c2812fe0$var$process = $6gFRb.process;
var $915ef8c6c2812fe0$var$Promise = $6gFRb.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var $915ef8c6c2812fe0$var$queueMicrotaskDescriptor = $915ef8c6c2812fe0$require$getOwnPropertyDescriptor($6gFRb, "queueMicrotask");
var $915ef8c6c2812fe0$var$microtask = $915ef8c6c2812fe0$var$queueMicrotaskDescriptor && $915ef8c6c2812fe0$var$queueMicrotaskDescriptor.value;
var $915ef8c6c2812fe0$var$notify, $915ef8c6c2812fe0$var$toggle, $915ef8c6c2812fe0$var$node, $915ef8c6c2812fe0$var$promise, $915ef8c6c2812fe0$var$then;
// modern engines have queueMicrotask method
if (!$915ef8c6c2812fe0$var$microtask) {
    var $915ef8c6c2812fe0$var$queue = new $57XA5();
    var $915ef8c6c2812fe0$var$flush = function() {
        var parent, fn;
        if ($jfyLo && (parent = $915ef8c6c2812fe0$var$process.domain)) parent.exit();
        while(fn = $915ef8c6c2812fe0$var$queue.get())try {
            fn();
        } catch (error) {
            if ($915ef8c6c2812fe0$var$queue.head) $915ef8c6c2812fe0$var$notify();
            throw error;
        }
        if (parent) parent.enter();
    };
    // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
    // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
    if (!$huJoc && !$jfyLo && !$01tz6 && $915ef8c6c2812fe0$var$MutationObserver && $915ef8c6c2812fe0$var$document) {
        $915ef8c6c2812fe0$var$toggle = true;
        $915ef8c6c2812fe0$var$node = $915ef8c6c2812fe0$var$document.createTextNode("");
        new $915ef8c6c2812fe0$var$MutationObserver($915ef8c6c2812fe0$var$flush).observe($915ef8c6c2812fe0$var$node, {
            characterData: true
        });
        $915ef8c6c2812fe0$var$notify = function() {
            $915ef8c6c2812fe0$var$node.data = $915ef8c6c2812fe0$var$toggle = !$915ef8c6c2812fe0$var$toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if (!$3LpF5 && $915ef8c6c2812fe0$var$Promise && $915ef8c6c2812fe0$var$Promise.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        $915ef8c6c2812fe0$var$promise = $915ef8c6c2812fe0$var$Promise.resolve(undefined);
        // workaround of WebKit ~ iOS Safari 10.1 bug
        $915ef8c6c2812fe0$var$promise.constructor = $915ef8c6c2812fe0$var$Promise;
        $915ef8c6c2812fe0$var$then = $2B9V4($915ef8c6c2812fe0$var$promise.then, $915ef8c6c2812fe0$var$promise);
        $915ef8c6c2812fe0$var$notify = function() {
            $915ef8c6c2812fe0$var$then($915ef8c6c2812fe0$var$flush);
        };
    // Node.js without promises
    } else if ($jfyLo) $915ef8c6c2812fe0$var$notify = function() {
        $915ef8c6c2812fe0$var$process.nextTick($915ef8c6c2812fe0$var$flush);
    };
    else {
        // `webpack` dev server bug on IE global methods - use bind(fn, global)
        $915ef8c6c2812fe0$require$macrotask = $2B9V4($915ef8c6c2812fe0$require$macrotask, $6gFRb);
        $915ef8c6c2812fe0$var$notify = function() {
            $915ef8c6c2812fe0$require$macrotask($915ef8c6c2812fe0$var$flush);
        };
    }
    $915ef8c6c2812fe0$var$microtask = function(fn) {
        if (!$915ef8c6c2812fe0$var$queue.head) $915ef8c6c2812fe0$var$notify();
        $915ef8c6c2812fe0$var$queue.add(fn);
    };
}
module.exports = $915ef8c6c2812fe0$var$microtask;

});
parcelRequire.register("57XA5", function(module, exports) {
var $3bbbd2c379e5983b$var$Queue = function() {
    this.head = null;
    this.tail = null;
};
$3bbbd2c379e5983b$var$Queue.prototype = {
    add: function(item) {
        var entry = {
            item: item,
            next: null
        };
        var tail = this.tail;
        if (tail) tail.next = entry;
        else this.head = entry;
        this.tail = entry;
    },
    get: function() {
        var entry = this.head;
        if (entry) {
            var next = this.head = entry.next;
            if (next === null) this.tail = null;
            return entry.item;
        }
    }
};
module.exports = $3bbbd2c379e5983b$var$Queue;

});

parcelRequire.register("3LpF5", function(module, exports) {

var $jGeXI = parcelRequire("jGeXI");
module.exports = /ipad|iphone|ipod/i.test($jGeXI) && typeof Pebble != "undefined";

});

parcelRequire.register("01tz6", function(module, exports) {

var $jGeXI = parcelRequire("jGeXI");
module.exports = /web0s(?!.*chrome)/i.test($jGeXI);

});


parcelRequire.register("1BLQP", function(module, exports) {
module.exports = function(a, b) {
    try {
        // eslint-disable-next-line no-console -- safe
        arguments.length == 1 ? console.error(a) : console.error(a, b);
    } catch (error) {}
};

});

parcelRequire.register("e3FYA", function(module, exports) {
module.exports = function(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};

});

parcelRequire.register("2wRdN", function(module, exports) {

var $6gFRb = parcelRequire("6gFRb");
module.exports = $6gFRb.Promise;

});

parcelRequire.register("ju2Lt", function(module, exports) {

var $6gFRb = parcelRequire("6gFRb");

var $2wRdN = parcelRequire("2wRdN");

var $6kYHq = parcelRequire("6kYHq");

var $uEW8O = parcelRequire("uEW8O");

var $JLKZp = parcelRequire("JLKZp");

var $bpQhg = parcelRequire("bpQhg");

var $a237h = parcelRequire("a237h");

var $7aJpX = parcelRequire("7aJpX");

var $2EepY = parcelRequire("2EepY");

var $dOZLy = parcelRequire("dOZLy");
var $e2f2f6af6e58c83d$var$NativePromisePrototype = $2wRdN && $2wRdN.prototype;
var $e2f2f6af6e58c83d$var$SPECIES = $bpQhg("species");
var $e2f2f6af6e58c83d$var$SUBCLASSING = false;
var $e2f2f6af6e58c83d$var$NATIVE_PROMISE_REJECTION_EVENT = $6kYHq($6gFRb.PromiseRejectionEvent);
var $e2f2f6af6e58c83d$var$FORCED_PROMISE_CONSTRUCTOR = $uEW8O("Promise", function() {
    var PROMISE_CONSTRUCTOR_SOURCE = $JLKZp($2wRdN);
    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String($2wRdN);
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (!GLOBAL_CORE_JS_PROMISE && $dOZLy === 66) return true;
    // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
    if ($2EepY && !($e2f2f6af6e58c83d$var$NativePromisePrototype["catch"] && $e2f2f6af6e58c83d$var$NativePromisePrototype["finally"])) return true;
    // We can't use @@species feature detection in V8 since it causes
    // deoptimization and performance degradation
    // https://github.com/zloirock/core-js/issues/679
    if (!$dOZLy || $dOZLy < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
        // Detect correctness of subclassing with @@species support
        var promise = new $2wRdN(function(resolve) {
            resolve(1);
        });
        var FakePromise = function(exec) {
            exec(function() {}, function() {});
        };
        var constructor = promise.constructor = {};
        constructor[$e2f2f6af6e58c83d$var$SPECIES] = FakePromise;
        $e2f2f6af6e58c83d$var$SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
        if (!$e2f2f6af6e58c83d$var$SUBCLASSING) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    }
    return !GLOBAL_CORE_JS_PROMISE && ($a237h || $7aJpX) && !$e2f2f6af6e58c83d$var$NATIVE_PROMISE_REJECTION_EVENT;
});
module.exports = {
    CONSTRUCTOR: $e2f2f6af6e58c83d$var$FORCED_PROMISE_CONSTRUCTOR,
    REJECTION_EVENT: $e2f2f6af6e58c83d$var$NATIVE_PROMISE_REJECTION_EVENT,
    SUBCLASSING: $e2f2f6af6e58c83d$var$SUBCLASSING
};

});
parcelRequire.register("a237h", function(module, exports) {

var $7aJpX = parcelRequire("7aJpX");

var $jfyLo = parcelRequire("jfyLo");
module.exports = !$7aJpX && !$jfyLo && typeof window == "object" && typeof document == "object";

});
parcelRequire.register("7aJpX", function(module, exports) {
/* global Deno -- Deno case */ module.exports = typeof Deno == "object" && Deno && typeof Deno.version == "object";

});



parcelRequire.register("l394u", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $f530ea2d36daeeda$export$2d1720544b23b823; }, function (v) { return $f530ea2d36daeeda$export$2d1720544b23b823 = v; });
// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
var $f530ea2d36daeeda$export$2d1720544b23b823;
"use strict";

var $aZpni = parcelRequire("aZpni");
var $f530ea2d36daeeda$var$$TypeError = TypeError;
var $f530ea2d36daeeda$var$PromiseCapability = function(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw $f530ea2d36daeeda$var$$TypeError("Bad Promise constructor");
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $aZpni(resolve);
    this.reject = $aZpni(reject);
};
$f530ea2d36daeeda$export$2d1720544b23b823 = function(C) {
    return new $f530ea2d36daeeda$var$PromiseCapability(C);
};

});


parcelRequire.register("9W36b", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $5qecd = parcelRequire("5qecd");

var $aZpni = parcelRequire("aZpni");

var $l394u = parcelRequire("l394u");

var $e3FYA = parcelRequire("e3FYA");

var $gSzFI = parcelRequire("gSzFI");

var $gLk6B = parcelRequire("gLk6B");
// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$g2B3u({
    target: "Promise",
    stat: true,
    forced: $gLk6B
}, {
    all: function all(iterable) {
        var C = this;
        var capability = $l394u.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $e3FYA(function() {
            var $promiseResolve = $aZpni(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $gSzFI(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $5qecd($promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});

});
parcelRequire.register("gLk6B", function(module, exports) {

var $2wRdN = parcelRequire("2wRdN");

var $atz9r = parcelRequire("atz9r");

var $ju2Lt = parcelRequire("ju2Lt");
var $c340a1ae57095475$require$FORCED_PROMISE_CONSTRUCTOR = $ju2Lt.CONSTRUCTOR;
module.exports = $c340a1ae57095475$require$FORCED_PROMISE_CONSTRUCTOR || !$atz9r(function(iterable) {
    $2wRdN.all(iterable).then(undefined, function() {});
});

});
parcelRequire.register("atz9r", function(module, exports) {

var $bpQhg = parcelRequire("bpQhg");
var $7a07e11d7a33bb69$var$ITERATOR = $bpQhg("iterator");
var $7a07e11d7a33bb69$var$SAFE_CLOSING = false;
try {
    var $7a07e11d7a33bb69$var$called = 0;
    var $7a07e11d7a33bb69$var$iteratorWithReturn = {
        next: function() {
            return {
                done: !!$7a07e11d7a33bb69$var$called++
            };
        },
        "return": function() {
            $7a07e11d7a33bb69$var$SAFE_CLOSING = true;
        }
    };
    $7a07e11d7a33bb69$var$iteratorWithReturn[$7a07e11d7a33bb69$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from($7a07e11d7a33bb69$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
module.exports = function(exec, SKIP_CLOSING) {
    if (!SKIP_CLOSING && !$7a07e11d7a33bb69$var$SAFE_CLOSING) return false;
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$7a07e11d7a33bb69$var$ITERATOR] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};

});



parcelRequire.register("6M4P9", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $2EepY = parcelRequire("2EepY");

var $ju2Lt = parcelRequire("ju2Lt");
var $4eeaf7b63143e4e2$require$FORCED_PROMISE_CONSTRUCTOR = $ju2Lt.CONSTRUCTOR;

var $2wRdN = parcelRequire("2wRdN");

var $bTXoK = parcelRequire("bTXoK");

var $6kYHq = parcelRequire("6kYHq");

var $87keX = parcelRequire("87keX");
var $4eeaf7b63143e4e2$var$NativePromisePrototype = $2wRdN && $2wRdN.prototype;
// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$g2B3u({
    target: "Promise",
    proto: true,
    forced: $4eeaf7b63143e4e2$require$FORCED_PROMISE_CONSTRUCTOR,
    real: true
}, {
    "catch": function(onRejected) {
        return this.then(undefined, onRejected);
    }
});
// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (!$2EepY && $6kYHq($2wRdN)) {
    var $4eeaf7b63143e4e2$var$method = $bTXoK("Promise").prototype["catch"];
    if ($4eeaf7b63143e4e2$var$NativePromisePrototype["catch"] !== $4eeaf7b63143e4e2$var$method) $87keX($4eeaf7b63143e4e2$var$NativePromisePrototype, "catch", $4eeaf7b63143e4e2$var$method, {
        unsafe: true
    });
}

});

parcelRequire.register("6z029", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $5qecd = parcelRequire("5qecd");

var $aZpni = parcelRequire("aZpni");

var $l394u = parcelRequire("l394u");

var $e3FYA = parcelRequire("e3FYA");

var $gSzFI = parcelRequire("gSzFI");

var $gLk6B = parcelRequire("gLk6B");
// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$g2B3u({
    target: "Promise",
    stat: true,
    forced: $gLk6B
}, {
    race: function race(iterable) {
        var C = this;
        var capability = $l394u.f(C);
        var reject = capability.reject;
        var result = $e3FYA(function() {
            var $promiseResolve = $aZpni(C.resolve);
            $gSzFI(iterable, function(promise) {
                $5qecd($promiseResolve, C, promise).then(capability.resolve, reject);
            });
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});

});

parcelRequire.register("dwOa2", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $5qecd = parcelRequire("5qecd");

var $l394u = parcelRequire("l394u");

var $ju2Lt = parcelRequire("ju2Lt");
var $9d952c6fa4df89ae$require$FORCED_PROMISE_CONSTRUCTOR = $ju2Lt.CONSTRUCTOR;
// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$g2B3u({
    target: "Promise",
    stat: true,
    forced: $9d952c6fa4df89ae$require$FORCED_PROMISE_CONSTRUCTOR
}, {
    reject: function reject(r) {
        var capability = $l394u.f(this);
        $5qecd(capability.reject, undefined, r);
        return capability.promise;
    }
});

});

parcelRequire.register("92mPa", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $bTXoK = parcelRequire("bTXoK");

var $2EepY = parcelRequire("2EepY");

var $2wRdN = parcelRequire("2wRdN");

var $ju2Lt = parcelRequire("ju2Lt");
var $69460168020bb69f$require$FORCED_PROMISE_CONSTRUCTOR = $ju2Lt.CONSTRUCTOR;

var $7P0CW = parcelRequire("7P0CW");
var $69460168020bb69f$var$PromiseConstructorWrapper = $bTXoK("Promise");
var $69460168020bb69f$var$CHECK_WRAPPER = $2EepY && !$69460168020bb69f$require$FORCED_PROMISE_CONSTRUCTOR;
// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$g2B3u({
    target: "Promise",
    stat: true,
    forced: $2EepY || $69460168020bb69f$require$FORCED_PROMISE_CONSTRUCTOR
}, {
    resolve: function resolve(x) {
        return $7P0CW($69460168020bb69f$var$CHECK_WRAPPER && this === $69460168020bb69f$var$PromiseConstructorWrapper ? $2wRdN : this, x);
    }
});

});
parcelRequire.register("7P0CW", function(module, exports) {

var $lalRy = parcelRequire("lalRy");

var $atGHr = parcelRequire("atGHr");

var $l394u = parcelRequire("l394u");
module.exports = function(C, x) {
    $lalRy(C);
    if ($atGHr(x) && x.constructor === C) return x;
    var promiseCapability = $l394u.f(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};

});



parcelRequire.register("6pPnA", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $5qecd = parcelRequire("5qecd");

var $aZpni = parcelRequire("aZpni");

var $l394u = parcelRequire("l394u");

var $e3FYA = parcelRequire("e3FYA");

var $gSzFI = parcelRequire("gSzFI");

var $gLk6B = parcelRequire("gLk6B");
// `Promise.allSettled` method
// https://tc39.es/ecma262/#sec-promise.allsettled
$g2B3u({
    target: "Promise",
    stat: true,
    forced: $gLk6B
}, {
    allSettled: function allSettled(iterable) {
        var C = this;
        var capability = $l394u.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $e3FYA(function() {
            var promiseResolve = $aZpni(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $gSzFI(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $5qecd(promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = {
                        status: "fulfilled",
                        value: value
                    };
                    --remaining || resolve(values);
                }, function(error) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = {
                        status: "rejected",
                        reason: error
                    };
                    --remaining || resolve(values);
                });
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});

});

parcelRequire.register("dTGrZ", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $5qecd = parcelRequire("5qecd");

var $aZpni = parcelRequire("aZpni");

var $bTXoK = parcelRequire("bTXoK");

var $l394u = parcelRequire("l394u");

var $e3FYA = parcelRequire("e3FYA");

var $gSzFI = parcelRequire("gSzFI");

var $gLk6B = parcelRequire("gLk6B");
var $a1e1572b84f11545$var$PROMISE_ANY_ERROR = "No one promise resolved";
// `Promise.any` method
// https://tc39.es/ecma262/#sec-promise.any
$g2B3u({
    target: "Promise",
    stat: true,
    forced: $gLk6B
}, {
    any: function any(iterable) {
        var C = this;
        var AggregateError = $bTXoK("AggregateError");
        var capability = $l394u.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $e3FYA(function() {
            var promiseResolve = $aZpni(C.resolve);
            var errors = [];
            var counter = 0;
            var remaining = 1;
            var alreadyResolved = false;
            $gSzFI(iterable, function(promise) {
                var index = counter++;
                var alreadyRejected = false;
                remaining++;
                $5qecd(promiseResolve, C, promise).then(function(value) {
                    if (alreadyRejected || alreadyResolved) return;
                    alreadyResolved = true;
                    resolve(value);
                }, function(error) {
                    if (alreadyRejected || alreadyResolved) return;
                    alreadyRejected = true;
                    errors[index] = error;
                    --remaining || reject(new AggregateError(errors, $a1e1572b84f11545$var$PROMISE_ANY_ERROR));
                });
            });
            --remaining || reject(new AggregateError(errors, $a1e1572b84f11545$var$PROMISE_ANY_ERROR));
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});

});

parcelRequire.register("gNC4x", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $2EepY = parcelRequire("2EepY");

var $2wRdN = parcelRequire("2wRdN");

var $avKuJ = parcelRequire("avKuJ");

var $bTXoK = parcelRequire("bTXoK");

var $6kYHq = parcelRequire("6kYHq");

var $jt3ct = parcelRequire("jt3ct");

var $7P0CW = parcelRequire("7P0CW");

var $87keX = parcelRequire("87keX");
var $c3aec1472a08d107$var$NativePromisePrototype = $2wRdN && $2wRdN.prototype;
// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var $c3aec1472a08d107$var$NON_GENERIC = !!$2wRdN && $avKuJ(function() {
    // eslint-disable-next-line unicorn/no-thenable -- required for testing
    $c3aec1472a08d107$var$NativePromisePrototype["finally"].call({
        then: function() {}
    }, function() {});
});
// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
$g2B3u({
    target: "Promise",
    proto: true,
    real: true,
    forced: $c3aec1472a08d107$var$NON_GENERIC
}, {
    "finally": function(onFinally) {
        var C = $jt3ct(this, $bTXoK("Promise"));
        var isFunction = $6kYHq(onFinally);
        return this.then(isFunction ? function(x) {
            return $7P0CW(C, onFinally()).then(function() {
                return x;
            });
        } : onFinally, isFunction ? function(e) {
            return $7P0CW(C, onFinally()).then(function() {
                throw e;
            });
        } : onFinally);
    }
});
// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
if (!$2EepY && $6kYHq($2wRdN)) {
    var $c3aec1472a08d107$var$method = $bTXoK("Promise").prototype["finally"];
    if ($c3aec1472a08d107$var$NativePromisePrototype["finally"] !== $c3aec1472a08d107$var$method) $87keX($c3aec1472a08d107$var$NativePromisePrototype, "finally", $c3aec1472a08d107$var$method, {
        unsafe: true
    });
}

});




parcelRequire.register("7CFxK", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $evY07 = parcelRequire("evY07");
$evY07(module.exports, "__esModule", {
    value: true
});
module.exports.default = $58cc4eab8a475dd4$var$decode;

var $58cc4eab8a475dd4$var$_forEach = $3Npdz((parcelRequire("jZGC2")));

var $58cc4eab8a475dd4$var$_isArray = $3Npdz((parcelRequire("i0kCX")));

var $58cc4eab8a475dd4$var$_typeof2 = $3Npdz((parcelRequire("akViX")));

var $58cc4eab8a475dd4$var$_ParseACL = $3Npdz((parcelRequire("9HvHn")));

var $58cc4eab8a475dd4$var$_ParseFile = $3Npdz((parcelRequire("gf3Ge")));

var $58cc4eab8a475dd4$var$_ParseGeoPoint = $3Npdz((parcelRequire("5vhig")));

var $58cc4eab8a475dd4$var$_ParsePolygon = $3Npdz((parcelRequire("dkxwb")));

var $58cc4eab8a475dd4$var$_ParseObject = $3Npdz((parcelRequire("2HIpX")));

var $1WcLm = parcelRequire("1WcLm");

var $58cc4eab8a475dd4$var$_ParseRelation = $3Npdz((parcelRequire("4Glkc")));
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ // eslint-disable-line no-unused-vars
function $58cc4eab8a475dd4$var$decode(value) /*: any*/ {
    if (value === null || (0, $58cc4eab8a475dd4$var$_typeof2.default)(value) !== "object" || value instanceof Date) return value;
    if ((0, $58cc4eab8a475dd4$var$_isArray.default)(value)) {
        var dup = [];
        (0, $58cc4eab8a475dd4$var$_forEach.default)(value).call(value, function(v, i) {
            dup[i] = $58cc4eab8a475dd4$var$decode(v);
        });
        return dup;
    }
    if (typeof value.__op === "string") return (0, $1WcLm.opFromJSON)(value);
    if (value.__type === "Pointer" && value.className) return $58cc4eab8a475dd4$var$_ParseObject.default.fromJSON(value);
    if (value.__type === "Object" && value.className) return $58cc4eab8a475dd4$var$_ParseObject.default.fromJSON(value);
    if (value.__type === "Relation") {
        // The parent and key fields will be populated by the parent
        var relation = new $58cc4eab8a475dd4$var$_ParseRelation.default(null, null);
        relation.targetClassName = value.className;
        return relation;
    }
    if (value.__type === "Date") return new Date(value.iso);
    if (value.__type === "File") return $58cc4eab8a475dd4$var$_ParseFile.default.fromJSON(value);
    if (value.__type === "GeoPoint") return new $58cc4eab8a475dd4$var$_ParseGeoPoint.default({
        latitude: value.latitude,
        longitude: value.longitude
    });
    if (value.__type === "Polygon") return new $58cc4eab8a475dd4$var$_ParsePolygon.default(value.coordinates);
    var copy = {};
    for(var k in value)copy[k] = $58cc4eab8a475dd4$var$decode(value[k]);
    return copy;
}

});
parcelRequire.register("jZGC2", function(module, exports) {

module.exports = (parcelRequire("5oHyx"));

});
parcelRequire.register("5oHyx", function(module, exports) {
parcelRequire("4YdnW");

var $3mH0O = parcelRequire("3mH0O");

var $dydfX = parcelRequire("dydfX");

var $5L8hR = parcelRequire("5L8hR");

var $9ssZC = parcelRequire("9ssZC");
var $3ee0faf8afefc267$var$ArrayPrototype = Array.prototype;
var $3ee0faf8afefc267$var$DOMIterables = {
    DOMTokenList: true,
    NodeList: true
};
module.exports = function(it) {
    var own = it.forEach;
    return it === $3ee0faf8afefc267$var$ArrayPrototype || $5L8hR($3ee0faf8afefc267$var$ArrayPrototype, it) && own === $3ee0faf8afefc267$var$ArrayPrototype.forEach || $dydfX($3ee0faf8afefc267$var$DOMIterables, $3mH0O(it)) ? $9ssZC : own;
};

});
parcelRequire.register("9ssZC", function(module, exports) {

var $8kQVo = parcelRequire("8kQVo");
module.exports = $8kQVo;

});
parcelRequire.register("8kQVo", function(module, exports) {
parcelRequire("iGxRC");

var $hESIr = parcelRequire("hESIr");
module.exports = $hESIr("Array").forEach;

});
parcelRequire.register("iGxRC", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $5k5fo = parcelRequire("5k5fo");
// `Array.prototype.forEach` method
// https://tc39.es/ecma262/#sec-array.prototype.foreach
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
$g2B3u({
    target: "Array",
    proto: true,
    forced: [].forEach != $5k5fo
}, {
    forEach: $5k5fo
});

});
parcelRequire.register("5k5fo", function(module, exports) {
"use strict";

var $lB6H8 = parcelRequire("lB6H8");
var $3e02e3fbdda06032$require$$forEach = $lB6H8.forEach;

var $iNgXn = parcelRequire("iNgXn");
var $3e02e3fbdda06032$var$STRICT_METHOD = $iNgXn("forEach");
// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !$3e02e3fbdda06032$var$STRICT_METHOD ? function forEach(callbackfn /* , thisArg */ ) {
    return $3e02e3fbdda06032$require$$forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;

});
parcelRequire.register("iNgXn", function(module, exports) {
"use strict";

var $avKuJ = parcelRequire("avKuJ");
module.exports = function(METHOD_NAME, argument) {
    var method = [][METHOD_NAME];
    return !!method && $avKuJ(function() {
        // eslint-disable-next-line no-useless-call -- required for testing
        method.call(null, argument || function() {
            return 1;
        }, 1);
    });
};

});



parcelRequire.register("hESIr", function(module, exports) {

var $envPC = parcelRequire("envPC");
module.exports = function(CONSTRUCTOR) {
    return $envPC[CONSTRUCTOR + "Prototype"];
};

});





parcelRequire.register("i0kCX", function(module, exports) {

module.exports = (parcelRequire("hXzHb"));

});
parcelRequire.register("hXzHb", function(module, exports) {

var $f9eRs = parcelRequire("f9eRs");
module.exports = $f9eRs;

});
parcelRequire.register("f9eRs", function(module, exports) {
parcelRequire("3saEZ");

var $envPC = parcelRequire("envPC");
module.exports = $envPC.Array.isArray;

});
parcelRequire.register("3saEZ", function(module, exports) {

var $g2B3u = parcelRequire("g2B3u");

var $6BgtM = parcelRequire("6BgtM");
// `Array.isArray` method
// https://tc39.es/ecma262/#sec-array.isarray
$g2B3u({
    target: "Array",
    stat: true
}, {
    isArray: $6BgtM
});

});




parcelRequire.register("9HvHn", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $evY07 = parcelRequire("evY07");
$evY07(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7100b7e8b79a8e0e$var$_keys = $3Npdz((parcelRequire("r9mpE")));

var $7100b7e8b79a8e0e$var$_typeof2 = $3Npdz((parcelRequire("akViX")));

var $7100b7e8b79a8e0e$var$_classCallCheck2 = $3Npdz((parcelRequire("9pQKE")));

var $7100b7e8b79a8e0e$var$_createClass2 = $3Npdz((parcelRequire("eZYdV")));

var $7100b7e8b79a8e0e$var$_defineProperty2 = $3Npdz((parcelRequire("bci6G")));

var $7100b7e8b79a8e0e$var$_ParseRole = $3Npdz((parcelRequire("62sYC")));

var $7100b7e8b79a8e0e$var$_ParseUser = $3Npdz((parcelRequire("8mqMW")));
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ var $7100b7e8b79a8e0e$var$PUBLIC_KEY = "*";
/**
 * Creates a new ACL.
 * If no argument is given, the ACL has no permissions for anyone.
 * If the argument is a Parse.User, the ACL will have read and write
 *   permission for only that user.
 * If the argument is any other JSON object, that object will be interpretted
 *   as a serialized ACL created with toJSON().
 *
 * <p>An ACL, or Access Control List can be added to any
 * <code>Parse.Object</code> to restrict access to only a subset of users
 * of your application.</p>
 *
 * @alias Parse.ACL
 */ var $7100b7e8b79a8e0e$var$ParseACL = /*#__PURE__*/ function() {
    /**
   * @param {(Parse.User | object)} arg1 The user to initialize the ACL for
   */ function ParseACL(arg1) {
        (0, $7100b7e8b79a8e0e$var$_classCallCheck2.default)(this, ParseACL);
        (0, $7100b7e8b79a8e0e$var$_defineProperty2.default)(this, "permissionsById", void 0);
        this.permissionsById = {};
        if (arg1 && (0, $7100b7e8b79a8e0e$var$_typeof2.default)(arg1) === "object") {
            if (arg1 instanceof $7100b7e8b79a8e0e$var$_ParseUser.default) {
                this.setReadAccess(arg1, true);
                this.setWriteAccess(arg1, true);
            } else for(var _userId in arg1){
                var accessList = arg1[_userId];
                this.permissionsById[_userId] = {};
                for(var _permission in accessList){
                    var allowed = accessList[_permission];
                    if (_permission !== "read" && _permission !== "write") throw new TypeError("Tried to create an ACL with an invalid permission type.");
                    if (typeof allowed !== "boolean") throw new TypeError("Tried to create an ACL with an invalid permission value.");
                    this.permissionsById[_userId][_permission] = allowed;
                }
            }
        } else if (typeof arg1 === "function") throw new TypeError("ParseACL constructed with a function. Did you forget ()?");
    }
    /**
   * Returns a JSON-encoded version of the ACL.
   *
   * @returns {object}
   */ (0, $7100b7e8b79a8e0e$var$_createClass2.default)(ParseACL, [
        {
            key: "toJSON",
            value: function() /*: ByIdMap*/ {
                var permissions = {};
                for(var p in this.permissionsById)permissions[p] = this.permissionsById[p];
                return permissions;
            }
        },
        {
            key: "equals",
            value: function(other) /*: boolean*/ {
                if (!(other instanceof ParseACL)) return false;
                var users = (0, $7100b7e8b79a8e0e$var$_keys.default)(this.permissionsById);
                var otherUsers = (0, $7100b7e8b79a8e0e$var$_keys.default)(other.permissionsById);
                if (users.length !== otherUsers.length) return false;
                for(var u in this.permissionsById){
                    if (!other.permissionsById[u]) return false;
                    if (this.permissionsById[u].read !== other.permissionsById[u].read) return false;
                    if (this.permissionsById[u].write !== other.permissionsById[u].write) return false;
                }
                return true;
            }
        },
        {
            key: "_setAccess",
            value: function(accessType, userId, allowed) {
                if (userId instanceof $7100b7e8b79a8e0e$var$_ParseUser.default) userId = userId.id;
                else if (userId instanceof $7100b7e8b79a8e0e$var$_ParseRole.default) {
                    var name = userId.getName();
                    if (!name) throw new TypeError("Role must have a name");
                    userId = "role:" + name;
                }
                if (typeof userId !== "string") throw new TypeError("userId must be a string.");
                if (typeof allowed !== "boolean") throw new TypeError("allowed must be either true or false.");
                var permissions = this.permissionsById[userId];
                if (!permissions) {
                    if (!allowed) // The user already doesn't have this permission, so no action is needed
                    return;
                    else {
                        permissions = {};
                        this.permissionsById[userId] = permissions;
                    }
                }
                if (allowed) this.permissionsById[userId][accessType] = true;
                else {
                    delete permissions[accessType];
                    if ((0, $7100b7e8b79a8e0e$var$_keys.default)(permissions).length === 0) delete this.permissionsById[userId];
                }
            }
        },
        {
            key: "_getAccess",
            value: function(accessType, userId) /*: boolean*/ {
                if (userId instanceof $7100b7e8b79a8e0e$var$_ParseUser.default) {
                    userId = userId.id;
                    if (!userId) throw new Error("Cannot get access for a ParseUser without an ID");
                } else if (userId instanceof $7100b7e8b79a8e0e$var$_ParseRole.default) {
                    var name = userId.getName();
                    if (!name) throw new TypeError("Role must have a name");
                    userId = "role:" + name;
                }
                var permissions = this.permissionsById[userId];
                if (!permissions) return false;
                return !!permissions[accessType];
            }
        },
        {
            key: "setReadAccess",
            value: function(userId, allowed) {
                this._setAccess("read", userId, allowed);
            }
        },
        {
            key: "getReadAccess",
            value: function(userId) /*: boolean*/ {
                return this._getAccess("read", userId);
            }
        },
        {
            key: "setWriteAccess",
            value: function(userId, allowed) {
                this._setAccess("write", userId, allowed);
            }
        },
        {
            key: "getWriteAccess",
            value: function(userId) /*: boolean*/ {
                return this._getAccess("write", userId);
            }
        },
        {
            key: "setPublicReadAccess",
            value: function(allowed) {
                this.setReadAccess($7100b7e8b79a8e0e$var$PUBLIC_KEY, allowed);
            }
        },
        {
            key: "getPublicReadAccess",
            value: function() /*: boolean*/ {
                return this.getReadAccess($7100b7e8b79a8e0e$var$PUBLIC_KEY);
            }
        },
        {
            key: "setPublicWriteAccess",
            value: function(allowed) {
                this.setWriteAccess($7100b7e8b79a8e0e$var$PUBLIC_KEY, allowed);
            }
        },
        {
            key: "getPublicWriteAccess",
            value: function() /*: boolean*/ {
                return this.getWriteAccess($7100b7e8b79a8e0e$var$PUBLIC_KEY);
            }
        },
        {
            key: "getRoleReadAccess",
            value: function(role) /*: boolean*/ {
                if (role instanceof $7100b7e8b79a8e0e$var$_ParseRole.default) // Normalize to the String name
                role = role.getName();
                if (typeof role !== "string") throw new TypeError("role must be a ParseRole or a String");
                return this.getReadAccess("role:" + role);
            }
        },
        {
            key: "getRoleWriteAccess",
            value: function(role) /*: boolean*/ {
                if (role instanceof $7100b7e8b79a8e0e$var$_ParseRole.default) // Normalize to the String name
                role = role.getName();
                if (typeof role !== "string") throw new TypeError("role must be a ParseRole or a String");
                return this.getWriteAccess("role:" + role);
            }
        },
        {
            key: "setRoleReadAccess",
            value: function(role, allowed) {
                if (role instanceof $7100b7e8b79a8e0e$var$_ParseRole.default) // Normalize to the String name
                role = role.getName();
                if (typeof role !== "string") throw new TypeError("role must be a ParseRole or a String");
                this.setReadAccess("role:" + role, allowed);
            }
        },
        {
            key: "setRoleWriteAccess",
            value: function(role, allowed) {
                if (role instanceof $7100b7e8b79a8e0e$var$_ParseRole.default) // Normalize to the String name
                role = role.getName();
                if (typeof role !== "string") throw new TypeError("role must be a ParseRole or a String");
                this.setWriteAccess("role:" + role, allowed);
            }
        }
    ]);
    return ParseACL;
}();
var $7100b7e8b79a8e0e$var$_default = $7100b7e8b79a8e0e$var$ParseACL;
module.exports.default = $7100b7e8b79a8e0e$var$_default;

});
parcelRequire.register("r9mpE", function(module, exports) {

module.exports = (parcelRequire("bxE33"));

});
parcelRequire.register("bxE33", function(module, exports) {

var $lxF87 = parcelRequire("lxF87");
module.exports = $lxF87;

});
parcelRequire.register("lxF87", function(module, exports) {
parcelRequire("ew0Je");

var $envPC = parcelRequire("envPC");
module.exports = $envPC.Object.keys;

});
parcelRequire.register("ew0Je", function(module, exports) {

var $g2B3u = parcelRequire("g2B3u");

var $bVwvx = parcelRequire("bVwvx");

var $lfsGJ = parcelRequire("lfsGJ");

var $avKuJ = parcelRequire("avKuJ");
var $a9149e8b9eadde0b$var$FAILS_ON_PRIMITIVES = $avKuJ(function() {
    $lfsGJ(1);
});
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$g2B3u({
    target: "Object",
    stat: true,
    forced: $a9149e8b9eadde0b$var$FAILS_ON_PRIMITIVES
}, {
    keys: function keys(it) {
        return $lfsGJ($bVwvx(it));
    }
});

});




parcelRequire.register("9pQKE", function(module, exports) {
function $6daf5e318969aaed$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $6daf5e318969aaed$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("eZYdV", function(module, exports) {

var $knWSj = parcelRequire("knWSj");
function $aeb57a5362e12709$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        $knWSj(target, descriptor.key, descriptor);
    }
}
function $aeb57a5362e12709$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $aeb57a5362e12709$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $aeb57a5362e12709$var$_defineProperties(Constructor, staticProps);
    $knWSj(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
module.exports = $aeb57a5362e12709$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("knWSj", function(module, exports) {

module.exports = (parcelRequire("bs0dy"));

});
parcelRequire.register("bs0dy", function(module, exports) {

module.exports = (parcelRequire("h0gyd"));

});
parcelRequire.register("h0gyd", function(module, exports) {

var $5fMzB = parcelRequire("5fMzB");
module.exports = $5fMzB;

});
parcelRequire.register("5fMzB", function(module, exports) {

var $dKDYY = parcelRequire("dKDYY");
module.exports = $dKDYY;

});





parcelRequire.register("bci6G", function(module, exports) {

var $knWSj = parcelRequire("knWSj");
function $826edc5727c368eb$var$_defineProperty(obj, key, value) {
    if (key in obj) $knWSj(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
module.exports = $826edc5727c368eb$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("62sYC", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $evY07 = parcelRequire("evY07");

var $dwGVc = parcelRequire("dwGVc");
$evY07(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $465968295d2f5e7f$var$_classCallCheck2 = $3Npdz((parcelRequire("9pQKE")));

var $465968295d2f5e7f$var$_createClass2 = $3Npdz((parcelRequire("eZYdV")));

var $465968295d2f5e7f$var$_get2 = $3Npdz((parcelRequire("eNGed")));

var $465968295d2f5e7f$var$_inherits2 = $3Npdz((parcelRequire("4QWF4")));

var $465968295d2f5e7f$var$_possibleConstructorReturn2 = $3Npdz((parcelRequire("kTHGs")));

var $465968295d2f5e7f$var$_getPrototypeOf2 = $3Npdz((parcelRequire("6MmOk")));

var $465968295d2f5e7f$var$_ParseACL = $3Npdz((parcelRequire("9HvHn")));

var $465968295d2f5e7f$var$_ParseError = $3Npdz((parcelRequire("3HQSG")));

var $465968295d2f5e7f$var$_ParseObject2 = $3Npdz((parcelRequire("2HIpX")));
function $465968295d2f5e7f$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $465968295d2f5e7f$var$_isNativeReflectConstruct();
    return function() {
        var Super = (0, $465968295d2f5e7f$var$_getPrototypeOf2.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $465968295d2f5e7f$var$_getPrototypeOf2.default)(this).constructor;
            result = $dwGVc(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $465968295d2f5e7f$var$_possibleConstructorReturn2.default)(this, result);
    };
}
function $465968295d2f5e7f$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !$dwGVc) return false;
    if ($dwGVc.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($dwGVc(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Represents a Role on the Parse server. Roles represent groupings of
 * Users for the purposes of granting permissions (e.g. specifying an ACL
 * for an Object). Roles are specified by their sets of child users and
 * child roles, all of which are granted any permissions that the parent
 * role has.
 *
 * <p>Roles must have a name (which cannot be changed after creation of the
 * role), and must specify an ACL.</p>
 *
 * @alias Parse.Role
 * @augments Parse.Object
 */ var $465968295d2f5e7f$var$ParseRole = /*#__PURE__*/ function(_ParseObject) {
    (0, $465968295d2f5e7f$var$_inherits2.default)(ParseRole, _ParseObject);
    var _super = $465968295d2f5e7f$var$_createSuper(ParseRole);
    /**
   * @param {string} name The name of the Role to create.
   * @param {Parse.ACL} acl The ACL for this role. Roles must have an ACL.
   * A Parse.Role is a local representation of a role persisted to the Parse
   * cloud.
   */ function ParseRole(name, acl) {
        var _this;
        (0, $465968295d2f5e7f$var$_classCallCheck2.default)(this, ParseRole);
        _this = _super.call(this, "_Role");
        if (typeof name === "string" && acl instanceof $465968295d2f5e7f$var$_ParseACL.default) {
            _this.setName(name);
            _this.setACL(acl);
        }
        return _this;
    }
    /**
   * Gets the name of the role.  You can alternatively call role.get("name")
   *
   * @returns {string} the name of the role.
   */ (0, $465968295d2f5e7f$var$_createClass2.default)(ParseRole, [
        {
            key: "getName",
            value: function() /*: ?string*/ {
                var name = this.get("name");
                if (name == null || typeof name === "string") return name;
                return "";
            }
        },
        {
            key: "setName",
            value: function(name, options) /*: ParseObject | boolean*/ {
                this._validateName(name);
                return this.set("name", name, options);
            }
        },
        {
            key: "getUsers",
            value: function() /*: ParseRelation*/ {
                return this.relation("users");
            }
        },
        {
            key: "getRoles",
            value: function() /*: ParseRelation*/ {
                return this.relation("roles");
            }
        },
        {
            key: "_validateName",
            value: function(newName) {
                if (typeof newName !== "string") throw new $465968295d2f5e7f$var$_ParseError.default($465968295d2f5e7f$var$_ParseError.default.OTHER_CAUSE, "A role's name must be a String.");
                if (!/^[0-9a-zA-Z\-_ ]+$/.test(newName)) throw new $465968295d2f5e7f$var$_ParseError.default($465968295d2f5e7f$var$_ParseError.default.OTHER_CAUSE, "A role's name can be only contain alphanumeric characters, _, -, and spaces.");
            }
        },
        {
            key: "validate",
            value: function(attrs, options) /*: ParseError | boolean*/ {
                var isInvalid = (0, $465968295d2f5e7f$var$_get2.default)((0, $465968295d2f5e7f$var$_getPrototypeOf2.default)(ParseRole.prototype), "validate", this).call(this, attrs, options);
                if (isInvalid) return isInvalid;
                if ("name" in attrs && attrs.name !== this.getName()) {
                    var newName = attrs.name;
                    if (this.id && this.id !== attrs.objectId) // Check to see if the objectId being set matches this.id
                    // This happens during a fetch -- the id is set before calling fetch
                    // Let the name be set in this case
                    return new $465968295d2f5e7f$var$_ParseError.default($465968295d2f5e7f$var$_ParseError.default.OTHER_CAUSE, "A role's name can only be set before it has been saved.");
                    try {
                        this._validateName(newName);
                    } catch (e) {
                        return e;
                    }
                }
                return false;
            }
        }
    ]);
    return ParseRole;
}($465968295d2f5e7f$var$_ParseObject2.default);
$465968295d2f5e7f$var$_ParseObject2.default.registerSubclass("_Role", $465968295d2f5e7f$var$ParseRole);
var $465968295d2f5e7f$var$_default = $465968295d2f5e7f$var$ParseRole;
module.exports.default = $465968295d2f5e7f$var$_default;

});
parcelRequire.register("dwGVc", function(module, exports) {

module.exports = (parcelRequire("1d4PA"));

});
parcelRequire.register("1d4PA", function(module, exports) {

var $f0c9b = parcelRequire("f0c9b");
module.exports = $f0c9b;

});
parcelRequire.register("f0c9b", function(module, exports) {
parcelRequire("7jAzm");

var $envPC = parcelRequire("envPC");
module.exports = $envPC.Reflect.construct;

});
parcelRequire.register("7jAzm", function(module, exports) {

var $g2B3u = parcelRequire("g2B3u");

var $bTXoK = parcelRequire("bTXoK");

var $9YGjW = parcelRequire("9YGjW");

var $ahsSP = parcelRequire("ahsSP");

var $f3ZOd = parcelRequire("f3ZOd");

var $lalRy = parcelRequire("lalRy");

var $atGHr = parcelRequire("atGHr");

var $2oTKI = parcelRequire("2oTKI");

var $avKuJ = parcelRequire("avKuJ");
var $5536acacc9cf5e60$var$nativeConstruct = $bTXoK("Reflect", "construct");
var $5536acacc9cf5e60$var$ObjectPrototype = Object.prototype;
var $5536acacc9cf5e60$var$push = [].push;
// `Reflect.construct` method
// https://tc39.es/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var $5536acacc9cf5e60$var$NEW_TARGET_BUG = $avKuJ(function() {
    function F() {}
    return !($5536acacc9cf5e60$var$nativeConstruct(function() {}, [], F) instanceof F);
});
var $5536acacc9cf5e60$var$ARGS_BUG = !$avKuJ(function() {
    $5536acacc9cf5e60$var$nativeConstruct(function() {});
});
var $5536acacc9cf5e60$var$FORCED = $5536acacc9cf5e60$var$NEW_TARGET_BUG || $5536acacc9cf5e60$var$ARGS_BUG;
$g2B3u({
    target: "Reflect",
    stat: true,
    forced: $5536acacc9cf5e60$var$FORCED,
    sham: $5536acacc9cf5e60$var$FORCED
}, {
    construct: function construct(Target, args /* , newTarget */ ) {
        $f3ZOd(Target);
        $lalRy(args);
        var newTarget = arguments.length < 3 ? Target : $f3ZOd(arguments[2]);
        if ($5536acacc9cf5e60$var$ARGS_BUG && !$5536acacc9cf5e60$var$NEW_TARGET_BUG) return $5536acacc9cf5e60$var$nativeConstruct(Target, args, newTarget);
        if (Target == newTarget) {
            // w/o altered newTarget, optimization for 0-4 arguments
            switch(args.length){
                case 0:
                    return new Target();
                case 1:
                    return new Target(args[0]);
                case 2:
                    return new Target(args[0], args[1]);
                case 3:
                    return new Target(args[0], args[1], args[2]);
                case 4:
                    return new Target(args[0], args[1], args[2], args[3]);
            }
            // w/o altered newTarget, lot of arguments case
            var $args = [
                null
            ];
            $9YGjW($5536acacc9cf5e60$var$push, $args, args);
            return new ($9YGjW($ahsSP, Target, $args))();
        }
        // with altered newTarget, not support built-in constructors
        var proto = newTarget.prototype;
        var instance = $2oTKI($atGHr(proto) ? proto : $5536acacc9cf5e60$var$ObjectPrototype);
        var result = $9YGjW(Target, instance, args);
        return $atGHr(result) ? result : instance;
    }
});

});
parcelRequire.register("ahsSP", function(module, exports) {
"use strict";

var $7tcts = parcelRequire("7tcts");

var $aZpni = parcelRequire("aZpni");

var $atGHr = parcelRequire("atGHr");

var $dydfX = parcelRequire("dydfX");

var $74qJH = parcelRequire("74qJH");

var $ag2S4 = parcelRequire("ag2S4");
var $77c1e5872303160d$var$$Function = Function;
var $77c1e5872303160d$var$concat = $7tcts([].concat);
var $77c1e5872303160d$var$join = $7tcts([].join);
var $77c1e5872303160d$var$factories = {};
var $77c1e5872303160d$var$construct = function(C, argsLength, args) {
    if (!$dydfX($77c1e5872303160d$var$factories, argsLength)) {
        for(var list = [], i = 0; i < argsLength; i++)list[i] = "a[" + i + "]";
        $77c1e5872303160d$var$factories[argsLength] = $77c1e5872303160d$var$$Function("C,a", "return new C(" + $77c1e5872303160d$var$join(list, ",") + ")");
    }
    return $77c1e5872303160d$var$factories[argsLength](C, args);
};
// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
// eslint-disable-next-line es/no-function-prototype-bind -- detection
module.exports = $ag2S4 ? $77c1e5872303160d$var$$Function.bind : function bind(that /* , ...args */ ) {
    var F = $aZpni(this);
    var Prototype = F.prototype;
    var partArgs = $74qJH(arguments, 1);
    var boundFunction = function bound() {
        var args = $77c1e5872303160d$var$concat(partArgs, $74qJH(arguments));
        return this instanceof boundFunction ? $77c1e5872303160d$var$construct(F, args.length, args) : F.apply(that, args);
    };
    if ($atGHr(Prototype)) boundFunction.prototype = Prototype;
    return boundFunction;
};

});





parcelRequire.register("eNGed", function(module, exports) {

var $la48N = parcelRequire("la48N");

var $htPMr = parcelRequire("htPMr");

var $5wX8L = parcelRequire("5wX8L");
function $ac6665f41733f13c$var$_get() {
    if (typeof Reflect !== "undefined" && $la48N) module.exports = $ac6665f41733f13c$var$_get = $la48N, module.exports.__esModule = true, module.exports["default"] = module.exports;
    else module.exports = $ac6665f41733f13c$var$_get = function _get(target, property, receiver) {
        var base = $5wX8L(target, property);
        if (!base) return;
        var desc = $htPMr(base, property);
        if (desc.get) return desc.get.call(arguments.length < 3 ? target : receiver);
        return desc.value;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $ac6665f41733f13c$var$_get.apply(this, arguments);
}
module.exports = $ac6665f41733f13c$var$_get, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("la48N", function(module, exports) {

module.exports = (parcelRequire("3u72L"));

});
parcelRequire.register("3u72L", function(module, exports) {

module.exports = (parcelRequire("kjxFQ"));

});
parcelRequire.register("kjxFQ", function(module, exports) {

var $2hAt8 = parcelRequire("2hAt8");
module.exports = $2hAt8;

});
parcelRequire.register("2hAt8", function(module, exports) {

var $bqw30 = parcelRequire("bqw30");
module.exports = $bqw30;

});
parcelRequire.register("bqw30", function(module, exports) {

var $4mnPK = parcelRequire("4mnPK");
module.exports = $4mnPK;

});
parcelRequire.register("4mnPK", function(module, exports) {
parcelRequire("gd8lI");

var $envPC = parcelRequire("envPC");
module.exports = $envPC.Reflect.get;

});
parcelRequire.register("gd8lI", function(module, exports) {

var $g2B3u = parcelRequire("g2B3u");

var $5qecd = parcelRequire("5qecd");

var $atGHr = parcelRequire("atGHr");

var $lalRy = parcelRequire("lalRy");

var $bATB8 = parcelRequire("bATB8");

var $6IpKK = parcelRequire("6IpKK");

var $gk5OL = parcelRequire("gk5OL");
// `Reflect.get` method
// https://tc39.es/ecma262/#sec-reflect.get
function $bcd45636114605fc$var$get(target, propertyKey /* , receiver */ ) {
    var receiver = arguments.length < 3 ? target : arguments[2];
    var descriptor, prototype;
    if ($lalRy(target) === receiver) return target[propertyKey];
    descriptor = $6IpKK.f(target, propertyKey);
    if (descriptor) return $bATB8(descriptor) ? descriptor.value : descriptor.get === undefined ? undefined : $5qecd(descriptor.get, receiver);
    if ($atGHr(prototype = $gk5OL(target))) return $bcd45636114605fc$var$get(prototype, propertyKey, receiver);
}
$g2B3u({
    target: "Reflect",
    stat: true
}, {
    get: $bcd45636114605fc$var$get
});

});
parcelRequire.register("bATB8", function(module, exports) {

var $dydfX = parcelRequire("dydfX");
module.exports = function(descriptor) {
    return descriptor !== undefined && ($dydfX(descriptor, "value") || $dydfX(descriptor, "writable"));
};

});








parcelRequire.register("htPMr", function(module, exports) {

module.exports = (parcelRequire("8gi6R"));

});
parcelRequire.register("8gi6R", function(module, exports) {

module.exports = (parcelRequire("iuw93"));

});
parcelRequire.register("iuw93", function(module, exports) {

var $dTfxP = parcelRequire("dTfxP");
module.exports = $dTfxP;

});
parcelRequire.register("dTfxP", function(module, exports) {

var $3h5Yc = parcelRequire("3h5Yc");
module.exports = $3h5Yc;

});




parcelRequire.register("5wX8L", function(module, exports) {

var $6MmOk = parcelRequire("6MmOk");
function $406dd0ee0e5c286b$var$_superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = $6MmOk(object);
        if (object === null) break;
    }
    return object;
}
module.exports = $406dd0ee0e5c286b$var$_superPropBase, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("6MmOk", function(module, exports) {

var $8O12w = parcelRequire("8O12w");

var $bEcRY = parcelRequire("bEcRY");
function $4ef8eb879c5e0efa$var$_getPrototypeOf(o) {
    module.exports = $4ef8eb879c5e0efa$var$_getPrototypeOf = $8O12w ? $bEcRY : function _getPrototypeOf(o) {
        return o.__proto__ || $bEcRY(o);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $4ef8eb879c5e0efa$var$_getPrototypeOf(o);
}
module.exports = $4ef8eb879c5e0efa$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("8O12w", function(module, exports) {

module.exports = (parcelRequire("dYqR4"));

});
parcelRequire.register("dYqR4", function(module, exports) {

module.exports = (parcelRequire("7M7ab"));

});
parcelRequire.register("7M7ab", function(module, exports) {

var $92F0w = parcelRequire("92F0w");
module.exports = $92F0w;

});
parcelRequire.register("92F0w", function(module, exports) {

var $gJRBE = parcelRequire("gJRBE");
module.exports = $gJRBE;

});
parcelRequire.register("gJRBE", function(module, exports) {

var $3kjtU = parcelRequire("3kjtU");
module.exports = $3kjtU;

});
parcelRequire.register("3kjtU", function(module, exports) {
parcelRequire("jgLLJ");

var $envPC = parcelRequire("envPC");
module.exports = $envPC.Object.setPrototypeOf;

});
parcelRequire.register("jgLLJ", function(module, exports) {

var $g2B3u = parcelRequire("g2B3u");

var $bV0bE = parcelRequire("bV0bE");
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
$g2B3u({
    target: "Object",
    stat: true
}, {
    setPrototypeOf: $bV0bE
});

});







parcelRequire.register("bEcRY", function(module, exports) {

module.exports = (parcelRequire("gSaCG"));

});
parcelRequire.register("gSaCG", function(module, exports) {

module.exports = (parcelRequire("idbI8"));

});
parcelRequire.register("idbI8", function(module, exports) {

var $iZgw7 = parcelRequire("iZgw7");
module.exports = $iZgw7;

});
parcelRequire.register("iZgw7", function(module, exports) {

var $8UYgl = parcelRequire("8UYgl");
module.exports = $8UYgl;

});
parcelRequire.register("8UYgl", function(module, exports) {

var $54m2H = parcelRequire("54m2H");
module.exports = $54m2H;

});
parcelRequire.register("54m2H", function(module, exports) {
parcelRequire("f6G5t");

var $envPC = parcelRequire("envPC");
module.exports = $envPC.Object.getPrototypeOf;

});
parcelRequire.register("f6G5t", function(module, exports) {

var $g2B3u = parcelRequire("g2B3u");

var $avKuJ = parcelRequire("avKuJ");

var $bVwvx = parcelRequire("bVwvx");

var $gk5OL = parcelRequire("gk5OL");

var $7YztP = parcelRequire("7YztP");
var $aff810336029fd95$var$FAILS_ON_PRIMITIVES = $avKuJ(function() {
    $gk5OL(1);
});
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$g2B3u({
    target: "Object",
    stat: true,
    forced: $aff810336029fd95$var$FAILS_ON_PRIMITIVES,
    sham: !$7YztP
}, {
    getPrototypeOf: function getPrototypeOf(it) {
        return $gk5OL($bVwvx(it));
    }
});

});










parcelRequire.register("4QWF4", function(module, exports) {

var $3geLe = parcelRequire("3geLe");

var $knWSj = parcelRequire("knWSj");

var $8FU8b = parcelRequire("8FU8b");
function $388985b043ce06d8$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = $3geLe(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    $knWSj(subClass, "prototype", {
        writable: false
    });
    if (superClass) $8FU8b(subClass, superClass);
}
module.exports = $388985b043ce06d8$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("3geLe", function(module, exports) {

module.exports = (parcelRequire("gY5Xm"));

});
parcelRequire.register("gY5Xm", function(module, exports) {

module.exports = (parcelRequire("xG2rM"));

});
parcelRequire.register("xG2rM", function(module, exports) {

var $lAuYb = parcelRequire("lAuYb");
module.exports = $lAuYb;

});
parcelRequire.register("lAuYb", function(module, exports) {

var $gQqG5 = parcelRequire("gQqG5");
module.exports = $gQqG5;

});
parcelRequire.register("gQqG5", function(module, exports) {

var $iXT0r = parcelRequire("iXT0r");
module.exports = $iXT0r;

});
parcelRequire.register("iXT0r", function(module, exports) {
parcelRequire("lUZE5");

var $envPC = parcelRequire("envPC");
var $dce867bd066cd890$var$Object = $envPC.Object;
module.exports = function create(P, D) {
    return $dce867bd066cd890$var$Object.create(P, D);
};

});
parcelRequire.register("lUZE5", function(module, exports) {
// TODO: Remove from `core-js@4`

var $g2B3u = parcelRequire("g2B3u");

var $99D40 = parcelRequire("99D40");

var $2oTKI = parcelRequire("2oTKI");
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
$g2B3u({
    target: "Object",
    stat: true,
    sham: !$99D40
}, {
    create: $2oTKI
});

});







parcelRequire.register("8FU8b", function(module, exports) {

var $8O12w = parcelRequire("8O12w");
function $650db17ee1889961$var$_setPrototypeOf(o, p) {
    module.exports = $650db17ee1889961$var$_setPrototypeOf = $8O12w || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $650db17ee1889961$var$_setPrototypeOf(o, p);
}
module.exports = $650db17ee1889961$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("kTHGs", function(module, exports) {

var $akViX = parcelRequire("akViX");
var $f36ad45eb65f76d0$var$_typeof = $akViX.default;

var $73Ztd = parcelRequire("73Ztd");
function $f36ad45eb65f76d0$var$_possibleConstructorReturn(self, call) {
    if (call && ($f36ad45eb65f76d0$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $73Ztd(self);
}
module.exports = $f36ad45eb65f76d0$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("73Ztd", function(module, exports) {
function $52487eeb70797071$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
module.exports = $52487eeb70797071$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("3HQSG", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");


var $dwGVc = parcelRequire("dwGVc");
(parcelRequire("evY07"))(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2b2e6852ed096801$var$_defineProperty = $3Npdz((parcelRequire("evY07")));

var $2b2e6852ed096801$var$_classCallCheck2 = $3Npdz((parcelRequire("9pQKE")));

var $2b2e6852ed096801$var$_createClass2 = $3Npdz((parcelRequire("eZYdV")));

var $2b2e6852ed096801$var$_assertThisInitialized2 = $3Npdz((parcelRequire("73Ztd")));

var $2b2e6852ed096801$var$_inherits2 = $3Npdz((parcelRequire("4QWF4")));

var $2b2e6852ed096801$var$_possibleConstructorReturn2 = $3Npdz((parcelRequire("kTHGs")));

var $2b2e6852ed096801$var$_getPrototypeOf2 = $3Npdz((parcelRequire("6MmOk")));

var $2b2e6852ed096801$var$_wrapNativeSuper2 = $3Npdz((parcelRequire("jb7jN")));
function $2b2e6852ed096801$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $2b2e6852ed096801$var$_isNativeReflectConstruct();
    return function() {
        var Super = (0, $2b2e6852ed096801$var$_getPrototypeOf2.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $2b2e6852ed096801$var$_getPrototypeOf2.default)(this).constructor;
            result = $dwGVc(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $2b2e6852ed096801$var$_possibleConstructorReturn2.default)(this, result);
    };
}
function $2b2e6852ed096801$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !$dwGVc) return false;
    if ($dwGVc.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($dwGVc(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */ /**
 * Constructs a new Parse.Error object with the given code and message.
 *
 * @alias Parse.Error
 */ var $2b2e6852ed096801$var$ParseError = /*#__PURE__*/ function(_Error) {
    (0, $2b2e6852ed096801$var$_inherits2.default)(ParseError, _Error);
    var _super = $2b2e6852ed096801$var$_createSuper(ParseError);
    /**
   * @param {number} code An error code constant from <code>Parse.Error</code>.
   * @param {string} message A detailed description of the error.
   */ function ParseError(code, message) {
        var _this;
        (0, $2b2e6852ed096801$var$_classCallCheck2.default)(this, ParseError);
        _this = _super.call(this, message);
        _this.code = code;
        (0, $2b2e6852ed096801$var$_defineProperty.default)((0, $2b2e6852ed096801$var$_assertThisInitialized2.default)(_this), "message", {
            enumerable: true,
            value: message
        });
        return _this;
    }
    (0, $2b2e6852ed096801$var$_createClass2.default)(ParseError, [
        {
            key: "toString",
            value: function() {
                return "ParseError: " + this.code + " " + this.message;
            }
        }
    ]);
    return ParseError;
}(/*#__PURE__*/ (0, $2b2e6852ed096801$var$_wrapNativeSuper2.default)(Error));
/**
 * Error code indicating some error other than those enumerated here.
 *
 * @property {number} OTHER_CAUSE
 * @static
 */ $2b2e6852ed096801$var$ParseError.OTHER_CAUSE = -1;
/**
 * Error code indicating that something has gone wrong with the server.
 *
 * @property {number} INTERNAL_SERVER_ERROR
 * @static
 */ $2b2e6852ed096801$var$ParseError.INTERNAL_SERVER_ERROR = 1;
/**
 * Error code indicating the connection to the Parse servers failed.
 *
 * @property {number} CONNECTION_FAILED
 * @static
 */ $2b2e6852ed096801$var$ParseError.CONNECTION_FAILED = 100;
/**
 * Error code indicating the specified object doesn't exist.
 *
 * @property {number} OBJECT_NOT_FOUND
 * @static
 */ $2b2e6852ed096801$var$ParseError.OBJECT_NOT_FOUND = 101;
/**
 * Error code indicating you tried to query with a datatype that doesn't
 * support it, like exact matching an array or object.
 *
 * @property {number} INVALID_QUERY
 * @static
 */ $2b2e6852ed096801$var$ParseError.INVALID_QUERY = 102;
/**
 * Error code indicating a missing or invalid classname. Classnames are
 * case-sensitive. They must start with a letter, and a-zA-Z0-9_ are the
 * only valid characters.
 *
 * @property {number} INVALID_CLASS_NAME
 * @static
 */ $2b2e6852ed096801$var$ParseError.INVALID_CLASS_NAME = 103;
/**
 * Error code indicating an unspecified object id.
 *
 * @property {number} MISSING_OBJECT_ID
 * @static
 */ $2b2e6852ed096801$var$ParseError.MISSING_OBJECT_ID = 104;
/**
 * Error code indicating an invalid key name. Keys are case-sensitive. They
 * must start with a letter, and a-zA-Z0-9_ are the only valid characters.
 *
 * @property {number} INVALID_KEY_NAME
 * @static
 */ $2b2e6852ed096801$var$ParseError.INVALID_KEY_NAME = 105;
/**
 * Error code indicating a malformed pointer. You should not see this unless
 * you have been mucking about changing internal Parse code.
 *
 * @property {number} INVALID_POINTER
 * @static
 */ $2b2e6852ed096801$var$ParseError.INVALID_POINTER = 106;
/**
 * Error code indicating that badly formed JSON was received upstream. This
 * either indicates you have done something unusual with modifying how
 * things encode to JSON, or the network is failing badly.
 *
 * @property {number} INVALID_JSON
 * @static
 */ $2b2e6852ed096801$var$ParseError.INVALID_JSON = 107;
/**
 * Error code indicating that the feature you tried to access is only
 * available internally for testing purposes.
 *
 * @property {number} COMMAND_UNAVAILABLE
 * @static
 */ $2b2e6852ed096801$var$ParseError.COMMAND_UNAVAILABLE = 108;
/**
 * You must call Parse.initialize before using the Parse library.
 *
 * @property {number} NOT_INITIALIZED
 * @static
 */ $2b2e6852ed096801$var$ParseError.NOT_INITIALIZED = 109;
/**
 * Error code indicating that a field was set to an inconsistent type.
 *
 * @property {number} INCORRECT_TYPE
 * @static
 */ $2b2e6852ed096801$var$ParseError.INCORRECT_TYPE = 111;
/**
 * Error code indicating an invalid channel name. A channel name is either
 * an empty string (the broadcast channel) or contains only a-zA-Z0-9_
 * characters and starts with a letter.
 *
 * @property {number} INVALID_CHANNEL_NAME
 * @static
 */ $2b2e6852ed096801$var$ParseError.INVALID_CHANNEL_NAME = 112;
/**
 * Error code indicating that push is misconfigured.
 *
 * @property {number} PUSH_MISCONFIGURED
 * @static
 */ $2b2e6852ed096801$var$ParseError.PUSH_MISCONFIGURED = 115;
/**
 * Error code indicating that the object is too large.
 *
 * @property {number} OBJECT_TOO_LARGE
 * @static
 */ $2b2e6852ed096801$var$ParseError.OBJECT_TOO_LARGE = 116;
/**
 * Error code indicating that the operation isn't allowed for clients.
 *
 * @property {number} OPERATION_FORBIDDEN
 * @static
 */ $2b2e6852ed096801$var$ParseError.OPERATION_FORBIDDEN = 119;
/**
 * Error code indicating the result was not found in the cache.
 *
 * @property {number} CACHE_MISS
 * @static
 */ $2b2e6852ed096801$var$ParseError.CACHE_MISS = 120;
/**
 * Error code indicating that an invalid key was used in a nested
 * JSONObject.
 *
 * @property {number} INVALID_NESTED_KEY
 * @static
 */ $2b2e6852ed096801$var$ParseError.INVALID_NESTED_KEY = 121;
/**
 * Error code indicating that an invalid filename was used for ParseFile.
 * A valid file name contains only a-zA-Z0-9_. characters and is between 1
 * and 128 characters.
 *
 * @property {number} INVALID_FILE_NAME
 * @static
 */ $2b2e6852ed096801$var$ParseError.INVALID_FILE_NAME = 122;
/**
 * Error code indicating an invalid ACL was provided.
 *
 * @property {number} INVALID_ACL
 * @static
 */ $2b2e6852ed096801$var$ParseError.INVALID_ACL = 123;
/**
 * Error code indicating that the request timed out on the server. Typically
 * this indicates that the request is too expensive to run.
 *
 * @property {number} TIMEOUT
 * @static
 */ $2b2e6852ed096801$var$ParseError.TIMEOUT = 124;
/**
 * Error code indicating that the email address was invalid.
 *
 * @property {number} INVALID_EMAIL_ADDRESS
 * @static
 */ $2b2e6852ed096801$var$ParseError.INVALID_EMAIL_ADDRESS = 125;
/**
 * Error code indicating a missing content type.
 *
 * @property {number} MISSING_CONTENT_TYPE
 * @static
 */ $2b2e6852ed096801$var$ParseError.MISSING_CONTENT_TYPE = 126;
/**
 * Error code indicating a missing content length.
 *
 * @property {number} MISSING_CONTENT_LENGTH
 * @static
 */ $2b2e6852ed096801$var$ParseError.MISSING_CONTENT_LENGTH = 127;
/**
 * Error code indicating an invalid content length.
 *
 * @property {number} INVALID_CONTENT_LENGTH
 * @static
 */ $2b2e6852ed096801$var$ParseError.INVALID_CONTENT_LENGTH = 128;
/**
 * Error code indicating a file that was too large.
 *
 * @property {number} FILE_TOO_LARGE
 * @static
 */ $2b2e6852ed096801$var$ParseError.FILE_TOO_LARGE = 129;
/**
 * Error code indicating an error saving a file.
 *
 * @property {number} FILE_SAVE_ERROR
 * @static
 */ $2b2e6852ed096801$var$ParseError.FILE_SAVE_ERROR = 130;
/**
 * Error code indicating that a unique field was given a value that is
 * already taken.
 *
 * @property {number} DUPLICATE_VALUE
 * @static
 */ $2b2e6852ed096801$var$ParseError.DUPLICATE_VALUE = 137;
/**
 * Error code indicating that a role's name is invalid.
 *
 * @property {number} INVALID_ROLE_NAME
 * @static
 */ $2b2e6852ed096801$var$ParseError.INVALID_ROLE_NAME = 139;
/**
 * Error code indicating that an application quota was exceeded.  Upgrade to
 * resolve.
 *
 * @property {number} EXCEEDED_QUOTA
 * @static
 */ $2b2e6852ed096801$var$ParseError.EXCEEDED_QUOTA = 140;
/**
 * Error code indicating that a Cloud Code script failed.
 *
 * @property {number} SCRIPT_FAILED
 * @static
 */ $2b2e6852ed096801$var$ParseError.SCRIPT_FAILED = 141;
/**
 * Error code indicating that a Cloud Code validation failed.
 *
 * @property {number} VALIDATION_ERROR
 * @static
 */ $2b2e6852ed096801$var$ParseError.VALIDATION_ERROR = 142;
/**
 * Error code indicating that invalid image data was provided.
 *
 * @property {number} INVALID_IMAGE_DATA
 * @static
 */ $2b2e6852ed096801$var$ParseError.INVALID_IMAGE_DATA = 143;
/**
 * Error code indicating an unsaved file.
 *
 * @property {number} UNSAVED_FILE_ERROR
 * @static
 */ $2b2e6852ed096801$var$ParseError.UNSAVED_FILE_ERROR = 151;
/**
 * Error code indicating an invalid push time.
 *
 * @property {number} INVALID_PUSH_TIME_ERROR
 * @static
 */ $2b2e6852ed096801$var$ParseError.INVALID_PUSH_TIME_ERROR = 152;
/**
 * Error code indicating an error deleting a file.
 *
 * @property {number} FILE_DELETE_ERROR
 * @static
 */ $2b2e6852ed096801$var$ParseError.FILE_DELETE_ERROR = 153;
/**
 * Error code indicating an error deleting an unnamed file.
 *
 * @property {number} FILE_DELETE_UNNAMED_ERROR
 * @static
 */ $2b2e6852ed096801$var$ParseError.FILE_DELETE_UNNAMED_ERROR = 161;
/**
 * Error code indicating that the application has exceeded its request
 * limit.
 *
 * @property {number} REQUEST_LIMIT_EXCEEDED
 * @static
 */ $2b2e6852ed096801$var$ParseError.REQUEST_LIMIT_EXCEEDED = 155;
/**
 * Error code indicating that the request was a duplicate and has been discarded due to
 * idempotency rules.
 *
 * @property {number} DUPLICATE_REQUEST
 * @static
 */ $2b2e6852ed096801$var$ParseError.DUPLICATE_REQUEST = 159;
/**
 * Error code indicating an invalid event name.
 *
 * @property {number} INVALID_EVENT_NAME
 * @static
 */ $2b2e6852ed096801$var$ParseError.INVALID_EVENT_NAME = 160;
/**
 * Error code indicating that a field had an invalid value.
 *
 * @property {number} INVALID_VALUE
 * @static
 */ $2b2e6852ed096801$var$ParseError.INVALID_VALUE = 162;
/**
 * Error code indicating that the username is missing or empty.
 *
 * @property {number} USERNAME_MISSING
 * @static
 */ $2b2e6852ed096801$var$ParseError.USERNAME_MISSING = 200;
/**
 * Error code indicating that the password is missing or empty.
 *
 * @property {number} PASSWORD_MISSING
 * @static
 */ $2b2e6852ed096801$var$ParseError.PASSWORD_MISSING = 201;
/**
 * Error code indicating that the username has already been taken.
 *
 * @property {number} USERNAME_TAKEN
 * @static
 */ $2b2e6852ed096801$var$ParseError.USERNAME_TAKEN = 202;
/**
 * Error code indicating that the email has already been taken.
 *
 * @property {number} EMAIL_TAKEN
 * @static
 */ $2b2e6852ed096801$var$ParseError.EMAIL_TAKEN = 203;
/**
 * Error code indicating that the email is missing, but must be specified.
 *
 * @property {number} EMAIL_MISSING
 * @static
 */ $2b2e6852ed096801$var$ParseError.EMAIL_MISSING = 204;
/**
 * Error code indicating that a user with the specified email was not found.
 *
 * @property {number} EMAIL_NOT_FOUND
 * @static
 */ $2b2e6852ed096801$var$ParseError.EMAIL_NOT_FOUND = 205;
/**
 * Error code indicating that a user object without a valid session could
 * not be altered.
 *
 * @property {number} SESSION_MISSING
 * @static
 */ $2b2e6852ed096801$var$ParseError.SESSION_MISSING = 206;
/**
 * Error code indicating that a user can only be created through signup.
 *
 * @property {number} MUST_CREATE_USER_THROUGH_SIGNUP
 * @static
 */ $2b2e6852ed096801$var$ParseError.MUST_CREATE_USER_THROUGH_SIGNUP = 207;
/**
 * Error code indicating that an an account being linked is already linked
 * to another user.
 *
 * @property {number} ACCOUNT_ALREADY_LINKED
 * @static
 */ $2b2e6852ed096801$var$ParseError.ACCOUNT_ALREADY_LINKED = 208;
/**
 * Error code indicating that the current session token is invalid.
 *
 * @property {number} INVALID_SESSION_TOKEN
 * @static
 */ $2b2e6852ed096801$var$ParseError.INVALID_SESSION_TOKEN = 209;
/**
 * Error code indicating an error enabling or verifying MFA
 *
 * @property {number} MFA_ERROR
 * @static
 */ $2b2e6852ed096801$var$ParseError.MFA_ERROR = 210;
/**
 * Error code indicating that a valid MFA token must be provided
 *
 * @property {number} MFA_TOKEN_REQUIRED
 * @static
 */ $2b2e6852ed096801$var$ParseError.MFA_TOKEN_REQUIRED = 211;
/**
 * Error code indicating that a user cannot be linked to an account because
 * that account's id could not be found.
 *
 * @property {number} LINKED_ID_MISSING
 * @static
 */ $2b2e6852ed096801$var$ParseError.LINKED_ID_MISSING = 250;
/**
 * Error code indicating that a user with a linked (e.g. Facebook) account
 * has an invalid session.
 *
 * @property {number} INVALID_LINKED_SESSION
 * @static
 */ $2b2e6852ed096801$var$ParseError.INVALID_LINKED_SESSION = 251;
/**
 * Error code indicating that a service being linked (e.g. Facebook or
 * Twitter) is unsupported.
 *
 * @property {number} UNSUPPORTED_SERVICE
 * @static
 */ $2b2e6852ed096801$var$ParseError.UNSUPPORTED_SERVICE = 252;
/**
 * Error code indicating an invalid operation occured on schema
 *
 * @property {number} INVALID_SCHEMA_OPERATION
 * @static
 */ $2b2e6852ed096801$var$ParseError.INVALID_SCHEMA_OPERATION = 255;
/**
 * Error code indicating that there were multiple errors. Aggregate errors
 * have an "errors" property, which is an array of error objects with more
 * detail about each error that occurred.
 *
 * @property {number} AGGREGATE_ERROR
 * @static
 */ $2b2e6852ed096801$var$ParseError.AGGREGATE_ERROR = 600;
/**
 * Error code indicating the client was unable to read an input file.
 *
 * @property {number} FILE_READ_ERROR
 * @static
 */ $2b2e6852ed096801$var$ParseError.FILE_READ_ERROR = 601;
/**
 * Error code indicating a real error code is unavailable because
 * we had to use an XDomainRequest object to allow CORS requests in
 * Internet Explorer, which strips the body from HTTP responses that have
 * a non-2XX status code.
 *
 * @property {number} X_DOMAIN_REQUEST
 * @static
 */ $2b2e6852ed096801$var$ParseError.X_DOMAIN_REQUEST = 602;
var $2b2e6852ed096801$var$_default = $2b2e6852ed096801$var$ParseError;
module.exports.default = $2b2e6852ed096801$var$_default;

});
parcelRequire.register("jb7jN", function(module, exports) {

var $b3yOG = parcelRequire("b3yOG");

var $3geLe = parcelRequire("3geLe");

var $6MmOk = parcelRequire("6MmOk");

var $8FU8b = parcelRequire("8FU8b");

var $d9XNm = parcelRequire("d9XNm");

var $jrXgC = parcelRequire("jrXgC");
function $df64b8a9560acf02$var$_wrapNativeSuper(Class) {
    var _cache = typeof $b3yOG === "function" ? new $b3yOG() : undefined;
    module.exports = $df64b8a9560acf02$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$d9XNm(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $jrXgC(Class, arguments, $6MmOk(this).constructor);
        }
        Wrapper.prototype = $3geLe(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $8FU8b(Wrapper, Class);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $df64b8a9560acf02$var$_wrapNativeSuper(Class);
}
module.exports = $df64b8a9560acf02$var$_wrapNativeSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("b3yOG", function(module, exports) {

module.exports = (parcelRequire("ju8v8"));

});
parcelRequire.register("ju8v8", function(module, exports) {

module.exports = (parcelRequire("5fSKb"));

});
parcelRequire.register("5fSKb", function(module, exports) {

var $dLsS4 = parcelRequire("dLsS4");
parcelRequire("dixnU");
parcelRequire("35Aek");
parcelRequire("aJpRs");
parcelRequire("9q9KV");
parcelRequire("f53om");
parcelRequire("3BGVv");
parcelRequire("h57rO");
parcelRequire("3b9fw");
parcelRequire("18Lnu");
parcelRequire("eqY3w");
parcelRequire("4GQSb");
parcelRequire("kMjJ9");
parcelRequire("fQHI2");
parcelRequire("6TvJ1");
parcelRequire("gpiCQ");
parcelRequire("8WIAi");
parcelRequire("cT1bR");
parcelRequire("fYq1y");
parcelRequire("4xz1H");
parcelRequire("bSsPK");
module.exports = $dLsS4;

});
parcelRequire.register("dLsS4", function(module, exports) {

var $1bC6H = parcelRequire("1bC6H");
module.exports = $1bC6H;

});
parcelRequire.register("1bC6H", function(module, exports) {

var $36MWp = parcelRequire("36MWp");
parcelRequire("4YdnW");
module.exports = $36MWp;

});
parcelRequire.register("36MWp", function(module, exports) {
parcelRequire("4IarS");
parcelRequire("1YFpR");
parcelRequire("edOxo");
parcelRequire("5cfBr");

var $envPC = parcelRequire("envPC");
module.exports = $envPC.Map;

});
parcelRequire.register("1YFpR", function(module, exports) {
// TODO: Remove this module from `core-js@4` since it's replaced to module below
parcelRequire("iCXMZ");

});
parcelRequire.register("iCXMZ", function(module, exports) {
"use strict";

var $7naRP = parcelRequire("7naRP");

var $8bzCn = parcelRequire("8bzCn");
// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
$7naRP("Map", function(init) {
    return function Map() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
}, $8bzCn);

});
parcelRequire.register("8bzCn", function(module, exports) {
"use strict";

var $2oTKI = parcelRequire("2oTKI");

var $1oUoQ = parcelRequire("1oUoQ");

var $lgLDw = parcelRequire("lgLDw");

var $2B9V4 = parcelRequire("2B9V4");

var $1SdiW = parcelRequire("1SdiW");

var $9PkDw = parcelRequire("9PkDw");

var $gSzFI = parcelRequire("gSzFI");

var $1o5CL = parcelRequire("1o5CL");

var $7FHs8 = parcelRequire("7FHs8");

var $gnIxM = parcelRequire("gnIxM");

var $99D40 = parcelRequire("99D40");

var $kBX5g = parcelRequire("kBX5g");
var $5f5afacf43751e52$require$fastKey = $kBX5g.fastKey;

var $CWMD0 = parcelRequire("CWMD0");
var $5f5afacf43751e52$var$setInternalState = $CWMD0.set;
var $5f5afacf43751e52$var$internalStateGetterFor = $CWMD0.getterFor;
module.exports = {
    getConstructor: function(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var Constructor = wrapper(function(that, iterable) {
            $1SdiW(that, Prototype);
            $5f5afacf43751e52$var$setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                index: $2oTKI(null),
                first: undefined,
                last: undefined,
                size: 0
            });
            if (!$99D40) that.size = 0;
            if (!$9PkDw(iterable)) $gSzFI(iterable, that[ADDER], {
                that: that,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = $5f5afacf43751e52$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function(that, key, value) {
            var state = getInternalState(that);
            var entry = getEntry(that, key);
            var previous, index;
            // change existing entry
            if (entry) entry.value = value;
            else {
                state.last = entry = {
                    index: index = $5f5afacf43751e52$require$fastKey(key, true),
                    key: key,
                    value: value,
                    previous: previous = state.last,
                    next: undefined,
                    removed: false
                };
                if (!state.first) state.first = entry;
                if (previous) previous.next = entry;
                if ($99D40) state.size++;
                else that.size++;
                // add to index
                if (index !== "F") state.index[index] = entry;
            }
            return that;
        };
        var getEntry = function(that, key) {
            var state = getInternalState(that);
            // fast case
            var index = $5f5afacf43751e52$require$fastKey(key);
            var entry;
            if (index !== "F") return state.index[index];
            // frozen object case
            for(entry = state.first; entry; entry = entry.next){
                if (entry.key == key) return entry;
            }
        };
        $lgLDw(Prototype, {
            // `{ Map, Set }.prototype.clear()` methods
            // https://tc39.es/ecma262/#sec-map.prototype.clear
            // https://tc39.es/ecma262/#sec-set.prototype.clear
            clear: function clear() {
                var that = this;
                var state = getInternalState(that);
                var data = state.index;
                var entry = state.first;
                while(entry){
                    entry.removed = true;
                    if (entry.previous) entry.previous = entry.previous.next = undefined;
                    delete data[entry.index];
                    entry = entry.next;
                }
                state.first = state.last = undefined;
                if ($99D40) state.size = 0;
                else that.size = 0;
            },
            // `{ Map, Set }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.delete
            // https://tc39.es/ecma262/#sec-set.prototype.delete
            "delete": function(key) {
                var that = this;
                var state = getInternalState(that);
                var entry = getEntry(that, key);
                if (entry) {
                    var next = entry.next;
                    var prev = entry.previous;
                    delete state.index[entry.index];
                    entry.removed = true;
                    if (prev) prev.next = next;
                    if (next) next.previous = prev;
                    if (state.first == entry) state.first = next;
                    if (state.last == entry) state.last = prev;
                    if ($99D40) state.size--;
                    else that.size--;
                }
                return !!entry;
            },
            // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.foreach
            // https://tc39.es/ecma262/#sec-set.prototype.foreach
            forEach: function forEach(callbackfn /* , that = undefined */ ) {
                var state = getInternalState(this);
                var boundFunction = $2B9V4(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                var entry;
                while(entry = entry ? entry.next : state.first){
                    boundFunction(entry.value, entry.key, this);
                    // revert to the last existing entry
                    while(entry && entry.removed)entry = entry.previous;
                }
            },
            // `{ Map, Set}.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.has
            // https://tc39.es/ecma262/#sec-set.prototype.has
            has: function has(key) {
                return !!getEntry(this, key);
            }
        });
        $lgLDw(Prototype, IS_MAP ? {
            // `Map.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-map.prototype.get
            get: function get(key) {
                var entry = getEntry(this, key);
                return entry && entry.value;
            },
            // `Map.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-map.prototype.set
            set: function set(key, value) {
                return define(this, key === 0 ? 0 : key, value);
            }
        } : {
            // `Set.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-set.prototype.add
            add: function add(value) {
                return define(this, value = value === 0 ? 0 : value, value);
            }
        });
        if ($99D40) $1oUoQ(Prototype, "size", {
            configurable: true,
            get: function() {
                return getInternalState(this).size;
            }
        });
        return Constructor;
    },
    setStrong: function(Constructor, CONSTRUCTOR_NAME, IS_MAP) {
        var ITERATOR_NAME = CONSTRUCTOR_NAME + " Iterator";
        var getInternalCollectionState = $5f5afacf43751e52$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var getInternalIteratorState = $5f5afacf43751e52$var$internalStateGetterFor(ITERATOR_NAME);
        // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
        // https://tc39.es/ecma262/#sec-map.prototype.entries
        // https://tc39.es/ecma262/#sec-map.prototype.keys
        // https://tc39.es/ecma262/#sec-map.prototype.values
        // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
        // https://tc39.es/ecma262/#sec-set.prototype.entries
        // https://tc39.es/ecma262/#sec-set.prototype.keys
        // https://tc39.es/ecma262/#sec-set.prototype.values
        // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
        $1o5CL(Constructor, CONSTRUCTOR_NAME, function(iterated, kind) {
            $5f5afacf43751e52$var$setInternalState(this, {
                type: ITERATOR_NAME,
                target: iterated,
                state: getInternalCollectionState(iterated),
                kind: kind,
                last: undefined
            });
        }, function() {
            var state = getInternalIteratorState(this);
            var kind = state.kind;
            var entry = state.last;
            // revert to the last existing entry
            while(entry && entry.removed)entry = entry.previous;
            // get next entry
            if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
                // or finish the iteration
                state.target = undefined;
                return $7FHs8(undefined, true);
            }
            // return step by kind
            if (kind == "keys") return $7FHs8(entry.key, false);
            if (kind == "values") return $7FHs8(entry.value, false);
            return $7FHs8([
                entry.key,
                entry.value
            ], false);
        }, IS_MAP ? "entries" : "values", !IS_MAP, true);
        // `{ Map, Set }.prototype[@@species]` accessors
        // https://tc39.es/ecma262/#sec-get-map-@@species
        // https://tc39.es/ecma262/#sec-get-set-@@species
        $gnIxM(CONSTRUCTOR_NAME);
    }
};

});






parcelRequire.register("dixnU", function(module, exports) {

var $g2B3u = parcelRequire("g2B3u");

var $1pEmU = parcelRequire("1pEmU");
// `Map.from` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
$g2B3u({
    target: "Map",
    stat: true,
    forced: true
}, {
    from: $1pEmU
});

});
parcelRequire.register("1pEmU", function(module, exports) {
"use strict";

var $2B9V4 = parcelRequire("2B9V4");

var $5qecd = parcelRequire("5qecd");

var $aZpni = parcelRequire("aZpni");

var $f3ZOd = parcelRequire("f3ZOd");

var $9PkDw = parcelRequire("9PkDw");

var $gSzFI = parcelRequire("gSzFI");
var $1077709c8b65b405$var$push = [].push;
module.exports = function from(source /* , mapFn, thisArg */ ) {
    var length = arguments.length;
    var mapFn = length > 1 ? arguments[1] : undefined;
    var mapping, array, n, boundFunction;
    $f3ZOd(this);
    mapping = mapFn !== undefined;
    if (mapping) $aZpni(mapFn);
    if ($9PkDw(source)) return new this();
    array = [];
    if (mapping) {
        n = 0;
        boundFunction = $2B9V4(mapFn, length > 2 ? arguments[2] : undefined);
        $gSzFI(source, function(nextItem) {
            $5qecd($1077709c8b65b405$var$push, array, boundFunction(nextItem, n++));
        });
    } else $gSzFI(source, $1077709c8b65b405$var$push, {
        that: array
    });
    return new this(array);
};

});


parcelRequire.register("35Aek", function(module, exports) {

var $g2B3u = parcelRequire("g2B3u");

var $64ScL = parcelRequire("64ScL");
// `Map.of` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
$g2B3u({
    target: "Map",
    stat: true,
    forced: true
}, {
    of: $64ScL
});

});
parcelRequire.register("64ScL", function(module, exports) {
"use strict";

var $74qJH = parcelRequire("74qJH");
// https://tc39.github.io/proposal-setmap-offrom/
module.exports = function of() {
    return new this($74qJH(arguments));
};

});


parcelRequire.register("aJpRs", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $ikHrE = parcelRequire("ikHrE");

var $15CH8 = parcelRequire("15CH8");
var $7d022adcf6c3a68c$require$remove = $15CH8.remove;
// `Map.prototype.deleteAll` method
// https://github.com/tc39/proposal-collection-methods
$g2B3u({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    deleteAll: function deleteAll() {
        var collection = $ikHrE(this);
        var allDeleted = true;
        var wasDeleted;
        for(var k = 0, len = arguments.length; k < len; k++){
            wasDeleted = $7d022adcf6c3a68c$require$remove(collection, arguments[k]);
            allDeleted = allDeleted && wasDeleted;
        }
        return !!allDeleted;
    }
});

});
parcelRequire.register("ikHrE", function(module, exports) {

var $4ubrU = parcelRequire("4ubrU");
// Perform ? RequireInternalSlot(M, [[MapData]])
module.exports = function(it) {
    if (typeof it == "object" && "size" in it && "has" in it && "get" in it && "set" in it && "delete" in it && "entries" in it) return it;
    throw TypeError($4ubrU(it) + " is not a map");
};

});

parcelRequire.register("15CH8", function(module, exports) {

var $bTXoK = parcelRequire("bTXoK");

var $5k5WW = parcelRequire("5k5WW");
var $0cb4460e324b2030$var$Map = $bTXoK("Map");
module.exports = {
    Map: $0cb4460e324b2030$var$Map,
    set: $5k5WW("set", 2),
    get: $5k5WW("get", 1),
    has: $5k5WW("has", 1),
    remove: $5k5WW("delete", 1),
    proto: $0cb4460e324b2030$var$Map.prototype
};

});
parcelRequire.register("5k5WW", function(module, exports) {
module.exports = function(methodName, numArgs) {
    return numArgs == 1 ? function(object, arg) {
        return object[methodName](arg);
    } : function(object, arg1, arg2) {
        return object[methodName](arg1, arg2);
    };
};

});



parcelRequire.register("9q9KV", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $ikHrE = parcelRequire("ikHrE");

var $15CH8 = parcelRequire("15CH8");
var $6dbe1c0eb4380c7e$var$get = $15CH8.get;
var $6dbe1c0eb4380c7e$var$has = $15CH8.has;
var $6dbe1c0eb4380c7e$var$set = $15CH8.set;
// `Map.prototype.emplace` method
// https://github.com/tc39/proposal-upsert
$g2B3u({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    emplace: function emplace(key, handler) {
        var map = $ikHrE(this);
        var value, inserted;
        if ($6dbe1c0eb4380c7e$var$has(map, key)) {
            value = $6dbe1c0eb4380c7e$var$get(map, key);
            if ("update" in handler) {
                value = handler.update(value, key, map);
                $6dbe1c0eb4380c7e$var$set(map, key, value);
            }
            return value;
        }
        inserted = handler.insert(key, map);
        $6dbe1c0eb4380c7e$var$set(map, key, inserted);
        return inserted;
    }
});

});

parcelRequire.register("f53om", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $2B9V4 = parcelRequire("2B9V4");

var $ikHrE = parcelRequire("ikHrE");

var $74gmx = parcelRequire("74gmx");
// `Map.prototype.every` method
// https://github.com/tc39/proposal-collection-methods
$g2B3u({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    every: function every(callbackfn /* , thisArg */ ) {
        var map = $ikHrE(this);
        var boundFunction = $2B9V4(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        return $74gmx(map, function(value, key) {
            if (!boundFunction(value, key, map)) return false;
        }, true) !== false;
    }
});

});
parcelRequire.register("74gmx", function(module, exports) {

var $6WLxB = parcelRequire("6WLxB");
module.exports = function(map, fn, interruptible) {
    return interruptible ? $6WLxB(map.entries(), function(entry) {
        return fn(entry[1], entry[0]);
    }) : map.forEach(fn);
};

});
parcelRequire.register("6WLxB", function(module, exports) {

var $5qecd = parcelRequire("5qecd");
module.exports = function(iterator, fn, $next) {
    var next = $next || iterator.next;
    var step, result;
    while(!(step = $5qecd(next, iterator)).done){
        result = fn(step.value);
        if (result !== undefined) return result;
    }
};

});



parcelRequire.register("3BGVv", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $2B9V4 = parcelRequire("2B9V4");

var $ikHrE = parcelRequire("ikHrE");

var $15CH8 = parcelRequire("15CH8");

var $74gmx = parcelRequire("74gmx");
var $2a06201a38a90cc0$var$Map = $15CH8.Map;
var $2a06201a38a90cc0$var$set = $15CH8.set;
// `Map.prototype.filter` method
// https://github.com/tc39/proposal-collection-methods
$g2B3u({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    filter: function filter(callbackfn /* , thisArg */ ) {
        var map = $ikHrE(this);
        var boundFunction = $2B9V4(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var newMap = new $2a06201a38a90cc0$var$Map();
        $74gmx(map, function(value, key) {
            if (boundFunction(value, key, map)) $2a06201a38a90cc0$var$set(newMap, key, value);
        });
        return newMap;
    }
});

});

parcelRequire.register("h57rO", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $2B9V4 = parcelRequire("2B9V4");

var $ikHrE = parcelRequire("ikHrE");

var $74gmx = parcelRequire("74gmx");
// `Map.prototype.find` method
// https://github.com/tc39/proposal-collection-methods
$g2B3u({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    find: function find(callbackfn /* , thisArg */ ) {
        var map = $ikHrE(this);
        var boundFunction = $2B9V4(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var result = $74gmx(map, function(value, key) {
            if (boundFunction(value, key, map)) return {
                value: value
            };
        }, true);
        return result && result.value;
    }
});

});

parcelRequire.register("3b9fw", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $2B9V4 = parcelRequire("2B9V4");

var $ikHrE = parcelRequire("ikHrE");

var $74gmx = parcelRequire("74gmx");
// `Map.prototype.findKey` method
// https://github.com/tc39/proposal-collection-methods
$g2B3u({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    findKey: function findKey(callbackfn /* , thisArg */ ) {
        var map = $ikHrE(this);
        var boundFunction = $2B9V4(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var result = $74gmx(map, function(value, key) {
            if (boundFunction(value, key, map)) return {
                key: key
            };
        }, true);
        return result && result.key;
    }
});

});

parcelRequire.register("18Lnu", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $7tcts = parcelRequire("7tcts");

var $aZpni = parcelRequire("aZpni");

var $dfvEY = parcelRequire("dfvEY");

var $gSzFI = parcelRequire("gSzFI");

var $15CH8 = parcelRequire("15CH8");
var $0d4b4a0eeaace612$var$Map = $15CH8.Map;
var $0d4b4a0eeaace612$var$has = $15CH8.has;
var $0d4b4a0eeaace612$var$get = $15CH8.get;
var $0d4b4a0eeaace612$var$set = $15CH8.set;
var $0d4b4a0eeaace612$var$push = $7tcts([].push);
// `Map.groupBy` method
// https://github.com/tc39/proposal-array-grouping
$g2B3u({
    target: "Map",
    stat: true,
    forced: true
}, {
    groupBy: function groupBy(items, callbackfn) {
        $dfvEY(items);
        $aZpni(callbackfn);
        var map = new $0d4b4a0eeaace612$var$Map();
        var k = 0;
        $gSzFI(items, function(value) {
            var key = callbackfn(value, k++);
            if (!$0d4b4a0eeaace612$var$has(map, key)) $0d4b4a0eeaace612$var$set(map, key, [
                value
            ]);
            else $0d4b4a0eeaace612$var$push($0d4b4a0eeaace612$var$get(map, key), value);
        });
        return map;
    }
});

});

parcelRequire.register("eqY3w", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $emAHQ = parcelRequire("emAHQ");

var $ikHrE = parcelRequire("ikHrE");

var $74gmx = parcelRequire("74gmx");
// `Map.prototype.includes` method
// https://github.com/tc39/proposal-collection-methods
$g2B3u({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    includes: function includes(searchElement) {
        return $74gmx($ikHrE(this), function(value) {
            if ($emAHQ(value, searchElement)) return true;
        }, true) === true;
    }
});

});
parcelRequire.register("emAHQ", function(module, exports) {
// `SameValueZero` abstract operation
// https://tc39.es/ecma262/#sec-samevaluezero
module.exports = function(x, y) {
    // eslint-disable-next-line no-self-compare -- NaN check
    return x === y || x != x && y != y;
};

});


parcelRequire.register("4GQSb", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $5qecd = parcelRequire("5qecd");

var $gSzFI = parcelRequire("gSzFI");

var $6kYHq = parcelRequire("6kYHq");

var $aZpni = parcelRequire("aZpni");

var $15CH8 = parcelRequire("15CH8");
var $36a41924008601f9$require$Map = $15CH8.Map;
// `Map.keyBy` method
// https://github.com/tc39/proposal-collection-methods
$g2B3u({
    target: "Map",
    stat: true,
    forced: true
}, {
    keyBy: function keyBy(iterable, keyDerivative) {
        var C = $6kYHq(this) ? this : $36a41924008601f9$require$Map;
        var newMap = new C();
        $aZpni(keyDerivative);
        var setter = $aZpni(newMap.set);
        $gSzFI(iterable, function(element) {
            $5qecd(setter, newMap, keyDerivative(element), element);
        });
        return newMap;
    }
});

});

parcelRequire.register("kMjJ9", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $ikHrE = parcelRequire("ikHrE");

var $74gmx = parcelRequire("74gmx");
// `Map.prototype.keyOf` method
// https://github.com/tc39/proposal-collection-methods
$g2B3u({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    keyOf: function keyOf(searchElement) {
        var result = $74gmx($ikHrE(this), function(value, key) {
            if (value === searchElement) return {
                key: key
            };
        }, true);
        return result && result.key;
    }
});

});

parcelRequire.register("fQHI2", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $2B9V4 = parcelRequire("2B9V4");

var $ikHrE = parcelRequire("ikHrE");

var $15CH8 = parcelRequire("15CH8");

var $74gmx = parcelRequire("74gmx");
var $b89d9e1e5c1f9932$var$Map = $15CH8.Map;
var $b89d9e1e5c1f9932$var$set = $15CH8.set;
// `Map.prototype.mapKeys` method
// https://github.com/tc39/proposal-collection-methods
$g2B3u({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    mapKeys: function mapKeys(callbackfn /* , thisArg */ ) {
        var map = $ikHrE(this);
        var boundFunction = $2B9V4(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var newMap = new $b89d9e1e5c1f9932$var$Map();
        $74gmx(map, function(value, key) {
            $b89d9e1e5c1f9932$var$set(newMap, boundFunction(value, key, map), value);
        });
        return newMap;
    }
});

});

parcelRequire.register("6TvJ1", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $2B9V4 = parcelRequire("2B9V4");

var $ikHrE = parcelRequire("ikHrE");

var $15CH8 = parcelRequire("15CH8");

var $74gmx = parcelRequire("74gmx");
var $50507d1cb5878cb6$var$Map = $15CH8.Map;
var $50507d1cb5878cb6$var$set = $15CH8.set;
// `Map.prototype.mapValues` method
// https://github.com/tc39/proposal-collection-methods
$g2B3u({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    mapValues: function mapValues(callbackfn /* , thisArg */ ) {
        var map = $ikHrE(this);
        var boundFunction = $2B9V4(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var newMap = new $50507d1cb5878cb6$var$Map();
        $74gmx(map, function(value, key) {
            $50507d1cb5878cb6$var$set(newMap, key, boundFunction(value, key, map));
        });
        return newMap;
    }
});

});

parcelRequire.register("gpiCQ", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $ikHrE = parcelRequire("ikHrE");

var $gSzFI = parcelRequire("gSzFI");

var $15CH8 = parcelRequire("15CH8");
var $bf1d6dc456efc22f$require$set = $15CH8.set;
// `Map.prototype.merge` method
// https://github.com/tc39/proposal-collection-methods
$g2B3u({
    target: "Map",
    proto: true,
    real: true,
    arity: 1,
    forced: true
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    merge: function merge(iterable /* ...iterables */ ) {
        var map = $ikHrE(this);
        var argumentsLength = arguments.length;
        var i = 0;
        while(i < argumentsLength)$gSzFI(arguments[i++], function(key, value) {
            $bf1d6dc456efc22f$require$set(map, key, value);
        }, {
            AS_ENTRIES: true
        });
        return map;
    }
});

});

parcelRequire.register("8WIAi", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $aZpni = parcelRequire("aZpni");

var $ikHrE = parcelRequire("ikHrE");

var $74gmx = parcelRequire("74gmx");
var $01ae4ba978ec5e08$var$$TypeError = TypeError;
// `Map.prototype.reduce` method
// https://github.com/tc39/proposal-collection-methods
$g2B3u({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        var map = $ikHrE(this);
        var noInitial = arguments.length < 2;
        var accumulator = noInitial ? undefined : arguments[1];
        $aZpni(callbackfn);
        $74gmx(map, function(value, key) {
            if (noInitial) {
                noInitial = false;
                accumulator = value;
            } else accumulator = callbackfn(accumulator, value, key, map);
        });
        if (noInitial) throw $01ae4ba978ec5e08$var$$TypeError("Reduce of empty map with no initial value");
        return accumulator;
    }
});

});

parcelRequire.register("cT1bR", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $2B9V4 = parcelRequire("2B9V4");

var $ikHrE = parcelRequire("ikHrE");

var $74gmx = parcelRequire("74gmx");
// `Map.prototype.some` method
// https://github.com/tc39/proposal-collection-methods
$g2B3u({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    some: function some(callbackfn /* , thisArg */ ) {
        var map = $ikHrE(this);
        var boundFunction = $2B9V4(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        return $74gmx(map, function(value, key) {
            if (boundFunction(value, key, map)) return true;
        }, true) === true;
    }
});

});

parcelRequire.register("fYq1y", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $aZpni = parcelRequire("aZpni");

var $ikHrE = parcelRequire("ikHrE");

var $15CH8 = parcelRequire("15CH8");
var $ba10a57462bf96a3$var$$TypeError = TypeError;
var $ba10a57462bf96a3$var$get = $15CH8.get;
var $ba10a57462bf96a3$var$has = $15CH8.has;
var $ba10a57462bf96a3$var$set = $15CH8.set;
// `Map.prototype.update` method
// https://github.com/tc39/proposal-collection-methods
$g2B3u({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    update: function update(key, callback /* , thunk */ ) {
        var map = $ikHrE(this);
        var length = arguments.length;
        $aZpni(callback);
        var isPresentInMap = $ba10a57462bf96a3$var$has(map, key);
        if (!isPresentInMap && length < 3) throw $ba10a57462bf96a3$var$$TypeError("Updating absent value");
        var value = isPresentInMap ? $ba10a57462bf96a3$var$get(map, key) : $aZpni(length > 2 ? arguments[2] : undefined)(key, map);
        $ba10a57462bf96a3$var$set(map, key, callback(value, key, map));
        return map;
    }
});

});

parcelRequire.register("4xz1H", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $ff7fw = parcelRequire("ff7fw");
// `Map.prototype.upsert` method (replaced by `Map.prototype.emplace`)
// https://github.com/thumbsupep/proposal-upsert
$g2B3u({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    upsert: $ff7fw
});

});
parcelRequire.register("ff7fw", function(module, exports) {
"use strict";

var $5qecd = parcelRequire("5qecd");

var $aZpni = parcelRequire("aZpni");

var $6kYHq = parcelRequire("6kYHq");

var $lalRy = parcelRequire("lalRy");
var $b18de14f5af7a55a$var$$TypeError = TypeError;
// `Map.prototype.upsert` method
// https://github.com/tc39/proposal-upsert
module.exports = function upsert(key, updateFn /* , insertFn */ ) {
    var map = $lalRy(this);
    var get = $aZpni(map.get);
    var has = $aZpni(map.has);
    var set = $aZpni(map.set);
    var insertFn = arguments.length > 2 ? arguments[2] : undefined;
    var value;
    if (!$6kYHq(updateFn) && !$6kYHq(insertFn)) throw $b18de14f5af7a55a$var$$TypeError("At least one callback required");
    if ($5qecd(has, map, key)) {
        value = $5qecd(get, map, key);
        if ($6kYHq(updateFn)) {
            value = updateFn(value);
            $5qecd(set, map, key, value);
        }
    } else if ($6kYHq(insertFn)) {
        value = insertFn();
        $5qecd(set, map, key, value);
    }
    return value;
};

});


parcelRequire.register("bSsPK", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $ff7fw = parcelRequire("ff7fw");
// `Map.prototype.updateOrInsert` method (replaced by `Map.prototype.emplace`)
// https://github.com/thumbsupep/proposal-upsert
$g2B3u({
    target: "Map",
    proto: true,
    real: true,
    name: "upsert",
    forced: true
}, {
    updateOrInsert: $ff7fw
});

});




parcelRequire.register("d9XNm", function(module, exports) {

var $49Nun = parcelRequire("49Nun");
function $994a7fafd925541a$var$_isNativeFunction(fn) {
    var _context;
    return $49Nun(_context = Function.toString.call(fn)).call(_context, "[native code]") !== -1;
}
module.exports = $994a7fafd925541a$var$_isNativeFunction, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("49Nun", function(module, exports) {

module.exports = (parcelRequire("gWEbt"));

});
parcelRequire.register("gWEbt", function(module, exports) {

module.exports = (parcelRequire("cD23K"));

});
parcelRequire.register("cD23K", function(module, exports) {

var $iIrVW = parcelRequire("iIrVW");
module.exports = $iIrVW;

});
parcelRequire.register("iIrVW", function(module, exports) {

var $fDhgc = parcelRequire("fDhgc");
module.exports = $fDhgc;

});
parcelRequire.register("fDhgc", function(module, exports) {

var $9uHI8 = parcelRequire("9uHI8");
module.exports = $9uHI8;

});
parcelRequire.register("9uHI8", function(module, exports) {

var $5L8hR = parcelRequire("5L8hR");

var $cViKV = parcelRequire("cViKV");
var $6e98d2751dd1b3d6$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.indexOf;
    return it === $6e98d2751dd1b3d6$var$ArrayPrototype || $5L8hR($6e98d2751dd1b3d6$var$ArrayPrototype, it) && own === $6e98d2751dd1b3d6$var$ArrayPrototype.indexOf ? $cViKV : own;
};

});
parcelRequire.register("cViKV", function(module, exports) {
parcelRequire("hwiFg");

var $hESIr = parcelRequire("hESIr");
module.exports = $hESIr("Array").indexOf;

});
parcelRequire.register("hwiFg", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $fCzmA = parcelRequire("fCzmA");

var $gehei = parcelRequire("gehei");
var $cc13e7378494f5e7$require$$indexOf = $gehei.indexOf;

var $iNgXn = parcelRequire("iNgXn");
var $cc13e7378494f5e7$var$nativeIndexOf = $fCzmA([].indexOf);
var $cc13e7378494f5e7$var$NEGATIVE_ZERO = !!$cc13e7378494f5e7$var$nativeIndexOf && 1 / $cc13e7378494f5e7$var$nativeIndexOf([
    1
], 1, -0) < 0;
var $cc13e7378494f5e7$var$FORCED = $cc13e7378494f5e7$var$NEGATIVE_ZERO || !$iNgXn("indexOf");
// `Array.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.indexof
$g2B3u({
    target: "Array",
    proto: true,
    forced: $cc13e7378494f5e7$var$FORCED
}, {
    indexOf: function indexOf(searchElement /* , fromIndex = 0 */ ) {
        var fromIndex = arguments.length > 1 ? arguments[1] : undefined;
        return $cc13e7378494f5e7$var$NEGATIVE_ZERO ? $cc13e7378494f5e7$var$nativeIndexOf(this, searchElement, fromIndex) || 0 : $cc13e7378494f5e7$require$$indexOf(this, searchElement, fromIndex);
    }
});

});









parcelRequire.register("jrXgC", function(module, exports) {

var $ccZH0 = parcelRequire("ccZH0");

var $32EKH = parcelRequire("32EKH");

var $8FU8b = parcelRequire("8FU8b");

var $5zK5U = parcelRequire("5zK5U");
function $e28e831f9617dd38$var$_construct(Parent, args, Class) {
    if ($5zK5U()) module.exports = $e28e831f9617dd38$var$_construct = $ccZH0, module.exports.__esModule = true, module.exports["default"] = module.exports;
    else module.exports = $e28e831f9617dd38$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = $32EKH(Function).apply(Parent, a);
        var instance = new Constructor();
        if (Class) $8FU8b(instance, Class.prototype);
        return instance;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $e28e831f9617dd38$var$_construct.apply(null, arguments);
}
module.exports = $e28e831f9617dd38$var$_construct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("ccZH0", function(module, exports) {

module.exports = (parcelRequire("kQ50t"));

});
parcelRequire.register("kQ50t", function(module, exports) {

module.exports = (parcelRequire("3nlfB"));

});
parcelRequire.register("3nlfB", function(module, exports) {

var $ccs8J = parcelRequire("ccs8J");
module.exports = $ccs8J;

});
parcelRequire.register("ccs8J", function(module, exports) {

var $1d4PA = parcelRequire("1d4PA");
module.exports = $1d4PA;

});




parcelRequire.register("32EKH", function(module, exports) {

module.exports = (parcelRequire("OWr3x"));

});
parcelRequire.register("OWr3x", function(module, exports) {

module.exports = (parcelRequire("4y9p5"));

});
parcelRequire.register("4y9p5", function(module, exports) {

var $4nqcz = parcelRequire("4nqcz");
module.exports = $4nqcz;

});
parcelRequire.register("4nqcz", function(module, exports) {

var $c0ccY = parcelRequire("c0ccY");
module.exports = $c0ccY;

});
parcelRequire.register("c0ccY", function(module, exports) {

var $g9eUY = parcelRequire("g9eUY");
module.exports = $g9eUY;

});
parcelRequire.register("g9eUY", function(module, exports) {

var $5L8hR = parcelRequire("5L8hR");

var $cHTtt = parcelRequire("cHTtt");
var $bc190efdd75d16ea$var$FunctionPrototype = Function.prototype;
module.exports = function(it) {
    var own = it.bind;
    return it === $bc190efdd75d16ea$var$FunctionPrototype || $5L8hR($bc190efdd75d16ea$var$FunctionPrototype, it) && own === $bc190efdd75d16ea$var$FunctionPrototype.bind ? $cHTtt : own;
};

});
parcelRequire.register("cHTtt", function(module, exports) {
parcelRequire("9P37i");

var $hESIr = parcelRequire("hESIr");
module.exports = $hESIr("Function").bind;

});
parcelRequire.register("9P37i", function(module, exports) {
// TODO: Remove from `core-js@4`

var $g2B3u = parcelRequire("g2B3u");

var $ahsSP = parcelRequire("ahsSP");
// `Function.prototype.bind` method
// https://tc39.es/ecma262/#sec-function.prototype.bind
// eslint-disable-next-line es/no-function-prototype-bind -- detection
$g2B3u({
    target: "Function",
    proto: true,
    forced: Function.bind !== $ahsSP
}, {
    bind: $ahsSP
});

});








parcelRequire.register("5zK5U", function(module, exports) {

var $ccZH0 = parcelRequire("ccZH0");
function $40f3f9ff33e5b304$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !$ccZH0) return false;
    if ($ccZH0.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($ccZH0(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
module.exports = $40f3f9ff33e5b304$var$_isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRequire.register("2HIpX", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $25qme = parcelRequire("25qme");


var $liESz = parcelRequire("liESz");

var $5hSqA = parcelRequire("5hSqA");

var $fG1Ke = parcelRequire("fG1Ke");

var $iY2ec = parcelRequire("iY2ec");


var $iWJ3a = parcelRequire("iWJ3a");




var $ebK4m = parcelRequire("ebK4m");


var $8jMtB = parcelRequire("8jMtB");

var $1nHJN = parcelRequire("1nHJN");


var $1o4IC = parcelRequire("1o4IC");

var $kYm0J = parcelRequire("kYm0J");

var $d3A5d = parcelRequire("d3A5d");

(parcelRequire("evY07"))(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1f820d57da405774$var$_map = $3Npdz((parcelRequire("hqsP5")));

var $1f820d57da405774$var$_find = $3Npdz((parcelRequire("jGOxU")));

var $1f820d57da405774$var$_defineProperty2 = $3Npdz((parcelRequire("evY07")));

var $1f820d57da405774$var$_create = $3Npdz((parcelRequire("dvfqn")));

var $1f820d57da405774$var$_promise = $3Npdz((parcelRequire("bCWDe")));

var $1f820d57da405774$var$_isArray = $3Npdz((parcelRequire("i0kCX")));

var $1f820d57da405774$var$_asyncToGenerator2 = $3Npdz((parcelRequire("iqZS2")));

var $1f820d57da405774$var$_concat = $3Npdz((parcelRequire("3mvQI")));

var $1f820d57da405774$var$_getPrototypeOf = $3Npdz((parcelRequire("cO2y8")));

var $1f820d57da405774$var$_includes = $3Npdz((parcelRequire("aUw0k")));

var $1f820d57da405774$var$_stringify = $3Npdz((parcelRequire("O2sNs")));

var $1f820d57da405774$var$_forEach = $3Npdz((parcelRequire("jZGC2")));

var $1f820d57da405774$var$_keys = $3Npdz((parcelRequire("r9mpE")));

var $1f820d57da405774$var$_freeze = $3Npdz((parcelRequire("jv0By")));

var $1f820d57da405774$var$_typeof2 = $3Npdz((parcelRequire("akViX")));

var $1f820d57da405774$var$_classCallCheck2 = $3Npdz((parcelRequire("9pQKE")));

var $1f820d57da405774$var$_createClass2 = $3Npdz((parcelRequire("eZYdV")));

var $1f820d57da405774$var$_defineProperty3 = $3Npdz((parcelRequire("bci6G")));

var $1f820d57da405774$var$_indexOf = $3Npdz((parcelRequire("eOZH4")));

var $1f820d57da405774$var$_CoreManager = $3Npdz((parcelRequire("465CW")));

var $1f820d57da405774$var$_canBeSerialized = $3Npdz((parcelRequire("eQIfM")));

var $1f820d57da405774$var$_decode = $3Npdz((parcelRequire("7CFxK")));

var $1f820d57da405774$var$_encode = $3Npdz((parcelRequire("gM4ym")));

var $1f820d57da405774$var$_escape2 = $3Npdz((parcelRequire("c9yrO")));

var $1f820d57da405774$var$_EventuallyQueue = $3Npdz((parcelRequire("3gAuF")));

var $1f820d57da405774$var$_ParseACL = $3Npdz((parcelRequire("9HvHn")));

var $1f820d57da405774$var$_parseDate = $3Npdz((parcelRequire("fimv0")));

var $1f820d57da405774$var$_ParseError = $3Npdz((parcelRequire("3HQSG")));

var $1f820d57da405774$var$_ParseFile = $3Npdz((parcelRequire("gf3Ge")));

var $j0i6P = parcelRequire("j0i6P");

var $7Icwu = parcelRequire("7Icwu");

var $1WcLm = parcelRequire("1WcLm");

var $1f820d57da405774$var$_ParseQuery = $3Npdz((parcelRequire("eJCLn")));

var $1f820d57da405774$var$_ParseRelation = $3Npdz((parcelRequire("4Glkc")));

var $1f820d57da405774$var$SingleInstanceStateController = $1f820d57da405774$var$_interopRequireWildcard((parcelRequire("YKYfs")));

var $1f820d57da405774$var$_unique = $3Npdz((parcelRequire("cQimZ")));

var $1f820d57da405774$var$UniqueInstanceStateController = $1f820d57da405774$var$_interopRequireWildcard((parcelRequire("4o7l6")));

var $1f820d57da405774$var$_unsavedChildren = $3Npdz((parcelRequire("7weND")));
function $1f820d57da405774$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof $25qme !== "function") return null;
    var cacheBabelInterop = new $25qme();
    var cacheNodeInterop = new $25qme();
    return ($1f820d57da405774$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $1f820d57da405774$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || (parcelRequire("akViX"))(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $1f820d57da405774$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = (parcelRequire("evY07")) && $1o4IC ? $1o4IC(obj, key) : null;
        if (desc && (desc.get || desc.set)) (parcelRequire("evY07"))(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $1f820d57da405774$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof $ebK4m !== "undefined" && $liESz(o) || o["@@iterator"];
    if (!it) {
        if ((parcelRequire("i0kCX"))(o) || (it = $1f820d57da405774$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function() {};
            return {
                s: F,
                n: function() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function() {
            it = it.call(o);
        },
        n: function() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $1f820d57da405774$var$_unsupportedIterableToArray(o, minLen) {
    var _context20;
    if (!o) return;
    if (typeof o === "string") return $1f820d57da405774$var$_arrayLikeToArray(o, minLen);
    var n = $fG1Ke(_context20 = Object.prototype.toString.call(o)).call(_context20, 8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return $5hSqA(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1f820d57da405774$var$_arrayLikeToArray(o, minLen);
}
function $1f820d57da405774$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1f820d57da405774$var$_regeneratorRuntime() {
    "use strict";
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ $1f820d57da405774$var$_regeneratorRuntime = function() {
        return exports1;
    };
    var exports1 = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof $ebK4m ? $ebK4m : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return (parcelRequire("evY07"))(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = (parcelRequire("dvfqn"))(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return generator._invoke = function(innerFn, self, context) {
            var state = "suspendedStart";
            return function(method, arg) {
                if ("executing" === state) throw new Error("Generator is already running");
                if ("completed" === state) {
                    if ("throw" === method) throw arg;
                    return doneResult();
                }
                for(context.method = method, context.arg = arg;;){
                    var delegate = context.delegate;
                    if (delegate) {
                        var delegateResult = maybeInvokeDelegate(delegate, context);
                        if (delegateResult) {
                            if (delegateResult === ContinueSentinel) continue;
                            return delegateResult;
                        }
                    }
                    if ("next" === context.method) context.sent = context._sent = context.arg;
                    else if ("throw" === context.method) {
                        if ("suspendedStart" === state) throw state = "completed", context.arg;
                        context.dispatchException(context.arg);
                    } else "return" === context.method && context.abrupt("return", context.arg);
                    state = "executing";
                    var record = tryCatch(innerFn, self, context);
                    if ("normal" === record.type) {
                        if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                        return {
                            value: record.arg,
                            done: context.done
                        };
                    }
                    "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
                }
            };
        }(innerFn, self, context), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports1.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = (parcelRequire("cO2y8")), NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = (parcelRequire("dvfqn"))(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        var _context18;
        (parcelRequire("jZGC2"))(_context18 = [
            "next",
            "throw",
            "return"
        ]).call(_context18, function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == (parcelRequire("akViX"))(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        this._invoke = function(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];
        if (undefined === method) {
            if (context.delegate = null, "throw" === context.method) {
                if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
                context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], (parcelRequire("jZGC2"))(tryLocsList).call(tryLocsList, pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;){
                        if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    }
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports1.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports1.mark = function(genFun) {
        return $iWJ3a ? $iWJ3a(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = (parcelRequire("dvfqn"))(Gp), genFun;
    }, exports1.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports1.AsyncIterator = AsyncIterator, exports1.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = (parcelRequire("bCWDe")));
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports1.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports1.keys = function(object) {
        var keys = [];
        for(var key in object)keys.push(key);
        return $iY2ec(keys).call(keys), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports1.values = values, Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            var _context19;
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, (parcelRequire("jZGC2"))(_context19 = this.tryEntries).call(_context19, resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+$fG1Ke(name).call(name, 1)) && (this[name] = undefined);
        },
        stop: function() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports1;
}
function $1f820d57da405774$var$ownKeys(object, enumerableOnly) {
    var keys = (parcelRequire("r9mpE"))(object);
    if ($d3A5d) {
        var symbols = $d3A5d(object);
        enumerableOnly && (symbols = $kYm0J(symbols).call(symbols, function(sym) {
            return $1o4IC(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1f820d57da405774$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var _context16, _context17;
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? (parcelRequire("jZGC2"))(_context16 = $1f820d57da405774$var$ownKeys(Object(source), !0)).call(_context16, function(key) {
            (0, $1f820d57da405774$var$_defineProperty3.default)(target, key, source[key]);
        }) : $1nHJN ? $8jMtB(target, $1nHJN(source)) : (parcelRequire("jZGC2"))(_context17 = $1f820d57da405774$var$ownKeys(Object(source))).call(_context17, function(key) {
            (parcelRequire("evY07"))(target, key, $1o4IC(source, key));
        });
    }
    return target;
}

var $JZta3 = parcelRequire("JZta3");
/*:: export type Pointer = {
  __type: string,
  className: string,
  objectId: string,
};*/ /*:: type SaveParams = {
  method: string,
  path: string,
  body: AttributeMap,
};*/ /*:: export type SaveOptions = FullOptions & {
  cascadeSave?: boolean,
  context?: AttributeMap,
};*/ // Mapping of class names to constructors, so we can populate objects from the
// server with appropriate subclasses of ParseObject
var $1f820d57da405774$var$classMap = {}; // Global counter for generating unique Ids for non-single-instance objects
var $1f820d57da405774$var$objectCount = 0; // On web clients, objects are single-instance: any two objects with the same Id
// will have the same attributes. However, this may be dangerous default
// behavior in a server scenario
var $1f820d57da405774$var$singleInstance = !$1f820d57da405774$var$_CoreManager.default.get("IS_NODE");
if ($1f820d57da405774$var$singleInstance) $1f820d57da405774$var$_CoreManager.default.setObjectStateController($1f820d57da405774$var$SingleInstanceStateController);
else $1f820d57da405774$var$_CoreManager.default.setObjectStateController($1f820d57da405774$var$UniqueInstanceStateController);
function $1f820d57da405774$var$getServerUrlPath() {
    var serverUrl = $1f820d57da405774$var$_CoreManager.default.get("SERVER_URL");
    if (serverUrl[serverUrl.length - 1] !== "/") serverUrl += "/";
    var url = serverUrl.replace(/https?:\/\//, "");
    return url.substr((0, $1f820d57da405774$var$_indexOf.default)(url).call(url, "/"));
}
/**
 * Creates a new model with defined attributes.
 *
 * <p>You won't normally call this method directly.  It is recommended that
 * you use a subclass of <code>Parse.Object</code> instead, created by calling
 * <code>extend</code>.</p>
 *
 * <p>However, if you don't want to use a subclass, or aren't sure which
 * subclass is appropriate, you can use this form:<pre>
 *     var object = new Parse.Object("ClassName");
 * </pre>
 * That is basically equivalent to:<pre>
 *     var MyClass = Parse.Object.extend("ClassName");
 *     var object = new MyClass();
 * </pre></p>
 *
 * @alias Parse.Object
 */ var $1f820d57da405774$var$ParseObject = /*#__PURE__*/ function() {
    /**
   * @param {string} className The class name for the object
   * @param {object} attributes The initial set of data to store in the object.
   * @param {object} options The options for this object instance.
   */ function ParseObject(className, attributes, options) {
        (0, $1f820d57da405774$var$_classCallCheck2.default)(this, ParseObject);
        (0, $1f820d57da405774$var$_defineProperty3.default)(this, "id", void 0);
        (0, $1f820d57da405774$var$_defineProperty3.default)(this, "_localId", void 0);
        (0, $1f820d57da405774$var$_defineProperty3.default)(this, "_objCount", void 0);
        (0, $1f820d57da405774$var$_defineProperty3.default)(this, "className", void 0); // Enable legacy initializers
        if (typeof this.initialize === "function") this.initialize.apply(this, arguments);
        var toSet = null;
        this._objCount = $1f820d57da405774$var$objectCount++;
        if (typeof className === "string") {
            this.className = className;
            if (attributes && (0, $1f820d57da405774$var$_typeof2.default)(attributes) === "object") toSet = attributes;
        } else if (className && (0, $1f820d57da405774$var$_typeof2.default)(className) === "object") {
            this.className = className.className;
            toSet = {};
            for(var _attr in className)if (_attr !== "className") toSet[_attr] = className[_attr];
            if (attributes && (0, $1f820d57da405774$var$_typeof2.default)(attributes) === "object") options = attributes;
        }
        if (toSet && !this.set(toSet, options)) throw new Error("Can't create an invalid Parse Object");
    }
    /**
   * The ID of this object, unique within its class.
   *
   * @property {string} id
   */ (0, $1f820d57da405774$var$_createClass2.default)(ParseObject, [
        {
            key: "attributes",
            get: /** Prototype getters / setters **/ function() /*: AttributeMap*/ {
                var stateController = $1f820d57da405774$var$_CoreManager.default.getObjectStateController();
                return (0, $1f820d57da405774$var$_freeze.default)(stateController.estimateAttributes(this._getStateIdentifier()));
            }
        },
        {
            key: "createdAt",
            get: function() /*: ?Date*/ {
                return this._getServerData().createdAt;
            }
        },
        {
            key: "updatedAt",
            get: function() /*: ?Date*/ {
                return this._getServerData().updatedAt;
            }
        },
        {
            key: "_getId",
            value: function() /*: string*/ {
                if (typeof this.id === "string") return this.id;
                if (typeof this._localId === "string") return this._localId;
                var localId = "local" + $JZta3();
                this._localId = localId;
                return localId;
            }
        },
        {
            key: "_getStateIdentifier",
            value: function() /*: ParseObject | { id: string, className: string }*/ {
                if ($1f820d57da405774$var$singleInstance) {
                    var id = this.id;
                    if (!id) id = this._getId();
                    return {
                        id: id,
                        className: this.className
                    };
                } else return this;
            }
        },
        {
            key: "_getServerData",
            value: function() /*: AttributeMap*/ {
                var stateController = $1f820d57da405774$var$_CoreManager.default.getObjectStateController();
                return stateController.getServerData(this._getStateIdentifier());
            }
        },
        {
            key: "_clearServerData",
            value: function() {
                var serverData = this._getServerData();
                var unset = {};
                for(var _attr2 in serverData)unset[_attr2] = undefined;
                var stateController = $1f820d57da405774$var$_CoreManager.default.getObjectStateController();
                stateController.setServerData(this._getStateIdentifier(), unset);
            }
        },
        {
            key: "_getPendingOps",
            value: function() /*: Array<OpsMap>*/ {
                var stateController = $1f820d57da405774$var$_CoreManager.default.getObjectStateController();
                return stateController.getPendingOps(this._getStateIdentifier());
            }
        },
        {
            key: "_clearPendingOps",
            value: function(keysToClear) {
                var pending = this._getPendingOps();
                var latest = pending[pending.length - 1];
                var keys = keysToClear || (0, $1f820d57da405774$var$_keys.default)(latest);
                (0, $1f820d57da405774$var$_forEach.default)(keys).call(keys, function(key) {
                    delete latest[key];
                });
            }
        },
        {
            key: "_getDirtyObjectAttributes",
            value: function() /*: AttributeMap*/ {
                var attributes = this.attributes;
                var stateController = $1f820d57da405774$var$_CoreManager.default.getObjectStateController();
                var objectCache = stateController.getObjectCache(this._getStateIdentifier());
                var dirty = {};
                for(var _attr3 in attributes){
                    var val = attributes[_attr3];
                    if (val && (0, $1f820d57da405774$var$_typeof2.default)(val) === "object" && !(val instanceof ParseObject) && !(val instanceof $1f820d57da405774$var$_ParseFile.default) && !(val instanceof $1f820d57da405774$var$_ParseRelation.default)) // Due to the way browsers construct maps, the key order will not change
                    // unless the object is changed
                    try {
                        var json = (0, $1f820d57da405774$var$_encode.default)(val, false, true);
                        var stringified = (0, $1f820d57da405774$var$_stringify.default)(json);
                        if (objectCache[_attr3] !== stringified) dirty[_attr3] = val;
                    } catch (e) {
                        // Error occurred, possibly by a nested unsaved pointer in a mutable container
                        // No matter how it happened, it indicates a change in the attribute
                        dirty[_attr3] = val;
                    }
                }
                return dirty;
            }
        },
        {
            key: "_toFullJSON",
            value: function(seen, offline) /*: AttributeMap*/ {
                var json = this.toJSON(seen, offline);
                json.__type = "Object";
                json.className = this.className;
                return json;
            }
        },
        {
            key: "_getSaveJSON",
            value: function() /*: AttributeMap*/ {
                var pending = this._getPendingOps();
                var dirtyObjects = this._getDirtyObjectAttributes();
                var json = {};
                for(var attr in dirtyObjects){
                    var isDotNotation = false;
                    for(var i = 0; i < pending.length; i += 1){
                        for(var field in pending[i])// Dot notation operations are handled later
                        if ((0, $1f820d57da405774$var$_includes.default)(field).call(field, ".")) {
                            var fieldName = field.split(".")[0];
                            if (fieldName === attr) {
                                isDotNotation = true;
                                break;
                            }
                        }
                    }
                    if (!isDotNotation) json[attr] = new $1WcLm.SetOp(dirtyObjects[attr]).toJSON();
                }
                for(attr in pending[0])json[attr] = pending[0][attr].toJSON();
                return json;
            }
        },
        {
            key: "_getSaveParams",
            value: function() /*: SaveParams*/ {
                var method = this.id ? "PUT" : "POST";
                var body = this._getSaveJSON();
                var path = "classes/" + this.className;
                if ($1f820d57da405774$var$_CoreManager.default.get("ALLOW_CUSTOM_OBJECT_ID")) {
                    if (!this.createdAt) {
                        method = "POST";
                        body.objectId = this.id;
                    } else {
                        method = "PUT";
                        path += "/" + this.id;
                    }
                } else if (this.id) path += "/" + this.id;
                else if (this.className === "_User") path = "users";
                return {
                    method: method,
                    body: body,
                    path: path
                };
            }
        },
        {
            key: "_finishFetch",
            value: function(serverData) {
                if (!this.id && serverData.objectId) this.id = serverData.objectId;
                var stateController = $1f820d57da405774$var$_CoreManager.default.getObjectStateController();
                stateController.initializeState(this._getStateIdentifier());
                var decoded = {};
                for(var _attr4 in serverData){
                    if (_attr4 === "ACL") decoded[_attr4] = new $1f820d57da405774$var$_ParseACL.default(serverData[_attr4]);
                    else if (_attr4 !== "objectId") {
                        decoded[_attr4] = (0, $1f820d57da405774$var$_decode.default)(serverData[_attr4]);
                        if (decoded[_attr4] instanceof $1f820d57da405774$var$_ParseRelation.default) decoded[_attr4]._ensureParentAndKey(this, _attr4);
                    }
                }
                if (decoded.createdAt && typeof decoded.createdAt === "string") decoded.createdAt = (0, $1f820d57da405774$var$_parseDate.default)(decoded.createdAt);
                if (decoded.updatedAt && typeof decoded.updatedAt === "string") decoded.updatedAt = (0, $1f820d57da405774$var$_parseDate.default)(decoded.updatedAt);
                if (!decoded.updatedAt && decoded.createdAt) decoded.updatedAt = decoded.createdAt;
                stateController.commitServerChanges(this._getStateIdentifier(), decoded);
            }
        },
        {
            key: "_setExisted",
            value: function(existed) {
                var stateController = $1f820d57da405774$var$_CoreManager.default.getObjectStateController();
                var state = stateController.getState(this._getStateIdentifier());
                if (state) state.existed = existed;
            }
        },
        {
            key: "_migrateId",
            value: function(serverId) {
                if (this._localId && serverId) {
                    if ($1f820d57da405774$var$singleInstance) {
                        var stateController = $1f820d57da405774$var$_CoreManager.default.getObjectStateController();
                        var oldState = stateController.removeState(this._getStateIdentifier());
                        this.id = serverId;
                        delete this._localId;
                        if (oldState) stateController.initializeState(this._getStateIdentifier(), oldState);
                    } else {
                        this.id = serverId;
                        delete this._localId;
                    }
                }
            }
        },
        {
            key: "_handleSaveResponse",
            value: function(response, status) {
                var changes = {};
                var stateController = $1f820d57da405774$var$_CoreManager.default.getObjectStateController();
                var pending = stateController.popPendingState(this._getStateIdentifier());
                for(var attr in pending){
                    if (pending[attr] instanceof $1WcLm.RelationOp) changes[attr] = pending[attr].applyTo(undefined, this, attr);
                    else if (!(attr in response)) // Only SetOps and UnsetOps should not come back with results
                    changes[attr] = pending[attr].applyTo(undefined);
                }
                for(attr in response){
                    if ((attr === "createdAt" || attr === "updatedAt") && typeof response[attr] === "string") changes[attr] = (0, $1f820d57da405774$var$_parseDate.default)(response[attr]);
                    else if (attr === "ACL") changes[attr] = new $1f820d57da405774$var$_ParseACL.default(response[attr]);
                    else if (attr !== "objectId") {
                        var val = (0, $1f820d57da405774$var$_decode.default)(response[attr]);
                        if (val && (0, $1f820d57da405774$var$_getPrototypeOf.default)(val) === Object.prototype) changes[attr] = $1f820d57da405774$var$_objectSpread($1f820d57da405774$var$_objectSpread({}, this.attributes[attr]), val);
                        else changes[attr] = val;
                        if (changes[attr] instanceof $1WcLm.UnsetOp) changes[attr] = undefined;
                    }
                }
                if (changes.createdAt && !changes.updatedAt) changes.updatedAt = changes.createdAt;
                this._migrateId(response.objectId);
                if (status !== 201) this._setExisted(true);
                stateController.commitServerChanges(this._getStateIdentifier(), changes);
            }
        },
        {
            key: "_handleSaveError",
            value: function() {
                var stateController = $1f820d57da405774$var$_CoreManager.default.getObjectStateController();
                stateController.mergeFirstPendingState(this._getStateIdentifier());
            }
        },
        {
            key: "initialize",
            value: /** Public methods **/ function() {}
        },
        {
            key: "toJSON",
            value: function(seen, offline) /*: AttributeMap*/ {
                var seenEntry = this.id ? this.className + ":" + this.id : this;
                seen = seen || [
                    seenEntry
                ];
                var json = {};
                var attrs = this.attributes;
                for(var _attr5 in attrs)if ((_attr5 === "createdAt" || _attr5 === "updatedAt") && attrs[_attr5].toJSON) json[_attr5] = attrs[_attr5].toJSON();
                else json[_attr5] = (0, $1f820d57da405774$var$_encode.default)(attrs[_attr5], false, false, seen, offline);
                var pending = this._getPendingOps();
                for(var _attr6 in pending[0])json[_attr6] = pending[0][_attr6].toJSON(offline);
                if (this.id) json.objectId = this.id;
                return json;
            }
        },
        {
            key: "equals",
            value: function(other) /*: boolean*/ {
                if (this === other) return true;
                return other instanceof ParseObject && this.className === other.className && this.id === other.id && typeof this.id !== "undefined";
            }
        },
        {
            key: "dirty",
            value: function(attr) /*: boolean*/ {
                if (!this.id) return true;
                var pendingOps = this._getPendingOps();
                var dirtyObjects = this._getDirtyObjectAttributes();
                if (attr) {
                    if (dirtyObjects.hasOwnProperty(attr)) return true;
                    for(var i = 0; i < pendingOps.length; i++){
                        if (pendingOps[i].hasOwnProperty(attr)) return true;
                    }
                    return false;
                }
                if ((0, $1f820d57da405774$var$_keys.default)(pendingOps[0]).length !== 0) return true;
                if ((0, $1f820d57da405774$var$_keys.default)(dirtyObjects).length !== 0) return true;
                return false;
            }
        },
        {
            key: "dirtyKeys",
            value: function() /*: Array<string>*/ {
                var pendingOps = this._getPendingOps();
                var keys = {};
                for(var i = 0; i < pendingOps.length; i++)for(var _attr7 in pendingOps[i])keys[_attr7] = true;
                var dirtyObjects = this._getDirtyObjectAttributes();
                for(var _attr8 in dirtyObjects)keys[_attr8] = true;
                return (0, $1f820d57da405774$var$_keys.default)(keys);
            }
        },
        {
            key: "isDataAvailable",
            value: function() /*: boolean*/ {
                var serverData = this._getServerData();
                return !!(0, $1f820d57da405774$var$_keys.default)(serverData).length;
            }
        },
        {
            key: "toPointer",
            value: function() /*: Pointer*/ {
                if (!this.id) throw new Error("Cannot create a pointer to an unsaved ParseObject");
                return {
                    __type: "Pointer",
                    className: this.className,
                    objectId: this.id
                };
            }
        },
        {
            key: "toOfflinePointer",
            value: function() /*: Pointer*/ {
                if (!this._localId) throw new Error("Cannot create a offline pointer to a saved ParseObject");
                return {
                    __type: "Object",
                    className: this.className,
                    _localId: this._localId
                };
            }
        },
        {
            key: "get",
            value: function(attr) /*: mixed*/ {
                return this.attributes[attr];
            }
        },
        {
            key: "relation",
            value: function(attr) /*: ParseRelation*/ {
                var value = this.get(attr);
                if (value) {
                    if (!(value instanceof $1f820d57da405774$var$_ParseRelation.default)) throw new Error("Called relation() on non-relation field " + attr);
                    value._ensureParentAndKey(this, attr);
                    return value;
                }
                return new $1f820d57da405774$var$_ParseRelation.default(this, attr);
            }
        },
        {
            key: "escape",
            value: function(attr) /*: string*/ {
                var val = this.attributes[attr];
                if (val == null) return "";
                if (typeof val !== "string") {
                    if (typeof val.toString !== "function") return "";
                    val = val.toString();
                }
                return (0, $1f820d57da405774$var$_escape2.default)(val);
            }
        },
        {
            key: "has",
            value: function(attr) /*: boolean*/ {
                var attributes = this.attributes;
                if (attributes.hasOwnProperty(attr)) return attributes[attr] != null;
                return false;
            }
        },
        {
            key: "set",
            value: function(key, value, options) /*: ParseObject | boolean*/ {
                var changes = {};
                var newOps = {};
                if (key && (0, $1f820d57da405774$var$_typeof2.default)(key) === "object") {
                    changes = key;
                    options = value;
                } else if (typeof key === "string") changes[key] = value;
                else return this;
                options = options || {};
                var readonly = [];
                if (typeof this.constructor.readOnlyAttributes === "function") readonly = (0, $1f820d57da405774$var$_concat.default)(readonly).call(readonly, this.constructor.readOnlyAttributes());
                for(var k in changes){
                    if (k === "createdAt" || k === "updatedAt") continue;
                    if ((0, $1f820d57da405774$var$_indexOf.default)(readonly).call(readonly, k) > -1) throw new Error("Cannot modify readonly attribute: " + k);
                    if (options.unset) newOps[k] = new $1WcLm.UnsetOp();
                    else if (changes[k] instanceof $1WcLm.Op) newOps[k] = changes[k];
                    else if (changes[k] && (0, $1f820d57da405774$var$_typeof2.default)(changes[k]) === "object" && typeof changes[k].__op === "string") newOps[k] = (0, $1WcLm.opFromJSON)(changes[k]);
                    else if (k === "objectId" || k === "id") {
                        if (typeof changes[k] === "string") this.id = changes[k];
                    } else if (k === "ACL" && (0, $1f820d57da405774$var$_typeof2.default)(changes[k]) === "object" && !(changes[k] instanceof $1f820d57da405774$var$_ParseACL.default)) newOps[k] = new $1WcLm.SetOp(new $1f820d57da405774$var$_ParseACL.default(changes[k]));
                    else if (changes[k] instanceof $1f820d57da405774$var$_ParseRelation.default) {
                        var relation = new $1f820d57da405774$var$_ParseRelation.default(this, k);
                        relation.targetClassName = changes[k].targetClassName;
                        newOps[k] = new $1WcLm.SetOp(relation);
                    } else newOps[k] = new $1WcLm.SetOp(changes[k]);
                }
                var currentAttributes = this.attributes; // Calculate new values
                var newValues = {};
                for(var _attr9 in newOps){
                    if (newOps[_attr9] instanceof $1WcLm.RelationOp) newValues[_attr9] = newOps[_attr9].applyTo(currentAttributes[_attr9], this, _attr9);
                    else if (!(newOps[_attr9] instanceof $1WcLm.UnsetOp)) newValues[_attr9] = newOps[_attr9].applyTo(currentAttributes[_attr9]);
                } // Validate changes
                if (!options.ignoreValidation) {
                    var validation = this.validate(newValues);
                    if (validation) {
                        if (typeof options.error === "function") options.error(this, validation);
                        return false;
                    }
                } // Consolidate Ops
                var pendingOps = this._getPendingOps();
                var last = pendingOps.length - 1;
                var stateController = $1f820d57da405774$var$_CoreManager.default.getObjectStateController();
                for(var _attr10 in newOps){
                    var nextOp = newOps[_attr10].mergeWith(pendingOps[last][_attr10]);
                    stateController.setPendingOp(this._getStateIdentifier(), _attr10, nextOp);
                }
                return this;
            }
        },
        {
            key: "unset",
            value: function(attr, options) /*: ParseObject | boolean*/ {
                options = options || {};
                options.unset = true;
                return this.set(attr, null, options);
            }
        },
        {
            key: "increment",
            value: function(attr, amount) /*: ParseObject | boolean*/ {
                if (typeof amount === "undefined") amount = 1;
                if (typeof amount !== "number") throw new Error("Cannot increment by a non-numeric amount.");
                return this.set(attr, new $1WcLm.IncrementOp(amount));
            }
        },
        {
            key: "decrement",
            value: function(attr, amount) /*: ParseObject | boolean*/ {
                if (typeof amount === "undefined") amount = 1;
                if (typeof amount !== "number") throw new Error("Cannot decrement by a non-numeric amount.");
                return this.set(attr, new $1WcLm.IncrementOp(amount * -1));
            }
        },
        {
            key: "add",
            value: function(attr, item) /*: ParseObject | boolean*/ {
                return this.set(attr, new $1WcLm.AddOp([
                    item
                ]));
            }
        },
        {
            key: "addAll",
            value: function(attr, items) /*: ParseObject | boolean*/ {
                return this.set(attr, new $1WcLm.AddOp(items));
            }
        },
        {
            key: "addUnique",
            value: function(attr, item) /*: ParseObject | boolean*/ {
                return this.set(attr, new $1WcLm.AddUniqueOp([
                    item
                ]));
            }
        },
        {
            key: "addAllUnique",
            value: function(attr, items) /*: ParseObject | boolean*/ {
                return this.set(attr, new $1WcLm.AddUniqueOp(items));
            }
        },
        {
            key: "remove",
            value: function(attr, item) /*: ParseObject | boolean*/ {
                return this.set(attr, new $1WcLm.RemoveOp([
                    item
                ]));
            }
        },
        {
            key: "removeAll",
            value: function(attr, items) /*: ParseObject | boolean*/ {
                return this.set(attr, new $1WcLm.RemoveOp(items));
            }
        },
        {
            key: "op",
            value: function(attr) /*: ?Op*/ {
                var pending = this._getPendingOps();
                for(var i = pending.length; i--;){
                    if (pending[i][attr]) return pending[i][attr];
                }
            }
        },
        {
            key: "clone",
            value: function clone() /*: any*/ {
                var clone = new this.constructor(this.className);
                var attributes = this.attributes;
                if (typeof this.constructor.readOnlyAttributes === "function") {
                    var readonly = this.constructor.readOnlyAttributes() || []; // Attributes are frozen, so we have to rebuild an object,
                    // rather than delete readonly keys
                    var copy = {};
                    for(var a in attributes)if ((0, $1f820d57da405774$var$_indexOf.default)(readonly).call(readonly, a) < 0) copy[a] = attributes[a];
                    attributes = copy;
                }
                if (clone.set) clone.set(attributes);
                return clone;
            }
        },
        {
            key: "newInstance",
            value: function() /*: any*/ {
                var clone = new this.constructor(this.className);
                clone.id = this.id;
                if ($1f820d57da405774$var$singleInstance) // Just return an object with the right id
                return clone;
                var stateController = $1f820d57da405774$var$_CoreManager.default.getObjectStateController();
                if (stateController) stateController.duplicateState(this._getStateIdentifier(), clone._getStateIdentifier());
                return clone;
            }
        },
        {
            key: "isNew",
            value: function() /*: boolean*/ {
                return !this.id;
            }
        },
        {
            key: "existed",
            value: function() /*: boolean*/ {
                if (!this.id) return false;
                var stateController = $1f820d57da405774$var$_CoreManager.default.getObjectStateController();
                var state = stateController.getState(this._getStateIdentifier());
                if (state) return state.existed;
                return false;
            }
        },
        {
            key: "exists",
            value: function() {
                var _exists = (0, $1f820d57da405774$var$_asyncToGenerator2.default)(/*#__PURE__*/ $1f820d57da405774$var$_regeneratorRuntime().mark(function _callee(options) {
                    var query;
                    return $1f820d57da405774$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (this.id) {
                                    _context.next = 2;
                                    break;
                                }
                                return _context.abrupt("return", false);
                            case 2:
                                _context.prev = 2;
                                query = new $1f820d57da405774$var$_ParseQuery.default(this.className);
                                _context.next = 6;
                                return query.get(this.id, options);
                            case 6:
                                return _context.abrupt("return", true);
                            case 9:
                                _context.prev = 9;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0.code === $1f820d57da405774$var$_ParseError.default.OBJECT_NOT_FOUND)) {
                                    _context.next = 13;
                                    break;
                                }
                                return _context.abrupt("return", false);
                            case 13:
                                throw _context.t0;
                            case 14:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            9
                        ]
                    ]);
                }));
                function exists(_x) {
                    return _exists.apply(this, arguments);
                }
                return exists;
            }()
        },
        {
            key: "isValid",
            value: function isValid() /*: boolean*/ {
                return !this.validate(this.attributes);
            }
        },
        {
            key: "validate",
            value: function validate(attrs) /*: ParseError | boolean*/ {
                if (attrs.hasOwnProperty("ACL") && !(attrs.ACL instanceof $1f820d57da405774$var$_ParseACL.default)) return new $1f820d57da405774$var$_ParseError.default($1f820d57da405774$var$_ParseError.default.OTHER_CAUSE, "ACL must be a Parse ACL.");
                for(var _key in attrs){
                    if (!/^[A-Za-z][0-9A-Za-z_.]*$/.test(_key)) return new $1f820d57da405774$var$_ParseError.default($1f820d57da405774$var$_ParseError.default.INVALID_KEY_NAME);
                }
                return false;
            }
        },
        {
            key: "getACL",
            value: function getACL() /*: ?ParseACL*/ {
                var acl = this.get("ACL");
                if (acl instanceof $1f820d57da405774$var$_ParseACL.default) return acl;
                return null;
            }
        },
        {
            key: "setACL",
            value: function setACL(acl, options) /*: ParseObject | boolean*/ {
                return this.set("ACL", acl, options);
            }
        },
        {
            key: "revert",
            value: function revert() /*: void*/ {
                var keysToRevert;
                for(var _len = arguments.length, keys = new Array(_len), _key2 = 0; _key2 < _len; _key2++)keys[_key2] = arguments[_key2];
                if (keys.length) {
                    keysToRevert = [];
                    var _iterator = $1f820d57da405774$var$_createForOfIteratorHelper(keys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var _key3 = _step.value;
                            if (typeof _key3 === "string") keysToRevert.push(_key3);
                            else throw new Error("Parse.Object#revert expects either no, or a list of string, arguments.");
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this._clearPendingOps(keysToRevert);
            }
        },
        {
            key: "clear",
            value: function clear() /*: ParseObject | boolean*/ {
                var attributes = this.attributes;
                var erasable = {};
                var readonly = [
                    "createdAt",
                    "updatedAt"
                ];
                if (typeof this.constructor.readOnlyAttributes === "function") readonly = (0, $1f820d57da405774$var$_concat.default)(readonly).call(readonly, this.constructor.readOnlyAttributes());
                for(var _attr11 in attributes)if ((0, $1f820d57da405774$var$_indexOf.default)(readonly).call(readonly, _attr11) < 0) erasable[_attr11] = true;
                return this.set(erasable, {
                    unset: true
                });
            }
        },
        {
            key: "fetch",
            value: function fetch(options) /*: Promise*/ {
                options = options || {};
                var fetchOptions = {};
                if (options.hasOwnProperty("useMasterKey")) fetchOptions.useMasterKey = options.useMasterKey;
                if (options.hasOwnProperty("sessionToken")) fetchOptions.sessionToken = options.sessionToken;
                if (options.hasOwnProperty("context") && (0, $1f820d57da405774$var$_typeof2.default)(options.context) === "object") fetchOptions.context = options.context;
                if (options.hasOwnProperty("include")) {
                    fetchOptions.include = [];
                    if ((0, $1f820d57da405774$var$_isArray.default)(options.include)) {
                        var _context2;
                        (0, $1f820d57da405774$var$_forEach.default)(_context2 = options.include).call(_context2, function(key) {
                            if ((0, $1f820d57da405774$var$_isArray.default)(key)) {
                                var _context3;
                                fetchOptions.include = (0, $1f820d57da405774$var$_concat.default)(_context3 = fetchOptions.include).call(_context3, key);
                            } else fetchOptions.include.push(key);
                        });
                    } else fetchOptions.include.push(options.include);
                }
                var controller = $1f820d57da405774$var$_CoreManager.default.getObjectController();
                return controller.fetch(this, true, fetchOptions);
            }
        },
        {
            key: "fetchWithInclude",
            value: function fetchWithInclude(keys, options) /*: Promise*/ {
                options = options || {};
                options.include = keys;
                return this.fetch(options);
            }
        },
        {
            key: "saveEventually",
            value: function() {
                var _saveEventually = (0, $1f820d57da405774$var$_asyncToGenerator2.default)(/*#__PURE__*/ $1f820d57da405774$var$_regeneratorRuntime().mark(function _callee2(options) {
                    return $1f820d57da405774$var$_regeneratorRuntime().wrap(function _callee2$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.prev = 0;
                                _context4.next = 3;
                                return this.save(null, options);
                            case 3:
                                _context4.next = 11;
                                break;
                            case 5:
                                _context4.prev = 5;
                                _context4.t0 = _context4["catch"](0);
                                if (!(_context4.t0.message === 'XMLHttpRequest failed: "Unable to connect to the Parse API"')) {
                                    _context4.next = 11;
                                    break;
                                }
                                _context4.next = 10;
                                return $1f820d57da405774$var$_EventuallyQueue.default.save(this, options);
                            case 10:
                                $1f820d57da405774$var$_EventuallyQueue.default.poll();
                            case 11:
                                return _context4.abrupt("return", this);
                            case 12:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee2, this, [
                        [
                            0,
                            5
                        ]
                    ]);
                }));
                function saveEventually(_x2) {
                    return _saveEventually.apply(this, arguments);
                }
                return saveEventually;
            }()
        },
        {
            key: "save",
            value: function save(arg1, arg2, arg3) /*: Promise*/ {
                var _this = this;
                var attrs;
                var options;
                if ((0, $1f820d57da405774$var$_typeof2.default)(arg1) === "object" || typeof arg1 === "undefined") {
                    attrs = arg1;
                    if ((0, $1f820d57da405774$var$_typeof2.default)(arg2) === "object") options = arg2;
                } else {
                    attrs = {};
                    attrs[arg1] = arg2;
                    options = arg3;
                }
                if (attrs) {
                    var validation = this.validate(attrs);
                    if (validation) return $1f820d57da405774$var$_promise.default.reject(validation);
                    this.set(attrs, options);
                }
                options = options || {};
                var saveOptions = {};
                if (options.hasOwnProperty("useMasterKey")) saveOptions.useMasterKey = !!options.useMasterKey;
                if (options.hasOwnProperty("sessionToken") && typeof options.sessionToken === "string") saveOptions.sessionToken = options.sessionToken;
                if (options.hasOwnProperty("installationId") && typeof options.installationId === "string") saveOptions.installationId = options.installationId;
                if (options.hasOwnProperty("context") && (0, $1f820d57da405774$var$_typeof2.default)(options.context) === "object") saveOptions.context = options.context;
                var controller = $1f820d57da405774$var$_CoreManager.default.getObjectController();
                var unsaved = options.cascadeSave !== false ? (0, $1f820d57da405774$var$_unsavedChildren.default)(this) : null;
                return controller.save(unsaved, saveOptions).then(function() {
                    return controller.save(_this, saveOptions);
                });
            }
        },
        {
            key: "destroyEventually",
            value: function() {
                var _destroyEventually = (0, $1f820d57da405774$var$_asyncToGenerator2.default)(/*#__PURE__*/ $1f820d57da405774$var$_regeneratorRuntime().mark(function _callee3(options) {
                    return $1f820d57da405774$var$_regeneratorRuntime().wrap(function _callee3$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                _context5.prev = 0;
                                _context5.next = 3;
                                return this.destroy(options);
                            case 3:
                                _context5.next = 11;
                                break;
                            case 5:
                                _context5.prev = 5;
                                _context5.t0 = _context5["catch"](0);
                                if (!(_context5.t0.message === 'XMLHttpRequest failed: "Unable to connect to the Parse API"')) {
                                    _context5.next = 11;
                                    break;
                                }
                                _context5.next = 10;
                                return $1f820d57da405774$var$_EventuallyQueue.default.destroy(this, options);
                            case 10:
                                $1f820d57da405774$var$_EventuallyQueue.default.poll();
                            case 11:
                                return _context5.abrupt("return", this);
                            case 12:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee3, this, [
                        [
                            0,
                            5
                        ]
                    ]);
                }));
                function destroyEventually(_x3) {
                    return _destroyEventually.apply(this, arguments);
                }
                return destroyEventually;
            }()
        },
        {
            key: "destroy",
            value: function destroy(options) /*: Promise*/ {
                options = options || {};
                var destroyOptions = {};
                if (options.hasOwnProperty("useMasterKey")) destroyOptions.useMasterKey = options.useMasterKey;
                if (options.hasOwnProperty("sessionToken")) destroyOptions.sessionToken = options.sessionToken;
                if (options.hasOwnProperty("context") && (0, $1f820d57da405774$var$_typeof2.default)(options.context) === "object") destroyOptions.context = options.context;
                if (!this.id) return $1f820d57da405774$var$_promise.default.resolve();
                return $1f820d57da405774$var$_CoreManager.default.getObjectController().destroy(this, destroyOptions);
            }
        },
        {
            key: "pin",
            value: function pin() /*: Promise<void>*/ {
                return ParseObject.pinAllWithName($7Icwu.DEFAULT_PIN, [
                    this
                ]);
            }
        },
        {
            key: "unPin",
            value: function unPin() /*: Promise<void>*/ {
                return ParseObject.unPinAllWithName($7Icwu.DEFAULT_PIN, [
                    this
                ]);
            }
        },
        {
            key: "isPinned",
            value: function() {
                var _isPinned = (0, $1f820d57da405774$var$_asyncToGenerator2.default)(/*#__PURE__*/ $1f820d57da405774$var$_regeneratorRuntime().mark(function _callee4() {
                    var localDatastore, objectKey, pin;
                    return $1f820d57da405774$var$_regeneratorRuntime().wrap(function _callee4$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                localDatastore = $1f820d57da405774$var$_CoreManager.default.getLocalDatastore();
                                if (localDatastore.isEnabled) {
                                    _context6.next = 3;
                                    break;
                                }
                                return _context6.abrupt("return", $1f820d57da405774$var$_promise.default.reject("Parse.enableLocalDatastore() must be called first"));
                            case 3:
                                objectKey = localDatastore.getKeyForObject(this);
                                _context6.next = 6;
                                return localDatastore.fromPinWithName(objectKey);
                            case 6:
                                pin = _context6.sent;
                                return _context6.abrupt("return", pin.length > 0);
                            case 8:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee4, this);
                }));
                function isPinned() {
                    return _isPinned.apply(this, arguments);
                }
                return isPinned;
            }()
        },
        {
            key: "pinWithName",
            value: function pinWithName(name) /*: Promise<void>*/ {
                return ParseObject.pinAllWithName(name, [
                    this
                ]);
            }
        },
        {
            key: "unPinWithName",
            value: function unPinWithName(name) /*: Promise<void>*/ {
                return ParseObject.unPinAllWithName(name, [
                    this
                ]);
            }
        },
        {
            key: "fetchFromLocalDatastore",
            value: function() {
                var _fetchFromLocalDatastore = (0, $1f820d57da405774$var$_asyncToGenerator2.default)(/*#__PURE__*/ $1f820d57da405774$var$_regeneratorRuntime().mark(function _callee5() {
                    var localDatastore, objectKey, pinned, result;
                    return $1f820d57da405774$var$_regeneratorRuntime().wrap(function _callee5$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                localDatastore = $1f820d57da405774$var$_CoreManager.default.getLocalDatastore();
                                if (localDatastore.isEnabled) {
                                    _context7.next = 3;
                                    break;
                                }
                                throw new Error("Parse.enableLocalDatastore() must be called first");
                            case 3:
                                objectKey = localDatastore.getKeyForObject(this);
                                _context7.next = 6;
                                return localDatastore._serializeObject(objectKey);
                            case 6:
                                pinned = _context7.sent;
                                if (pinned) {
                                    _context7.next = 9;
                                    break;
                                }
                                throw new Error("Cannot fetch an unsaved ParseObject");
                            case 9:
                                result = ParseObject.fromJSON(pinned);
                                this._finishFetch(result.toJSON());
                                return _context7.abrupt("return", this);
                            case 12:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchFromLocalDatastore() {
                    return _fetchFromLocalDatastore.apply(this, arguments);
                }
                return fetchFromLocalDatastore;
            }()
        }
    ], [
        {
            key: "_getClassMap",
            value: function _getClassMap() {
                return $1f820d57da405774$var$classMap;
            }
        },
        {
            key: "_clearAllState",
            value: function _clearAllState() {
                var stateController = $1f820d57da405774$var$_CoreManager.default.getObjectStateController();
                stateController.clearAllState();
            }
        },
        {
            key: "fetchAll",
            value: function fetchAll(list) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var queryOptions = {};
                if (options.hasOwnProperty("useMasterKey")) queryOptions.useMasterKey = options.useMasterKey;
                if (options.hasOwnProperty("sessionToken")) queryOptions.sessionToken = options.sessionToken;
                if (options.hasOwnProperty("include")) queryOptions.include = ParseObject.handleIncludeOptions(options);
                return $1f820d57da405774$var$_CoreManager.default.getObjectController().fetch(list, true, queryOptions);
            }
        },
        {
            key: "fetchAllWithInclude",
            value: function fetchAllWithInclude(list, keys, options) {
                options = options || {};
                options.include = keys;
                return ParseObject.fetchAll(list, options);
            }
        },
        {
            key: "fetchAllIfNeededWithInclude",
            value: function fetchAllIfNeededWithInclude(list, keys, options) {
                options = options || {};
                options.include = keys;
                return ParseObject.fetchAllIfNeeded(list, options);
            }
        },
        {
            key: "fetchAllIfNeeded",
            value: function fetchAllIfNeeded(list, options) {
                options = options || {};
                var queryOptions = {};
                if (options.hasOwnProperty("useMasterKey")) queryOptions.useMasterKey = options.useMasterKey;
                if (options.hasOwnProperty("sessionToken")) queryOptions.sessionToken = options.sessionToken;
                if (options.hasOwnProperty("include")) queryOptions.include = ParseObject.handleIncludeOptions(options);
                return $1f820d57da405774$var$_CoreManager.default.getObjectController().fetch(list, false, queryOptions);
            }
        },
        {
            key: "handleIncludeOptions",
            value: function handleIncludeOptions(options) {
                var include = [];
                if ((0, $1f820d57da405774$var$_isArray.default)(options.include)) {
                    var _context8;
                    (0, $1f820d57da405774$var$_forEach.default)(_context8 = options.include).call(_context8, function(key) {
                        if ((0, $1f820d57da405774$var$_isArray.default)(key)) include = (0, $1f820d57da405774$var$_concat.default)(include).call(include, key);
                        else include.push(key);
                    });
                } else include.push(options.include);
                return include;
            }
        },
        {
            key: "destroyAll",
            value: function destroyAll(list) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var destroyOptions = {};
                if (options.hasOwnProperty("useMasterKey")) destroyOptions.useMasterKey = options.useMasterKey;
                if (options.hasOwnProperty("sessionToken")) destroyOptions.sessionToken = options.sessionToken;
                if (options.hasOwnProperty("batchSize") && typeof options.batchSize === "number") destroyOptions.batchSize = options.batchSize;
                if (options.hasOwnProperty("context") && (0, $1f820d57da405774$var$_typeof2.default)(options.context) === "object") destroyOptions.context = options.context;
                return $1f820d57da405774$var$_CoreManager.default.getObjectController().destroy(list, destroyOptions);
            }
        },
        {
            key: "saveAll",
            value: function saveAll(list) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var saveOptions = {};
                if (options.hasOwnProperty("useMasterKey")) saveOptions.useMasterKey = options.useMasterKey;
                if (options.hasOwnProperty("sessionToken")) saveOptions.sessionToken = options.sessionToken;
                if (options.hasOwnProperty("batchSize") && typeof options.batchSize === "number") saveOptions.batchSize = options.batchSize;
                if (options.hasOwnProperty("context") && (0, $1f820d57da405774$var$_typeof2.default)(options.context) === "object") saveOptions.context = options.context;
                return $1f820d57da405774$var$_CoreManager.default.getObjectController().save(list, saveOptions);
            }
        },
        {
            key: "createWithoutData",
            value: function createWithoutData(id) {
                var obj = new this();
                obj.id = id;
                return obj;
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json, override, dirty) {
                if (!json.className) throw new Error("Cannot create an object without a className");
                var constructor = $1f820d57da405774$var$classMap[json.className];
                var o = constructor ? new constructor(json.className) : new ParseObject(json.className);
                var otherAttributes = {};
                for(var _attr12 in json)if (_attr12 !== "className" && _attr12 !== "__type") {
                    otherAttributes[_attr12] = json[_attr12];
                    if (dirty) o.set(_attr12, json[_attr12]);
                }
                if (override) {
                    // id needs to be set before clearServerData can work
                    if (otherAttributes.objectId) o.id = otherAttributes.objectId;
                    var preserved = null;
                    if (typeof o._preserveFieldsOnFetch === "function") preserved = o._preserveFieldsOnFetch();
                    o._clearServerData();
                    if (preserved) o._finishFetch(preserved);
                }
                o._finishFetch(otherAttributes);
                if (json.objectId) o._setExisted(true);
                return o;
            }
        },
        {
            key: "registerSubclass",
            value: function registerSubclass(className, constructor) {
                if (typeof className !== "string") throw new TypeError("The first argument must be a valid class name.");
                if (typeof constructor === "undefined") throw new TypeError("You must supply a subclass constructor.");
                if (typeof constructor !== "function") throw new TypeError("You must register the subclass constructor. Did you attempt to register an instance of the subclass?");
                $1f820d57da405774$var$classMap[className] = constructor;
                if (!constructor.className) constructor.className = className;
            }
        },
        {
            key: "unregisterSubclass",
            value: function unregisterSubclass(className) {
                if (typeof className !== "string") throw new TypeError("The first argument must be a valid class name.");
                delete $1f820d57da405774$var$classMap[className];
            }
        },
        {
            key: "extend",
            value: function extend(className, protoProps, classProps) {
                if (typeof className !== "string") {
                    if (className && typeof className.className === "string") return ParseObject.extend(className.className, className, protoProps);
                    else throw new Error("Parse.Object.extend's first argument should be the className.");
                }
                var adjustedClassName = className;
                if (adjustedClassName === "User" && $1f820d57da405774$var$_CoreManager.default.get("PERFORM_USER_REWRITE")) adjustedClassName = "_User";
                var parentProto = ParseObject.prototype;
                if (this.hasOwnProperty("__super__") && this.__super__) parentProto = this.prototype;
                else if ($1f820d57da405774$var$classMap[adjustedClassName]) parentProto = $1f820d57da405774$var$classMap[adjustedClassName].prototype;
                var ParseObjectSubclass = function ParseObjectSubclass(attributes, options) {
                    this.className = adjustedClassName;
                    this._objCount = $1f820d57da405774$var$objectCount++; // Enable legacy initializers
                    if (typeof this.initialize === "function") this.initialize.apply(this, arguments);
                    if (attributes && (0, $1f820d57da405774$var$_typeof2.default)(attributes) === "object") {
                        if (!this.set(attributes || {}, options)) throw new Error("Can't create an invalid Parse Object");
                    }
                };
                ParseObjectSubclass.className = adjustedClassName;
                ParseObjectSubclass.__super__ = parentProto;
                ParseObjectSubclass.prototype = (0, $1f820d57da405774$var$_create.default)(parentProto, {
                    constructor: {
                        value: ParseObjectSubclass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (protoProps) {
                    for(var prop in protoProps)if (prop !== "className") (0, $1f820d57da405774$var$_defineProperty2.default)(ParseObjectSubclass.prototype, prop, {
                        value: protoProps[prop],
                        enumerable: false,
                        writable: true,
                        configurable: true
                    });
                }
                if (classProps) {
                    for(var _prop in classProps)if (_prop !== "className") (0, $1f820d57da405774$var$_defineProperty2.default)(ParseObjectSubclass, _prop, {
                        value: classProps[_prop],
                        enumerable: false,
                        writable: true,
                        configurable: true
                    });
                }
                ParseObjectSubclass.extend = function(name, protoProps, classProps) {
                    if (typeof name === "string") return ParseObject.extend.call(ParseObjectSubclass, name, protoProps, classProps);
                    return ParseObject.extend.call(ParseObjectSubclass, adjustedClassName, name, protoProps);
                };
                ParseObjectSubclass.createWithoutData = ParseObject.createWithoutData;
                $1f820d57da405774$var$classMap[adjustedClassName] = ParseObjectSubclass;
                return ParseObjectSubclass;
            }
        },
        {
            key: "enableSingleInstance",
            value: function enableSingleInstance() {
                $1f820d57da405774$var$singleInstance = true;
                $1f820d57da405774$var$_CoreManager.default.setObjectStateController($1f820d57da405774$var$SingleInstanceStateController);
            }
        },
        {
            key: "disableSingleInstance",
            value: function disableSingleInstance() {
                $1f820d57da405774$var$singleInstance = false;
                $1f820d57da405774$var$_CoreManager.default.setObjectStateController($1f820d57da405774$var$UniqueInstanceStateController);
            }
        },
        {
            key: "pinAll",
            value: function pinAll(objects) /*: Promise<void>*/ {
                var localDatastore = $1f820d57da405774$var$_CoreManager.default.getLocalDatastore();
                if (!localDatastore.isEnabled) return $1f820d57da405774$var$_promise.default.reject("Parse.enableLocalDatastore() must be called first");
                return ParseObject.pinAllWithName($7Icwu.DEFAULT_PIN, objects);
            }
        },
        {
            key: "pinAllWithName",
            value: function pinAllWithName(name, objects) /*: Promise<void>*/ {
                var localDatastore = $1f820d57da405774$var$_CoreManager.default.getLocalDatastore();
                if (!localDatastore.isEnabled) return $1f820d57da405774$var$_promise.default.reject("Parse.enableLocalDatastore() must be called first");
                return localDatastore._handlePinAllWithName(name, objects);
            }
        },
        {
            key: "unPinAll",
            value: function unPinAll(objects) /*: Promise<void>*/ {
                var localDatastore = $1f820d57da405774$var$_CoreManager.default.getLocalDatastore();
                if (!localDatastore.isEnabled) return $1f820d57da405774$var$_promise.default.reject("Parse.enableLocalDatastore() must be called first");
                return ParseObject.unPinAllWithName($7Icwu.DEFAULT_PIN, objects);
            }
        },
        {
            key: "unPinAllWithName",
            value: function unPinAllWithName(name, objects) /*: Promise<void>*/ {
                var localDatastore = $1f820d57da405774$var$_CoreManager.default.getLocalDatastore();
                if (!localDatastore.isEnabled) return $1f820d57da405774$var$_promise.default.reject("Parse.enableLocalDatastore() must be called first");
                return localDatastore._handleUnPinAllWithName(name, objects);
            }
        },
        {
            key: "unPinAllObjects",
            value: function unPinAllObjects() /*: Promise<void>*/ {
                var localDatastore = $1f820d57da405774$var$_CoreManager.default.getLocalDatastore();
                if (!localDatastore.isEnabled) return $1f820d57da405774$var$_promise.default.reject("Parse.enableLocalDatastore() must be called first");
                return localDatastore.unPinWithName($7Icwu.DEFAULT_PIN);
            }
        },
        {
            key: "unPinAllObjectsWithName",
            value: function unPinAllObjectsWithName(name) /*: Promise<void>*/ {
                var localDatastore = $1f820d57da405774$var$_CoreManager.default.getLocalDatastore();
                if (!localDatastore.isEnabled) return $1f820d57da405774$var$_promise.default.reject("Parse.enableLocalDatastore() must be called first");
                return localDatastore.unPinWithName($7Icwu.PIN_PREFIX + name);
            }
        }
    ]);
    return ParseObject;
}();
var $1f820d57da405774$var$DefaultController = {
    fetch: function fetch(target, forceFetch, options) /*: Promise<Array<void> | ParseObject>*/ {
        var localDatastore = $1f820d57da405774$var$_CoreManager.default.getLocalDatastore();
        if ((0, $1f820d57da405774$var$_isArray.default)(target)) {
            if (target.length < 1) return $1f820d57da405774$var$_promise.default.resolve([]);
            var objs = [];
            var ids = [];
            var className = null;
            var results = [];
            var error = null;
            (0, $1f820d57da405774$var$_forEach.default)(target).call(target, function(el) {
                if (error) return;
                if (!className) className = el.className;
                if (className !== el.className) error = new $1f820d57da405774$var$_ParseError.default($1f820d57da405774$var$_ParseError.default.INVALID_CLASS_NAME, "All objects should be of the same class");
                if (!el.id) error = new $1f820d57da405774$var$_ParseError.default($1f820d57da405774$var$_ParseError.default.MISSING_OBJECT_ID, "All objects must have an ID");
                if (forceFetch || !el.isDataAvailable()) {
                    ids.push(el.id);
                    objs.push(el);
                }
                results.push(el);
            });
            if (error) return $1f820d57da405774$var$_promise.default.reject(error);
            var query = new $1f820d57da405774$var$_ParseQuery.default(className);
            query.containedIn("objectId", ids);
            if (options && options.include) query.include(options.include);
            query._limit = ids.length;
            return (0, $1f820d57da405774$var$_find.default)(query).call(query, options).then(/*#__PURE__*/ function() {
                var _ref = (0, $1f820d57da405774$var$_asyncToGenerator2.default)(/*#__PURE__*/ $1f820d57da405774$var$_regeneratorRuntime().mark(function _callee6(objects) {
                    var idMap, i, obj, _i, _obj, id, _iterator2, _step2, object;
                    return $1f820d57da405774$var$_regeneratorRuntime().wrap(function _callee6$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                idMap = {};
                                (0, $1f820d57da405774$var$_forEach.default)(objects).call(objects, function(o) {
                                    idMap[o.id] = o;
                                });
                                i = 0;
                            case 3:
                                if (!(i < objs.length)) {
                                    _context9.next = 11;
                                    break;
                                }
                                obj = objs[i];
                                if (!(!obj || !obj.id || !idMap[obj.id])) {
                                    _context9.next = 8;
                                    break;
                                }
                                if (!forceFetch) {
                                    _context9.next = 8;
                                    break;
                                }
                                return _context9.abrupt("return", $1f820d57da405774$var$_promise.default.reject(new $1f820d57da405774$var$_ParseError.default($1f820d57da405774$var$_ParseError.default.OBJECT_NOT_FOUND, "All objects must exist on the server.")));
                            case 8:
                                i++;
                                _context9.next = 3;
                                break;
                            case 11:
                                if (!$1f820d57da405774$var$singleInstance) // If single instance objects are disabled, we need to replace the
                                for(_i = 0; _i < results.length; _i++){
                                    _obj = results[_i];
                                    if (_obj && _obj.id && idMap[_obj.id]) {
                                        id = _obj.id;
                                        _obj._finishFetch(idMap[id].toJSON());
                                        results[_i] = idMap[id];
                                    }
                                }
                                _iterator2 = $1f820d57da405774$var$_createForOfIteratorHelper(results);
                                _context9.prev = 13;
                                _iterator2.s();
                            case 15:
                                if ((_step2 = _iterator2.n()).done) {
                                    _context9.next = 21;
                                    break;
                                }
                                object = _step2.value;
                                _context9.next = 19;
                                return localDatastore._updateObjectIfPinned(object);
                            case 19:
                                _context9.next = 15;
                                break;
                            case 21:
                                _context9.next = 26;
                                break;
                            case 23:
                                _context9.prev = 23;
                                _context9.t0 = _context9["catch"](13);
                                _iterator2.e(_context9.t0);
                            case 26:
                                _context9.prev = 26;
                                _iterator2.f();
                                return _context9.finish(26);
                            case 29:
                                return _context9.abrupt("return", $1f820d57da405774$var$_promise.default.resolve(results));
                            case 30:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee6, null, [
                        [
                            13,
                            23,
                            26,
                            29
                        ]
                    ]);
                }));
                return function(_x4) {
                    return _ref.apply(this, arguments);
                };
            }());
        } else if (target instanceof $1f820d57da405774$var$ParseObject) {
            if (!target.id) return $1f820d57da405774$var$_promise.default.reject(new $1f820d57da405774$var$_ParseError.default($1f820d57da405774$var$_ParseError.default.MISSING_OBJECT_ID, "Object does not have an ID"));
            var RESTController = $1f820d57da405774$var$_CoreManager.default.getRESTController();
            var params = {};
            if (options && options.include) params.include = options.include.join();
            return RESTController.request("GET", "classes/" + target.className + "/" + target._getId(), params, options).then(/*#__PURE__*/ function() {
                var _ref2 = (0, $1f820d57da405774$var$_asyncToGenerator2.default)(/*#__PURE__*/ $1f820d57da405774$var$_regeneratorRuntime().mark(function _callee7(response) {
                    return $1f820d57da405774$var$_regeneratorRuntime().wrap(function _callee7$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                target._clearPendingOps();
                                target._clearServerData();
                                target._finishFetch(response);
                                _context10.next = 5;
                                return localDatastore._updateObjectIfPinned(target);
                            case 5:
                                return _context10.abrupt("return", target);
                            case 6:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee7);
                }));
                return function(_x5) {
                    return _ref2.apply(this, arguments);
                };
            }());
        }
        return $1f820d57da405774$var$_promise.default.resolve();
    },
    destroy: function destroy(target, options) /*: Promise<Array<void> | ParseObject>*/ {
        return (0, $1f820d57da405774$var$_asyncToGenerator2.default)(/*#__PURE__*/ $1f820d57da405774$var$_regeneratorRuntime().mark(function _callee10() {
            var batchSize, localDatastore, RESTController, batches, deleteCompleted, errors;
            return $1f820d57da405774$var$_regeneratorRuntime().wrap(function _callee10$(_context13) {
                while(true)switch(_context13.prev = _context13.next){
                    case 0:
                        batchSize = options && options.batchSize ? options.batchSize : $1f820d57da405774$var$_CoreManager.default.get("REQUEST_BATCH_SIZE");
                        localDatastore = $1f820d57da405774$var$_CoreManager.default.getLocalDatastore();
                        RESTController = $1f820d57da405774$var$_CoreManager.default.getRESTController();
                        if (!(0, $1f820d57da405774$var$_isArray.default)(target)) {
                            _context13.next = 15;
                            break;
                        }
                        if (!(target.length < 1)) {
                            _context13.next = 6;
                            break;
                        }
                        return _context13.abrupt("return", $1f820d57da405774$var$_promise.default.resolve([]));
                    case 6:
                        batches = [
                            []
                        ];
                        (0, $1f820d57da405774$var$_forEach.default)(target).call(target, function(obj) {
                            if (!obj.id) return;
                            batches[batches.length - 1].push(obj);
                            if (batches[batches.length - 1].length >= batchSize) batches.push([]);
                        });
                        if (batches[batches.length - 1].length === 0) // If the last batch is empty, remove it
                        batches.pop();
                        deleteCompleted = $1f820d57da405774$var$_promise.default.resolve();
                        errors = [];
                        (0, $1f820d57da405774$var$_forEach.default)(batches).call(batches, function(batch) {
                            deleteCompleted = deleteCompleted.then(function() {
                                return RESTController.request("POST", "batch", {
                                    requests: (0, $1f820d57da405774$var$_map.default)(batch).call(batch, function(obj) {
                                        return {
                                            method: "DELETE",
                                            path: $1f820d57da405774$var$getServerUrlPath() + "classes/" + obj.className + "/" + obj._getId(),
                                            body: {}
                                        };
                                    })
                                }, options).then(function(results) {
                                    for(var i = 0; i < results.length; i++)if (results[i] && results[i].hasOwnProperty("error")) {
                                        var err = new $1f820d57da405774$var$_ParseError.default(results[i].error.code, results[i].error.error);
                                        err.object = batch[i];
                                        errors.push(err);
                                    }
                                });
                            });
                        });
                        return _context13.abrupt("return", deleteCompleted.then(/*#__PURE__*/ (0, $1f820d57da405774$var$_asyncToGenerator2.default)(/*#__PURE__*/ $1f820d57da405774$var$_regeneratorRuntime().mark(function _callee8() {
                            var aggregate, _iterator3, _step3, object;
                            return $1f820d57da405774$var$_regeneratorRuntime().wrap(function _callee8$(_context11) {
                                while(true)switch(_context11.prev = _context11.next){
                                    case 0:
                                        if (!errors.length) {
                                            _context11.next = 4;
                                            break;
                                        }
                                        aggregate = new $1f820d57da405774$var$_ParseError.default($1f820d57da405774$var$_ParseError.default.AGGREGATE_ERROR);
                                        aggregate.errors = errors;
                                        return _context11.abrupt("return", $1f820d57da405774$var$_promise.default.reject(aggregate));
                                    case 4:
                                        _iterator3 = $1f820d57da405774$var$_createForOfIteratorHelper(target);
                                        _context11.prev = 5;
                                        _iterator3.s();
                                    case 7:
                                        if ((_step3 = _iterator3.n()).done) {
                                            _context11.next = 13;
                                            break;
                                        }
                                        object = _step3.value;
                                        _context11.next = 11;
                                        return localDatastore._destroyObjectIfPinned(object);
                                    case 11:
                                        _context11.next = 7;
                                        break;
                                    case 13:
                                        _context11.next = 18;
                                        break;
                                    case 15:
                                        _context11.prev = 15;
                                        _context11.t0 = _context11["catch"](5);
                                        _iterator3.e(_context11.t0);
                                    case 18:
                                        _context11.prev = 18;
                                        _iterator3.f();
                                        return _context11.finish(18);
                                    case 21:
                                        return _context11.abrupt("return", $1f820d57da405774$var$_promise.default.resolve(target));
                                    case 22:
                                    case "end":
                                        return _context11.stop();
                                }
                            }, _callee8, null, [
                                [
                                    5,
                                    15,
                                    18,
                                    21
                                ]
                            ]);
                        }))));
                    case 15:
                        if (!(target instanceof $1f820d57da405774$var$ParseObject)) {
                            _context13.next = 17;
                            break;
                        }
                        return _context13.abrupt("return", RESTController.request("DELETE", "classes/" + target.className + "/" + target._getId(), {}, options).then(/*#__PURE__*/ (0, $1f820d57da405774$var$_asyncToGenerator2.default)(/*#__PURE__*/ $1f820d57da405774$var$_regeneratorRuntime().mark(function _callee9() {
                            return $1f820d57da405774$var$_regeneratorRuntime().wrap(function _callee9$(_context12) {
                                while(true)switch(_context12.prev = _context12.next){
                                    case 0:
                                        _context12.next = 2;
                                        return localDatastore._destroyObjectIfPinned(target);
                                    case 2:
                                        return _context12.abrupt("return", $1f820d57da405774$var$_promise.default.resolve(target));
                                    case 3:
                                    case "end":
                                        return _context12.stop();
                                }
                            }, _callee9);
                        }))));
                    case 17:
                        return _context13.abrupt("return", $1f820d57da405774$var$_promise.default.resolve(target));
                    case 18:
                    case "end":
                        return _context13.stop();
                }
            }, _callee10);
        }))();
    },
    save: function save(target, options) {
        var batchSize = options && options.batchSize ? options.batchSize : $1f820d57da405774$var$_CoreManager.default.get("REQUEST_BATCH_SIZE");
        var localDatastore = $1f820d57da405774$var$_CoreManager.default.getLocalDatastore();
        var mapIdForPin = {};
        var RESTController = $1f820d57da405774$var$_CoreManager.default.getRESTController();
        var stateController = $1f820d57da405774$var$_CoreManager.default.getObjectStateController();
        var allowCustomObjectId = $1f820d57da405774$var$_CoreManager.default.get("ALLOW_CUSTOM_OBJECT_ID");
        options = options || {};
        options.returnStatus = options.returnStatus || true;
        if ((0, $1f820d57da405774$var$_isArray.default)(target)) {
            if (target.length < 1) return $1f820d57da405774$var$_promise.default.resolve([]);
            var unsaved = (0, $1f820d57da405774$var$_concat.default)(target).call(target);
            for(var i = 0; i < target.length; i++)if (target[i] instanceof $1f820d57da405774$var$ParseObject) unsaved = (0, $1f820d57da405774$var$_concat.default)(unsaved).call(unsaved, (0, $1f820d57da405774$var$_unsavedChildren.default)(target[i], true));
            unsaved = (0, $1f820d57da405774$var$_unique.default)(unsaved);
            var filesSaved = [];
            var pending = [];
            (0, $1f820d57da405774$var$_forEach.default)(unsaved).call(unsaved, function(el) {
                if (el instanceof $1f820d57da405774$var$_ParseFile.default) filesSaved.push(el.save(options));
                else if (el instanceof $1f820d57da405774$var$ParseObject) pending.push(el);
            });
            return $1f820d57da405774$var$_promise.default.all(filesSaved).then(function() {
                var objectError = null;
                return (0, $j0i6P.continueWhile)(function() {
                    return pending.length > 0;
                }, function() {
                    var batch = [];
                    var nextPending = [];
                    (0, $1f820d57da405774$var$_forEach.default)(pending).call(pending, function(el) {
                        if (allowCustomObjectId && Object.prototype.hasOwnProperty.call(el, "id") && !el.id) throw new $1f820d57da405774$var$_ParseError.default($1f820d57da405774$var$_ParseError.default.MISSING_OBJECT_ID, "objectId must not be empty or null");
                        if (batch.length < batchSize && (0, $1f820d57da405774$var$_canBeSerialized.default)(el)) batch.push(el);
                        else nextPending.push(el);
                    });
                    pending = nextPending;
                    if (batch.length < 1) return $1f820d57da405774$var$_promise.default.reject(new $1f820d57da405774$var$_ParseError.default($1f820d57da405774$var$_ParseError.default.OTHER_CAUSE, "Tried to save a batch with a cycle."));
                     // Queue up tasks for each object in the batch.
                    // When every task is ready, the API request will execute
                    var batchReturned = new $j0i6P.resolvingPromise();
                    var batchReady = [];
                    var batchTasks = [];
                    (0, $1f820d57da405774$var$_forEach.default)(batch).call(batch, function(obj, index) {
                        var ready = new $j0i6P.resolvingPromise();
                        batchReady.push(ready);
                        var task = function task() {
                            ready.resolve();
                            return batchReturned.then(function(responses) {
                                if (responses[index].hasOwnProperty("success")) {
                                    var objectId = responses[index].success.objectId;
                                    var status = responses[index]._status;
                                    delete responses[index]._status;
                                    mapIdForPin[objectId] = obj._localId;
                                    obj._handleSaveResponse(responses[index].success, status);
                                } else {
                                    if (!objectError && responses[index].hasOwnProperty("error")) {
                                        var serverError = responses[index].error;
                                        objectError = new $1f820d57da405774$var$_ParseError.default(serverError.code, serverError.error); // Cancel the rest of the save
                                        pending = [];
                                    }
                                    obj._handleSaveError();
                                }
                            });
                        };
                        stateController.pushPendingState(obj._getStateIdentifier());
                        batchTasks.push(stateController.enqueueTask(obj._getStateIdentifier(), task));
                    });
                    (0, $j0i6P.when)(batchReady).then(function() {
                        // Kick off the batch request
                        return RESTController.request("POST", "batch", {
                            requests: (0, $1f820d57da405774$var$_map.default)(batch).call(batch, function(obj) {
                                var params = obj._getSaveParams();
                                params.path = $1f820d57da405774$var$getServerUrlPath() + params.path;
                                return params;
                            })
                        }, options);
                    }).then(batchReturned.resolve, function(error) {
                        batchReturned.reject(new $1f820d57da405774$var$_ParseError.default($1f820d57da405774$var$_ParseError.default.INCORRECT_TYPE, error.message));
                    });
                    return (0, $j0i6P.when)(batchTasks);
                }).then(/*#__PURE__*/ (0, $1f820d57da405774$var$_asyncToGenerator2.default)(/*#__PURE__*/ $1f820d57da405774$var$_regeneratorRuntime().mark(function _callee11() {
                    var _iterator4, _step4, object;
                    return $1f820d57da405774$var$_regeneratorRuntime().wrap(function _callee11$(_context14) {
                        while(true)switch(_context14.prev = _context14.next){
                            case 0:
                                if (!objectError) {
                                    _context14.next = 2;
                                    break;
                                }
                                return _context14.abrupt("return", $1f820d57da405774$var$_promise.default.reject(objectError));
                            case 2:
                                _iterator4 = $1f820d57da405774$var$_createForOfIteratorHelper(target);
                                _context14.prev = 3;
                                _iterator4.s();
                            case 5:
                                if ((_step4 = _iterator4.n()).done) {
                                    _context14.next = 13;
                                    break;
                                }
                                object = _step4.value;
                                _context14.next = 9;
                                return localDatastore._updateLocalIdForObject(mapIdForPin[object.id], object);
                            case 9:
                                _context14.next = 11;
                                return localDatastore._updateObjectIfPinned(object);
                            case 11:
                                _context14.next = 5;
                                break;
                            case 13:
                                _context14.next = 18;
                                break;
                            case 15:
                                _context14.prev = 15;
                                _context14.t0 = _context14["catch"](3);
                                _iterator4.e(_context14.t0);
                            case 18:
                                _context14.prev = 18;
                                _iterator4.f();
                                return _context14.finish(18);
                            case 21:
                                return _context14.abrupt("return", $1f820d57da405774$var$_promise.default.resolve(target));
                            case 22:
                            case "end":
                                return _context14.stop();
                        }
                    }, _callee11, null, [
                        [
                            3,
                            15,
                            18,
                            21
                        ]
                    ]);
                })));
            });
        } else if (target instanceof $1f820d57da405774$var$ParseObject) {
            if (allowCustomObjectId && Object.prototype.hasOwnProperty.call(target, "id") && !target.id) throw new $1f820d57da405774$var$_ParseError.default($1f820d57da405774$var$_ParseError.default.MISSING_OBJECT_ID, "objectId must not be empty or null");
             // generate _localId in case if cascadeSave=false
            target._getId();
            var localId = target._localId; // copying target lets Flow guarantee the pointer isn't modified elsewhere
            var targetCopy = target;
            var task = function task() {
                var params = targetCopy._getSaveParams();
                return RESTController.request(params.method, params.path, params.body, options).then(function(response) {
                    var status = response._status;
                    delete response._status;
                    targetCopy._handleSaveResponse(response, status);
                }, function(error) {
                    targetCopy._handleSaveError();
                    return $1f820d57da405774$var$_promise.default.reject(error);
                });
            };
            stateController.pushPendingState(target._getStateIdentifier());
            return stateController.enqueueTask(target._getStateIdentifier(), task).then(/*#__PURE__*/ (0, $1f820d57da405774$var$_asyncToGenerator2.default)(/*#__PURE__*/ $1f820d57da405774$var$_regeneratorRuntime().mark(function _callee12() {
                return $1f820d57da405774$var$_regeneratorRuntime().wrap(function _callee12$(_context15) {
                    while(true)switch(_context15.prev = _context15.next){
                        case 0:
                            _context15.next = 2;
                            return localDatastore._updateLocalIdForObject(localId, target);
                        case 2:
                            _context15.next = 4;
                            return localDatastore._updateObjectIfPinned(target);
                        case 4:
                            return _context15.abrupt("return", target);
                        case 5:
                        case "end":
                            return _context15.stop();
                    }
                }, _callee12);
            })), function(error) {
                return $1f820d57da405774$var$_promise.default.reject(error);
            });
        }
        return $1f820d57da405774$var$_promise.default.resolve();
    }
};
$1f820d57da405774$var$_CoreManager.default.setObjectController($1f820d57da405774$var$DefaultController);
var $1f820d57da405774$var$_default = $1f820d57da405774$var$ParseObject;
module.exports.default = $1f820d57da405774$var$_default;

});
parcelRequire.register("liESz", function(module, exports) {

module.exports = (parcelRequire("5dGyx"));

});
parcelRequire.register("5dGyx", function(module, exports) {

module.exports = (parcelRequire("90aFB"));

});
parcelRequire.register("90aFB", function(module, exports) {

var $347m6 = parcelRequire("347m6");
module.exports = $347m6;

});
parcelRequire.register("347m6", function(module, exports) {

var $dtFbU = parcelRequire("dtFbU");
module.exports = $dtFbU;

});
parcelRequire.register("dtFbU", function(module, exports) {

var $icTlf = parcelRequire("icTlf");
parcelRequire("4YdnW");
module.exports = $icTlf;

});
parcelRequire.register("icTlf", function(module, exports) {
parcelRequire("4IarS");
parcelRequire("5cfBr");

var $dZGy8 = parcelRequire("dZGy8");
module.exports = $dZGy8;

});






parcelRequire.register("5hSqA", function(module, exports) {

module.exports = (parcelRequire("1H189"));

});
parcelRequire.register("1H189", function(module, exports) {

var $ezNak = parcelRequire("ezNak");
module.exports = $ezNak;

});
parcelRequire.register("ezNak", function(module, exports) {
parcelRequire("5cfBr");
parcelRequire("54feM");

var $envPC = parcelRequire("envPC");
module.exports = $envPC.Array.from;

});
parcelRequire.register("54feM", function(module, exports) {

var $g2B3u = parcelRequire("g2B3u");

var $kKQ0L = parcelRequire("kKQ0L");

var $atz9r = parcelRequire("atz9r");
var $3b092552df1d495d$var$INCORRECT_ITERATION = !$atz9r(function(iterable) {
    // eslint-disable-next-line es/no-array-from -- required for testing
    Array.from(iterable);
});
// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$g2B3u({
    target: "Array",
    stat: true,
    forced: $3b092552df1d495d$var$INCORRECT_ITERATION
}, {
    from: $kKQ0L
});

});
parcelRequire.register("kKQ0L", function(module, exports) {
"use strict";

var $2B9V4 = parcelRequire("2B9V4");

var $5qecd = parcelRequire("5qecd");

var $bVwvx = parcelRequire("bVwvx");

var $zXurq = parcelRequire("zXurq");

var $hUYot = parcelRequire("hUYot");

var $3BUS6 = parcelRequire("3BUS6");

var $25Yeh = parcelRequire("25Yeh");

var $4mEJZ = parcelRequire("4mEJZ");

var $9AQvs = parcelRequire("9AQvs");

var $dZGy8 = parcelRequire("dZGy8");
var $f1c072ddfb1e929d$var$$Array = Array;
// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */ ) {
    var O = $bVwvx(arrayLike);
    var IS_CONSTRUCTOR = $3BUS6(this);
    var argumentsLength = arguments.length;
    var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    if (mapping) mapfn = $2B9V4(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
    var iteratorMethod = $dZGy8(O);
    var index = 0;
    var length, result, step, iterator, next, value;
    // if the target is not iterable or it's an array with the default iterator - use a simple case
    if (iteratorMethod && !(this === $f1c072ddfb1e929d$var$$Array && $hUYot(iteratorMethod))) {
        iterator = $9AQvs(O, iteratorMethod);
        next = iterator.next;
        result = IS_CONSTRUCTOR ? new this() : [];
        for(; !(step = $5qecd(next, iterator)).done; index++){
            value = mapping ? $zXurq(iterator, mapfn, [
                step.value,
                index
            ], true) : step.value;
            $4mEJZ(result, index, value);
        }
    } else {
        length = $25Yeh(O);
        result = IS_CONSTRUCTOR ? new this(length) : $f1c072ddfb1e929d$var$$Array(length);
        for(; length > index; index++){
            value = mapping ? mapfn(O[index], index) : O[index];
            $4mEJZ(result, index, value);
        }
    }
    result.length = index;
    return result;
};

});
parcelRequire.register("zXurq", function(module, exports) {

var $lalRy = parcelRequire("lalRy");

var $gJ4Z0 = parcelRequire("gJ4Z0");
// call something on iterator step with safe closing on error
module.exports = function(iterator, fn, value, ENTRIES) {
    try {
        return ENTRIES ? fn($lalRy(value)[0], value[1]) : fn(value);
    } catch (error) {
        $gJ4Z0(iterator, "throw", error);
    }
};

});






parcelRequire.register("fG1Ke", function(module, exports) {

module.exports = (parcelRequire("ddhE4"));

});
parcelRequire.register("ddhE4", function(module, exports) {

var $eiDap = parcelRequire("eiDap");
module.exports = $eiDap;

});
parcelRequire.register("eiDap", function(module, exports) {

var $5L8hR = parcelRequire("5L8hR");

var $60ALL = parcelRequire("60ALL");
var $a69120ddee1a9506$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.slice;
    return it === $a69120ddee1a9506$var$ArrayPrototype || $5L8hR($a69120ddee1a9506$var$ArrayPrototype, it) && own === $a69120ddee1a9506$var$ArrayPrototype.slice ? $60ALL : own;
};

});
parcelRequire.register("60ALL", function(module, exports) {
parcelRequire("kVhvL");

var $hESIr = parcelRequire("hESIr");
module.exports = $hESIr("Array").slice;

});
parcelRequire.register("kVhvL", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $6BgtM = parcelRequire("6BgtM");

var $3BUS6 = parcelRequire("3BUS6");

var $atGHr = parcelRequire("atGHr");

var $5LbRx = parcelRequire("5LbRx");

var $25Yeh = parcelRequire("25Yeh");

var $1YJYD = parcelRequire("1YJYD");

var $4mEJZ = parcelRequire("4mEJZ");

var $bpQhg = parcelRequire("bpQhg");

var $jS11O = parcelRequire("jS11O");

var $74qJH = parcelRequire("74qJH");
var $f3b6b6ec3b850e34$var$HAS_SPECIES_SUPPORT = $jS11O("slice");
var $f3b6b6ec3b850e34$var$SPECIES = $bpQhg("species");
var $f3b6b6ec3b850e34$var$$Array = Array;
var $f3b6b6ec3b850e34$var$max = Math.max;
// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$g2B3u({
    target: "Array",
    proto: true,
    forced: !$f3b6b6ec3b850e34$var$HAS_SPECIES_SUPPORT
}, {
    slice: function slice(start, end) {
        var O = $1YJYD(this);
        var length = $25Yeh(O);
        var k = $5LbRx(start, length);
        var fin = $5LbRx(end === undefined ? length : end, length);
        // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
        var Constructor, result, n;
        if ($6BgtM(O)) {
            Constructor = O.constructor;
            // cross-realm fallback
            if ($3BUS6(Constructor) && (Constructor === $f3b6b6ec3b850e34$var$$Array || $6BgtM(Constructor.prototype))) Constructor = undefined;
            else if ($atGHr(Constructor)) {
                Constructor = Constructor[$f3b6b6ec3b850e34$var$SPECIES];
                if (Constructor === null) Constructor = undefined;
            }
            if (Constructor === $f3b6b6ec3b850e34$var$$Array || Constructor === undefined) return $74qJH(O, k, fin);
        }
        result = new (Constructor === undefined ? $f3b6b6ec3b850e34$var$$Array : Constructor)($f3b6b6ec3b850e34$var$max(fin - k, 0));
        for(n = 0; k < fin; k++, n++)if (k in O) $4mEJZ(result, n, O[k]);
        result.length = n;
        return result;
    }
});

});





parcelRequire.register("iY2ec", function(module, exports) {

module.exports = (parcelRequire("kYudv"));

});
parcelRequire.register("kYudv", function(module, exports) {

var $8GUYj = parcelRequire("8GUYj");
module.exports = $8GUYj;

});
parcelRequire.register("8GUYj", function(module, exports) {

var $5L8hR = parcelRequire("5L8hR");

var $9LUMQ = parcelRequire("9LUMQ");
var $653e706646ef1030$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.reverse;
    return it === $653e706646ef1030$var$ArrayPrototype || $5L8hR($653e706646ef1030$var$ArrayPrototype, it) && own === $653e706646ef1030$var$ArrayPrototype.reverse ? $9LUMQ : own;
};

});
parcelRequire.register("9LUMQ", function(module, exports) {
parcelRequire("5FbWe");

var $hESIr = parcelRequire("hESIr");
module.exports = $hESIr("Array").reverse;

});
parcelRequire.register("5FbWe", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $7tcts = parcelRequire("7tcts");

var $6BgtM = parcelRequire("6BgtM");
var $41fa0ac21f87ed8c$var$nativeReverse = $7tcts([].reverse);
var $41fa0ac21f87ed8c$var$test = [
    1,
    2
];
// `Array.prototype.reverse` method
// https://tc39.es/ecma262/#sec-array.prototype.reverse
// fix for Safari 12.0 bug
// https://bugs.webkit.org/show_bug.cgi?id=188794
$g2B3u({
    target: "Array",
    proto: true,
    forced: String($41fa0ac21f87ed8c$var$test) === String($41fa0ac21f87ed8c$var$test.reverse())
}, {
    reverse: function reverse() {
        // eslint-disable-next-line no-self-assign -- dirty hack
        if ($6BgtM(this)) this.length = this.length;
        return $41fa0ac21f87ed8c$var$nativeReverse(this);
    }
});

});





parcelRequire.register("iWJ3a", function(module, exports) {

module.exports = (parcelRequire("gJRBE"));

});

parcelRequire.register("cO2y8", function(module, exports) {

module.exports = (parcelRequire("8UYgl"));

});

parcelRequire.register("dvfqn", function(module, exports) {

module.exports = (parcelRequire("gQqG5"));

});

parcelRequire.register("ebK4m", function(module, exports) {

module.exports = (parcelRequire("02Urn"));

});

parcelRequire.register("8jMtB", function(module, exports) {

module.exports = (parcelRequire("1Mnco"));

});
parcelRequire.register("1Mnco", function(module, exports) {

var $8C6VI = parcelRequire("8C6VI");
module.exports = $8C6VI;

});
parcelRequire.register("8C6VI", function(module, exports) {
parcelRequire("icnIP");

var $envPC = parcelRequire("envPC");
var $64573f7c82d06e48$var$Object = $envPC.Object;
var $64573f7c82d06e48$var$defineProperties = module.exports = function defineProperties(T, D) {
    return $64573f7c82d06e48$var$Object.defineProperties(T, D);
};
if ($64573f7c82d06e48$var$Object.defineProperties.sham) $64573f7c82d06e48$var$defineProperties.sham = true;

});
parcelRequire.register("icnIP", function(module, exports) {

var $g2B3u = parcelRequire("g2B3u");

var $99D40 = parcelRequire("99D40");

var $aYYr7 = parcelRequire("aYYr7");
var $d3fbbfa9eeb9867a$require$defineProperties = $aYYr7.f;
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
$g2B3u({
    target: "Object",
    stat: true,
    forced: Object.defineProperties !== $d3fbbfa9eeb9867a$require$defineProperties,
    sham: !$99D40
}, {
    defineProperties: $d3fbbfa9eeb9867a$require$defineProperties
});

});




parcelRequire.register("1nHJN", function(module, exports) {

module.exports = (parcelRequire("93GKN"));

});
parcelRequire.register("93GKN", function(module, exports) {

var $5rMjP = parcelRequire("5rMjP");
module.exports = $5rMjP;

});
parcelRequire.register("5rMjP", function(module, exports) {
parcelRequire("3eAyJ");

var $envPC = parcelRequire("envPC");
module.exports = $envPC.Object.getOwnPropertyDescriptors;

});
parcelRequire.register("3eAyJ", function(module, exports) {

var $g2B3u = parcelRequire("g2B3u");

var $99D40 = parcelRequire("99D40");

var $56H6d = parcelRequire("56H6d");

var $1YJYD = parcelRequire("1YJYD");

var $6IpKK = parcelRequire("6IpKK");

var $4mEJZ = parcelRequire("4mEJZ");
// `Object.getOwnPropertyDescriptors` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
$g2B3u({
    target: "Object",
    stat: true,
    sham: !$99D40
}, {
    getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
        var O = $1YJYD(object);
        var getOwnPropertyDescriptor = $6IpKK.f;
        var keys = $56H6d(O);
        var result = {};
        var index = 0;
        var key, descriptor;
        while(keys.length > index){
            descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
            if (descriptor !== undefined) $4mEJZ(result, key, descriptor);
        }
        return result;
    }
});

});




parcelRequire.register("kYm0J", function(module, exports) {

module.exports = (parcelRequire("7mVsw"));

});
parcelRequire.register("7mVsw", function(module, exports) {

var $8gVEv = parcelRequire("8gVEv");
module.exports = $8gVEv;

});
parcelRequire.register("8gVEv", function(module, exports) {

var $5L8hR = parcelRequire("5L8hR");

var $1SawH = parcelRequire("1SawH");
var $605c89ea553e528e$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.filter;
    return it === $605c89ea553e528e$var$ArrayPrototype || $5L8hR($605c89ea553e528e$var$ArrayPrototype, it) && own === $605c89ea553e528e$var$ArrayPrototype.filter ? $1SawH : own;
};

});
parcelRequire.register("1SawH", function(module, exports) {
parcelRequire("bUqqn");

var $hESIr = parcelRequire("hESIr");
module.exports = $hESIr("Array").filter;

});
parcelRequire.register("bUqqn", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $lB6H8 = parcelRequire("lB6H8");
var $8ab96c05bf7079a5$require$$filter = $lB6H8.filter;

var $jS11O = parcelRequire("jS11O");
var $8ab96c05bf7079a5$var$HAS_SPECIES_SUPPORT = $jS11O("filter");
// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$g2B3u({
    target: "Array",
    proto: true,
    forced: !$8ab96c05bf7079a5$var$HAS_SPECIES_SUPPORT
}, {
    filter: function filter(callbackfn /* , thisArg */ ) {
        return $8ab96c05bf7079a5$require$$filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});

});





parcelRequire.register("d3A5d", function(module, exports) {

module.exports = (parcelRequire("9SPSI"));

});
parcelRequire.register("9SPSI", function(module, exports) {

var $7xRqT = parcelRequire("7xRqT");
module.exports = $7xRqT;

});
parcelRequire.register("7xRqT", function(module, exports) {
parcelRequire("bolJ5");

var $envPC = parcelRequire("envPC");
module.exports = $envPC.Object.getOwnPropertySymbols;

});



parcelRequire.register("hqsP5", function(module, exports) {

module.exports = (parcelRequire("iZzLn"));

});
parcelRequire.register("iZzLn", function(module, exports) {

var $2Ump9 = parcelRequire("2Ump9");
module.exports = $2Ump9;

});
parcelRequire.register("2Ump9", function(module, exports) {

var $5L8hR = parcelRequire("5L8hR");

var $8Jf32 = parcelRequire("8Jf32");
var $21e230d8c1c7925e$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.map;
    return it === $21e230d8c1c7925e$var$ArrayPrototype || $5L8hR($21e230d8c1c7925e$var$ArrayPrototype, it) && own === $21e230d8c1c7925e$var$ArrayPrototype.map ? $8Jf32 : own;
};

});
parcelRequire.register("8Jf32", function(module, exports) {
parcelRequire("2o1JZ");

var $hESIr = parcelRequire("hESIr");
module.exports = $hESIr("Array").map;

});
parcelRequire.register("2o1JZ", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $lB6H8 = parcelRequire("lB6H8");
var $1bcf2c53168a4438$require$$map = $lB6H8.map;

var $jS11O = parcelRequire("jS11O");
var $1bcf2c53168a4438$var$HAS_SPECIES_SUPPORT = $jS11O("map");
// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$g2B3u({
    target: "Array",
    proto: true,
    forced: !$1bcf2c53168a4438$var$HAS_SPECIES_SUPPORT
}, {
    map: function map(callbackfn /* , thisArg */ ) {
        return $1bcf2c53168a4438$require$$map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});

});





parcelRequire.register("jGOxU", function(module, exports) {

module.exports = (parcelRequire("3ej05"));

});
parcelRequire.register("3ej05", function(module, exports) {

var $3UOMo = parcelRequire("3UOMo");
module.exports = $3UOMo;

});
parcelRequire.register("3UOMo", function(module, exports) {

var $5L8hR = parcelRequire("5L8hR");

var $bbc56 = parcelRequire("bbc56");
var $2d9dfdd74df81e4b$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.find;
    return it === $2d9dfdd74df81e4b$var$ArrayPrototype || $5L8hR($2d9dfdd74df81e4b$var$ArrayPrototype, it) && own === $2d9dfdd74df81e4b$var$ArrayPrototype.find ? $bbc56 : own;
};

});
parcelRequire.register("bbc56", function(module, exports) {
parcelRequire("ezrmb");

var $hESIr = parcelRequire("hESIr");
module.exports = $hESIr("Array").find;

});
parcelRequire.register("ezrmb", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $lB6H8 = parcelRequire("lB6H8");
var $a9b98e0a87693e36$require$$find = $lB6H8.find;

var $7lCJ1 = parcelRequire("7lCJ1");
var $a9b98e0a87693e36$var$FIND = "find";
var $a9b98e0a87693e36$var$SKIPS_HOLES = true;
// Shouldn't skip holes
// eslint-disable-next-line es/no-array-prototype-find -- testing
if ($a9b98e0a87693e36$var$FIND in []) Array(1)[$a9b98e0a87693e36$var$FIND](function() {
    $a9b98e0a87693e36$var$SKIPS_HOLES = false;
});
// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$g2B3u({
    target: "Array",
    proto: true,
    forced: $a9b98e0a87693e36$var$SKIPS_HOLES
}, {
    find: function find(callbackfn /* , that = undefined */ ) {
        return $a9b98e0a87693e36$require$$find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$7lCJ1($a9b98e0a87693e36$var$FIND);

});





parcelRequire.register("iqZS2", function(module, exports) {

var $cK0YL = parcelRequire("cK0YL");
function $d6baa5e9753ef517$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else $cK0YL.resolve(value).then(_next, _throw);
}
function $d6baa5e9753ef517$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new $cK0YL(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $d6baa5e9753ef517$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $d6baa5e9753ef517$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
module.exports = $d6baa5e9753ef517$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("cK0YL", function(module, exports) {

module.exports = (parcelRequire("2lxLS"));

});
parcelRequire.register("2lxLS", function(module, exports) {

module.exports = (parcelRequire("eFxNy"));

});
parcelRequire.register("eFxNy", function(module, exports) {

var $jq9ij = parcelRequire("jq9ij");
parcelRequire("eRsSi");
parcelRequire("cLlRS");
parcelRequire("g0SuT");
parcelRequire("4qZ6c");
parcelRequire("arNgi");
module.exports = $jq9ij;

});
parcelRequire.register("jq9ij", function(module, exports) {

var $dJORH = parcelRequire("dJORH");
module.exports = $dJORH;

});

parcelRequire.register("eRsSi", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $l394u = parcelRequire("l394u");
// `Promise.withResolvers` method
// https://github.com/tc39/proposal-promise-with-resolvers
$g2B3u({
    target: "Promise",
    stat: true,
    forced: true
}, {
    withResolvers: function withResolvers() {
        var promiseCapability = $l394u.f(this);
        return {
            promise: promiseCapability.promise,
            resolve: promiseCapability.resolve,
            reject: promiseCapability.reject
        };
    }
});

});

parcelRequire.register("cLlRS", function(module, exports) {
// TODO: Remove from `core-js@4`
parcelRequire("6LlS9");

});

parcelRequire.register("g0SuT", function(module, exports) {
// TODO: Remove from `core-js@4`
parcelRequire("6pPnA");

});

parcelRequire.register("4qZ6c", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $l394u = parcelRequire("l394u");

var $e3FYA = parcelRequire("e3FYA");
// `Promise.try` method
// https://github.com/tc39/proposal-promise-try
$g2B3u({
    target: "Promise",
    stat: true,
    forced: true
}, {
    "try": function(callbackfn) {
        var promiseCapability = $l394u.f(this);
        var result = $e3FYA(callbackfn);
        (result.error ? promiseCapability.reject : promiseCapability.resolve)(result.value);
        return promiseCapability.promise;
    }
});

});

parcelRequire.register("arNgi", function(module, exports) {
// TODO: Remove from `core-js@4`
parcelRequire("dTGrZ");

});





parcelRequire.register("3mvQI", function(module, exports) {

module.exports = (parcelRequire("kxTwQ"));

});
parcelRequire.register("kxTwQ", function(module, exports) {

var $fkjeJ = parcelRequire("fkjeJ");
module.exports = $fkjeJ;

});
parcelRequire.register("fkjeJ", function(module, exports) {

var $5L8hR = parcelRequire("5L8hR");

var $kBT61 = parcelRequire("kBT61");
var $b287a543a35124a0$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.concat;
    return it === $b287a543a35124a0$var$ArrayPrototype || $5L8hR($b287a543a35124a0$var$ArrayPrototype, it) && own === $b287a543a35124a0$var$ArrayPrototype.concat ? $kBT61 : own;
};

});
parcelRequire.register("kBT61", function(module, exports) {
parcelRequire("iJ6bK");

var $hESIr = parcelRequire("hESIr");
module.exports = $hESIr("Array").concat;

});




parcelRequire.register("aUw0k", function(module, exports) {

module.exports = (parcelRequire("faTas"));

});
parcelRequire.register("faTas", function(module, exports) {

var $cEHke = parcelRequire("cEHke");
module.exports = $cEHke;

});
parcelRequire.register("cEHke", function(module, exports) {

var $5L8hR = parcelRequire("5L8hR");

var $ghNkl = parcelRequire("ghNkl");

var $2hHJz = parcelRequire("2hHJz");
var $936ad3f92a1335e7$var$ArrayPrototype = Array.prototype;
var $936ad3f92a1335e7$var$StringPrototype = String.prototype;
module.exports = function(it) {
    var own = it.includes;
    if (it === $936ad3f92a1335e7$var$ArrayPrototype || $5L8hR($936ad3f92a1335e7$var$ArrayPrototype, it) && own === $936ad3f92a1335e7$var$ArrayPrototype.includes) return $ghNkl;
    if (typeof it == "string" || it === $936ad3f92a1335e7$var$StringPrototype || $5L8hR($936ad3f92a1335e7$var$StringPrototype, it) && own === $936ad3f92a1335e7$var$StringPrototype.includes) return $2hHJz;
    return own;
};

});
parcelRequire.register("ghNkl", function(module, exports) {
parcelRequire("ge3Rg");

var $hESIr = parcelRequire("hESIr");
module.exports = $hESIr("Array").includes;

});
parcelRequire.register("ge3Rg", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $gehei = parcelRequire("gehei");
var $bd00f2481e2ca486$require$$includes = $gehei.includes;

var $avKuJ = parcelRequire("avKuJ");

var $7lCJ1 = parcelRequire("7lCJ1");
// FF99+ bug
var $bd00f2481e2ca486$var$BROKEN_ON_SPARSE = $avKuJ(function() {
    // eslint-disable-next-line es/no-array-prototype-includes -- detection
    return !Array(1).includes();
});
// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$g2B3u({
    target: "Array",
    proto: true,
    forced: $bd00f2481e2ca486$var$BROKEN_ON_SPARSE
}, {
    includes: function includes(el /* , fromIndex = 0 */ ) {
        return $bd00f2481e2ca486$require$$includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$7lCJ1("includes");

});


parcelRequire.register("2hHJz", function(module, exports) {
parcelRequire("4lpx2");

var $hESIr = parcelRequire("hESIr");
module.exports = $hESIr("String").includes;

});
parcelRequire.register("4lpx2", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $7tcts = parcelRequire("7tcts");

var $fqTB3 = parcelRequire("fqTB3");

var $dfvEY = parcelRequire("dfvEY");

var $eG0jW = parcelRequire("eG0jW");

var $8B4KA = parcelRequire("8B4KA");
var $329cedb446c06741$var$stringIndexOf = $7tcts("".indexOf);
// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$g2B3u({
    target: "String",
    proto: true,
    forced: !$8B4KA("includes")
}, {
    includes: function includes(searchString /* , position = 0 */ ) {
        return !!~$329cedb446c06741$var$stringIndexOf($eG0jW($dfvEY(this)), $eG0jW($fqTB3(searchString)), arguments.length > 1 ? arguments[1] : undefined);
    }
});

});
parcelRequire.register("fqTB3", function(module, exports) {

var $6A6TU = parcelRequire("6A6TU");
var $b3c469109d2060ff$var$$TypeError = TypeError;
module.exports = function(it) {
    if ($6A6TU(it)) throw $b3c469109d2060ff$var$$TypeError("The method doesn't accept regular expressions");
    return it;
};

});
parcelRequire.register("6A6TU", function(module, exports) {

var $atGHr = parcelRequire("atGHr");

var $1SBP2 = parcelRequire("1SBP2");

var $bpQhg = parcelRequire("bpQhg");
var $4cab75378792876b$var$MATCH = $bpQhg("match");
// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function(it) {
    var isRegExp;
    return $atGHr(it) && ((isRegExp = it[$4cab75378792876b$var$MATCH]) !== undefined ? !!isRegExp : $1SBP2(it) == "RegExp");
};

});


parcelRequire.register("8B4KA", function(module, exports) {

var $bpQhg = parcelRequire("bpQhg");
var $642576c4548b78e3$var$MATCH = $bpQhg("match");
module.exports = function(METHOD_NAME) {
    var regexp = /./;
    try {
        "/./"[METHOD_NAME](regexp);
    } catch (error1) {
        try {
            regexp[$642576c4548b78e3$var$MATCH] = false;
            return "/./"[METHOD_NAME](regexp);
        } catch (error2) {}
    }
    return false;
};

});






parcelRequire.register("O2sNs", function(module, exports) {

module.exports = (parcelRequire("bQEym"));

});
parcelRequire.register("bQEym", function(module, exports) {

var $3xHfB = parcelRequire("3xHfB");
module.exports = $3xHfB;

});
parcelRequire.register("3xHfB", function(module, exports) {
parcelRequire("3zJKl");

var $envPC = parcelRequire("envPC");

var $9YGjW = parcelRequire("9YGjW");
// eslint-disable-next-line es/no-json -- safe
if (!$envPC.JSON) $envPC.JSON = {
    stringify: JSON.stringify
};
// eslint-disable-next-line no-unused-vars -- required for `.length`
module.exports = function stringify(it, replacer, space) {
    return $9YGjW($envPC.JSON.stringify, null, arguments);
};

});



parcelRequire.register("jv0By", function(module, exports) {

module.exports = (parcelRequire("eoULB"));

});
parcelRequire.register("eoULB", function(module, exports) {

var $aHd9l = parcelRequire("aHd9l");
module.exports = $aHd9l;

});
parcelRequire.register("aHd9l", function(module, exports) {
parcelRequire("2yV1B");

var $envPC = parcelRequire("envPC");
module.exports = $envPC.Object.freeze;

});
parcelRequire.register("2yV1B", function(module, exports) {

var $g2B3u = parcelRequire("g2B3u");

var $6GLAg = parcelRequire("6GLAg");

var $avKuJ = parcelRequire("avKuJ");

var $atGHr = parcelRequire("atGHr");

var $kBX5g = parcelRequire("kBX5g");
var $1ddafdabe5441d5a$require$onFreeze = $kBX5g.onFreeze;
// eslint-disable-next-line es/no-object-freeze -- safe
var $1ddafdabe5441d5a$var$$freeze = Object.freeze;
var $1ddafdabe5441d5a$var$FAILS_ON_PRIMITIVES = $avKuJ(function() {
    $1ddafdabe5441d5a$var$$freeze(1);
});
// `Object.freeze` method
// https://tc39.es/ecma262/#sec-object.freeze
$g2B3u({
    target: "Object",
    stat: true,
    forced: $1ddafdabe5441d5a$var$FAILS_ON_PRIMITIVES,
    sham: !$6GLAg
}, {
    freeze: function freeze(it) {
        return $1ddafdabe5441d5a$var$$freeze && $atGHr(it) ? $1ddafdabe5441d5a$var$$freeze($1ddafdabe5441d5a$require$onFreeze(it)) : it;
    }
});

});




parcelRequire.register("eOZH4", function(module, exports) {

module.exports = (parcelRequire("fDhgc"));

});

parcelRequire.register("465CW", function(module, exports) {

var $6qd2L = parcelRequire("6qd2L");
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $2fbc165cae83bd16$var$_concat = $3Npdz((parcelRequire("3mvQI")));

var $2fbc165cae83bd16$var$_forEach = $3Npdz((parcelRequire("jZGC2")));
/*
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ /*:: import type { AttributeMap, ObjectCache, OpsMap, State } from './ObjectStateMutations';*/ /*:: import type ParseFile from './ParseFile';*/ /*:: import type { FileSource } from './ParseFile';*/ /*:: import type { Op } from './ParseOp';*/ /*:: import type ParseObject from './ParseObject';*/ /*:: import type { QueryJSON } from './ParseQuery';*/ /*:: import type ParseUser from './ParseUser';*/ /*:: import type { AuthData } from './ParseUser';*/ /*:: import type { PushData } from './Push';*/ /*:: import type { RequestOptions, FullOptions } from './RESTController';*/ /*:: type AnalyticsController = {
  track: (name: string, dimensions: { [key: string]: string }) => Promise,
};*/ /*:: type CloudController = {
  run: (name: string, data: mixed, options: RequestOptions) => Promise,
  getJobsData: (options: RequestOptions) => Promise,
  startJob: (name: string, data: mixed, options: RequestOptions) => Promise,
};*/ /*:: type ConfigController = {
  current: () => Promise,
  get: () => Promise,
  save: (attrs: { [key: string]: any }) => Promise,
};*/ /*:: type CryptoController = {
  encrypt: (obj: any, secretKey: string) => string,
  decrypt: (encryptedText: string, secretKey: any) => string,
};*/ /*:: type FileController = {
  saveFile: (name: string, source: FileSource, options: FullOptions) => Promise,
  saveBase64: (name: string, source: FileSource, options: FullOptions) => Promise,
  download: (uri: string) => Promise,
};*/ /*:: type InstallationController = {
  currentInstallationId: () => Promise,
};*/ /*:: type ObjectController = {
  fetch: (
    object: ParseObject | Array<ParseObject>,
    forceFetch: boolean,
    options: RequestOptions
  ) => Promise,
  save: (object: ParseObject | Array<ParseObject | ParseFile>, options: RequestOptions) => Promise,
  destroy: (object: ParseObject | Array<ParseObject>, options: RequestOptions) => Promise,
};*/ /*:: type ObjectStateController = {
  getState: (obj: any) => ?State,
  initializeState: (obj: any, initial?: State) => State,
  removeState: (obj: any) => ?State,
  getServerData: (obj: any) => AttributeMap,
  setServerData: (obj: any, attributes: AttributeMap) => void,
  getPendingOps: (obj: any) => Array<OpsMap>,
  setPendingOp: (obj: any, attr: string, op: ?Op) => void,
  pushPendingState: (obj: any) => void,
  popPendingState: (obj: any) => OpsMap,
  mergeFirstPendingState: (obj: any) => void,
  getObjectCache: (obj: any) => ObjectCache,
  estimateAttribute: (obj: any, attr: string) => mixed,
  estimateAttributes: (obj: any) => AttributeMap,
  commitServerChanges: (obj: any, changes: AttributeMap) => void,
  enqueueTask: (obj: any, task: () => Promise) => Promise,
  clearAllState: () => void,
  duplicateState: (source: any, dest: any) => void,
};*/ /*:: type PushController = {
  send: (data: PushData) => Promise,
};*/ /*:: type QueryController = {
  find: (className: string, params: QueryJSON, options: RequestOptions) => Promise,
  aggregate: (className: string, params: any, options: RequestOptions) => Promise,
};*/ /*:: type RESTController = {
  request: (method: string, path: string, data: mixed, options: RequestOptions) => Promise,
  ajax: (method: string, url: string, data: any, headers?: any, options: FullOptions) => Promise,
};*/ /*:: type SchemaController = {
  purge: (className: string) => Promise,
  get: (className: string, options: RequestOptions) => Promise,
  delete: (className: string, options: RequestOptions) => Promise,
  create: (className: string, params: any, options: RequestOptions) => Promise,
  update: (className: string, params: any, options: RequestOptions) => Promise,
  send(className: string, method: string, params: any, options: RequestOptions): Promise,
};*/ /*:: type SessionController = {
  getSession: (token: RequestOptions) => Promise,
};*/ /*:: type StorageController =
  | {
      async: 0,
      getItem: (path: string) => ?string,
      setItem: (path: string, value: string) => void,
      removeItem: (path: string) => void,
      getItemAsync?: (path: string) => Promise,
      setItemAsync?: (path: string, value: string) => Promise,
      removeItemAsync?: (path: string) => Promise,
      clear: () => void,
    }
  | {
      async: 1,
      getItem?: (path: string) => ?string,
      setItem?: (path: string, value: string) => void,
      removeItem?: (path: string) => void,
      getItemAsync: (path: string) => Promise,
      setItemAsync: (path: string, value: string) => Promise,
      removeItemAsync: (path: string) => Promise,
      clear: () => void,
    };*/ /*:: type LocalDatastoreController = {
  fromPinWithName: (name: string) => ?any,
  pinWithName: (name: string, objects: any) => void,
  unPinWithName: (name: string) => void,
  getAllContents: () => ?any,
  clear: () => void,
};*/ /*:: type UserController = {
  setCurrentUser: (user: ParseUser) => Promise,
  currentUser: () => ?ParseUser,
  currentUserAsync: () => Promise,
  signUp: (user: ParseUser, attrs: AttributeMap, options: RequestOptions) => Promise,
  logIn: (user: ParseUser, options: RequestOptions) => Promise,
  become: (options: RequestOptions) => Promise,
  hydrate: (userJSON: AttributeMap) => Promise,
  logOut: (options: RequestOptions) => Promise,
  me: (options: RequestOptions) => Promise,
  requestPasswordReset: (email: string, options: RequestOptions) => Promise,
  updateUserOnDisk: (user: ParseUser) => Promise,
  upgradeToRevocableSession: (user: ParseUser, options: RequestOptions) => Promise,
  linkWith: (user: ParseUser, authData: AuthData) => Promise,
  removeUserFromDisk: () => Promise,
  verifyPassword: (username: string, password: string, options: RequestOptions) => Promise,
  requestEmailVerification: (email: string, options: RequestOptions) => Promise,
};*/ /*:: type HooksController = {
  get: (type: string, functionName?: string, triggerName?: string) => Promise,
  create: (hook: mixed) => Promise,
  delete: (hook: mixed) => Promise,
  update: (hook: mixed) => Promise,
  send: (method: string, path: string, body?: mixed) => Promise,
};*/ /*:: type WebSocketController = {
  onopen: () => void,
  onmessage: (message: any) => void,
  onclose: () => void,
  onerror: (error: any) => void,
  send: (data: any) => void,
  close: () => void,
};*/ /*:: type Config = {
  AnalyticsController?: AnalyticsController,
  CloudController?: CloudController,
  ConfigController?: ConfigController,
  FileController?: FileController,
  InstallationController?: InstallationController,
  ObjectController?: ObjectController,
  ObjectStateController?: ObjectStateController,
  PushController?: PushController,
  QueryController?: QueryController,
  RESTController?: RESTController,
  SchemaController?: SchemaController,
  SessionController?: SessionController,
  StorageController?: StorageController,
  LocalDatastoreController?: LocalDatastoreController,
  UserController?: UserController,
  HooksController?: HooksController,
  WebSocketController?: WebSocketController,
};*/ var $2fbc165cae83bd16$var$config = {
    // Defaults
    IS_NODE: typeof $6qd2L !== "undefined" && !!$6qd2L.versions && !!$6qd2L.versions.node && !$6qd2L.versions.electron,
    REQUEST_ATTEMPT_LIMIT: 5,
    REQUEST_BATCH_SIZE: 20,
    REQUEST_HEADERS: {},
    SERVER_URL: "https://api.parse.com/1",
    SERVER_AUTH_TYPE: null,
    SERVER_AUTH_TOKEN: null,
    LIVEQUERY_SERVER_URL: null,
    ENCRYPTED_KEY: null,
    VERSION: "js3.5.1",
    APPLICATION_ID: null,
    JAVASCRIPT_KEY: null,
    MASTER_KEY: null,
    USE_MASTER_KEY: false,
    PERFORM_USER_REWRITE: true,
    FORCE_REVOCABLE_SESSION: false,
    ENCRYPTED_USER: false,
    IDEMPOTENCY: false,
    ALLOW_CUSTOM_OBJECT_ID: false
};
function $2fbc165cae83bd16$var$requireMethods(name, methods, controller) {
    (0, $2fbc165cae83bd16$var$_forEach.default)(methods).call(methods, function(func) {
        if (typeof controller[func] !== "function") {
            var _context;
            throw new Error((0, $2fbc165cae83bd16$var$_concat.default)(_context = "".concat(name, " must implement ")).call(_context, func, "()"));
        }
    });
}
module.exports = {
    get: function(key) /*: any*/ {
        if ($2fbc165cae83bd16$var$config.hasOwnProperty(key)) return $2fbc165cae83bd16$var$config[key];
        throw new Error("Configuration key not found: " + key);
    },
    set: function(key, value) /*: void*/ {
        $2fbc165cae83bd16$var$config[key] = value;
    },
    /* Specialized Controller Setters/Getters */ setAnalyticsController: function(controller) {
        $2fbc165cae83bd16$var$requireMethods("AnalyticsController", [
            "track"
        ], controller);
        $2fbc165cae83bd16$var$config["AnalyticsController"] = controller;
    },
    getAnalyticsController: function() /*: AnalyticsController*/ {
        return $2fbc165cae83bd16$var$config["AnalyticsController"];
    },
    setCloudController: function(controller) {
        $2fbc165cae83bd16$var$requireMethods("CloudController", [
            "run",
            "getJobsData",
            "startJob"
        ], controller);
        $2fbc165cae83bd16$var$config["CloudController"] = controller;
    },
    getCloudController: function() /*: CloudController*/ {
        return $2fbc165cae83bd16$var$config["CloudController"];
    },
    setConfigController: function(controller) {
        $2fbc165cae83bd16$var$requireMethods("ConfigController", [
            "current",
            "get",
            "save"
        ], controller);
        $2fbc165cae83bd16$var$config["ConfigController"] = controller;
    },
    getConfigController: function() /*: ConfigController*/ {
        return $2fbc165cae83bd16$var$config["ConfigController"];
    },
    setCryptoController: function(controller) {
        $2fbc165cae83bd16$var$requireMethods("CryptoController", [
            "encrypt",
            "decrypt"
        ], controller);
        $2fbc165cae83bd16$var$config["CryptoController"] = controller;
    },
    getCryptoController: function() /*: CryptoController*/ {
        return $2fbc165cae83bd16$var$config["CryptoController"];
    },
    setFileController: function(controller) {
        $2fbc165cae83bd16$var$requireMethods("FileController", [
            "saveFile",
            "saveBase64"
        ], controller);
        $2fbc165cae83bd16$var$config["FileController"] = controller;
    },
    getFileController: function() /*: FileController*/ {
        return $2fbc165cae83bd16$var$config["FileController"];
    },
    setInstallationController: function(controller) {
        $2fbc165cae83bd16$var$requireMethods("InstallationController", [
            "currentInstallationId"
        ], controller);
        $2fbc165cae83bd16$var$config["InstallationController"] = controller;
    },
    getInstallationController: function() /*: InstallationController*/ {
        return $2fbc165cae83bd16$var$config["InstallationController"];
    },
    setObjectController: function(controller) {
        $2fbc165cae83bd16$var$requireMethods("ObjectController", [
            "save",
            "fetch",
            "destroy"
        ], controller);
        $2fbc165cae83bd16$var$config["ObjectController"] = controller;
    },
    getObjectController: function() /*: ObjectController*/ {
        return $2fbc165cae83bd16$var$config["ObjectController"];
    },
    setObjectStateController: function(controller) {
        $2fbc165cae83bd16$var$requireMethods("ObjectStateController", [
            "getState",
            "initializeState",
            "removeState",
            "getServerData",
            "setServerData",
            "getPendingOps",
            "setPendingOp",
            "pushPendingState",
            "popPendingState",
            "mergeFirstPendingState",
            "getObjectCache",
            "estimateAttribute",
            "estimateAttributes",
            "commitServerChanges",
            "enqueueTask",
            "clearAllState"
        ], controller);
        $2fbc165cae83bd16$var$config["ObjectStateController"] = controller;
    },
    getObjectStateController: function() /*: ObjectStateController*/ {
        return $2fbc165cae83bd16$var$config["ObjectStateController"];
    },
    setPushController: function(controller) {
        $2fbc165cae83bd16$var$requireMethods("PushController", [
            "send"
        ], controller);
        $2fbc165cae83bd16$var$config["PushController"] = controller;
    },
    getPushController: function() /*: PushController*/ {
        return $2fbc165cae83bd16$var$config["PushController"];
    },
    setQueryController: function(controller) {
        $2fbc165cae83bd16$var$requireMethods("QueryController", [
            "find",
            "aggregate"
        ], controller);
        $2fbc165cae83bd16$var$config["QueryController"] = controller;
    },
    getQueryController: function() /*: QueryController*/ {
        return $2fbc165cae83bd16$var$config["QueryController"];
    },
    setRESTController: function(controller) {
        $2fbc165cae83bd16$var$requireMethods("RESTController", [
            "request",
            "ajax"
        ], controller);
        $2fbc165cae83bd16$var$config["RESTController"] = controller;
    },
    getRESTController: function() /*: RESTController*/ {
        return $2fbc165cae83bd16$var$config["RESTController"];
    },
    setSchemaController: function(controller) {
        $2fbc165cae83bd16$var$requireMethods("SchemaController", [
            "get",
            "create",
            "update",
            "delete",
            "send",
            "purge"
        ], controller);
        $2fbc165cae83bd16$var$config["SchemaController"] = controller;
    },
    getSchemaController: function() /*: SchemaController*/ {
        return $2fbc165cae83bd16$var$config["SchemaController"];
    },
    setSessionController: function(controller) {
        $2fbc165cae83bd16$var$requireMethods("SessionController", [
            "getSession"
        ], controller);
        $2fbc165cae83bd16$var$config["SessionController"] = controller;
    },
    getSessionController: function() /*: SessionController*/ {
        return $2fbc165cae83bd16$var$config["SessionController"];
    },
    setStorageController: function(controller) {
        if (controller.async) $2fbc165cae83bd16$var$requireMethods("An async StorageController", [
            "getItemAsync",
            "setItemAsync",
            "removeItemAsync",
            "getAllKeysAsync"
        ], controller);
        else $2fbc165cae83bd16$var$requireMethods("A synchronous StorageController", [
            "getItem",
            "setItem",
            "removeItem",
            "getAllKeys"
        ], controller);
        $2fbc165cae83bd16$var$config["StorageController"] = controller;
    },
    setLocalDatastoreController: function(controller) {
        $2fbc165cae83bd16$var$requireMethods("LocalDatastoreController", [
            "pinWithName",
            "fromPinWithName",
            "unPinWithName",
            "getAllContents",
            "clear"
        ], controller);
        $2fbc165cae83bd16$var$config["LocalDatastoreController"] = controller;
    },
    getLocalDatastoreController: function() /*: LocalDatastoreController*/ {
        return $2fbc165cae83bd16$var$config["LocalDatastoreController"];
    },
    setLocalDatastore: function(store) {
        $2fbc165cae83bd16$var$config["LocalDatastore"] = store;
    },
    getLocalDatastore: function() {
        return $2fbc165cae83bd16$var$config["LocalDatastore"];
    },
    getStorageController: function() /*: StorageController*/ {
        return $2fbc165cae83bd16$var$config["StorageController"];
    },
    setAsyncStorage: function(storage) {
        $2fbc165cae83bd16$var$config["AsyncStorage"] = storage;
    },
    getAsyncStorage: function() {
        return $2fbc165cae83bd16$var$config["AsyncStorage"];
    },
    setWebSocketController: function(controller) {
        $2fbc165cae83bd16$var$config["WebSocketController"] = controller;
    },
    getWebSocketController: function() /*: WebSocketController*/ {
        return $2fbc165cae83bd16$var$config["WebSocketController"];
    },
    setUserController: function(controller) {
        $2fbc165cae83bd16$var$requireMethods("UserController", [
            "setCurrentUser",
            "currentUser",
            "currentUserAsync",
            "signUp",
            "logIn",
            "become",
            "logOut",
            "me",
            "requestPasswordReset",
            "upgradeToRevocableSession",
            "requestEmailVerification",
            "verifyPassword",
            "linkWith"
        ], controller);
        $2fbc165cae83bd16$var$config["UserController"] = controller;
    },
    getUserController: function() /*: UserController*/ {
        return $2fbc165cae83bd16$var$config["UserController"];
    },
    setLiveQueryController: function(controller) {
        $2fbc165cae83bd16$var$requireMethods("LiveQueryController", [
            "setDefaultLiveQueryClient",
            "getDefaultLiveQueryClient",
            "_clearCachedDefaultClient"
        ], controller);
        $2fbc165cae83bd16$var$config["LiveQueryController"] = controller;
    },
    getLiveQueryController: function() /*: any*/ {
        return $2fbc165cae83bd16$var$config["LiveQueryController"];
    },
    setHooksController: function(controller) {
        $2fbc165cae83bd16$var$requireMethods("HooksController", [
            "create",
            "get",
            "update",
            "remove"
        ], controller);
        $2fbc165cae83bd16$var$config["HooksController"] = controller;
    },
    getHooksController: function() /*: HooksController*/ {
        return $2fbc165cae83bd16$var$config["HooksController"];
    }
};

});

parcelRequire.register("eQIfM", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $evY07 = parcelRequire("evY07");
$evY07(module.exports, "__esModule", {
    value: true
});
module.exports.default = $acf83fd9d6c607bb$var$canBeSerialized;

var $acf83fd9d6c607bb$var$_isArray = $3Npdz((parcelRequire("i0kCX")));

var $acf83fd9d6c607bb$var$_typeof2 = $3Npdz((parcelRequire("akViX")));

var $acf83fd9d6c607bb$var$_ParseFile = $3Npdz((parcelRequire("gf3Ge")));

var $acf83fd9d6c607bb$var$_ParseObject = $3Npdz((parcelRequire("2HIpX")));

var $acf83fd9d6c607bb$var$_ParseRelation = $3Npdz((parcelRequire("4Glkc")));
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ function $acf83fd9d6c607bb$var$canBeSerialized(obj) /*: boolean*/ {
    if (!(obj instanceof $acf83fd9d6c607bb$var$_ParseObject.default)) return true;
    var attributes = obj.attributes;
    for(var attr in attributes){
        var val = attributes[attr];
        if (!$acf83fd9d6c607bb$var$canBeSerializedHelper(val)) return false;
    }
    return true;
}
function $acf83fd9d6c607bb$var$canBeSerializedHelper(value) /*: boolean*/ {
    if ((0, $acf83fd9d6c607bb$var$_typeof2.default)(value) !== "object") return true;
    if (value instanceof $acf83fd9d6c607bb$var$_ParseRelation.default) return true;
    if (value instanceof $acf83fd9d6c607bb$var$_ParseObject.default) return !!value.id;
    if (value instanceof $acf83fd9d6c607bb$var$_ParseFile.default) {
        if (value.url()) return true;
        return false;
    }
    if ((0, $acf83fd9d6c607bb$var$_isArray.default)(value)) {
        for(var i = 0; i < value.length; i++){
            if (!$acf83fd9d6c607bb$var$canBeSerializedHelper(value[i])) return false;
        }
        return true;
    }
    for(var k in value){
        if (!$acf83fd9d6c607bb$var$canBeSerializedHelper(value[k])) return false;
    }
    return true;
}

});
parcelRequire.register("gf3Ge", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $8jMtB = parcelRequire("8jMtB");

var $1nHJN = parcelRequire("1nHJN");

var $1o4IC = parcelRequire("1o4IC");

var $kYm0J = parcelRequire("kYm0J");

var $d3A5d = parcelRequire("d3A5d");



var $iY2ec = parcelRequire("iY2ec");


var $iWJ3a = parcelRequire("iWJ3a");



var $cO2y8 = parcelRequire("cO2y8");

var $dvfqn = parcelRequire("dvfqn");

var $evY07 = parcelRequire("evY07");

var $ebK4m = parcelRequire("ebK4m");
$evY07(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bd30e6d93a510522$var$_indexOf = $3Npdz((parcelRequire("eOZH4")));

var $bd30e6d93a510522$var$_slicedToArray2 = $3Npdz((parcelRequire("5kSp4")));

var $bd30e6d93a510522$var$_promise = $3Npdz((parcelRequire("bCWDe")));

var $bd30e6d93a510522$var$_keys = $3Npdz((parcelRequire("r9mpE")));

var $bd30e6d93a510522$var$_forEach = $3Npdz((parcelRequire("jZGC2")));

var $bd30e6d93a510522$var$_typeof2 = $3Npdz((parcelRequire("akViX")));

var $bd30e6d93a510522$var$_asyncToGenerator2 = $3Npdz((parcelRequire("iqZS2")));

var $bd30e6d93a510522$var$_slice = $3Npdz((parcelRequire("fG1Ke")));

var $bd30e6d93a510522$var$_isArray = $3Npdz((parcelRequire("i0kCX")));

var $bd30e6d93a510522$var$_classCallCheck2 = $3Npdz((parcelRequire("9pQKE")));

var $bd30e6d93a510522$var$_createClass2 = $3Npdz((parcelRequire("eZYdV")));

var $bd30e6d93a510522$var$_defineProperty2 = $3Npdz((parcelRequire("bci6G")));

var $bd30e6d93a510522$var$_CoreManager = $3Npdz((parcelRequire("465CW")));
function $bd30e6d93a510522$var$ownKeys(object, enumerableOnly) {
    var keys = (parcelRequire("r9mpE"))(object);
    if ($d3A5d) {
        var symbols = $d3A5d(object);
        enumerableOnly && (symbols = $kYm0J(symbols).call(symbols, function(sym) {
            return $1o4IC(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bd30e6d93a510522$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var _context10, _context11;
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? (parcelRequire("jZGC2"))(_context10 = $bd30e6d93a510522$var$ownKeys(Object(source), !0)).call(_context10, function(key) {
            (0, $bd30e6d93a510522$var$_defineProperty2.default)(target, key, source[key]);
        }) : $1nHJN ? $8jMtB(target, $1nHJN(source)) : (parcelRequire("jZGC2"))(_context11 = $bd30e6d93a510522$var$ownKeys(Object(source))).call(_context11, function(key) {
            $evY07(target, key, $1o4IC(source, key));
        });
    }
    return target;
}
function $bd30e6d93a510522$var$_regeneratorRuntime() {
    "use strict";
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ $bd30e6d93a510522$var$_regeneratorRuntime = function() {
        return exports1;
    };
    var exports1 = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof $ebK4m ? $ebK4m : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return $evY07(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = $dvfqn(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return generator._invoke = function(innerFn, self, context) {
            var state = "suspendedStart";
            return function(method, arg) {
                if ("executing" === state) throw new Error("Generator is already running");
                if ("completed" === state) {
                    if ("throw" === method) throw arg;
                    return doneResult();
                }
                for(context.method = method, context.arg = arg;;){
                    var delegate = context.delegate;
                    if (delegate) {
                        var delegateResult = maybeInvokeDelegate(delegate, context);
                        if (delegateResult) {
                            if (delegateResult === ContinueSentinel) continue;
                            return delegateResult;
                        }
                    }
                    if ("next" === context.method) context.sent = context._sent = context.arg;
                    else if ("throw" === context.method) {
                        if ("suspendedStart" === state) throw state = "completed", context.arg;
                        context.dispatchException(context.arg);
                    } else "return" === context.method && context.abrupt("return", context.arg);
                    state = "executing";
                    var record = tryCatch(innerFn, self, context);
                    if ("normal" === record.type) {
                        if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                        return {
                            value: record.arg,
                            done: context.done
                        };
                    }
                    "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
                }
            };
        }(innerFn, self, context), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports1.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = $cO2y8, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = $dvfqn(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        var _context8;
        (parcelRequire("jZGC2"))(_context8 = [
            "next",
            "throw",
            "return"
        ]).call(_context8, function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == (parcelRequire("akViX"))(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        this._invoke = function(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];
        if (undefined === method) {
            if (context.delegate = null, "throw" === context.method) {
                if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
                context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], (parcelRequire("jZGC2"))(tryLocsList).call(tryLocsList, pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;){
                        if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    }
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports1.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports1.mark = function(genFun) {
        return $iWJ3a ? $iWJ3a(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = $dvfqn(Gp), genFun;
    }, exports1.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports1.AsyncIterator = AsyncIterator, exports1.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = (parcelRequire("bCWDe")));
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports1.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports1.keys = function(object) {
        var keys = [];
        for(var key in object)keys.push(key);
        return $iY2ec(keys).call(keys), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports1.values = values, Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            var _context9;
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, (parcelRequire("jZGC2"))(_context9 = this.tryEntries).call(_context9, resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+(parcelRequire("fG1Ke"))(name).call(name, 1)) && (this[name] = undefined);
        },
        stop: function() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports1;
}

var $3HQSG = parcelRequire("3HQSG");
var $bd30e6d93a510522$require$ParseError = $3HQSG.default;
var $bd30e6d93a510522$var$XHR = null;
if (typeof XMLHttpRequest !== "undefined") $bd30e6d93a510522$var$XHR = XMLHttpRequest;
/*:: type Base64 = { base64: string };*/ /*:: type Uri = { uri: string };*/ /*:: type FileData = Array<number> | Base64 | Blob | Uri;*/ /*:: export type FileSource =
  | {
      format: 'file',
      file: Blob,
      type: string,
    }
  | {
      format: 'base64',
      base64: string,
      type: string,
    }
  | {
      format: 'uri',
      uri: string,
      type: string,
    };*/ function $bd30e6d93a510522$var$b64Digit(number) /*: string*/ {
    if (number < 26) return String.fromCharCode(65 + number);
    if (number < 52) return String.fromCharCode(97 + (number - 26));
    if (number < 62) return String.fromCharCode(48 + (number - 52));
    if (number === 62) return "+";
    if (number === 63) return "/";
    throw new TypeError("Tried to encode large digit " + number + " in base64.");
}
/**
 * A Parse.File is a local representation of a file that is saved to the Parse
 * cloud.
 *
 * @alias Parse.File
 */ var $bd30e6d93a510522$var$ParseFile = /*#__PURE__*/ function() {
    /**
   * @param name {String} The file's name. This will be prefixed by a unique
   *     value once the file has finished saving. The file name must begin with
   *     an alphanumeric character, and consist of alphanumeric characters,
   *     periods, spaces, underscores, or dashes.
   * @param data {Array} The data for the file, as either:
   *     1. an Array of byte value Numbers, or
   *     2. an Object like { base64: "..." } with a base64-encoded String.
   *     3. an Object like { uri: "..." } with a uri String.
   *     4. a File object selected with a file upload control. (3) only works
   *        in Firefox 3.6+, Safari 6.0.2+, Chrome 7+, and IE 10+.
   *        For example:
   * <pre>
   * var fileUploadControl = $("#profilePhotoFileUpload")[0];
   * if (fileUploadControl.files.length > 0) {
   *   var file = fileUploadControl.files[0];
   *   var name = "photo.jpg";
   *   var parseFile = new Parse.File(name, file);
   *   parseFile.save().then(function() {
   *     // The file has been saved to Parse.
   *   }, function(error) {
   *     // The file either could not be read, or could not be saved to Parse.
   *   });
   * }</pre>
   * @param type {String} Optional Content-Type header to use for the file. If
   *     this is omitted, the content type will be inferred from the name's
   *     extension.
   * @param metadata {Object} Optional key value pairs to be stored with file object
   * @param tags {Object} Optional key value pairs to be stored with file object
   */ function ParseFile(name, data, type, metadata, tags) {
        (0, $bd30e6d93a510522$var$_classCallCheck2.default)(this, ParseFile);
        (0, $bd30e6d93a510522$var$_defineProperty2.default)(this, "_name", void 0);
        (0, $bd30e6d93a510522$var$_defineProperty2.default)(this, "_url", void 0);
        (0, $bd30e6d93a510522$var$_defineProperty2.default)(this, "_source", void 0);
        (0, $bd30e6d93a510522$var$_defineProperty2.default)(this, "_previousSave", void 0);
        (0, $bd30e6d93a510522$var$_defineProperty2.default)(this, "_data", void 0);
        (0, $bd30e6d93a510522$var$_defineProperty2.default)(this, "_requestTask", void 0);
        (0, $bd30e6d93a510522$var$_defineProperty2.default)(this, "_metadata", void 0);
        (0, $bd30e6d93a510522$var$_defineProperty2.default)(this, "_tags", void 0);
        var specifiedType = type || "";
        this._name = name;
        this._metadata = metadata || {};
        this._tags = tags || {};
        if (data !== undefined) {
            if ((0, $bd30e6d93a510522$var$_isArray.default)(data)) {
                this._data = ParseFile.encodeBase64(data);
                this._source = {
                    format: "base64",
                    base64: this._data,
                    type: specifiedType
                };
            } else if (typeof Blob !== "undefined" && data instanceof Blob) this._source = {
                format: "file",
                file: data,
                type: specifiedType
            };
            else if (data && typeof data.uri === "string" && data.uri !== undefined) this._source = {
                format: "uri",
                uri: data.uri,
                type: specifiedType
            };
            else if (data && typeof data.base64 === "string") {
                var _context, _context2, _context3;
                var base64 = (0, $bd30e6d93a510522$var$_slice.default)(_context = data.base64.split(",")).call(_context, -1)[0];
                var dataType = specifiedType || (0, $bd30e6d93a510522$var$_slice.default)(_context2 = (0, $bd30e6d93a510522$var$_slice.default)(_context3 = data.base64.split(";")).call(_context3, 0, 1)[0].split(":")).call(_context2, 1, 2)[0] || "text/plain";
                this._data = base64;
                this._source = {
                    format: "base64",
                    base64: base64,
                    type: dataType
                };
            } else throw new TypeError("Cannot create a Parse.File with that data.");
        }
    }
    /**
   * Return the data for the file, downloading it if not already present.
   * Data is present if initialized with Byte Array, Base64 or Saved with Uri.
   * Data is cleared if saved with File object selected with a file upload control
   *
   * @returns {Promise} Promise that is resolve with base64 data
   */ (0, $bd30e6d93a510522$var$_createClass2.default)(ParseFile, [
        {
            key: "getData",
            value: function() {
                var _getData = (0, $bd30e6d93a510522$var$_asyncToGenerator2.default)(/*#__PURE__*/ $bd30e6d93a510522$var$_regeneratorRuntime().mark(function _callee() {
                    var _this = this;
                    var options, controller, result;
                    return $bd30e6d93a510522$var$_regeneratorRuntime().wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                if (!this._data) {
                                    _context4.next = 2;
                                    break;
                                }
                                return _context4.abrupt("return", this._data);
                            case 2:
                                if (this._url) {
                                    _context4.next = 4;
                                    break;
                                }
                                throw new Error("Cannot retrieve data for unsaved ParseFile.");
                            case 4:
                                options = {
                                    requestTask: function(task) {
                                        return _this._requestTask = task;
                                    }
                                };
                                controller = $bd30e6d93a510522$var$_CoreManager.default.getFileController();
                                _context4.next = 8;
                                return controller.download(this._url, options);
                            case 8:
                                result = _context4.sent;
                                this._data = result.base64;
                                return _context4.abrupt("return", this._data);
                            case 11:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee, this);
                }));
                function getData() {
                    return _getData.apply(this, arguments);
                }
                return getData;
            }()
        },
        {
            key: "name",
            value: function() /*: string*/ {
                return this._name;
            }
        },
        {
            key: "url",
            value: function(options) /*: ?string*/ {
                options = options || {};
                if (!this._url) return;
                if (options.forceSecure) return this._url.replace(/^http:\/\//i, "https://");
                else return this._url;
            }
        },
        {
            key: "metadata",
            value: function() /*: Object*/ {
                return this._metadata;
            }
        },
        {
            key: "tags",
            value: function() /*: Object*/ {
                return this._tags;
            }
        },
        {
            key: "save",
            value: function(options) {
                var _this2 = this;
                options = options || {};
                options.requestTask = function(task) {
                    return _this2._requestTask = task;
                };
                options.metadata = this._metadata;
                options.tags = this._tags;
                var controller = $bd30e6d93a510522$var$_CoreManager.default.getFileController();
                if (!this._previousSave) {
                    if (this._source.format === "file") this._previousSave = controller.saveFile(this._name, this._source, options).then(function(res) {
                        _this2._name = res.name;
                        _this2._url = res.url;
                        _this2._data = null;
                        _this2._requestTask = null;
                        return _this2;
                    });
                    else if (this._source.format === "uri") this._previousSave = controller.download(this._source.uri, options).then(function(result) {
                        if (!(result && result.base64)) return {};
                        var newSource = {
                            format: "base64",
                            base64: result.base64,
                            type: result.contentType
                        };
                        _this2._data = result.base64;
                        _this2._requestTask = null;
                        return controller.saveBase64(_this2._name, newSource, options);
                    }).then(function(res) {
                        _this2._name = res.name;
                        _this2._url = res.url;
                        _this2._requestTask = null;
                        return _this2;
                    });
                    else this._previousSave = controller.saveBase64(this._name, this._source, options).then(function(res) {
                        _this2._name = res.name;
                        _this2._url = res.url;
                        _this2._requestTask = null;
                        return _this2;
                    });
                }
                if (this._previousSave) return this._previousSave;
            }
        },
        {
            key: "cancel",
            value: function() {
                if (this._requestTask && typeof this._requestTask.abort === "function") this._requestTask.abort();
                this._requestTask = null;
            }
        },
        {
            key: "destroy",
            value: function() {
                var _this3 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!this._name) throw new $bd30e6d93a510522$require$ParseError($bd30e6d93a510522$require$ParseError.FILE_DELETE_UNNAMED_ERROR, "Cannot delete an unnamed file.");
                var destroyOptions = {
                    useMasterKey: true
                };
                if (options.hasOwnProperty("useMasterKey")) destroyOptions.useMasterKey = options.useMasterKey;
                var controller = $bd30e6d93a510522$var$_CoreManager.default.getFileController();
                return controller.deleteFile(this._name, destroyOptions).then(function() {
                    _this3._data = null;
                    _this3._requestTask = null;
                    return _this3;
                });
            }
        },
        {
            key: "toJSON",
            value: function() /*: { name: ?string, url: ?string }*/ {
                return {
                    __type: "File",
                    name: this._name,
                    url: this._url
                };
            }
        },
        {
            key: "equals",
            value: function(other) /*: boolean*/ {
                if (this === other) return true;
                 // Unsaved Files are never equal, since they will be saved to different URLs
                return other instanceof ParseFile && this.name() === other.name() && this.url() === other.url() && typeof this.url() !== "undefined";
            }
        },
        {
            key: "setMetadata",
            value: function(metadata) {
                var _this4 = this;
                if (metadata && (0, $bd30e6d93a510522$var$_typeof2.default)(metadata) === "object") {
                    var _context5;
                    (0, $bd30e6d93a510522$var$_forEach.default)(_context5 = (0, $bd30e6d93a510522$var$_keys.default)(metadata)).call(_context5, function(key) {
                        _this4.addMetadata(key, metadata[key]);
                    });
                }
            }
        },
        {
            key: "addMetadata",
            value: function(key, value) {
                if (typeof key === "string") this._metadata[key] = value;
            }
        },
        {
            key: "setTags",
            value: function(tags) {
                var _this5 = this;
                if (tags && (0, $bd30e6d93a510522$var$_typeof2.default)(tags) === "object") {
                    var _context6;
                    (0, $bd30e6d93a510522$var$_forEach.default)(_context6 = (0, $bd30e6d93a510522$var$_keys.default)(tags)).call(_context6, function(key) {
                        _this5.addTag(key, tags[key]);
                    });
                }
            }
        },
        {
            key: "addTag",
            value: function(key, value) {
                if (typeof key === "string") this._tags[key] = value;
            }
        }
    ], [
        {
            key: "fromJSON",
            value: function(obj) /*: ParseFile*/ {
                if (obj.__type !== "File") throw new TypeError("JSON object does not represent a ParseFile");
                var file = new ParseFile(obj.name);
                file._url = obj.url;
                return file;
            }
        },
        {
            key: "encodeBase64",
            value: function(bytes) /*: string*/ {
                var chunks = [];
                chunks.length = Math.ceil(bytes.length / 3);
                for(var i = 0; i < chunks.length; i++){
                    var b1 = bytes[i * 3];
                    var b2 = bytes[i * 3 + 1] || 0;
                    var b3 = bytes[i * 3 + 2] || 0;
                    var has2 = i * 3 + 1 < bytes.length;
                    var has3 = i * 3 + 2 < bytes.length;
                    chunks[i] = [
                        $bd30e6d93a510522$var$b64Digit(b1 >> 2 & 0x3f),
                        $bd30e6d93a510522$var$b64Digit(b1 << 4 & 0x30 | b2 >> 4 & 0x0f),
                        has2 ? $bd30e6d93a510522$var$b64Digit(b2 << 2 & 0x3c | b3 >> 6 & 0x03) : "=",
                        has3 ? $bd30e6d93a510522$var$b64Digit(b3 & 0x3f) : "="
                    ].join("");
                }
                return chunks.join("");
            }
        }
    ]);
    return ParseFile;
}();
var $bd30e6d93a510522$var$DefaultController = {
    saveFile: function() {
        var _saveFile = (0, $bd30e6d93a510522$var$_asyncToGenerator2.default)(/*#__PURE__*/ $bd30e6d93a510522$var$_regeneratorRuntime().mark(function _callee2(name, source, options) {
            var base64Data, _base64Data$split, _base64Data$split2, first, second, data, newSource;
            return $bd30e6d93a510522$var$_regeneratorRuntime().wrap(function _callee2$(_context7) {
                while(true)switch(_context7.prev = _context7.next){
                    case 0:
                        if (!(source.format !== "file")) {
                            _context7.next = 2;
                            break;
                        }
                        throw new Error("saveFile can only be used with File-type sources.");
                    case 2:
                        _context7.next = 4;
                        return new $bd30e6d93a510522$var$_promise.default(function(res, rej) {
                            // eslint-disable-next-line no-undef
                            var reader = new FileReader();
                            reader.onload = function() {
                                return res(reader.result);
                            };
                            reader.onerror = function(error) {
                                return rej(error);
                            };
                            reader.readAsDataURL(source.file);
                        });
                    case 4:
                        base64Data = _context7.sent; // we only want the data after the comma
                        // For example: "data:application/pdf;base64,JVBERi0xLjQKJ..." we would only want "JVBERi0xLjQKJ..."
                        _base64Data$split = base64Data.split(","), _base64Data$split2 = (0, $bd30e6d93a510522$var$_slicedToArray2.default)(_base64Data$split, 2), first = _base64Data$split2[0], second = _base64Data$split2[1]; // in the event there is no 'data:application/pdf;base64,' at the beginning of the base64 string
                        // use the entire string instead
                        data = second ? second : first;
                        newSource = {
                            format: "base64",
                            base64: data,
                            type: source.type || (source.file ? source.file.type : null)
                        };
                        _context7.next = 10;
                        return $bd30e6d93a510522$var$DefaultController.saveBase64(name, newSource, options);
                    case 10:
                        return _context7.abrupt("return", _context7.sent);
                    case 11:
                    case "end":
                        return _context7.stop();
                }
            }, _callee2);
        }));
        function saveFile(_x, _x2, _x3) {
            return _saveFile.apply(this, arguments);
        }
        return saveFile;
    }(),
    saveBase64: function saveBase64(name, source, options) {
        if (source.format !== "base64") throw new Error("saveBase64 can only be used with Base64-type sources.");
        var data = {
            base64: source.base64,
            fileData: {
                metadata: $bd30e6d93a510522$var$_objectSpread({}, options.metadata),
                tags: $bd30e6d93a510522$var$_objectSpread({}, options.tags)
            }
        };
        delete options.metadata;
        delete options.tags;
        if (source.type) data._ContentType = source.type;
        var path = "files/" + name;
        return $bd30e6d93a510522$var$_CoreManager.default.getRESTController().request("POST", path, data, options);
    },
    download: function download(uri, options) {
        if ($bd30e6d93a510522$var$XHR) return this.downloadAjax(uri, options);
        else return $bd30e6d93a510522$var$_promise.default.reject("Cannot make a request: No definition of XMLHttpRequest was found.");
    },
    downloadAjax: function downloadAjax(uri, options) {
        return new $bd30e6d93a510522$var$_promise.default(function(resolve, reject) {
            var xhr = new $bd30e6d93a510522$var$XHR();
            xhr.open("GET", uri, true);
            xhr.responseType = "arraybuffer";
            xhr.onerror = function(e) {
                reject(e);
            };
            xhr.onreadystatechange = function() {
                if (xhr.readyState !== xhr.DONE) return;
                if (!this.response) return resolve({});
                var bytes = new Uint8Array(this.response);
                resolve({
                    base64: $bd30e6d93a510522$var$ParseFile.encodeBase64(bytes),
                    contentType: xhr.getResponseHeader("content-type")
                });
            };
            options.requestTask(xhr);
            xhr.send();
        });
    },
    deleteFile: function deleteFile(name, options) {
        var headers = {
            "X-Parse-Application-ID": $bd30e6d93a510522$var$_CoreManager.default.get("APPLICATION_ID")
        };
        if (options.useMasterKey) headers["X-Parse-Master-Key"] = $bd30e6d93a510522$var$_CoreManager.default.get("MASTER_KEY");
        var url = $bd30e6d93a510522$var$_CoreManager.default.get("SERVER_URL");
        if (url[url.length - 1] !== "/") url += "/";
        url += "files/" + name;
        return $bd30e6d93a510522$var$_CoreManager.default.getRESTController().ajax("DELETE", url, "", headers).catch(function(response) {
            // TODO: return JSON object in server
            if (!response || response === "SyntaxError: Unexpected end of JSON input") return $bd30e6d93a510522$var$_promise.default.resolve();
            else return $bd30e6d93a510522$var$_CoreManager.default.getRESTController().handleError(response);
        });
    },
    _setXHR: function _setXHR(xhr) {
        $bd30e6d93a510522$var$XHR = xhr;
    },
    _getXHR: function _getXHR() {
        return $bd30e6d93a510522$var$XHR;
    }
};
$bd30e6d93a510522$var$_CoreManager.default.setFileController($bd30e6d93a510522$var$DefaultController);
var $bd30e6d93a510522$var$_default = $bd30e6d93a510522$var$ParseFile;
module.exports.default = $bd30e6d93a510522$var$_default;
module.exports.b64Digit = $bd30e6d93a510522$var$b64Digit;

});
parcelRequire.register("5kSp4", function(module, exports) {

var $hctBu = parcelRequire("hctBu");

var $cdUMp = parcelRequire("cdUMp");

var $7XfuR = parcelRequire("7XfuR");

var $jUE2o = parcelRequire("jUE2o");
function $3e29055d265242a7$var$_slicedToArray(arr, i) {
    return $hctBu(arr) || $cdUMp(arr, i) || $7XfuR(arr, i) || $jUE2o();
}
module.exports = $3e29055d265242a7$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("hctBu", function(module, exports) {

var $43adY = parcelRequire("43adY");
function $033b4437137dcfb6$var$_arrayWithHoles(arr) {
    if ($43adY(arr)) return arr;
}
module.exports = $033b4437137dcfb6$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("43adY", function(module, exports) {

module.exports = (parcelRequire("3cRXo"));

});
parcelRequire.register("3cRXo", function(module, exports) {

module.exports = (parcelRequire("4nm5m"));

});
parcelRequire.register("4nm5m", function(module, exports) {

var $jVpwF = parcelRequire("jVpwF");
module.exports = $jVpwF;

});
parcelRequire.register("jVpwF", function(module, exports) {

var $hXzHb = parcelRequire("hXzHb");
module.exports = $hXzHb;

});





parcelRequire.register("cdUMp", function(module, exports) {

var $iqC1p = parcelRequire("iqC1p");

var $liESz = parcelRequire("liESz");
function $8e62be397866db5a$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof $iqC1p !== "undefined" && $liESz(arr) || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
module.exports = $8e62be397866db5a$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("7XfuR", function(module, exports) {

var $2DBLy = parcelRequire("2DBLy");

var $eWWwU = parcelRequire("eWWwU");

var $gQJnG = parcelRequire("gQJnG");
function $5caa1070060ce381$var$_unsupportedIterableToArray(o, minLen) {
    var _context;
    if (!o) return;
    if (typeof o === "string") return $gQJnG(o, minLen);
    var n = $2DBLy(_context = Object.prototype.toString.call(o)).call(_context, 8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return $eWWwU(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $gQJnG(o, minLen);
}
module.exports = $5caa1070060ce381$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("2DBLy", function(module, exports) {

module.exports = (parcelRequire("1EZyz"));

});
parcelRequire.register("1EZyz", function(module, exports) {

module.exports = (parcelRequire("hFdmV"));

});
parcelRequire.register("hFdmV", function(module, exports) {

var $dHfBf = parcelRequire("dHfBf");
module.exports = $dHfBf;

});
parcelRequire.register("dHfBf", function(module, exports) {

var $ddhE4 = parcelRequire("ddhE4");
module.exports = $ddhE4;

});




parcelRequire.register("eWWwU", function(module, exports) {

module.exports = (parcelRequire("3pyWy"));

});
parcelRequire.register("3pyWy", function(module, exports) {

module.exports = (parcelRequire("7kq19"));

});
parcelRequire.register("7kq19", function(module, exports) {

var $hazqc = parcelRequire("hazqc");
module.exports = $hazqc;

});
parcelRequire.register("hazqc", function(module, exports) {

var $1H189 = parcelRequire("1H189");
module.exports = $1H189;

});




parcelRequire.register("gQJnG", function(module, exports) {
function $c444b464cf7246c6$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
module.exports = $c444b464cf7246c6$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("jUE2o", function(module, exports) {
function $e7f24de627636813$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $e7f24de627636813$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRequire.register("4Glkc", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $evY07 = parcelRequire("evY07");
$evY07(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $368ba04fe718603f$var$_isArray = $3Npdz((parcelRequire("i0kCX")));

var $368ba04fe718603f$var$_classCallCheck2 = $3Npdz((parcelRequire("9pQKE")));

var $368ba04fe718603f$var$_createClass2 = $3Npdz((parcelRequire("eZYdV")));

var $368ba04fe718603f$var$_defineProperty2 = $3Npdz((parcelRequire("bci6G")));

var $1WcLm = parcelRequire("1WcLm");

var $368ba04fe718603f$var$_ParseObject = $3Npdz((parcelRequire("2HIpX")));

var $368ba04fe718603f$var$_ParseQuery = $3Npdz((parcelRequire("eJCLn")));
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ /**
 * Creates a new Relation for the given parent object and key. This
 * constructor should rarely be used directly, but rather created by
 * Parse.Object.relation.
 *
 * <p>
 * A class that is used to access all of the children of a many-to-many
 * relationship.  Each instance of Parse.Relation is associated with a
 * particular parent object and key.
 * </p>
 *
 * @alias Parse.Relation
 */ var $368ba04fe718603f$var$ParseRelation = /*#__PURE__*/ function() {
    /**
   * @param {Parse.Object} parent The parent of this relation.
   * @param {string} key The key for this relation on the parent.
   */ function ParseRelation(parent, key) {
        (0, $368ba04fe718603f$var$_classCallCheck2.default)(this, ParseRelation);
        (0, $368ba04fe718603f$var$_defineProperty2.default)(this, "parent", void 0);
        (0, $368ba04fe718603f$var$_defineProperty2.default)(this, "key", void 0);
        (0, $368ba04fe718603f$var$_defineProperty2.default)(this, "targetClassName", void 0);
        this.parent = parent;
        this.key = key;
        this.targetClassName = null;
    }
    /*
   * Makes sure that this relation has the right parent and key.
   */ (0, $368ba04fe718603f$var$_createClass2.default)(ParseRelation, [
        {
            key: "_ensureParentAndKey",
            value: function(parent, key) {
                this.key = this.key || key;
                if (this.key !== key) throw new Error("Internal Error. Relation retrieved from two different keys.");
                if (this.parent) {
                    if (this.parent.className !== parent.className) throw new Error("Internal Error. Relation retrieved from two different Objects.");
                    if (this.parent.id) {
                        if (this.parent.id !== parent.id) throw new Error("Internal Error. Relation retrieved from two different Objects.");
                    } else if (parent.id) this.parent = parent;
                } else this.parent = parent;
            }
        },
        {
            key: "add",
            value: function(objects) /*: ParseObject*/ {
                if (!(0, $368ba04fe718603f$var$_isArray.default)(objects)) objects = [
                    objects
                ];
                var change = new $1WcLm.RelationOp(objects, []);
                var parent = this.parent;
                if (!parent) throw new Error("Cannot add to a Relation without a parent");
                if (objects.length === 0) return parent;
                parent.set(this.key, change);
                this.targetClassName = change._targetClassName;
                return parent;
            }
        },
        {
            key: "remove",
            value: function(objects) {
                if (!(0, $368ba04fe718603f$var$_isArray.default)(objects)) objects = [
                    objects
                ];
                var change = new $1WcLm.RelationOp([], objects);
                if (!this.parent) throw new Error("Cannot remove from a Relation without a parent");
                if (objects.length === 0) return;
                this.parent.set(this.key, change);
                this.targetClassName = change._targetClassName;
            }
        },
        {
            key: "toJSON",
            value: function() /*: { __type: 'Relation', className: ?string }*/ {
                return {
                    __type: "Relation",
                    className: this.targetClassName
                };
            }
        },
        {
            key: "query",
            value: function query() /*: ParseQuery*/ {
                var query;
                var parent = this.parent;
                if (!parent) throw new Error("Cannot construct a query for a Relation without a parent");
                if (!this.targetClassName) {
                    query = new $368ba04fe718603f$var$_ParseQuery.default(parent.className);
                    query._extraOptions.redirectClassNameForKey = this.key;
                } else query = new $368ba04fe718603f$var$_ParseQuery.default(this.targetClassName);
                query._addCondition("$relatedTo", "object", {
                    __type: "Pointer",
                    className: parent.className,
                    objectId: parent.id
                });
                query._addCondition("$relatedTo", "key", this.key);
                return query;
            }
        }
    ]);
    return ParseRelation;
}();
var $368ba04fe718603f$var$_default = $368ba04fe718603f$var$ParseRelation;
module.exports.default = $368ba04fe718603f$var$_default;

});
parcelRequire.register("1WcLm", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $evY07 = parcelRequire("evY07");

var $dwGVc = parcelRequire("dwGVc");
$evY07(module.exports, "__esModule", {
    value: true
});
module.exports.UnsetOp = module.exports.SetOp = module.exports.RemoveOp = module.exports.RelationOp = module.exports.Op = module.exports.IncrementOp = module.exports.AddUniqueOp = module.exports.AddOp = void 0;
module.exports.opFromJSON = $16951ba653986413$var$opFromJSON;

var $16951ba653986413$var$_map = $3Npdz((parcelRequire("hqsP5")));

var $16951ba653986413$var$_splice = $3Npdz((parcelRequire("5SAes")));

var $16951ba653986413$var$_indexOf = $3Npdz((parcelRequire("eOZH4")));

var $16951ba653986413$var$_forEach = $3Npdz((parcelRequire("jZGC2")));

var $16951ba653986413$var$_assertThisInitialized2 = $3Npdz((parcelRequire("73Ztd")));

var $16951ba653986413$var$_inherits2 = $3Npdz((parcelRequire("4QWF4")));

var $16951ba653986413$var$_possibleConstructorReturn2 = $3Npdz((parcelRequire("kTHGs")));

var $16951ba653986413$var$_getPrototypeOf2 = $3Npdz((parcelRequire("6MmOk")));

var $16951ba653986413$var$_defineProperty2 = $3Npdz((parcelRequire("bci6G")));

var $16951ba653986413$var$_classCallCheck2 = $3Npdz((parcelRequire("9pQKE")));

var $16951ba653986413$var$_createClass2 = $3Npdz((parcelRequire("eZYdV")));

var $16951ba653986413$var$_concat = $3Npdz((parcelRequire("3mvQI")));

var $16951ba653986413$var$_isArray = $3Npdz((parcelRequire("i0kCX")));

var $16951ba653986413$var$_arrayContainsObject = $3Npdz((parcelRequire("5K0EB")));

var $16951ba653986413$var$_decode = $3Npdz((parcelRequire("7CFxK")));

var $16951ba653986413$var$_encode = $3Npdz((parcelRequire("gM4ym")));

var $16951ba653986413$var$_ParseObject = $3Npdz((parcelRequire("2HIpX")));

var $16951ba653986413$var$_ParseRelation = $3Npdz((parcelRequire("4Glkc")));

var $16951ba653986413$var$_unique = $3Npdz((parcelRequire("cQimZ")));
function $16951ba653986413$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $16951ba653986413$var$_isNativeReflectConstruct();
    return function() {
        var Super = (0, $16951ba653986413$var$_getPrototypeOf2.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $16951ba653986413$var$_getPrototypeOf2.default)(this).constructor;
            result = $dwGVc(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $16951ba653986413$var$_possibleConstructorReturn2.default)(this, result);
    };
}
function $16951ba653986413$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !$dwGVc) return false;
    if ($dwGVc.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($dwGVc(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $16951ba653986413$var$opFromJSON(json) /*: ?Op*/ {
    if (!json || !json.__op) return null;
    switch(json.__op){
        case "Delete":
            return new $16951ba653986413$var$UnsetOp();
        case "Increment":
            return new $16951ba653986413$var$IncrementOp(json.amount);
        case "Add":
            return new $16951ba653986413$var$AddOp((0, $16951ba653986413$var$_decode.default)(json.objects));
        case "AddUnique":
            return new $16951ba653986413$var$AddUniqueOp((0, $16951ba653986413$var$_decode.default)(json.objects));
        case "Remove":
            return new $16951ba653986413$var$RemoveOp((0, $16951ba653986413$var$_decode.default)(json.objects));
        case "AddRelation":
            var toAdd = (0, $16951ba653986413$var$_decode.default)(json.objects);
            if (!(0, $16951ba653986413$var$_isArray.default)(toAdd)) return new $16951ba653986413$var$RelationOp([], []);
            return new $16951ba653986413$var$RelationOp(toAdd, []);
        case "RemoveRelation":
            var toRemove = (0, $16951ba653986413$var$_decode.default)(json.objects);
            if (!(0, $16951ba653986413$var$_isArray.default)(toRemove)) return new $16951ba653986413$var$RelationOp([], []);
            return new $16951ba653986413$var$RelationOp([], toRemove);
        case "Batch":
            var _toAdd = [];
            var _toRemove = [];
            for(var i = 0; i < json.ops.length; i++){
                if (json.ops[i].__op === "AddRelation") _toAdd = (0, $16951ba653986413$var$_concat.default)(_toAdd).call(_toAdd, (0, $16951ba653986413$var$_decode.default)(json.ops[i].objects));
                else if (json.ops[i].__op === "RemoveRelation") _toRemove = (0, $16951ba653986413$var$_concat.default)(_toRemove).call(_toRemove, (0, $16951ba653986413$var$_decode.default)(json.ops[i].objects));
            }
            return new $16951ba653986413$var$RelationOp(_toAdd, _toRemove);
    }
    return null;
}
var $16951ba653986413$var$Op = /*#__PURE__*/ function() {
    function Op() {
        (0, $16951ba653986413$var$_classCallCheck2.default)(this, Op);
    }
    (0, $16951ba653986413$var$_createClass2.default)(Op, [
        {
            key: "applyTo",
            value: function() /*: mixed*/ {}
        },
        {
            key: "mergeWith",
            value: function() /*: ?Op*/ {}
        },
        {
            key: "toJSON",
            value: function() /*: mixed*/ {}
        }
    ]);
    return Op;
}();
module.exports.Op = $16951ba653986413$var$Op;
var $16951ba653986413$var$SetOp = /*#__PURE__*/ function(_Op) {
    (0, $16951ba653986413$var$_inherits2.default)(SetOp, _Op);
    var _super = $16951ba653986413$var$_createSuper(SetOp);
    function SetOp(value) {
        var _this;
        (0, $16951ba653986413$var$_classCallCheck2.default)(this, SetOp);
        _this = _super.call(this);
        (0, $16951ba653986413$var$_defineProperty2.default)((0, $16951ba653986413$var$_assertThisInitialized2.default)(_this), "_value", void 0);
        _this._value = value;
        return _this;
    }
    (0, $16951ba653986413$var$_createClass2.default)(SetOp, [
        {
            key: "applyTo",
            value: function() /*: mixed*/ {
                return this._value;
            }
        },
        {
            key: "mergeWith",
            value: function() /*: SetOp*/ {
                return new SetOp(this._value);
            }
        },
        {
            key: "toJSON",
            value: function(offline) {
                return (0, $16951ba653986413$var$_encode.default)(this._value, false, true, undefined, offline);
            }
        }
    ]);
    return SetOp;
}($16951ba653986413$var$Op);
module.exports.SetOp = $16951ba653986413$var$SetOp;
var $16951ba653986413$var$UnsetOp = /*#__PURE__*/ function(_Op2) {
    (0, $16951ba653986413$var$_inherits2.default)(UnsetOp, _Op2);
    var _super2 = $16951ba653986413$var$_createSuper(UnsetOp);
    function UnsetOp() {
        (0, $16951ba653986413$var$_classCallCheck2.default)(this, UnsetOp);
        return _super2.apply(this, arguments);
    }
    (0, $16951ba653986413$var$_createClass2.default)(UnsetOp, [
        {
            key: "applyTo",
            value: function() {
                return undefined;
            }
        },
        {
            key: "mergeWith",
            value: function() /*: UnsetOp*/ {
                return new UnsetOp();
            }
        },
        {
            key: "toJSON",
            value: function() /*: { __op: string }*/ {
                return {
                    __op: "Delete"
                };
            }
        }
    ]);
    return UnsetOp;
}($16951ba653986413$var$Op);
module.exports.UnsetOp = $16951ba653986413$var$UnsetOp;
var $16951ba653986413$var$IncrementOp = /*#__PURE__*/ function(_Op3) {
    (0, $16951ba653986413$var$_inherits2.default)(IncrementOp, _Op3);
    var _super3 = $16951ba653986413$var$_createSuper(IncrementOp);
    function IncrementOp(amount) {
        var _this2;
        (0, $16951ba653986413$var$_classCallCheck2.default)(this, IncrementOp);
        _this2 = _super3.call(this);
        (0, $16951ba653986413$var$_defineProperty2.default)((0, $16951ba653986413$var$_assertThisInitialized2.default)(_this2), "_amount", void 0);
        if (typeof amount !== "number") throw new TypeError("Increment Op must be initialized with a numeric amount.");
        _this2._amount = amount;
        return _this2;
    }
    (0, $16951ba653986413$var$_createClass2.default)(IncrementOp, [
        {
            key: "applyTo",
            value: function(value) /*: number*/ {
                if (typeof value === "undefined") return this._amount;
                if (typeof value !== "number") throw new TypeError("Cannot increment a non-numeric value.");
                return this._amount + value;
            }
        },
        {
            key: "mergeWith",
            value: function(previous) /*: Op*/ {
                if (!previous) return this;
                if (previous instanceof $16951ba653986413$var$SetOp) return new $16951ba653986413$var$SetOp(this.applyTo(previous._value));
                if (previous instanceof $16951ba653986413$var$UnsetOp) return new $16951ba653986413$var$SetOp(this._amount);
                if (previous instanceof IncrementOp) return new IncrementOp(this.applyTo(previous._amount));
                throw new Error("Cannot merge Increment Op with the previous Op");
            }
        },
        {
            key: "toJSON",
            value: function() /*: { __op: string, amount: number }*/ {
                return {
                    __op: "Increment",
                    amount: this._amount
                };
            }
        }
    ]);
    return IncrementOp;
}($16951ba653986413$var$Op);
module.exports.IncrementOp = $16951ba653986413$var$IncrementOp;
var $16951ba653986413$var$AddOp = /*#__PURE__*/ function(_Op4) {
    (0, $16951ba653986413$var$_inherits2.default)(AddOp, _Op4);
    var _super4 = $16951ba653986413$var$_createSuper(AddOp);
    function AddOp(value) {
        var _this3;
        (0, $16951ba653986413$var$_classCallCheck2.default)(this, AddOp);
        _this3 = _super4.call(this);
        (0, $16951ba653986413$var$_defineProperty2.default)((0, $16951ba653986413$var$_assertThisInitialized2.default)(_this3), "_value", void 0);
        _this3._value = (0, $16951ba653986413$var$_isArray.default)(value) ? value : [
            value
        ];
        return _this3;
    }
    (0, $16951ba653986413$var$_createClass2.default)(AddOp, [
        {
            key: "applyTo",
            value: function(value) /*: Array<mixed>*/ {
                if (value == null) return this._value;
                if ((0, $16951ba653986413$var$_isArray.default)(value)) return (0, $16951ba653986413$var$_concat.default)(value).call(value, this._value);
                throw new Error("Cannot add elements to a non-array value");
            }
        },
        {
            key: "mergeWith",
            value: function(previous) /*: Op*/ {
                if (!previous) return this;
                if (previous instanceof $16951ba653986413$var$SetOp) return new $16951ba653986413$var$SetOp(this.applyTo(previous._value));
                if (previous instanceof $16951ba653986413$var$UnsetOp) return new $16951ba653986413$var$SetOp(this._value);
                if (previous instanceof AddOp) return new AddOp(this.applyTo(previous._value));
                throw new Error("Cannot merge Add Op with the previous Op");
            }
        },
        {
            key: "toJSON",
            value: function() /*: { __op: string, objects: mixed }*/ {
                return {
                    __op: "Add",
                    objects: (0, $16951ba653986413$var$_encode.default)(this._value, false, true)
                };
            }
        }
    ]);
    return AddOp;
}($16951ba653986413$var$Op);
module.exports.AddOp = $16951ba653986413$var$AddOp;
var $16951ba653986413$var$AddUniqueOp = /*#__PURE__*/ function(_Op5) {
    (0, $16951ba653986413$var$_inherits2.default)(AddUniqueOp, _Op5);
    var _super5 = $16951ba653986413$var$_createSuper(AddUniqueOp);
    function AddUniqueOp(value) {
        var _this4;
        (0, $16951ba653986413$var$_classCallCheck2.default)(this, AddUniqueOp);
        _this4 = _super5.call(this);
        (0, $16951ba653986413$var$_defineProperty2.default)((0, $16951ba653986413$var$_assertThisInitialized2.default)(_this4), "_value", void 0);
        _this4._value = (0, $16951ba653986413$var$_unique.default)((0, $16951ba653986413$var$_isArray.default)(value) ? value : [
            value
        ]);
        return _this4;
    }
    (0, $16951ba653986413$var$_createClass2.default)(AddUniqueOp, [
        {
            key: "applyTo",
            value: function(value) /*: Array<mixed>*/ {
                if (value == null) return this._value || [];
                if ((0, $16951ba653986413$var$_isArray.default)(value)) {
                    var _context;
                    var toAdd = [];
                    (0, $16951ba653986413$var$_forEach.default)(_context = this._value).call(_context, function(v) {
                        if (v instanceof $16951ba653986413$var$_ParseObject.default) {
                            if (!(0, $16951ba653986413$var$_arrayContainsObject.default)(value, v)) toAdd.push(v);
                        } else if ((0, $16951ba653986413$var$_indexOf.default)(value).call(value, v) < 0) toAdd.push(v);
                    });
                    return (0, $16951ba653986413$var$_concat.default)(value).call(value, toAdd);
                }
                throw new Error("Cannot add elements to a non-array value");
            }
        },
        {
            key: "mergeWith",
            value: function(previous) /*: Op*/ {
                if (!previous) return this;
                if (previous instanceof $16951ba653986413$var$SetOp) return new $16951ba653986413$var$SetOp(this.applyTo(previous._value));
                if (previous instanceof $16951ba653986413$var$UnsetOp) return new $16951ba653986413$var$SetOp(this._value);
                if (previous instanceof AddUniqueOp) return new AddUniqueOp(this.applyTo(previous._value));
                throw new Error("Cannot merge AddUnique Op with the previous Op");
            }
        },
        {
            key: "toJSON",
            value: function() /*: { __op: string, objects: mixed }*/ {
                return {
                    __op: "AddUnique",
                    objects: (0, $16951ba653986413$var$_encode.default)(this._value, false, true)
                };
            }
        }
    ]);
    return AddUniqueOp;
}($16951ba653986413$var$Op);
module.exports.AddUniqueOp = $16951ba653986413$var$AddUniqueOp;
var $16951ba653986413$var$RemoveOp = /*#__PURE__*/ function(_Op6) {
    (0, $16951ba653986413$var$_inherits2.default)(RemoveOp, _Op6);
    var _super6 = $16951ba653986413$var$_createSuper(RemoveOp);
    function RemoveOp(value) {
        var _this5;
        (0, $16951ba653986413$var$_classCallCheck2.default)(this, RemoveOp);
        _this5 = _super6.call(this);
        (0, $16951ba653986413$var$_defineProperty2.default)((0, $16951ba653986413$var$_assertThisInitialized2.default)(_this5), "_value", void 0);
        _this5._value = (0, $16951ba653986413$var$_unique.default)((0, $16951ba653986413$var$_isArray.default)(value) ? value : [
            value
        ]);
        return _this5;
    }
    (0, $16951ba653986413$var$_createClass2.default)(RemoveOp, [
        {
            key: "applyTo",
            value: function(value) /*: Array<mixed>*/ {
                if (value == null) return [];
                if ((0, $16951ba653986413$var$_isArray.default)(value)) {
                    // var i = value.indexOf(this._value);
                    var removed = (0, $16951ba653986413$var$_concat.default)(value).call(value, []);
                    for(var i = 0; i < this._value.length; i++){
                        var index = (0, $16951ba653986413$var$_indexOf.default)(removed).call(removed, this._value[i]);
                        while(index > -1){
                            (0, $16951ba653986413$var$_splice.default)(removed).call(removed, index, 1);
                            index = (0, $16951ba653986413$var$_indexOf.default)(removed).call(removed, this._value[i]);
                        }
                        if (this._value[i] instanceof $16951ba653986413$var$_ParseObject.default && this._value[i].id) {
                            for(var j = 0; j < removed.length; j++)if (removed[j] instanceof $16951ba653986413$var$_ParseObject.default && this._value[i].id === removed[j].id) {
                                (0, $16951ba653986413$var$_splice.default)(removed).call(removed, j, 1);
                                j--;
                            }
                        }
                    }
                    return removed;
                }
                throw new Error("Cannot remove elements from a non-array value");
            }
        },
        {
            key: "mergeWith",
            value: function(previous) /*: Op*/ {
                if (!previous) return this;
                if (previous instanceof $16951ba653986413$var$SetOp) return new $16951ba653986413$var$SetOp(this.applyTo(previous._value));
                if (previous instanceof $16951ba653986413$var$UnsetOp) return new $16951ba653986413$var$UnsetOp();
                if (previous instanceof RemoveOp) {
                    var _context2;
                    var uniques = (0, $16951ba653986413$var$_concat.default)(_context2 = previous._value).call(_context2, []);
                    for(var i = 0; i < this._value.length; i++){
                        if (this._value[i] instanceof $16951ba653986413$var$_ParseObject.default) {
                            if (!(0, $16951ba653986413$var$_arrayContainsObject.default)(uniques, this._value[i])) uniques.push(this._value[i]);
                        } else if ((0, $16951ba653986413$var$_indexOf.default)(uniques).call(uniques, this._value[i]) < 0) uniques.push(this._value[i]);
                    }
                    return new RemoveOp(uniques);
                }
                throw new Error("Cannot merge Remove Op with the previous Op");
            }
        },
        {
            key: "toJSON",
            value: function() /*: { __op: string, objects: mixed }*/ {
                return {
                    __op: "Remove",
                    objects: (0, $16951ba653986413$var$_encode.default)(this._value, false, true)
                };
            }
        }
    ]);
    return RemoveOp;
}($16951ba653986413$var$Op);
module.exports.RemoveOp = $16951ba653986413$var$RemoveOp;
var $16951ba653986413$var$RelationOp = /*#__PURE__*/ function(_Op7) {
    (0, $16951ba653986413$var$_inherits2.default)(RelationOp, _Op7);
    var _super7 = $16951ba653986413$var$_createSuper(RelationOp);
    function RelationOp(adds, removes) {
        var _this6;
        (0, $16951ba653986413$var$_classCallCheck2.default)(this, RelationOp);
        _this6 = _super7.call(this);
        (0, $16951ba653986413$var$_defineProperty2.default)((0, $16951ba653986413$var$_assertThisInitialized2.default)(_this6), "_targetClassName", void 0);
        (0, $16951ba653986413$var$_defineProperty2.default)((0, $16951ba653986413$var$_assertThisInitialized2.default)(_this6), "relationsToAdd", void 0);
        (0, $16951ba653986413$var$_defineProperty2.default)((0, $16951ba653986413$var$_assertThisInitialized2.default)(_this6), "relationsToRemove", void 0);
        _this6._targetClassName = null;
        if ((0, $16951ba653986413$var$_isArray.default)(adds)) _this6.relationsToAdd = (0, $16951ba653986413$var$_unique.default)((0, $16951ba653986413$var$_map.default)(adds).call(adds, _this6._extractId, (0, $16951ba653986413$var$_assertThisInitialized2.default)(_this6)));
        if ((0, $16951ba653986413$var$_isArray.default)(removes)) _this6.relationsToRemove = (0, $16951ba653986413$var$_unique.default)((0, $16951ba653986413$var$_map.default)(removes).call(removes, _this6._extractId, (0, $16951ba653986413$var$_assertThisInitialized2.default)(_this6)));
        return _this6;
    }
    (0, $16951ba653986413$var$_createClass2.default)(RelationOp, [
        {
            key: "_extractId",
            value: function(obj) /*: string*/ {
                if (typeof obj === "string") return obj;
                if (!obj.id) throw new Error("You cannot add or remove an unsaved Parse Object from a relation");
                if (!this._targetClassName) this._targetClassName = obj.className;
                if (this._targetClassName !== obj.className) throw new Error("Tried to create a Relation with 2 different object types: " + this._targetClassName + " and " + obj.className + ".");
                return obj.id;
            }
        },
        {
            key: "applyTo",
            value: function(value, object, key) /*: ?ParseRelation*/ {
                if (!value) {
                    var _context3;
                    if (!object || !key) throw new Error("Cannot apply a RelationOp without either a previous value, or an object and a key");
                    var parent = new $16951ba653986413$var$_ParseObject.default(object.className);
                    if (object.id && (0, $16951ba653986413$var$_indexOf.default)(_context3 = object.id).call(_context3, "local") === 0) parent._localId = object.id;
                    else if (object.id) parent.id = object.id;
                    var relation = new $16951ba653986413$var$_ParseRelation.default(parent, key);
                    relation.targetClassName = this._targetClassName;
                    return relation;
                }
                if (value instanceof $16951ba653986413$var$_ParseRelation.default) {
                    if (this._targetClassName) {
                        if (value.targetClassName) {
                            if (this._targetClassName !== value.targetClassName) throw new Error("Related object must be a " + value.targetClassName + ", but a " + this._targetClassName + " was passed in.");
                        } else value.targetClassName = this._targetClassName;
                    }
                    return value;
                } else throw new Error("Relation cannot be applied to a non-relation field");
            }
        },
        {
            key: "mergeWith",
            value: function(previous) /*: Op*/ {
                if (!previous) return this;
                else if (previous instanceof $16951ba653986413$var$UnsetOp) throw new Error("You cannot modify a relation after deleting it.");
                else if (previous instanceof $16951ba653986413$var$SetOp && previous._value instanceof $16951ba653986413$var$_ParseRelation.default) return this;
                else if (previous instanceof RelationOp) {
                    var _context4, _context5, _context6, _context7, _context8, _context9;
                    if (previous._targetClassName && previous._targetClassName !== this._targetClassName) throw new Error("Related object must be of class " + previous._targetClassName + ", but " + (this._targetClassName || "null") + " was passed in.");
                    var newAdd = (0, $16951ba653986413$var$_concat.default)(_context4 = previous.relationsToAdd).call(_context4, []);
                    (0, $16951ba653986413$var$_forEach.default)(_context5 = this.relationsToRemove).call(_context5, function(r) {
                        var index = (0, $16951ba653986413$var$_indexOf.default)(newAdd).call(newAdd, r);
                        if (index > -1) (0, $16951ba653986413$var$_splice.default)(newAdd).call(newAdd, index, 1);
                    });
                    (0, $16951ba653986413$var$_forEach.default)(_context6 = this.relationsToAdd).call(_context6, function(r) {
                        var index = (0, $16951ba653986413$var$_indexOf.default)(newAdd).call(newAdd, r);
                        if (index < 0) newAdd.push(r);
                    });
                    var newRemove = (0, $16951ba653986413$var$_concat.default)(_context7 = previous.relationsToRemove).call(_context7, []);
                    (0, $16951ba653986413$var$_forEach.default)(_context8 = this.relationsToAdd).call(_context8, function(r) {
                        var index = (0, $16951ba653986413$var$_indexOf.default)(newRemove).call(newRemove, r);
                        if (index > -1) (0, $16951ba653986413$var$_splice.default)(newRemove).call(newRemove, index, 1);
                    });
                    (0, $16951ba653986413$var$_forEach.default)(_context9 = this.relationsToRemove).call(_context9, function(r) {
                        var index = (0, $16951ba653986413$var$_indexOf.default)(newRemove).call(newRemove, r);
                        if (index < 0) newRemove.push(r);
                    });
                    var newRelation = new RelationOp(newAdd, newRemove);
                    newRelation._targetClassName = this._targetClassName;
                    return newRelation;
                }
                throw new Error("Cannot merge Relation Op with the previous Op");
            }
        },
        {
            key: "toJSON",
            value: function() /*: { __op?: string, objects?: mixed, ops?: mixed }*/ {
                var _this7 = this;
                var idToPointer = function(id) {
                    return {
                        __type: "Pointer",
                        className: _this7._targetClassName,
                        objectId: id
                    };
                };
                var adds = null;
                var removes = null;
                var pointers = null;
                if (this.relationsToAdd.length > 0) {
                    var _context10;
                    pointers = (0, $16951ba653986413$var$_map.default)(_context10 = this.relationsToAdd).call(_context10, idToPointer);
                    adds = {
                        __op: "AddRelation",
                        objects: pointers
                    };
                }
                if (this.relationsToRemove.length > 0) {
                    var _context11;
                    pointers = (0, $16951ba653986413$var$_map.default)(_context11 = this.relationsToRemove).call(_context11, idToPointer);
                    removes = {
                        __op: "RemoveRelation",
                        objects: pointers
                    };
                }
                if (adds && removes) return {
                    __op: "Batch",
                    ops: [
                        adds,
                        removes
                    ]
                };
                return adds || removes || {};
            }
        }
    ]);
    return RelationOp;
}($16951ba653986413$var$Op);
module.exports.RelationOp = $16951ba653986413$var$RelationOp;

});
parcelRequire.register("5SAes", function(module, exports) {

module.exports = (parcelRequire("8IgSy"));

});
parcelRequire.register("8IgSy", function(module, exports) {

var $aqTu7 = parcelRequire("aqTu7");
module.exports = $aqTu7;

});
parcelRequire.register("aqTu7", function(module, exports) {

var $5L8hR = parcelRequire("5L8hR");

var $e0pfQ = parcelRequire("e0pfQ");
var $79875f31914a4606$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.splice;
    return it === $79875f31914a4606$var$ArrayPrototype || $5L8hR($79875f31914a4606$var$ArrayPrototype, it) && own === $79875f31914a4606$var$ArrayPrototype.splice ? $e0pfQ : own;
};

});
parcelRequire.register("e0pfQ", function(module, exports) {
parcelRequire("jVTT6");

var $hESIr = parcelRequire("hESIr");
module.exports = $hESIr("Array").splice;

});
parcelRequire.register("jVTT6", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $bVwvx = parcelRequire("bVwvx");

var $5LbRx = parcelRequire("5LbRx");

var $5flhu = parcelRequire("5flhu");

var $25Yeh = parcelRequire("25Yeh");

var $cnFA4 = parcelRequire("cnFA4");

var $1KUkA = parcelRequire("1KUkA");

var $YzIa0 = parcelRequire("YzIa0");

var $4mEJZ = parcelRequire("4mEJZ");

var $7IrDt = parcelRequire("7IrDt");

var $jS11O = parcelRequire("jS11O");
var $e82eb1549f02ac72$var$HAS_SPECIES_SUPPORT = $jS11O("splice");
var $e82eb1549f02ac72$var$max = Math.max;
var $e82eb1549f02ac72$var$min = Math.min;
// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$g2B3u({
    target: "Array",
    proto: true,
    forced: !$e82eb1549f02ac72$var$HAS_SPECIES_SUPPORT
}, {
    splice: function splice(start, deleteCount /* , ...items */ ) {
        var O = $bVwvx(this);
        var len = $25Yeh(O);
        var actualStart = $5LbRx(start, len);
        var argumentsLength = arguments.length;
        var insertCount, actualDeleteCount, A, k, from, to;
        if (argumentsLength === 0) insertCount = actualDeleteCount = 0;
        else if (argumentsLength === 1) {
            insertCount = 0;
            actualDeleteCount = len - actualStart;
        } else {
            insertCount = argumentsLength - 2;
            actualDeleteCount = $e82eb1549f02ac72$var$min($e82eb1549f02ac72$var$max($5flhu(deleteCount), 0), len - actualStart);
        }
        $1KUkA(len + insertCount - actualDeleteCount);
        A = $YzIa0(O, actualDeleteCount);
        for(k = 0; k < actualDeleteCount; k++){
            from = actualStart + k;
            if (from in O) $4mEJZ(A, k, O[from]);
        }
        A.length = actualDeleteCount;
        if (insertCount < actualDeleteCount) {
            for(k = actualStart; k < len - actualDeleteCount; k++){
                from = k + actualDeleteCount;
                to = k + insertCount;
                if (from in O) O[to] = O[from];
                else $7IrDt(O, to);
            }
            for(k = len; k > len - actualDeleteCount + insertCount; k--)$7IrDt(O, k - 1);
        } else if (insertCount > actualDeleteCount) for(k = len - actualDeleteCount; k > actualStart; k--){
            from = k + actualDeleteCount - 1;
            to = k + insertCount - 1;
            if (from in O) O[to] = O[from];
            else $7IrDt(O, to);
        }
        for(k = 0; k < insertCount; k++)O[k + actualStart] = arguments[k + 2];
        $cnFA4(O, len - actualDeleteCount + insertCount);
        return A;
    }
});

});
parcelRequire.register("cnFA4", function(module, exports) {
"use strict";

var $99D40 = parcelRequire("99D40");

var $6BgtM = parcelRequire("6BgtM");
var $9037e31a398866a1$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $9037e31a398866a1$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Safari < 13 does not throw an error in this case
var $9037e31a398866a1$var$SILENT_ON_NON_WRITABLE_LENGTH_SET = $99D40 && !function() {
    // makes no sense without proper strict mode support
    if (this !== undefined) return true;
    try {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty([], "length", {
            writable: false
        }).length = 1;
    } catch (error) {
        return error instanceof TypeError;
    }
}();
module.exports = $9037e31a398866a1$var$SILENT_ON_NON_WRITABLE_LENGTH_SET ? function(O, length) {
    if ($6BgtM(O) && !$9037e31a398866a1$var$getOwnPropertyDescriptor(O, "length").writable) throw $9037e31a398866a1$var$$TypeError("Cannot set read only .length");
    return O.length = length;
} : function(O, length) {
    return O.length = length;
};

});

parcelRequire.register("7IrDt", function(module, exports) {
"use strict";

var $4ubrU = parcelRequire("4ubrU");
var $59e2145a1e939258$var$$TypeError = TypeError;
module.exports = function(O, P) {
    if (!delete O[P]) throw $59e2145a1e939258$var$$TypeError("Cannot delete property " + $4ubrU(P) + " of " + $4ubrU(O));
};

});






parcelRequire.register("5K0EB", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $evY07 = parcelRequire("evY07");
$evY07(module.exports, "__esModule", {
    value: true
});
module.exports.default = $42e1c17803a1f047$var$arrayContainsObject;

var $42e1c17803a1f047$var$_indexOf = $3Npdz((parcelRequire("eOZH4")));

var $42e1c17803a1f047$var$_ParseObject = $3Npdz((parcelRequire("2HIpX")));
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ function $42e1c17803a1f047$var$arrayContainsObject(array, object) /*: boolean*/ {
    if ((0, $42e1c17803a1f047$var$_indexOf.default)(array).call(array, object) > -1) return true;
    for(var i = 0; i < array.length; i++){
        if (array[i] instanceof $42e1c17803a1f047$var$_ParseObject.default && array[i].className === object.className && array[i]._getId() === object._getId()) return true;
    }
    return false;
}

});

parcelRequire.register("gM4ym", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $evY07 = parcelRequire("evY07");
$evY07(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c364a939edc90b4f$var$_default;

var $c364a939edc90b4f$var$_typeof2 = $3Npdz((parcelRequire("akViX")));

var $c364a939edc90b4f$var$_map = $3Npdz((parcelRequire("hqsP5")));

var $c364a939edc90b4f$var$_isArray = $3Npdz((parcelRequire("i0kCX")));

var $c364a939edc90b4f$var$_concat = $3Npdz((parcelRequire("3mvQI")));

var $c364a939edc90b4f$var$_startsWith = $3Npdz((parcelRequire("fgj1z")));

var $c364a939edc90b4f$var$_keys = $3Npdz((parcelRequire("r9mpE")));

var $c364a939edc90b4f$var$_indexOf = $3Npdz((parcelRequire("eOZH4")));

var $c364a939edc90b4f$var$_ParseACL = $3Npdz((parcelRequire("9HvHn")));

var $c364a939edc90b4f$var$_ParseFile = $3Npdz((parcelRequire("gf3Ge")));

var $c364a939edc90b4f$var$_ParseGeoPoint = $3Npdz((parcelRequire("5vhig")));

var $c364a939edc90b4f$var$_ParsePolygon = $3Npdz((parcelRequire("dkxwb")));

var $c364a939edc90b4f$var$_ParseObject = $3Npdz((parcelRequire("2HIpX")));

var $1WcLm = parcelRequire("1WcLm");

var $c364a939edc90b4f$var$_ParseRelation = $3Npdz((parcelRequire("4Glkc")));
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ function $c364a939edc90b4f$var$encode(value, disallowObjects, forcePointers, seen, offline) /*: any*/ {
    if (value instanceof $c364a939edc90b4f$var$_ParseObject.default) {
        if (disallowObjects) throw new Error("Parse Objects not allowed here");
        var seenEntry = value.id ? value.className + ":" + value.id : value;
        if (forcePointers || !seen || (0, $c364a939edc90b4f$var$_indexOf.default)(seen).call(seen, seenEntry) > -1 || value.dirty() || (0, $c364a939edc90b4f$var$_keys.default)(value._getServerData()).length < 1) {
            var _context;
            if (offline && (0, $c364a939edc90b4f$var$_startsWith.default)(_context = value._getId()).call(_context, "local")) return value.toOfflinePointer();
            return value.toPointer();
        }
        seen = (0, $c364a939edc90b4f$var$_concat.default)(seen).call(seen, seenEntry);
        return value._toFullJSON(seen, offline);
    }
    if (value instanceof $1WcLm.Op || value instanceof $c364a939edc90b4f$var$_ParseACL.default || value instanceof $c364a939edc90b4f$var$_ParseGeoPoint.default || value instanceof $c364a939edc90b4f$var$_ParsePolygon.default || value instanceof $c364a939edc90b4f$var$_ParseRelation.default) return value.toJSON();
    if (value instanceof $c364a939edc90b4f$var$_ParseFile.default) {
        if (!value.url()) throw new Error("Tried to encode an unsaved file.");
        return value.toJSON();
    }
    if (Object.prototype.toString.call(value) === "[object Date]") {
        if (isNaN(value)) throw new Error("Tried to encode an invalid date.");
        return {
            __type: "Date",
            iso: value/*: any*/ .toJSON()
        };
    }
    if (Object.prototype.toString.call(value) === "[object RegExp]" && typeof value.source === "string") return value.source;
    if ((0, $c364a939edc90b4f$var$_isArray.default)(value)) return (0, $c364a939edc90b4f$var$_map.default)(value).call(value, function(v) {
        return $c364a939edc90b4f$var$encode(v, disallowObjects, forcePointers, seen, offline);
    });
    if (value && (0, $c364a939edc90b4f$var$_typeof2.default)(value) === "object") {
        var output = {};
        for(var k in value)output[k] = $c364a939edc90b4f$var$encode(value[k], disallowObjects, forcePointers, seen, offline);
        return output;
    }
    return value;
}
function $c364a939edc90b4f$var$_default(value, disallowObjects, forcePointers, seen, offline) /*: any*/ {
    return $c364a939edc90b4f$var$encode(value, !!disallowObjects, !!forcePointers, seen || [], offline);
}

});
parcelRequire.register("fgj1z", function(module, exports) {

module.exports = (parcelRequire("5G9JK"));

});
parcelRequire.register("5G9JK", function(module, exports) {

var $dyG4h = parcelRequire("dyG4h");
module.exports = $dyG4h;

});
parcelRequire.register("dyG4h", function(module, exports) {

var $5L8hR = parcelRequire("5L8hR");

var $fNmS6 = parcelRequire("fNmS6");
var $9def152cc1b25c65$var$StringPrototype = String.prototype;
module.exports = function(it) {
    var own = it.startsWith;
    return typeof it == "string" || it === $9def152cc1b25c65$var$StringPrototype || $5L8hR($9def152cc1b25c65$var$StringPrototype, it) && own === $9def152cc1b25c65$var$StringPrototype.startsWith ? $fNmS6 : own;
};

});
parcelRequire.register("fNmS6", function(module, exports) {
parcelRequire("8nOhk");

var $hESIr = parcelRequire("hESIr");
module.exports = $hESIr("String").startsWith;

});
parcelRequire.register("8nOhk", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $fCzmA = parcelRequire("fCzmA");

var $6IpKK = parcelRequire("6IpKK");
var $61a778f8a7abce7f$require$getOwnPropertyDescriptor = $6IpKK.f;

var $5zf2j = parcelRequire("5zf2j");

var $eG0jW = parcelRequire("eG0jW");

var $fqTB3 = parcelRequire("fqTB3");

var $dfvEY = parcelRequire("dfvEY");

var $8B4KA = parcelRequire("8B4KA");

var $2EepY = parcelRequire("2EepY");
// eslint-disable-next-line es/no-string-prototype-startswith -- safe
var $61a778f8a7abce7f$var$nativeStartsWith = $fCzmA("".startsWith);
var $61a778f8a7abce7f$var$stringSlice = $fCzmA("".slice);
var $61a778f8a7abce7f$var$min = Math.min;
var $61a778f8a7abce7f$var$CORRECT_IS_REGEXP_LOGIC = $8B4KA("startsWith");
// https://github.com/zloirock/core-js/pull/702
var $61a778f8a7abce7f$var$MDN_POLYFILL_BUG = !$2EepY && !$61a778f8a7abce7f$var$CORRECT_IS_REGEXP_LOGIC && !!function() {
    var descriptor = $61a778f8a7abce7f$require$getOwnPropertyDescriptor(String.prototype, "startsWith");
    return descriptor && !descriptor.writable;
}();
// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$g2B3u({
    target: "String",
    proto: true,
    forced: !$61a778f8a7abce7f$var$MDN_POLYFILL_BUG && !$61a778f8a7abce7f$var$CORRECT_IS_REGEXP_LOGIC
}, {
    startsWith: function startsWith(searchString /* , position = 0 */ ) {
        var that = $eG0jW($dfvEY(this));
        $fqTB3(searchString);
        var index = $5zf2j($61a778f8a7abce7f$var$min(arguments.length > 1 ? arguments[1] : undefined, that.length));
        var search = $eG0jW(searchString);
        return $61a778f8a7abce7f$var$nativeStartsWith ? $61a778f8a7abce7f$var$nativeStartsWith(that, search, index) : $61a778f8a7abce7f$var$stringSlice(that, index, index + search.length) === search;
    }
});

});





parcelRequire.register("5vhig", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $evY07 = parcelRequire("evY07");
$evY07(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $401d432a7ae12b20$var$_typeof2 = $3Npdz((parcelRequire("akViX")));

var $401d432a7ae12b20$var$_isArray = $3Npdz((parcelRequire("i0kCX")));

var $401d432a7ae12b20$var$_classCallCheck2 = $3Npdz((parcelRequire("9pQKE")));

var $401d432a7ae12b20$var$_createClass2 = $3Npdz((parcelRequire("eZYdV")));

var $401d432a7ae12b20$var$_defineProperty2 = $3Npdz((parcelRequire("bci6G")));
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ /**
 * Creates a new GeoPoint with any of the following forms:<br>
 *   <pre>
 *   new GeoPoint(otherGeoPoint)
 *   new GeoPoint(30, 30)
 *   new GeoPoint([30, 30])
 *   new GeoPoint({latitude: 30, longitude: 30})
 *   new GeoPoint()  // defaults to (0, 0)
 *   </pre>
 * <p>Represents a latitude / longitude point that may be associated
 * with a key in a ParseObject or used as a reference point for geo queries.
 * This allows proximity-based queries on the key.</p>
 *
 * <p>Only one key in a class may contain a GeoPoint.</p>
 *
 * <p>Example:<pre>
 *   var point = new Parse.GeoPoint(30.0, -20.0);
 *   var object = new Parse.Object("PlaceObject");
 *   object.set("location", point);
 *   object.save();</pre></p>
 *
 * @alias Parse.GeoPoint
 */ /* global navigator */ var $401d432a7ae12b20$var$ParseGeoPoint = /*#__PURE__*/ function() {
    /**
   * @param {(number[] | object | number)} arg1 Either a list of coordinate pairs, an object with `latitude`, `longitude`, or the latitude or the point.
   * @param {number} arg2 The longitude of the GeoPoint
   */ function ParseGeoPoint(arg1, arg2) {
        (0, $401d432a7ae12b20$var$_classCallCheck2.default)(this, ParseGeoPoint);
        (0, $401d432a7ae12b20$var$_defineProperty2.default)(this, "_latitude", void 0);
        (0, $401d432a7ae12b20$var$_defineProperty2.default)(this, "_longitude", void 0);
        if ((0, $401d432a7ae12b20$var$_isArray.default)(arg1)) {
            ParseGeoPoint._validate(arg1[0], arg1[1]);
            this._latitude = arg1[0];
            this._longitude = arg1[1];
        } else if ((0, $401d432a7ae12b20$var$_typeof2.default)(arg1) === "object") {
            ParseGeoPoint._validate(arg1.latitude, arg1.longitude);
            this._latitude = arg1.latitude;
            this._longitude = arg1.longitude;
        } else if (arg1 !== undefined && arg2 !== undefined) {
            ParseGeoPoint._validate(arg1, arg2);
            this._latitude = arg1;
            this._longitude = arg2;
        } else {
            this._latitude = 0;
            this._longitude = 0;
        }
    }
    /**
   * North-south portion of the coordinate, in range [-90, 90].
   * Throws an exception if set out of range in a modern browser.
   *
   * @property {number} latitude
   * @returns {number}
   */ (0, $401d432a7ae12b20$var$_createClass2.default)(ParseGeoPoint, [
        {
            key: "latitude",
            get: function() /*: number*/ {
                return this._latitude;
            },
            set: function(val) {
                ParseGeoPoint._validate(val, this.longitude);
                this._latitude = val;
            }
        },
        {
            key: "longitude",
            get: function() /*: number*/ {
                return this._longitude;
            },
            set: function(val) {
                ParseGeoPoint._validate(this.latitude, val);
                this._longitude = val;
            }
        },
        {
            key: "toJSON",
            value: function() /*: { __type: string, latitude: number, longitude: number }*/ {
                ParseGeoPoint._validate(this._latitude, this._longitude);
                return {
                    __type: "GeoPoint",
                    latitude: this._latitude,
                    longitude: this._longitude
                };
            }
        },
        {
            key: "equals",
            value: function(other) /*: boolean*/ {
                return other instanceof ParseGeoPoint && this.latitude === other.latitude && this.longitude === other.longitude;
            }
        },
        {
            key: "radiansTo",
            value: function(point) /*: number*/ {
                var d2r = Math.PI / 180.0;
                var lat1rad = this.latitude * d2r;
                var long1rad = this.longitude * d2r;
                var lat2rad = point.latitude * d2r;
                var long2rad = point.longitude * d2r;
                var sinDeltaLatDiv2 = Math.sin((lat1rad - lat2rad) / 2);
                var sinDeltaLongDiv2 = Math.sin((long1rad - long2rad) / 2); // Square of half the straight line chord distance between both points.
                var a = sinDeltaLatDiv2 * sinDeltaLatDiv2 + Math.cos(lat1rad) * Math.cos(lat2rad) * sinDeltaLongDiv2 * sinDeltaLongDiv2;
                a = Math.min(1.0, a);
                return 2 * Math.asin(Math.sqrt(a));
            }
        },
        {
            key: "kilometersTo",
            value: function(point) /*: number*/ {
                return this.radiansTo(point) * 6371.0;
            }
        },
        {
            key: "milesTo",
            value: function(point) /*: number*/ {
                return this.radiansTo(point) * 3958.8;
            }
        }
    ], [
        {
            key: "_validate",
            value: function(latitude, longitude) {
                if (isNaN(latitude) || isNaN(longitude) || typeof latitude !== "number" || typeof longitude !== "number") throw new TypeError("GeoPoint latitude and longitude must be valid numbers");
                if (latitude < -90) throw new TypeError("GeoPoint latitude out of bounds: " + latitude + " < -90.0.");
                if (latitude > 90.0) throw new TypeError("GeoPoint latitude out of bounds: " + latitude + " > 90.0.");
                if (longitude < -180) throw new TypeError("GeoPoint longitude out of bounds: " + longitude + " < -180.0.");
                if (longitude > 180.0) throw new TypeError("GeoPoint longitude out of bounds: " + longitude + " > 180.0.");
            }
        },
        {
            key: "current",
            value: function() {
                return navigator.geolocation.getCurrentPosition(function(location) {
                    return new ParseGeoPoint(location.coords.latitude, location.coords.longitude);
                });
            }
        }
    ]);
    return ParseGeoPoint;
}();
var $401d432a7ae12b20$var$_default = $401d432a7ae12b20$var$ParseGeoPoint;
module.exports.default = $401d432a7ae12b20$var$_default;

});

parcelRequire.register("dkxwb", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $evY07 = parcelRequire("evY07");
$evY07(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9b47249e4490c21b$var$_isArray = $3Npdz((parcelRequire("i0kCX")));

var $9b47249e4490c21b$var$_classCallCheck2 = $3Npdz((parcelRequire("9pQKE")));

var $9b47249e4490c21b$var$_createClass2 = $3Npdz((parcelRequire("eZYdV")));

var $9b47249e4490c21b$var$_defineProperty2 = $3Npdz((parcelRequire("bci6G")));

var $9b47249e4490c21b$var$_ParseGeoPoint = $3Npdz((parcelRequire("5vhig")));
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ /**
 * Creates a new Polygon with any of the following forms:<br>
 *   <pre>
 *   new Polygon([[0,0],[0,1],[1,1],[1,0]])
 *   new Polygon([GeoPoint, GeoPoint, GeoPoint])
 *   </pre>
 *
 * <p>Represents a coordinates that may be associated
 * with a key in a ParseObject or used as a reference point for geo queries.
 * This allows proximity-based queries on the key.</p>
 *
 * <p>Example:<pre>
 *   var polygon = new Parse.Polygon([[0,0],[0,1],[1,1],[1,0]]);
 *   var object = new Parse.Object("PlaceObject");
 *   object.set("area", polygon);
 *   object.save();</pre></p>
 *
 * @alias Parse.Polygon
 */ var $9b47249e4490c21b$var$ParsePolygon = /*#__PURE__*/ function() {
    /**
   * @param {(number[][] | Parse.GeoPoint[])} coordinates An Array of coordinate pairs
   */ function ParsePolygon(coordinates) {
        (0, $9b47249e4490c21b$var$_classCallCheck2.default)(this, ParsePolygon);
        (0, $9b47249e4490c21b$var$_defineProperty2.default)(this, "_coordinates", void 0);
        this._coordinates = ParsePolygon._validate(coordinates);
    }
    /**
   * Coordinates value for this Polygon.
   * Throws an exception if not valid type.
   *
   * @property {(number[][] | Parse.GeoPoint[])} coordinates list of coordinates
   * @returns {number[][]}
   */ (0, $9b47249e4490c21b$var$_createClass2.default)(ParsePolygon, [
        {
            key: "coordinates",
            get: function() /*: Array<Array<number>>*/ {
                return this._coordinates;
            },
            set: function(coords) {
                this._coordinates = ParsePolygon._validate(coords);
            }
        },
        {
            key: "toJSON",
            value: function() /*: { __type: string, coordinates: Array<Array<number>> }*/ {
                ParsePolygon._validate(this._coordinates);
                return {
                    __type: "Polygon",
                    coordinates: this._coordinates
                };
            }
        },
        {
            key: "equals",
            value: function(other) /*: boolean*/ {
                if (!(other instanceof ParsePolygon) || this.coordinates.length !== other.coordinates.length) return false;
                var isEqual = true;
                for(var i = 1; i < this._coordinates.length; i += 1)if (this._coordinates[i][0] != other.coordinates[i][0] || this._coordinates[i][1] != other.coordinates[i][1]) {
                    isEqual = false;
                    break;
                }
                return isEqual;
            }
        },
        {
            key: "containsPoint",
            value: function(point) /*: boolean*/ {
                var minX = this._coordinates[0][0];
                var maxX = this._coordinates[0][0];
                var minY = this._coordinates[0][1];
                var maxY = this._coordinates[0][1];
                for(var i = 1; i < this._coordinates.length; i += 1){
                    var p = this._coordinates[i];
                    minX = Math.min(p[0], minX);
                    maxX = Math.max(p[0], maxX);
                    minY = Math.min(p[1], minY);
                    maxY = Math.max(p[1], maxY);
                }
                var outside = point.latitude < minX || point.latitude > maxX || point.longitude < minY || point.longitude > maxY;
                if (outside) return false;
                var inside = false;
                for(var _i = 0, j = this._coordinates.length - 1; _i < this._coordinates.length; j = _i++){
                    var startX = this._coordinates[_i][0];
                    var startY = this._coordinates[_i][1];
                    var endX = this._coordinates[j][0];
                    var endY = this._coordinates[j][1];
                    var intersect = startY > point.longitude != endY > point.longitude && point.latitude < (endX - startX) * (point.longitude - startY) / (endY - startY) + startX;
                    if (intersect) inside = !inside;
                }
                return inside;
            }
        }
    ], [
        {
            key: "_validate",
            value: function(coords) /*: Array<Array<number>>*/ {
                if (!(0, $9b47249e4490c21b$var$_isArray.default)(coords)) throw new TypeError("Coordinates must be an Array");
                if (coords.length < 3) throw new TypeError("Polygon must have at least 3 GeoPoints or Points");
                var points = [];
                for(var i = 0; i < coords.length; i += 1){
                    var coord = coords[i];
                    var geoPoint = void 0;
                    if (coord instanceof $9b47249e4490c21b$var$_ParseGeoPoint.default) geoPoint = coord;
                    else if ((0, $9b47249e4490c21b$var$_isArray.default)(coord) && coord.length === 2) geoPoint = new $9b47249e4490c21b$var$_ParseGeoPoint.default(coord[0], coord[1]);
                    else throw new TypeError("Coordinates must be an Array of GeoPoints or Points");
                    points.push([
                        geoPoint.latitude,
                        geoPoint.longitude
                    ]);
                }
                return points;
            }
        }
    ]);
    return ParsePolygon;
}();
var $9b47249e4490c21b$var$_default = $9b47249e4490c21b$var$ParsePolygon;
module.exports.default = $9b47249e4490c21b$var$_default;

});


parcelRequire.register("cQimZ", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $evY07 = parcelRequire("evY07");
$evY07(module.exports, "__esModule", {
    value: true
});
module.exports.default = $95989735f5b0b345$var$unique;

var $95989735f5b0b345$var$_indexOf = $3Npdz((parcelRequire("eOZH4")));

var $95989735f5b0b345$var$_forEach = $3Npdz((parcelRequire("jZGC2")));

var $95989735f5b0b345$var$_arrayContainsObject = $3Npdz((parcelRequire("5K0EB")));

var $95989735f5b0b345$var$_ParseObject = $3Npdz((parcelRequire("2HIpX")));
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ function $95989735f5b0b345$var$unique(arr) /*: Array<T>*/ {
    var uniques = [];
    (0, $95989735f5b0b345$var$_forEach.default)(arr).call(arr, function(value) {
        if (value instanceof $95989735f5b0b345$var$_ParseObject.default) {
            if (!(0, $95989735f5b0b345$var$_arrayContainsObject.default)(uniques, value)) uniques.push(value);
        } else if ((0, $95989735f5b0b345$var$_indexOf.default)(uniques).call(uniques, value) < 0) uniques.push(value);
    });
    return uniques;
}

});


parcelRequire.register("eJCLn", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");


var $iY2ec = parcelRequire("iY2ec");


var $iWJ3a = parcelRequire("iWJ3a");



var $cO2y8 = parcelRequire("cO2y8");

var $dvfqn = parcelRequire("dvfqn");

var $evY07 = parcelRequire("evY07");

var $ebK4m = parcelRequire("ebK4m");
$evY07(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aba3563ab31b6b2a$var$_entries = $3Npdz((parcelRequire("fsovd")));

var $aba3563ab31b6b2a$var$_slicedToArray2 = $3Npdz((parcelRequire("5kSp4")));

var $aba3563ab31b6b2a$var$_isArray = $3Npdz((parcelRequire("i0kCX")));

var $aba3563ab31b6b2a$var$_toConsumableArray2 = $3Npdz((parcelRequire("6VZVY")));

var $aba3563ab31b6b2a$var$_find = $3Npdz((parcelRequire("jGOxU")));

var $aba3563ab31b6b2a$var$_promise = $3Npdz((parcelRequire("bCWDe")));

var $aba3563ab31b6b2a$var$_splice = $3Npdz((parcelRequire("5SAes")));

var $aba3563ab31b6b2a$var$_sort = $3Npdz((parcelRequire("lzvCu")));

var $aba3563ab31b6b2a$var$_includes = $3Npdz((parcelRequire("aUw0k")));

var $aba3563ab31b6b2a$var$_concat = $3Npdz((parcelRequire("3mvQI")));

var $aba3563ab31b6b2a$var$_keys = $3Npdz((parcelRequire("gKrgO")));

var $aba3563ab31b6b2a$var$_filter2 = $3Npdz((parcelRequire("kYm0J")));

var $aba3563ab31b6b2a$var$_asyncToGenerator2 = $3Npdz((parcelRequire("iqZS2")));

var $aba3563ab31b6b2a$var$_map2 = $3Npdz((parcelRequire("hqsP5")));

var $aba3563ab31b6b2a$var$_classCallCheck2 = $3Npdz((parcelRequire("9pQKE")));

var $aba3563ab31b6b2a$var$_createClass2 = $3Npdz((parcelRequire("eZYdV")));

var $aba3563ab31b6b2a$var$_defineProperty2 = $3Npdz((parcelRequire("bci6G")));

var $aba3563ab31b6b2a$var$_slice = $3Npdz((parcelRequire("fG1Ke")));

var $aba3563ab31b6b2a$var$_keys2 = $3Npdz((parcelRequire("r9mpE")));

var $aba3563ab31b6b2a$var$_typeof2 = $3Npdz((parcelRequire("akViX")));

var $aba3563ab31b6b2a$var$_indexOf = $3Npdz((parcelRequire("eOZH4")));

var $aba3563ab31b6b2a$var$_forEach = $3Npdz((parcelRequire("jZGC2")));

var $aba3563ab31b6b2a$var$_CoreManager = $3Npdz((parcelRequire("465CW")));

var $aba3563ab31b6b2a$var$_encode = $3Npdz((parcelRequire("gM4ym")));

var $j0i6P = parcelRequire("j0i6P");

var $aba3563ab31b6b2a$var$_ParseError = $3Npdz((parcelRequire("3HQSG")));

var $aba3563ab31b6b2a$var$_ParseGeoPoint = $3Npdz((parcelRequire("5vhig")));

var $aba3563ab31b6b2a$var$_ParseObject = $3Npdz((parcelRequire("2HIpX")));

var $aba3563ab31b6b2a$var$_OfflineQuery = $3Npdz((parcelRequire("1e9ZI")));

var $7Icwu = parcelRequire("7Icwu");
function $aba3563ab31b6b2a$var$_regeneratorRuntime() {
    "use strict";
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ $aba3563ab31b6b2a$var$_regeneratorRuntime = function() {
        return exports1;
    };
    var exports1 = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof $ebK4m ? $ebK4m : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return $evY07(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = $dvfqn(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return generator._invoke = function(innerFn, self, context) {
            var state = "suspendedStart";
            return function(method, arg) {
                if ("executing" === state) throw new Error("Generator is already running");
                if ("completed" === state) {
                    if ("throw" === method) throw arg;
                    return doneResult();
                }
                for(context.method = method, context.arg = arg;;){
                    var delegate = context.delegate;
                    if (delegate) {
                        var delegateResult = maybeInvokeDelegate(delegate, context);
                        if (delegateResult) {
                            if (delegateResult === ContinueSentinel) continue;
                            return delegateResult;
                        }
                    }
                    if ("next" === context.method) context.sent = context._sent = context.arg;
                    else if ("throw" === context.method) {
                        if ("suspendedStart" === state) throw state = "completed", context.arg;
                        context.dispatchException(context.arg);
                    } else "return" === context.method && context.abrupt("return", context.arg);
                    state = "executing";
                    var record = tryCatch(innerFn, self, context);
                    if ("normal" === record.type) {
                        if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                        return {
                            value: record.arg,
                            done: context.done
                        };
                    }
                    "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
                }
            };
        }(innerFn, self, context), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports1.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = $cO2y8, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = $dvfqn(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        var _context23;
        (parcelRequire("jZGC2"))(_context23 = [
            "next",
            "throw",
            "return"
        ]).call(_context23, function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == (parcelRequire("akViX"))(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        this._invoke = function(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];
        if (undefined === method) {
            if (context.delegate = null, "throw" === context.method) {
                if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
                context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], (parcelRequire("jZGC2"))(tryLocsList).call(tryLocsList, pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;){
                        if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    }
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports1.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports1.mark = function(genFun) {
        return $iWJ3a ? $iWJ3a(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = $dvfqn(Gp), genFun;
    }, exports1.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports1.AsyncIterator = AsyncIterator, exports1.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = (parcelRequire("bCWDe")));
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports1.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports1.keys = function(object) {
        var keys = [];
        for(var key in object)keys.push(key);
        return $iY2ec(keys).call(keys), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports1.values = values, Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            var _context24;
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, (parcelRequire("jZGC2"))(_context24 = this.tryEntries).call(_context24, resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+(parcelRequire("fG1Ke"))(name).call(name, 1)) && (this[name] = undefined);
        },
        stop: function() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports1;
}
/**
 * Converts a string into a regex that matches it.
 * Surrounding with \Q .. \E does this, we just need to escape any \E's in
 * the text separately.
 *
 * @param s
 * @private
 * @returns {string}
 */ function $aba3563ab31b6b2a$var$quote(s) /*: string*/ {
    return "\\Q" + s.replace("\\E", "\\E\\\\E\\Q") + "\\E";
}
/**
 * Extracts the class name from queries. If not all queries have the same
 * class name an error will be thrown.
 *
 * @param queries
 * @private
 * @returns {string}
 */ function $aba3563ab31b6b2a$var$_getClassNameFromQueries(queries) /*: ?string*/ {
    var className = null;
    (0, $aba3563ab31b6b2a$var$_forEach.default)(queries).call(queries, function(q) {
        if (!className) className = q.className;
        if (className !== q.className) throw new Error("All queries must be for the same class.");
    });
    return className;
}
/*
 * Handles pre-populating the result data of a query with select fields,
 * making sure that the data object contains keys for all objects that have
 * been requested with a select, so that our cached state updates correctly.
 */ function $aba3563ab31b6b2a$var$handleSelectResult(data, select) {
    var serverDataMask = {};
    (0, $aba3563ab31b6b2a$var$_forEach.default)(select).call(select, function(field) {
        var hasSubObjectSelect = (0, $aba3563ab31b6b2a$var$_indexOf.default)(field).call(field, ".") !== -1;
        if (!hasSubObjectSelect && !data.hasOwnProperty(field)) // this field was selected, but is missing from the retrieved data
        data[field] = undefined;
        else if (hasSubObjectSelect) {
            // this field references a sub-object,
            // so we need to walk down the path components
            var pathComponents = field.split(".");
            var _obj = data;
            var serverMask = serverDataMask;
            (0, $aba3563ab31b6b2a$var$_forEach.default)(pathComponents).call(pathComponents, function(component, index, arr) {
                // add keys if the expected data is missing
                if (_obj && !_obj.hasOwnProperty(component)) _obj[component] = undefined;
                if (_obj && (0, $aba3563ab31b6b2a$var$_typeof2.default)(_obj) === "object") _obj = _obj[component];
                 //add this path component to the server mask so we can fill it in later if needed
                if (index < arr.length - 1) {
                    if (!serverMask[component]) serverMask[component] = {};
                    serverMask = serverMask[component];
                }
            });
        }
    });
    if ((0, $aba3563ab31b6b2a$var$_keys2.default)(serverDataMask).length > 0) {
        // When selecting from sub-objects, we don't want to blow away the missing
        // information that we may have retrieved before. We've already added any
        // missing selected keys to sub-objects, but we still need to add in the
        // data for any previously retrieved sub-objects that were not selected.
        var serverData = $aba3563ab31b6b2a$var$_CoreManager.default.getObjectStateController().getServerData({
            id: data.objectId,
            className: data.className
        });
        $aba3563ab31b6b2a$var$copyMissingDataWithMask(serverData, data, serverDataMask, false);
    }
}
function $aba3563ab31b6b2a$var$copyMissingDataWithMask(src, dest, mask, copyThisLevel) {
    //copy missing elements at this level
    if (copyThisLevel) {
        for(var _key in src)if (src.hasOwnProperty(_key) && !dest.hasOwnProperty(_key)) dest[_key] = src[_key];
    }
    for(var _key2 in mask)if (dest[_key2] !== undefined && dest[_key2] !== null && src !== undefined && src !== null) //traverse into objects as needed
    $aba3563ab31b6b2a$var$copyMissingDataWithMask(src[_key2], dest[_key2], mask[_key2], true);
}
function $aba3563ab31b6b2a$var$handleOfflineSort(a, b, sorts) {
    var order = sorts[0];
    var operator = (0, $aba3563ab31b6b2a$var$_slice.default)(order).call(order, 0, 1);
    var isDescending = operator === "-";
    if (isDescending) order = order.substring(1);
    if (order === "_created_at") order = "createdAt";
    if (order === "_updated_at") order = "updatedAt";
    if (!/^[A-Za-z][0-9A-Za-z_]*$/.test(order) || order === "password") throw new $aba3563ab31b6b2a$var$_ParseError.default($aba3563ab31b6b2a$var$_ParseError.default.INVALID_KEY_NAME, "Invalid Key: ".concat(order));
    var field1 = a.get(order);
    var field2 = b.get(order);
    if (field1 < field2) return isDescending ? 1 : -1;
    if (field1 > field2) return isDescending ? -1 : 1;
    if (sorts.length > 1) {
        var remainingSorts = (0, $aba3563ab31b6b2a$var$_slice.default)(sorts).call(sorts, 1);
        return $aba3563ab31b6b2a$var$handleOfflineSort(a, b, remainingSorts);
    }
    return 0;
}
/**
 * Creates a new parse Parse.Query for the given Parse.Object subclass.
 *
 * <p>Parse.Query defines a query that is used to fetch Parse.Objects. The
 * most common use case is finding all objects that match a query through the
 * <code>find</code> method. for example, this sample code fetches all objects
 * of class <code>myclass</code>. it calls a different function depending on
 * whether the fetch succeeded or not.
 *
 * <pre>
 * var query = new Parse.Query(myclass);
 * query.find().then((results) => {
 *   // results is an array of parse.object.
 * }).catch((error) =>  {
 *  // error is an instance of parse.error.
 * });</pre></p>
 *
 * <p>a Parse.Query can also be used to retrieve a single object whose id is
 * known, through the get method. for example, this sample code fetches an
 * object of class <code>myclass</code> and id <code>myid</code>. it calls a
 * different function depending on whether the fetch succeeded or not.
 *
 * <pre>
 * var query = new Parse.Query(myclass);
 * query.get(myid).then((object) => {
 *     // object is an instance of parse.object.
 * }).catch((error) =>  {
 *  // error is an instance of parse.error.
 * });</pre></p>
 *
 * <p>a Parse.Query can also be used to count the number of objects that match
 * the query without retrieving all of those objects. for example, this
 * sample code counts the number of objects of the class <code>myclass</code>
 * <pre>
 * var query = new Parse.Query(myclass);
 * query.count().then((number) => {
 *     // there are number instances of myclass.
 * }).catch((error) => {
 *     // error is an instance of Parse.Error.
 * });</pre></p>
 *
 * @alias Parse.Query
 */ var $aba3563ab31b6b2a$var$ParseQuery = /*#__PURE__*/ function() {
    /**
   * @property {string} className
   */ /**
   * @param {(string | Parse.Object)} objectClass An instance of a subclass of Parse.Object, or a Parse className string.
   */ function ParseQuery(objectClass) {
        (0, $aba3563ab31b6b2a$var$_classCallCheck2.default)(this, ParseQuery);
        (0, $aba3563ab31b6b2a$var$_defineProperty2.default)(this, "className", void 0);
        (0, $aba3563ab31b6b2a$var$_defineProperty2.default)(this, "_where", void 0);
        (0, $aba3563ab31b6b2a$var$_defineProperty2.default)(this, "_include", void 0);
        (0, $aba3563ab31b6b2a$var$_defineProperty2.default)(this, "_exclude", void 0);
        (0, $aba3563ab31b6b2a$var$_defineProperty2.default)(this, "_select", void 0);
        (0, $aba3563ab31b6b2a$var$_defineProperty2.default)(this, "_limit", void 0);
        (0, $aba3563ab31b6b2a$var$_defineProperty2.default)(this, "_skip", void 0);
        (0, $aba3563ab31b6b2a$var$_defineProperty2.default)(this, "_count", void 0);
        (0, $aba3563ab31b6b2a$var$_defineProperty2.default)(this, "_order", void 0);
        (0, $aba3563ab31b6b2a$var$_defineProperty2.default)(this, "_readPreference", void 0);
        (0, $aba3563ab31b6b2a$var$_defineProperty2.default)(this, "_includeReadPreference", void 0);
        (0, $aba3563ab31b6b2a$var$_defineProperty2.default)(this, "_subqueryReadPreference", void 0);
        (0, $aba3563ab31b6b2a$var$_defineProperty2.default)(this, "_queriesLocalDatastore", void 0);
        (0, $aba3563ab31b6b2a$var$_defineProperty2.default)(this, "_localDatastorePinName", void 0);
        (0, $aba3563ab31b6b2a$var$_defineProperty2.default)(this, "_extraOptions", void 0);
        (0, $aba3563ab31b6b2a$var$_defineProperty2.default)(this, "_hint", void 0);
        (0, $aba3563ab31b6b2a$var$_defineProperty2.default)(this, "_explain", void 0);
        (0, $aba3563ab31b6b2a$var$_defineProperty2.default)(this, "_xhrRequest", void 0);
        if (typeof objectClass === "string") {
            if (objectClass === "User" && $aba3563ab31b6b2a$var$_CoreManager.default.get("PERFORM_USER_REWRITE")) this.className = "_User";
            else this.className = objectClass;
        } else if (objectClass instanceof $aba3563ab31b6b2a$var$_ParseObject.default) this.className = objectClass.className;
        else if (typeof objectClass === "function") {
            if (typeof objectClass.className === "string") this.className = objectClass.className;
            else {
                var _obj2 = new objectClass();
                this.className = _obj2.className;
            }
        } else throw new TypeError("A ParseQuery must be constructed with a ParseObject or class name.");
        this._where = {};
        this._include = [];
        this._exclude = [];
        this._count = false;
        this._limit = -1; // negative limit is not sent in the server request
        this._skip = 0;
        this._readPreference = null;
        this._includeReadPreference = null;
        this._subqueryReadPreference = null;
        this._queriesLocalDatastore = false;
        this._localDatastorePinName = null;
        this._extraOptions = {};
        this._xhrRequest = {
            task: null,
            onchange: function() {}
        };
    }
    /**
   * Adds constraint that at least one of the passed in queries matches.
   *
   * @param {Array} queries
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ (0, $aba3563ab31b6b2a$var$_createClass2.default)(ParseQuery, [
        {
            key: "_orQuery",
            value: function(queries) /*: ParseQuery*/ {
                var queryJSON = (0, $aba3563ab31b6b2a$var$_map2.default)(queries).call(queries, function(q) {
                    return q.toJSON().where;
                });
                this._where.$or = queryJSON;
                return this;
            }
        },
        {
            key: "_andQuery",
            value: function(queries) /*: ParseQuery*/ {
                var queryJSON = (0, $aba3563ab31b6b2a$var$_map2.default)(queries).call(queries, function(q) {
                    return q.toJSON().where;
                });
                this._where.$and = queryJSON;
                return this;
            }
        },
        {
            key: "_norQuery",
            value: function(queries) /*: ParseQuery*/ {
                var queryJSON = (0, $aba3563ab31b6b2a$var$_map2.default)(queries).call(queries, function(q) {
                    return q.toJSON().where;
                });
                this._where.$nor = queryJSON;
                return this;
            }
        },
        {
            key: "_addCondition",
            value: function(key, condition, value) /*: ParseQuery*/ {
                if (!this._where[key] || typeof this._where[key] === "string") this._where[key] = {};
                this._where[key][condition] = (0, $aba3563ab31b6b2a$var$_encode.default)(value, false, true);
                return this;
            }
        },
        {
            key: "_regexStartWith",
            value: function(string) /*: string*/ {
                return "^" + $aba3563ab31b6b2a$var$quote(string);
            }
        },
        {
            key: "_handleOfflineQuery",
            value: function() {
                var _handleOfflineQuery2 = (0, $aba3563ab31b6b2a$var$_asyncToGenerator2.default)(/*#__PURE__*/ $aba3563ab31b6b2a$var$_regeneratorRuntime().mark(function _callee(params) {
                    var _context, _this2 = this;
                    var localDatastore, objects, results, keys, alwaysSelectedKeys, sorts, count, limit;
                    return $aba3563ab31b6b2a$var$_regeneratorRuntime().wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                $aba3563ab31b6b2a$var$_OfflineQuery.default.validateQuery(this);
                                localDatastore = $aba3563ab31b6b2a$var$_CoreManager.default.getLocalDatastore();
                                _context3.next = 4;
                                return localDatastore._serializeObjectsFromPinName(this._localDatastorePinName);
                            case 4:
                                objects = _context3.sent;
                                results = (0, $aba3563ab31b6b2a$var$_filter2.default)(_context = (0, $aba3563ab31b6b2a$var$_map2.default)(objects).call(objects, function(json, index, arr) {
                                    var object = $aba3563ab31b6b2a$var$_ParseObject.default.fromJSON(json, false);
                                    if (json._localId && !json.objectId) object._localId = json._localId;
                                    if (!$aba3563ab31b6b2a$var$_OfflineQuery.default.matchesQuery(_this2.className, object, arr, _this2)) return null;
                                    return object;
                                })).call(_context, function(object) {
                                    return object !== null;
                                });
                                if ((0, $aba3563ab31b6b2a$var$_keys.default)(params)) {
                                    keys = (0, $aba3563ab31b6b2a$var$_keys.default)(params).split(",");
                                    alwaysSelectedKeys = [
                                        "className",
                                        "objectId",
                                        "createdAt",
                                        "updatedAt",
                                        "ACL"
                                    ];
                                    keys = (0, $aba3563ab31b6b2a$var$_concat.default)(keys).call(keys, alwaysSelectedKeys);
                                    results = (0, $aba3563ab31b6b2a$var$_map2.default)(results).call(results, function(object) {
                                        var _context2;
                                        var json = object._toFullJSON();
                                        (0, $aba3563ab31b6b2a$var$_forEach.default)(_context2 = (0, $aba3563ab31b6b2a$var$_keys2.default)(json)).call(_context2, function(key) {
                                            if (!(0, $aba3563ab31b6b2a$var$_includes.default)(keys).call(keys, key)) delete json[key];
                                        });
                                        return $aba3563ab31b6b2a$var$_ParseObject.default.fromJSON(json, false);
                                    });
                                }
                                if (params.order) {
                                    sorts = params.order.split(",");
                                    (0, $aba3563ab31b6b2a$var$_sort.default)(results).call(results, function(a, b) {
                                        return $aba3563ab31b6b2a$var$handleOfflineSort(a, b, sorts);
                                    });
                                } // count total before applying limit/skip
                                if (params.count) count = results.length; // total count from response
                                if (params.skip) {
                                    if (params.skip >= results.length) results = [];
                                    else results = (0, $aba3563ab31b6b2a$var$_splice.default)(results).call(results, params.skip, results.length);
                                }
                                limit = results.length;
                                if (params.limit !== 0 && params.limit < results.length) limit = params.limit;
                                results = (0, $aba3563ab31b6b2a$var$_splice.default)(results).call(results, 0, limit);
                                if (!(typeof count === "number")) {
                                    _context3.next = 15;
                                    break;
                                }
                                return _context3.abrupt("return", {
                                    results: results,
                                    count: count
                                });
                            case 15:
                                return _context3.abrupt("return", results);
                            case 16:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee, this);
                }));
                function _handleOfflineQuery() {
                    return _handleOfflineQuery2.apply(this, arguments);
                }
                return _handleOfflineQuery;
            }()
        },
        {
            key: "toJSON",
            value: function() /*: QueryJSON*/ {
                var params = {
                    where: this._where
                };
                if (this._include.length) params.include = this._include.join(",");
                if (this._exclude.length) params.excludeKeys = this._exclude.join(",");
                if (this._select) params.keys = this._select.join(",");
                if (this._count) params.count = 1;
                if (this._limit >= 0) params.limit = this._limit;
                if (this._skip > 0) params.skip = this._skip;
                if (this._order) params.order = this._order.join(",");
                if (this._readPreference) params.readPreference = this._readPreference;
                if (this._includeReadPreference) params.includeReadPreference = this._includeReadPreference;
                if (this._subqueryReadPreference) params.subqueryReadPreference = this._subqueryReadPreference;
                if (this._hint) params.hint = this._hint;
                if (this._explain) params.explain = true;
                for(var _key3 in this._extraOptions)params[_key3] = this._extraOptions[_key3];
                return params;
            }
        },
        {
            key: "withJSON",
            value: function(json) /*: ParseQuery*/ {
                if (json.where) this._where = json.where;
                if (json.include) this._include = json.include.split(",");
                if ((0, $aba3563ab31b6b2a$var$_keys.default)(json)) this._select = (0, $aba3563ab31b6b2a$var$_keys.default)(json).split(",");
                if (json.excludeKeys) this._exclude = json.excludeKeys.split(",");
                if (json.count) this._count = json.count === 1;
                if (json.limit) this._limit = json.limit;
                if (json.skip) this._skip = json.skip;
                if (json.order) this._order = json.order.split(",");
                if (json.readPreference) this._readPreference = json.readPreference;
                if (json.includeReadPreference) this._includeReadPreference = json.includeReadPreference;
                if (json.subqueryReadPreference) this._subqueryReadPreference = json.subqueryReadPreference;
                if (json.hint) this._hint = json.hint;
                if (json.explain) this._explain = !!json.explain;
                for(var _key4 in json)if (json.hasOwnProperty(_key4)) {
                    var _context4;
                    if ((0, $aba3563ab31b6b2a$var$_indexOf.default)(_context4 = [
                        "where",
                        "include",
                        "keys",
                        "count",
                        "limit",
                        "skip",
                        "order",
                        "readPreference",
                        "includeReadPreference",
                        "subqueryReadPreference",
                        "hint",
                        "explain"
                    ]).call(_context4, _key4) === -1) this._extraOptions[_key4] = json[_key4];
                }
                return this;
            }
        },
        {
            key: "get",
            value: /**
     * Constructs a Parse.Object whose id is already known by fetching data from
     * the server. Unlike the <code>first</code> method, it never returns undefined.
     *
     * @param {string} objectId The id of the object to be fetched.
     * @param {object} options
     * Valid options are:<ul>
     *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
     *     be used for this request.
     *   <li>sessionToken: A valid session token, used for making a request on
     *       behalf of a specific user.
     *   <li>context: A dictionary that is accessible in Cloud Code `beforeFind` trigger.
     *   <li>json: Return raw json without converting to Parse.Object
     * </ul>
     *
     * @returns {Promise} A promise that is resolved with the result when
     * the query completes.
     */ function(objectId, options) /*: Promise<ParseObject>*/ {
                this.equalTo("objectId", objectId);
                var firstOptions = {};
                if (options && options.hasOwnProperty("useMasterKey")) firstOptions.useMasterKey = options.useMasterKey;
                if (options && options.hasOwnProperty("sessionToken")) firstOptions.sessionToken = options.sessionToken;
                if (options && options.hasOwnProperty("context") && (0, $aba3563ab31b6b2a$var$_typeof2.default)(options.context) === "object") firstOptions.context = options.context;
                if (options && options.hasOwnProperty("json")) firstOptions.json = options.json;
                return this.first(firstOptions).then(function(response) {
                    if (response) return response;
                    var errorObject = new $aba3563ab31b6b2a$var$_ParseError.default($aba3563ab31b6b2a$var$_ParseError.default.OBJECT_NOT_FOUND, "Object not found.");
                    return $aba3563ab31b6b2a$var$_promise.default.reject(errorObject);
                });
            }
        },
        {
            key: "find",
            value: function(options) /*: Promise<Array<ParseObject>>*/ {
                var _this3 = this;
                options = options || {};
                var findOptions = {};
                if (options.hasOwnProperty("useMasterKey")) findOptions.useMasterKey = options.useMasterKey;
                if (options.hasOwnProperty("sessionToken")) findOptions.sessionToken = options.sessionToken;
                if (options.hasOwnProperty("context") && (0, $aba3563ab31b6b2a$var$_typeof2.default)(options.context) === "object") findOptions.context = options.context;
                this._setRequestTask(findOptions);
                var controller = $aba3563ab31b6b2a$var$_CoreManager.default.getQueryController();
                var select = this._select;
                if (this._queriesLocalDatastore) return this._handleOfflineQuery(this.toJSON());
                return (0, $aba3563ab31b6b2a$var$_find.default)(controller).call(controller, this.className, this.toJSON(), findOptions).then(function(response) {
                    var _context5; // Return generic object when explain is used
                    if (_this3._explain) return response.results;
                    var results = (0, $aba3563ab31b6b2a$var$_map2.default)(_context5 = response.results).call(_context5, function(data) {
                        // In cases of relations, the server may send back a className
                        // on the top level of the payload
                        var override = response.className || _this3.className;
                        if (!data.className) data.className = override;
                         // Make sure the data object contains keys for all objects that
                        // have been requested with a select, so that our cached state
                        // updates correctly.
                        if (select) $aba3563ab31b6b2a$var$handleSelectResult(data, select);
                        if (options.json) return data;
                        else return $aba3563ab31b6b2a$var$_ParseObject.default.fromJSON(data, !select);
                    });
                    var count = response.count;
                    if (typeof count === "number") return {
                        results: results,
                        count: count
                    };
                    else return results;
                });
            }
        },
        {
            key: "findAll",
            value: function() {
                var _findAll = (0, $aba3563ab31b6b2a$var$_asyncToGenerator2.default)(/*#__PURE__*/ $aba3563ab31b6b2a$var$_regeneratorRuntime().mark(function _callee2(options) {
                    var result;
                    return $aba3563ab31b6b2a$var$_regeneratorRuntime().wrap(function _callee2$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                result = [];
                                _context7.next = 3;
                                return this.eachBatch(function(objects) {
                                    var _context6;
                                    result = (0, $aba3563ab31b6b2a$var$_concat.default)(_context6 = []).call(_context6, (0, $aba3563ab31b6b2a$var$_toConsumableArray2.default)(result), (0, $aba3563ab31b6b2a$var$_toConsumableArray2.default)(objects));
                                }, options);
                            case 3:
                                return _context7.abrupt("return", result);
                            case 4:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee2, this);
                }));
                function findAll(_x2) {
                    return _findAll.apply(this, arguments);
                }
                return findAll;
            }()
        },
        {
            key: "count",
            value: function count(options) /*: Promise<number>*/ {
                options = options || {};
                var findOptions = {};
                if (options.hasOwnProperty("useMasterKey")) findOptions.useMasterKey = options.useMasterKey;
                if (options.hasOwnProperty("sessionToken")) findOptions.sessionToken = options.sessionToken;
                this._setRequestTask(findOptions);
                var controller = $aba3563ab31b6b2a$var$_CoreManager.default.getQueryController();
                var params = this.toJSON();
                params.limit = 0;
                params.count = 1;
                return (0, $aba3563ab31b6b2a$var$_find.default)(controller).call(controller, this.className, params, findOptions).then(function(result) {
                    return result.count;
                });
            }
        },
        {
            key: "distinct",
            value: function distinct(key, options) /*: Promise<Array<mixed>>*/ {
                options = options || {};
                var distinctOptions = {};
                distinctOptions.useMasterKey = true;
                if (options.hasOwnProperty("sessionToken")) distinctOptions.sessionToken = options.sessionToken;
                this._setRequestTask(distinctOptions);
                var controller = $aba3563ab31b6b2a$var$_CoreManager.default.getQueryController();
                var params = {
                    distinct: key,
                    where: this._where,
                    hint: this._hint
                };
                return controller.aggregate(this.className, params, distinctOptions).then(function(results) {
                    return results.results;
                });
            }
        },
        {
            key: "aggregate",
            value: function aggregate(pipeline, options) /*: Promise<Array<mixed>>*/ {
                options = options || {};
                var aggregateOptions = {};
                aggregateOptions.useMasterKey = true;
                if (options.hasOwnProperty("sessionToken")) aggregateOptions.sessionToken = options.sessionToken;
                this._setRequestTask(aggregateOptions);
                var controller = $aba3563ab31b6b2a$var$_CoreManager.default.getQueryController();
                if (!(0, $aba3563ab31b6b2a$var$_isArray.default)(pipeline) && (0, $aba3563ab31b6b2a$var$_typeof2.default)(pipeline) !== "object") throw new Error("Invalid pipeline must be Array or Object");
                if ((0, $aba3563ab31b6b2a$var$_keys2.default)(this._where || {}).length) {
                    if (!(0, $aba3563ab31b6b2a$var$_isArray.default)(pipeline)) pipeline = [
                        pipeline
                    ];
                    pipeline.unshift({
                        match: this._where
                    });
                }
                var params = {
                    pipeline: pipeline,
                    hint: this._hint,
                    explain: this._explain,
                    readPreference: this._readPreference
                };
                return controller.aggregate(this.className, params, aggregateOptions).then(function(results) {
                    return results.results;
                });
            }
        },
        {
            key: "first",
            value: function first(options) /*: Promise<ParseObject | void>*/ {
                var _this4 = this;
                options = options || {};
                var findOptions = {};
                if (options.hasOwnProperty("useMasterKey")) findOptions.useMasterKey = options.useMasterKey;
                if (options.hasOwnProperty("sessionToken")) findOptions.sessionToken = options.sessionToken;
                if (options.hasOwnProperty("context") && (0, $aba3563ab31b6b2a$var$_typeof2.default)(options.context) === "object") findOptions.context = options.context;
                this._setRequestTask(findOptions);
                var controller = $aba3563ab31b6b2a$var$_CoreManager.default.getQueryController();
                var params = this.toJSON();
                params.limit = 1;
                var select = this._select;
                if (this._queriesLocalDatastore) return this._handleOfflineQuery(params).then(function(objects) {
                    if (!objects[0]) return undefined;
                    return objects[0];
                });
                return (0, $aba3563ab31b6b2a$var$_find.default)(controller).call(controller, this.className, params, findOptions).then(function(response) {
                    var objects = response.results;
                    if (!objects[0]) return undefined;
                    if (!objects[0].className) objects[0].className = _this4.className;
                     // Make sure the data object contains keys for all objects that
                    // have been requested with a select, so that our cached state
                    // updates correctly.
                    if (select) $aba3563ab31b6b2a$var$handleSelectResult(objects[0], select);
                    if (options.json) return objects[0];
                    else return $aba3563ab31b6b2a$var$_ParseObject.default.fromJSON(objects[0], !select);
                });
            }
        },
        {
            key: "eachBatch",
            value: function eachBatch(callback, options) /*: Promise<void>*/ {
                var _context8;
                options = options || {};
                if (this._order || this._skip || this._limit >= 0) {
                    var error = "Cannot iterate on a query with sort, skip, or limit.";
                    return $aba3563ab31b6b2a$var$_promise.default.reject(error);
                }
                var query = new ParseQuery(this.className);
                query._limit = options.batchSize || 100;
                query._include = (0, $aba3563ab31b6b2a$var$_map2.default)(_context8 = this._include).call(_context8, function(i) {
                    return i;
                });
                if (this._select) {
                    var _context9;
                    query._select = (0, $aba3563ab31b6b2a$var$_map2.default)(_context9 = this._select).call(_context9, function(s) {
                        return s;
                    });
                }
                query._hint = this._hint;
                query._where = {};
                for(var _attr in this._where){
                    var val = this._where[_attr];
                    if ((0, $aba3563ab31b6b2a$var$_isArray.default)(val)) query._where[_attr] = (0, $aba3563ab31b6b2a$var$_map2.default)(val).call(val, function(v) {
                        return v;
                    });
                    else if (val && (0, $aba3563ab31b6b2a$var$_typeof2.default)(val) === "object") {
                        var conditionMap = {};
                        query._where[_attr] = conditionMap;
                        for(var cond in val)conditionMap[cond] = val[cond];
                    } else query._where[_attr] = val;
                }
                query.ascending("objectId");
                var findOptions = {};
                if (options.hasOwnProperty("useMasterKey")) findOptions.useMasterKey = options.useMasterKey;
                if (options.hasOwnProperty("sessionToken")) findOptions.sessionToken = options.sessionToken;
                if (options.hasOwnProperty("context") && (0, $aba3563ab31b6b2a$var$_typeof2.default)(options.context) === "object") findOptions.context = options.context;
                if (options.hasOwnProperty("json")) findOptions.json = options.json;
                var finished = false;
                var previousResults = [];
                return (0, $j0i6P.continueWhile)(function() {
                    return !finished;
                }, /*#__PURE__*/ (0, $aba3563ab31b6b2a$var$_asyncToGenerator2.default)(/*#__PURE__*/ $aba3563ab31b6b2a$var$_regeneratorRuntime().mark(function _callee3() {
                    var _yield$Promise$all, _yield$Promise$all2, results;
                    return $aba3563ab31b6b2a$var$_regeneratorRuntime().wrap(function _callee3$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                _context10.next = 2;
                                return $aba3563ab31b6b2a$var$_promise.default.all([
                                    (0, $aba3563ab31b6b2a$var$_find.default)(query).call(query, findOptions),
                                    $aba3563ab31b6b2a$var$_promise.default.resolve(previousResults.length > 0 && callback(previousResults))
                                ]);
                            case 2:
                                _yield$Promise$all = _context10.sent;
                                _yield$Promise$all2 = (0, $aba3563ab31b6b2a$var$_slicedToArray2.default)(_yield$Promise$all, 1);
                                results = _yield$Promise$all2[0];
                                if (!(results.length >= query._limit)) {
                                    _context10.next = 10;
                                    break;
                                }
                                query.greaterThan("objectId", results[results.length - 1].id);
                                previousResults = results;
                                _context10.next = 17;
                                break;
                            case 10:
                                if (!(results.length > 0)) {
                                    _context10.next = 16;
                                    break;
                                }
                                _context10.next = 13;
                                return $aba3563ab31b6b2a$var$_promise.default.resolve(callback(results));
                            case 13:
                                finished = true;
                                _context10.next = 17;
                                break;
                            case 16:
                                finished = true;
                            case 17:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee3);
                })));
            }
        },
        {
            key: "each",
            value: function each(callback, options) /*: Promise<void>*/ {
                return this.eachBatch(function(results) {
                    var callbacksDone = $aba3563ab31b6b2a$var$_promise.default.resolve();
                    (0, $aba3563ab31b6b2a$var$_forEach.default)(results).call(results, function(result) {
                        callbacksDone = callbacksDone.then(function() {
                            return callback(result);
                        });
                    });
                    return callbacksDone;
                }, options);
            }
        },
        {
            key: "hint",
            value: function hint(value) /*: ParseQuery*/ {
                if (typeof value === "undefined") delete this._hint;
                this._hint = value;
                return this;
            }
        },
        {
            key: "explain",
            value: function explain() /*: ParseQuery*/ {
                var _explain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                if (typeof _explain !== "boolean") throw new Error("You can only set explain to a boolean value");
                this._explain = _explain;
                return this;
            }
        },
        {
            key: "map",
            value: function() {
                var _map = (0, $aba3563ab31b6b2a$var$_asyncToGenerator2.default)(/*#__PURE__*/ $aba3563ab31b6b2a$var$_regeneratorRuntime().mark(function _callee4(callback, options) {
                    var _this5 = this;
                    var array, index;
                    return $aba3563ab31b6b2a$var$_regeneratorRuntime().wrap(function _callee4$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                array = [];
                                index = 0;
                                _context11.next = 4;
                                return this.each(function(object) {
                                    return $aba3563ab31b6b2a$var$_promise.default.resolve(callback(object, index, _this5)).then(function(result) {
                                        array.push(result);
                                        index += 1;
                                    });
                                }, options);
                            case 4:
                                return _context11.abrupt("return", array);
                            case 5:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee4, this);
                }));
                function map(_x3, _x4) {
                    return _map.apply(this, arguments);
                }
                return map;
            }()
        },
        {
            key: "reduce",
            value: function() {
                var _reduce = (0, $aba3563ab31b6b2a$var$_asyncToGenerator2.default)(/*#__PURE__*/ $aba3563ab31b6b2a$var$_regeneratorRuntime().mark(function _callee5(callback, initialValue, options) {
                    var accumulator, index;
                    return $aba3563ab31b6b2a$var$_regeneratorRuntime().wrap(function _callee5$(_context12) {
                        while(true)switch(_context12.prev = _context12.next){
                            case 0:
                                accumulator = initialValue;
                                index = 0;
                                _context12.next = 4;
                                return this.each(function(object) {
                                    // If no initial value was given, we take the first object from the query
                                    // as the initial value and don't call the callback with it.
                                    if (index === 0 && initialValue === undefined) {
                                        accumulator = object;
                                        index += 1;
                                        return;
                                    }
                                    return $aba3563ab31b6b2a$var$_promise.default.resolve(callback(accumulator, object, index)).then(function(result) {
                                        accumulator = result;
                                        index += 1;
                                    });
                                }, options);
                            case 4:
                                if (!(index === 0 && initialValue === undefined)) {
                                    _context12.next = 6;
                                    break;
                                }
                                throw new TypeError("Reducing empty query result set with no initial value");
                            case 6:
                                return _context12.abrupt("return", accumulator);
                            case 7:
                            case "end":
                                return _context12.stop();
                        }
                    }, _callee5, this);
                }));
                function reduce(_x5, _x6, _x7) {
                    return _reduce.apply(this, arguments);
                }
                return reduce;
            }()
        },
        {
            key: "filter",
            value: function() {
                var _filter = (0, $aba3563ab31b6b2a$var$_asyncToGenerator2.default)(/*#__PURE__*/ $aba3563ab31b6b2a$var$_regeneratorRuntime().mark(function _callee6(callback, options) {
                    var _this6 = this;
                    var array, index;
                    return $aba3563ab31b6b2a$var$_regeneratorRuntime().wrap(function _callee6$(_context13) {
                        while(true)switch(_context13.prev = _context13.next){
                            case 0:
                                array = [];
                                index = 0;
                                _context13.next = 4;
                                return this.each(function(object) {
                                    return $aba3563ab31b6b2a$var$_promise.default.resolve(callback(object, index, _this6)).then(function(flag) {
                                        if (flag) array.push(object);
                                        index += 1;
                                    });
                                }, options);
                            case 4:
                                return _context13.abrupt("return", array);
                            case 5:
                            case "end":
                                return _context13.stop();
                        }
                    }, _callee6, this);
                }));
                function filter(_x8, _x9) {
                    return _filter.apply(this, arguments);
                }
                return filter;
            }()
        },
        {
            key: "equalTo",
            value: function equalTo(key, value) /*: ParseQuery*/ {
                var _this7 = this;
                if (key && (0, $aba3563ab31b6b2a$var$_typeof2.default)(key) === "object") {
                    var _context14;
                    (0, $aba3563ab31b6b2a$var$_forEach.default)(_context14 = (0, $aba3563ab31b6b2a$var$_entries.default)(key)).call(_context14, function(_ref2) {
                        var _ref3 = (0, $aba3563ab31b6b2a$var$_slicedToArray2.default)(_ref2, 2), k = _ref3[0], val = _ref3[1];
                        return _this7.equalTo(k, val);
                    });
                    return this;
                }
                if (typeof value === "undefined") return this.doesNotExist(key);
                this._where[key] = (0, $aba3563ab31b6b2a$var$_encode.default)(value, false, true);
                return this;
            }
        },
        {
            key: "notEqualTo",
            value: function notEqualTo(key, value) /*: ParseQuery*/ {
                var _this8 = this;
                if (key && (0, $aba3563ab31b6b2a$var$_typeof2.default)(key) === "object") {
                    var _context15;
                    (0, $aba3563ab31b6b2a$var$_forEach.default)(_context15 = (0, $aba3563ab31b6b2a$var$_entries.default)(key)).call(_context15, function(_ref4) {
                        var _ref5 = (0, $aba3563ab31b6b2a$var$_slicedToArray2.default)(_ref4, 2), k = _ref5[0], val = _ref5[1];
                        return _this8.notEqualTo(k, val);
                    });
                    return this;
                }
                return this._addCondition(key, "$ne", value);
            }
        },
        {
            key: "lessThan",
            value: function lessThan(key, value) /*: ParseQuery*/ {
                return this._addCondition(key, "$lt", value);
            }
        },
        {
            key: "greaterThan",
            value: function greaterThan(key, value) /*: ParseQuery*/ {
                return this._addCondition(key, "$gt", value);
            }
        },
        {
            key: "lessThanOrEqualTo",
            value: function lessThanOrEqualTo(key, value) /*: ParseQuery*/ {
                return this._addCondition(key, "$lte", value);
            }
        },
        {
            key: "greaterThanOrEqualTo",
            value: function greaterThanOrEqualTo(key, value) /*: ParseQuery*/ {
                return this._addCondition(key, "$gte", value);
            }
        },
        {
            key: "containedIn",
            value: function containedIn(key, value) /*: ParseQuery*/ {
                return this._addCondition(key, "$in", value);
            }
        },
        {
            key: "notContainedIn",
            value: function notContainedIn(key, value) /*: ParseQuery*/ {
                return this._addCondition(key, "$nin", value);
            }
        },
        {
            key: "containedBy",
            value: function containedBy(key, values) /*: ParseQuery*/ {
                return this._addCondition(key, "$containedBy", values);
            }
        },
        {
            key: "containsAll",
            value: function containsAll(key, values) /*: ParseQuery*/ {
                return this._addCondition(key, "$all", values);
            }
        },
        {
            key: "containsAllStartingWith",
            value: function containsAllStartingWith(key, values) /*: ParseQuery*/ {
                var _this = this;
                if (!(0, $aba3563ab31b6b2a$var$_isArray.default)(values)) values = [
                    values
                ];
                var regexObject = (0, $aba3563ab31b6b2a$var$_map2.default)(values).call(values, function(value) {
                    return {
                        $regex: _this._regexStartWith(value)
                    };
                });
                return this.containsAll(key, regexObject);
            }
        },
        {
            key: "exists",
            value: function exists(key) /*: ParseQuery*/ {
                return this._addCondition(key, "$exists", true);
            }
        },
        {
            key: "doesNotExist",
            value: function doesNotExist(key) /*: ParseQuery*/ {
                return this._addCondition(key, "$exists", false);
            }
        },
        {
            key: "matches",
            value: function matches(key, regex, modifiers) /*: ParseQuery*/ {
                this._addCondition(key, "$regex", regex);
                if (!modifiers) modifiers = "";
                if (regex.ignoreCase) modifiers += "i";
                if (regex.multiline) modifiers += "m";
                if (modifiers.length) this._addCondition(key, "$options", modifiers);
                return this;
            }
        },
        {
            key: "matchesQuery",
            value: function matchesQuery(key, query) /*: ParseQuery*/ {
                var queryJSON = query.toJSON();
                queryJSON.className = query.className;
                return this._addCondition(key, "$inQuery", queryJSON);
            }
        },
        {
            key: "doesNotMatchQuery",
            value: function doesNotMatchQuery(key, query) /*: ParseQuery*/ {
                var queryJSON = query.toJSON();
                queryJSON.className = query.className;
                return this._addCondition(key, "$notInQuery", queryJSON);
            }
        },
        {
            key: "matchesKeyInQuery",
            value: function matchesKeyInQuery(key, queryKey, query) /*: ParseQuery*/ {
                var queryJSON = query.toJSON();
                queryJSON.className = query.className;
                return this._addCondition(key, "$select", {
                    key: queryKey,
                    query: queryJSON
                });
            }
        },
        {
            key: "doesNotMatchKeyInQuery",
            value: function doesNotMatchKeyInQuery(key, queryKey, query) /*: ParseQuery*/ {
                var queryJSON = query.toJSON();
                queryJSON.className = query.className;
                return this._addCondition(key, "$dontSelect", {
                    key: queryKey,
                    query: queryJSON
                });
            }
        },
        {
            key: "contains",
            value: function contains(key, substring) /*: ParseQuery*/ {
                if (typeof substring !== "string") throw new Error("The value being searched for must be a string.");
                return this._addCondition(key, "$regex", $aba3563ab31b6b2a$var$quote(substring));
            }
        },
        {
            key: "fullText",
            value: function fullText(key, value, options) /*: ParseQuery*/ {
                options = options || {};
                if (!key) throw new Error("A key is required.");
                if (!value) throw new Error("A search term is required");
                if (typeof value !== "string") throw new Error("The value being searched for must be a string.");
                var fullOptions = {};
                fullOptions.$term = value;
                for(var option in options)switch(option){
                    case "language":
                        fullOptions.$language = options[option];
                        break;
                    case "caseSensitive":
                        fullOptions.$caseSensitive = options[option];
                        break;
                    case "diacriticSensitive":
                        fullOptions.$diacriticSensitive = options[option];
                        break;
                    default:
                        throw new Error("Unknown option: ".concat(option));
                }
                return this._addCondition(key, "$text", {
                    $search: fullOptions
                });
            }
        },
        {
            key: "sortByTextScore",
            value: function sortByTextScore() {
                this.ascending("$score");
                this.select([
                    "$score"
                ]);
                return this;
            }
        },
        {
            key: "startsWith",
            value: function startsWith(key, prefix, modifiers) /*: ParseQuery*/ {
                if (typeof prefix !== "string") throw new Error("The value being searched for must be a string.");
                return this.matches(key, this._regexStartWith(prefix), modifiers);
            }
        },
        {
            key: "endsWith",
            value: function endsWith(key, suffix, modifiers) /*: ParseQuery*/ {
                if (typeof suffix !== "string") throw new Error("The value being searched for must be a string.");
                return this.matches(key, $aba3563ab31b6b2a$var$quote(suffix) + "$", modifiers);
            }
        },
        {
            key: "near",
            value: function near(key, point) /*: ParseQuery*/ {
                if (!(point instanceof $aba3563ab31b6b2a$var$_ParseGeoPoint.default)) // Try to cast it as a GeoPoint
                point = new $aba3563ab31b6b2a$var$_ParseGeoPoint.default(point);
                return this._addCondition(key, "$nearSphere", point);
            }
        },
        {
            key: "withinRadians",
            value: function withinRadians(key, point, maxDistance, sorted) /*: ParseQuery*/ {
                if (sorted || sorted === undefined) {
                    this.near(key, point);
                    return this._addCondition(key, "$maxDistance", maxDistance);
                } else return this._addCondition(key, "$geoWithin", {
                    $centerSphere: [
                        [
                            point.longitude,
                            point.latitude
                        ],
                        maxDistance
                    ]
                });
            }
        },
        {
            key: "withinMiles",
            value: function withinMiles(key, point, maxDistance, sorted) /*: ParseQuery*/ {
                return this.withinRadians(key, point, maxDistance / 3958.8, sorted);
            }
        },
        {
            key: "withinKilometers",
            value: function withinKilometers(key, point, maxDistance, sorted) /*: ParseQuery*/ {
                return this.withinRadians(key, point, maxDistance / 6371.0, sorted);
            }
        },
        {
            key: "withinGeoBox",
            value: function withinGeoBox(key, southwest, northeast) /*: ParseQuery*/ {
                if (!(southwest instanceof $aba3563ab31b6b2a$var$_ParseGeoPoint.default)) southwest = new $aba3563ab31b6b2a$var$_ParseGeoPoint.default(southwest);
                if (!(northeast instanceof $aba3563ab31b6b2a$var$_ParseGeoPoint.default)) northeast = new $aba3563ab31b6b2a$var$_ParseGeoPoint.default(northeast);
                this._addCondition(key, "$within", {
                    $box: [
                        southwest,
                        northeast
                    ]
                });
                return this;
            }
        },
        {
            key: "withinPolygon",
            value: function withinPolygon(key, points) /*: ParseQuery*/ {
                return this._addCondition(key, "$geoWithin", {
                    $polygon: points
                });
            }
        },
        {
            key: "polygonContains",
            value: function polygonContains(key, point) /*: ParseQuery*/ {
                return this._addCondition(key, "$geoIntersects", {
                    $point: point
                });
            }
        },
        {
            key: "ascending",
            value: function ascending() /*: ParseQuery*/ {
                this._order = [];
                for(var _len = arguments.length, keys = new Array(_len), _key5 = 0; _key5 < _len; _key5++)keys[_key5] = arguments[_key5];
                return this.addAscending.apply(this, keys);
            }
        },
        {
            key: "addAscending",
            value: function addAscending() /*: ParseQuery*/ {
                var _this9 = this;
                if (!this._order) this._order = [];
                for(var _len2 = arguments.length, keys = new Array(_len2), _key6 = 0; _key6 < _len2; _key6++)keys[_key6] = arguments[_key6];
                (0, $aba3563ab31b6b2a$var$_forEach.default)(keys).call(keys, function(key) {
                    var _context16;
                    if ((0, $aba3563ab31b6b2a$var$_isArray.default)(key)) key = key.join();
                    _this9._order = (0, $aba3563ab31b6b2a$var$_concat.default)(_context16 = _this9._order).call(_context16, key.replace(/\s/g, "").split(","));
                });
                return this;
            }
        },
        {
            key: "descending",
            value: function descending() /*: ParseQuery*/ {
                this._order = [];
                for(var _len3 = arguments.length, keys = new Array(_len3), _key7 = 0; _key7 < _len3; _key7++)keys[_key7] = arguments[_key7];
                return this.addDescending.apply(this, keys);
            }
        },
        {
            key: "addDescending",
            value: function addDescending() /*: ParseQuery*/ {
                var _this10 = this;
                if (!this._order) this._order = [];
                for(var _len4 = arguments.length, keys = new Array(_len4), _key8 = 0; _key8 < _len4; _key8++)keys[_key8] = arguments[_key8];
                (0, $aba3563ab31b6b2a$var$_forEach.default)(keys).call(keys, function(key) {
                    var _context17, _context18;
                    if ((0, $aba3563ab31b6b2a$var$_isArray.default)(key)) key = key.join();
                    _this10._order = (0, $aba3563ab31b6b2a$var$_concat.default)(_context17 = _this10._order).call(_context17, (0, $aba3563ab31b6b2a$var$_map2.default)(_context18 = key.replace(/\s/g, "").split(",")).call(_context18, function(k) {
                        return "-" + k;
                    }));
                });
                return this;
            }
        },
        {
            key: "skip",
            value: function skip(n) /*: ParseQuery*/ {
                if (typeof n !== "number" || n < 0) throw new Error("You can only skip by a positive number");
                this._skip = n;
                return this;
            }
        },
        {
            key: "limit",
            value: function limit(n) /*: ParseQuery*/ {
                if (typeof n !== "number") throw new Error("You can only set the limit to a numeric value");
                this._limit = n;
                return this;
            }
        },
        {
            key: "withCount",
            value: function withCount() /*: ParseQuery*/ {
                var includeCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                if (typeof includeCount !== "boolean") throw new Error("You can only set withCount to a boolean value");
                this._count = includeCount;
                return this;
            }
        },
        {
            key: "include",
            value: function include() /*: ParseQuery*/ {
                var _this11 = this;
                for(var _len5 = arguments.length, keys = new Array(_len5), _key9 = 0; _key9 < _len5; _key9++)keys[_key9] = arguments[_key9];
                (0, $aba3563ab31b6b2a$var$_forEach.default)(keys).call(keys, function(key) {
                    if ((0, $aba3563ab31b6b2a$var$_isArray.default)(key)) {
                        var _context19;
                        _this11._include = (0, $aba3563ab31b6b2a$var$_concat.default)(_context19 = _this11._include).call(_context19, key);
                    } else _this11._include.push(key);
                });
                return this;
            }
        },
        {
            key: "includeAll",
            value: function includeAll() /*: ParseQuery*/ {
                return this.include("*");
            }
        },
        {
            key: "select",
            value: function select() /*: ParseQuery*/ {
                var _this12 = this;
                if (!this._select) this._select = [];
                for(var _len6 = arguments.length, keys = new Array(_len6), _key10 = 0; _key10 < _len6; _key10++)keys[_key10] = arguments[_key10];
                (0, $aba3563ab31b6b2a$var$_forEach.default)(keys).call(keys, function(key) {
                    if ((0, $aba3563ab31b6b2a$var$_isArray.default)(key)) {
                        var _context20;
                        _this12._select = (0, $aba3563ab31b6b2a$var$_concat.default)(_context20 = _this12._select).call(_context20, key);
                    } else _this12._select.push(key);
                });
                return this;
            }
        },
        {
            key: "exclude",
            value: function exclude() /*: ParseQuery*/ {
                var _this13 = this;
                for(var _len7 = arguments.length, keys = new Array(_len7), _key11 = 0; _key11 < _len7; _key11++)keys[_key11] = arguments[_key11];
                (0, $aba3563ab31b6b2a$var$_forEach.default)(keys).call(keys, function(key) {
                    if ((0, $aba3563ab31b6b2a$var$_isArray.default)(key)) {
                        var _context21;
                        _this13._exclude = (0, $aba3563ab31b6b2a$var$_concat.default)(_context21 = _this13._exclude).call(_context21, key);
                    } else _this13._exclude.push(key);
                });
                return this;
            }
        },
        {
            key: "readPreference",
            value: function readPreference(_readPreference, includeReadPreference, subqueryReadPreference) /*: ParseQuery*/ {
                this._readPreference = _readPreference;
                this._includeReadPreference = includeReadPreference;
                this._subqueryReadPreference = subqueryReadPreference;
                return this;
            }
        },
        {
            key: "subscribe",
            value: function() {
                var _subscribe = (0, $aba3563ab31b6b2a$var$_asyncToGenerator2.default)(/*#__PURE__*/ $aba3563ab31b6b2a$var$_regeneratorRuntime().mark(function _callee7(sessionToken) {
                    var currentUser, liveQueryClient, subscription;
                    return $aba3563ab31b6b2a$var$_regeneratorRuntime().wrap(function _callee7$(_context22) {
                        while(true)switch(_context22.prev = _context22.next){
                            case 0:
                                _context22.next = 2;
                                return $aba3563ab31b6b2a$var$_CoreManager.default.getUserController().currentUserAsync();
                            case 2:
                                currentUser = _context22.sent;
                                if (!sessionToken) sessionToken = currentUser ? currentUser.getSessionToken() : undefined;
                                _context22.next = 6;
                                return $aba3563ab31b6b2a$var$_CoreManager.default.getLiveQueryController().getDefaultLiveQueryClient();
                            case 6:
                                liveQueryClient = _context22.sent;
                                if (liveQueryClient.shouldOpen()) liveQueryClient.open();
                                subscription = liveQueryClient.subscribe(this, sessionToken);
                                return _context22.abrupt("return", subscription.subscribePromise.then(function() {
                                    return subscription;
                                }));
                            case 10:
                            case "end":
                                return _context22.stop();
                        }
                    }, _callee7, this);
                }));
                function subscribe(_x10) {
                    return _subscribe.apply(this, arguments);
                }
                return subscribe;
            }()
        },
        {
            key: "fromNetwork",
            value: /**
     * Change the source of this query to the server.
     *
     * @returns {Parse.Query} Returns the query, so you can chain this call.
     */ function fromNetwork() /*: ParseQuery*/ {
                this._queriesLocalDatastore = false;
                this._localDatastorePinName = null;
                return this;
            }
        },
        {
            key: "fromLocalDatastore",
            value: function fromLocalDatastore() /*: ParseQuery*/ {
                return this.fromPinWithName(null);
            }
        },
        {
            key: "fromPin",
            value: function fromPin() /*: ParseQuery*/ {
                return this.fromPinWithName($7Icwu.DEFAULT_PIN);
            }
        },
        {
            key: "fromPinWithName",
            value: function fromPinWithName(name) /*: ParseQuery*/ {
                var localDatastore = $aba3563ab31b6b2a$var$_CoreManager.default.getLocalDatastore();
                if (localDatastore.checkIfEnabled()) {
                    this._queriesLocalDatastore = true;
                    this._localDatastorePinName = name;
                }
                return this;
            }
        },
        {
            key: "cancel",
            value: function cancel() /*: ParseQuery*/ {
                var _this14 = this;
                if (this._xhrRequest.task && typeof this._xhrRequest.task.abort === "function") {
                    this._xhrRequest.task._aborted = true;
                    this._xhrRequest.task.abort();
                    this._xhrRequest.task = null;
                    this._xhrRequest.onchange = function() {};
                    return this;
                }
                return this._xhrRequest.onchange = function() {
                    return _this14.cancel();
                };
            }
        },
        {
            key: "_setRequestTask",
            value: function _setRequestTask(options) {
                var _this15 = this;
                options.requestTask = function(task) {
                    _this15._xhrRequest.task = task;
                    _this15._xhrRequest.onchange();
                };
            }
        }
    ], [
        {
            key: "fromJSON",
            value: function fromJSON(className, json) /*: ParseQuery*/ {
                var query = new ParseQuery(className);
                return query.withJSON(json);
            }
        },
        {
            key: "or",
            value: function or() /*: ParseQuery*/ {
                for(var _len8 = arguments.length, queries = new Array(_len8), _key12 = 0; _key12 < _len8; _key12++)queries[_key12] = arguments[_key12];
                var className = $aba3563ab31b6b2a$var$_getClassNameFromQueries(queries);
                var query = new ParseQuery(className);
                query._orQuery(queries);
                return query;
            }
        },
        {
            key: "and",
            value: function and() /*: ParseQuery*/ {
                for(var _len9 = arguments.length, queries = new Array(_len9), _key13 = 0; _key13 < _len9; _key13++)queries[_key13] = arguments[_key13];
                var className = $aba3563ab31b6b2a$var$_getClassNameFromQueries(queries);
                var query = new ParseQuery(className);
                query._andQuery(queries);
                return query;
            }
        },
        {
            key: "nor",
            value: function nor() /*: ParseQuery*/ {
                for(var _len10 = arguments.length, queries = new Array(_len10), _key14 = 0; _key14 < _len10; _key14++)queries[_key14] = arguments[_key14];
                var className = $aba3563ab31b6b2a$var$_getClassNameFromQueries(queries);
                var query = new ParseQuery(className);
                query._norQuery(queries);
                return query;
            }
        }
    ]);
    return ParseQuery;
}();
var $aba3563ab31b6b2a$var$DefaultController = {
    find: function find(className, params, options) /*: Promise<Array<ParseObject>>*/ {
        var RESTController = $aba3563ab31b6b2a$var$_CoreManager.default.getRESTController();
        return RESTController.request("GET", "classes/" + className, params, options);
    },
    aggregate: function aggregate(className, params, options) /*: Promise<Array<mixed>>*/ {
        var RESTController = $aba3563ab31b6b2a$var$_CoreManager.default.getRESTController();
        return RESTController.request("GET", "aggregate/" + className, params, options);
    }
};
$aba3563ab31b6b2a$var$_CoreManager.default.setQueryController($aba3563ab31b6b2a$var$DefaultController);
var $aba3563ab31b6b2a$var$_default = $aba3563ab31b6b2a$var$ParseQuery;
module.exports.default = $aba3563ab31b6b2a$var$_default;

});
parcelRequire.register("fsovd", function(module, exports) {

module.exports = (parcelRequire("aqT6q"));

});
parcelRequire.register("aqT6q", function(module, exports) {

var $fMB85 = parcelRequire("fMB85");
module.exports = $fMB85;

});
parcelRequire.register("fMB85", function(module, exports) {
parcelRequire("30xVH");

var $envPC = parcelRequire("envPC");
module.exports = $envPC.Object.entries;

});
parcelRequire.register("30xVH", function(module, exports) {

var $g2B3u = parcelRequire("g2B3u");

var $4oEkW = parcelRequire("4oEkW");
var $230bb0e403a06eee$require$$entries = $4oEkW.entries;
// `Object.entries` method
// https://tc39.es/ecma262/#sec-object.entries
$g2B3u({
    target: "Object",
    stat: true
}, {
    entries: function entries(O) {
        return $230bb0e403a06eee$require$$entries(O);
    }
});

});
parcelRequire.register("4oEkW", function(module, exports) {

var $99D40 = parcelRequire("99D40");

var $avKuJ = parcelRequire("avKuJ");

var $7tcts = parcelRequire("7tcts");

var $gk5OL = parcelRequire("gk5OL");

var $lfsGJ = parcelRequire("lfsGJ");

var $1YJYD = parcelRequire("1YJYD");

var $lqqOI = parcelRequire("lqqOI");
var $3338b1614d125062$require$$propertyIsEnumerable = $lqqOI.f;
var $3338b1614d125062$var$propertyIsEnumerable = $7tcts($3338b1614d125062$require$$propertyIsEnumerable);
var $3338b1614d125062$var$push = $7tcts([].push);
// in some IE versions, `propertyIsEnumerable` returns incorrect result on integer keys
// of `null` prototype objects
var $3338b1614d125062$var$IE_BUG = $99D40 && $avKuJ(function() {
    // eslint-disable-next-line es/no-object-create -- safe
    var O = Object.create(null);
    O[2] = 2;
    return !$3338b1614d125062$var$propertyIsEnumerable(O, 2);
});
// `Object.{ entries, values }` methods implementation
var $3338b1614d125062$var$createMethod = function(TO_ENTRIES) {
    return function(it) {
        var O = $1YJYD(it);
        var keys = $lfsGJ(O);
        var IE_WORKAROUND = $3338b1614d125062$var$IE_BUG && $gk5OL(O) === null;
        var length = keys.length;
        var i = 0;
        var result = [];
        var key;
        while(length > i){
            key = keys[i++];
            if (!$99D40 || (IE_WORKAROUND ? key in O : $3338b1614d125062$var$propertyIsEnumerable(O, key))) $3338b1614d125062$var$push(result, TO_ENTRIES ? [
                key,
                O[key]
            ] : O[key]);
        }
        return result;
    };
};
module.exports = {
    // `Object.entries` method
    // https://tc39.es/ecma262/#sec-object.entries
    entries: $3338b1614d125062$var$createMethod(true),
    // `Object.values` method
    // https://tc39.es/ecma262/#sec-object.values
    values: $3338b1614d125062$var$createMethod(false)
};

});





parcelRequire.register("6VZVY", function(module, exports) {

var $bctyG = parcelRequire("bctyG");

var $lssvv = parcelRequire("lssvv");

var $7XfuR = parcelRequire("7XfuR");

var $54OqZ = parcelRequire("54OqZ");
function $014d8cd5b98bbcad$var$_toConsumableArray(arr) {
    return $bctyG(arr) || $lssvv(arr) || $7XfuR(arr) || $54OqZ();
}
module.exports = $014d8cd5b98bbcad$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("bctyG", function(module, exports) {

var $43adY = parcelRequire("43adY");

var $gQJnG = parcelRequire("gQJnG");
function $8277be5ff444cc96$var$_arrayWithoutHoles(arr) {
    if ($43adY(arr)) return $gQJnG(arr);
}
module.exports = $8277be5ff444cc96$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("lssvv", function(module, exports) {

var $iqC1p = parcelRequire("iqC1p");

var $liESz = parcelRequire("liESz");

var $eWWwU = parcelRequire("eWWwU");
function $f9f2536d466ecd08$var$_iterableToArray(iter) {
    if (typeof $iqC1p !== "undefined" && $liESz(iter) != null || iter["@@iterator"] != null) return $eWWwU(iter);
}
module.exports = $f9f2536d466ecd08$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("54OqZ", function(module, exports) {
function $3b2472b34fcc6148$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $3b2472b34fcc6148$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("lzvCu", function(module, exports) {

module.exports = (parcelRequire("a5sq1"));

});
parcelRequire.register("a5sq1", function(module, exports) {

var $hDEp6 = parcelRequire("hDEp6");
module.exports = $hDEp6;

});
parcelRequire.register("hDEp6", function(module, exports) {

var $5L8hR = parcelRequire("5L8hR");

var $7cwIN = parcelRequire("7cwIN");
var $cd756b8c4e6bb3a3$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.sort;
    return it === $cd756b8c4e6bb3a3$var$ArrayPrototype || $5L8hR($cd756b8c4e6bb3a3$var$ArrayPrototype, it) && own === $cd756b8c4e6bb3a3$var$ArrayPrototype.sort ? $7cwIN : own;
};

});
parcelRequire.register("7cwIN", function(module, exports) {
parcelRequire("9eaEK");

var $hESIr = parcelRequire("hESIr");
module.exports = $hESIr("Array").sort;

});
parcelRequire.register("9eaEK", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $7tcts = parcelRequire("7tcts");

var $aZpni = parcelRequire("aZpni");

var $bVwvx = parcelRequire("bVwvx");

var $25Yeh = parcelRequire("25Yeh");

var $7IrDt = parcelRequire("7IrDt");

var $eG0jW = parcelRequire("eG0jW");

var $avKuJ = parcelRequire("avKuJ");

var $7dGL8 = parcelRequire("7dGL8");

var $iNgXn = parcelRequire("iNgXn");

var $lq57x = parcelRequire("lq57x");

var $bAzAw = parcelRequire("bAzAw");

var $dOZLy = parcelRequire("dOZLy");

var $9GImd = parcelRequire("9GImd");
var $6b7daff206c37a3a$var$test = [];
var $6b7daff206c37a3a$var$nativeSort = $7tcts($6b7daff206c37a3a$var$test.sort);
var $6b7daff206c37a3a$var$push = $7tcts($6b7daff206c37a3a$var$test.push);
// IE8-
var $6b7daff206c37a3a$var$FAILS_ON_UNDEFINED = $avKuJ(function() {
    $6b7daff206c37a3a$var$test.sort(undefined);
});
// V8 bug
var $6b7daff206c37a3a$var$FAILS_ON_NULL = $avKuJ(function() {
    $6b7daff206c37a3a$var$test.sort(null);
});
// Old WebKit
var $6b7daff206c37a3a$var$STRICT_METHOD = $iNgXn("sort");
var $6b7daff206c37a3a$var$STABLE_SORT = !$avKuJ(function() {
    // feature detection can be too slow, so check engines versions
    if ($dOZLy) return $dOZLy < 70;
    if ($lq57x && $lq57x > 3) return;
    if ($bAzAw) return true;
    if ($9GImd) return $9GImd < 603;
    var result = "";
    var code, chr, value, index;
    // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
    for(code = 65; code < 76; code++){
        chr = String.fromCharCode(code);
        switch(code){
            case 66:
            case 69:
            case 70:
            case 72:
                value = 3;
                break;
            case 68:
            case 71:
                value = 4;
                break;
            default:
                value = 2;
        }
        for(index = 0; index < 47; index++)$6b7daff206c37a3a$var$test.push({
            k: chr + index,
            v: value
        });
    }
    $6b7daff206c37a3a$var$test.sort(function(a, b) {
        return b.v - a.v;
    });
    for(index = 0; index < $6b7daff206c37a3a$var$test.length; index++){
        chr = $6b7daff206c37a3a$var$test[index].k.charAt(0);
        if (result.charAt(result.length - 1) !== chr) result += chr;
    }
    return result !== "DGBEFHACIJK";
});
var $6b7daff206c37a3a$var$FORCED = $6b7daff206c37a3a$var$FAILS_ON_UNDEFINED || !$6b7daff206c37a3a$var$FAILS_ON_NULL || !$6b7daff206c37a3a$var$STRICT_METHOD || !$6b7daff206c37a3a$var$STABLE_SORT;
var $6b7daff206c37a3a$var$getSortCompare = function(comparefn) {
    return function(x, y) {
        if (y === undefined) return -1;
        if (x === undefined) return 1;
        if (comparefn !== undefined) return +comparefn(x, y) || 0;
        return $eG0jW(x) > $eG0jW(y) ? 1 : -1;
    };
};
// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$g2B3u({
    target: "Array",
    proto: true,
    forced: $6b7daff206c37a3a$var$FORCED
}, {
    sort: function sort(comparefn) {
        if (comparefn !== undefined) $aZpni(comparefn);
        var array = $bVwvx(this);
        if ($6b7daff206c37a3a$var$STABLE_SORT) return comparefn === undefined ? $6b7daff206c37a3a$var$nativeSort(array) : $6b7daff206c37a3a$var$nativeSort(array, comparefn);
        var items = [];
        var arrayLength = $25Yeh(array);
        var itemsLength, index;
        for(index = 0; index < arrayLength; index++)if (index in array) $6b7daff206c37a3a$var$push(items, array[index]);
        $7dGL8(items, $6b7daff206c37a3a$var$getSortCompare(comparefn));
        itemsLength = $25Yeh(items);
        index = 0;
        while(index < itemsLength)array[index] = items[index++];
        while(index < arrayLength)$7IrDt(array, index++);
        return array;
    }
});

});
parcelRequire.register("7dGL8", function(module, exports) {

var $ecLmr = parcelRequire("ecLmr");
var $541aea6a171f0517$var$floor = Math.floor;
var $541aea6a171f0517$var$mergeSort = function(array, comparefn) {
    var length = array.length;
    var middle = $541aea6a171f0517$var$floor(length / 2);
    return length < 8 ? $541aea6a171f0517$var$insertionSort(array, comparefn) : $541aea6a171f0517$var$merge(array, $541aea6a171f0517$var$mergeSort($ecLmr(array, 0, middle), comparefn), $541aea6a171f0517$var$mergeSort($ecLmr(array, middle), comparefn), comparefn);
};
var $541aea6a171f0517$var$insertionSort = function(array, comparefn) {
    var length = array.length;
    var i = 1;
    var element, j;
    while(i < length){
        j = i;
        element = array[i];
        while(j && comparefn(array[j - 1], element) > 0)array[j] = array[--j];
        if (j !== i++) array[j] = element;
    }
    return array;
};
var $541aea6a171f0517$var$merge = function(array, left, right, comparefn) {
    var llength = left.length;
    var rlength = right.length;
    var lindex = 0;
    var rindex = 0;
    while(lindex < llength || rindex < rlength)array[lindex + rindex] = lindex < llength && rindex < rlength ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++] : lindex < llength ? left[lindex++] : right[rindex++];
    return array;
};
module.exports = $541aea6a171f0517$var$mergeSort;

});

parcelRequire.register("lq57x", function(module, exports) {

var $jGeXI = parcelRequire("jGeXI");
var $f97fff8b78ad7791$var$firefox = $jGeXI.match(/firefox\/(\d+)/i);
module.exports = !!$f97fff8b78ad7791$var$firefox && +$f97fff8b78ad7791$var$firefox[1];

});

parcelRequire.register("bAzAw", function(module, exports) {

var $jGeXI = parcelRequire("jGeXI");
module.exports = /MSIE|Trident/.test($jGeXI);

});

parcelRequire.register("9GImd", function(module, exports) {

var $jGeXI = parcelRequire("jGeXI");
var $70da71b996f75de8$var$webkit = $jGeXI.match(/AppleWebKit\/(\d+)\./);
module.exports = !!$70da71b996f75de8$var$webkit && +$70da71b996f75de8$var$webkit[1];

});






parcelRequire.register("gKrgO", function(module, exports) {

module.exports = (parcelRequire("5OgMJ"));

});
parcelRequire.register("5OgMJ", function(module, exports) {
parcelRequire("4YdnW");

var $3mH0O = parcelRequire("3mH0O");

var $dydfX = parcelRequire("dydfX");

var $5L8hR = parcelRequire("5L8hR");

var $ezrBh = parcelRequire("ezrBh");
var $43aea469a2f88665$var$ArrayPrototype = Array.prototype;
var $43aea469a2f88665$var$DOMIterables = {
    DOMTokenList: true,
    NodeList: true
};
module.exports = function(it) {
    var own = it.keys;
    return it === $43aea469a2f88665$var$ArrayPrototype || $5L8hR($43aea469a2f88665$var$ArrayPrototype, it) && own === $43aea469a2f88665$var$ArrayPrototype.keys || $dydfX($43aea469a2f88665$var$DOMIterables, $3mH0O(it)) ? $ezrBh : own;
};

});
parcelRequire.register("ezrBh", function(module, exports) {

var $dijGm = parcelRequire("dijGm");
module.exports = $dijGm;

});
parcelRequire.register("dijGm", function(module, exports) {
parcelRequire("4IarS");
parcelRequire("edOxo");

var $hESIr = parcelRequire("hESIr");
module.exports = $hESIr("Array").keys;

});




parcelRequire.register("j0i6P", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $evY07 = parcelRequire("evY07");
$evY07(module.exports, "__esModule", {
    value: true
});
module.exports.continueWhile = $dd5c1087ccc0ddd2$var$continueWhile;
module.exports.resolvingPromise = $dd5c1087ccc0ddd2$var$resolvingPromise;
module.exports.when = $dd5c1087ccc0ddd2$var$when;

var $dd5c1087ccc0ddd2$var$_isArray = $3Npdz((parcelRequire("i0kCX")));

var $dd5c1087ccc0ddd2$var$_promise = $3Npdz((parcelRequire("bCWDe"))); // Create Deferred Promise
function $dd5c1087ccc0ddd2$var$resolvingPromise() {
    var res;
    var rej;
    var promise = new $dd5c1087ccc0ddd2$var$_promise.default(function(resolve, reject) {
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function $dd5c1087ccc0ddd2$var$when(promises) {
    var objects;
    var arrayArgument = (0, $dd5c1087ccc0ddd2$var$_isArray.default)(promises);
    if (arrayArgument) objects = promises;
    else objects = arguments;
    var total = objects.length;
    var hadError = false;
    var results = [];
    var returnValue = arrayArgument ? [
        results
    ] : results;
    var errors = [];
    results.length = objects.length;
    errors.length = objects.length;
    if (total === 0) return $dd5c1087ccc0ddd2$var$_promise.default.resolve(returnValue);
    var promise = new $dd5c1087ccc0ddd2$var$resolvingPromise();
    var resolveOne = function() {
        total--;
        if (total <= 0) {
            if (hadError) promise.reject(errors);
            else promise.resolve(returnValue);
        }
    };
    var chain = function(object, index) {
        if (object && typeof object.then === "function") object.then(function(result) {
            results[index] = result;
            resolveOne();
        }, function(error) {
            errors[index] = error;
            hadError = true;
            resolveOne();
        });
        else {
            results[index] = object;
            resolveOne();
        }
    };
    for(var i = 0; i < objects.length; i++)chain(objects[i], i);
    return promise;
}
function $dd5c1087ccc0ddd2$var$continueWhile(test, emitter) {
    if (test()) return emitter().then(function() {
        return $dd5c1087ccc0ddd2$var$continueWhile(test, emitter);
    });
    return $dd5c1087ccc0ddd2$var$_promise.default.resolve();
}

});

parcelRequire.register("1e9ZI", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");


var $liESz = parcelRequire("liESz");

var $ebK4m = parcelRequire("ebK4m");

var $5hSqA = parcelRequire("5hSqA");


var $0e4ed9ecb5644e3b$var$_keys = $3Npdz((parcelRequire("r9mpE")));

var $0e4ed9ecb5644e3b$var$_forEach = $3Npdz((parcelRequire("jZGC2")));

var $0e4ed9ecb5644e3b$var$_map = $3Npdz((parcelRequire("hqsP5")));

var $0e4ed9ecb5644e3b$var$_concat = $3Npdz((parcelRequire("3mvQI")));

var $0e4ed9ecb5644e3b$var$_typeof2 = $3Npdz((parcelRequire("akViX")));

var $0e4ed9ecb5644e3b$var$_isInteger = $3Npdz((parcelRequire("hNeT5")));

var $0e4ed9ecb5644e3b$var$_slicedToArray2 = $3Npdz((parcelRequire("5kSp4")));

var $0e4ed9ecb5644e3b$var$_slice = $3Npdz((parcelRequire("fG1Ke")));

var $0e4ed9ecb5644e3b$var$_filter = $3Npdz((parcelRequire("kYm0J")));

var $0e4ed9ecb5644e3b$var$_isArray = $3Npdz((parcelRequire("i0kCX")));

var $0e4ed9ecb5644e3b$var$_indexOf = $3Npdz((parcelRequire("eOZH4")));
function $0e4ed9ecb5644e3b$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof $ebK4m !== "undefined" && $liESz(o) || o["@@iterator"];
    if (!it) {
        if ((parcelRequire("i0kCX"))(o) || (it = $0e4ed9ecb5644e3b$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function() {};
            return {
                s: F,
                n: function() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function() {
            it = it.call(o);
        },
        n: function() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $0e4ed9ecb5644e3b$var$_unsupportedIterableToArray(o, minLen) {
    var _context6;
    if (!o) return;
    if (typeof o === "string") return $0e4ed9ecb5644e3b$var$_arrayLikeToArray(o, minLen);
    var n = (parcelRequire("fG1Ke"))(_context6 = Object.prototype.toString.call(o)).call(_context6, 8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return $5hSqA(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0e4ed9ecb5644e3b$var$_arrayLikeToArray(o, minLen);
}
function $0e4ed9ecb5644e3b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

var $26BK8 = parcelRequire("26BK8");
var $0e4ed9ecb5644e3b$require$equalObjects = $26BK8.default;

var $7CFxK = parcelRequire("7CFxK");
var $0e4ed9ecb5644e3b$require$decode = $7CFxK.default;

var $3HQSG = parcelRequire("3HQSG");
var $0e4ed9ecb5644e3b$require$ParseError = $3HQSG.default;

var $dkxwb = parcelRequire("dkxwb");
var $0e4ed9ecb5644e3b$require$ParsePolygon = $dkxwb.default;

var $5vhig = parcelRequire("5vhig");
var $0e4ed9ecb5644e3b$require$ParseGeoPoint = $5vhig.default;
/**
 * contains -- Determines if an object is contained in a list with special handling for Parse pointers.
 *
 * @param haystack
 * @param needle
 * @private
 * @returns {boolean}
 */ function $0e4ed9ecb5644e3b$var$contains(haystack, needle) {
    if (needle && needle.__type && (needle.__type === "Pointer" || needle.__type === "Object")) {
        for(var i in haystack){
            var ptr = haystack[i];
            if (typeof ptr === "string" && ptr === needle.objectId) return true;
            if (ptr.className === needle.className && ptr.objectId === needle.objectId) return true;
        }
        return false;
    }
    return (0, $0e4ed9ecb5644e3b$var$_indexOf.default)(haystack).call(haystack, needle) > -1;
}
function $0e4ed9ecb5644e3b$var$transformObject(object) {
    if (object._toFullJSON) return object._toFullJSON();
    return object;
}
/**
 * matchesQuery -- Determines if an object would be returned by a Parse Query
 * It's a lightweight, where-clause only implementation of a full query engine.
 * Since we find queries that match objects, rather than objects that match
 * queries, we can avoid building a full-blown query tool.
 *
 * @param className
 * @param object
 * @param objects
 * @param query
 * @private
 * @returns {boolean}
 */ function $0e4ed9ecb5644e3b$var$matchesQuery(className, object, objects, query) {
    if (object.className !== className) return false;
    var obj = object;
    var q = query;
    if (object.toJSON) obj = object.toJSON();
    if (query.toJSON) q = query.toJSON().where;
    obj.className = className;
    for(var field in q){
        if (!$0e4ed9ecb5644e3b$var$matchesKeyConstraints(className, obj, objects, field, q[field])) return false;
    }
    return true;
}
function $0e4ed9ecb5644e3b$var$equalObjectsGeneric(obj, compareTo, eqlFn) {
    if ((0, $0e4ed9ecb5644e3b$var$_isArray.default)(obj)) {
        for(var i = 0; i < obj.length; i++){
            if (eqlFn(obj[i], compareTo)) return true;
        }
        return false;
    }
    return eqlFn(obj, compareTo);
}
/**
 * @typedef RelativeTimeToDateResult
 * @property {string} status The conversion status, `error` if conversion failed or
 * `success` if conversion succeeded.
 * @property {string} info The error message if conversion failed, or the relative
 * time indication (`past`, `present`, `future`) if conversion succeeded.
 * @property {Date|undefined} result The converted date, or `undefined` if conversion
 * failed.
 */ /**
 * Converts human readable relative date string, for example, 'in 10 days' to a date
 * relative to now.
 *
 * @param {string} text The text to convert.
 * @param {Date} [now=new Date()] The date from which add or subtract. Default is now.
 * @returns {RelativeTimeToDateResult}
 */ function $0e4ed9ecb5644e3b$var$relativeTimeToDate(text) {
    var now = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
    text = text.toLowerCase();
    var parts = text.split(" "); // Filter out whitespace
    parts = (0, $0e4ed9ecb5644e3b$var$_filter.default)(parts).call(parts, function(part) {
        return part !== "";
    });
    var future = parts[0] === "in";
    var past = parts[parts.length - 1] === "ago";
    if (!future && !past && text !== "now") return {
        status: "error",
        info: "Time should either start with 'in' or end with 'ago'"
    };
    if (future && past) return {
        status: "error",
        info: "Time cannot have both 'in' and 'ago'"
    };
     // strip the 'ago' or 'in'
    if (future) parts = (0, $0e4ed9ecb5644e3b$var$_slice.default)(parts).call(parts, 1);
    else // past
    parts = (0, $0e4ed9ecb5644e3b$var$_slice.default)(parts).call(parts, 0, parts.length - 1);
    if (parts.length % 2 !== 0 && text !== "now") return {
        status: "error",
        info: "Invalid time string. Dangling unit or number."
    };
    var pairs = [];
    while(parts.length)pairs.push([
        parts.shift(),
        parts.shift()
    ]);
    var seconds = 0;
    for(var _i = 0, _pairs = pairs; _i < _pairs.length; _i++){
        var _pairs$_i = (0, $0e4ed9ecb5644e3b$var$_slicedToArray2.default)(_pairs[_i], 2), num = _pairs$_i[0], interval = _pairs$_i[1];
        var val = Number(num);
        if (!(0, $0e4ed9ecb5644e3b$var$_isInteger.default)(val)) return {
            status: "error",
            info: "'".concat(num, "' is not an integer.")
        };
        switch(interval){
            case "yr":
            case "yrs":
            case "year":
            case "years":
                seconds += val * 31536000; // 365 * 24 * 60 * 60
                break;
            case "wk":
            case "wks":
            case "week":
            case "weeks":
                seconds += val * 604800; // 7 * 24 * 60 * 60
                break;
            case "d":
            case "day":
            case "days":
                seconds += val * 86400; // 24 * 60 * 60
                break;
            case "hr":
            case "hrs":
            case "hour":
            case "hours":
                seconds += val * 3600; // 60 * 60
                break;
            case "min":
            case "mins":
            case "minute":
            case "minutes":
                seconds += val * 60;
                break;
            case "sec":
            case "secs":
            case "second":
            case "seconds":
                seconds += val;
                break;
            default:
                return {
                    status: "error",
                    info: "Invalid interval: '".concat(interval, "'")
                };
        }
    }
    var milliseconds = seconds * 1000;
    if (future) return {
        status: "success",
        info: "future",
        result: new Date(now.valueOf() + milliseconds)
    };
    else if (past) return {
        status: "success",
        info: "past",
        result: new Date(now.valueOf() - milliseconds)
    };
    else return {
        status: "success",
        info: "present",
        result: new Date(now.valueOf())
    };
}
/**
 * Determines whether an object matches a single key's constraints
 *
 * @param className
 * @param object
 * @param objects
 * @param key
 * @param constraints
 * @private
 * @returns {boolean}
 */ function $0e4ed9ecb5644e3b$var$matchesKeyConstraints(className, object, objects, key, constraints) {
    if (constraints === null) return false;
    if ((0, $0e4ed9ecb5644e3b$var$_indexOf.default)(key).call(key, ".") >= 0) {
        // Key references a subobject
        var keyComponents = key.split(".");
        var subObjectKey = keyComponents[0];
        var keyRemainder = (0, $0e4ed9ecb5644e3b$var$_slice.default)(keyComponents).call(keyComponents, 1).join(".");
        return $0e4ed9ecb5644e3b$var$matchesKeyConstraints(className, object[subObjectKey] || {}, objects, keyRemainder, constraints);
    }
    var i;
    if (key === "$or") {
        for(i = 0; i < constraints.length; i++){
            if ($0e4ed9ecb5644e3b$var$matchesQuery(className, object, objects, constraints[i])) return true;
        }
        return false;
    }
    if (key === "$and") {
        for(i = 0; i < constraints.length; i++){
            if (!$0e4ed9ecb5644e3b$var$matchesQuery(className, object, objects, constraints[i])) return false;
        }
        return true;
    }
    if (key === "$nor") {
        for(i = 0; i < constraints.length; i++){
            if ($0e4ed9ecb5644e3b$var$matchesQuery(className, object, objects, constraints[i])) return false;
        }
        return true;
    }
    if (key === "$relatedTo") // Bail! We can't handle relational queries locally
    return false;
    if (!/^[A-Za-z][0-9A-Za-z_]*$/.test(key)) throw new $0e4ed9ecb5644e3b$require$ParseError($0e4ed9ecb5644e3b$require$ParseError.INVALID_KEY_NAME, "Invalid Key: ".concat(key));
     // Equality (or Array contains) cases
    if ((0, $0e4ed9ecb5644e3b$var$_typeof2.default)(constraints) !== "object") {
        if ((0, $0e4ed9ecb5644e3b$var$_isArray.default)(object[key])) {
            var _context;
            return (0, $0e4ed9ecb5644e3b$var$_indexOf.default)(_context = object[key]).call(_context, constraints) > -1;
        }
        return object[key] === constraints;
    }
    var compareTo;
    if (constraints.__type) {
        if (constraints.__type === "Pointer") return $0e4ed9ecb5644e3b$var$equalObjectsGeneric(object[key], constraints, function(obj, ptr) {
            return typeof obj !== "undefined" && ptr.className === obj.className && ptr.objectId === obj.objectId;
        });
        return $0e4ed9ecb5644e3b$var$equalObjectsGeneric($0e4ed9ecb5644e3b$require$decode(object[key]), $0e4ed9ecb5644e3b$require$decode(constraints), $0e4ed9ecb5644e3b$require$equalObjects);
    } // More complex cases
    for(var condition in constraints){
        compareTo = constraints[condition];
        if (compareTo.__type) compareTo = $0e4ed9ecb5644e3b$require$decode(compareTo);
         // is it a $relativeTime? convert to date
        if (compareTo["$relativeTime"]) {
            var parserResult = $0e4ed9ecb5644e3b$var$relativeTimeToDate(compareTo["$relativeTime"]);
            if (parserResult.status !== "success") {
                var _context2;
                throw new $0e4ed9ecb5644e3b$require$ParseError($0e4ed9ecb5644e3b$require$ParseError.INVALID_JSON, (0, $0e4ed9ecb5644e3b$var$_concat.default)(_context2 = "bad $relativeTime (".concat(key, ") value. ")).call(_context2, parserResult.info));
            }
            compareTo = parserResult.result;
        } // Compare Date Object or Date String
        if (toString.call(compareTo) === "[object Date]" || typeof compareTo === "string" && true && !isNaN(new Date(compareTo))) object[key] = new Date(object[key].iso ? object[key].iso : object[key]);
        switch(condition){
            case "$lt":
                if (object[key] >= compareTo) return false;
                break;
            case "$lte":
                if (object[key] > compareTo) return false;
                break;
            case "$gt":
                if (object[key] <= compareTo) return false;
                break;
            case "$gte":
                if (object[key] < compareTo) return false;
                break;
            case "$ne":
                if ($0e4ed9ecb5644e3b$require$equalObjects(object[key], compareTo)) return false;
                break;
            case "$in":
                if (!$0e4ed9ecb5644e3b$var$contains(compareTo, object[key])) return false;
                break;
            case "$nin":
                if ($0e4ed9ecb5644e3b$var$contains(compareTo, object[key])) return false;
                break;
            case "$all":
                for(i = 0; i < compareTo.length; i++){
                    var _context3;
                    if ((0, $0e4ed9ecb5644e3b$var$_indexOf.default)(_context3 = object[key]).call(_context3, compareTo[i]) < 0) return false;
                }
                break;
            case "$exists":
                var propertyExists = typeof object[key] !== "undefined";
                var existenceIsRequired = constraints["$exists"];
                if (typeof constraints["$exists"] !== "boolean") break;
                if (!propertyExists && existenceIsRequired || propertyExists && !existenceIsRequired) return false;
                break;
            case "$regex":
                if ((0, $0e4ed9ecb5644e3b$var$_typeof2.default)(compareTo) === "object") return compareTo.test(object[key]);
                 // JS doesn't support perl-style escaping
                var expString = "";
                var escapeEnd = -2;
                var escapeStart = (0, $0e4ed9ecb5644e3b$var$_indexOf.default)(compareTo).call(compareTo, "\\Q");
                while(escapeStart > -1){
                    // Add the unescaped portion
                    expString += compareTo.substring(escapeEnd + 2, escapeStart);
                    escapeEnd = (0, $0e4ed9ecb5644e3b$var$_indexOf.default)(compareTo).call(compareTo, "\\E", escapeStart);
                    if (escapeEnd > -1) expString += compareTo.substring(escapeStart + 2, escapeEnd).replace(/\\\\\\\\E/g, "\\E").replace(/\W/g, "\\$&");
                    escapeStart = (0, $0e4ed9ecb5644e3b$var$_indexOf.default)(compareTo).call(compareTo, "\\Q", escapeEnd);
                }
                expString += compareTo.substring(Math.max(escapeStart, escapeEnd + 2));
                var modifiers = constraints.$options || "";
                modifiers = modifiers.replace("x", "").replace("s", ""); // Parse Server / Mongo support x and s modifiers but JS RegExp doesn't
                var exp = new RegExp(expString, modifiers);
                if (!exp.test(object[key])) return false;
                break;
            case "$nearSphere":
                if (!compareTo || !object[key]) return false;
                var distance = compareTo.radiansTo(object[key]);
                var max = constraints.$maxDistance || Infinity;
                return distance <= max;
            case "$within":
                if (!compareTo || !object[key]) return false;
                var southWest = compareTo.$box[0];
                var northEast = compareTo.$box[1];
                if (southWest.latitude > northEast.latitude || southWest.longitude > northEast.longitude) // Invalid box, crosses the date line
                return false;
                return object[key].latitude > southWest.latitude && object[key].latitude < northEast.latitude && object[key].longitude > southWest.longitude && object[key].longitude < northEast.longitude;
            case "$options":
                break;
            case "$maxDistance":
                break;
            case "$select":
                var subQueryObjects = (0, $0e4ed9ecb5644e3b$var$_filter.default)(objects).call(objects, function(obj, index, arr) {
                    return $0e4ed9ecb5644e3b$var$matchesQuery(compareTo.query.className, obj, arr, compareTo.query.where);
                });
                for(var _i2 = 0; _i2 < subQueryObjects.length; _i2 += 1){
                    var subObject = $0e4ed9ecb5644e3b$var$transformObject(subQueryObjects[_i2]);
                    return $0e4ed9ecb5644e3b$require$equalObjects(object[key], subObject[compareTo.key]);
                }
                return false;
            case "$dontSelect":
                var _subQueryObjects = (0, $0e4ed9ecb5644e3b$var$_filter.default)(objects).call(objects, function(obj, index, arr) {
                    return $0e4ed9ecb5644e3b$var$matchesQuery(compareTo.query.className, obj, arr, compareTo.query.where);
                });
                for(var _i3 = 0; _i3 < _subQueryObjects.length; _i3 += 1){
                    var _subObject = $0e4ed9ecb5644e3b$var$transformObject(_subQueryObjects[_i3]);
                    return !$0e4ed9ecb5644e3b$require$equalObjects(object[key], _subObject[compareTo.key]);
                }
                return false;
            case "$inQuery":
                var _subQueryObjects2 = (0, $0e4ed9ecb5644e3b$var$_filter.default)(objects).call(objects, function(obj, index, arr) {
                    return $0e4ed9ecb5644e3b$var$matchesQuery(compareTo.className, obj, arr, compareTo.where);
                });
                for(var _i4 = 0; _i4 < _subQueryObjects2.length; _i4 += 1){
                    var _subObject2 = $0e4ed9ecb5644e3b$var$transformObject(_subQueryObjects2[_i4]);
                    if (object[key].className === _subObject2.className && object[key].objectId === _subObject2.objectId) return true;
                }
                return false;
            case "$notInQuery":
                var _subQueryObjects3 = (0, $0e4ed9ecb5644e3b$var$_filter.default)(objects).call(objects, function(obj, index, arr) {
                    return $0e4ed9ecb5644e3b$var$matchesQuery(compareTo.className, obj, arr, compareTo.where);
                });
                for(var _i5 = 0; _i5 < _subQueryObjects3.length; _i5 += 1){
                    var _subObject3 = $0e4ed9ecb5644e3b$var$transformObject(_subQueryObjects3[_i5]);
                    if (object[key].className === _subObject3.className && object[key].objectId === _subObject3.objectId) return false;
                }
                return true;
            case "$containedBy":
                var _iterator = $0e4ed9ecb5644e3b$var$_createForOfIteratorHelper(object[key]), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var value = _step.value;
                        if (!$0e4ed9ecb5644e3b$var$contains(compareTo, value)) return false;
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                return true;
            case "$geoWithin":
                if (compareTo.$polygon) {
                    var _context4;
                    var points = (0, $0e4ed9ecb5644e3b$var$_map.default)(_context4 = compareTo.$polygon).call(_context4, function(geoPoint) {
                        return [
                            geoPoint.latitude,
                            geoPoint.longitude
                        ];
                    });
                    var polygon = new $0e4ed9ecb5644e3b$require$ParsePolygon(points);
                    return polygon.containsPoint(object[key]);
                }
                if (compareTo.$centerSphere) {
                    var _compareTo$$centerSph = (0, $0e4ed9ecb5644e3b$var$_slicedToArray2.default)(compareTo.$centerSphere, 2), WGS84Point = _compareTo$$centerSph[0], maxDistance = _compareTo$$centerSph[1];
                    var centerPoint = new $0e4ed9ecb5644e3b$require$ParseGeoPoint({
                        latitude: WGS84Point[1],
                        longitude: WGS84Point[0]
                    });
                    var point = new $0e4ed9ecb5644e3b$require$ParseGeoPoint(object[key]);
                    var _distance = point.radiansTo(centerPoint);
                    return _distance <= maxDistance;
                }
                break;
            case "$geoIntersects":
                var _polygon = new $0e4ed9ecb5644e3b$require$ParsePolygon(object[key].coordinates);
                var _point = new $0e4ed9ecb5644e3b$require$ParseGeoPoint(compareTo.$point);
                return _polygon.containsPoint(_point);
            default:
                return false;
        }
    }
    return true;
}
function $0e4ed9ecb5644e3b$var$validateQuery(query) {
    var _context5;
    var q = query;
    if (query.toJSON) q = query.toJSON().where;
    var specialQuerykeys = [
        "$and",
        "$or",
        "$nor",
        "_rperm",
        "_wperm",
        "_perishable_token",
        "_email_verify_token",
        "_email_verify_token_expires_at",
        "_account_lockout_expires_at",
        "_failed_login_count"
    ];
    (0, $0e4ed9ecb5644e3b$var$_forEach.default)(_context5 = (0, $0e4ed9ecb5644e3b$var$_keys.default)(q)).call(_context5, function(key) {
        if (q && q[key] && q[key].$regex) {
            if (typeof q[key].$options === "string") {
                if (!q[key].$options.match(/^[imxs]+$/)) throw new $0e4ed9ecb5644e3b$require$ParseError($0e4ed9ecb5644e3b$require$ParseError.INVALID_QUERY, "Bad $options value for query: ".concat(q[key].$options));
            }
        }
        if ((0, $0e4ed9ecb5644e3b$var$_indexOf.default)(specialQuerykeys).call(specialQuerykeys, key) < 0 && !key.match(/^[a-zA-Z][a-zA-Z0-9_\.]*$/)) throw new $0e4ed9ecb5644e3b$require$ParseError($0e4ed9ecb5644e3b$require$ParseError.INVALID_KEY_NAME, "Invalid key name: ".concat(key));
    });
}
var $0e4ed9ecb5644e3b$var$OfflineQuery = {
    matchesQuery: $0e4ed9ecb5644e3b$var$matchesQuery,
    validateQuery: $0e4ed9ecb5644e3b$var$validateQuery
};
module.exports = $0e4ed9ecb5644e3b$var$OfflineQuery;

});
parcelRequire.register("hNeT5", function(module, exports) {

module.exports = (parcelRequire("dJdQe"));

});
parcelRequire.register("dJdQe", function(module, exports) {

var $4NwEp = parcelRequire("4NwEp");
module.exports = $4NwEp;

});
parcelRequire.register("4NwEp", function(module, exports) {
parcelRequire("a52zj");

var $envPC = parcelRequire("envPC");
module.exports = $envPC.Number.isInteger;

});
parcelRequire.register("a52zj", function(module, exports) {

var $g2B3u = parcelRequire("g2B3u");

var $eIRBL = parcelRequire("eIRBL");
// `Number.isInteger` method
// https://tc39.es/ecma262/#sec-number.isinteger
$g2B3u({
    target: "Number",
    stat: true
}, {
    isInteger: $eIRBL
});

});
parcelRequire.register("eIRBL", function(module, exports) {

var $atGHr = parcelRequire("atGHr");
var $ab7ec230806ca1f3$var$floor = Math.floor;
// `IsIntegralNumber` abstract operation
// https://tc39.es/ecma262/#sec-isintegralnumber
// eslint-disable-next-line es/no-number-isinteger -- safe
module.exports = Number.isInteger || function isInteger(it) {
    return !$atGHr(it) && isFinite(it) && $ab7ec230806ca1f3$var$floor(it) === it;
};

});





parcelRequire.register("26BK8", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $evY07 = parcelRequire("evY07");
$evY07(module.exports, "__esModule", {
    value: true
});
module.exports.default = $18896b4bd5dd8275$var$equals;

var $18896b4bd5dd8275$var$_keys = $3Npdz((parcelRequire("r9mpE")));

var $18896b4bd5dd8275$var$_isArray = $3Npdz((parcelRequire("i0kCX")));

var $18896b4bd5dd8275$var$_typeof2 = $3Npdz((parcelRequire("akViX")));

var $18896b4bd5dd8275$var$_ParseACL = $3Npdz((parcelRequire("9HvHn")));

var $18896b4bd5dd8275$var$_ParseFile = $3Npdz((parcelRequire("gf3Ge")));

var $18896b4bd5dd8275$var$_ParseGeoPoint = $3Npdz((parcelRequire("5vhig")));

var $18896b4bd5dd8275$var$_ParseObject = $3Npdz((parcelRequire("2HIpX")));
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */ function $18896b4bd5dd8275$var$equals(a, b) {
    var toString = Object.prototype.toString;
    if (toString.call(a) === "[object Date]" || toString.call(b) === "[object Date]") {
        var dateA = new Date(a);
        var dateB = new Date(b);
        return +dateA === +dateB;
    }
    if ((0, $18896b4bd5dd8275$var$_typeof2.default)(a) !== (0, $18896b4bd5dd8275$var$_typeof2.default)(b)) return false;
    if (!a || (0, $18896b4bd5dd8275$var$_typeof2.default)(a) !== "object") // a is a primitive
    return a === b;
    if ((0, $18896b4bd5dd8275$var$_isArray.default)(a) || (0, $18896b4bd5dd8275$var$_isArray.default)(b)) {
        if (!(0, $18896b4bd5dd8275$var$_isArray.default)(a) || !(0, $18896b4bd5dd8275$var$_isArray.default)(b)) return false;
        if (a.length !== b.length) return false;
        for(var i = a.length; i--;){
            if (!$18896b4bd5dd8275$var$equals(a[i], b[i])) return false;
        }
        return true;
    }
    if (a instanceof $18896b4bd5dd8275$var$_ParseACL.default || a instanceof $18896b4bd5dd8275$var$_ParseFile.default || a instanceof $18896b4bd5dd8275$var$_ParseGeoPoint.default || a instanceof $18896b4bd5dd8275$var$_ParseObject.default) return a.equals(b);
    if (b instanceof $18896b4bd5dd8275$var$_ParseObject.default) {
        if (a.__type === "Object" || a.__type === "Pointer") return a.objectId === b.id && a.className === b.className;
    }
    if ((0, $18896b4bd5dd8275$var$_keys.default)(a).length !== (0, $18896b4bd5dd8275$var$_keys.default)(b).length) return false;
    for(var k in a){
        if (!$18896b4bd5dd8275$var$equals(a[k], b[k])) return false;
    }
    return true;
}

});


parcelRequire.register("7Icwu", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $evY07 = parcelRequire("evY07");
$evY07(module.exports, "__esModule", {
    value: true
});
module.exports.PIN_PREFIX = module.exports.OBJECT_PREFIX = module.exports.DEFAULT_PIN = void 0;
module.exports.isLocalDatastoreKey = $59d65b4802df57e9$var$isLocalDatastoreKey;

var $59d65b4802df57e9$var$_startsWith = $3Npdz((parcelRequire("fgj1z")));
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 * @private
 */ var $59d65b4802df57e9$var$DEFAULT_PIN = "_default";
module.exports.DEFAULT_PIN = $59d65b4802df57e9$var$DEFAULT_PIN;
var $59d65b4802df57e9$var$PIN_PREFIX = "parsePin_";
module.exports.PIN_PREFIX = $59d65b4802df57e9$var$PIN_PREFIX;
var $59d65b4802df57e9$var$OBJECT_PREFIX = "Parse_LDS_";
module.exports.OBJECT_PREFIX = $59d65b4802df57e9$var$OBJECT_PREFIX;
function $59d65b4802df57e9$var$isLocalDatastoreKey(key) /*: boolean*/ {
    return !!(key && (key === $59d65b4802df57e9$var$DEFAULT_PIN || (0, $59d65b4802df57e9$var$_startsWith.default)(key).call(key, $59d65b4802df57e9$var$PIN_PREFIX) || (0, $59d65b4802df57e9$var$_startsWith.default)(key).call(key, $59d65b4802df57e9$var$OBJECT_PREFIX)));
}

});




parcelRequire.register("c9yrO", function(module, exports) {
"use strict";

var $evY07 = parcelRequire("evY07");
$evY07(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8d910bd8c9e26cd0$var$escape;
/*
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ var $8d910bd8c9e26cd0$var$encoded = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    "/": "&#x2F;",
    "'": "&#x27;",
    '"': "&quot;"
};
function $8d910bd8c9e26cd0$var$escape(str) /*: string*/ {
    return str.replace(/[&<>\/'"]/g, function(char) {
        return $8d910bd8c9e26cd0$var$encoded[char];
    });
}

});

parcelRequire.register("3gAuF", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $fG1Ke = parcelRequire("fG1Ke");

var $iY2ec = parcelRequire("iY2ec");

var $bCWDe = parcelRequire("bCWDe");

var $iWJ3a = parcelRequire("iWJ3a");

var $akViX = parcelRequire("akViX");

var $jZGC2 = parcelRequire("jZGC2");

var $cO2y8 = parcelRequire("cO2y8");

var $dvfqn = parcelRequire("dvfqn");

var $evY07 = parcelRequire("evY07");

var $ebK4m = parcelRequire("ebK4m");

var $260f2c952070dccb$var$_find = $3Npdz((parcelRequire("jGOxU")));

var $260f2c952070dccb$var$_setInterval2 = $3Npdz((parcelRequire("5wnDQ")));

var $260f2c952070dccb$var$_toConsumableArray2 = $3Npdz((parcelRequire("6VZVY")));

var $260f2c952070dccb$var$_findIndex = $3Npdz((parcelRequire("f2quz")));

var $260f2c952070dccb$var$_splice = $3Npdz((parcelRequire("5SAes")));

var $260f2c952070dccb$var$_stringify = $3Npdz((parcelRequire("O2sNs")));

var $260f2c952070dccb$var$_asyncToGenerator2 = $3Npdz((parcelRequire("iqZS2")));

var $260f2c952070dccb$var$_CoreManager = $3Npdz((parcelRequire("465CW")));

var $260f2c952070dccb$var$_ParseObject = $3Npdz((parcelRequire("2HIpX")));

var $260f2c952070dccb$var$_ParseQuery = $3Npdz((parcelRequire("eJCLn")));

var $260f2c952070dccb$var$_Storage = $3Npdz((parcelRequire("7Zbj0")));
function $260f2c952070dccb$var$_regeneratorRuntime() {
    "use strict";
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ $260f2c952070dccb$var$_regeneratorRuntime = function() {
        return exports;
    };
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof $ebK4m ? $ebK4m : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return $evY07(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = $dvfqn(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return generator._invoke = function(innerFn, self, context) {
            var state = "suspendedStart";
            return function(method, arg) {
                if ("executing" === state) throw new Error("Generator is already running");
                if ("completed" === state) {
                    if ("throw" === method) throw arg;
                    return doneResult();
                }
                for(context.method = method, context.arg = arg;;){
                    var delegate = context.delegate;
                    if (delegate) {
                        var delegateResult = maybeInvokeDelegate(delegate, context);
                        if (delegateResult) {
                            if (delegateResult === ContinueSentinel) continue;
                            return delegateResult;
                        }
                    }
                    if ("next" === context.method) context.sent = context._sent = context.arg;
                    else if ("throw" === context.method) {
                        if ("suspendedStart" === state) throw state = "completed", context.arg;
                        context.dispatchException(context.arg);
                    } else "return" === context.method && context.abrupt("return", context.arg);
                    state = "executing";
                    var record = tryCatch(innerFn, self, context);
                    if ("normal" === record.type) {
                        if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                        return {
                            value: record.arg,
                            done: context.done
                        };
                    }
                    "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
                }
            };
        }(innerFn, self, context), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = $cO2y8, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = $dvfqn(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        var _context9;
        $jZGC2(_context9 = [
            "next",
            "throw",
            "return"
        ]).call(_context9, function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == $akViX(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        this._invoke = function(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];
        if (undefined === method) {
            if (context.delegate = null, "throw" === context.method) {
                if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
                context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], $jZGC2(tryLocsList).call(tryLocsList, pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;){
                        if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    }
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return $iWJ3a ? $iWJ3a(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = $dvfqn(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = $bCWDe);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(object) {
        var keys = [];
        for(var key in object)keys.push(key);
        return $iY2ec(keys).call(keys), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            var _context10;
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, $jZGC2(_context10 = this.tryEntries).call(_context10, resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+$fG1Ke(name).call(name, 1)) && (this[name] = undefined);
        },
        stop: function() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
var $260f2c952070dccb$var$QUEUE_KEY = "Parse/Eventually/Queue";
var $260f2c952070dccb$var$queueCache = [];
var $260f2c952070dccb$var$dirtyCache = true;
var $260f2c952070dccb$var$polling = undefined;
/**
 * Provides utility functions to queue objects that will be
 * saved to the server at a later date.
 *
 * @class Parse.EventuallyQueue
 * @static
 */ var $260f2c952070dccb$var$EventuallyQueue = {
    /**
   * Add object to queue with save operation.
   *
   * @function save
   * @name Parse.EventuallyQueue.save
   * @param {ParseObject} object Parse.Object to be saved eventually
   * @param {object} [serverOptions] See {@link https://parseplatform.org/Parse-SDK-JS/api/master/Parse.Object.html#save Parse.Object.save} options.
   * @returns {Promise} A promise that is fulfilled if object is added to queue.
   * @static
   * @see Parse.Object#saveEventually
   */ save: function(object) /*: Promise*/ {
        var serverOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.enqueue("save", object, serverOptions);
    },
    /**
   * Add object to queue with save operation.
   *
   * @function destroy
   * @name Parse.EventuallyQueue.destroy
   * @param {ParseObject} object Parse.Object to be destroyed eventually
   * @param {object} [serverOptions] See {@link https://parseplatform.org/Parse-SDK-JS/api/master/Parse.Object.html#destroy Parse.Object.destroy} options
   * @returns {Promise} A promise that is fulfilled if object is added to queue.
   * @static
   * @see Parse.Object#destroyEventually
   */ destroy: function(object) /*: Promise*/ {
        var serverOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.enqueue("destroy", object, serverOptions);
    },
    /**
   * Generate unique identifier to avoid duplicates and maintain previous state.
   *
   * @param {string} action save / destroy
   * @param {object} object Parse.Object to be queued
   * @returns {string}
   * @static
   * @ignore
   */ generateQueueId: function(action, object) /*: string*/ {
        object._getId();
        var className = object.className, id = object.id, _localId = object._localId;
        var uniqueId = object.get("hash") || _localId;
        return [
            action,
            className,
            id,
            uniqueId
        ].join("_");
    },
    /**
   * Build queue object and add to queue.
   *
   * @param {string} action save / destroy
   * @param {object} object Parse.Object to be queued
   * @param {object} [serverOptions]
   * @returns {Promise} A promise that is fulfilled if object is added to queue.
   * @static
   * @ignore
   */ enqueue: function(action, object, serverOptions) /*: Promise*/ {
        var _this = this;
        return (0, $260f2c952070dccb$var$_asyncToGenerator2.default)(/*#__PURE__*/ $260f2c952070dccb$var$_regeneratorRuntime().mark(function _callee() {
            var queueData, queueId, index, prop;
            return $260f2c952070dccb$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        _context.next = 2;
                        return _this.getQueue();
                    case 2:
                        queueData = _context.sent;
                        queueId = _this.generateQueueId(action, object);
                        index = _this.queueItemExists(queueData, queueId);
                        if (index > -1) {
                            // Add cached values to new object if they don't exist
                            for(prop in queueData[index].object)if (typeof object.get(prop) === "undefined") object.set(prop, queueData[index].object[prop]);
                        } else index = queueData.length;
                        queueData[index] = {
                            queueId: queueId,
                            action: action,
                            object: object.toJSON(),
                            serverOptions: serverOptions,
                            id: object.id,
                            className: object.className,
                            hash: object.get("hash"),
                            createdAt: new Date()
                        };
                        return _context.abrupt("return", _this.setQueue(queueData));
                    case 8:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }))();
    },
    store: function store(data) {
        return $260f2c952070dccb$var$_Storage.default.setItemAsync($260f2c952070dccb$var$QUEUE_KEY, (0, $260f2c952070dccb$var$_stringify.default)(data));
    },
    load: function load() {
        return $260f2c952070dccb$var$_Storage.default.getItemAsync($260f2c952070dccb$var$QUEUE_KEY);
    },
    /**
   * Sets the in-memory queue from local storage and returns.
   *
   * @function getQueue
   * @name Parse.EventuallyQueue.getQueue
   * @returns {Promise<Array>}
   * @static
   */ getQueue: function getQueue() /*: Promise<Array>*/ {
        var _this2 = this;
        return (0, $260f2c952070dccb$var$_asyncToGenerator2.default)(/*#__PURE__*/ $260f2c952070dccb$var$_regeneratorRuntime().mark(function _callee2() {
            return $260f2c952070dccb$var$_regeneratorRuntime().wrap(function _callee2$(_context2) {
                while(true)switch(_context2.prev = _context2.next){
                    case 0:
                        if (!$260f2c952070dccb$var$dirtyCache) {
                            _context2.next = 10;
                            break;
                        }
                        _context2.t0 = JSON;
                        _context2.next = 4;
                        return _this2.load();
                    case 4:
                        _context2.t1 = _context2.sent;
                        if (_context2.t1) {
                            _context2.next = 7;
                            break;
                        }
                        _context2.t1 = "[]";
                    case 7:
                        _context2.t2 = _context2.t1;
                        $260f2c952070dccb$var$queueCache = _context2.t0.parse.call(_context2.t0, _context2.t2);
                        $260f2c952070dccb$var$dirtyCache = false;
                    case 10:
                        return _context2.abrupt("return", $260f2c952070dccb$var$queueCache);
                    case 11:
                    case "end":
                        return _context2.stop();
                }
            }, _callee2);
        }))();
    },
    /**
   * Saves the queue to local storage
   *
   * @param {Queue} queue Queue containing Parse.Object data.
   * @returns {Promise} A promise that is fulfilled when queue is stored.
   * @static
   * @ignore
   */ setQueue: function setQueue(queue) /*: Promise<void>*/ {
        $260f2c952070dccb$var$queueCache = queue;
        return this.store($260f2c952070dccb$var$queueCache);
    },
    /**
   * Removes Parse.Object data from queue.
   *
   * @param {string} queueId Unique identifier for Parse.Object data.
   * @returns {Promise} A promise that is fulfilled when queue is stored.
   * @static
   * @ignore
   */ remove: function remove(queueId) /*: Promise<void>*/ {
        var _this3 = this;
        return (0, $260f2c952070dccb$var$_asyncToGenerator2.default)(/*#__PURE__*/ $260f2c952070dccb$var$_regeneratorRuntime().mark(function _callee3() {
            var queueData, index;
            return $260f2c952070dccb$var$_regeneratorRuntime().wrap(function _callee3$(_context3) {
                while(true)switch(_context3.prev = _context3.next){
                    case 0:
                        _context3.next = 2;
                        return _this3.getQueue();
                    case 2:
                        queueData = _context3.sent;
                        index = _this3.queueItemExists(queueData, queueId);
                        if (!(index > -1)) {
                            _context3.next = 8;
                            break;
                        }
                        (0, $260f2c952070dccb$var$_splice.default)(queueData).call(queueData, index, 1);
                        _context3.next = 8;
                        return _this3.setQueue(queueData);
                    case 8:
                    case "end":
                        return _context3.stop();
                }
            }, _callee3);
        }))();
    },
    /**
   * Removes all objects from queue.
   *
   * @function clear
   * @name Parse.EventuallyQueue.clear
   * @returns {Promise} A promise that is fulfilled when queue is cleared.
   * @static
   */ clear: function clear() /*: Promise*/ {
        $260f2c952070dccb$var$queueCache = [];
        return this.store([]);
    },
    /**
   * Return the index of a queueId in the queue. Returns -1 if not found.
   *
   * @param {Queue} queue Queue containing Parse.Object data.
   * @param {string} queueId Unique identifier for Parse.Object data.
   * @returns {number}
   * @static
   * @ignore
   */ queueItemExists: function queueItemExists(queue, queueId) /*: number*/ {
        return (0, $260f2c952070dccb$var$_findIndex.default)(queue).call(queue, function(data) {
            return data.queueId === queueId;
        });
    },
    /**
   * Return the number of objects in the queue.
   *
   * @function length
   * @name Parse.EventuallyQueue.length
   * @returns {number}
   * @static
   */ length: function length() /*: number*/ {
        var _this4 = this;
        return (0, $260f2c952070dccb$var$_asyncToGenerator2.default)(/*#__PURE__*/ $260f2c952070dccb$var$_regeneratorRuntime().mark(function _callee4() {
            var queueData;
            return $260f2c952070dccb$var$_regeneratorRuntime().wrap(function _callee4$(_context4) {
                while(true)switch(_context4.prev = _context4.next){
                    case 0:
                        _context4.next = 2;
                        return _this4.getQueue();
                    case 2:
                        queueData = _context4.sent;
                        return _context4.abrupt("return", queueData.length);
                    case 4:
                    case "end":
                        return _context4.stop();
                }
            }, _callee4);
        }))();
    },
    /**
   * Sends the queue to the server.
   *
   * @function sendQueue
   * @name Parse.EventuallyQueue.sendQueue
   * @returns {Promise<boolean>} Returns true if queue was sent successfully.
   * @static
   */ sendQueue: function sendQueue() /*: Promise<boolean>*/ {
        var _this5 = this;
        return (0, $260f2c952070dccb$var$_asyncToGenerator2.default)(/*#__PURE__*/ $260f2c952070dccb$var$_regeneratorRuntime().mark(function _callee5() {
            var queue, queueData, i, queueObject, id, hash, className, ObjectType;
            return $260f2c952070dccb$var$_regeneratorRuntime().wrap(function _callee5$(_context5) {
                while(true)switch(_context5.prev = _context5.next){
                    case 0:
                        _context5.next = 2;
                        return _this5.getQueue();
                    case 2:
                        queue = _context5.sent;
                        queueData = (0, $260f2c952070dccb$var$_toConsumableArray2.default)(queue);
                        if (!(queueData.length === 0)) {
                            _context5.next = 6;
                            break;
                        }
                        return _context5.abrupt("return", false);
                    case 6:
                        i = 0;
                    case 7:
                        if (!(i < queueData.length)) {
                            _context5.next = 26;
                            break;
                        }
                        queueObject = queueData[i];
                        id = queueObject.id, hash = queueObject.hash, className = queueObject.className;
                        ObjectType = $260f2c952070dccb$var$_ParseObject.default.extend(className);
                        if (!id) {
                            _context5.next = 16;
                            break;
                        }
                        _context5.next = 14;
                        return _this5.process.byId(ObjectType, queueObject);
                    case 14:
                        _context5.next = 23;
                        break;
                    case 16:
                        if (!hash) {
                            _context5.next = 21;
                            break;
                        }
                        _context5.next = 19;
                        return _this5.process.byHash(ObjectType, queueObject);
                    case 19:
                        _context5.next = 23;
                        break;
                    case 21:
                        _context5.next = 23;
                        return _this5.process.create(ObjectType, queueObject);
                    case 23:
                        i += 1;
                        _context5.next = 7;
                        break;
                    case 26:
                        return _context5.abrupt("return", true);
                    case 27:
                    case "end":
                        return _context5.stop();
                }
            }, _callee5);
        }))();
    },
    /**
   * Build queue object and add to queue.
   *
   * @param {ParseObject} object Parse.Object to be processed
   * @param {QueueObject} queueObject Parse.Object data from the queue
   * @returns {Promise} A promise that is fulfilled when operation is performed.
   * @static
   * @ignore
   */ sendQueueCallback: function sendQueueCallback(object, queueObject) /*: Promise<void>*/ {
        var _this6 = this;
        return (0, $260f2c952070dccb$var$_asyncToGenerator2.default)(/*#__PURE__*/ $260f2c952070dccb$var$_regeneratorRuntime().mark(function _callee6() {
            return $260f2c952070dccb$var$_regeneratorRuntime().wrap(function _callee6$(_context6) {
                while(true)switch(_context6.prev = _context6.next){
                    case 0:
                        if (object) {
                            _context6.next = 2;
                            break;
                        }
                        return _context6.abrupt("return", _this6.remove(queueObject.queueId));
                    case 2:
                        _context6.t0 = queueObject.action;
                        _context6.next = _context6.t0 === "save" ? 5 : _context6.t0 === "destroy" ? 20 : 33;
                        break;
                    case 5:
                        if (!(typeof object.updatedAt !== "undefined" && object.updatedAt > new Date(queueObject.object.createdAt))) {
                            _context6.next = 7;
                            break;
                        }
                        return _context6.abrupt("return", _this6.remove(queueObject.queueId));
                    case 7:
                        _context6.prev = 7;
                        _context6.next = 10;
                        return object.save(queueObject.object, queueObject.serverOptions);
                    case 10:
                        _context6.next = 12;
                        return _this6.remove(queueObject.queueId);
                    case 12:
                        _context6.next = 19;
                        break;
                    case 14:
                        _context6.prev = 14;
                        _context6.t1 = _context6["catch"](7);
                        if (!(_context6.t1.message !== 'XMLHttpRequest failed: "Unable to connect to the Parse API"')) {
                            _context6.next = 19;
                            break;
                        }
                        _context6.next = 19;
                        return _this6.remove(queueObject.queueId);
                    case 19:
                        return _context6.abrupt("break", 33);
                    case 20:
                        _context6.prev = 20;
                        _context6.next = 23;
                        return object.destroy(queueObject.serverOptions);
                    case 23:
                        _context6.next = 25;
                        return _this6.remove(queueObject.queueId);
                    case 25:
                        _context6.next = 32;
                        break;
                    case 27:
                        _context6.prev = 27;
                        _context6.t2 = _context6["catch"](20);
                        if (!(_context6.t2.message !== 'XMLHttpRequest failed: "Unable to connect to the Parse API"')) {
                            _context6.next = 32;
                            break;
                        }
                        _context6.next = 32;
                        return _this6.remove(queueObject.queueId);
                    case 32:
                        return _context6.abrupt("break", 33);
                    case 33:
                    case "end":
                        return _context6.stop();
                }
            }, _callee6, null, [
                [
                    7,
                    14
                ],
                [
                    20,
                    27
                ]
            ]);
        }))();
    },
    /**
   * Start polling server for network connection.
   * Will send queue if connection is established.
   *
   * @function poll
   * @name Parse.EventuallyQueue.poll
   * @param [ms] Milliseconds to ping the server. Default 2000ms
   * @static
   */ poll: function poll() {
        var _this7 = this;
        var ms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2000;
        if ($260f2c952070dccb$var$polling) return;
        $260f2c952070dccb$var$polling = (0, $260f2c952070dccb$var$_setInterval2.default)(function() {
            var RESTController = $260f2c952070dccb$var$_CoreManager.default.getRESTController();
            RESTController.request("GET", "health").then(function(_ref) {
                var status = _ref.status;
                if (status === "ok") {
                    _this7.stopPoll();
                    return _this7.sendQueue();
                }
            }).catch(function(e) {
                return e;
            });
        }, ms);
    },
    /**
   * Turns off polling.
   *
   * @function stopPoll
   * @name Parse.EventuallyQueue.stopPoll
   * @static
   */ stopPoll: function stopPoll() {
        clearInterval($260f2c952070dccb$var$polling);
        $260f2c952070dccb$var$polling = undefined;
    },
    /**
   * Return true if pinging the server.
   *
   * @function isPolling
   * @name Parse.EventuallyQueue.isPolling
   * @returns {boolean}
   * @static
   */ isPolling: function isPolling() /*: boolean*/ {
        return !!$260f2c952070dccb$var$polling;
    },
    _setPolling: function _setPolling(flag) {
        $260f2c952070dccb$var$polling = flag;
    },
    process: {
        create: function create(ObjectType, queueObject) {
            var object = new ObjectType();
            return $260f2c952070dccb$var$EventuallyQueue.sendQueueCallback(object, queueObject);
        },
        byId: function byId(ObjectType, queueObject) {
            return (0, $260f2c952070dccb$var$_asyncToGenerator2.default)(/*#__PURE__*/ $260f2c952070dccb$var$_regeneratorRuntime().mark(function _callee7() {
                var sessionToken, query, results;
                return $260f2c952070dccb$var$_regeneratorRuntime().wrap(function _callee7$(_context7) {
                    while(true)switch(_context7.prev = _context7.next){
                        case 0:
                            sessionToken = queueObject.serverOptions.sessionToken;
                            query = new $260f2c952070dccb$var$_ParseQuery.default(ObjectType);
                            query.equalTo("objectId", queueObject.id);
                            _context7.next = 5;
                            return (0, $260f2c952070dccb$var$_find.default)(query).call(query, {
                                sessionToken: sessionToken
                            });
                        case 5:
                            results = _context7.sent;
                            return _context7.abrupt("return", $260f2c952070dccb$var$EventuallyQueue.sendQueueCallback(results[0], queueObject));
                        case 7:
                        case "end":
                            return _context7.stop();
                    }
                }, _callee7);
            }))();
        },
        byHash: function byHash(ObjectType, queueObject) {
            return (0, $260f2c952070dccb$var$_asyncToGenerator2.default)(/*#__PURE__*/ $260f2c952070dccb$var$_regeneratorRuntime().mark(function _callee8() {
                var sessionToken, query, results;
                return $260f2c952070dccb$var$_regeneratorRuntime().wrap(function _callee8$(_context8) {
                    while(true)switch(_context8.prev = _context8.next){
                        case 0:
                            sessionToken = queueObject.serverOptions.sessionToken;
                            query = new $260f2c952070dccb$var$_ParseQuery.default(ObjectType);
                            query.equalTo("hash", queueObject.hash);
                            _context8.next = 5;
                            return (0, $260f2c952070dccb$var$_find.default)(query).call(query, {
                                sessionToken: sessionToken
                            });
                        case 5:
                            results = _context8.sent;
                            if (!(results.length > 0)) {
                                _context8.next = 8;
                                break;
                            }
                            return _context8.abrupt("return", $260f2c952070dccb$var$EventuallyQueue.sendQueueCallback(results[0], queueObject));
                        case 8:
                            return _context8.abrupt("return", $260f2c952070dccb$var$EventuallyQueue.process.create(ObjectType, queueObject));
                        case 9:
                        case "end":
                            return _context8.stop();
                    }
                }, _callee8);
            }))();
        }
    }
};
module.exports = $260f2c952070dccb$var$EventuallyQueue;

});
parcelRequire.register("5wnDQ", function(module, exports) {

module.exports = (parcelRequire("aRA01"));

});
parcelRequire.register("aRA01", function(module, exports) {
parcelRequire("2IATd");

var $envPC = parcelRequire("envPC");
module.exports = $envPC.setInterval;

});
parcelRequire.register("2IATd", function(module, exports) {
// TODO: Remove this module from `core-js@4` since it's split to modules listed below
parcelRequire("dWp7C");
parcelRequire("26sJo");

});
parcelRequire.register("dWp7C", function(module, exports) {

var $g2B3u = parcelRequire("g2B3u");

var $6gFRb = parcelRequire("6gFRb");

var $Krrgz = parcelRequire("Krrgz");
var $a2642dd90b353822$var$setInterval = $Krrgz($6gFRb.setInterval, true);
// Bun / IE9- setInterval additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
$g2B3u({
    global: true,
    bind: true,
    forced: $6gFRb.setInterval !== $a2642dd90b353822$var$setInterval
}, {
    setInterval: $a2642dd90b353822$var$setInterval
});

});
parcelRequire.register("Krrgz", function(module, exports) {
"use strict";

var $6gFRb = parcelRequire("6gFRb");

var $9YGjW = parcelRequire("9YGjW");

var $6kYHq = parcelRequire("6kYHq");

var $8IiKk = parcelRequire("8IiKk");

var $jGeXI = parcelRequire("jGeXI");

var $74qJH = parcelRequire("74qJH");

var $acL92 = parcelRequire("acL92");
var $08b994c340de0fd9$var$Function = $6gFRb.Function;
// dirty IE9- and Bun 0.3.0- checks
var $08b994c340de0fd9$var$WRAP = /MSIE .\./.test($jGeXI) || $8IiKk && function() {
    var version = $6gFRb.Bun.version.split(".");
    return version.length < 3 || version[0] == 0 && (version[1] < 3 || version[1] == 3 && version[2] == 0);
}();
// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
module.exports = function(scheduler, hasTimeArg) {
    var firstParamIndex = hasTimeArg ? 2 : 1;
    return $08b994c340de0fd9$var$WRAP ? function(handler, timeout /* , ...arguments */ ) {
        var boundArgs = $acL92(arguments.length, 1) > firstParamIndex;
        var fn = $6kYHq(handler) ? handler : $08b994c340de0fd9$var$Function(handler);
        var params = boundArgs ? $74qJH(arguments, firstParamIndex) : [];
        var callback = boundArgs ? function() {
            $9YGjW(fn, this, params);
        } : fn;
        return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
    } : scheduler;
};

});
parcelRequire.register("8IiKk", function(module, exports) {
/* global Bun -- Deno case */ module.exports = typeof Bun == "function" && Bun && typeof Bun.version == "string";

});



parcelRequire.register("26sJo", function(module, exports) {

var $g2B3u = parcelRequire("g2B3u");

var $6gFRb = parcelRequire("6gFRb");

var $Krrgz = parcelRequire("Krrgz");
var $18826db6b1cfe65c$var$setTimeout = $Krrgz($6gFRb.setTimeout, true);
// Bun / IE9- setTimeout additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout
$g2B3u({
    global: true,
    bind: true,
    forced: $6gFRb.setTimeout !== $18826db6b1cfe65c$var$setTimeout
}, {
    setTimeout: $18826db6b1cfe65c$var$setTimeout
});

});




parcelRequire.register("f2quz", function(module, exports) {

module.exports = (parcelRequire("3Uuab"));

});
parcelRequire.register("3Uuab", function(module, exports) {

var $2Y50u = parcelRequire("2Y50u");
module.exports = $2Y50u;

});
parcelRequire.register("2Y50u", function(module, exports) {

var $5L8hR = parcelRequire("5L8hR");

var $dh6HF = parcelRequire("dh6HF");
var $229511a0fea95ad7$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.findIndex;
    return it === $229511a0fea95ad7$var$ArrayPrototype || $5L8hR($229511a0fea95ad7$var$ArrayPrototype, it) && own === $229511a0fea95ad7$var$ArrayPrototype.findIndex ? $dh6HF : own;
};

});
parcelRequire.register("dh6HF", function(module, exports) {
parcelRequire("8c5i5");

var $hESIr = parcelRequire("hESIr");
module.exports = $hESIr("Array").findIndex;

});
parcelRequire.register("8c5i5", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $lB6H8 = parcelRequire("lB6H8");
var $5f738c5818293706$require$$findIndex = $lB6H8.findIndex;

var $7lCJ1 = parcelRequire("7lCJ1");
var $5f738c5818293706$var$FIND_INDEX = "findIndex";
var $5f738c5818293706$var$SKIPS_HOLES = true;
// Shouldn't skip holes
// eslint-disable-next-line es/no-array-prototype-findindex -- testing
if ($5f738c5818293706$var$FIND_INDEX in []) Array(1)[$5f738c5818293706$var$FIND_INDEX](function() {
    $5f738c5818293706$var$SKIPS_HOLES = false;
});
// `Array.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-array.prototype.findindex
$g2B3u({
    target: "Array",
    proto: true,
    forced: $5f738c5818293706$var$SKIPS_HOLES
}, {
    findIndex: function findIndex(callbackfn /* , that = undefined */ ) {
        return $5f738c5818293706$require$$findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$7lCJ1($5f738c5818293706$var$FIND_INDEX);

});





parcelRequire.register("7Zbj0", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $5d06fff9f5c66348$var$_promise = $3Npdz((parcelRequire("bCWDe")));

var $5d06fff9f5c66348$var$_CoreManager = $3Npdz((parcelRequire("465CW")));
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ var $5d06fff9f5c66348$var$Storage = {
    async: function() /*: boolean*/ {
        var controller = $5d06fff9f5c66348$var$_CoreManager.default.getStorageController();
        return !!controller.async;
    },
    getItem: function(path) /*: ?string*/ {
        var controller = $5d06fff9f5c66348$var$_CoreManager.default.getStorageController();
        if (controller.async === 1) throw new Error("Synchronous storage is not supported by the current storage controller");
        return controller.getItem(path);
    },
    getItemAsync: function(path) /*: Promise<string>*/ {
        var controller = $5d06fff9f5c66348$var$_CoreManager.default.getStorageController();
        if (controller.async === 1) return controller.getItemAsync(path);
        return $5d06fff9f5c66348$var$_promise.default.resolve(controller.getItem(path));
    },
    setItem: function(path, value) /*: void*/ {
        var controller = $5d06fff9f5c66348$var$_CoreManager.default.getStorageController();
        if (controller.async === 1) throw new Error("Synchronous storage is not supported by the current storage controller");
        return controller.setItem(path, value);
    },
    setItemAsync: function(path, value) /*: Promise<void>*/ {
        var controller = $5d06fff9f5c66348$var$_CoreManager.default.getStorageController();
        if (controller.async === 1) return controller.setItemAsync(path, value);
        return $5d06fff9f5c66348$var$_promise.default.resolve(controller.setItem(path, value));
    },
    removeItem: function(path) /*: void*/ {
        var controller = $5d06fff9f5c66348$var$_CoreManager.default.getStorageController();
        if (controller.async === 1) throw new Error("Synchronous storage is not supported by the current storage controller");
        return controller.removeItem(path);
    },
    removeItemAsync: function(path) /*: Promise<void>*/ {
        var controller = $5d06fff9f5c66348$var$_CoreManager.default.getStorageController();
        if (controller.async === 1) return controller.removeItemAsync(path);
        return $5d06fff9f5c66348$var$_promise.default.resolve(controller.removeItem(path));
    },
    getAllKeys: function() /*: Array<string>*/ {
        var controller = $5d06fff9f5c66348$var$_CoreManager.default.getStorageController();
        if (controller.async === 1) throw new Error("Synchronous storage is not supported by the current storage controller");
        return controller.getAllKeys();
    },
    getAllKeysAsync: function() /*: Promise<Array<string>>*/ {
        var controller = $5d06fff9f5c66348$var$_CoreManager.default.getStorageController();
        if (controller.async === 1) return controller.getAllKeysAsync();
        return $5d06fff9f5c66348$var$_promise.default.resolve(controller.getAllKeys());
    },
    generatePath: function(path) /*: string*/ {
        if (!$5d06fff9f5c66348$var$_CoreManager.default.get("APPLICATION_ID")) throw new Error("You need to call Parse.initialize before using Parse.");
        if (typeof path !== "string") throw new Error("Tried to get a Storage path that was not a String.");
        if (path[0] === "/") path = path.substr(1);
        return "Parse/" + $5d06fff9f5c66348$var$_CoreManager.default.get("APPLICATION_ID") + "/" + path;
    },
    _clear: function() {
        var controller = $5d06fff9f5c66348$var$_CoreManager.default.getStorageController();
        if (controller.hasOwnProperty("clear")) controller.clear();
    }
};
module.exports = $5d06fff9f5c66348$var$Storage;

$5d06fff9f5c66348$var$_CoreManager.default.setStorageController((parcelRequire("jPIbD")));

});
parcelRequire.register("jPIbD", function(module, exports) {
"use strict";
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 * @private
 */ /* global localStorage */ var $e7050e4da466a441$var$StorageController = {
    async: 0,
    getItem: function(path) /*: ?string*/ {
        return localStorage.getItem(path);
    },
    setItem: function(path, value) {
        try {
            localStorage.setItem(path, value);
        } catch (e) {
            // Quota exceeded, possibly due to Safari Private Browsing mode
            console.log(e.message);
        }
    },
    removeItem: function(path) {
        localStorage.removeItem(path);
    },
    getAllKeys: function() {
        var keys = [];
        for(var i = 0; i < localStorage.length; i += 1)keys.push(localStorage.key(i));
        return keys;
    },
    clear: function() {
        localStorage.clear();
    }
};
module.exports = $e7050e4da466a441$var$StorageController;

});



parcelRequire.register("fimv0", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $evY07 = parcelRequire("evY07");
$evY07(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b229fd51babb1cdd$var$parseDate;

var $b229fd51babb1cdd$var$_parseInt2 = $3Npdz((parcelRequire("jpsdA")));
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ function $b229fd51babb1cdd$var$parseDate(iso8601) /*: ?Date*/ {
    var regexp = new RegExp("^([0-9]{1,4})-([0-9]{1,2})-([0-9]{1,2})T([0-9]{1,2}):([0-9]{1,2}):([0-9]{1,2})(.([0-9]+))?Z$");
    var match = regexp.exec(iso8601);
    if (!match) return null;
    var year = (0, $b229fd51babb1cdd$var$_parseInt2.default)(match[1]) || 0;
    var month = ((0, $b229fd51babb1cdd$var$_parseInt2.default)(match[2]) || 1) - 1;
    var day = (0, $b229fd51babb1cdd$var$_parseInt2.default)(match[3]) || 0;
    var hour = (0, $b229fd51babb1cdd$var$_parseInt2.default)(match[4]) || 0;
    var minute = (0, $b229fd51babb1cdd$var$_parseInt2.default)(match[5]) || 0;
    var second = (0, $b229fd51babb1cdd$var$_parseInt2.default)(match[6]) || 0;
    var milli = (0, $b229fd51babb1cdd$var$_parseInt2.default)(match[8]) || 0;
    return new Date(Date.UTC(year, month, day, hour, minute, second, milli));
}

});
parcelRequire.register("jpsdA", function(module, exports) {

module.exports = (parcelRequire("dnZ5v"));

});
parcelRequire.register("dnZ5v", function(module, exports) {

var $5k82C = parcelRequire("5k82C");
module.exports = $5k82C;

});
parcelRequire.register("5k82C", function(module, exports) {
parcelRequire("8MNvi");

var $envPC = parcelRequire("envPC");
module.exports = $envPC.parseInt;

});
parcelRequire.register("8MNvi", function(module, exports) {

var $g2B3u = parcelRequire("g2B3u");

var $7bmbV = parcelRequire("7bmbV");
// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$g2B3u({
    global: true,
    forced: parseInt != $7bmbV
}, {
    parseInt: $7bmbV
});

});
parcelRequire.register("7bmbV", function(module, exports) {

var $6gFRb = parcelRequire("6gFRb");

var $avKuJ = parcelRequire("avKuJ");

var $7tcts = parcelRequire("7tcts");

var $eG0jW = parcelRequire("eG0jW");

var $apsqH = parcelRequire("apsqH");
var $53aac6330b3b2ca4$require$trim = $apsqH.trim;

var $jjXzY = parcelRequire("jjXzY");
var $53aac6330b3b2ca4$var$$parseInt = $6gFRb.parseInt;
var $53aac6330b3b2ca4$var$Symbol = $6gFRb.Symbol;
var $53aac6330b3b2ca4$var$ITERATOR = $53aac6330b3b2ca4$var$Symbol && $53aac6330b3b2ca4$var$Symbol.iterator;
var $53aac6330b3b2ca4$var$hex = /^[+-]?0x/i;
var $53aac6330b3b2ca4$var$exec = $7tcts($53aac6330b3b2ca4$var$hex.exec);
var $53aac6330b3b2ca4$var$FORCED = $53aac6330b3b2ca4$var$$parseInt($jjXzY + "08") !== 8 || $53aac6330b3b2ca4$var$$parseInt($jjXzY + "0x16") !== 22 || $53aac6330b3b2ca4$var$ITERATOR && !$avKuJ(function() {
    $53aac6330b3b2ca4$var$$parseInt(Object($53aac6330b3b2ca4$var$ITERATOR));
});
// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
module.exports = $53aac6330b3b2ca4$var$FORCED ? function parseInt(string, radix) {
    var S = $53aac6330b3b2ca4$require$trim($eG0jW(string));
    return $53aac6330b3b2ca4$var$$parseInt(S, radix >>> 0 || ($53aac6330b3b2ca4$var$exec($53aac6330b3b2ca4$var$hex, S) ? 16 : 10));
} : $53aac6330b3b2ca4$var$$parseInt;

});
parcelRequire.register("apsqH", function(module, exports) {

var $7tcts = parcelRequire("7tcts");

var $dfvEY = parcelRequire("dfvEY");

var $eG0jW = parcelRequire("eG0jW");

var $jjXzY = parcelRequire("jjXzY");
var $79424ab6f57428dd$var$replace = $7tcts("".replace);
var $79424ab6f57428dd$var$ltrim = RegExp("^[" + $jjXzY + "]+");
var $79424ab6f57428dd$var$rtrim = RegExp("(^|[^" + $jjXzY + "])[" + $jjXzY + "]+$");
// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var $79424ab6f57428dd$var$createMethod = function(TYPE) {
    return function($this) {
        var string = $eG0jW($dfvEY($this));
        if (TYPE & 1) string = $79424ab6f57428dd$var$replace(string, $79424ab6f57428dd$var$ltrim, "");
        if (TYPE & 2) string = $79424ab6f57428dd$var$replace(string, $79424ab6f57428dd$var$rtrim, "$1");
        return string;
    };
};
module.exports = {
    // `String.prototype.{ trimLeft, trimStart }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimstart
    start: $79424ab6f57428dd$var$createMethod(1),
    // `String.prototype.{ trimRight, trimEnd }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimend
    end: $79424ab6f57428dd$var$createMethod(2),
    // `String.prototype.trim` method
    // https://tc39.es/ecma262/#sec-string.prototype.trim
    trim: $79424ab6f57428dd$var$createMethod(3)
};

});
parcelRequire.register("jjXzY", function(module, exports) {
// a string of all valid unicode whitespaces
module.exports = "	\n\v\f\r \xa0              　\u2028\u2029\uFEFF";

});








parcelRequire.register("YKYfs", function(module, exports) {
"use strict";

var $1o4IC = parcelRequire("1o4IC");

var $evY07 = parcelRequire("evY07");

var $akViX = parcelRequire("akViX");

var $25qme = parcelRequire("25qme");
$evY07(module.exports, "__esModule", {
    value: true
});
module.exports.clearAllState = $0b6a0a1f9f9f48cb$var$clearAllState;
module.exports.commitServerChanges = $0b6a0a1f9f9f48cb$var$commitServerChanges;
module.exports.duplicateState = $0b6a0a1f9f9f48cb$var$duplicateState;
module.exports.enqueueTask = $0b6a0a1f9f9f48cb$var$enqueueTask;
module.exports.estimateAttribute = $0b6a0a1f9f9f48cb$var$estimateAttribute;
module.exports.estimateAttributes = $0b6a0a1f9f9f48cb$var$estimateAttributes;
module.exports.getObjectCache = $0b6a0a1f9f9f48cb$var$getObjectCache;
module.exports.getPendingOps = $0b6a0a1f9f9f48cb$var$getPendingOps;
module.exports.getServerData = $0b6a0a1f9f9f48cb$var$getServerData;
module.exports.getState = $0b6a0a1f9f9f48cb$var$getState;
module.exports.initializeState = $0b6a0a1f9f9f48cb$var$initializeState;
module.exports.mergeFirstPendingState = $0b6a0a1f9f9f48cb$var$mergeFirstPendingState;
module.exports.popPendingState = $0b6a0a1f9f9f48cb$var$popPendingState;
module.exports.pushPendingState = $0b6a0a1f9f9f48cb$var$pushPendingState;
module.exports.removeState = $0b6a0a1f9f9f48cb$var$removeState;
module.exports.setPendingOp = $0b6a0a1f9f9f48cb$var$setPendingOp;
module.exports.setServerData = $0b6a0a1f9f9f48cb$var$setServerData;

var $0b6a0a1f9f9f48cb$var$ObjectStateMutations = $0b6a0a1f9f9f48cb$var$_interopRequireWildcard((parcelRequire("5Tj02")));
function $0b6a0a1f9f9f48cb$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof $25qme !== "function") return null;
    var cacheBabelInterop = new $25qme();
    var cacheNodeInterop = new $25qme();
    return ($0b6a0a1f9f9f48cb$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $0b6a0a1f9f9f48cb$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $akViX(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $0b6a0a1f9f9f48cb$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = $evY07 && $1o4IC ? $1o4IC(obj, key) : null;
        if (desc && (desc.get || desc.set)) $evY07(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ var $0b6a0a1f9f9f48cb$var$objectState = {};
function $0b6a0a1f9f9f48cb$var$getState(obj) /*: ?State*/ {
    var classData = $0b6a0a1f9f9f48cb$var$objectState[obj.className];
    if (classData) return classData[obj.id] || null;
    return null;
}
function $0b6a0a1f9f9f48cb$var$initializeState(obj, initial) /*: State*/ {
    var state = $0b6a0a1f9f9f48cb$var$getState(obj);
    if (state) return state;
    if (!$0b6a0a1f9f9f48cb$var$objectState[obj.className]) $0b6a0a1f9f9f48cb$var$objectState[obj.className] = {};
    if (!initial) initial = $0b6a0a1f9f9f48cb$var$ObjectStateMutations.defaultState();
    state = $0b6a0a1f9f9f48cb$var$objectState[obj.className][obj.id] = initial;
    return state;
}
function $0b6a0a1f9f9f48cb$var$removeState(obj) /*: ?State*/ {
    var state = $0b6a0a1f9f9f48cb$var$getState(obj);
    if (state === null) return null;
    delete $0b6a0a1f9f9f48cb$var$objectState[obj.className][obj.id];
    return state;
}
function $0b6a0a1f9f9f48cb$var$getServerData(obj) /*: AttributeMap*/ {
    var state = $0b6a0a1f9f9f48cb$var$getState(obj);
    if (state) return state.serverData;
    return {};
}
function $0b6a0a1f9f9f48cb$var$setServerData(obj, attributes) {
    var serverData = $0b6a0a1f9f9f48cb$var$initializeState(obj).serverData;
    $0b6a0a1f9f9f48cb$var$ObjectStateMutations.setServerData(serverData, attributes);
}
function $0b6a0a1f9f9f48cb$var$getPendingOps(obj) /*: Array<OpsMap>*/ {
    var state = $0b6a0a1f9f9f48cb$var$getState(obj);
    if (state) return state.pendingOps;
    return [
        {}
    ];
}
function $0b6a0a1f9f9f48cb$var$setPendingOp(obj, attr, op) {
    var pendingOps = $0b6a0a1f9f9f48cb$var$initializeState(obj).pendingOps;
    $0b6a0a1f9f9f48cb$var$ObjectStateMutations.setPendingOp(pendingOps, attr, op);
}
function $0b6a0a1f9f9f48cb$var$pushPendingState(obj) {
    var pendingOps = $0b6a0a1f9f9f48cb$var$initializeState(obj).pendingOps;
    $0b6a0a1f9f9f48cb$var$ObjectStateMutations.pushPendingState(pendingOps);
}
function $0b6a0a1f9f9f48cb$var$popPendingState(obj) /*: OpsMap*/ {
    var pendingOps = $0b6a0a1f9f9f48cb$var$initializeState(obj).pendingOps;
    return $0b6a0a1f9f9f48cb$var$ObjectStateMutations.popPendingState(pendingOps);
}
function $0b6a0a1f9f9f48cb$var$mergeFirstPendingState(obj) {
    var pendingOps = $0b6a0a1f9f9f48cb$var$getPendingOps(obj);
    $0b6a0a1f9f9f48cb$var$ObjectStateMutations.mergeFirstPendingState(pendingOps);
}
function $0b6a0a1f9f9f48cb$var$getObjectCache(obj) /*: ObjectCache*/ {
    var state = $0b6a0a1f9f9f48cb$var$getState(obj);
    if (state) return state.objectCache;
    return {};
}
function $0b6a0a1f9f9f48cb$var$estimateAttribute(obj, attr) /*: mixed*/ {
    var serverData = $0b6a0a1f9f9f48cb$var$getServerData(obj);
    var pendingOps = $0b6a0a1f9f9f48cb$var$getPendingOps(obj);
    return $0b6a0a1f9f9f48cb$var$ObjectStateMutations.estimateAttribute(serverData, pendingOps, obj.className, obj.id, attr);
}
function $0b6a0a1f9f9f48cb$var$estimateAttributes(obj) /*: AttributeMap*/ {
    var serverData = $0b6a0a1f9f9f48cb$var$getServerData(obj);
    var pendingOps = $0b6a0a1f9f9f48cb$var$getPendingOps(obj);
    return $0b6a0a1f9f9f48cb$var$ObjectStateMutations.estimateAttributes(serverData, pendingOps, obj.className, obj.id);
}
function $0b6a0a1f9f9f48cb$var$commitServerChanges(obj, changes) {
    var state = $0b6a0a1f9f9f48cb$var$initializeState(obj);
    $0b6a0a1f9f9f48cb$var$ObjectStateMutations.commitServerChanges(state.serverData, state.objectCache, changes);
}
function $0b6a0a1f9f9f48cb$var$enqueueTask(obj, task) /*: Promise*/ {
    var state = $0b6a0a1f9f9f48cb$var$initializeState(obj);
    return state.tasks.enqueue(task);
}
function $0b6a0a1f9f9f48cb$var$clearAllState() {
    $0b6a0a1f9f9f48cb$var$objectState = {};
}
function $0b6a0a1f9f9f48cb$var$duplicateState(source, dest) {
    dest.id = source.id;
}

});
parcelRequire.register("5Tj02", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $evY07 = parcelRequire("evY07");

var $8jMtB = parcelRequire("8jMtB");

var $1nHJN = parcelRequire("1nHJN");

var $jZGC2 = parcelRequire("jZGC2");

var $1o4IC = parcelRequire("1o4IC");

var $kYm0J = parcelRequire("kYm0J");

var $d3A5d = parcelRequire("d3A5d");

var $r9mpE = parcelRequire("r9mpE");
$evY07(module.exports, "__esModule", {
    value: true
});
module.exports.commitServerChanges = $44a0d3b894674576$var$commitServerChanges;
module.exports.defaultState = $44a0d3b894674576$var$defaultState;
module.exports.estimateAttribute = $44a0d3b894674576$var$estimateAttribute;
module.exports.estimateAttributes = $44a0d3b894674576$var$estimateAttributes;
module.exports.mergeFirstPendingState = $44a0d3b894674576$var$mergeFirstPendingState;
module.exports.popPendingState = $44a0d3b894674576$var$popPendingState;
module.exports.pushPendingState = $44a0d3b894674576$var$pushPendingState;
module.exports.setPendingOp = $44a0d3b894674576$var$setPendingOp;
module.exports.setServerData = $44a0d3b894674576$var$setServerData;

var $44a0d3b894674576$var$_stringify = $3Npdz((parcelRequire("O2sNs")));

var $44a0d3b894674576$var$_typeof2 = $3Npdz((parcelRequire("akViX")));

var $44a0d3b894674576$var$_defineProperty2 = $3Npdz((parcelRequire("bci6G")));

var $44a0d3b894674576$var$_includes = $3Npdz((parcelRequire("aUw0k")));

var $44a0d3b894674576$var$_encode = $3Npdz((parcelRequire("gM4ym")));

var $44a0d3b894674576$var$_ParseFile = $3Npdz((parcelRequire("gf3Ge")));

var $44a0d3b894674576$var$_ParseObject = $3Npdz((parcelRequire("2HIpX")));

var $44a0d3b894674576$var$_ParseRelation = $3Npdz((parcelRequire("4Glkc")));

var $44a0d3b894674576$var$_TaskQueue = $3Npdz((parcelRequire("lLzga")));

var $1WcLm = parcelRequire("1WcLm");
function $44a0d3b894674576$var$ownKeys(object, enumerableOnly) {
    var keys = $r9mpE(object);
    if ($d3A5d) {
        var symbols = $d3A5d(object);
        enumerableOnly && (symbols = $kYm0J(symbols).call(symbols, function(sym) {
            return $1o4IC(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $44a0d3b894674576$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var _context, _context2;
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $jZGC2(_context = $44a0d3b894674576$var$ownKeys(Object(source), !0)).call(_context, function(key) {
            (0, $44a0d3b894674576$var$_defineProperty2.default)(target, key, source[key]);
        }) : $1nHJN ? $8jMtB(target, $1nHJN(source)) : $jZGC2(_context2 = $44a0d3b894674576$var$ownKeys(Object(source))).call(_context2, function(key) {
            $evY07(target, key, $1o4IC(source, key));
        });
    }
    return target;
}
function $44a0d3b894674576$var$defaultState() /*: State*/ {
    return {
        serverData: {},
        pendingOps: [
            {}
        ],
        objectCache: {},
        tasks: new $44a0d3b894674576$var$_TaskQueue.default(),
        existed: false
    };
}
function $44a0d3b894674576$var$setServerData(serverData, attributes) {
    for(var _attr in attributes)if (typeof attributes[_attr] !== "undefined") serverData[_attr] = attributes[_attr];
    else delete serverData[_attr];
}
function $44a0d3b894674576$var$setPendingOp(pendingOps, attr, op) {
    var last = pendingOps.length - 1;
    if (op) pendingOps[last][attr] = op;
    else delete pendingOps[last][attr];
}
function $44a0d3b894674576$var$pushPendingState(pendingOps) {
    pendingOps.push({});
}
function $44a0d3b894674576$var$popPendingState(pendingOps) /*: OpsMap*/ {
    var first = pendingOps.shift();
    if (!pendingOps.length) pendingOps[0] = {};
    return first;
}
function $44a0d3b894674576$var$mergeFirstPendingState(pendingOps) {
    var first = $44a0d3b894674576$var$popPendingState(pendingOps);
    var next = pendingOps[0];
    for(var _attr2 in first)if (next[_attr2] && first[_attr2]) {
        var merged = next[_attr2].mergeWith(first[_attr2]);
        if (merged) next[_attr2] = merged;
    } else next[_attr2] = first[_attr2];
}
function $44a0d3b894674576$var$estimateAttribute(serverData, pendingOps, className, id, attr) /*: mixed*/ {
    var value = serverData[attr];
    for(var i = 0; i < pendingOps.length; i++)if (pendingOps[i][attr]) {
        if (pendingOps[i][attr] instanceof $1WcLm.RelationOp) {
            if (id) value = pendingOps[i][attr].applyTo(value, {
                className: className,
                id: id
            }, attr);
        } else value = pendingOps[i][attr].applyTo(value);
    }
    return value;
}
function $44a0d3b894674576$var$estimateAttributes(serverData, pendingOps, className, id) /*: AttributeMap*/ {
    var data = {};
    for(var attr in serverData)data[attr] = serverData[attr];
    for(var i = 0; i < pendingOps.length; i++)for(attr in pendingOps[i]){
        if (pendingOps[i][attr] instanceof $1WcLm.RelationOp) {
            if (id) data[attr] = pendingOps[i][attr].applyTo(data[attr], {
                className: className,
                id: id
            }, attr);
        } else if ((0, $44a0d3b894674576$var$_includes.default)(attr).call(attr, ".")) {
            // convert a.b.c into { a: { b: { c: value } } }
            var fields = attr.split(".");
            var first = fields[0];
            var last = fields[fields.length - 1];
            data[first] = $44a0d3b894674576$var$_objectSpread({}, serverData[first]);
            var object = $44a0d3b894674576$var$_objectSpread({}, data);
            for(var _i = 0; _i < fields.length - 1; _i++){
                var key = fields[_i];
                if (!(key in object)) object[key] = {};
                object = object[key];
            }
            object[last] = pendingOps[i][attr].applyTo(object[last]);
        } else data[attr] = pendingOps[i][attr].applyTo(data[attr]);
    }
    return data;
}
function $44a0d3b894674576$var$nestedSet(obj, key, value) {
    var path = key.split(".");
    for(var i = 0; i < path.length - 1; i++){
        if (!(path[i] in obj)) obj[path[i]] = {};
        obj = obj[path[i]];
    }
    if (typeof value === "undefined") delete obj[path[path.length - 1]];
    else obj[path[path.length - 1]] = value;
}
function $44a0d3b894674576$var$commitServerChanges(serverData, objectCache, changes) {
    for(var _attr3 in changes){
        var val = changes[_attr3];
        $44a0d3b894674576$var$nestedSet(serverData, _attr3, val);
        if (val && (0, $44a0d3b894674576$var$_typeof2.default)(val) === "object" && !(val instanceof $44a0d3b894674576$var$_ParseObject.default) && !(val instanceof $44a0d3b894674576$var$_ParseFile.default) && !(val instanceof $44a0d3b894674576$var$_ParseRelation.default)) {
            var json = (0, $44a0d3b894674576$var$_encode.default)(val, false, true);
            objectCache[_attr3] = (0, $44a0d3b894674576$var$_stringify.default)(json);
        }
    }
}

});
parcelRequire.register("lLzga", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $fd89569c8bf70e8e$var$_classCallCheck2 = $3Npdz((parcelRequire("9pQKE")));

var $fd89569c8bf70e8e$var$_createClass2 = $3Npdz((parcelRequire("eZYdV")));

var $fd89569c8bf70e8e$var$_defineProperty2 = $3Npdz((parcelRequire("bci6G")));

var $j0i6P = parcelRequire("j0i6P");
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ var $fd89569c8bf70e8e$var$TaskQueue = /*#__PURE__*/ function() {
    function TaskQueue() {
        (0, $fd89569c8bf70e8e$var$_classCallCheck2.default)(this, TaskQueue);
        (0, $fd89569c8bf70e8e$var$_defineProperty2.default)(this, "queue", void 0);
        this.queue = [];
    }
    (0, $fd89569c8bf70e8e$var$_createClass2.default)(TaskQueue, [
        {
            key: "enqueue",
            value: function(task) /*: Promise*/ {
                var _this = this;
                var taskComplete = new $j0i6P.resolvingPromise();
                this.queue.push({
                    task: task,
                    _completion: taskComplete
                });
                if (this.queue.length === 1) task().then(function() {
                    _this._dequeue();
                    taskComplete.resolve();
                }, function(error) {
                    _this._dequeue();
                    taskComplete.reject(error);
                });
                return taskComplete;
            }
        },
        {
            key: "_dequeue",
            value: function() {
                var _this2 = this;
                this.queue.shift();
                if (this.queue.length) {
                    var next = this.queue[0];
                    next.task().then(function() {
                        _this2._dequeue();
                        next._completion.resolve();
                    }, function(error) {
                        _this2._dequeue();
                        next._completion.reject(error);
                    });
                }
            }
        }
    ]);
    return TaskQueue;
}();
module.exports = $fd89569c8bf70e8e$var$TaskQueue;

});



parcelRequire.register("4o7l6", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $1o4IC = parcelRequire("1o4IC");

var $evY07 = parcelRequire("evY07");

var $akViX = parcelRequire("akViX");

$evY07(module.exports, "__esModule", {
    value: true
});
module.exports.clearAllState = $331f18c65dee33f6$var$clearAllState;
module.exports.commitServerChanges = $331f18c65dee33f6$var$commitServerChanges;
module.exports.duplicateState = $331f18c65dee33f6$var$duplicateState;
module.exports.enqueueTask = $331f18c65dee33f6$var$enqueueTask;
module.exports.estimateAttribute = $331f18c65dee33f6$var$estimateAttribute;
module.exports.estimateAttributes = $331f18c65dee33f6$var$estimateAttributes;
module.exports.getObjectCache = $331f18c65dee33f6$var$getObjectCache;
module.exports.getPendingOps = $331f18c65dee33f6$var$getPendingOps;
module.exports.getServerData = $331f18c65dee33f6$var$getServerData;
module.exports.getState = $331f18c65dee33f6$var$getState;
module.exports.initializeState = $331f18c65dee33f6$var$initializeState;
module.exports.mergeFirstPendingState = $331f18c65dee33f6$var$mergeFirstPendingState;
module.exports.popPendingState = $331f18c65dee33f6$var$popPendingState;
module.exports.pushPendingState = $331f18c65dee33f6$var$pushPendingState;
module.exports.removeState = $331f18c65dee33f6$var$removeState;
module.exports.setPendingOp = $331f18c65dee33f6$var$setPendingOp;
module.exports.setServerData = $331f18c65dee33f6$var$setServerData;

var $331f18c65dee33f6$var$_weakMap = $3Npdz((parcelRequire("25qme")));

var $331f18c65dee33f6$var$ObjectStateMutations = $331f18c65dee33f6$var$_interopRequireWildcard((parcelRequire("5Tj02")));

var $331f18c65dee33f6$var$_TaskQueue = $3Npdz((parcelRequire("lLzga")));
function $331f18c65dee33f6$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof (parcelRequire("25qme")) !== "function") return null;
    var cacheBabelInterop = new (parcelRequire("25qme"))();
    var cacheNodeInterop = new (parcelRequire("25qme"))();
    return ($331f18c65dee33f6$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $331f18c65dee33f6$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $akViX(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $331f18c65dee33f6$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = $evY07 && $1o4IC ? $1o4IC(obj, key) : null;
        if (desc && (desc.get || desc.set)) $evY07(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ var $331f18c65dee33f6$var$objectState = new $331f18c65dee33f6$var$_weakMap.default();
function $331f18c65dee33f6$var$getState(obj) /*: ?State*/ {
    var classData = $331f18c65dee33f6$var$objectState.get(obj);
    return classData || null;
}
function $331f18c65dee33f6$var$initializeState(obj, initial) /*: State*/ {
    var state = $331f18c65dee33f6$var$getState(obj);
    if (state) return state;
    if (!initial) initial = {
        serverData: {},
        pendingOps: [
            {}
        ],
        objectCache: {},
        tasks: new $331f18c65dee33f6$var$_TaskQueue.default(),
        existed: false
    };
    state = initial;
    $331f18c65dee33f6$var$objectState.set(obj, state);
    return state;
}
function $331f18c65dee33f6$var$removeState(obj) /*: ?State*/ {
    var state = $331f18c65dee33f6$var$getState(obj);
    if (state === null) return null;
    $331f18c65dee33f6$var$objectState.delete(obj);
    return state;
}
function $331f18c65dee33f6$var$getServerData(obj) /*: AttributeMap*/ {
    var state = $331f18c65dee33f6$var$getState(obj);
    if (state) return state.serverData;
    return {};
}
function $331f18c65dee33f6$var$setServerData(obj, attributes) {
    var serverData = $331f18c65dee33f6$var$initializeState(obj).serverData;
    $331f18c65dee33f6$var$ObjectStateMutations.setServerData(serverData, attributes);
}
function $331f18c65dee33f6$var$getPendingOps(obj) /*: Array<OpsMap>*/ {
    var state = $331f18c65dee33f6$var$getState(obj);
    if (state) return state.pendingOps;
    return [
        {}
    ];
}
function $331f18c65dee33f6$var$setPendingOp(obj, attr, op) {
    var pendingOps = $331f18c65dee33f6$var$initializeState(obj).pendingOps;
    $331f18c65dee33f6$var$ObjectStateMutations.setPendingOp(pendingOps, attr, op);
}
function $331f18c65dee33f6$var$pushPendingState(obj) {
    var pendingOps = $331f18c65dee33f6$var$initializeState(obj).pendingOps;
    $331f18c65dee33f6$var$ObjectStateMutations.pushPendingState(pendingOps);
}
function $331f18c65dee33f6$var$popPendingState(obj) /*: OpsMap*/ {
    var pendingOps = $331f18c65dee33f6$var$initializeState(obj).pendingOps;
    return $331f18c65dee33f6$var$ObjectStateMutations.popPendingState(pendingOps);
}
function $331f18c65dee33f6$var$mergeFirstPendingState(obj) {
    var pendingOps = $331f18c65dee33f6$var$getPendingOps(obj);
    $331f18c65dee33f6$var$ObjectStateMutations.mergeFirstPendingState(pendingOps);
}
function $331f18c65dee33f6$var$getObjectCache(obj) /*: ObjectCache*/ {
    var state = $331f18c65dee33f6$var$getState(obj);
    if (state) return state.objectCache;
    return {};
}
function $331f18c65dee33f6$var$estimateAttribute(obj, attr) /*: mixed*/ {
    var serverData = $331f18c65dee33f6$var$getServerData(obj);
    var pendingOps = $331f18c65dee33f6$var$getPendingOps(obj);
    return $331f18c65dee33f6$var$ObjectStateMutations.estimateAttribute(serverData, pendingOps, obj.className, obj.id, attr);
}
function $331f18c65dee33f6$var$estimateAttributes(obj) /*: AttributeMap*/ {
    var serverData = $331f18c65dee33f6$var$getServerData(obj);
    var pendingOps = $331f18c65dee33f6$var$getPendingOps(obj);
    return $331f18c65dee33f6$var$ObjectStateMutations.estimateAttributes(serverData, pendingOps, obj.className, obj.id);
}
function $331f18c65dee33f6$var$commitServerChanges(obj, changes) {
    var state = $331f18c65dee33f6$var$initializeState(obj);
    $331f18c65dee33f6$var$ObjectStateMutations.commitServerChanges(state.serverData, state.objectCache, changes);
}
function $331f18c65dee33f6$var$enqueueTask(obj, task) /*: Promise*/ {
    var state = $331f18c65dee33f6$var$initializeState(obj);
    return state.tasks.enqueue(task);
}
function $331f18c65dee33f6$var$duplicateState(source, dest) /*: void*/ {
    var oldState = $331f18c65dee33f6$var$initializeState(source);
    var newState = $331f18c65dee33f6$var$initializeState(dest);
    for(var key in oldState.serverData)newState.serverData[key] = oldState.serverData[key];
    for(var index = 0; index < oldState.pendingOps.length; index++)for(var _key in oldState.pendingOps[index])newState.pendingOps[index][_key] = oldState.pendingOps[index][_key];
    for(var _key2 in oldState.objectCache)newState.objectCache[_key2] = oldState.objectCache[_key2];
    newState.existed = oldState.existed;
}
function $331f18c65dee33f6$var$clearAllState() {
    $331f18c65dee33f6$var$objectState = new $331f18c65dee33f6$var$_weakMap.default();
}

});

parcelRequire.register("7weND", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $evY07 = parcelRequire("evY07");
$evY07(module.exports, "__esModule", {
    value: true
});
module.exports.default = $579700739f4c49e3$var$unsavedChildren;

var $579700739f4c49e3$var$_forEach = $3Npdz((parcelRequire("jZGC2")));

var $579700739f4c49e3$var$_isArray = $3Npdz((parcelRequire("i0kCX")));

var $579700739f4c49e3$var$_indexOf = $3Npdz((parcelRequire("eOZH4")));

var $579700739f4c49e3$var$_concat = $3Npdz((parcelRequire("3mvQI")));

var $579700739f4c49e3$var$_typeof2 = $3Npdz((parcelRequire("akViX")));

var $579700739f4c49e3$var$_ParseFile = $3Npdz((parcelRequire("gf3Ge")));

var $579700739f4c49e3$var$_ParseObject = $3Npdz((parcelRequire("2HIpX")));

var $579700739f4c49e3$var$_ParseRelation = $3Npdz((parcelRequire("4Glkc")));
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ /**
 * Return an array of unsaved children, which are either Parse Objects or Files.
 * If it encounters any dirty Objects without Ids, it will throw an exception.
 *
 * @param {Parse.Object} obj
 * @param {boolean} allowDeepUnsaved
 * @returns {Array}
 */ function $579700739f4c49e3$var$unsavedChildren(obj, allowDeepUnsaved) /*: Array<ParseFile | ParseObject>*/ {
    var encountered = {
        objects: {},
        files: []
    };
    var identifier = obj.className + ":" + obj._getId();
    encountered.objects[identifier] = obj.dirty() ? obj : true;
    var attributes = obj.attributes;
    for(var attr in attributes)if ((0, $579700739f4c49e3$var$_typeof2.default)(attributes[attr]) === "object") $579700739f4c49e3$var$traverse(attributes[attr], encountered, false, !!allowDeepUnsaved);
    var unsaved = [];
    for(var id in encountered.objects)if (id !== identifier && encountered.objects[id] !== true) unsaved.push(encountered.objects[id]);
    return (0, $579700739f4c49e3$var$_concat.default)(unsaved).call(unsaved, encountered.files);
}
function $579700739f4c49e3$var$traverse(obj, encountered, shouldThrow, allowDeepUnsaved) {
    if (obj instanceof $579700739f4c49e3$var$_ParseObject.default) {
        if (!obj.id && shouldThrow) throw new Error("Cannot create a pointer to an unsaved Object.");
        var _identifier = obj.className + ":" + obj._getId();
        if (!encountered.objects[_identifier]) {
            encountered.objects[_identifier] = obj.dirty() ? obj : true;
            var attributes = obj.attributes;
            for(var attr in attributes)if ((0, $579700739f4c49e3$var$_typeof2.default)(attributes[attr]) === "object") $579700739f4c49e3$var$traverse(attributes[attr], encountered, !allowDeepUnsaved, allowDeepUnsaved);
        }
        return;
    }
    if (obj instanceof $579700739f4c49e3$var$_ParseFile.default) {
        var _context;
        if (!obj.url() && (0, $579700739f4c49e3$var$_indexOf.default)(_context = encountered.files).call(_context, obj) < 0) encountered.files.push(obj);
        return;
    }
    if (obj instanceof $579700739f4c49e3$var$_ParseRelation.default) return;
    if ((0, $579700739f4c49e3$var$_isArray.default)(obj)) (0, $579700739f4c49e3$var$_forEach.default)(obj).call(obj, function(el) {
        if ((0, $579700739f4c49e3$var$_typeof2.default)(el) === "object") $579700739f4c49e3$var$traverse(el, encountered, shouldThrow, allowDeepUnsaved);
    });
    for(var k in obj)if ((0, $579700739f4c49e3$var$_typeof2.default)(obj[k]) === "object") $579700739f4c49e3$var$traverse(obj[k], encountered, shouldThrow, allowDeepUnsaved);
}

});

parcelRequire.register("JZta3", function(module, exports) {
"use strict";
var $08a3e29d53fe8850$var$uuid = null;

$08a3e29d53fe8850$var$uuid = (parcelRequire("2GnZl"));
module.exports = $08a3e29d53fe8850$var$uuid;

});
parcelRequire.register("2GnZl", function(module, exports) {

var $1glfZ = parcelRequire("1glfZ");

var $k3sRO = parcelRequire("k3sRO");
function $1f421c9a4067e9bf$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $1glfZ)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $k3sRO(rnds);
}
module.exports = $1f421c9a4067e9bf$var$v4;

});
parcelRequire.register("1glfZ", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $0eb7c6448f19e6b2$var$getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if ($0eb7c6448f19e6b2$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $0eb7c6448f19e6b2$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $0eb7c6448f19e6b2$var$getRandomValues($0eb7c6448f19e6b2$var$rnds8);
        return $0eb7c6448f19e6b2$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $0eb7c6448f19e6b2$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $0eb7c6448f19e6b2$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $0eb7c6448f19e6b2$var$rnds;
    };
}

});

parcelRequire.register("k3sRO", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $e99a7ad985709b74$var$byteToHex = [];
for(var $e99a7ad985709b74$var$i = 0; $e99a7ad985709b74$var$i < 256; ++$e99a7ad985709b74$var$i)$e99a7ad985709b74$var$byteToHex[$e99a7ad985709b74$var$i] = ($e99a7ad985709b74$var$i + 0x100).toString(16).substr(1);
function $e99a7ad985709b74$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $e99a7ad985709b74$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
module.exports = $e99a7ad985709b74$var$bytesToUuid;

});





parcelRequire.register("8mqMW", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $fG1Ke = parcelRequire("fG1Ke");

var $iY2ec = parcelRequire("iY2ec");


var $iWJ3a = parcelRequire("iWJ3a");


var $jZGC2 = parcelRequire("jZGC2");

var $cO2y8 = parcelRequire("cO2y8");

var $dvfqn = parcelRequire("dvfqn");


var $ebK4m = parcelRequire("ebK4m");

var $dwGVc = parcelRequire("dwGVc");
(parcelRequire("evY07"))(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6165286c1ddc758f$var$_stringify = $3Npdz((parcelRequire("O2sNs")));

var $6165286c1ddc758f$var$_defineProperty = $3Npdz((parcelRequire("evY07")));

var $6165286c1ddc758f$var$_asyncToGenerator2 = $3Npdz((parcelRequire("iqZS2")));

var $6165286c1ddc758f$var$_promise = $3Npdz((parcelRequire("bCWDe")));

var $6165286c1ddc758f$var$_typeof2 = $3Npdz((parcelRequire("akViX")));

var $6165286c1ddc758f$var$_classCallCheck2 = $3Npdz((parcelRequire("9pQKE")));

var $6165286c1ddc758f$var$_createClass2 = $3Npdz((parcelRequire("eZYdV")));

var $6165286c1ddc758f$var$_get2 = $3Npdz((parcelRequire("eNGed")));

var $6165286c1ddc758f$var$_inherits2 = $3Npdz((parcelRequire("4QWF4")));

var $6165286c1ddc758f$var$_possibleConstructorReturn2 = $3Npdz((parcelRequire("kTHGs")));

var $6165286c1ddc758f$var$_getPrototypeOf2 = $3Npdz((parcelRequire("6MmOk")));

var $6165286c1ddc758f$var$_CoreManager = $3Npdz((parcelRequire("465CW")));

var $6165286c1ddc758f$var$_isRevocableSession = $3Npdz((parcelRequire("6p8dk")));

var $6165286c1ddc758f$var$_ParseError = $3Npdz((parcelRequire("3HQSG")));

var $6165286c1ddc758f$var$_ParseObject2 = $3Npdz((parcelRequire("2HIpX")));

var $6165286c1ddc758f$var$_ParseSession = $3Npdz((parcelRequire("afk0M")));

var $6165286c1ddc758f$var$_Storage = $3Npdz((parcelRequire("7Zbj0")));
function $6165286c1ddc758f$var$_regeneratorRuntime() {
    "use strict";
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ $6165286c1ddc758f$var$_regeneratorRuntime = function() {
        return exports1;
    };
    var exports1 = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof $ebK4m ? $ebK4m : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return (parcelRequire("evY07"))(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = $dvfqn(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return generator._invoke = function(innerFn, self, context) {
            var state = "suspendedStart";
            return function(method, arg) {
                if ("executing" === state) throw new Error("Generator is already running");
                if ("completed" === state) {
                    if ("throw" === method) throw arg;
                    return doneResult();
                }
                for(context.method = method, context.arg = arg;;){
                    var delegate = context.delegate;
                    if (delegate) {
                        var delegateResult = maybeInvokeDelegate(delegate, context);
                        if (delegateResult) {
                            if (delegateResult === ContinueSentinel) continue;
                            return delegateResult;
                        }
                    }
                    if ("next" === context.method) context.sent = context._sent = context.arg;
                    else if ("throw" === context.method) {
                        if ("suspendedStart" === state) throw state = "completed", context.arg;
                        context.dispatchException(context.arg);
                    } else "return" === context.method && context.abrupt("return", context.arg);
                    state = "executing";
                    var record = tryCatch(innerFn, self, context);
                    if ("normal" === record.type) {
                        if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                        return {
                            value: record.arg,
                            done: context.done
                        };
                    }
                    "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
                }
            };
        }(innerFn, self, context), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports1.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = $cO2y8, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = $dvfqn(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        var _context7;
        $jZGC2(_context7 = [
            "next",
            "throw",
            "return"
        ]).call(_context7, function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == (parcelRequire("akViX"))(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        this._invoke = function(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];
        if (undefined === method) {
            if (context.delegate = null, "throw" === context.method) {
                if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
                context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], $jZGC2(tryLocsList).call(tryLocsList, pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;){
                        if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    }
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports1.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports1.mark = function(genFun) {
        return $iWJ3a ? $iWJ3a(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = $dvfqn(Gp), genFun;
    }, exports1.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports1.AsyncIterator = AsyncIterator, exports1.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = (parcelRequire("bCWDe")));
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports1.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports1.keys = function(object) {
        var keys = [];
        for(var key in object)keys.push(key);
        return $iY2ec(keys).call(keys), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports1.values = values, Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            var _context8;
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, $jZGC2(_context8 = this.tryEntries).call(_context8, resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+$fG1Ke(name).call(name, 1)) && (this[name] = undefined);
        },
        stop: function() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports1;
}
function $6165286c1ddc758f$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $6165286c1ddc758f$var$_isNativeReflectConstruct();
    return function() {
        var Super = (0, $6165286c1ddc758f$var$_getPrototypeOf2.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $6165286c1ddc758f$var$_getPrototypeOf2.default)(this).constructor;
            result = $dwGVc(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6165286c1ddc758f$var$_possibleConstructorReturn2.default)(this, result);
    };
}
function $6165286c1ddc758f$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !$dwGVc) return false;
    if ($dwGVc.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($dwGVc(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $6165286c1ddc758f$var$CURRENT_USER_KEY = "currentUser";
var $6165286c1ddc758f$var$canUseCurrentUser = !$6165286c1ddc758f$var$_CoreManager.default.get("IS_NODE");
var $6165286c1ddc758f$var$currentUserCacheMatchesDisk = false;
var $6165286c1ddc758f$var$currentUserCache = null;
var $6165286c1ddc758f$var$authProviders = {};
/**
 * <p>A Parse.User object is a local representation of a user persisted to the
 * Parse cloud. This class is a subclass of a Parse.Object, and retains the
 * same functionality of a Parse.Object, but also extends it with various
 * user specific methods, like authentication, signing up, and validation of
 * uniqueness.</p>
 *
 * @alias Parse.User
 * @augments Parse.Object
 */ var $6165286c1ddc758f$var$ParseUser = /*#__PURE__*/ function(_ParseObject) {
    (0, $6165286c1ddc758f$var$_inherits2.default)(ParseUser, _ParseObject);
    var _super = $6165286c1ddc758f$var$_createSuper(ParseUser);
    /**
   * @param {object} attributes The initial set of data to store in the user.
   */ function ParseUser(attributes) {
        var _this;
        (0, $6165286c1ddc758f$var$_classCallCheck2.default)(this, ParseUser);
        _this = _super.call(this, "_User");
        if (attributes && (0, $6165286c1ddc758f$var$_typeof2.default)(attributes) === "object") {
            if (!_this.set(attributes || {})) throw new Error("Can't create an invalid Parse User");
        }
        return _this;
    }
    /**
   * Request a revocable session token to replace the older style of token.
   *
   * @param {object} options
   * @returns {Promise} A promise that is resolved when the replacement
   *   token has been fetched.
   */ (0, $6165286c1ddc758f$var$_createClass2.default)(ParseUser, [
        {
            key: "_upgradeToRevocableSession",
            value: function(options) /*: Promise<void>*/ {
                options = options || {};
                var upgradeOptions = {};
                if (options.hasOwnProperty("useMasterKey")) upgradeOptions.useMasterKey = options.useMasterKey;
                var controller = $6165286c1ddc758f$var$_CoreManager.default.getUserController();
                return controller.upgradeToRevocableSession(this, upgradeOptions);
            }
        },
        {
            key: "linkWith",
            value: function(provider, options) /*: Promise<ParseUser>*/ {
                var _this2 = this;
                var saveOpts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                saveOpts.sessionToken = saveOpts.sessionToken || this.getSessionToken() || "";
                var authType;
                if (typeof provider === "string") {
                    authType = provider;
                    if ($6165286c1ddc758f$var$authProviders[provider]) provider = $6165286c1ddc758f$var$authProviders[provider];
                    else {
                        var authProvider = {
                            restoreAuthentication: function() {
                                return true;
                            },
                            getAuthType: function() {
                                return authType;
                            }
                        };
                        $6165286c1ddc758f$var$authProviders[authProvider.getAuthType()] = authProvider;
                        provider = authProvider;
                    }
                } else authType = provider.getAuthType();
                if (options && options.hasOwnProperty("authData")) {
                    var authData = this.get("authData") || {};
                    if ((0, $6165286c1ddc758f$var$_typeof2.default)(authData) !== "object") throw new Error("Invalid type: authData field should be an object");
                    authData[authType] = options.authData;
                    var controller = $6165286c1ddc758f$var$_CoreManager.default.getUserController();
                    return controller.linkWith(this, authData, saveOpts);
                } else return new $6165286c1ddc758f$var$_promise.default(function(resolve, reject) {
                    provider.authenticate({
                        success: function(provider, result) {
                            var opts = {};
                            opts.authData = result;
                            _this2.linkWith(provider, opts, saveOpts).then(function() {
                                resolve(_this2);
                            }, function(error) {
                                reject(error);
                            });
                        },
                        error: function(provider, _error) {
                            reject(_error);
                        }
                    });
                });
            }
        },
        {
            key: "_linkWith",
            value: function(provider, options) /*: Promise<ParseUser>*/ {
                var saveOpts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return this.linkWith(provider, options, saveOpts);
            }
        },
        {
            key: "_synchronizeAuthData",
            value: function(provider) {
                if (!this.isCurrent() || !provider) return;
                var authType;
                if (typeof provider === "string") {
                    authType = provider;
                    provider = $6165286c1ddc758f$var$authProviders[authType];
                } else authType = provider.getAuthType();
                var authData = this.get("authData");
                if (!provider || !authData || (0, $6165286c1ddc758f$var$_typeof2.default)(authData) !== "object") return;
                var success = provider.restoreAuthentication(authData[authType]);
                if (!success) this._unlinkFrom(provider);
            }
        },
        {
            key: "_synchronizeAllAuthData",
            value: function() {
                var authData = this.get("authData");
                if ((0, $6165286c1ddc758f$var$_typeof2.default)(authData) !== "object") return;
                for(var _key in authData)this._synchronizeAuthData(_key);
            }
        },
        {
            key: "_cleanupAuthData",
            value: function() {
                if (!this.isCurrent()) return;
                var authData = this.get("authData");
                if ((0, $6165286c1ddc758f$var$_typeof2.default)(authData) !== "object") return;
                for(var _key2 in authData)if (!authData[_key2]) delete authData[_key2];
            }
        },
        {
            key: "_unlinkFrom",
            value: function(provider, options) /*: Promise<ParseUser>*/ {
                var _this3 = this;
                return this.linkWith(provider, {
                    authData: null
                }, options).then(function() {
                    _this3._synchronizeAuthData(provider);
                    return $6165286c1ddc758f$var$_promise.default.resolve(_this3);
                });
            }
        },
        {
            key: "_isLinked",
            value: function(provider) /*: boolean*/ {
                var authType;
                if (typeof provider === "string") authType = provider;
                else authType = provider.getAuthType();
                var authData = this.get("authData") || {};
                if ((0, $6165286c1ddc758f$var$_typeof2.default)(authData) !== "object") return false;
                return !!authData[authType];
            }
        },
        {
            key: "_logOutWithAll",
            value: function() {
                var authData = this.get("authData");
                if ((0, $6165286c1ddc758f$var$_typeof2.default)(authData) !== "object") return;
                for(var _key3 in authData)this._logOutWith(_key3);
            }
        },
        {
            key: "_logOutWith",
            value: function(provider) {
                if (!this.isCurrent()) return;
                if (typeof provider === "string") provider = $6165286c1ddc758f$var$authProviders[provider];
                if (provider && provider.deauthenticate) provider.deauthenticate();
            }
        },
        {
            key: "_preserveFieldsOnFetch",
            value: function() /*: AttributeMap*/ {
                return {
                    sessionToken: this.get("sessionToken")
                };
            }
        },
        {
            key: "isCurrent",
            value: function() /*: boolean*/ {
                var current = ParseUser.current();
                return !!current && current.id === this.id;
            }
        },
        {
            key: "isCurrentAsync",
            value: function() {
                var _isCurrentAsync = (0, $6165286c1ddc758f$var$_asyncToGenerator2.default)(/*#__PURE__*/ $6165286c1ddc758f$var$_regeneratorRuntime().mark(function _callee() {
                    var current;
                    return $6165286c1ddc758f$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _context.next = 2;
                                return ParseUser.currentAsync();
                            case 2:
                                current = _context.sent;
                                return _context.abrupt("return", !!current && current.id === this.id);
                            case 4:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function isCurrentAsync() {
                    return _isCurrentAsync.apply(this, arguments);
                }
                return isCurrentAsync;
            }()
        },
        {
            key: "getUsername",
            value: function getUsername() /*: ?string*/ {
                var username = this.get("username");
                if (username == null || typeof username === "string") return username;
                return "";
            }
        },
        {
            key: "setUsername",
            value: function setUsername(username) {
                // Strip anonymity
                var authData = this.get("authData");
                if (authData && (0, $6165286c1ddc758f$var$_typeof2.default)(authData) === "object" && authData.hasOwnProperty("anonymous")) // We need to set anonymous to null instead of deleting it in order to remove it from Parse.
                authData.anonymous = null;
                this.set("username", username);
            }
        },
        {
            key: "setPassword",
            value: function setPassword(password) {
                this.set("password", password);
            }
        },
        {
            key: "getEmail",
            value: function getEmail() /*: ?string*/ {
                var email = this.get("email");
                if (email == null || typeof email === "string") return email;
                return "";
            }
        },
        {
            key: "setEmail",
            value: function setEmail(email) {
                return this.set("email", email);
            }
        },
        {
            key: "getSessionToken",
            value: function getSessionToken() /*: ?string*/ {
                var token = this.get("sessionToken");
                if (token == null || typeof token === "string") return token;
                return "";
            }
        },
        {
            key: "authenticated",
            value: function authenticated() /*: boolean*/ {
                var current = ParseUser.current();
                return !!this.get("sessionToken") && !!current && current.id === this.id;
            }
        },
        {
            key: "signUp",
            value: function signUp(attrs, options) /*: Promise<ParseUser>*/ {
                options = options || {};
                var signupOptions = {};
                if (options.hasOwnProperty("useMasterKey")) signupOptions.useMasterKey = options.useMasterKey;
                if (options.hasOwnProperty("installationId")) signupOptions.installationId = options.installationId;
                if (options.hasOwnProperty("context") && Object.prototype.toString.call(options.context) === "[object Object]") signupOptions.context = options.context;
                var controller = $6165286c1ddc758f$var$_CoreManager.default.getUserController();
                return controller.signUp(this, attrs, signupOptions);
            }
        },
        {
            key: "logIn",
            value: function logIn(options) /*: Promise<ParseUser>*/ {
                options = options || {};
                var loginOptions = {
                    usePost: true
                };
                if (options.hasOwnProperty("useMasterKey")) loginOptions.useMasterKey = options.useMasterKey;
                if (options.hasOwnProperty("installationId")) loginOptions.installationId = options.installationId;
                if (options.hasOwnProperty("usePost")) loginOptions.usePost = options.usePost;
                var controller = $6165286c1ddc758f$var$_CoreManager.default.getUserController();
                return controller.logIn(this, loginOptions);
            }
        },
        {
            key: "save",
            value: function() {
                var _save = (0, $6165286c1ddc758f$var$_asyncToGenerator2.default)(/*#__PURE__*/ $6165286c1ddc758f$var$_regeneratorRuntime().mark(function _callee2() {
                    var _len, args, _key4, current, _args2 = arguments;
                    return $6165286c1ddc758f$var$_regeneratorRuntime().wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                for(_len = _args2.length, args = new Array(_len), _key4 = 0; _key4 < _len; _key4++)args[_key4] = _args2[_key4];
                                _context2.next = 3;
                                return (0, $6165286c1ddc758f$var$_get2.default)((0, $6165286c1ddc758f$var$_getPrototypeOf2.default)(ParseUser.prototype), "save", this).apply(this, args);
                            case 3:
                                _context2.next = 5;
                                return this.isCurrentAsync();
                            case 5:
                                current = _context2.sent;
                                if (!current) {
                                    _context2.next = 8;
                                    break;
                                }
                                return _context2.abrupt("return", $6165286c1ddc758f$var$_CoreManager.default.getUserController().updateUserOnDisk(this));
                            case 8:
                                return _context2.abrupt("return", this);
                            case 9:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function save() {
                    return _save.apply(this, arguments);
                }
                return save;
            }()
        },
        {
            key: "destroy",
            value: function() {
                var _destroy = (0, $6165286c1ddc758f$var$_asyncToGenerator2.default)(/*#__PURE__*/ $6165286c1ddc758f$var$_regeneratorRuntime().mark(function _callee3() {
                    var _len2, args, _key5, current, _args3 = arguments;
                    return $6165286c1ddc758f$var$_regeneratorRuntime().wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                for(_len2 = _args3.length, args = new Array(_len2), _key5 = 0; _key5 < _len2; _key5++)args[_key5] = _args3[_key5];
                                _context3.next = 3;
                                return (0, $6165286c1ddc758f$var$_get2.default)((0, $6165286c1ddc758f$var$_getPrototypeOf2.default)(ParseUser.prototype), "destroy", this).apply(this, args);
                            case 3:
                                _context3.next = 5;
                                return this.isCurrentAsync();
                            case 5:
                                current = _context3.sent;
                                if (!current) {
                                    _context3.next = 8;
                                    break;
                                }
                                return _context3.abrupt("return", $6165286c1ddc758f$var$_CoreManager.default.getUserController().removeUserFromDisk());
                            case 8:
                                return _context3.abrupt("return", this);
                            case 9:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function destroy() {
                    return _destroy.apply(this, arguments);
                }
                return destroy;
            }()
        },
        {
            key: "fetch",
            value: function() {
                var _fetch = (0, $6165286c1ddc758f$var$_asyncToGenerator2.default)(/*#__PURE__*/ $6165286c1ddc758f$var$_regeneratorRuntime().mark(function _callee4() {
                    var _len3, args, _key6, current, _args4 = arguments;
                    return $6165286c1ddc758f$var$_regeneratorRuntime().wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                for(_len3 = _args4.length, args = new Array(_len3), _key6 = 0; _key6 < _len3; _key6++)args[_key6] = _args4[_key6];
                                _context4.next = 3;
                                return (0, $6165286c1ddc758f$var$_get2.default)((0, $6165286c1ddc758f$var$_getPrototypeOf2.default)(ParseUser.prototype), "fetch", this).apply(this, args);
                            case 3:
                                _context4.next = 5;
                                return this.isCurrentAsync();
                            case 5:
                                current = _context4.sent;
                                if (!current) {
                                    _context4.next = 8;
                                    break;
                                }
                                return _context4.abrupt("return", $6165286c1ddc758f$var$_CoreManager.default.getUserController().updateUserOnDisk(this));
                            case 8:
                                return _context4.abrupt("return", this);
                            case 9:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function fetch() {
                    return _fetch.apply(this, arguments);
                }
                return fetch;
            }()
        },
        {
            key: "fetchWithInclude",
            value: function() {
                var _fetchWithInclude = (0, $6165286c1ddc758f$var$_asyncToGenerator2.default)(/*#__PURE__*/ $6165286c1ddc758f$var$_regeneratorRuntime().mark(function _callee5() {
                    var _len4, args, _key7, current, _args5 = arguments;
                    return $6165286c1ddc758f$var$_regeneratorRuntime().wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                for(_len4 = _args5.length, args = new Array(_len4), _key7 = 0; _key7 < _len4; _key7++)args[_key7] = _args5[_key7];
                                _context5.next = 3;
                                return (0, $6165286c1ddc758f$var$_get2.default)((0, $6165286c1ddc758f$var$_getPrototypeOf2.default)(ParseUser.prototype), "fetchWithInclude", this).apply(this, args);
                            case 3:
                                _context5.next = 5;
                                return this.isCurrentAsync();
                            case 5:
                                current = _context5.sent;
                                if (!current) {
                                    _context5.next = 8;
                                    break;
                                }
                                return _context5.abrupt("return", $6165286c1ddc758f$var$_CoreManager.default.getUserController().updateUserOnDisk(this));
                            case 8:
                                return _context5.abrupt("return", this);
                            case 9:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchWithInclude() {
                    return _fetchWithInclude.apply(this, arguments);
                }
                return fetchWithInclude;
            }()
        },
        {
            key: "verifyPassword",
            value: function verifyPassword(password, options) /*: Promise<ParseUser>*/ {
                var username = this.getUsername() || "";
                return ParseUser.verifyPassword(username, password, options);
            }
        }
    ], [
        {
            key: "readOnlyAttributes",
            value: function readOnlyAttributes() {
                return [
                    "sessionToken"
                ];
            }
        },
        {
            key: "extend",
            value: function extend(protoProps, classProps) {
                if (protoProps) {
                    for(var _prop in protoProps)if (_prop !== "className") (0, $6165286c1ddc758f$var$_defineProperty.default)(ParseUser.prototype, _prop, {
                        value: protoProps[_prop],
                        enumerable: false,
                        writable: true,
                        configurable: true
                    });
                }
                if (classProps) {
                    for(var _prop2 in classProps)if (_prop2 !== "className") (0, $6165286c1ddc758f$var$_defineProperty.default)(ParseUser, _prop2, {
                        value: classProps[_prop2],
                        enumerable: false,
                        writable: true,
                        configurable: true
                    });
                }
                return ParseUser;
            }
        },
        {
            key: "current",
            value: function current() /*: ?ParseUser*/ {
                if (!$6165286c1ddc758f$var$canUseCurrentUser) return null;
                var controller = $6165286c1ddc758f$var$_CoreManager.default.getUserController();
                return controller.currentUser();
            }
        },
        {
            key: "currentAsync",
            value: function currentAsync() /*: Promise<?ParseUser>*/ {
                if (!$6165286c1ddc758f$var$canUseCurrentUser) return $6165286c1ddc758f$var$_promise.default.resolve(null);
                var controller = $6165286c1ddc758f$var$_CoreManager.default.getUserController();
                return controller.currentUserAsync();
            }
        },
        {
            key: "signUp",
            value: function signUp(username, password, attrs, options) {
                attrs = attrs || {};
                attrs.username = username;
                attrs.password = password;
                var user = new this(attrs);
                return user.signUp({}, options);
            }
        },
        {
            key: "logIn",
            value: function logIn(username, password, options) {
                if (typeof username !== "string") return $6165286c1ddc758f$var$_promise.default.reject(new $6165286c1ddc758f$var$_ParseError.default($6165286c1ddc758f$var$_ParseError.default.OTHER_CAUSE, "Username must be a string."));
                else if (typeof password !== "string") return $6165286c1ddc758f$var$_promise.default.reject(new $6165286c1ddc758f$var$_ParseError.default($6165286c1ddc758f$var$_ParseError.default.OTHER_CAUSE, "Password must be a string."));
                var user = new this();
                user._finishFetch({
                    username: username,
                    password: password
                });
                return user.logIn(options);
            }
        },
        {
            key: "become",
            value: function become(sessionToken, options) {
                if (!$6165286c1ddc758f$var$canUseCurrentUser) throw new Error("It is not memory-safe to become a user in a server environment");
                options = options || {};
                var becomeOptions = {
                    sessionToken: sessionToken
                };
                if (options.hasOwnProperty("useMasterKey")) becomeOptions.useMasterKey = options.useMasterKey;
                var controller = $6165286c1ddc758f$var$_CoreManager.default.getUserController();
                var user = new this();
                return controller.become(user, becomeOptions);
            }
        },
        {
            key: "me",
            value: function me(sessionToken) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var controller = $6165286c1ddc758f$var$_CoreManager.default.getUserController();
                var meOptions = {
                    sessionToken: sessionToken
                };
                if (options.useMasterKey) meOptions.useMasterKey = options.useMasterKey;
                var user = new this();
                return controller.me(user, meOptions);
            }
        },
        {
            key: "hydrate",
            value: function hydrate(userJSON) {
                var controller = $6165286c1ddc758f$var$_CoreManager.default.getUserController();
                var user = new this();
                return controller.hydrate(user, userJSON);
            }
        },
        {
            key: "logInWith",
            value: function logInWith(provider, options, saveOpts) /*: Promise<ParseUser>*/ {
                var user = new this();
                return user.linkWith(provider, options, saveOpts);
            }
        },
        {
            key: "logOut",
            value: function logOut() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var controller = $6165286c1ddc758f$var$_CoreManager.default.getUserController();
                return controller.logOut(options);
            }
        },
        {
            key: "requestPasswordReset",
            value: function requestPasswordReset(email, options) {
                options = options || {};
                var requestOptions = {};
                if (options.hasOwnProperty("useMasterKey")) requestOptions.useMasterKey = options.useMasterKey;
                var controller = $6165286c1ddc758f$var$_CoreManager.default.getUserController();
                return controller.requestPasswordReset(email, requestOptions);
            }
        },
        {
            key: "requestEmailVerification",
            value: function requestEmailVerification(email, options) {
                options = options || {};
                var requestOptions = {};
                if (options.hasOwnProperty("useMasterKey")) requestOptions.useMasterKey = options.useMasterKey;
                var controller = $6165286c1ddc758f$var$_CoreManager.default.getUserController();
                return controller.requestEmailVerification(email, requestOptions);
            }
        },
        {
            key: "verifyPassword",
            value: function verifyPassword(username, password, options) {
                if (typeof username !== "string") return $6165286c1ddc758f$var$_promise.default.reject(new $6165286c1ddc758f$var$_ParseError.default($6165286c1ddc758f$var$_ParseError.default.OTHER_CAUSE, "Username must be a string."));
                if (typeof password !== "string") return $6165286c1ddc758f$var$_promise.default.reject(new $6165286c1ddc758f$var$_ParseError.default($6165286c1ddc758f$var$_ParseError.default.OTHER_CAUSE, "Password must be a string."));
                options = options || {};
                var verificationOption = {};
                if (options.hasOwnProperty("useMasterKey")) verificationOption.useMasterKey = options.useMasterKey;
                var controller = $6165286c1ddc758f$var$_CoreManager.default.getUserController();
                return controller.verifyPassword(username, password, verificationOption);
            }
        },
        {
            key: "allowCustomUserClass",
            value: function allowCustomUserClass(isAllowed) {
                $6165286c1ddc758f$var$_CoreManager.default.set("PERFORM_USER_REWRITE", !isAllowed);
            }
        },
        {
            key: "enableRevocableSession",
            value: function enableRevocableSession(options) {
                options = options || {};
                $6165286c1ddc758f$var$_CoreManager.default.set("FORCE_REVOCABLE_SESSION", true);
                if ($6165286c1ddc758f$var$canUseCurrentUser) {
                    var current = ParseUser.current();
                    if (current) return current._upgradeToRevocableSession(options);
                }
                return $6165286c1ddc758f$var$_promise.default.resolve();
            }
        },
        {
            key: "enableUnsafeCurrentUser",
            value: function enableUnsafeCurrentUser() {
                $6165286c1ddc758f$var$canUseCurrentUser = true;
            }
        },
        {
            key: "disableUnsafeCurrentUser",
            value: function disableUnsafeCurrentUser() {
                $6165286c1ddc758f$var$canUseCurrentUser = false;
            }
        },
        {
            key: "_registerAuthenticationProvider",
            value: function _registerAuthenticationProvider(provider) {
                $6165286c1ddc758f$var$authProviders[provider.getAuthType()] = provider; // Synchronize the current user with the auth provider.
                ParseUser.currentAsync().then(function(current) {
                    if (current) current._synchronizeAuthData(provider.getAuthType());
                });
            }
        },
        {
            key: "_logInWith",
            value: function _logInWith(provider, options, saveOpts) {
                var user = new this();
                return user.linkWith(provider, options, saveOpts);
            }
        },
        {
            key: "_clearCache",
            value: function _clearCache() {
                $6165286c1ddc758f$var$currentUserCache = null;
                $6165286c1ddc758f$var$currentUserCacheMatchesDisk = false;
            }
        },
        {
            key: "_setCurrentUserCache",
            value: function _setCurrentUserCache(user) {
                $6165286c1ddc758f$var$currentUserCache = user;
            }
        }
    ]);
    return ParseUser;
}($6165286c1ddc758f$var$_ParseObject2.default);
$6165286c1ddc758f$var$_ParseObject2.default.registerSubclass("_User", $6165286c1ddc758f$var$ParseUser);
var $6165286c1ddc758f$var$DefaultController = {
    updateUserOnDisk: function updateUserOnDisk(user) {
        var path = $6165286c1ddc758f$var$_Storage.default.generatePath($6165286c1ddc758f$var$CURRENT_USER_KEY);
        var json = user.toJSON();
        delete json.password;
        json.className = "_User";
        var userData = (0, $6165286c1ddc758f$var$_stringify.default)(json);
        if ($6165286c1ddc758f$var$_CoreManager.default.get("ENCRYPTED_USER")) {
            var crypto = $6165286c1ddc758f$var$_CoreManager.default.getCryptoController();
            userData = crypto.encrypt(json, $6165286c1ddc758f$var$_CoreManager.default.get("ENCRYPTED_KEY"));
        }
        return $6165286c1ddc758f$var$_Storage.default.setItemAsync(path, userData).then(function() {
            return user;
        });
    },
    removeUserFromDisk: function removeUserFromDisk() {
        var path = $6165286c1ddc758f$var$_Storage.default.generatePath($6165286c1ddc758f$var$CURRENT_USER_KEY);
        $6165286c1ddc758f$var$currentUserCacheMatchesDisk = true;
        $6165286c1ddc758f$var$currentUserCache = null;
        return $6165286c1ddc758f$var$_Storage.default.removeItemAsync(path);
    },
    setCurrentUser: function setCurrentUser(user) {
        $6165286c1ddc758f$var$currentUserCache = user;
        user._cleanupAuthData();
        user._synchronizeAllAuthData();
        return $6165286c1ddc758f$var$DefaultController.updateUserOnDisk(user);
    },
    currentUser: function currentUser() /*: ?ParseUser*/ {
        if ($6165286c1ddc758f$var$currentUserCache) return $6165286c1ddc758f$var$currentUserCache;
        if ($6165286c1ddc758f$var$currentUserCacheMatchesDisk) return null;
        if ($6165286c1ddc758f$var$_Storage.default.async()) throw new Error("Cannot call currentUser() when using a platform with an async storage system. Call currentUserAsync() instead.");
        var path = $6165286c1ddc758f$var$_Storage.default.generatePath($6165286c1ddc758f$var$CURRENT_USER_KEY);
        var userData = $6165286c1ddc758f$var$_Storage.default.getItem(path);
        $6165286c1ddc758f$var$currentUserCacheMatchesDisk = true;
        if (!userData) {
            $6165286c1ddc758f$var$currentUserCache = null;
            return null;
        }
        if ($6165286c1ddc758f$var$_CoreManager.default.get("ENCRYPTED_USER")) {
            var crypto = $6165286c1ddc758f$var$_CoreManager.default.getCryptoController();
            userData = crypto.decrypt(userData, $6165286c1ddc758f$var$_CoreManager.default.get("ENCRYPTED_KEY"));
        }
        userData = JSON.parse(userData);
        if (!userData.className) userData.className = "_User";
        if (userData._id) {
            if (userData.objectId !== userData._id) userData.objectId = userData._id;
            delete userData._id;
        }
        if (userData._sessionToken) {
            userData.sessionToken = userData._sessionToken;
            delete userData._sessionToken;
        }
        var current = $6165286c1ddc758f$var$_ParseObject2.default.fromJSON(userData);
        $6165286c1ddc758f$var$currentUserCache = current;
        current._synchronizeAllAuthData();
        return current;
    },
    currentUserAsync: function currentUserAsync() /*: Promise<?ParseUser>*/ {
        if ($6165286c1ddc758f$var$currentUserCache) return $6165286c1ddc758f$var$_promise.default.resolve($6165286c1ddc758f$var$currentUserCache);
        if ($6165286c1ddc758f$var$currentUserCacheMatchesDisk) return $6165286c1ddc758f$var$_promise.default.resolve(null);
        var path = $6165286c1ddc758f$var$_Storage.default.generatePath($6165286c1ddc758f$var$CURRENT_USER_KEY);
        return $6165286c1ddc758f$var$_Storage.default.getItemAsync(path).then(function(userData) {
            $6165286c1ddc758f$var$currentUserCacheMatchesDisk = true;
            if (!userData) {
                $6165286c1ddc758f$var$currentUserCache = null;
                return $6165286c1ddc758f$var$_promise.default.resolve(null);
            }
            if ($6165286c1ddc758f$var$_CoreManager.default.get("ENCRYPTED_USER")) {
                var crypto = $6165286c1ddc758f$var$_CoreManager.default.getCryptoController();
                userData = crypto.decrypt(userData.toString(), $6165286c1ddc758f$var$_CoreManager.default.get("ENCRYPTED_KEY"));
            }
            userData = JSON.parse(userData);
            if (!userData.className) userData.className = "_User";
            if (userData._id) {
                if (userData.objectId !== userData._id) userData.objectId = userData._id;
                delete userData._id;
            }
            if (userData._sessionToken) {
                userData.sessionToken = userData._sessionToken;
                delete userData._sessionToken;
            }
            var current = $6165286c1ddc758f$var$_ParseObject2.default.fromJSON(userData);
            $6165286c1ddc758f$var$currentUserCache = current;
            current._synchronizeAllAuthData();
            return $6165286c1ddc758f$var$_promise.default.resolve(current);
        });
    },
    signUp: function signUp(user, attrs, options) /*: Promise<ParseUser>*/ {
        var username = attrs && attrs.username || user.get("username");
        var password = attrs && attrs.password || user.get("password");
        if (!username || !username.length) return $6165286c1ddc758f$var$_promise.default.reject(new $6165286c1ddc758f$var$_ParseError.default($6165286c1ddc758f$var$_ParseError.default.OTHER_CAUSE, "Cannot sign up user with an empty username."));
        if (!password || !password.length) return $6165286c1ddc758f$var$_promise.default.reject(new $6165286c1ddc758f$var$_ParseError.default($6165286c1ddc758f$var$_ParseError.default.OTHER_CAUSE, "Cannot sign up user with an empty password."));
        return user.save(attrs, options).then(function() {
            // Clear the password field
            user._finishFetch({
                password: undefined
            });
            if ($6165286c1ddc758f$var$canUseCurrentUser) return $6165286c1ddc758f$var$DefaultController.setCurrentUser(user);
            return user;
        });
    },
    logIn: function logIn(user, options) /*: Promise<ParseUser>*/ {
        var RESTController = $6165286c1ddc758f$var$_CoreManager.default.getRESTController();
        var stateController = $6165286c1ddc758f$var$_CoreManager.default.getObjectStateController();
        var auth = {
            username: user.get("username"),
            password: user.get("password")
        };
        return RESTController.request(options.usePost ? "POST" : "GET", "login", auth, options).then(function(response) {
            user._migrateId(response.objectId);
            user._setExisted(true);
            stateController.setPendingOp(user._getStateIdentifier(), "username", undefined);
            stateController.setPendingOp(user._getStateIdentifier(), "password", undefined);
            response.password = undefined;
            user._finishFetch(response);
            if (!$6165286c1ddc758f$var$canUseCurrentUser) // We can't set the current user, so just return the one we logged in
            return $6165286c1ddc758f$var$_promise.default.resolve(user);
            return $6165286c1ddc758f$var$DefaultController.setCurrentUser(user);
        });
    },
    become: function become(user, options) /*: Promise<ParseUser>*/ {
        var RESTController = $6165286c1ddc758f$var$_CoreManager.default.getRESTController();
        return RESTController.request("GET", "users/me", {}, options).then(function(response) {
            user._finishFetch(response);
            user._setExisted(true);
            return $6165286c1ddc758f$var$DefaultController.setCurrentUser(user);
        });
    },
    hydrate: function hydrate(user, userJSON) /*: Promise<ParseUser>*/ {
        user._finishFetch(userJSON);
        user._setExisted(true);
        if (userJSON.sessionToken && $6165286c1ddc758f$var$canUseCurrentUser) return $6165286c1ddc758f$var$DefaultController.setCurrentUser(user);
        else return $6165286c1ddc758f$var$_promise.default.resolve(user);
    },
    me: function me(user, options) /*: Promise<ParseUser>*/ {
        var RESTController = $6165286c1ddc758f$var$_CoreManager.default.getRESTController();
        return RESTController.request("GET", "users/me", {}, options).then(function(response) {
            user._finishFetch(response);
            user._setExisted(true);
            return user;
        });
    },
    logOut: function logOut(options) /*: Promise<ParseUser>*/ {
        var RESTController = $6165286c1ddc758f$var$_CoreManager.default.getRESTController();
        if (options.sessionToken) return RESTController.request("POST", "logout", {}, options);
        return $6165286c1ddc758f$var$DefaultController.currentUserAsync().then(function(currentUser) {
            var path = $6165286c1ddc758f$var$_Storage.default.generatePath($6165286c1ddc758f$var$CURRENT_USER_KEY);
            var promise = $6165286c1ddc758f$var$_Storage.default.removeItemAsync(path);
            if (currentUser !== null) {
                var currentSession = currentUser.getSessionToken();
                if (currentSession && (0, $6165286c1ddc758f$var$_isRevocableSession.default)(currentSession)) promise = promise.then(function() {
                    return RESTController.request("POST", "logout", {}, {
                        sessionToken: currentSession
                    });
                });
                currentUser._logOutWithAll();
                currentUser._finishFetch({
                    sessionToken: undefined
                });
            }
            $6165286c1ddc758f$var$currentUserCacheMatchesDisk = true;
            $6165286c1ddc758f$var$currentUserCache = null;
            return promise;
        });
    },
    requestPasswordReset: function requestPasswordReset(email, options) {
        var RESTController = $6165286c1ddc758f$var$_CoreManager.default.getRESTController();
        return RESTController.request("POST", "requestPasswordReset", {
            email: email
        }, options);
    },
    upgradeToRevocableSession: function upgradeToRevocableSession(user, options) {
        return (0, $6165286c1ddc758f$var$_asyncToGenerator2.default)(/*#__PURE__*/ $6165286c1ddc758f$var$_regeneratorRuntime().mark(function _callee6() {
            var token, RESTController, result, session, current;
            return $6165286c1ddc758f$var$_regeneratorRuntime().wrap(function _callee6$(_context6) {
                while(true)switch(_context6.prev = _context6.next){
                    case 0:
                        token = user.getSessionToken();
                        if (token) {
                            _context6.next = 3;
                            break;
                        }
                        return _context6.abrupt("return", $6165286c1ddc758f$var$_promise.default.reject(new $6165286c1ddc758f$var$_ParseError.default($6165286c1ddc758f$var$_ParseError.default.SESSION_MISSING, "Cannot upgrade a user with no session token")));
                    case 3:
                        options.sessionToken = token;
                        RESTController = $6165286c1ddc758f$var$_CoreManager.default.getRESTController();
                        _context6.next = 7;
                        return RESTController.request("POST", "upgradeToRevocableSession", {}, options);
                    case 7:
                        result = _context6.sent;
                        session = new $6165286c1ddc758f$var$_ParseSession.default();
                        session._finishFetch(result);
                        user._finishFetch({
                            sessionToken: session.getSessionToken()
                        });
                        _context6.next = 13;
                        return user.isCurrentAsync();
                    case 13:
                        current = _context6.sent;
                        if (!current) {
                            _context6.next = 16;
                            break;
                        }
                        return _context6.abrupt("return", $6165286c1ddc758f$var$DefaultController.setCurrentUser(user));
                    case 16:
                        return _context6.abrupt("return", $6165286c1ddc758f$var$_promise.default.resolve(user));
                    case 17:
                    case "end":
                        return _context6.stop();
                }
            }, _callee6);
        }))();
    },
    linkWith: function linkWith(user, authData, options) {
        return user.save({
            authData: authData
        }, options).then(function() {
            if ($6165286c1ddc758f$var$canUseCurrentUser) return $6165286c1ddc758f$var$DefaultController.setCurrentUser(user);
            return user;
        });
    },
    verifyPassword: function verifyPassword(username, password, options) {
        var RESTController = $6165286c1ddc758f$var$_CoreManager.default.getRESTController();
        return RESTController.request("GET", "verifyPassword", {
            username: username,
            password: password
        }, options);
    },
    requestEmailVerification: function requestEmailVerification(email, options) {
        var RESTController = $6165286c1ddc758f$var$_CoreManager.default.getRESTController();
        return RESTController.request("POST", "verificationEmailRequest", {
            email: email
        }, options);
    }
};
$6165286c1ddc758f$var$_CoreManager.default.setUserController($6165286c1ddc758f$var$DefaultController);
var $6165286c1ddc758f$var$_default = $6165286c1ddc758f$var$ParseUser;
module.exports.default = $6165286c1ddc758f$var$_default;

});
parcelRequire.register("6p8dk", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $evY07 = parcelRequire("evY07");
$evY07(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4a9b73063815de8e$var$isRevocableSession;

var $4a9b73063815de8e$var$_indexOf = $3Npdz((parcelRequire("eOZH4")));
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ function $4a9b73063815de8e$var$isRevocableSession(token) /*: boolean*/ {
    return (0, $4a9b73063815de8e$var$_indexOf.default)(token).call(token, "r:") > -1;
}

});

parcelRequire.register("afk0M", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $evY07 = parcelRequire("evY07");

var $dwGVc = parcelRequire("dwGVc");
$evY07(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $775ad3f8565db041$var$_promise = $3Npdz((parcelRequire("bCWDe")));

var $775ad3f8565db041$var$_typeof2 = $3Npdz((parcelRequire("akViX")));

var $775ad3f8565db041$var$_classCallCheck2 = $3Npdz((parcelRequire("9pQKE")));

var $775ad3f8565db041$var$_createClass2 = $3Npdz((parcelRequire("eZYdV")));

var $775ad3f8565db041$var$_inherits2 = $3Npdz((parcelRequire("4QWF4")));

var $775ad3f8565db041$var$_possibleConstructorReturn2 = $3Npdz((parcelRequire("kTHGs")));

var $775ad3f8565db041$var$_getPrototypeOf2 = $3Npdz((parcelRequire("6MmOk")));

var $775ad3f8565db041$var$_CoreManager = $3Npdz((parcelRequire("465CW")));

var $775ad3f8565db041$var$_isRevocableSession = $3Npdz((parcelRequire("6p8dk")));

var $775ad3f8565db041$var$_ParseObject2 = $3Npdz((parcelRequire("2HIpX")));

var $775ad3f8565db041$var$_ParseUser = $3Npdz((parcelRequire("8mqMW")));
function $775ad3f8565db041$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $775ad3f8565db041$var$_isNativeReflectConstruct();
    return function() {
        var Super = (0, $775ad3f8565db041$var$_getPrototypeOf2.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $775ad3f8565db041$var$_getPrototypeOf2.default)(this).constructor;
            result = $dwGVc(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $775ad3f8565db041$var$_possibleConstructorReturn2.default)(this, result);
    };
}
function $775ad3f8565db041$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !$dwGVc) return false;
    if ($dwGVc.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($dwGVc(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * <p>A Parse.Session object is a local representation of a revocable session.
 * This class is a subclass of a Parse.Object, and retains the same
 * functionality of a Parse.Object.</p>
 *
 * @alias Parse.Session
 * @augments Parse.Object
 */ var $775ad3f8565db041$var$ParseSession = /*#__PURE__*/ function(_ParseObject) {
    (0, $775ad3f8565db041$var$_inherits2.default)(ParseSession, _ParseObject);
    var _super = $775ad3f8565db041$var$_createSuper(ParseSession);
    /**
   * @param {object} attributes The initial set of data to store in the user.
   */ function ParseSession(attributes) {
        var _this;
        (0, $775ad3f8565db041$var$_classCallCheck2.default)(this, ParseSession);
        _this = _super.call(this, "_Session");
        if (attributes && (0, $775ad3f8565db041$var$_typeof2.default)(attributes) === "object") {
            if (!_this.set(attributes || {})) throw new Error("Can't create an invalid Session");
        }
        return _this;
    }
    /**
   * Returns the session token string.
   *
   * @returns {string}
   */ (0, $775ad3f8565db041$var$_createClass2.default)(ParseSession, [
        {
            key: "getSessionToken",
            value: function() /*: string*/ {
                var token = this.get("sessionToken");
                if (typeof token === "string") return token;
                return "";
            }
        }
    ], [
        {
            key: "readOnlyAttributes",
            value: function() {
                return [
                    "createdWith",
                    "expiresAt",
                    "installationId",
                    "restricted",
                    "sessionToken",
                    "user"
                ];
            }
        },
        {
            key: "current",
            value: function(options) {
                options = options || {};
                var controller = $775ad3f8565db041$var$_CoreManager.default.getSessionController();
                var sessionOptions = {};
                if (options.hasOwnProperty("useMasterKey")) sessionOptions.useMasterKey = options.useMasterKey;
                return $775ad3f8565db041$var$_ParseUser.default.currentAsync().then(function(user) {
                    if (!user) return $775ad3f8565db041$var$_promise.default.reject("There is no current user.");
                    sessionOptions.sessionToken = user.getSessionToken();
                    return controller.getSession(sessionOptions);
                });
            }
        },
        {
            key: "isCurrentSessionRevocable",
            value: function() /*: boolean*/ {
                var currentUser = $775ad3f8565db041$var$_ParseUser.default.current();
                if (currentUser) return (0, $775ad3f8565db041$var$_isRevocableSession.default)(currentUser.getSessionToken() || "");
                return false;
            }
        }
    ]);
    return ParseSession;
}($775ad3f8565db041$var$_ParseObject2.default);
$775ad3f8565db041$var$_ParseObject2.default.registerSubclass("_Session", $775ad3f8565db041$var$ParseSession);
var $775ad3f8565db041$var$DefaultController = {
    getSession: function(options) /*: Promise<ParseSession>*/ {
        var RESTController = $775ad3f8565db041$var$_CoreManager.default.getRESTController();
        var session = new $775ad3f8565db041$var$ParseSession();
        return RESTController.request("GET", "sessions/me", {}, options).then(function(sessionData) {
            session._finishFetch(sessionData);
            session._setExisted(true);
            return session;
        });
    }
};
$775ad3f8565db041$var$_CoreManager.default.setSessionController($775ad3f8565db041$var$DefaultController);
var $775ad3f8565db041$var$_default = $775ad3f8565db041$var$ParseSession;
module.exports.default = $775ad3f8565db041$var$_default;

});




parcelRequire.register("7jja0", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $55292b97512d3fa1$var$_stringify = $3Npdz((parcelRequire("O2sNs")));
var $55292b97512d3fa1$var$AES;
var $55292b97512d3fa1$var$ENC;

$55292b97512d3fa1$var$AES = (parcelRequire("evHfo"));

$55292b97512d3fa1$var$ENC = (parcelRequire("gBi6S"));
var $55292b97512d3fa1$var$CryptoJS;
var $55292b97512d3fa1$var$CryptoController = {
    encrypt: function(obj, secretKey) /*: ?string*/ {
        var encrypted = $55292b97512d3fa1$var$AES.encrypt((0, $55292b97512d3fa1$var$_stringify.default)(obj), secretKey);
        return encrypted.toString();
    },
    decrypt: function(encryptedText, secretKey) /*: ?string*/ {
        var decryptedStr = $55292b97512d3fa1$var$AES.decrypt(encryptedText, secretKey).toString($55292b97512d3fa1$var$ENC);
        return decryptedStr;
    }
};
module.exports = $55292b97512d3fa1$var$CryptoController;

});
parcelRequire.register("evHfo", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3VShD")), (parcelRequire("fLcAH")), (parcelRequire("jxlMi")), (parcelRequire("drK4C")), (parcelRequire("fUsrA")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        // Lookup tables
        var SBOX = [];
        var INV_SBOX = [];
        var SUB_MIX_0 = [];
        var SUB_MIX_1 = [];
        var SUB_MIX_2 = [];
        var SUB_MIX_3 = [];
        var INV_SUB_MIX_0 = [];
        var INV_SUB_MIX_1 = [];
        var INV_SUB_MIX_2 = [];
        var INV_SUB_MIX_3 = [];
        // Compute lookup tables
        (function() {
            // Compute double table
            var d = [];
            for(var i = 0; i < 256; i++)if (i < 128) d[i] = i << 1;
            else d[i] = i << 1 ^ 0x11b;
            // Walk GF(2^8)
            var x = 0;
            var xi = 0;
            for(var i = 0; i < 256; i++){
                // Compute sbox
                var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
                sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
                SBOX[x] = sx;
                INV_SBOX[sx] = x;
                // Compute multiplication
                var x2 = d[x];
                var x4 = d[x2];
                var x8 = d[x4];
                // Compute sub bytes, mix columns tables
                var t = d[sx] * 0x101 ^ sx * 0x1010100;
                SUB_MIX_0[x] = t << 24 | t >>> 8;
                SUB_MIX_1[x] = t << 16 | t >>> 16;
                SUB_MIX_2[x] = t << 8 | t >>> 24;
                SUB_MIX_3[x] = t;
                // Compute inv sub bytes, inv mix columns tables
                var t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
                INV_SUB_MIX_0[sx] = t << 24 | t >>> 8;
                INV_SUB_MIX_1[sx] = t << 16 | t >>> 16;
                INV_SUB_MIX_2[sx] = t << 8 | t >>> 24;
                INV_SUB_MIX_3[sx] = t;
                // Compute next counter
                if (!x) x = xi = 1;
                else {
                    x = x2 ^ d[d[d[x8 ^ x2]]];
                    xi ^= d[d[xi]];
                }
            }
        })();
        // Precomputed Rcon lookup
        var RCON = [
            0x00,
            0x01,
            0x02,
            0x04,
            0x08,
            0x10,
            0x20,
            0x40,
            0x80,
            0x1b,
            0x36
        ];
        /**
	     * AES block cipher algorithm.
	     */ var AES = C_algo.AES = BlockCipher.extend({
            _doReset: function() {
                var t;
                // Skip reset of nRounds has been set before and key did not change
                if (this._nRounds && this._keyPriorReset === this._key) return;
                // Shortcuts
                var key = this._keyPriorReset = this._key;
                var keyWords = key.words;
                var keySize = key.sigBytes / 4;
                // Compute number of rounds
                var nRounds = this._nRounds = keySize + 6;
                // Compute number of key schedule rows
                var ksRows = (nRounds + 1) * 4;
                // Compute key schedule
                var keySchedule = this._keySchedule = [];
                for(var ksRow = 0; ksRow < ksRows; ksRow++)if (ksRow < keySize) keySchedule[ksRow] = keyWords[ksRow];
                else {
                    t = keySchedule[ksRow - 1];
                    if (!(ksRow % keySize)) {
                        // Rot word
                        t = t << 8 | t >>> 24;
                        // Sub word
                        t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                        // Mix Rcon
                        t ^= RCON[ksRow / keySize | 0] << 24;
                    } else if (keySize > 6 && ksRow % keySize == 4) // Sub word
                    t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
                }
                // Compute inv key schedule
                var invKeySchedule = this._invKeySchedule = [];
                for(var invKsRow = 0; invKsRow < ksRows; invKsRow++){
                    var ksRow = ksRows - invKsRow;
                    if (invKsRow % 4) var t = keySchedule[ksRow];
                    else var t = keySchedule[ksRow - 4];
                    if (invKsRow < 4 || ksRow <= 4) invKeySchedule[invKsRow] = t;
                    else invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[t >>> 16 & 0xff]] ^ INV_SUB_MIX_2[SBOX[t >>> 8 & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
                }
            },
            encryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
            },
            decryptBlock: function(M, offset) {
                // Swap 2nd and 4th rows
                var t = M[offset + 1];
                M[offset + 1] = M[offset + 3];
                M[offset + 3] = t;
                this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);
                // Inv swap 2nd and 4th rows
                var t = M[offset + 1];
                M[offset + 1] = M[offset + 3];
                M[offset + 3] = t;
            },
            _doCryptBlock: function(M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
                // Shortcut
                var nRounds = this._nRounds;
                // Get input, add round key
                var s0 = M[offset] ^ keySchedule[0];
                var s1 = M[offset + 1] ^ keySchedule[1];
                var s2 = M[offset + 2] ^ keySchedule[2];
                var s3 = M[offset + 3] ^ keySchedule[3];
                // Key schedule row counter
                var ksRow = 4;
                // Rounds
                for(var round = 1; round < nRounds; round++){
                    // Shift rows, sub bytes, mix columns, add round key
                    var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[s1 >>> 16 & 0xff] ^ SUB_MIX_2[s2 >>> 8 & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
                    var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[s2 >>> 16 & 0xff] ^ SUB_MIX_2[s3 >>> 8 & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
                    var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[s3 >>> 16 & 0xff] ^ SUB_MIX_2[s0 >>> 8 & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
                    var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[s0 >>> 16 & 0xff] ^ SUB_MIX_2[s1 >>> 8 & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];
                    // Update state
                    s0 = t0;
                    s1 = t1;
                    s2 = t2;
                    s3 = t3;
                }
                // Shift rows, sub bytes, add round key
                var t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
                var t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
                var t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
                var t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
                // Set output
                M[offset] = t0;
                M[offset + 1] = t1;
                M[offset + 2] = t2;
                M[offset + 3] = t3;
            },
            keySize: 8
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
	     */ C.AES = BlockCipher._createHelper(AES);
    })();
    return CryptoJS.AES;
});

});
parcelRequire.register("3VShD", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory();
})(this, function() {
    /*globals window, global, require*/ /**
	 * CryptoJS core components.
	 */ var CryptoJS = CryptoJS || function(Math1, undefined) {
        var crypto;
        // Native crypto from window (Browser)
        if (typeof window !== "undefined" && window.crypto) crypto = window.crypto;
        // Native crypto in web worker (Browser)
        if (typeof self !== "undefined" && self.crypto) crypto = self.crypto;
        // Native crypto from worker
        if (typeof globalThis !== "undefined" && globalThis.crypto) crypto = globalThis.crypto;
        // Native (experimental IE 11) crypto from window (Browser)
        if (!crypto && typeof window !== "undefined" && window.msCrypto) crypto = window.msCrypto;
        // Native crypto from global (NodeJS)
        if (!crypto && typeof $parcel$global !== "undefined" && $parcel$global.crypto) crypto = $parcel$global.crypto;
        // Native crypto import via require (NodeJS)
        if (!crypto && true) try {
            crypto = (parcelRequire("1wVs5"));
        } catch (err) {}
        /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */ var cryptoSecureRandomInt = function() {
            if (crypto) {
                // Use getRandomValues method (Browser)
                if (typeof crypto.getRandomValues === "function") try {
                    return crypto.getRandomValues(new Uint32Array(1))[0];
                } catch (err) {}
                // Use randomBytes method (NodeJS)
                if (typeof crypto.randomBytes === "function") try {
                    return crypto.randomBytes(4).readInt32LE();
                } catch (err) {}
            }
            throw new Error("Native crypto module could not be used to get secure random number.");
        };
        /*
	     * Local polyfill of Object.create

	     */ var create = Object.create || function() {
            function F() {}
            return function(obj) {
                var subtype;
                F.prototype = obj;
                subtype = new F();
                F.prototype = null;
                return subtype;
            };
        }();
        /**
	     * CryptoJS namespace.
	     */ var C = {};
        /**
	     * Library namespace.
	     */ var C_lib = C.lib = {};
        /**
	     * Base object for prototypal inheritance.
	     */ var Base = C_lib.Base = function() {
            return {
                /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */ extend: function(overrides) {
                    // Spawn
                    var subtype = create(this);
                    // Augment
                    if (overrides) subtype.mixIn(overrides);
                    // Create default initializer
                    if (!subtype.hasOwnProperty("init") || this.init === subtype.init) subtype.init = function() {
                        subtype.$super.init.apply(this, arguments);
                    };
                    // Initializer's prototype is the subtype object
                    subtype.init.prototype = subtype;
                    // Reference supertype
                    subtype.$super = this;
                    return subtype;
                },
                /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */ create: function() {
                    var instance = this.extend();
                    instance.init.apply(instance, arguments);
                    return instance;
                },
                /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */ init: function() {},
                /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */ mixIn: function(properties) {
                    for(var propertyName in properties)if (properties.hasOwnProperty(propertyName)) this[propertyName] = properties[propertyName];
                    // IE won't copy toString using the loop above
                    if (properties.hasOwnProperty("toString")) this.toString = properties.toString;
                },
                /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */ clone: function() {
                    return this.init.prototype.extend(this);
                }
            };
        }();
        /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var WordArray = C_lib.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 4;
            },
            /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */ toString: function(encoder) {
                return (encoder || Hex).stringify(this);
            },
            /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */ concat: function(wordArray) {
                // Shortcuts
                var thisWords = this.words;
                var thatWords = wordArray.words;
                var thisSigBytes = this.sigBytes;
                var thatSigBytes = wordArray.sigBytes;
                // Clamp excess bits
                this.clamp();
                // Concat
                if (thisSigBytes % 4) // Copy one byte at a time
                for(var i = 0; i < thatSigBytes; i++){
                    var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
                }
                else // Copy one word at a time
                for(var j = 0; j < thatSigBytes; j += 4)thisWords[thisSigBytes + j >>> 2] = thatWords[j >>> 2];
                this.sigBytes += thatSigBytes;
                // Chainable
                return this;
            },
            /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */ clamp: function() {
                // Shortcuts
                var words = this.words;
                var sigBytes = this.sigBytes;
                // Clamp
                words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
                words.length = Math1.ceil(sigBytes / 4);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone.words = this.words.slice(0);
                return clone;
            },
            /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */ random: function(nBytes) {
                var words = [];
                for(var i = 0; i < nBytes; i += 4)words.push(cryptoSecureRandomInt());
                return new WordArray.init(words, nBytes);
            }
        });
        /**
	     * Encoder namespace.
	     */ var C_enc = C.enc = {};
        /**
	     * Hex encoding strategy.
	     */ var Hex = C_enc.Hex = {
            /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var hexChars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    hexChars.push((bite >>> 4).toString(16));
                    hexChars.push((bite & 0x0f).toString(16));
                }
                return hexChars.join("");
            },
            /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */ parse: function(hexStr) {
                // Shortcut
                var hexStrLength = hexStr.length;
                // Convert
                var words = [];
                for(var i = 0; i < hexStrLength; i += 2)words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
                return new WordArray.init(words, hexStrLength / 2);
            }
        };
        /**
	     * Latin1 encoding strategy.
	     */ var Latin1 = C_enc.Latin1 = {
            /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var latin1Chars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    latin1Chars.push(String.fromCharCode(bite));
                }
                return latin1Chars.join("");
            },
            /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */ parse: function(latin1Str) {
                // Shortcut
                var latin1StrLength = latin1Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < latin1StrLength; i++)words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
                return new WordArray.init(words, latin1StrLength);
            }
        };
        /**
	     * UTF-8 encoding strategy.
	     */ var Utf8 = C_enc.Utf8 = {
            /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */ stringify: function(wordArray) {
                try {
                    return decodeURIComponent(escape(Latin1.stringify(wordArray)));
                } catch (e) {
                    throw new Error("Malformed UTF-8 data");
                }
            },
            /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */ parse: function(utf8Str) {
                return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
            }
        };
        /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */ var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
            /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */ reset: function() {
                // Initial values
                this._data = new WordArray.init();
                this._nDataBytes = 0;
            },
            /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */ _append: function(data) {
                // Convert string to WordArray, else assume WordArray already
                if (typeof data == "string") data = Utf8.parse(data);
                // Append
                this._data.concat(data);
                this._nDataBytes += data.sigBytes;
            },
            /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */ _process: function(doFlush) {
                var processedWords;
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var dataSigBytes = data.sigBytes;
                var blockSize = this.blockSize;
                var blockSizeBytes = blockSize * 4;
                // Count blocks ready
                var nBlocksReady = dataSigBytes / blockSizeBytes;
                if (doFlush) // Round up to include partial blocks
                nBlocksReady = Math1.ceil(nBlocksReady);
                else // Round down to include only full blocks,
                // less the number of blocks that must remain in the buffer
                nBlocksReady = Math1.max((nBlocksReady | 0) - this._minBufferSize, 0);
                // Count words ready
                var nWordsReady = nBlocksReady * blockSize;
                // Count bytes ready
                var nBytesReady = Math1.min(nWordsReady * 4, dataSigBytes);
                // Process blocks
                if (nWordsReady) {
                    for(var offset = 0; offset < nWordsReady; offset += blockSize)// Perform concrete-algorithm logic
                    this._doProcessBlock(dataWords, offset);
                    // Remove processed words
                    processedWords = dataWords.splice(0, nWordsReady);
                    data.sigBytes -= nBytesReady;
                }
                // Return processed words
                return new WordArray.init(processedWords, nBytesReady);
            },
            /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone._data = this._data.clone();
                return clone;
            },
            _minBufferSize: 0
        });
        /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */ var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         */ cfg: Base.extend(),
            /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */ init: function(cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-hasher logic
                this._doReset();
            },
            /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */ update: function(messageUpdate) {
                // Append
                this._append(messageUpdate);
                // Update the hash
                this._process();
                // Chainable
                return this;
            },
            /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Final message update
                if (messageUpdate) this._append(messageUpdate);
                // Perform concrete-hasher logic
                var hash = this._doFinalize();
                return hash;
            },
            blockSize: 16,
            /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */ _createHelper: function(hasher) {
                return function(message, cfg) {
                    return new hasher.init(cfg).finalize(message);
                };
            },
            /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */ _createHmacHelper: function(hasher) {
                return function(message, key) {
                    return new C_algo.HMAC.init(hasher, key).finalize(message);
                };
            }
        });
        /**
	     * Algorithm namespace.
	     */ var C_algo = C.algo = {};
        return C;
    }(Math);
    return CryptoJS;
});

});
parcelRequire.register("1wVs5", function(module, exports) {
"use strict";

});


parcelRequire.register("fLcAH", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3VShD")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64 encoding strategy.
	     */ var Base64 = C_enc.Base64 = {
            /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join("");
            },
            /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */ parse: function(base64Str) {
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64;
});

});

parcelRequire.register("jxlMi", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3VShD")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Constants table
        var T = [];
        // Compute constants
        (function() {
            for(var i = 0; i < 64; i++)T[i] = Math1.abs(Math1.sin(i + 1)) * 0x100000000 | 0;
        })();
        /**
	     * MD5 hash algorithm.
	     */ var MD5 = C_algo.MD5 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0x67452301,
                    0xefcdab89,
                    0x98badcfe,
                    0x10325476
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Swap endian
                for(var i = 0; i < 16; i++){
                    // Shortcuts
                    var offset_i = offset + i;
                    var M_offset_i = M[offset_i];
                    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                }
                // Shortcuts
                var H = this._hash.words;
                var M_offset_0 = M[offset + 0];
                var M_offset_1 = M[offset + 1];
                var M_offset_2 = M[offset + 2];
                var M_offset_3 = M[offset + 3];
                var M_offset_4 = M[offset + 4];
                var M_offset_5 = M[offset + 5];
                var M_offset_6 = M[offset + 6];
                var M_offset_7 = M[offset + 7];
                var M_offset_8 = M[offset + 8];
                var M_offset_9 = M[offset + 9];
                var M_offset_10 = M[offset + 10];
                var M_offset_11 = M[offset + 11];
                var M_offset_12 = M[offset + 12];
                var M_offset_13 = M[offset + 13];
                var M_offset_14 = M[offset + 14];
                var M_offset_15 = M[offset + 15];
                // Working varialbes
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                // Computation
                a = FF(a, b, c, d, M_offset_0, 7, T[0]);
                d = FF(d, a, b, c, M_offset_1, 12, T[1]);
                c = FF(c, d, a, b, M_offset_2, 17, T[2]);
                b = FF(b, c, d, a, M_offset_3, 22, T[3]);
                a = FF(a, b, c, d, M_offset_4, 7, T[4]);
                d = FF(d, a, b, c, M_offset_5, 12, T[5]);
                c = FF(c, d, a, b, M_offset_6, 17, T[6]);
                b = FF(b, c, d, a, M_offset_7, 22, T[7]);
                a = FF(a, b, c, d, M_offset_8, 7, T[8]);
                d = FF(d, a, b, c, M_offset_9, 12, T[9]);
                c = FF(c, d, a, b, M_offset_10, 17, T[10]);
                b = FF(b, c, d, a, M_offset_11, 22, T[11]);
                a = FF(a, b, c, d, M_offset_12, 7, T[12]);
                d = FF(d, a, b, c, M_offset_13, 12, T[13]);
                c = FF(c, d, a, b, M_offset_14, 17, T[14]);
                b = FF(b, c, d, a, M_offset_15, 22, T[15]);
                a = GG(a, b, c, d, M_offset_1, 5, T[16]);
                d = GG(d, a, b, c, M_offset_6, 9, T[17]);
                c = GG(c, d, a, b, M_offset_11, 14, T[18]);
                b = GG(b, c, d, a, M_offset_0, 20, T[19]);
                a = GG(a, b, c, d, M_offset_5, 5, T[20]);
                d = GG(d, a, b, c, M_offset_10, 9, T[21]);
                c = GG(c, d, a, b, M_offset_15, 14, T[22]);
                b = GG(b, c, d, a, M_offset_4, 20, T[23]);
                a = GG(a, b, c, d, M_offset_9, 5, T[24]);
                d = GG(d, a, b, c, M_offset_14, 9, T[25]);
                c = GG(c, d, a, b, M_offset_3, 14, T[26]);
                b = GG(b, c, d, a, M_offset_8, 20, T[27]);
                a = GG(a, b, c, d, M_offset_13, 5, T[28]);
                d = GG(d, a, b, c, M_offset_2, 9, T[29]);
                c = GG(c, d, a, b, M_offset_7, 14, T[30]);
                b = GG(b, c, d, a, M_offset_12, 20, T[31]);
                a = HH(a, b, c, d, M_offset_5, 4, T[32]);
                d = HH(d, a, b, c, M_offset_8, 11, T[33]);
                c = HH(c, d, a, b, M_offset_11, 16, T[34]);
                b = HH(b, c, d, a, M_offset_14, 23, T[35]);
                a = HH(a, b, c, d, M_offset_1, 4, T[36]);
                d = HH(d, a, b, c, M_offset_4, 11, T[37]);
                c = HH(c, d, a, b, M_offset_7, 16, T[38]);
                b = HH(b, c, d, a, M_offset_10, 23, T[39]);
                a = HH(a, b, c, d, M_offset_13, 4, T[40]);
                d = HH(d, a, b, c, M_offset_0, 11, T[41]);
                c = HH(c, d, a, b, M_offset_3, 16, T[42]);
                b = HH(b, c, d, a, M_offset_6, 23, T[43]);
                a = HH(a, b, c, d, M_offset_9, 4, T[44]);
                d = HH(d, a, b, c, M_offset_12, 11, T[45]);
                c = HH(c, d, a, b, M_offset_15, 16, T[46]);
                b = HH(b, c, d, a, M_offset_2, 23, T[47]);
                a = II(a, b, c, d, M_offset_0, 6, T[48]);
                d = II(d, a, b, c, M_offset_7, 10, T[49]);
                c = II(c, d, a, b, M_offset_14, 15, T[50]);
                b = II(b, c, d, a, M_offset_5, 21, T[51]);
                a = II(a, b, c, d, M_offset_12, 6, T[52]);
                d = II(d, a, b, c, M_offset_3, 10, T[53]);
                c = II(c, d, a, b, M_offset_10, 15, T[54]);
                b = II(b, c, d, a, M_offset_1, 21, T[55]);
                a = II(a, b, c, d, M_offset_8, 6, T[56]);
                d = II(d, a, b, c, M_offset_15, 10, T[57]);
                c = II(c, d, a, b, M_offset_6, 15, T[58]);
                b = II(b, c, d, a, M_offset_13, 21, T[59]);
                a = II(a, b, c, d, M_offset_4, 6, T[60]);
                d = II(d, a, b, c, M_offset_11, 10, T[61]);
                c = II(c, d, a, b, M_offset_2, 15, T[62]);
                b = II(b, c, d, a, M_offset_9, 21, T[63]);
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                var nBitsTotalH = Math1.floor(nBitsTotal / 0x100000000);
                var nBitsTotalL = nBitsTotal;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = (nBitsTotalH << 8 | nBitsTotalH >>> 24) & 0x00ff00ff | (nBitsTotalH << 24 | nBitsTotalH >>> 8) & 0xff00ff00;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotalL << 8 | nBitsTotalL >>> 24) & 0x00ff00ff | (nBitsTotalL << 24 | nBitsTotalL >>> 8) & 0xff00ff00;
                data.sigBytes = (dataWords.length + 1) * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var hash = this._hash;
                var H = hash.words;
                // Swap endian
                for(var i = 0; i < 4; i++){
                    // Shortcut
                    var H_i = H[i];
                    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                }
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        function FF(a, b, c, d, x, s, t) {
            var n = a + (b & c | ~b & d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function GG(a, b, c, d, x, s, t) {
            var n = a + (b & d | c & ~d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function HH(a, b, c, d, x, s, t) {
            var n = a + (b ^ c ^ d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function II(a, b, c, d, x, s, t) {
            var n = a + (c ^ (b | ~d)) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */ C.MD5 = Hasher._createHelper(MD5);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */ C.HmacMD5 = Hasher._createHmacHelper(MD5);
    })(Math);
    return CryptoJS.MD5;
});

});

parcelRequire.register("drK4C", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3VShD")), (parcelRequire("9lolz")), (parcelRequire("fa8iZ")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var MD5 = C_algo.MD5;
        /**
	     * This key derivation function is meant to conform with EVP_BytesToKey.
	     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
	     */ var EvpKDF = C_algo.EvpKDF = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */ cfg: Base.extend({
                keySize: 4,
                hasher: MD5,
                iterations: 1
            }),
            /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.EvpKDF.create();
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
	         */ init: function(cfg) {
                this.cfg = this.cfg.extend(cfg);
            },
            /**
	         * Derives a key from a password.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */ compute: function(password, salt) {
                var block;
                // Shortcut
                var cfg = this.cfg;
                // Init hasher
                var hasher = cfg.hasher.create();
                // Initial values
                var derivedKey = WordArray.create();
                // Shortcuts
                var derivedKeyWords = derivedKey.words;
                var keySize = cfg.keySize;
                var iterations = cfg.iterations;
                // Generate key
                while(derivedKeyWords.length < keySize){
                    if (block) hasher.update(block);
                    block = hasher.update(password).finalize(salt);
                    hasher.reset();
                    // Iterations
                    for(var i = 1; i < iterations; i++){
                        block = hasher.finalize(block);
                        hasher.reset();
                    }
                    derivedKey.concat(block);
                }
                derivedKey.sigBytes = keySize * 4;
                return derivedKey;
            }
        });
        /**
	     * Derives a key from a password.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.EvpKDF(password, salt);
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
	     */ C.EvpKDF = function(password, salt, cfg) {
            return EvpKDF.create(cfg).compute(password, salt);
        };
    })();
    return CryptoJS.EvpKDF;
});

});
parcelRequire.register("9lolz", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3VShD")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Reusable object
        var W = [];
        /**
	     * SHA-1 hash algorithm.
	     */ var SHA1 = C_algo.SHA1 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0x67452301,
                    0xefcdab89,
                    0x98badcfe,
                    0x10325476,
                    0xc3d2e1f0
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                // Computation
                for(var i = 0; i < 80; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
                        W[i] = n << 1 | n >>> 31;
                    }
                    var t = (a << 5 | a >>> 27) + e + W[i];
                    if (i < 20) t += (b & c | ~b & d) + 0x5a827999;
                    else if (i < 40) t += (b ^ c ^ d) + 0x6ed9eba1;
                    else if (i < 60) t += (b & c | b & d | c & d) - 0x70e44324;
                    else t += (b ^ c ^ d) - 0x359d3e2a;
                    e = d;
                    d = c;
                    c = b << 30 | b >>> 2;
                    b = a;
                    a = t;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */ C.SHA1 = Hasher._createHelper(SHA1);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */ C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
    })();
    return CryptoJS.SHA1;
});

});

parcelRequire.register("fa8iZ", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3VShD")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var C_algo = C.algo;
        /**
	     * HMAC algorithm.
	     */ var HMAC = C_algo.HMAC = Base.extend({
            /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */ init: function(hasher, key) {
                // Init hasher
                hasher = this._hasher = new hasher.init();
                // Convert string to WordArray, else assume WordArray already
                if (typeof key == "string") key = Utf8.parse(key);
                // Shortcuts
                var hasherBlockSize = hasher.blockSize;
                var hasherBlockSizeBytes = hasherBlockSize * 4;
                // Allow arbitrary length keys
                if (key.sigBytes > hasherBlockSizeBytes) key = hasher.finalize(key);
                // Clamp excess bits
                key.clamp();
                // Clone key for inner and outer pads
                var oKey = this._oKey = key.clone();
                var iKey = this._iKey = key.clone();
                // Shortcuts
                var oKeyWords = oKey.words;
                var iKeyWords = iKey.words;
                // XOR keys with pad constants
                for(var i = 0; i < hasherBlockSize; i++){
                    oKeyWords[i] ^= 0x5c5c5c5c;
                    iKeyWords[i] ^= 0x36363636;
                }
                oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */ reset: function() {
                // Shortcut
                var hasher = this._hasher;
                // Reset
                hasher.reset();
                hasher.update(this._iKey);
            },
            /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */ update: function(messageUpdate) {
                this._hasher.update(messageUpdate);
                // Chainable
                return this;
            },
            /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Shortcut
                var hasher = this._hasher;
                // Compute HMAC
                var innerHash = hasher.finalize(messageUpdate);
                hasher.reset();
                var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
                return hmac;
            }
        });
    })();
});

});


parcelRequire.register("fUsrA", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3VShD")), (parcelRequire("drK4C")));
})(this, function(CryptoJS) {
    /**
	 * Cipher core components.
	 */ CryptoJS.lib.Cipher || function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var Base64 = C_enc.Base64;
        var C_algo = C.algo;
        var EvpKDF = C_algo.EvpKDF;
        /**
	     * Abstract base cipher template.
	     *
	     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
	     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
	     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
	     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
	     */ var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         *
	         * @property {WordArray} iv The IV to use for this operation.
	         */ cfg: Base.extend(),
            /**
	         * Creates this cipher in encryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
	         */ createEncryptor: function(key, cfg) {
                return this.create(this._ENC_XFORM_MODE, key, cfg);
            },
            /**
	         * Creates this cipher in decryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
	         */ createDecryptor: function(key, cfg) {
                return this.create(this._DEC_XFORM_MODE, key, cfg);
            },
            /**
	         * Initializes a newly created cipher.
	         *
	         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
	         */ init: function(xformMode, key, cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Store transform mode and key
                this._xformMode = xformMode;
                this._key = key;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this cipher to its initial state.
	         *
	         * @example
	         *
	         *     cipher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-cipher logic
                this._doReset();
            },
            /**
	         * Adds data to be encrypted or decrypted.
	         *
	         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.process('data');
	         *     var encrypted = cipher.process(wordArray);
	         */ process: function(dataUpdate) {
                // Append
                this._append(dataUpdate);
                // Process available blocks
                return this._process();
            },
            /**
	         * Finalizes the encryption or decryption process.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after final processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.finalize();
	         *     var encrypted = cipher.finalize('data');
	         *     var encrypted = cipher.finalize(wordArray);
	         */ finalize: function(dataUpdate) {
                // Final data update
                if (dataUpdate) this._append(dataUpdate);
                // Perform concrete-cipher logic
                var finalProcessedData = this._doFinalize();
                return finalProcessedData;
            },
            keySize: 4,
            ivSize: 4,
            _ENC_XFORM_MODE: 1,
            _DEC_XFORM_MODE: 2,
            /**
	         * Creates shortcut functions to a cipher's object interface.
	         *
	         * @param {Cipher} cipher The cipher to create a helper for.
	         *
	         * @return {Object} An object with encrypt and decrypt shortcut functions.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
	         */ _createHelper: function() {
                function selectCipherStrategy(key) {
                    if (typeof key == "string") return PasswordBasedCipher;
                    else return SerializableCipher;
                }
                return function(cipher) {
                    return {
                        encrypt: function(message, key, cfg) {
                            return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
                        },
                        decrypt: function(ciphertext, key, cfg) {
                            return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
                        }
                    };
                };
            }()
        });
        /**
	     * Abstract base stream cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
	     */ var StreamCipher = C_lib.StreamCipher = Cipher.extend({
            _doFinalize: function() {
                // Process partial blocks
                var finalProcessedBlocks = this._process(true);
                return finalProcessedBlocks;
            },
            blockSize: 1
        });
        /**
	     * Mode namespace.
	     */ var C_mode = C.mode = {};
        /**
	     * Abstract base block cipher mode template.
	     */ var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
            /**
	         * Creates this mode for encryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
	         */ createEncryptor: function(cipher, iv) {
                return this.Encryptor.create(cipher, iv);
            },
            /**
	         * Creates this mode for decryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
	         */ createDecryptor: function(cipher, iv) {
                return this.Decryptor.create(cipher, iv);
            },
            /**
	         * Initializes a newly created mode.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
	         */ init: function(cipher, iv) {
                this._cipher = cipher;
                this._iv = iv;
            }
        });
        /**
	     * Cipher Block Chaining mode.
	     */ var CBC = C_mode.CBC = function() {
            /**
	         * Abstract base CBC mode.
	         */ var CBC = BlockCipherMode.extend();
            /**
	         * CBC encryptor.
	         */ CBC.Encryptor = CBC.extend({
                /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */ processBlock: function(words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
                    // XOR and encrypt
                    xorBlock.call(this, words, offset, blockSize);
                    cipher.encryptBlock(words, offset);
                    // Remember this block to use with next block
                    this._prevBlock = words.slice(offset, offset + blockSize);
                }
            });
            /**
	         * CBC decryptor.
	         */ CBC.Decryptor = CBC.extend({
                /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */ processBlock: function(words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
                    // Remember this block to use with next block
                    var thisBlock = words.slice(offset, offset + blockSize);
                    // Decrypt and XOR
                    cipher.decryptBlock(words, offset);
                    xorBlock.call(this, words, offset, blockSize);
                    // This block becomes the previous block
                    this._prevBlock = thisBlock;
                }
            });
            function xorBlock(words, offset, blockSize) {
                var block;
                // Shortcut
                var iv = this._iv;
                // Choose mixing block
                if (iv) {
                    block = iv;
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                } else block = this._prevBlock;
                // XOR blocks
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= block[i];
            }
            return CBC;
        }();
        /**
	     * Padding namespace.
	     */ var C_pad = C.pad = {};
        /**
	     * PKCS #5/7 padding strategy.
	     */ var Pkcs7 = C_pad.Pkcs7 = {
            /**
	         * Pads data using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to pad.
	         * @param {number} blockSize The multiple that the data should be padded to.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
	         */ pad: function(data, blockSize) {
                // Shortcut
                var blockSizeBytes = blockSize * 4;
                // Count padding bytes
                var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
                // Create padding word
                var paddingWord = nPaddingBytes << 24 | nPaddingBytes << 16 | nPaddingBytes << 8 | nPaddingBytes;
                // Create padding
                var paddingWords = [];
                for(var i = 0; i < nPaddingBytes; i += 4)paddingWords.push(paddingWord);
                var padding = WordArray.create(paddingWords, nPaddingBytes);
                // Add padding
                data.concat(padding);
            },
            /**
	         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to unpad.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
	         */ unpad: function(data) {
                // Get number of padding bytes from last byte
                var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
                // Remove padding
                data.sigBytes -= nPaddingBytes;
            }
        };
        /**
	     * Abstract base block cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
	     */ var BlockCipher = C_lib.BlockCipher = Cipher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {Mode} mode The block mode to use. Default: CBC
	         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
	         */ cfg: Cipher.cfg.extend({
                mode: CBC,
                padding: Pkcs7
            }),
            reset: function() {
                var modeCreator;
                // Reset cipher
                Cipher.reset.call(this);
                // Shortcuts
                var cfg = this.cfg;
                var iv = cfg.iv;
                var mode = cfg.mode;
                // Reset block mode
                if (this._xformMode == this._ENC_XFORM_MODE) modeCreator = mode.createEncryptor;
                else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                    modeCreator = mode.createDecryptor;
                    // Keep at least one block in the buffer for unpadding
                    this._minBufferSize = 1;
                }
                if (this._mode && this._mode.__creator == modeCreator) this._mode.init(this, iv && iv.words);
                else {
                    this._mode = modeCreator.call(mode, this, iv && iv.words);
                    this._mode.__creator = modeCreator;
                }
            },
            _doProcessBlock: function(words, offset) {
                this._mode.processBlock(words, offset);
            },
            _doFinalize: function() {
                var finalProcessedBlocks;
                // Shortcut
                var padding = this.cfg.padding;
                // Finalize
                if (this._xformMode == this._ENC_XFORM_MODE) {
                    // Pad data
                    padding.pad(this._data, this.blockSize);
                    // Process final blocks
                    finalProcessedBlocks = this._process(true);
                } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                    // Process final blocks
                    finalProcessedBlocks = this._process(true);
                    // Unpad data
                    padding.unpad(finalProcessedBlocks);
                }
                return finalProcessedBlocks;
            },
            blockSize: 4
        });
        /**
	     * A collection of cipher parameters.
	     *
	     * @property {WordArray} ciphertext The raw ciphertext.
	     * @property {WordArray} key The key to this ciphertext.
	     * @property {WordArray} iv The IV used in the ciphering operation.
	     * @property {WordArray} salt The salt used with a key derivation function.
	     * @property {Cipher} algorithm The cipher algorithm.
	     * @property {Mode} mode The block mode used in the ciphering operation.
	     * @property {Padding} padding The padding scheme used in the ciphering operation.
	     * @property {number} blockSize The block size of the cipher.
	     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
	     */ var CipherParams = C_lib.CipherParams = Base.extend({
            /**
	         * Initializes a newly created cipher params object.
	         *
	         * @param {Object} cipherParams An object with any of the possible cipher parameters.
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.lib.CipherParams.create({
	         *         ciphertext: ciphertextWordArray,
	         *         key: keyWordArray,
	         *         iv: ivWordArray,
	         *         salt: saltWordArray,
	         *         algorithm: CryptoJS.algo.AES,
	         *         mode: CryptoJS.mode.CBC,
	         *         padding: CryptoJS.pad.PKCS7,
	         *         blockSize: 4,
	         *         formatter: CryptoJS.format.OpenSSL
	         *     });
	         */ init: function(cipherParams) {
                this.mixIn(cipherParams);
            },
            /**
	         * Converts this cipher params object to a string.
	         *
	         * @param {Format} formatter (Optional) The formatting strategy to use.
	         *
	         * @return {string} The stringified cipher params.
	         *
	         * @throws Error If neither the formatter nor the default formatter is set.
	         *
	         * @example
	         *
	         *     var string = cipherParams + '';
	         *     var string = cipherParams.toString();
	         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
	         */ toString: function(formatter) {
                return (formatter || this.formatter).stringify(this);
            }
        });
        /**
	     * Format namespace.
	     */ var C_format = C.format = {};
        /**
	     * OpenSSL formatting strategy.
	     */ var OpenSSLFormatter = C_format.OpenSSL = {
            /**
	         * Converts a cipher params object to an OpenSSL-compatible string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The OpenSSL-compatible string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
	         */ stringify: function(cipherParams) {
                var wordArray;
                // Shortcuts
                var ciphertext = cipherParams.ciphertext;
                var salt = cipherParams.salt;
                // Format
                if (salt) wordArray = WordArray.create([
                    0x53616c74,
                    0x65645f5f
                ]).concat(salt).concat(ciphertext);
                else wordArray = ciphertext;
                return wordArray.toString(Base64);
            },
            /**
	         * Converts an OpenSSL-compatible string to a cipher params object.
	         *
	         * @param {string} openSSLStr The OpenSSL-compatible string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
	         */ parse: function(openSSLStr) {
                var salt;
                // Parse base64
                var ciphertext = Base64.parse(openSSLStr);
                // Shortcut
                var ciphertextWords = ciphertext.words;
                // Test for salt
                if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
                    // Extract salt
                    salt = WordArray.create(ciphertextWords.slice(2, 4));
                    // Remove salt from ciphertext
                    ciphertextWords.splice(0, 4);
                    ciphertext.sigBytes -= 16;
                }
                return CipherParams.create({
                    ciphertext: ciphertext,
                    salt: salt
                });
            }
        };
        /**
	     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
	     */ var SerializableCipher = C_lib.SerializableCipher = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
	         */ cfg: Base.extend({
                format: OpenSSLFormatter
            }),
            /**
	         * Encrypts a message.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */ encrypt: function(cipher, message, key, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Encrypt
                var encryptor = cipher.createEncryptor(key, cfg);
                var ciphertext = encryptor.finalize(message);
                // Shortcut
                var cipherCfg = encryptor.cfg;
                // Create and return serializable cipher params
                return CipherParams.create({
                    ciphertext: ciphertext,
                    key: key,
                    iv: cipherCfg.iv,
                    algorithm: cipher,
                    mode: cipherCfg.mode,
                    padding: cipherCfg.padding,
                    blockSize: cipher.blockSize,
                    formatter: cfg.format
                });
            },
            /**
	         * Decrypts serialized ciphertext.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */ decrypt: function(cipher, ciphertext, key, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Convert string to CipherParams
                ciphertext = this._parse(ciphertext, cfg.format);
                // Decrypt
                var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);
                return plaintext;
            },
            /**
	         * Converts serialized ciphertext to CipherParams,
	         * else assumed CipherParams already and returns ciphertext unchanged.
	         *
	         * @param {CipherParams|string} ciphertext The ciphertext.
	         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
	         *
	         * @return {CipherParams} The unserialized ciphertext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
	         */ _parse: function(ciphertext, format) {
                if (typeof ciphertext == "string") return format.parse(ciphertext, this);
                else return ciphertext;
            }
        });
        /**
	     * Key derivation function namespace.
	     */ var C_kdf = C.kdf = {};
        /**
	     * OpenSSL key derivation function.
	     */ var OpenSSLKdf = C_kdf.OpenSSL = {
            /**
	         * Derives a key and IV from a password.
	         *
	         * @param {string} password The password to derive from.
	         * @param {number} keySize The size in words of the key to generate.
	         * @param {number} ivSize The size in words of the IV to generate.
	         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
	         *
	         * @return {CipherParams} A cipher params object with the key, IV, and salt.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
	         */ execute: function(password, keySize, ivSize, salt) {
                // Generate random salt
                if (!salt) salt = WordArray.random(8);
                // Derive key and IV
                var key = EvpKDF.create({
                    keySize: keySize + ivSize
                }).compute(password, salt);
                // Separate key and IV
                var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
                key.sigBytes = keySize * 4;
                // Return params
                return CipherParams.create({
                    key: key,
                    iv: iv,
                    salt: salt
                });
            }
        };
        /**
	     * A serializable cipher wrapper that derives the key from a password,
	     * and returns ciphertext as a serializable cipher params object.
	     */ var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
	         */ cfg: SerializableCipher.cfg.extend({
                kdf: OpenSSLKdf
            }),
            /**
	         * Encrypts a message using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
	         */ encrypt: function(cipher, message, password, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Derive key and other params
                var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize);
                // Add IV to config
                cfg.iv = derivedParams.iv;
                // Encrypt
                var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);
                // Mix in derived params
                ciphertext.mixIn(derivedParams);
                return ciphertext;
            },
            /**
	         * Decrypts serialized ciphertext using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
	         */ decrypt: function(cipher, ciphertext, password, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Convert string to CipherParams
                ciphertext = this._parse(ciphertext, cfg.format);
                // Derive key and other params
                var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt);
                // Add IV to config
                cfg.iv = derivedParams.iv;
                // Decrypt
                var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);
                return plaintext;
            }
        });
    }();
});

});


parcelRequire.register("gBi6S", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3VShD")));
})(this, function(CryptoJS) {
    return CryptoJS.enc.Utf8;
});

});


parcelRequire.register("eqNh5", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $a819b7536bb83691$var$_promise = $3Npdz((parcelRequire("bCWDe")));

var $a819b7536bb83691$var$_Storage = $3Npdz((parcelRequire("7Zbj0")));

var $JZta3 = parcelRequire("JZta3");
var $a819b7536bb83691$var$iidCache = null;
var $a819b7536bb83691$var$InstallationController = {
    currentInstallationId: function() /*: Promise<string>*/ {
        if (typeof $a819b7536bb83691$var$iidCache === "string") return $a819b7536bb83691$var$_promise.default.resolve($a819b7536bb83691$var$iidCache);
        var path = $a819b7536bb83691$var$_Storage.default.generatePath("installationId");
        return $a819b7536bb83691$var$_Storage.default.getItemAsync(path).then(function(iid) {
            if (!iid) {
                iid = $JZta3();
                return $a819b7536bb83691$var$_Storage.default.setItemAsync(path, iid).then(function() {
                    $a819b7536bb83691$var$iidCache = iid;
                    return iid;
                });
            }
            $a819b7536bb83691$var$iidCache = iid;
            return iid;
        });
    },
    _clearCache: function() {
        $a819b7536bb83691$var$iidCache = null;
    },
    _setInstallationIdCache: function(iid) {
        $a819b7536bb83691$var$iidCache = iid;
    }
};
module.exports = $a819b7536bb83691$var$InstallationController;

});

parcelRequire.register("hBLOK", function(module, exports) {

var $6qd2L = parcelRequire("6qd2L");
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $evY07 = parcelRequire("evY07");

var $8jMtB = parcelRequire("8jMtB");

var $1nHJN = parcelRequire("1nHJN");

var $jZGC2 = parcelRequire("jZGC2");

var $1o4IC = parcelRequire("1o4IC");

var $kYm0J = parcelRequire("kYm0J");

var $d3A5d = parcelRequire("d3A5d");

var $r9mpE = parcelRequire("r9mpE");

var $cd1afbe83544868d$var$_defineProperty2 = $3Npdz((parcelRequire("bci6G")));

var $cd1afbe83544868d$var$_typeof2 = $3Npdz((parcelRequire("akViX")));

var $cd1afbe83544868d$var$_setTimeout2 = $3Npdz((parcelRequire("i3aqT")));

var $cd1afbe83544868d$var$_includes = $3Npdz((parcelRequire("aUw0k")));

var $cd1afbe83544868d$var$_stringify = $3Npdz((parcelRequire("O2sNs")));

var $cd1afbe83544868d$var$_promise = $3Npdz((parcelRequire("bCWDe")));

var $cd1afbe83544868d$var$_CoreManager = $3Npdz((parcelRequire("465CW")));

var $cd1afbe83544868d$var$_ParseError = $3Npdz((parcelRequire("3HQSG")));

var $j0i6P = parcelRequire("j0i6P");
function $cd1afbe83544868d$var$ownKeys(object, enumerableOnly) {
    var keys = $r9mpE(object);
    if ($d3A5d) {
        var symbols = $d3A5d(object);
        enumerableOnly && (symbols = $kYm0J(symbols).call(symbols, function(sym) {
            return $1o4IC(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $cd1afbe83544868d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var _context4, _context5;
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $jZGC2(_context4 = $cd1afbe83544868d$var$ownKeys(Object(source), !0)).call(_context4, function(key) {
            (0, $cd1afbe83544868d$var$_defineProperty2.default)(target, key, source[key]);
        }) : $1nHJN ? $8jMtB(target, $1nHJN(source)) : $jZGC2(_context5 = $cd1afbe83544868d$var$ownKeys(Object(source))).call(_context5, function(key) {
            $evY07(target, key, $1o4IC(source, key));
        });
    }
    return target;
}

var $JZta3 = parcelRequire("JZta3");
var $cd1afbe83544868d$var$XHR = null;
if (typeof XMLHttpRequest !== "undefined") $cd1afbe83544868d$var$XHR = XMLHttpRequest;
var $cd1afbe83544868d$var$useXDomainRequest = false;
if (typeof XDomainRequest !== "undefined" && !("withCredentials" in new XMLHttpRequest())) $cd1afbe83544868d$var$useXDomainRequest = true;
function $cd1afbe83544868d$var$ajaxIE9(method, url, data, headers, options) {
    return new $cd1afbe83544868d$var$_promise.default(function(resolve, reject) {
        var xdr = new XDomainRequest();
        xdr.onload = function() {
            var response;
            try {
                response = JSON.parse(xdr.responseText);
            } catch (e) {
                reject(e);
            }
            if (response) resolve({
                response: response
            });
        };
        xdr.onerror = xdr.ontimeout = function() {
            // Let's fake a real error message.
            var fakeResponse = {
                responseText: (0, $cd1afbe83544868d$var$_stringify.default)({
                    code: $cd1afbe83544868d$var$_ParseError.default.X_DOMAIN_REQUEST,
                    error: "IE's XDomainRequest does not supply error info."
                })
            };
            reject(fakeResponse);
        };
        xdr.onprogress = function() {
            if (options && typeof options.progress === "function") options.progress(xdr.responseText);
        };
        xdr.open(method, url);
        xdr.send(data);
        if (options && typeof options.requestTask === "function") options.requestTask(xdr);
    });
}
var $cd1afbe83544868d$var$RESTController = {
    ajax: function(method, url, data, headers, options) {
        var _context;
        if ($cd1afbe83544868d$var$useXDomainRequest) return $cd1afbe83544868d$var$ajaxIE9(method, url, data, headers, options);
        var promise = (0, $j0i6P.resolvingPromise)();
        var isIdempotent = $cd1afbe83544868d$var$_CoreManager.default.get("IDEMPOTENCY") && (0, $cd1afbe83544868d$var$_includes.default)(_context = [
            "POST",
            "PUT"
        ]).call(_context, method);
        var requestId = isIdempotent ? $JZta3() : "";
        var attempts = 0;
        (function dispatch() {
            if ($cd1afbe83544868d$var$XHR == null) throw new Error("Cannot make a request: No definition of XMLHttpRequest was found.");
            var handled = false;
            var xhr = new $cd1afbe83544868d$var$XHR();
            xhr.onreadystatechange = function() {
                if (xhr.readyState !== 4 || handled || xhr._aborted) return;
                handled = true;
                if (xhr.status >= 200 && xhr.status < 300) {
                    var response;
                    try {
                        response = JSON.parse(xhr.responseText);
                        if (typeof xhr.getResponseHeader === "function") {
                            var _context2, _context3;
                            if ((0, $cd1afbe83544868d$var$_includes.default)(_context2 = xhr.getAllResponseHeaders() || "").call(_context2, "x-parse-job-status-id: ")) response = xhr.getResponseHeader("x-parse-job-status-id");
                            if ((0, $cd1afbe83544868d$var$_includes.default)(_context3 = xhr.getAllResponseHeaders() || "").call(_context3, "x-parse-push-status-id: ")) response = xhr.getResponseHeader("x-parse-push-status-id");
                        }
                    } catch (e) {
                        promise.reject(e.toString());
                    }
                    if (response) promise.resolve({
                        response: response,
                        status: xhr.status,
                        xhr: xhr
                    });
                } else if (xhr.status >= 500 || xhr.status === 0) {
                    // retry on 5XX or node-xmlhttprequest error
                    if (++attempts < $cd1afbe83544868d$var$_CoreManager.default.get("REQUEST_ATTEMPT_LIMIT")) {
                        // Exponentially-growing random delay
                        var delay = Math.round(Math.random() * 125 * Math.pow(2, attempts));
                        (0, $cd1afbe83544868d$var$_setTimeout2.default)(dispatch, delay);
                    } else if (xhr.status === 0) promise.reject("Unable to connect to the Parse API");
                    else // After the retry limit is reached, fail
                    promise.reject(xhr);
                } else promise.reject(xhr);
            };
            headers = headers || {};
            if (typeof headers["Content-Type"] !== "string") headers["Content-Type"] = "text/plain"; // Avoid pre-flight
            if ($cd1afbe83544868d$var$_CoreManager.default.get("IS_NODE")) headers["User-Agent"] = "Parse/" + $cd1afbe83544868d$var$_CoreManager.default.get("VERSION") + " (NodeJS " + $6qd2L.versions.node + ")";
            if (isIdempotent) headers["X-Parse-Request-Id"] = requestId;
            if ($cd1afbe83544868d$var$_CoreManager.default.get("SERVER_AUTH_TYPE") && $cd1afbe83544868d$var$_CoreManager.default.get("SERVER_AUTH_TOKEN")) headers["Authorization"] = $cd1afbe83544868d$var$_CoreManager.default.get("SERVER_AUTH_TYPE") + " " + $cd1afbe83544868d$var$_CoreManager.default.get("SERVER_AUTH_TOKEN");
            var customHeaders = $cd1afbe83544868d$var$_CoreManager.default.get("REQUEST_HEADERS");
            for(var key in customHeaders)headers[key] = customHeaders[key];
            function handleProgress(type, event) {
                if (options && typeof options.progress === "function") {
                    if (event.lengthComputable) options.progress(event.loaded / event.total, event.loaded, event.total, {
                        type: type
                    });
                    else options.progress(null, null, null, {
                        type: type
                    });
                }
            }
            xhr.onprogress = function(event) {
                handleProgress("download", event);
            };
            if (xhr.upload) xhr.upload.onprogress = function(event) {
                handleProgress("upload", event);
            };
            xhr.open(method, url, true);
            for(var h in headers)xhr.setRequestHeader(h, headers[h]);
            xhr.onabort = function() {
                promise.resolve({
                    response: {
                        results: []
                    },
                    status: 0,
                    xhr: xhr
                });
            };
            xhr.send(data);
            if (options && typeof options.requestTask === "function") options.requestTask(xhr);
        })();
        return promise;
    },
    request: function request(method, path, data, options) {
        options = options || {};
        var url = $cd1afbe83544868d$var$_CoreManager.default.get("SERVER_URL");
        if (url[url.length - 1] !== "/") url += "/";
        url += path;
        var payload = {};
        if (data && (0, $cd1afbe83544868d$var$_typeof2.default)(data) === "object") for(var k in data)payload[k] = data[k];
         // Add context
        var context = options.context;
        if (context !== undefined) payload._context = context;
        if (method !== "POST") {
            payload._method = method;
            method = "POST";
        }
        payload._ApplicationId = $cd1afbe83544868d$var$_CoreManager.default.get("APPLICATION_ID");
        var jsKey = $cd1afbe83544868d$var$_CoreManager.default.get("JAVASCRIPT_KEY");
        if (jsKey) payload._JavaScriptKey = jsKey;
        payload._ClientVersion = $cd1afbe83544868d$var$_CoreManager.default.get("VERSION");
        var useMasterKey = options.useMasterKey;
        if (typeof useMasterKey === "undefined") useMasterKey = $cd1afbe83544868d$var$_CoreManager.default.get("USE_MASTER_KEY");
        if (useMasterKey) {
            if ($cd1afbe83544868d$var$_CoreManager.default.get("MASTER_KEY")) {
                delete payload._JavaScriptKey;
                payload._MasterKey = $cd1afbe83544868d$var$_CoreManager.default.get("MASTER_KEY");
            } else throw new Error("Cannot use the Master Key, it has not been provided.");
        }
        if ($cd1afbe83544868d$var$_CoreManager.default.get("FORCE_REVOCABLE_SESSION")) payload._RevocableSession = "1";
        var installationId = options.installationId;
        var installationIdPromise;
        if (installationId && typeof installationId === "string") installationIdPromise = $cd1afbe83544868d$var$_promise.default.resolve(installationId);
        else {
            var installationController = $cd1afbe83544868d$var$_CoreManager.default.getInstallationController();
            installationIdPromise = installationController.currentInstallationId();
        }
        return installationIdPromise.then(function(iid) {
            payload._InstallationId = iid;
            var userController = $cd1afbe83544868d$var$_CoreManager.default.getUserController();
            if (options && typeof options.sessionToken === "string") return $cd1afbe83544868d$var$_promise.default.resolve(options.sessionToken);
            else if (userController) return userController.currentUserAsync().then(function(user) {
                if (user) return $cd1afbe83544868d$var$_promise.default.resolve(user.getSessionToken());
                return $cd1afbe83544868d$var$_promise.default.resolve(null);
            });
            return $cd1afbe83544868d$var$_promise.default.resolve(null);
        }).then(function(token) {
            if (token) payload._SessionToken = token;
            var payloadString = (0, $cd1afbe83544868d$var$_stringify.default)(payload);
            return $cd1afbe83544868d$var$RESTController.ajax(method, url, payloadString, {}, options).then(function(_ref) {
                var response = _ref.response, status = _ref.status;
                if (options.returnStatus) return $cd1afbe83544868d$var$_objectSpread($cd1afbe83544868d$var$_objectSpread({}, response), {}, {
                    _status: status
                });
                else return response;
            });
        }).catch($cd1afbe83544868d$var$RESTController.handleError);
    },
    handleError: function handleError(response) {
        // Transform the error into an instance of ParseError by trying to parse
        // the error string as JSON
        var error;
        if (response && response.responseText) try {
            var errorJSON = JSON.parse(response.responseText);
            error = new $cd1afbe83544868d$var$_ParseError.default(errorJSON.code, errorJSON.error);
        } catch (e) {
            // If we fail to parse the error text, that's okay.
            error = new $cd1afbe83544868d$var$_ParseError.default($cd1afbe83544868d$var$_ParseError.default.INVALID_JSON, "Received an error with invalid JSON from Parse: " + response.responseText);
        }
        else {
            var message = response.message ? response.message : response;
            error = new $cd1afbe83544868d$var$_ParseError.default($cd1afbe83544868d$var$_ParseError.default.CONNECTION_FAILED, "XMLHttpRequest failed: " + (0, $cd1afbe83544868d$var$_stringify.default)(message));
        }
        return $cd1afbe83544868d$var$_promise.default.reject(error);
    },
    _setXHR: function _setXHR(xhr) {
        $cd1afbe83544868d$var$XHR = xhr;
    },
    _getXHR: function _getXHR() {
        return $cd1afbe83544868d$var$XHR;
    }
};
module.exports = $cd1afbe83544868d$var$RESTController;

});
parcelRequire.register("i3aqT", function(module, exports) {

module.exports = (parcelRequire("gS8hf"));

});
parcelRequire.register("gS8hf", function(module, exports) {
parcelRequire("2IATd");

var $envPC = parcelRequire("envPC");
module.exports = $envPC.setTimeout;

});



parcelRequire.register("i6I5N", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $evY07 = parcelRequire("evY07");
$evY07(module.exports, "__esModule", {
    value: true
});
module.exports.track = $d2eafd5e6cef8f6c$var$track;

var $d2eafd5e6cef8f6c$var$_CoreManager = $3Npdz((parcelRequire("465CW")));
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ /**
 * Parse.Analytics provides an interface to Parse's logging and analytics
 * backend.
 *
 * @class Parse.Analytics
 * @static
 * @hideconstructor
 */ /**
 * Tracks the occurrence of a custom event with additional dimensions.
 * Parse will store a data point at the time of invocation with the given
 * event name.
 *
 * Dimensions will allow segmentation of the occurrences of this custom
 * event. Keys and values should be {@code String}s, and will throw
 * otherwise.
 *
 * To track a user signup along with additional metadata, consider the
 * following:
 * <pre>
 * var dimensions = {
 *  gender: 'm',
 *  source: 'web',
 *  dayType: 'weekend'
 * };
 * Parse.Analytics.track('signup', dimensions);
 * </pre>
 *
 * There is a default limit of 8 dimensions per event tracked.
 *
 * @function track
 * @name Parse.Analytics.track
 * @param {string} name The name of the custom event to report to Parse as
 * having happened.
 * @param {object} dimensions The dictionary of information by which to
 * segment this event.
 * @returns {Promise} A promise that is resolved when the round-trip
 * to the server completes.
 */ function $d2eafd5e6cef8f6c$var$track(name, dimensions) /*: Promise*/ {
    name = name || "";
    name = name.replace(/^\s*/, "");
    name = name.replace(/\s*$/, "");
    if (name.length === 0) throw new TypeError("A name for the custom event must be provided");
    for(var _key in dimensions){
        if (typeof _key !== "string" || typeof dimensions[_key] !== "string") throw new TypeError('track() dimensions expects keys and values of type "string".');
    }
    return $d2eafd5e6cef8f6c$var$_CoreManager.default.getAnalyticsController().track(name, dimensions);
}
var $d2eafd5e6cef8f6c$var$DefaultController = {
    track: function(name, dimensions) {
        var RESTController = $d2eafd5e6cef8f6c$var$_CoreManager.default.getRESTController();
        return RESTController.request("POST", "events/" + name, {
            dimensions: dimensions
        });
    }
};
$d2eafd5e6cef8f6c$var$_CoreManager.default.setAnalyticsController($d2eafd5e6cef8f6c$var$DefaultController);

});

parcelRequire.register("9Fxsf", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $evY07 = parcelRequire("evY07");
$evY07(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $70a1e4c478059c9b$var$_ParseUser = $3Npdz((parcelRequire("8mqMW")));

var $JZta3 = parcelRequire("JZta3");
var $70a1e4c478059c9b$var$registered = false;
/**
 * Provides utility functions for working with Anonymously logged-in users. <br />
 * Anonymous users have some unique characteristics:
 * <ul>
 *  <li>Anonymous users don't need a user name or password.</li>
 *  <ul>
 *    <li>Once logged out, an anonymous user cannot be recovered.</li>
 *  </ul>
 *  <li>signUp converts an anonymous user to a standard user with the given username and password.</li>
 *  <ul>
 *    <li>Data associated with the anonymous user is retained.</li>
 *  </ul>
 *  <li>logIn switches users without converting the anonymous user.</li>
 *  <ul>
 *    <li>Data associated with the anonymous user will be lost.</li>
 *  </ul>
 *  <li>Service logIn (e.g. Facebook, Twitter) will attempt to convert
 *  the anonymous user into a standard user by linking it to the service.</li>
 *  <ul>
 *    <li>If a user already exists that is linked to the service, it will instead switch to the existing user.</li>
 *  </ul>
 *  <li>Service linking (e.g. Facebook, Twitter) will convert the anonymous user
 *  into a standard user by linking it to the service.</li>
 * </ul>
 *
 * @class Parse.AnonymousUtils
 * @static
 */ var $70a1e4c478059c9b$var$AnonymousUtils = {
    /**
   * Gets whether the user has their account linked to anonymous user.
   *
   * @function isLinked
   * @name Parse.AnonymousUtils.isLinked
   * @param {Parse.User} user User to check for.
   *     The user must be logged in on this device.
   * @returns {boolean} <code>true</code> if the user has their account
   *     linked to an anonymous user.
   * @static
   */ isLinked: function(user) {
        var provider = this._getAuthProvider();
        return user._isLinked(provider.getAuthType());
    },
    /**
   * Logs in a user Anonymously.
   *
   * @function logIn
   * @name Parse.AnonymousUtils.logIn
   * @param {object} options MasterKey / SessionToken.
   * @returns {Promise} Logged in user
   * @static
   */ logIn: function(options) /*: Promise<ParseUser>*/ {
        var provider = this._getAuthProvider();
        return $70a1e4c478059c9b$var$_ParseUser.default.logInWith(provider.getAuthType(), provider.getAuthData(), options);
    },
    /**
   * Links Anonymous User to an existing PFUser.
   *
   * @function link
   * @name Parse.AnonymousUtils.link
   * @param {Parse.User} user User to link. This must be the current user.
   * @param {object} options MasterKey / SessionToken.
   * @returns {Promise} Linked with User
   * @static
   */ link: function(user, options) /*: Promise<ParseUser>*/ {
        var provider = this._getAuthProvider();
        return user.linkWith(provider.getAuthType(), provider.getAuthData(), options);
    },
    /**
   * Returns true if Authentication Provider has been registered for use.
   *
   * @function isRegistered
   * @name Parse.AnonymousUtils.isRegistered
   * @returns {boolean}
   * @static
   */ isRegistered: function() /*: boolean*/ {
        return $70a1e4c478059c9b$var$registered;
    },
    _getAuthProvider: function() {
        var provider = {
            restoreAuthentication: function() {
                return true;
            },
            getAuthType: function() {
                return "anonymous";
            },
            getAuthData: function() {
                return {
                    authData: {
                        id: $JZta3()
                    }
                };
            }
        };
        if (!$70a1e4c478059c9b$var$registered) {
            $70a1e4c478059c9b$var$_ParseUser.default._registerAuthenticationProvider(provider);
            $70a1e4c478059c9b$var$registered = true;
        }
        return provider;
    }
};
var $70a1e4c478059c9b$var$_default = $70a1e4c478059c9b$var$AnonymousUtils;
module.exports.default = $70a1e4c478059c9b$var$_default;

});

parcelRequire.register("7M26W", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $evY07 = parcelRequire("evY07");
$evY07(module.exports, "__esModule", {
    value: true
});
module.exports.getJobStatus = $5a8ea748a47efa39$var$getJobStatus;
module.exports.getJobsData = $5a8ea748a47efa39$var$getJobsData;
module.exports.run = $5a8ea748a47efa39$var$run;
module.exports.startJob = $5a8ea748a47efa39$var$startJob;

var $5a8ea748a47efa39$var$_promise = $3Npdz((parcelRequire("bCWDe")));

var $5a8ea748a47efa39$var$_keys = $3Npdz((parcelRequire("r9mpE")));

var $5a8ea748a47efa39$var$_typeof2 = $3Npdz((parcelRequire("akViX")));

var $5a8ea748a47efa39$var$_CoreManager = $3Npdz((parcelRequire("465CW")));

var $5a8ea748a47efa39$var$_decode = $3Npdz((parcelRequire("7CFxK")));

var $5a8ea748a47efa39$var$_encode = $3Npdz((parcelRequire("gM4ym")));

var $5a8ea748a47efa39$var$_ParseError = $3Npdz((parcelRequire("3HQSG")));

var $5a8ea748a47efa39$var$_ParseQuery = $3Npdz((parcelRequire("eJCLn")));

var $5a8ea748a47efa39$var$_ParseObject = $3Npdz((parcelRequire("2HIpX")));
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ /**
 * Contains functions for calling and declaring
 * <a href="/docs/cloud_code_guide#functions">cloud functions</a>.
 * <p><strong><em>
 *   Some functions are only available from Cloud Code.
 * </em></strong></p>
 *
 * @class Parse.Cloud
 * @static
 * @hideconstructor
 */ /**
 * Makes a call to a cloud function.
 *
 * @function run
 * @name Parse.Cloud.run
 * @param {string} name The function name.
 * @param {object} data The parameters to send to the cloud function.
 * @param {object} options
 * @returns {Promise} A promise that will be resolved with the result
 * of the function.
 */ function $5a8ea748a47efa39$var$run(name, data, options) /*: Promise<mixed>*/ {
    options = options || {};
    if (typeof name !== "string" || name.length === 0) throw new TypeError("Cloud function name must be a string.");
    var requestOptions = {};
    if (options.useMasterKey) requestOptions.useMasterKey = options.useMasterKey;
    if (options.sessionToken) requestOptions.sessionToken = options.sessionToken;
    if (options.context && (0, $5a8ea748a47efa39$var$_typeof2.default)(options.context) === "object") requestOptions.context = options.context;
    return $5a8ea748a47efa39$var$_CoreManager.default.getCloudController().run(name, data, requestOptions);
}
/**
 * Gets data for the current set of cloud jobs.
 *
 * @function getJobsData
 * @name Parse.Cloud.getJobsData
 * @returns {Promise} A promise that will be resolved with the result
 * of the function.
 */ function $5a8ea748a47efa39$var$getJobsData() /*: Promise<Object>*/ {
    return $5a8ea748a47efa39$var$_CoreManager.default.getCloudController().getJobsData({
        useMasterKey: true
    });
}
/**
 * Starts a given cloud job, which will process asynchronously.
 *
 * @function startJob
 * @name Parse.Cloud.startJob
 * @param {string} name The function name.
 * @param {object} data The parameters to send to the cloud function.
 * @returns {Promise} A promise that will be resolved with the jobStatusId
 * of the job.
 */ function $5a8ea748a47efa39$var$startJob(name, data) /*: Promise<string>*/ {
    if (typeof name !== "string" || name.length === 0) throw new TypeError("Cloud job name must be a string.");
    return $5a8ea748a47efa39$var$_CoreManager.default.getCloudController().startJob(name, data, {
        useMasterKey: true
    });
}
/**
 * Gets job status by Id
 *
 * @function getJobStatus
 * @name Parse.Cloud.getJobStatus
 * @param {string} jobStatusId The Id of Job Status.
 * @returns {Parse.Object} Status of Job.
 */ function $5a8ea748a47efa39$var$getJobStatus(jobStatusId) /*: Promise<ParseObject>*/ {
    var query = new $5a8ea748a47efa39$var$_ParseQuery.default("_JobStatus");
    return query.get(jobStatusId, {
        useMasterKey: true
    });
}
var $5a8ea748a47efa39$var$DefaultController = {
    run: function(name, data, options) {
        var RESTController = $5a8ea748a47efa39$var$_CoreManager.default.getRESTController();
        var payload = (0, $5a8ea748a47efa39$var$_encode.default)(data, true);
        var request = RESTController.request("POST", "functions/" + name, payload, options);
        return request.then(function(res) {
            if ((0, $5a8ea748a47efa39$var$_typeof2.default)(res) === "object" && (0, $5a8ea748a47efa39$var$_keys.default)(res).length > 0 && !res.hasOwnProperty("result")) throw new $5a8ea748a47efa39$var$_ParseError.default($5a8ea748a47efa39$var$_ParseError.default.INVALID_JSON, "The server returned an invalid response.");
            var decoded = (0, $5a8ea748a47efa39$var$_decode.default)(res);
            if (decoded && decoded.hasOwnProperty("result")) return $5a8ea748a47efa39$var$_promise.default.resolve(decoded.result);
            return $5a8ea748a47efa39$var$_promise.default.resolve(undefined);
        });
    },
    getJobsData: function(options) {
        var RESTController = $5a8ea748a47efa39$var$_CoreManager.default.getRESTController();
        return RESTController.request("GET", "cloud_code/jobs/data", null, options);
    },
    startJob: function(name, data, options) {
        var RESTController = $5a8ea748a47efa39$var$_CoreManager.default.getRESTController();
        var payload = (0, $5a8ea748a47efa39$var$_encode.default)(data, true);
        return RESTController.request("POST", "jobs/" + name, payload, options);
    }
};
$5a8ea748a47efa39$var$_CoreManager.default.setCloudController($5a8ea748a47efa39$var$DefaultController);

});

parcelRequire.register("2wtte", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $evY07 = parcelRequire("evY07");

var $8jMtB = parcelRequire("8jMtB");

var $1nHJN = parcelRequire("1nHJN");

var $jZGC2 = parcelRequire("jZGC2");

var $1o4IC = parcelRequire("1o4IC");

var $kYm0J = parcelRequire("kYm0J");

var $d3A5d = parcelRequire("d3A5d");



var $liESz = parcelRequire("liESz");

var $ebK4m = parcelRequire("ebK4m");

var $5hSqA = parcelRequire("5hSqA");

$evY07(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1d656e278658d981$var$_isArray = $3Npdz((parcelRequire("i0kCX")));

var $1d656e278658d981$var$_keys = $3Npdz((parcelRequire("r9mpE")));

var $1d656e278658d981$var$_slice = $3Npdz((parcelRequire("fG1Ke")));

var $1d656e278658d981$var$_assign = $3Npdz((parcelRequire("dZDQb")));

var $1d656e278658d981$var$_slicedToArray2 = $3Npdz((parcelRequire("5kSp4")));

var $1d656e278658d981$var$_entries = $3Npdz((parcelRequire("i3rvd")));

var $1d656e278658d981$var$_every = $3Npdz((parcelRequire("d3onG")));

var $1d656e278658d981$var$_includes = $3Npdz((parcelRequire("aUw0k")));

var $1d656e278658d981$var$_typeof2 = $3Npdz((parcelRequire("akViX")));

var $1d656e278658d981$var$_classCallCheck2 = $3Npdz((parcelRequire("9pQKE")));

var $1d656e278658d981$var$_createClass2 = $3Npdz((parcelRequire("eZYdV")));

var $1d656e278658d981$var$_defineProperty2 = $3Npdz((parcelRequire("bci6G")));

var $1d656e278658d981$var$_map = $3Npdz((parcelRequire("jIsi7")));

var $1d656e278658d981$var$_ParseRole = $3Npdz((parcelRequire("62sYC")));

var $1d656e278658d981$var$_ParseUser = $3Npdz((parcelRequire("8mqMW")));
function $1d656e278658d981$var$ownKeys(object, enumerableOnly) {
    var keys = (parcelRequire("r9mpE"))(object);
    if ($d3A5d) {
        var symbols = $d3A5d(object);
        enumerableOnly && (symbols = $kYm0J(symbols).call(symbols, function(sym) {
            return $1o4IC(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1d656e278658d981$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var _context3, _context4;
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $jZGC2(_context3 = $1d656e278658d981$var$ownKeys(Object(source), !0)).call(_context3, function(key) {
            (0, $1d656e278658d981$var$_defineProperty2.default)(target, key, source[key]);
        }) : $1nHJN ? $8jMtB(target, $1nHJN(source)) : $jZGC2(_context4 = $1d656e278658d981$var$ownKeys(Object(source))).call(_context4, function(key) {
            $evY07(target, key, $1o4IC(source, key));
        });
    }
    return target;
}
function $1d656e278658d981$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof $ebK4m !== "undefined" && $liESz(o) || o["@@iterator"];
    if (!it) {
        if ((parcelRequire("i0kCX"))(o) || (it = $1d656e278658d981$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function() {};
            return {
                s: F,
                n: function() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function() {
            it = it.call(o);
        },
        n: function() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $1d656e278658d981$var$_unsupportedIterableToArray(o, minLen) {
    var _context2;
    if (!o) return;
    if (typeof o === "string") return $1d656e278658d981$var$_arrayLikeToArray(o, minLen);
    var n = (parcelRequire("fG1Ke"))(_context2 = Object.prototype.toString.call(o)).call(_context2, 8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return $5hSqA(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1d656e278658d981$var$_arrayLikeToArray(o, minLen);
}
function $1d656e278658d981$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $1d656e278658d981$var$PUBLIC_KEY = "*";
var $1d656e278658d981$var$VALID_PERMISSIONS = new $1d656e278658d981$var$_map.default();
$1d656e278658d981$var$VALID_PERMISSIONS.set("get", {});
$1d656e278658d981$var$VALID_PERMISSIONS.set("find", {});
$1d656e278658d981$var$VALID_PERMISSIONS.set("count", {});
$1d656e278658d981$var$VALID_PERMISSIONS.set("create", {});
$1d656e278658d981$var$VALID_PERMISSIONS.set("update", {});
$1d656e278658d981$var$VALID_PERMISSIONS.set("delete", {});
$1d656e278658d981$var$VALID_PERMISSIONS.set("addField", {});
var $1d656e278658d981$var$VALID_PERMISSIONS_EXTENDED = new $1d656e278658d981$var$_map.default();
$1d656e278658d981$var$VALID_PERMISSIONS_EXTENDED.set("protectedFields", {});
/**
 * Creates a new CLP.
 * If no argument is given, the CLP has no permissions for anyone.
 * If the argument is a Parse.User or Parse.Role, the CLP will have read and write
 *   permission for only that user or role.
 * If the argument is any other JSON object, that object will be interpretted
 *   as a serialized CLP created with toJSON().
 *
 * <p>A CLP, or Class Level Permissions can be added to any
 * <code>Parse.Schema</code> to restrict access to only a subset of users
 * of your application.</p>
 *
 * <p>
 * For get/count/find/create/update/delete/addField using the following functions:
 *
 * Entity is type Parse.User or Parse.Role or string
 * Role is type Parse.Role or Name of Parse.Role
 *
 * getGetRequiresAuthentication()
 * setGetRequiresAuthentication(allowed: boolean)
 * getGetPointerFields()
 * setGetPointerFields(pointerFields: string[])
 * getGetAccess(entity: Entity)
 * setGetAccess(entity: Entity, allowed: boolean)
 * getPublicGetAccess()
 * setPublicGetAccess(allowed: boolean)
 * getRoleGetAccess(role: Role)
 * setRoleGetAccess(role: Role, allowed: boolean)
 * getFindRequiresAuthentication()
 * setFindRequiresAuthentication(allowed: boolean)
 * getFindPointerFields()
 * setFindPointerFields(pointerFields: string[])
 * getFindAccess(entity: Entity)
 * setFindAccess(entity: Entity, allowed: boolean)
 * getPublicFindAccess()
 * setPublicFindAccess(allowed: boolean)
 * getRoleFindAccess(role: Role)
 * setRoleFindAccess(role: Role, allowed: boolean)
 * getCountRequiresAuthentication()
 * setCountRequiresAuthentication(allowed: boolean)
 * getCountPointerFields()
 * setCountPointerFields(pointerFields: string[])
 * getCountAccess(entity: Entity)
 * setCountAccess(entity: Entity, allowed: boolean)
 * getPublicCountAccess()
 * setPublicCountAccess(allowed: boolean)
 * getRoleCountAccess(role: Role)
 * setRoleCountAccess(role: Role, allowed: boolean)
 * getCreateRequiresAuthentication()
 * setCreateRequiresAuthentication(allowed: boolean)
 * getCreatePointerFields()
 * setCreatePointerFields(pointerFields: string[])
 * getCreateAccess(entity: Entity)
 * setCreateAccess(entity: Entity, allowed: boolean)
 * getPublicCreateAccess()
 * setPublicCreateAccess(allowed: Boolean)
 * getRoleCreateAccess(role: Role)
 * setRoleCreateAccess(role: Role, allowed: boolean)
 * getUpdateRequiresAuthentication()
 * setUpdateRequiresAuthentication(allowed: boolean)
 * getUpdatePointerFields()
 * setUpdatePointerFields(pointerFields: string[])
 * getUpdateAccess(entity: Entity)
 * setUpdateAccess(entity: Entity, allowed: boolean)
 * getPublicUpdateAccess()
 * setPublicUpdateAccess(allowed: boolean)
 * getRoleUpdateAccess(role: Role)
 * setRoleUpdateAccess(role: Role, allowed: boolean)
 * getDeleteRequiresAuthentication()
 * setDeleteRequiresAuthentication(allowed: boolean)
 * getDeletePointerFields()
 * setDeletePointerFields(pointerFields: string[])
 * getDeleteAccess(entity: Entity)
 * setDeleteAccess(entity: Entity, allowed: boolean)
 * getPublicDeleteAccess()
 * setPublicDeleteAccess(allowed: boolean)
 * getRoleDeleteAccess(role: Role)
 * setRoleDeleteAccess(role: Role, allowed: boolean)
 * getAddFieldRequiresAuthentication()
 * setAddFieldRequiresAuthentication(allowed: boolean)
 * getAddFieldPointerFields()
 * setAddFieldPointerFields(pointerFields: string[])
 * getAddFieldAccess(entity: Entity)
 * setAddFieldAccess(entity: Entity, allowed: boolean)
 * getPublicAddFieldAccess()
 * setPublicAddFieldAccess(allowed: boolean)
 * getRoleAddFieldAccess(role: Role)
 * setRoleAddFieldAccess(role: Role, allowed: boolean)
 * </p>
 *
 * @alias Parse.CLP
 */ var $1d656e278658d981$var$ParseCLP = /*#__PURE__*/ function() {
    /**
   * @param {(Parse.User | Parse.Role | object)} userId The user to initialize the CLP for
   */ function ParseCLP(userId) {
        var _this = this;
        (0, $1d656e278658d981$var$_classCallCheck2.default)(this, ParseCLP);
        (0, $1d656e278658d981$var$_defineProperty2.default)(this, "permissionsMap", void 0);
        this.permissionsMap = {}; // Initialize permissions Map with default permissions
        var _iterator = $1d656e278658d981$var$_createForOfIteratorHelper((0, $1d656e278658d981$var$_entries.default)($1d656e278658d981$var$VALID_PERMISSIONS).call($1d656e278658d981$var$VALID_PERMISSIONS)), _step;
        try {
            var _loop = function _loop() {
                var _step$value = (0, $1d656e278658d981$var$_slicedToArray2.default)(_step.value, 2), operation = _step$value[0], group = _step$value[1];
                _this.permissionsMap[operation] = (0, $1d656e278658d981$var$_assign.default)({}, group);
                var action = operation.charAt(0).toUpperCase() + (0, $1d656e278658d981$var$_slice.default)(operation).call(operation, 1);
                _this["get".concat(action, "RequiresAuthentication")] = function() {
                    return this._getAccess(operation, "requiresAuthentication");
                };
                _this["set".concat(action, "RequiresAuthentication")] = function(allowed) {
                    this._setAccess(operation, "requiresAuthentication", allowed);
                };
                _this["get".concat(action, "PointerFields")] = function() {
                    return this._getAccess(operation, "pointerFields", false);
                };
                _this["set".concat(action, "PointerFields")] = function(pointerFields) {
                    this._setArrayAccess(operation, "pointerFields", pointerFields);
                };
                _this["get".concat(action, "Access")] = function(entity) {
                    return this._getAccess(operation, entity);
                };
                _this["set".concat(action, "Access")] = function(entity, allowed) {
                    this._setAccess(operation, entity, allowed);
                };
                _this["getPublic".concat(action, "Access")] = function() {
                    return this["get".concat(action, "Access")]($1d656e278658d981$var$PUBLIC_KEY);
                };
                _this["setPublic".concat(action, "Access")] = function(allowed) {
                    this["set".concat(action, "Access")]($1d656e278658d981$var$PUBLIC_KEY, allowed);
                };
                _this["getRole".concat(action, "Access")] = function(role) {
                    return this["get".concat(action, "Access")](this._getRoleName(role));
                };
                _this["setRole".concat(action, "Access")] = function(role, allowed) {
                    this["set".concat(action, "Access")](this._getRoleName(role), allowed);
                };
            };
            for(_iterator.s(); !(_step = _iterator.n()).done;)_loop();
             // Initialize permissions Map with default extended permissions
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        var _iterator2 = $1d656e278658d981$var$_createForOfIteratorHelper((0, $1d656e278658d981$var$_entries.default)($1d656e278658d981$var$VALID_PERMISSIONS_EXTENDED).call($1d656e278658d981$var$VALID_PERMISSIONS_EXTENDED)), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var _step2$value = (0, $1d656e278658d981$var$_slicedToArray2.default)(_step2.value, 2), operation = _step2$value[0], group = _step2$value[1];
                this.permissionsMap[operation] = (0, $1d656e278658d981$var$_assign.default)({}, group);
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        if (userId && (0, $1d656e278658d981$var$_typeof2.default)(userId) === "object") {
            if (userId instanceof $1d656e278658d981$var$_ParseUser.default) {
                this.setReadAccess(userId, true);
                this.setWriteAccess(userId, true);
            } else if (userId instanceof $1d656e278658d981$var$_ParseRole.default) {
                this.setRoleReadAccess(userId, true);
                this.setRoleWriteAccess(userId, true);
            } else for(var _permission in userId){
                var _context;
                var users = userId[_permission];
                var isValidPermission = !!$1d656e278658d981$var$VALID_PERMISSIONS.get(_permission);
                var isValidPermissionExtended = !!$1d656e278658d981$var$VALID_PERMISSIONS_EXTENDED.get(_permission);
                var isValidGroupPermission = (0, $1d656e278658d981$var$_includes.default)(_context = [
                    "readUserFields",
                    "writeUserFields"
                ]).call(_context, _permission);
                if (typeof _permission !== "string" || !(isValidPermission || isValidPermissionExtended || isValidGroupPermission)) throw new TypeError("Tried to create an CLP with an invalid permission type.");
                if (isValidGroupPermission) {
                    if ((0, $1d656e278658d981$var$_every.default)(users).call(users, function(pointer) {
                        return typeof pointer === "string";
                    })) {
                        this.permissionsMap[_permission] = users;
                        continue;
                    } else throw new TypeError("Tried to create an CLP with an invalid permission value.");
                }
                for(var user in users){
                    var allowed = users[user];
                    if (typeof allowed !== "boolean" && !isValidPermissionExtended && user !== "pointerFields") throw new TypeError("Tried to create an CLP with an invalid permission value.");
                    this.permissionsMap[_permission][user] = allowed;
                }
            }
        } else if (typeof userId === "function") throw new TypeError("ParseCLP constructed with a function. Did you forget ()?");
    }
    /**
   * Returns a JSON-encoded version of the CLP.
   *
   * @returns {object}
   */ (0, $1d656e278658d981$var$_createClass2.default)(ParseCLP, [
        {
            key: "toJSON",
            value: function toJSON() /*: PermissionsMap*/ {
                return $1d656e278658d981$var$_objectSpread({}, this.permissionsMap);
            }
        },
        {
            key: "equals",
            value: function equals(other) /*: boolean*/ {
                if (!(other instanceof ParseCLP)) return false;
                var permissions = (0, $1d656e278658d981$var$_keys.default)(this.permissionsMap);
                var otherPermissions = (0, $1d656e278658d981$var$_keys.default)(other.permissionsMap);
                if (permissions.length !== otherPermissions.length) return false;
                for(var _permission2 in this.permissionsMap){
                    if (!other.permissionsMap[_permission2]) return false;
                    var users = (0, $1d656e278658d981$var$_keys.default)(this.permissionsMap[_permission2]);
                    var otherUsers = (0, $1d656e278658d981$var$_keys.default)(other.permissionsMap[_permission2]);
                    if (users.length !== otherUsers.length) return false;
                    for(var user in this.permissionsMap[_permission2]){
                        if (!other.permissionsMap[_permission2][user]) return false;
                        if (this.permissionsMap[_permission2][user] !== other.permissionsMap[_permission2][user]) return false;
                    }
                }
                return true;
            }
        },
        {
            key: "_getRoleName",
            value: function _getRoleName(role) /*: string*/ {
                var name = role;
                if (role instanceof $1d656e278658d981$var$_ParseRole.default) // Normalize to the String name
                name = role.getName();
                if (typeof name !== "string") throw new TypeError("role must be a Parse.Role or a String");
                return "role:".concat(name);
            }
        },
        {
            key: "_parseEntity",
            value: function _parseEntity(entity) {
                var userId = entity;
                if (userId instanceof $1d656e278658d981$var$_ParseUser.default) {
                    userId = userId.id;
                    if (!userId) throw new Error("Cannot get access for a Parse.User without an id.");
                } else if (userId instanceof $1d656e278658d981$var$_ParseRole.default) userId = this._getRoleName(userId);
                if (typeof userId !== "string") throw new TypeError("userId must be a string.");
                return userId;
            }
        },
        {
            key: "_setAccess",
            value: function _setAccess(permission, userId, allowed) {
                userId = this._parseEntity(userId);
                if (typeof allowed !== "boolean") throw new TypeError("allowed must be either true or false.");
                var permissions = this.permissionsMap[permission][userId];
                if (!permissions) {
                    if (!allowed) // The user already doesn't have this permission, so no action is needed
                    return;
                    else this.permissionsMap[permission][userId] = {};
                }
                if (allowed) this.permissionsMap[permission][userId] = true;
                else delete this.permissionsMap[permission][userId];
            }
        },
        {
            key: "_getAccess",
            value: function _getAccess(permission, userId) /*: boolean | string[]*/ {
                var returnBoolean = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
                userId = this._parseEntity(userId);
                var permissions = this.permissionsMap[permission][userId];
                if (returnBoolean) {
                    if (!permissions) return false;
                    return !!this.permissionsMap[permission][userId];
                }
                return permissions;
            }
        },
        {
            key: "_setArrayAccess",
            value: function _setArrayAccess(permission, userId, fields) {
                userId = this._parseEntity(userId);
                var permissions = this.permissionsMap[permission][userId];
                if (!permissions) this.permissionsMap[permission][userId] = [];
                if (!fields || (0, $1d656e278658d981$var$_isArray.default)(fields) && fields.length === 0) delete this.permissionsMap[permission][userId];
                else if ((0, $1d656e278658d981$var$_isArray.default)(fields) && (0, $1d656e278658d981$var$_every.default)(fields).call(fields, function(field) {
                    return typeof field === "string";
                })) this.permissionsMap[permission][userId] = fields;
                else throw new TypeError("fields must be an array of strings or undefined.");
            }
        },
        {
            key: "_setGroupPointerPermission",
            value: function _setGroupPointerPermission(operation, pointerFields) {
                var fields = this.permissionsMap[operation];
                if (!fields) this.permissionsMap[operation] = [];
                if (!pointerFields || (0, $1d656e278658d981$var$_isArray.default)(pointerFields) && pointerFields.length === 0) delete this.permissionsMap[operation];
                else if ((0, $1d656e278658d981$var$_isArray.default)(pointerFields) && (0, $1d656e278658d981$var$_every.default)(pointerFields).call(pointerFields, function(field) {
                    return typeof field === "string";
                })) this.permissionsMap[operation] = pointerFields;
                else throw new TypeError("".concat(operation, ".pointerFields must be an array of strings or undefined."));
            }
        },
        {
            key: "_getGroupPointerPermissions",
            value: function _getGroupPointerPermissions(operation) /*: string[]*/ {
                return this.permissionsMap[operation];
            }
        },
        {
            key: "setReadUserFields",
            value: function setReadUserFields(pointerFields) {
                this._setGroupPointerPermission("readUserFields", pointerFields);
            }
        },
        {
            key: "getReadUserFields",
            value: function getReadUserFields() /*: string[]*/ {
                return this._getGroupPointerPermissions("readUserFields");
            }
        },
        {
            key: "setWriteUserFields",
            value: function setWriteUserFields(pointerFields) {
                this._setGroupPointerPermission("writeUserFields", pointerFields);
            }
        },
        {
            key: "getWriteUserFields",
            value: function getWriteUserFields() /*: string[]*/ {
                return this._getGroupPointerPermissions("writeUserFields");
            }
        },
        {
            key: "setProtectedFields",
            value: function setProtectedFields(userId, fields) {
                this._setArrayAccess("protectedFields", userId, fields);
            }
        },
        {
            key: "getProtectedFields",
            value: function getProtectedFields(userId) /*: string[]*/ {
                return this._getAccess("protectedFields", userId, false);
            }
        },
        {
            key: "setReadAccess",
            value: function setReadAccess(userId, allowed) {
                this._setAccess("find", userId, allowed);
                this._setAccess("get", userId, allowed);
                this._setAccess("count", userId, allowed);
            }
        },
        {
            key: "getReadAccess",
            value: function getReadAccess(userId) /*: boolean*/ {
                return this._getAccess("find", userId) && this._getAccess("get", userId) && this._getAccess("count", userId);
            }
        },
        {
            key: "setWriteAccess",
            value: function setWriteAccess(userId, allowed) {
                this._setAccess("create", userId, allowed);
                this._setAccess("update", userId, allowed);
                this._setAccess("delete", userId, allowed);
                this._setAccess("addField", userId, allowed);
            }
        },
        {
            key: "getWriteAccess",
            value: function getWriteAccess(userId) /*: boolean*/ {
                return this._getAccess("create", userId) && this._getAccess("update", userId) && this._getAccess("delete", userId) && this._getAccess("addField", userId);
            }
        },
        {
            key: "setPublicReadAccess",
            value: function setPublicReadAccess(allowed) {
                this.setReadAccess($1d656e278658d981$var$PUBLIC_KEY, allowed);
            }
        },
        {
            key: "getPublicReadAccess",
            value: function getPublicReadAccess() /*: boolean*/ {
                return this.getReadAccess($1d656e278658d981$var$PUBLIC_KEY);
            }
        },
        {
            key: "setPublicWriteAccess",
            value: function setPublicWriteAccess(allowed) {
                this.setWriteAccess($1d656e278658d981$var$PUBLIC_KEY, allowed);
            }
        },
        {
            key: "getPublicWriteAccess",
            value: function getPublicWriteAccess() /*: boolean*/ {
                return this.getWriteAccess($1d656e278658d981$var$PUBLIC_KEY);
            }
        },
        {
            key: "setPublicProtectedFields",
            value: function setPublicProtectedFields(fields) {
                this.setProtectedFields($1d656e278658d981$var$PUBLIC_KEY, fields);
            }
        },
        {
            key: "getPublicProtectedFields",
            value: function getPublicProtectedFields() /*: string[]*/ {
                return this.getProtectedFields($1d656e278658d981$var$PUBLIC_KEY);
            }
        },
        {
            key: "getRoleReadAccess",
            value: function getRoleReadAccess(role) /*: boolean*/ {
                return this.getReadAccess(this._getRoleName(role));
            }
        },
        {
            key: "getRoleWriteAccess",
            value: function getRoleWriteAccess(role) /*: boolean*/ {
                return this.getWriteAccess(this._getRoleName(role));
            }
        },
        {
            key: "setRoleReadAccess",
            value: function setRoleReadAccess(role, allowed) {
                this.setReadAccess(this._getRoleName(role), allowed);
            }
        },
        {
            key: "setRoleWriteAccess",
            value: function setRoleWriteAccess(role, allowed) {
                this.setWriteAccess(this._getRoleName(role), allowed);
            }
        },
        {
            key: "getRoleProtectedFields",
            value: function getRoleProtectedFields(role) /*: string[]*/ {
                return this.getProtectedFields(this._getRoleName(role));
            }
        },
        {
            key: "setRoleProtectedFields",
            value: function setRoleProtectedFields(role, fields) {
                this.setProtectedFields(this._getRoleName(role), fields);
            }
        }
    ]);
    return ParseCLP;
}();
var $1d656e278658d981$var$_default = $1d656e278658d981$var$ParseCLP;
module.exports.default = $1d656e278658d981$var$_default;

});
parcelRequire.register("dZDQb", function(module, exports) {

module.exports = (parcelRequire("9aBjz"));

});
parcelRequire.register("9aBjz", function(module, exports) {

var $37BbF = parcelRequire("37BbF");
module.exports = $37BbF;

});
parcelRequire.register("37BbF", function(module, exports) {
parcelRequire("3BO89");

var $envPC = parcelRequire("envPC");
module.exports = $envPC.Object.assign;

});
parcelRequire.register("3BO89", function(module, exports) {

var $g2B3u = parcelRequire("g2B3u");

var $aT27s = parcelRequire("aT27s");
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$g2B3u({
    target: "Object",
    stat: true,
    arity: 2,
    forced: Object.assign !== $aT27s
}, {
    assign: $aT27s
});

});
parcelRequire.register("aT27s", function(module, exports) {
"use strict";

var $99D40 = parcelRequire("99D40");

var $7tcts = parcelRequire("7tcts");

var $5qecd = parcelRequire("5qecd");

var $avKuJ = parcelRequire("avKuJ");

var $lfsGJ = parcelRequire("lfsGJ");

var $fZ8lI = parcelRequire("fZ8lI");

var $lqqOI = parcelRequire("lqqOI");

var $bVwvx = parcelRequire("bVwvx");

var $5LLAg = parcelRequire("5LLAg");
// eslint-disable-next-line es/no-object-assign -- safe
var $7ed0af4273ffee9f$var$$assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var $7ed0af4273ffee9f$var$defineProperty = Object.defineProperty;
var $7ed0af4273ffee9f$var$concat = $7tcts([].concat);
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
module.exports = !$7ed0af4273ffee9f$var$$assign || $avKuJ(function() {
    // should have correct order of operations (Edge bug)
    if ($99D40 && $7ed0af4273ffee9f$var$$assign({
        b: 1
    }, $7ed0af4273ffee9f$var$$assign($7ed0af4273ffee9f$var$defineProperty({}, "a", {
        enumerable: true,
        get: function() {
            $7ed0af4273ffee9f$var$defineProperty(this, "b", {
                value: 3,
                enumerable: false
            });
        }
    }), {
        b: 2
    })).b !== 1) return true;
    // should work with symbols and should have deterministic property order (V8 bug)
    var A = {};
    var B = {};
    // eslint-disable-next-line es/no-symbol -- safe
    var symbol = Symbol();
    var alphabet = "abcdefghijklmnopqrst";
    A[symbol] = 7;
    alphabet.split("").forEach(function(chr) {
        B[chr] = chr;
    });
    return $7ed0af4273ffee9f$var$$assign({}, A)[symbol] != 7 || $lfsGJ($7ed0af4273ffee9f$var$$assign({}, B)).join("") != alphabet;
}) ? function assign(target, source) {
    var T = $bVwvx(target);
    var argumentsLength = arguments.length;
    var index = 1;
    var getOwnPropertySymbols = $fZ8lI.f;
    var propertyIsEnumerable = $lqqOI.f;
    while(argumentsLength > index){
        var S = $5LLAg(arguments[index++]);
        var keys = getOwnPropertySymbols ? $7ed0af4273ffee9f$var$concat($lfsGJ(S), getOwnPropertySymbols(S)) : $lfsGJ(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$99D40 || $5qecd(propertyIsEnumerable, S, key)) T[key] = S[key];
        }
    }
    return T;
} : $7ed0af4273ffee9f$var$$assign;

});





parcelRequire.register("i3rvd", function(module, exports) {

module.exports = (parcelRequire("eznKa"));

});
parcelRequire.register("eznKa", function(module, exports) {
parcelRequire("4YdnW");

var $3mH0O = parcelRequire("3mH0O");

var $dydfX = parcelRequire("dydfX");

var $5L8hR = parcelRequire("5L8hR");

var $kH5AP = parcelRequire("kH5AP");
var $a9b6c08af7756ab0$var$ArrayPrototype = Array.prototype;
var $a9b6c08af7756ab0$var$DOMIterables = {
    DOMTokenList: true,
    NodeList: true
};
module.exports = function(it) {
    var own = it.entries;
    return it === $a9b6c08af7756ab0$var$ArrayPrototype || $5L8hR($a9b6c08af7756ab0$var$ArrayPrototype, it) && own === $a9b6c08af7756ab0$var$ArrayPrototype.entries || $dydfX($a9b6c08af7756ab0$var$DOMIterables, $3mH0O(it)) ? $kH5AP : own;
};

});
parcelRequire.register("kH5AP", function(module, exports) {

var $8qnqK = parcelRequire("8qnqK");
module.exports = $8qnqK;

});
parcelRequire.register("8qnqK", function(module, exports) {
parcelRequire("4IarS");
parcelRequire("edOxo");

var $hESIr = parcelRequire("hESIr");
module.exports = $hESIr("Array").entries;

});




parcelRequire.register("d3onG", function(module, exports) {

module.exports = (parcelRequire("lyJnl"));

});
parcelRequire.register("lyJnl", function(module, exports) {

var $8hhga = parcelRequire("8hhga");
module.exports = $8hhga;

});
parcelRequire.register("8hhga", function(module, exports) {

var $5L8hR = parcelRequire("5L8hR");

var $2ISxq = parcelRequire("2ISxq");
var $606d4caf527adade$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.every;
    return it === $606d4caf527adade$var$ArrayPrototype || $5L8hR($606d4caf527adade$var$ArrayPrototype, it) && own === $606d4caf527adade$var$ArrayPrototype.every ? $2ISxq : own;
};

});
parcelRequire.register("2ISxq", function(module, exports) {
parcelRequire("g1E8d");

var $hESIr = parcelRequire("hESIr");
module.exports = $hESIr("Array").every;

});
parcelRequire.register("g1E8d", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $lB6H8 = parcelRequire("lB6H8");
var $baabdea2afdb19bf$require$$every = $lB6H8.every;

var $iNgXn = parcelRequire("iNgXn");
var $baabdea2afdb19bf$var$STRICT_METHOD = $iNgXn("every");
// `Array.prototype.every` method
// https://tc39.es/ecma262/#sec-array.prototype.every
$g2B3u({
    target: "Array",
    proto: true,
    forced: !$baabdea2afdb19bf$var$STRICT_METHOD
}, {
    every: function every(callbackfn /* , thisArg */ ) {
        return $baabdea2afdb19bf$require$$every(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});

});





parcelRequire.register("jIsi7", function(module, exports) {

module.exports = (parcelRequire("1bC6H"));

});


parcelRequire.register("bIIcS", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $evY07 = parcelRequire("evY07");
$evY07(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8886184bc60a5eca$var$_stringify = $3Npdz((parcelRequire("O2sNs")));

var $8886184bc60a5eca$var$_typeof2 = $3Npdz((parcelRequire("akViX")));

var $8886184bc60a5eca$var$_promise = $3Npdz((parcelRequire("bCWDe")));

var $8886184bc60a5eca$var$_classCallCheck2 = $3Npdz((parcelRequire("9pQKE")));

var $8886184bc60a5eca$var$_createClass2 = $3Npdz((parcelRequire("eZYdV")));

var $8886184bc60a5eca$var$_defineProperty2 = $3Npdz((parcelRequire("bci6G")));

var $8886184bc60a5eca$var$_CoreManager = $3Npdz((parcelRequire("465CW")));

var $8886184bc60a5eca$var$_decode = $3Npdz((parcelRequire("7CFxK")));

var $8886184bc60a5eca$var$_encode = $3Npdz((parcelRequire("gM4ym")));

var $8886184bc60a5eca$var$_escape2 = $3Npdz((parcelRequire("c9yrO")));

var $8886184bc60a5eca$var$_ParseError = $3Npdz((parcelRequire("3HQSG")));

var $8886184bc60a5eca$var$_Storage = $3Npdz((parcelRequire("7Zbj0")));
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ /**
 * Parse.Config is a local representation of configuration data that
 * can be set from the Parse dashboard.
 *
 * @alias Parse.Config
 */ var $8886184bc60a5eca$var$ParseConfig = /*#__PURE__*/ function() {
    function ParseConfig() {
        (0, $8886184bc60a5eca$var$_classCallCheck2.default)(this, ParseConfig);
        (0, $8886184bc60a5eca$var$_defineProperty2.default)(this, "attributes", void 0);
        (0, $8886184bc60a5eca$var$_defineProperty2.default)(this, "_escapedAttributes", void 0);
        this.attributes = {};
        this._escapedAttributes = {};
    }
    /**
   * Gets the value of an attribute.
   *
   * @param {string} attr The name of an attribute.
   * @returns {*}
   */ (0, $8886184bc60a5eca$var$_createClass2.default)(ParseConfig, [
        {
            key: "get",
            value: function(attr) /*: any*/ {
                return this.attributes[attr];
            }
        },
        {
            key: "escape",
            value: function(attr) /*: string*/ {
                var html = this._escapedAttributes[attr];
                if (html) return html;
                var val = this.attributes[attr];
                var escaped = "";
                if (val != null) escaped = (0, $8886184bc60a5eca$var$_escape2.default)(val.toString());
                this._escapedAttributes[attr] = escaped;
                return escaped;
            }
        }
    ], [
        {
            key: "current",
            value: function() {
                var controller = $8886184bc60a5eca$var$_CoreManager.default.getConfigController();
                return controller.current();
            }
        },
        {
            key: "get",
            value: function() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var controller = $8886184bc60a5eca$var$_CoreManager.default.getConfigController();
                return controller.get(options);
            }
        },
        {
            key: "save",
            value: function(attrs, masterKeyOnlyFlags) {
                var controller = $8886184bc60a5eca$var$_CoreManager.default.getConfigController(); //To avoid a mismatch with the local and the cloud config we get a new version
                return controller.save(attrs, masterKeyOnlyFlags).then(function() {
                    return controller.get({
                        useMasterKey: true
                    });
                }, function(error) {
                    return $8886184bc60a5eca$var$_promise.default.reject(error);
                });
            }
        },
        {
            key: "_clearCache",
            value: function() {
                $8886184bc60a5eca$var$currentConfig = null;
            }
        }
    ]);
    return ParseConfig;
}();
var $8886184bc60a5eca$var$currentConfig = null;
var $8886184bc60a5eca$var$CURRENT_CONFIG_KEY = "currentConfig";
function $8886184bc60a5eca$var$decodePayload(data) {
    try {
        var json = JSON.parse(data);
        if (json && (0, $8886184bc60a5eca$var$_typeof2.default)(json) === "object") return (0, $8886184bc60a5eca$var$_decode.default)(json);
    } catch (e) {
        return null;
    }
}
var $8886184bc60a5eca$var$DefaultController = {
    current: function() {
        if ($8886184bc60a5eca$var$currentConfig) return $8886184bc60a5eca$var$currentConfig;
        var config = new $8886184bc60a5eca$var$ParseConfig();
        var storagePath = $8886184bc60a5eca$var$_Storage.default.generatePath($8886184bc60a5eca$var$CURRENT_CONFIG_KEY);
        if (!$8886184bc60a5eca$var$_Storage.default.async()) {
            var configData = $8886184bc60a5eca$var$_Storage.default.getItem(storagePath);
            if (configData) {
                var attributes = $8886184bc60a5eca$var$decodePayload(configData);
                if (attributes) {
                    config.attributes = attributes;
                    $8886184bc60a5eca$var$currentConfig = config;
                }
            }
            return config;
        } // Return a promise for async storage controllers
        return $8886184bc60a5eca$var$_Storage.default.getItemAsync(storagePath).then(function(configData) {
            if (configData) {
                var _attributes = $8886184bc60a5eca$var$decodePayload(configData);
                if (_attributes) {
                    config.attributes = _attributes;
                    $8886184bc60a5eca$var$currentConfig = config;
                }
            }
            return config;
        });
    },
    get: function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var RESTController = $8886184bc60a5eca$var$_CoreManager.default.getRESTController();
        return RESTController.request("GET", "config", {}, options).then(function(response) {
            if (!response || !response.params) {
                var error = new $8886184bc60a5eca$var$_ParseError.default($8886184bc60a5eca$var$_ParseError.default.INVALID_JSON, "Config JSON response invalid.");
                return $8886184bc60a5eca$var$_promise.default.reject(error);
            }
            var config = new $8886184bc60a5eca$var$ParseConfig();
            config.attributes = {};
            for(var attr in response.params)config.attributes[attr] = (0, $8886184bc60a5eca$var$_decode.default)(response.params[attr]);
            $8886184bc60a5eca$var$currentConfig = config;
            return $8886184bc60a5eca$var$_Storage.default.setItemAsync($8886184bc60a5eca$var$_Storage.default.generatePath($8886184bc60a5eca$var$CURRENT_CONFIG_KEY), (0, $8886184bc60a5eca$var$_stringify.default)(response.params)).then(function() {
                return config;
            });
        });
    },
    save: function(attrs, masterKeyOnlyFlags) {
        var RESTController = $8886184bc60a5eca$var$_CoreManager.default.getRESTController();
        var encodedAttrs = {};
        for(var _key in attrs)encodedAttrs[_key] = (0, $8886184bc60a5eca$var$_encode.default)(attrs[_key]);
        return RESTController.request("PUT", "config", {
            params: encodedAttrs,
            masterKeyOnly: masterKeyOnlyFlags
        }, {
            useMasterKey: true
        }).then(function(response) {
            if (response && response.result) return $8886184bc60a5eca$var$_promise.default.resolve();
            else {
                var error = new $8886184bc60a5eca$var$_ParseError.default($8886184bc60a5eca$var$_ParseError.default.INTERNAL_SERVER_ERROR, "Error occured updating Config.");
                return $8886184bc60a5eca$var$_promise.default.reject(error);
            }
        });
    }
};
$8886184bc60a5eca$var$_CoreManager.default.setConfigController($8886184bc60a5eca$var$DefaultController);
var $8886184bc60a5eca$var$_default = $8886184bc60a5eca$var$ParseConfig;
module.exports.default = $8886184bc60a5eca$var$_default;

});

parcelRequire.register("9X9a0", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $evY07 = parcelRequire("evY07");
$evY07(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $73f0bad4ad3f3973$var$_ParseUser = $3Npdz((parcelRequire("8mqMW")));
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow-weak
 */ /* global FB */ var $73f0bad4ad3f3973$var$initialized = false;
var $73f0bad4ad3f3973$var$requestedPermissions;
var $73f0bad4ad3f3973$var$initOptions;
var $73f0bad4ad3f3973$var$provider = {
    authenticate: function(options) {
        var _this = this;
        if (typeof FB === "undefined") options.error(this, "Facebook SDK not found.");
        FB.login(function(response) {
            if (response.authResponse) {
                if (options.success) options.success(_this, {
                    id: response.authResponse.userID,
                    access_token: response.authResponse.accessToken,
                    expiration_date: new Date(response.authResponse.expiresIn * 1000 + new Date().getTime()).toJSON()
                });
            } else if (options.error) options.error(_this, response);
        }, {
            scope: $73f0bad4ad3f3973$var$requestedPermissions
        });
    },
    restoreAuthentication: function(authData) {
        if (authData) {
            var newOptions = {};
            if ($73f0bad4ad3f3973$var$initOptions) for(var key in $73f0bad4ad3f3973$var$initOptions)newOptions[key] = $73f0bad4ad3f3973$var$initOptions[key];
             // Suppress checks for login status from the browser.
            newOptions.status = false; // If the user doesn't match the one known by the FB SDK, log out.
            // Most of the time, the users will match -- it's only in cases where
            // the FB SDK knows of a different user than the one being restored
            // from a Parse User that logged in with username/password.
            var existingResponse = FB.getAuthResponse();
            if (existingResponse && existingResponse.userID !== authData.id) FB.logout();
            FB.init(newOptions);
        }
        return true;
    },
    getAuthType: function() {
        return "facebook";
    },
    deauthenticate: function() {
        this.restoreAuthentication(null);
    }
};
/**
 * Provides a set of utilities for using Parse with Facebook.
 *
 * @class Parse.FacebookUtils
 * @static
 * @hideconstructor
 */ var $73f0bad4ad3f3973$var$FacebookUtils = {
    /**
   * Initializes Parse Facebook integration.  Call this function after you
   * have loaded the Facebook Javascript SDK with the same parameters
   * as you would pass to<code>
   * <a href=
   * "https://developers.facebook.com/docs/reference/javascript/FB.init/">
   * FB.init()</a></code>.  Parse.FacebookUtils will invoke FB.init() for you
   * with these arguments.
   *
   * @function init
   * @name Parse.FacebookUtils.init
   * @param {object} options Facebook options argument as described here:
   *   <a href=
   *   "https://developers.facebook.com/docs/reference/javascript/FB.init/">
   *   FB.init()</a>. The status flag will be coerced to 'false' because it
   *   interferes with Parse Facebook integration. Call FB.getLoginStatus()
   *   explicitly if this behavior is required by your application.
   */ init: function(options) {
        if (typeof FB === "undefined") throw new Error("The Facebook JavaScript SDK must be loaded before calling init.");
        $73f0bad4ad3f3973$var$initOptions = {};
        if (options) for(var key in options)$73f0bad4ad3f3973$var$initOptions[key] = options[key];
        if ($73f0bad4ad3f3973$var$initOptions.status && typeof console !== "undefined") {
            var warn = console.warn || console.log || function() {}; // eslint-disable-line no-console
            warn.call(console, 'The "status" flag passed into FB.init, when set to true, can interfere with Parse Facebook integration, so it has been suppressed. Please call FB.getLoginStatus() explicitly if you require this behavior.');
        }
        $73f0bad4ad3f3973$var$initOptions.status = false;
        FB.init($73f0bad4ad3f3973$var$initOptions);
        $73f0bad4ad3f3973$var$_ParseUser.default._registerAuthenticationProvider($73f0bad4ad3f3973$var$provider);
        $73f0bad4ad3f3973$var$initialized = true;
    },
    /**
   * Gets whether the user has their account linked to Facebook.
   *
   * @function isLinked
   * @name Parse.FacebookUtils.isLinked
   * @param {Parse.User} user User to check for a facebook link.
   *     The user must be logged in on this device.
   * @returns {boolean} <code>true</code> if the user has their account
   *     linked to Facebook.
   */ isLinked: function(user) {
        return user._isLinked("facebook");
    },
    /**
   * Logs in a user using Facebook. This method delegates to the Facebook
   * SDK to authenticate the user, and then automatically logs in (or
   * creates, in the case where it is a new user) a Parse.User.
   *
   * Standard API:
   *
   * <code>logIn(permission: string, authData: Object);</code>
   *
   * Advanced API: Used for handling your own oAuth tokens
   * {@link https://docs.parseplatform.org/rest/guide/#linking-users}
   *
   * <code>logIn(authData: Object, options?: Object);</code>
   *
   * @function logIn
   * @name Parse.FacebookUtils.logIn
   * @param {(string | object)} permissions The permissions required for Facebook
   *    log in.  This is a comma-separated string of permissions.
   *    Alternatively, supply a Facebook authData object as described in our
   *    REST API docs if you want to handle getting facebook auth tokens
   *    yourself.
   * @param {object} options MasterKey / SessionToken. Alternatively can be used for authData if permissions is a string
   * @returns {Promise}
   */ logIn: function(permissions, options) {
        if (!permissions || typeof permissions === "string") {
            if (!$73f0bad4ad3f3973$var$initialized) throw new Error("You must initialize FacebookUtils before calling logIn.");
            $73f0bad4ad3f3973$var$requestedPermissions = permissions;
            return $73f0bad4ad3f3973$var$_ParseUser.default.logInWith("facebook", options);
        }
        return $73f0bad4ad3f3973$var$_ParseUser.default.logInWith("facebook", {
            authData: permissions
        }, options);
    },
    /**
   * Links Facebook to an existing PFUser. This method delegates to the
   * Facebook SDK to authenticate the user, and then automatically links
   * the account to the Parse.User.
   *
   * Standard API:
   *
   * <code>link(user: Parse.User, permission: string, authData?: Object);</code>
   *
   * Advanced API: Used for handling your own oAuth tokens
   * {@link https://docs.parseplatform.org/rest/guide/#linking-users}
   *
   * <code>link(user: Parse.User, authData: Object, options?: FullOptions);</code>
   *
   * @function link
   * @name Parse.FacebookUtils.link
   * @param {Parse.User} user User to link to Facebook. This must be the
   *     current user.
   * @param {(string | object)} permissions The permissions required for Facebook
   *    log in.  This is a comma-separated string of permissions.
   *    Alternatively, supply a Facebook authData object as described in our
   *    REST API docs if you want to handle getting facebook auth tokens
   *    yourself.
   * @param {object} options MasterKey / SessionToken. Alternatively can be used for authData if permissions is a string
   * @returns {Promise}
   */ link: function(user, permissions, options) {
        if (!permissions || typeof permissions === "string") {
            if (!$73f0bad4ad3f3973$var$initialized) throw new Error("You must initialize FacebookUtils before calling link.");
            $73f0bad4ad3f3973$var$requestedPermissions = permissions;
            return user.linkWith("facebook", options);
        }
        return user.linkWith("facebook", {
            authData: permissions
        }, options);
    },
    /**
   * Unlinks the Parse.User from a Facebook account.
   *
   * @function unlink
   * @name Parse.FacebookUtils.unlink
   * @param {Parse.User} user User to unlink from Facebook. This must be the
   *     current user.
   * @param {object} options Standard options object with success and error
   *    callbacks.
   * @returns {Promise}
   */ unlink: function(user, options) {
        if (!$73f0bad4ad3f3973$var$initialized) throw new Error("You must initialize FacebookUtils before calling unlink.");
        return user._unlinkFrom("facebook", options);
    },
    // Used for testing purposes
    _getAuthProvider: function() {
        return $73f0bad4ad3f3973$var$provider;
    }
};
var $73f0bad4ad3f3973$var$_default = $73f0bad4ad3f3973$var$FacebookUtils;
module.exports.default = $73f0bad4ad3f3973$var$_default;

});

parcelRequire.register("9QDBo", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $evY07 = parcelRequire("evY07");

var $dwGVc = parcelRequire("dwGVc");
$evY07(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $72b7b08f4e3f23c8$var$_typeof2 = $3Npdz((parcelRequire("akViX")));

var $72b7b08f4e3f23c8$var$_createClass2 = $3Npdz((parcelRequire("eZYdV")));

var $72b7b08f4e3f23c8$var$_classCallCheck2 = $3Npdz((parcelRequire("9pQKE")));

var $72b7b08f4e3f23c8$var$_inherits2 = $3Npdz((parcelRequire("4QWF4")));

var $72b7b08f4e3f23c8$var$_possibleConstructorReturn2 = $3Npdz((parcelRequire("kTHGs")));

var $72b7b08f4e3f23c8$var$_getPrototypeOf2 = $3Npdz((parcelRequire("6MmOk")));

var $72b7b08f4e3f23c8$var$_ParseObject2 = $3Npdz((parcelRequire("2HIpX")));
function $72b7b08f4e3f23c8$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $72b7b08f4e3f23c8$var$_isNativeReflectConstruct();
    return function() {
        var Super = (0, $72b7b08f4e3f23c8$var$_getPrototypeOf2.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $72b7b08f4e3f23c8$var$_getPrototypeOf2.default)(this).constructor;
            result = $dwGVc(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $72b7b08f4e3f23c8$var$_possibleConstructorReturn2.default)(this, result);
    };
}
function $72b7b08f4e3f23c8$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !$dwGVc) return false;
    if ($dwGVc.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($dwGVc(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $72b7b08f4e3f23c8$var$Installation = /*#__PURE__*/ function(_ParseObject) {
    (0, $72b7b08f4e3f23c8$var$_inherits2.default)(Installation, _ParseObject);
    var _super = $72b7b08f4e3f23c8$var$_createSuper(Installation);
    function Installation(attributes) {
        var _this;
        (0, $72b7b08f4e3f23c8$var$_classCallCheck2.default)(this, Installation);
        _this = _super.call(this, "_Installation");
        if (attributes && (0, $72b7b08f4e3f23c8$var$_typeof2.default)(attributes) === "object") {
            if (!_this.set(attributes || {})) throw new Error("Can't create an invalid Installation");
        }
        return _this;
    }
    return (0, $72b7b08f4e3f23c8$var$_createClass2.default)(Installation);
}($72b7b08f4e3f23c8$var$_ParseObject2.default);
module.exports.default = $72b7b08f4e3f23c8$var$Installation;
$72b7b08f4e3f23c8$var$_ParseObject2.default.registerSubclass("_Installation", $72b7b08f4e3f23c8$var$Installation);

});

parcelRequire.register("fkiJv", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $iY2ec = parcelRequire("iY2ec");


var $iWJ3a = parcelRequire("iWJ3a");

var $akViX = parcelRequire("akViX");

var $jZGC2 = parcelRequire("jZGC2");

var $cO2y8 = parcelRequire("cO2y8");

var $dvfqn = parcelRequire("dvfqn");

var $evY07 = parcelRequire("evY07");


var $liESz = parcelRequire("liESz");

var $ebK4m = parcelRequire("ebK4m");


var $fG1Ke = parcelRequire("fG1Ke");

var $b287413b22dc453d$var$_find = $3Npdz((parcelRequire("jGOxU")));

var $b287413b22dc453d$var$_from = $3Npdz((parcelRequire("5hSqA")));

var $b287413b22dc453d$var$_map = $3Npdz((parcelRequire("hqsP5")));

var $b287413b22dc453d$var$_isArray = $3Npdz((parcelRequire("i0kCX")));

var $b287413b22dc453d$var$_regenerator = $3Npdz((parcelRequire("iSrvj")));

var $b287413b22dc453d$var$_keys2 = $3Npdz((parcelRequire("gKrgO")));

var $b287413b22dc453d$var$_startsWith = $3Npdz((parcelRequire("fgj1z")));

var $b287413b22dc453d$var$_keys3 = $3Npdz((parcelRequire("r9mpE")));

var $b287413b22dc453d$var$_includes = $3Npdz((parcelRequire("aUw0k")));

var $b287413b22dc453d$var$_filter = $3Npdz((parcelRequire("kYm0J")));

var $b287413b22dc453d$var$_concat = $3Npdz((parcelRequire("3mvQI")));

var $b287413b22dc453d$var$_set = $3Npdz((parcelRequire("g4Tgs")));

var $b287413b22dc453d$var$_toConsumableArray2 = $3Npdz((parcelRequire("6VZVY")));

var $b287413b22dc453d$var$_promise = $3Npdz((parcelRequire("bCWDe")));

var $b287413b22dc453d$var$_slicedToArray2 = $3Npdz((parcelRequire("5kSp4")));

var $b287413b22dc453d$var$_asyncToGenerator2 = $3Npdz((parcelRequire("iqZS2")));

var $b287413b22dc453d$var$_CoreManager = $3Npdz((parcelRequire("465CW")));

var $b287413b22dc453d$var$_ParseQuery = $3Npdz((parcelRequire("eJCLn")));

var $7Icwu = parcelRequire("7Icwu");
function $b287413b22dc453d$var$_regeneratorRuntime() {
    "use strict";
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ $b287413b22dc453d$var$_regeneratorRuntime = function() {
        return exports;
    };
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof $ebK4m ? $ebK4m : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return $evY07(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = $dvfqn(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return generator._invoke = function(innerFn, self, context) {
            var state = "suspendedStart";
            return function(method, arg) {
                if ("executing" === state) throw new Error("Generator is already running");
                if ("completed" === state) {
                    if ("throw" === method) throw arg;
                    return doneResult();
                }
                for(context.method = method, context.arg = arg;;){
                    var delegate = context.delegate;
                    if (delegate) {
                        var delegateResult = maybeInvokeDelegate(delegate, context);
                        if (delegateResult) {
                            if (delegateResult === ContinueSentinel) continue;
                            return delegateResult;
                        }
                    }
                    if ("next" === context.method) context.sent = context._sent = context.arg;
                    else if ("throw" === context.method) {
                        if ("suspendedStart" === state) throw state = "completed", context.arg;
                        context.dispatchException(context.arg);
                    } else "return" === context.method && context.abrupt("return", context.arg);
                    state = "executing";
                    var record = tryCatch(innerFn, self, context);
                    if ("normal" === record.type) {
                        if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                        return {
                            value: record.arg,
                            done: context.done
                        };
                    }
                    "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
                }
            };
        }(innerFn, self, context), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = $cO2y8, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = $dvfqn(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        var _context19;
        $jZGC2(_context19 = [
            "next",
            "throw",
            "return"
        ]).call(_context19, function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == $akViX(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        this._invoke = function(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];
        if (undefined === method) {
            if (context.delegate = null, "throw" === context.method) {
                if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
                context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], $jZGC2(tryLocsList).call(tryLocsList, pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;){
                        if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    }
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return $iWJ3a ? $iWJ3a(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = $dvfqn(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = (parcelRequire("bCWDe")));
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(object) {
        var keys = [];
        for(var key in object)keys.push(key);
        return $iY2ec(keys).call(keys), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            var _context20;
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, $jZGC2(_context20 = this.tryEntries).call(_context20, resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+$fG1Ke(name).call(name, 1)) && (this[name] = undefined);
        },
        stop: function() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
function $b287413b22dc453d$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof $ebK4m !== "undefined" && $liESz(o) || o["@@iterator"];
    if (!it) {
        if ((parcelRequire("i0kCX"))(o) || (it = $b287413b22dc453d$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function() {};
            return {
                s: F,
                n: function() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function() {
            it = it.call(o);
        },
        n: function() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $b287413b22dc453d$var$_unsupportedIterableToArray(o, minLen) {
    var _context18;
    if (!o) return;
    if (typeof o === "string") return $b287413b22dc453d$var$_arrayLikeToArray(o, minLen);
    var n = $fG1Ke(_context18 = Object.prototype.toString.call(o)).call(_context18, 8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return (parcelRequire("5hSqA"))(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b287413b22dc453d$var$_arrayLikeToArray(o, minLen);
}
function $b287413b22dc453d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
/**
 * Provides a local datastore which can be used to store and retrieve <code>Parse.Object</code>. <br />
 * To enable this functionality, call <code>Parse.enableLocalDatastore()</code>.
 *
 * Pin object to add to local datastore
 *
 * <pre>await object.pin();</pre>
 * <pre>await object.pinWithName('pinName');</pre>
 *
 * Query pinned objects
 *
 * <pre>query.fromLocalDatastore();</pre>
 * <pre>query.fromPin();</pre>
 * <pre>query.fromPinWithName();</pre>
 *
 * <pre>const localObjects = await query.find();</pre>
 *
 * @class Parse.LocalDatastore
 * @static
 */ var $b287413b22dc453d$var$LocalDatastore = {
    isEnabled: false,
    isSyncing: false,
    fromPinWithName: function(name) /*: Promise<Array<Object>>*/ {
        var controller = $b287413b22dc453d$var$_CoreManager.default.getLocalDatastoreController();
        return controller.fromPinWithName(name);
    },
    pinWithName: function(name, value) /*: Promise<void>*/ {
        var controller = $b287413b22dc453d$var$_CoreManager.default.getLocalDatastoreController();
        return controller.pinWithName(name, value);
    },
    unPinWithName: function(name) /*: Promise<void>*/ {
        var controller = $b287413b22dc453d$var$_CoreManager.default.getLocalDatastoreController();
        return controller.unPinWithName(name);
    },
    _getAllContents: function() /*: Promise<Object>*/ {
        var controller = $b287413b22dc453d$var$_CoreManager.default.getLocalDatastoreController();
        return controller.getAllContents();
    },
    // Use for testing
    _getRawStorage: function() /*: Promise<Object>*/ {
        var controller = $b287413b22dc453d$var$_CoreManager.default.getLocalDatastoreController();
        return controller.getRawStorage();
    },
    _clear: function() /*: Promise<void>*/ {
        var controller = $b287413b22dc453d$var$_CoreManager.default.getLocalDatastoreController();
        return controller.clear();
    },
    // Pin the object and children recursively
    // Saves the object and children key to Pin Name
    _handlePinAllWithName: function(name, objects) /*: Promise<void>*/ {
        var _this = this;
        return (0, $b287413b22dc453d$var$_asyncToGenerator2.default)(/*#__PURE__*/ $b287413b22dc453d$var$_regeneratorRuntime().mark(function _callee() {
            var _context;
            var pinName, toPinPromises, objectKeys, _iterator, _step, parent, children, parentKey, json, objectKey, fromPinPromise, _yield$Promise$all, _yield$Promise$all2, pinned, toPin;
            return $b287413b22dc453d$var$_regeneratorRuntime().wrap(function _callee$(_context2) {
                while(true)switch(_context2.prev = _context2.next){
                    case 0:
                        pinName = _this.getPinName(name);
                        toPinPromises = [];
                        objectKeys = [];
                        _iterator = $b287413b22dc453d$var$_createForOfIteratorHelper(objects);
                        try {
                            for(_iterator.s(); !(_step = _iterator.n()).done;){
                                parent = _step.value;
                                children = _this._getChildren(parent);
                                parentKey = _this.getKeyForObject(parent);
                                json = parent._toFullJSON(undefined, true);
                                if (parent._localId) json._localId = parent._localId;
                                children[parentKey] = json;
                                for(objectKey in children){
                                    objectKeys.push(objectKey);
                                    toPinPromises.push(_this.pinWithName(objectKey, [
                                        children[objectKey]
                                    ]));
                                }
                            }
                        } catch (err) {
                            _iterator.e(err);
                        } finally{
                            _iterator.f();
                        }
                        fromPinPromise = _this.fromPinWithName(pinName);
                        _context2.next = 8;
                        return $b287413b22dc453d$var$_promise.default.all([
                            fromPinPromise,
                            toPinPromises
                        ]);
                    case 8:
                        _yield$Promise$all = _context2.sent;
                        _yield$Promise$all2 = (0, $b287413b22dc453d$var$_slicedToArray2.default)(_yield$Promise$all, 1);
                        pinned = _yield$Promise$all2[0];
                        toPin = (0, $b287413b22dc453d$var$_toConsumableArray2.default)(new $b287413b22dc453d$var$_set.default((0, $b287413b22dc453d$var$_concat.default)(_context = []).call(_context, (0, $b287413b22dc453d$var$_toConsumableArray2.default)(pinned || []), objectKeys)));
                        return _context2.abrupt("return", _this.pinWithName(pinName, toPin));
                    case 13:
                    case "end":
                        return _context2.stop();
                }
            }, _callee);
        }))();
    },
    // Removes object and children keys from pin name
    // Keeps the object and children pinned
    _handleUnPinAllWithName: function _handleUnPinAllWithName(name, objects) {
        var _this2 = this;
        return (0, $b287413b22dc453d$var$_asyncToGenerator2.default)(/*#__PURE__*/ $b287413b22dc453d$var$_regeneratorRuntime().mark(function _callee2() {
            var localDatastore, pinName, promises, objectKeys, _iterator2, _step2, _objectKeys, _context3, parent, children, parentKey, pinned, _iterator3, _step3, objectKey, hasReference, key, pinnedObjects;
            return $b287413b22dc453d$var$_regeneratorRuntime().wrap(function _callee2$(_context4) {
                while(true)switch(_context4.prev = _context4.next){
                    case 0:
                        _context4.next = 2;
                        return _this2._getAllContents();
                    case 2:
                        localDatastore = _context4.sent;
                        pinName = _this2.getPinName(name);
                        promises = [];
                        objectKeys = [];
                        _iterator2 = $b287413b22dc453d$var$_createForOfIteratorHelper(objects);
                        try {
                            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                parent = _step2.value;
                                children = _this2._getChildren(parent);
                                parentKey = _this2.getKeyForObject(parent);
                                (_objectKeys = objectKeys).push.apply(_objectKeys, (0, $b287413b22dc453d$var$_concat.default)(_context3 = [
                                    parentKey
                                ]).call(_context3, (0, $b287413b22dc453d$var$_toConsumableArray2.default)((0, $b287413b22dc453d$var$_keys3.default)(children))));
                            }
                        } catch (err) {
                            _iterator2.e(err);
                        } finally{
                            _iterator2.f();
                        }
                        objectKeys = (0, $b287413b22dc453d$var$_toConsumableArray2.default)(new $b287413b22dc453d$var$_set.default(objectKeys));
                        pinned = localDatastore[pinName] || [];
                        pinned = (0, $b287413b22dc453d$var$_filter.default)(pinned).call(pinned, function(item) {
                            return !(0, $b287413b22dc453d$var$_includes.default)(objectKeys).call(objectKeys, item);
                        });
                        if (pinned.length == 0) {
                            promises.push(_this2.unPinWithName(pinName));
                            delete localDatastore[pinName];
                        } else {
                            promises.push(_this2.pinWithName(pinName, pinned));
                            localDatastore[pinName] = pinned;
                        }
                        _iterator3 = $b287413b22dc453d$var$_createForOfIteratorHelper(objectKeys);
                        _context4.prev = 13;
                        _iterator3.s();
                    case 15:
                        if ((_step3 = _iterator3.n()).done) {
                            _context4.next = 31;
                            break;
                        }
                        objectKey = _step3.value;
                        hasReference = false;
                        _context4.t0 = (0, $b287413b22dc453d$var$_keys2.default)($b287413b22dc453d$var$_regenerator.default).call($b287413b22dc453d$var$_regenerator.default, localDatastore);
                    case 19:
                        if ((_context4.t1 = _context4.t0()).done) {
                            _context4.next = 28;
                            break;
                        }
                        key = _context4.t1.value;
                        if (!(key === $7Icwu.DEFAULT_PIN || (0, $b287413b22dc453d$var$_startsWith.default)(key).call(key, $7Icwu.PIN_PREFIX))) {
                            _context4.next = 26;
                            break;
                        }
                        pinnedObjects = localDatastore[key] || [];
                        if (!(0, $b287413b22dc453d$var$_includes.default)(pinnedObjects).call(pinnedObjects, objectKey)) {
                            _context4.next = 26;
                            break;
                        }
                        hasReference = true;
                        return _context4.abrupt("break", 28);
                    case 26:
                        _context4.next = 19;
                        break;
                    case 28:
                        if (!hasReference) promises.push(_this2.unPinWithName(objectKey));
                    case 29:
                        _context4.next = 15;
                        break;
                    case 31:
                        _context4.next = 36;
                        break;
                    case 33:
                        _context4.prev = 33;
                        _context4.t2 = _context4["catch"](13);
                        _iterator3.e(_context4.t2);
                    case 36:
                        _context4.prev = 36;
                        _iterator3.f();
                        return _context4.finish(36);
                    case 39:
                        return _context4.abrupt("return", $b287413b22dc453d$var$_promise.default.all(promises));
                    case 40:
                    case "end":
                        return _context4.stop();
                }
            }, _callee2, null, [
                [
                    13,
                    33,
                    36,
                    39
                ]
            ]);
        }))();
    },
    // Retrieve all pointer fields from object recursively
    _getChildren: function _getChildren(object) {
        var encountered = {};
        var json = object._toFullJSON(undefined, true);
        for(var key in json)if (json[key] && json[key].__type && json[key].__type === "Object") this._traverse(json[key], encountered);
        return encountered;
    },
    _traverse: function _traverse(object, encountered) {
        if (!object.objectId) return;
        else {
            var objectKey = this.getKeyForObject(object);
            if (encountered[objectKey]) return;
            encountered[objectKey] = object;
        }
        for(var key in object){
            var json = object[key];
            if (!object[key]) json = object;
            if (json.__type && json.__type === "Object") this._traverse(json, encountered);
        }
    },
    // Transform keys in pin name to objects
    _serializeObjectsFromPinName: function _serializeObjectsFromPinName(name) {
        var _this3 = this;
        return (0, $b287413b22dc453d$var$_asyncToGenerator2.default)(/*#__PURE__*/ $b287413b22dc453d$var$_regeneratorRuntime().mark(function _callee3() {
            var _context5, _concatInstanceProper, _context6;
            var localDatastore, allObjects, key, pinName, pinned, promises, objects;
            return $b287413b22dc453d$var$_regeneratorRuntime().wrap(function _callee3$(_context7) {
                while(true)switch(_context7.prev = _context7.next){
                    case 0:
                        _context7.next = 2;
                        return _this3._getAllContents();
                    case 2:
                        localDatastore = _context7.sent;
                        allObjects = [];
                        for(key in localDatastore)if ((0, $b287413b22dc453d$var$_startsWith.default)(key).call(key, $7Icwu.OBJECT_PREFIX)) allObjects.push(localDatastore[key][0]);
                        if (name) {
                            _context7.next = 7;
                            break;
                        }
                        return _context7.abrupt("return", allObjects);
                    case 7:
                        pinName = _this3.getPinName(name);
                        pinned = localDatastore[pinName];
                        if ((0, $b287413b22dc453d$var$_isArray.default)(pinned)) {
                            _context7.next = 11;
                            break;
                        }
                        return _context7.abrupt("return", []);
                    case 11:
                        promises = (0, $b287413b22dc453d$var$_map.default)(pinned).call(pinned, function(objectKey) {
                            return _this3.fromPinWithName(objectKey);
                        });
                        _context7.next = 14;
                        return $b287413b22dc453d$var$_promise.default.all(promises);
                    case 14:
                        objects = _context7.sent;
                        objects = (_concatInstanceProper = (0, $b287413b22dc453d$var$_concat.default)(_context5 = [])).call.apply(_concatInstanceProper, (0, $b287413b22dc453d$var$_concat.default)(_context6 = [
                            _context5
                        ]).call(_context6, (0, $b287413b22dc453d$var$_toConsumableArray2.default)(objects)));
                        return _context7.abrupt("return", (0, $b287413b22dc453d$var$_filter.default)(objects).call(objects, function(object) {
                            return object != null;
                        }));
                    case 17:
                    case "end":
                        return _context7.stop();
                }
            }, _callee3);
        }))();
    },
    // Replaces object pointers with pinned pointers
    // The object pointers may contain old data
    // Uses Breadth First Search Algorithm
    _serializeObject: function _serializeObject(objectKey, localDatastore) {
        var _this4 = this;
        return (0, $b287413b22dc453d$var$_asyncToGenerator2.default)(/*#__PURE__*/ $b287413b22dc453d$var$_regeneratorRuntime().mark(function _callee4() {
            var LDS, root, queue, meta, uniqueId, nodeId, subTreeRoot, field, value, key, pointer;
            return $b287413b22dc453d$var$_regeneratorRuntime().wrap(function _callee4$(_context8) {
                while(true)switch(_context8.prev = _context8.next){
                    case 0:
                        LDS = localDatastore;
                        if (LDS) {
                            _context8.next = 5;
                            break;
                        }
                        _context8.next = 4;
                        return _this4._getAllContents();
                    case 4:
                        LDS = _context8.sent;
                    case 5:
                        if (!(!LDS[objectKey] || LDS[objectKey].length === 0)) {
                            _context8.next = 7;
                            break;
                        }
                        return _context8.abrupt("return", null);
                    case 7:
                        root = LDS[objectKey][0];
                        queue = [];
                        meta = {};
                        uniqueId = 0;
                        meta[uniqueId] = root;
                        queue.push(uniqueId);
                        while(queue.length !== 0){
                            nodeId = queue.shift();
                            subTreeRoot = meta[nodeId];
                            for(field in subTreeRoot){
                                value = subTreeRoot[field];
                                if (value.__type && value.__type === "Object") {
                                    key = _this4.getKeyForObject(value);
                                    if (LDS[key] && LDS[key].length > 0) {
                                        pointer = LDS[key][0];
                                        uniqueId++;
                                        meta[uniqueId] = pointer;
                                        subTreeRoot[field] = pointer;
                                        queue.push(uniqueId);
                                    }
                                }
                            }
                        }
                        return _context8.abrupt("return", root);
                    case 15:
                    case "end":
                        return _context8.stop();
                }
            }, _callee4);
        }))();
    },
    // Called when an object is save / fetched
    // Update object pin value
    _updateObjectIfPinned: function _updateObjectIfPinned(object) /*: Promise<void>*/ {
        var _this5 = this;
        return (0, $b287413b22dc453d$var$_asyncToGenerator2.default)(/*#__PURE__*/ $b287413b22dc453d$var$_regeneratorRuntime().mark(function _callee5() {
            var objectKey, pinned;
            return $b287413b22dc453d$var$_regeneratorRuntime().wrap(function _callee5$(_context9) {
                while(true)switch(_context9.prev = _context9.next){
                    case 0:
                        if (_this5.isEnabled) {
                            _context9.next = 2;
                            break;
                        }
                        return _context9.abrupt("return");
                    case 2:
                        objectKey = _this5.getKeyForObject(object);
                        _context9.next = 5;
                        return _this5.fromPinWithName(objectKey);
                    case 5:
                        pinned = _context9.sent;
                        if (!(!pinned || pinned.length === 0)) {
                            _context9.next = 8;
                            break;
                        }
                        return _context9.abrupt("return");
                    case 8:
                        return _context9.abrupt("return", _this5.pinWithName(objectKey, [
                            object._toFullJSON()
                        ]));
                    case 9:
                    case "end":
                        return _context9.stop();
                }
            }, _callee5);
        }))();
    },
    // Called when object is destroyed
    // Unpin object and remove all references from pin names
    // TODO: Destroy children?
    _destroyObjectIfPinned: function _destroyObjectIfPinned(object) {
        var _this6 = this;
        return (0, $b287413b22dc453d$var$_asyncToGenerator2.default)(/*#__PURE__*/ $b287413b22dc453d$var$_regeneratorRuntime().mark(function _callee6() {
            var localDatastore, objectKey, pin, promises, key, pinned;
            return $b287413b22dc453d$var$_regeneratorRuntime().wrap(function _callee6$(_context10) {
                while(true)switch(_context10.prev = _context10.next){
                    case 0:
                        if (_this6.isEnabled) {
                            _context10.next = 2;
                            break;
                        }
                        return _context10.abrupt("return");
                    case 2:
                        _context10.next = 4;
                        return _this6._getAllContents();
                    case 4:
                        localDatastore = _context10.sent;
                        objectKey = _this6.getKeyForObject(object);
                        pin = localDatastore[objectKey];
                        if (pin) {
                            _context10.next = 9;
                            break;
                        }
                        return _context10.abrupt("return");
                    case 9:
                        promises = [
                            _this6.unPinWithName(objectKey)
                        ];
                        delete localDatastore[objectKey];
                        for(key in localDatastore)if (key === $7Icwu.DEFAULT_PIN || (0, $b287413b22dc453d$var$_startsWith.default)(key).call(key, $7Icwu.PIN_PREFIX)) {
                            pinned = localDatastore[key] || [];
                            if ((0, $b287413b22dc453d$var$_includes.default)(pinned).call(pinned, objectKey)) {
                                pinned = (0, $b287413b22dc453d$var$_filter.default)(pinned).call(pinned, function(item) {
                                    return item !== objectKey;
                                });
                                if (pinned.length == 0) {
                                    promises.push(_this6.unPinWithName(key));
                                    delete localDatastore[key];
                                } else {
                                    promises.push(_this6.pinWithName(key, pinned));
                                    localDatastore[key] = pinned;
                                }
                            }
                        }
                        return _context10.abrupt("return", $b287413b22dc453d$var$_promise.default.all(promises));
                    case 13:
                    case "end":
                        return _context10.stop();
                }
            }, _callee6);
        }))();
    },
    // Update pin and references of the unsaved object
    _updateLocalIdForObject: function _updateLocalIdForObject(localId, object) {
        var _this7 = this;
        return (0, $b287413b22dc453d$var$_asyncToGenerator2.default)(/*#__PURE__*/ $b287413b22dc453d$var$_regeneratorRuntime().mark(function _callee7() {
            var _context11, _context12;
            var localKey, objectKey, unsaved, promises, localDatastore, key, pinned;
            return $b287413b22dc453d$var$_regeneratorRuntime().wrap(function _callee7$(_context13) {
                while(true)switch(_context13.prev = _context13.next){
                    case 0:
                        if (_this7.isEnabled) {
                            _context13.next = 2;
                            break;
                        }
                        return _context13.abrupt("return");
                    case 2:
                        localKey = (0, $b287413b22dc453d$var$_concat.default)(_context11 = (0, $b287413b22dc453d$var$_concat.default)(_context12 = "".concat($7Icwu.OBJECT_PREFIX)).call(_context12, object.className, "_")).call(_context11, localId);
                        objectKey = _this7.getKeyForObject(object);
                        _context13.next = 6;
                        return _this7.fromPinWithName(localKey);
                    case 6:
                        unsaved = _context13.sent;
                        if (!(!unsaved || unsaved.length === 0)) {
                            _context13.next = 9;
                            break;
                        }
                        return _context13.abrupt("return");
                    case 9:
                        promises = [
                            _this7.unPinWithName(localKey),
                            _this7.pinWithName(objectKey, unsaved)
                        ];
                        _context13.next = 12;
                        return _this7._getAllContents();
                    case 12:
                        localDatastore = _context13.sent;
                        for(key in localDatastore)if (key === $7Icwu.DEFAULT_PIN || (0, $b287413b22dc453d$var$_startsWith.default)(key).call(key, $7Icwu.PIN_PREFIX)) {
                            pinned = localDatastore[key] || [];
                            if ((0, $b287413b22dc453d$var$_includes.default)(pinned).call(pinned, localKey)) {
                                pinned = (0, $b287413b22dc453d$var$_filter.default)(pinned).call(pinned, function(item) {
                                    return item !== localKey;
                                });
                                pinned.push(objectKey);
                                promises.push(_this7.pinWithName(key, pinned));
                                localDatastore[key] = pinned;
                            }
                        }
                        return _context13.abrupt("return", $b287413b22dc453d$var$_promise.default.all(promises));
                    case 15:
                    case "end":
                        return _context13.stop();
                }
            }, _callee7);
        }))();
    },
    /**
   * Updates Local Datastore from Server
   *
   * <pre>
   * await Parse.LocalDatastore.updateFromServer();
   * </pre>
   *
   * @function updateFromServer
   * @name Parse.LocalDatastore.updateFromServer
   * @static
   */ updateFromServer: function updateFromServer() {
        var _this8 = this;
        return (0, $b287413b22dc453d$var$_asyncToGenerator2.default)(/*#__PURE__*/ $b287413b22dc453d$var$_regeneratorRuntime().mark(function _callee8() {
            var _context14;
            var localDatastore, keys, key, pointersHash, _i, _keys, _key, _key$split, _key$split2, className, objectId, queryPromises, responses, objects, pinPromises;
            return $b287413b22dc453d$var$_regeneratorRuntime().wrap(function _callee8$(_context15) {
                while(true)switch(_context15.prev = _context15.next){
                    case 0:
                        if (!(!_this8.checkIfEnabled() || _this8.isSyncing)) {
                            _context15.next = 2;
                            break;
                        }
                        return _context15.abrupt("return");
                    case 2:
                        _context15.next = 4;
                        return _this8._getAllContents();
                    case 4:
                        localDatastore = _context15.sent;
                        keys = [];
                        for(key in localDatastore)if ((0, $b287413b22dc453d$var$_startsWith.default)(key).call(key, $7Icwu.OBJECT_PREFIX)) keys.push(key);
                        if (!(keys.length === 0)) {
                            _context15.next = 9;
                            break;
                        }
                        return _context15.abrupt("return");
                    case 9:
                        _this8.isSyncing = true;
                        pointersHash = {};
                        _i = 0, _keys = keys;
                    case 12:
                        if (!(_i < _keys.length)) {
                            _context15.next = 23;
                            break;
                        }
                        _key = _keys[_i]; // Ignore the OBJECT_PREFIX
                        _key$split = _key.split("_"), _key$split2 = (0, $b287413b22dc453d$var$_slicedToArray2.default)(_key$split, 4), className = _key$split2[2], objectId = _key$split2[3]; // User key is split into [ 'Parse', 'LDS', '', 'User', 'objectId' ]
                        if (_key.split("_").length === 5 && _key.split("_")[3] === "User") {
                            className = "_User";
                            objectId = _key.split("_")[4];
                        }
                        if (!(0, $b287413b22dc453d$var$_startsWith.default)(objectId).call(objectId, "local")) {
                            _context15.next = 18;
                            break;
                        }
                        return _context15.abrupt("continue", 20);
                    case 18:
                        if (!(className in pointersHash)) pointersHash[className] = new $b287413b22dc453d$var$_set.default();
                        pointersHash[className].add(objectId);
                    case 20:
                        _i++;
                        _context15.next = 12;
                        break;
                    case 23:
                        queryPromises = (0, $b287413b22dc453d$var$_map.default)(_context14 = (0, $b287413b22dc453d$var$_keys3.default)(pointersHash)).call(_context14, function(className) {
                            var objectIds = (0, $b287413b22dc453d$var$_from.default)(pointersHash[className]);
                            var query = new $b287413b22dc453d$var$_ParseQuery.default(className);
                            query.limit(objectIds.length);
                            if (objectIds.length === 1) query.equalTo("objectId", objectIds[0]);
                            else query.containedIn("objectId", objectIds);
                            return (0, $b287413b22dc453d$var$_find.default)(query).call(query);
                        });
                        _context15.prev = 24;
                        _context15.next = 27;
                        return $b287413b22dc453d$var$_promise.default.all(queryPromises);
                    case 27:
                        responses = _context15.sent;
                        objects = (0, $b287413b22dc453d$var$_concat.default)([]).apply([], responses);
                        pinPromises = (0, $b287413b22dc453d$var$_map.default)(objects).call(objects, function(object) {
                            var objectKey = _this8.getKeyForObject(object);
                            return _this8.pinWithName(objectKey, object._toFullJSON());
                        });
                        _context15.next = 32;
                        return $b287413b22dc453d$var$_promise.default.all(pinPromises);
                    case 32:
                        _this8.isSyncing = false;
                        _context15.next = 39;
                        break;
                    case 35:
                        _context15.prev = 35;
                        _context15.t0 = _context15["catch"](24);
                        console.error("Error syncing LocalDatastore: ", _context15.t0);
                        _this8.isSyncing = false;
                    case 39:
                    case "end":
                        return _context15.stop();
                }
            }, _callee8, null, [
                [
                    24,
                    35
                ]
            ]);
        }))();
    },
    getKeyForObject: function getKeyForObject(object) {
        var _context16, _context17;
        var objectId = object.objectId || object._getId();
        return (0, $b287413b22dc453d$var$_concat.default)(_context16 = (0, $b287413b22dc453d$var$_concat.default)(_context17 = "".concat($7Icwu.OBJECT_PREFIX)).call(_context17, object.className, "_")).call(_context16, objectId);
    },
    getPinName: function getPinName(pinName) {
        if (!pinName || pinName === $7Icwu.DEFAULT_PIN) return $7Icwu.DEFAULT_PIN;
        return $7Icwu.PIN_PREFIX + pinName;
    },
    checkIfEnabled: function checkIfEnabled() {
        if (!this.isEnabled) console.error("Parse.enableLocalDatastore() must be called first");
        return this.isEnabled;
    }
};
module.exports = $b287413b22dc453d$var$LocalDatastore;

$b287413b22dc453d$var$_CoreManager.default.setLocalDatastoreController((parcelRequire("5iV8J")));
$b287413b22dc453d$var$_CoreManager.default.setLocalDatastore($b287413b22dc453d$var$LocalDatastore);

});
parcelRequire.register("iSrvj", function(module, exports) {

module.exports = (parcelRequire("2TvXO"));

});
parcelRequire.register("2TvXO", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $21b983287c82ebd3$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next mehtod, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return {
            next: doneResult
        };
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, module.exports));
try {
    regeneratorRuntime = $21b983287c82ebd3$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $21b983287c82ebd3$var$runtime;
    else Function("r", "regeneratorRuntime = r")($21b983287c82ebd3$var$runtime);
}

});


parcelRequire.register("g4Tgs", function(module, exports) {

module.exports = (parcelRequire("88bh5"));

});
parcelRequire.register("88bh5", function(module, exports) {

var $fnLeC = parcelRequire("fnLeC");
parcelRequire("4YdnW");
module.exports = $fnLeC;

});
parcelRequire.register("fnLeC", function(module, exports) {
parcelRequire("4IarS");
parcelRequire("edOxo");
parcelRequire("6CUex");
parcelRequire("5cfBr");

var $envPC = parcelRequire("envPC");
module.exports = $envPC.Set;

});
parcelRequire.register("6CUex", function(module, exports) {
// TODO: Remove this module from `core-js@4` since it's replaced to module below
parcelRequire("etE4L");

});
parcelRequire.register("etE4L", function(module, exports) {
"use strict";

var $7naRP = parcelRequire("7naRP");

var $8bzCn = parcelRequire("8bzCn");
// `Set` constructor
// https://tc39.es/ecma262/#sec-set-objects
$7naRP("Set", function(init) {
    return function Set() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
}, $8bzCn);

});





parcelRequire.register("5iV8J", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $i0kCX = parcelRequire("i0kCX");

var $liESz = parcelRequire("liESz");

var $5hSqA = parcelRequire("5hSqA");

var $fG1Ke = parcelRequire("fG1Ke");

var $iY2ec = parcelRequire("iY2ec");


var $iWJ3a = parcelRequire("iWJ3a");

var $akViX = parcelRequire("akViX");

var $jZGC2 = parcelRequire("jZGC2");

var $cO2y8 = parcelRequire("cO2y8");

var $dvfqn = parcelRequire("dvfqn");

var $evY07 = parcelRequire("evY07");

var $ebK4m = parcelRequire("ebK4m");

var $3dcaf4fcb197d831$var$_map = $3Npdz((parcelRequire("hqsP5")));

var $3dcaf4fcb197d831$var$_promise = $3Npdz((parcelRequire("bCWDe")));

var $3dcaf4fcb197d831$var$_reduce = $3Npdz((parcelRequire("ki92O")));

var $3dcaf4fcb197d831$var$_stringify = $3Npdz((parcelRequire("O2sNs")));

var $3dcaf4fcb197d831$var$_asyncToGenerator2 = $3Npdz((parcelRequire("iqZS2")));

var $7Icwu = parcelRequire("7Icwu");

var $3dcaf4fcb197d831$var$_Storage = $3Npdz((parcelRequire("7Zbj0")));
function $3dcaf4fcb197d831$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof $ebK4m !== "undefined" && $liESz(o) || o["@@iterator"];
    if (!it) {
        if ($i0kCX(o) || (it = $3dcaf4fcb197d831$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function() {};
            return {
                s: F,
                n: function() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function() {
            it = it.call(o);
        },
        n: function() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $3dcaf4fcb197d831$var$_unsupportedIterableToArray(o, minLen) {
    var _context9;
    if (!o) return;
    if (typeof o === "string") return $3dcaf4fcb197d831$var$_arrayLikeToArray(o, minLen);
    var n = $fG1Ke(_context9 = Object.prototype.toString.call(o)).call(_context9, 8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return $5hSqA(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3dcaf4fcb197d831$var$_arrayLikeToArray(o, minLen);
}
function $3dcaf4fcb197d831$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3dcaf4fcb197d831$var$_regeneratorRuntime() {
    "use strict";
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ $3dcaf4fcb197d831$var$_regeneratorRuntime = function() {
        return exports;
    };
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof $ebK4m ? $ebK4m : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return $evY07(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = $dvfqn(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return generator._invoke = function(innerFn, self, context) {
            var state = "suspendedStart";
            return function(method, arg) {
                if ("executing" === state) throw new Error("Generator is already running");
                if ("completed" === state) {
                    if ("throw" === method) throw arg;
                    return doneResult();
                }
                for(context.method = method, context.arg = arg;;){
                    var delegate = context.delegate;
                    if (delegate) {
                        var delegateResult = maybeInvokeDelegate(delegate, context);
                        if (delegateResult) {
                            if (delegateResult === ContinueSentinel) continue;
                            return delegateResult;
                        }
                    }
                    if ("next" === context.method) context.sent = context._sent = context.arg;
                    else if ("throw" === context.method) {
                        if ("suspendedStart" === state) throw state = "completed", context.arg;
                        context.dispatchException(context.arg);
                    } else "return" === context.method && context.abrupt("return", context.arg);
                    state = "executing";
                    var record = tryCatch(innerFn, self, context);
                    if ("normal" === record.type) {
                        if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                        return {
                            value: record.arg,
                            done: context.done
                        };
                    }
                    "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
                }
            };
        }(innerFn, self, context), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = $cO2y8, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = $dvfqn(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        var _context7;
        $jZGC2(_context7 = [
            "next",
            "throw",
            "return"
        ]).call(_context7, function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == $akViX(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        this._invoke = function(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];
        if (undefined === method) {
            if (context.delegate = null, "throw" === context.method) {
                if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
                context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], $jZGC2(tryLocsList).call(tryLocsList, pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;){
                        if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    }
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return $iWJ3a ? $iWJ3a(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = $dvfqn(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = (parcelRequire("bCWDe")));
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(object) {
        var keys = [];
        for(var key in object)keys.push(key);
        return $iY2ec(keys).call(keys), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            var _context8;
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, $jZGC2(_context8 = this.tryEntries).call(_context8, resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+$fG1Ke(name).call(name, 1)) && (this[name] = undefined);
        },
        stop: function() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
var $3dcaf4fcb197d831$var$LocalDatastoreController = {
    fromPinWithName: function(name) /*: Array<Object>*/ {
        return (0, $3dcaf4fcb197d831$var$_asyncToGenerator2.default)(/*#__PURE__*/ $3dcaf4fcb197d831$var$_regeneratorRuntime().mark(function _callee() {
            var values, objects;
            return $3dcaf4fcb197d831$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        _context.next = 2;
                        return $3dcaf4fcb197d831$var$_Storage.default.getItemAsync(name);
                    case 2:
                        values = _context.sent;
                        if (values) {
                            _context.next = 5;
                            break;
                        }
                        return _context.abrupt("return", []);
                    case 5:
                        objects = JSON.parse(values);
                        return _context.abrupt("return", objects);
                    case 7:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }))();
    },
    pinWithName: function pinWithName(name, value) {
        var values = (0, $3dcaf4fcb197d831$var$_stringify.default)(value);
        return $3dcaf4fcb197d831$var$_Storage.default.setItemAsync(name, values);
    },
    unPinWithName: function unPinWithName(name) {
        return $3dcaf4fcb197d831$var$_Storage.default.removeItemAsync(name);
    },
    getAllContents: function getAllContents() /*: Object*/ {
        return (0, $3dcaf4fcb197d831$var$_asyncToGenerator2.default)(/*#__PURE__*/ $3dcaf4fcb197d831$var$_regeneratorRuntime().mark(function _callee3() {
            var keys;
            return $3dcaf4fcb197d831$var$_regeneratorRuntime().wrap(function _callee3$(_context3) {
                while(true)switch(_context3.prev = _context3.next){
                    case 0:
                        _context3.next = 2;
                        return $3dcaf4fcb197d831$var$_Storage.default.getAllKeysAsync();
                    case 2:
                        keys = _context3.sent;
                        return _context3.abrupt("return", (0, $3dcaf4fcb197d831$var$_reduce.default)(keys).call(keys, /*#__PURE__*/ function() {
                            var _ref = (0, $3dcaf4fcb197d831$var$_asyncToGenerator2.default)(/*#__PURE__*/ $3dcaf4fcb197d831$var$_regeneratorRuntime().mark(function _callee2(previousPromise, key) {
                                var LDS, value;
                                return $3dcaf4fcb197d831$var$_regeneratorRuntime().wrap(function _callee2$(_context2) {
                                    while(true)switch(_context2.prev = _context2.next){
                                        case 0:
                                            _context2.next = 2;
                                            return previousPromise;
                                        case 2:
                                            LDS = _context2.sent;
                                            if (!(0, $7Icwu.isLocalDatastoreKey)(key)) {
                                                _context2.next = 8;
                                                break;
                                            }
                                            _context2.next = 6;
                                            return $3dcaf4fcb197d831$var$_Storage.default.getItemAsync(key);
                                        case 6:
                                            value = _context2.sent;
                                            try {
                                                LDS[key] = JSON.parse(value);
                                            } catch (error) {
                                                console.error("Error getAllContents: ", error);
                                            }
                                        case 8:
                                            return _context2.abrupt("return", LDS);
                                        case 9:
                                        case "end":
                                            return _context2.stop();
                                    }
                                }, _callee2);
                            }));
                            return function(_x, _x2) {
                                return _ref.apply(this, arguments);
                            };
                        }(), $3dcaf4fcb197d831$var$_promise.default.resolve({})));
                    case 4:
                    case "end":
                        return _context3.stop();
                }
            }, _callee3);
        }))();
    },
    // Used for testing
    getRawStorage: function getRawStorage() /*: Object*/ {
        return (0, $3dcaf4fcb197d831$var$_asyncToGenerator2.default)(/*#__PURE__*/ $3dcaf4fcb197d831$var$_regeneratorRuntime().mark(function _callee5() {
            var keys;
            return $3dcaf4fcb197d831$var$_regeneratorRuntime().wrap(function _callee5$(_context5) {
                while(true)switch(_context5.prev = _context5.next){
                    case 0:
                        _context5.next = 2;
                        return $3dcaf4fcb197d831$var$_Storage.default.getAllKeysAsync();
                    case 2:
                        keys = _context5.sent;
                        return _context5.abrupt("return", (0, $3dcaf4fcb197d831$var$_reduce.default)(keys).call(keys, /*#__PURE__*/ function() {
                            var _ref2 = (0, $3dcaf4fcb197d831$var$_asyncToGenerator2.default)(/*#__PURE__*/ $3dcaf4fcb197d831$var$_regeneratorRuntime().mark(function _callee4(previousPromise, key) {
                                var LDS, value;
                                return $3dcaf4fcb197d831$var$_regeneratorRuntime().wrap(function _callee4$(_context4) {
                                    while(true)switch(_context4.prev = _context4.next){
                                        case 0:
                                            _context4.next = 2;
                                            return previousPromise;
                                        case 2:
                                            LDS = _context4.sent;
                                            _context4.next = 5;
                                            return $3dcaf4fcb197d831$var$_Storage.default.getItemAsync(key);
                                        case 5:
                                            value = _context4.sent;
                                            LDS[key] = value;
                                            return _context4.abrupt("return", LDS);
                                        case 8:
                                        case "end":
                                            return _context4.stop();
                                    }
                                }, _callee4);
                            }));
                            return function(_x3, _x4) {
                                return _ref2.apply(this, arguments);
                            };
                        }(), $3dcaf4fcb197d831$var$_promise.default.resolve({})));
                    case 4:
                    case "end":
                        return _context5.stop();
                }
            }, _callee5);
        }))();
    },
    clear: function clear() /*: Promise*/ {
        var _this = this;
        return (0, $3dcaf4fcb197d831$var$_asyncToGenerator2.default)(/*#__PURE__*/ $3dcaf4fcb197d831$var$_regeneratorRuntime().mark(function _callee6() {
            var keys, toRemove, _iterator, _step, key, promises;
            return $3dcaf4fcb197d831$var$_regeneratorRuntime().wrap(function _callee6$(_context6) {
                while(true)switch(_context6.prev = _context6.next){
                    case 0:
                        _context6.next = 2;
                        return $3dcaf4fcb197d831$var$_Storage.default.getAllKeysAsync();
                    case 2:
                        keys = _context6.sent;
                        toRemove = [];
                        _iterator = $3dcaf4fcb197d831$var$_createForOfIteratorHelper(keys);
                        try {
                            for(_iterator.s(); !(_step = _iterator.n()).done;){
                                key = _step.value;
                                if ((0, $7Icwu.isLocalDatastoreKey)(key)) toRemove.push(key);
                            }
                        } catch (err) {
                            _iterator.e(err);
                        } finally{
                            _iterator.f();
                        }
                        promises = (0, $3dcaf4fcb197d831$var$_map.default)(toRemove).call(toRemove, _this.unPinWithName);
                        return _context6.abrupt("return", $3dcaf4fcb197d831$var$_promise.default.all(promises));
                    case 8:
                    case "end":
                        return _context6.stop();
                }
            }, _callee6);
        }))();
    }
};
module.exports = $3dcaf4fcb197d831$var$LocalDatastoreController;

});
parcelRequire.register("ki92O", function(module, exports) {

module.exports = (parcelRequire("9kztE"));

});
parcelRequire.register("9kztE", function(module, exports) {

var $kwbIn = parcelRequire("kwbIn");
module.exports = $kwbIn;

});
parcelRequire.register("kwbIn", function(module, exports) {

var $5L8hR = parcelRequire("5L8hR");

var $5dlRZ = parcelRequire("5dlRZ");
var $eeffe21ffce8e2f7$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.reduce;
    return it === $eeffe21ffce8e2f7$var$ArrayPrototype || $5L8hR($eeffe21ffce8e2f7$var$ArrayPrototype, it) && own === $eeffe21ffce8e2f7$var$ArrayPrototype.reduce ? $5dlRZ : own;
};

});
parcelRequire.register("5dlRZ", function(module, exports) {
parcelRequire("hDgDb");

var $hESIr = parcelRequire("hESIr");
module.exports = $hESIr("Array").reduce;

});
parcelRequire.register("hDgDb", function(module, exports) {
"use strict";

var $g2B3u = parcelRequire("g2B3u");

var $kzNZ3 = parcelRequire("kzNZ3");
var $cd62fac68c20c6a9$require$$reduce = $kzNZ3.left;

var $iNgXn = parcelRequire("iNgXn");

var $dOZLy = parcelRequire("dOZLy");

var $jfyLo = parcelRequire("jfyLo");
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var $cd62fac68c20c6a9$var$CHROME_BUG = !$jfyLo && $dOZLy > 79 && $dOZLy < 83;
var $cd62fac68c20c6a9$var$FORCED = $cd62fac68c20c6a9$var$CHROME_BUG || !$iNgXn("reduce");
// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$g2B3u({
    target: "Array",
    proto: true,
    forced: $cd62fac68c20c6a9$var$FORCED
}, {
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        var length = arguments.length;
        return $cd62fac68c20c6a9$require$$reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
    }
});

});
parcelRequire.register("kzNZ3", function(module, exports) {

var $aZpni = parcelRequire("aZpni");

var $bVwvx = parcelRequire("bVwvx");

var $5LLAg = parcelRequire("5LLAg");

var $25Yeh = parcelRequire("25Yeh");
var $efadd9445145af30$var$$TypeError = TypeError;
// `Array.prototype.{ reduce, reduceRight }` methods implementation
var $efadd9445145af30$var$createMethod = function(IS_RIGHT) {
    return function(that, callbackfn, argumentsLength, memo) {
        $aZpni(callbackfn);
        var O = $bVwvx(that);
        var self = $5LLAg(O);
        var length = $25Yeh(O);
        var index = IS_RIGHT ? length - 1 : 0;
        var i = IS_RIGHT ? -1 : 1;
        if (argumentsLength < 2) while(true){
            if (index in self) {
                memo = self[index];
                index += i;
                break;
            }
            index += i;
            if (IS_RIGHT ? index < 0 : length <= index) throw $efadd9445145af30$var$$TypeError("Reduce of empty array with no initial value");
        }
        for(; IS_RIGHT ? index >= 0 : length > index; index += i)if (index in self) memo = callbackfn(memo, self[index], index, O);
        return memo;
    };
};
module.exports = {
    // `Array.prototype.reduce` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduce
    left: $efadd9445145af30$var$createMethod(false),
    // `Array.prototype.reduceRight` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduceright
    right: $efadd9445145af30$var$createMethod(true)
};

});








parcelRequire.register("jNOW9", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $evY07 = parcelRequire("evY07");
$evY07(module.exports, "__esModule", {
    value: true
});
module.exports.getPushStatus = $e6aa1aedef89895d$var$getPushStatus;
module.exports.send = $e6aa1aedef89895d$var$send;

var $e6aa1aedef89895d$var$_typeof2 = $3Npdz((parcelRequire("akViX")));

var $e6aa1aedef89895d$var$_CoreManager = $3Npdz((parcelRequire("465CW")));

var $e6aa1aedef89895d$var$_ParseQuery = $3Npdz((parcelRequire("eJCLn")));
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ /**
 * Contains functions to deal with Push in Parse.
 *
 * @class Parse.Push
 * @static
 * @hideconstructor
 */ /**
 * Sends a push notification.
 * **Available in Cloud Code only.**
 *
 * See {@link https://docs.parseplatform.org/js/guide/#push-notifications Push Notification Guide}
 *
 * @function send
 * @name Parse.Push.send
 * @param {object} data -  The data of the push notification. Valid fields
 * are:
 *   <ol>
 *     <li>channels - An Array of channels to push to.</li>
 *     <li>push_time - A Date object for when to send the push.</li>
 *     <li>expiration_time -  A Date object for when to expire
 *         the push.</li>
 *     <li>expiration_interval - The seconds from now to expire the push.</li>
 *     <li>where - A Parse.Query over Parse.Installation that is used to match
 *         a set of installations to push to.</li>
 *     <li>data - The data to send as part of the push.</li>
 *   <ol>
 * @param {object} options Valid options
 * are:<ul>
 *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
 *     be used for this request.
 * </ul>
 * @returns {Promise} A promise that is fulfilled when the push request
 *     completes.
 */ function $e6aa1aedef89895d$var$send(data) /*: Promise*/ {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (data.where && data.where instanceof $e6aa1aedef89895d$var$_ParseQuery.default) data.where = data.where.toJSON().where;
    if (data.push_time && (0, $e6aa1aedef89895d$var$_typeof2.default)(data.push_time) === "object") data.push_time = data.push_time.toJSON();
    if (data.expiration_time && (0, $e6aa1aedef89895d$var$_typeof2.default)(data.expiration_time) === "object") data.expiration_time = data.expiration_time.toJSON();
    if (data.expiration_time && data.expiration_interval) throw new Error("expiration_time and expiration_interval cannot both be set.");
    var pushOptions = {
        useMasterKey: true
    };
    if (options.hasOwnProperty("useMasterKey")) pushOptions.useMasterKey = options.useMasterKey;
    return $e6aa1aedef89895d$var$_CoreManager.default.getPushController().send(data, pushOptions);
}
/**
 * Gets push status by Id
 *
 * @function getPushStatus
 * @name Parse.Push.getPushStatus
 * @param {string} pushStatusId The Id of Push Status.
 * @param {object} options Valid options
 * are:<ul>
 *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
 *     be used for this request.
 * </ul>
 * @returns {Parse.Object} Status of Push.
 */ function $e6aa1aedef89895d$var$getPushStatus(pushStatusId) /*: Promise<string>*/ {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var pushOptions = {
        useMasterKey: true
    };
    if (options.hasOwnProperty("useMasterKey")) pushOptions.useMasterKey = options.useMasterKey;
    var query = new $e6aa1aedef89895d$var$_ParseQuery.default("_PushStatus");
    return query.get(pushStatusId, pushOptions);
}
var $e6aa1aedef89895d$var$DefaultController = {
    send: function(data, options) {
        return $e6aa1aedef89895d$var$_CoreManager.default.getRESTController().request("POST", "push", data, options);
    }
};
$e6aa1aedef89895d$var$_CoreManager.default.setPushController($e6aa1aedef89895d$var$DefaultController);

});

parcelRequire.register("fz5kg", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $evY07 = parcelRequire("evY07");
$evY07(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b54e417bcb0f9584$var$_indexOf = $3Npdz((parcelRequire("eOZH4")));

var $b54e417bcb0f9584$var$_classCallCheck2 = $3Npdz((parcelRequire("9pQKE")));

var $b54e417bcb0f9584$var$_createClass2 = $3Npdz((parcelRequire("eZYdV")));

var $b54e417bcb0f9584$var$_defineProperty2 = $3Npdz((parcelRequire("bci6G")));

var $b54e417bcb0f9584$var$_CoreManager = $3Npdz((parcelRequire("465CW")));

var $b54e417bcb0f9584$var$_ParseObject = $3Npdz((parcelRequire("2HIpX")));

var $b54e417bcb0f9584$var$_ParseCLP = $3Npdz((parcelRequire("2wtte")));
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ var $b54e417bcb0f9584$var$FIELD_TYPES = [
    "String",
    "Number",
    "Boolean",
    "Date",
    "File",
    "GeoPoint",
    "Polygon",
    "Array",
    "Object",
    "Pointer",
    "Relation"
];
/*:: type FieldOptions = {
  required: boolean,
  defaultValue: mixed,
};*/ /**
 * A Parse.Schema object is for handling schema data from Parse.
 * <p>All the schemas methods require MasterKey.
 *
 * When adding fields, you may set required and default values. (Requires Parse Server 3.7.0+)
 *
 * <pre>
 * const options = { required: true, defaultValue: 'hello world' };
 * const schema = new Parse.Schema('MyClass');
 * schema.addString('field', options);
 * schema.addIndex('index_name', { 'field': 1 });
 * schema.save();
 * </pre>
 * </p>
 *
 * @alias Parse.Schema
 */ var $b54e417bcb0f9584$var$ParseSchema = /*#__PURE__*/ function() {
    /**
   * @param {string} className Parse Class string.
   */ function ParseSchema(className) {
        (0, $b54e417bcb0f9584$var$_classCallCheck2.default)(this, ParseSchema);
        (0, $b54e417bcb0f9584$var$_defineProperty2.default)(this, "className", void 0);
        (0, $b54e417bcb0f9584$var$_defineProperty2.default)(this, "_fields", void 0);
        (0, $b54e417bcb0f9584$var$_defineProperty2.default)(this, "_indexes", void 0);
        (0, $b54e417bcb0f9584$var$_defineProperty2.default)(this, "_clp", void 0);
        if (typeof className === "string") {
            if (className === "User" && $b54e417bcb0f9584$var$_CoreManager.default.get("PERFORM_USER_REWRITE")) this.className = "_User";
            else this.className = className;
        }
        this._fields = {};
        this._indexes = {};
    }
    /**
   * Static method to get all schemas
   *
   * @returns {Promise} A promise that is resolved with the result when
   * the query completes.
   */ (0, $b54e417bcb0f9584$var$_createClass2.default)(ParseSchema, [
        {
            key: "get",
            value: /**
     * Get the Schema from Parse
     *
     * @returns {Promise} A promise that is resolved with the result when
     * the query completes.
     */ function() {
                this.assertClassName();
                var controller = $b54e417bcb0f9584$var$_CoreManager.default.getSchemaController();
                return controller.get(this.className).then(function(response) {
                    if (!response) throw new Error("Schema not found.");
                    return response;
                });
            }
        },
        {
            key: "save",
            value: function() {
                this.assertClassName();
                var controller = $b54e417bcb0f9584$var$_CoreManager.default.getSchemaController();
                var params = {
                    className: this.className,
                    fields: this._fields,
                    indexes: this._indexes,
                    classLevelPermissions: this._clp
                };
                return controller.create(this.className, params);
            }
        },
        {
            key: "update",
            value: function() {
                this.assertClassName();
                var controller = $b54e417bcb0f9584$var$_CoreManager.default.getSchemaController();
                var params = {
                    className: this.className,
                    fields: this._fields,
                    indexes: this._indexes,
                    classLevelPermissions: this._clp
                };
                this._fields = {};
                this._indexes = {};
                return controller.update(this.className, params);
            }
        },
        {
            key: "delete",
            value: function() {
                this.assertClassName();
                var controller = $b54e417bcb0f9584$var$_CoreManager.default.getSchemaController();
                return controller.delete(this.className);
            }
        },
        {
            key: "purge",
            value: function() {
                this.assertClassName();
                var controller = $b54e417bcb0f9584$var$_CoreManager.default.getSchemaController();
                return controller.purge(this.className);
            }
        },
        {
            key: "assertClassName",
            value: function() {
                if (!this.className) throw new Error("You must set a Class Name before making any request.");
            }
        },
        {
            key: "setCLP",
            value: function(clp) {
                if (clp instanceof $b54e417bcb0f9584$var$_ParseCLP.default) this._clp = clp.toJSON();
                else this._clp = clp;
                return this;
            }
        },
        {
            key: "addField",
            value: function(name, type) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                type = type || "String";
                if (!name) throw new Error("field name may not be null.");
                if ((0, $b54e417bcb0f9584$var$_indexOf.default)($b54e417bcb0f9584$var$FIELD_TYPES).call($b54e417bcb0f9584$var$FIELD_TYPES, type) === -1) throw new Error("".concat(type, " is not a valid type."));
                if (type === "Pointer") return this.addPointer(name, options.targetClass, options);
                if (type === "Relation") return this.addRelation(name, options.targetClass, options);
                var fieldOptions = {
                    type: type
                };
                if (typeof options.required === "boolean") fieldOptions.required = options.required;
                if (options.defaultValue !== undefined) fieldOptions.defaultValue = options.defaultValue;
                if (type === "Date") {
                    if (options && options.defaultValue) fieldOptions.defaultValue = {
                        __type: "Date",
                        iso: new Date(options.defaultValue)
                    };
                }
                this._fields[name] = fieldOptions;
                return this;
            }
        },
        {
            key: "addIndex",
            value: function(name, index) {
                if (!name) throw new Error("index name may not be null.");
                if (!index) throw new Error("index may not be null.");
                this._indexes[name] = index;
                return this;
            }
        },
        {
            key: "addString",
            value: function(name, options) {
                return this.addField(name, "String", options);
            }
        },
        {
            key: "addNumber",
            value: function(name, options) {
                return this.addField(name, "Number", options);
            }
        },
        {
            key: "addBoolean",
            value: function(name, options) {
                return this.addField(name, "Boolean", options);
            }
        },
        {
            key: "addDate",
            value: function(name, options) {
                return this.addField(name, "Date", options);
            }
        },
        {
            key: "addFile",
            value: function(name, options) {
                return this.addField(name, "File", options);
            }
        },
        {
            key: "addGeoPoint",
            value: function(name, options) {
                return this.addField(name, "GeoPoint", options);
            }
        },
        {
            key: "addPolygon",
            value: function(name, options) {
                return this.addField(name, "Polygon", options);
            }
        },
        {
            key: "addArray",
            value: function(name, options) {
                return this.addField(name, "Array", options);
            }
        },
        {
            key: "addObject",
            value: function(name, options) {
                return this.addField(name, "Object", options);
            }
        },
        {
            key: "addPointer",
            value: function(name, targetClass) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                if (!name) throw new Error("field name may not be null.");
                if (!targetClass) throw new Error("You need to set the targetClass of the Pointer.");
                var fieldOptions = {
                    type: "Pointer",
                    targetClass: targetClass
                };
                if (typeof options.required === "boolean") fieldOptions.required = options.required;
                if (options.defaultValue !== undefined) {
                    fieldOptions.defaultValue = options.defaultValue;
                    if (options.defaultValue instanceof $b54e417bcb0f9584$var$_ParseObject.default) fieldOptions.defaultValue = options.defaultValue.toPointer();
                }
                this._fields[name] = fieldOptions;
                return this;
            }
        },
        {
            key: "addRelation",
            value: function(name, targetClass) {
                if (!name) throw new Error("field name may not be null.");
                if (!targetClass) throw new Error("You need to set the targetClass of the Relation.");
                this._fields[name] = {
                    type: "Relation",
                    targetClass: targetClass
                };
                return this;
            }
        },
        {
            key: "deleteField",
            value: function(name) {
                this._fields[name] = {
                    __op: "Delete"
                };
                return this;
            }
        },
        {
            key: "deleteIndex",
            value: function(name) {
                this._indexes[name] = {
                    __op: "Delete"
                };
                return this;
            }
        }
    ], [
        {
            key: "all",
            value: function() {
                var controller = $b54e417bcb0f9584$var$_CoreManager.default.getSchemaController();
                return controller.get("").then(function(response) {
                    if (response.results.length === 0) throw new Error("Schema not found.");
                    return response.results;
                });
            }
        }
    ]);
    return ParseSchema;
}();
var $b54e417bcb0f9584$var$DefaultController = {
    send: function(className, method) /*: Promise*/ {
        var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var RESTController = $b54e417bcb0f9584$var$_CoreManager.default.getRESTController();
        return RESTController.request(method, "schemas/".concat(className), params, {
            useMasterKey: true
        });
    },
    get: function(className) /*: Promise*/ {
        return this.send(className, "GET");
    },
    create: function(className, params) /*: Promise*/ {
        return this.send(className, "POST", params);
    },
    update: function(className, params) /*: Promise*/ {
        return this.send(className, "PUT", params);
    },
    delete: function(className) /*: Promise*/ {
        return this.send(className, "DELETE");
    },
    purge: function(className) /*: Promise*/ {
        var RESTController = $b54e417bcb0f9584$var$_CoreManager.default.getRESTController();
        return RESTController.request("DELETE", "purge/".concat(className), {}, {
            useMasterKey: true
        });
    }
};
$b54e417bcb0f9584$var$_CoreManager.default.setSchemaController($b54e417bcb0f9584$var$DefaultController);
var $b54e417bcb0f9584$var$_default = $b54e417bcb0f9584$var$ParseSchema;
module.exports.default = $b54e417bcb0f9584$var$_default;

});

parcelRequire.register("3ErMa", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $fG1Ke = parcelRequire("fG1Ke");

var $iY2ec = parcelRequire("iY2ec");


var $iWJ3a = parcelRequire("iWJ3a");

var $akViX = parcelRequire("akViX");

var $jZGC2 = parcelRequire("jZGC2");

var $cO2y8 = parcelRequire("cO2y8");

var $dvfqn = parcelRequire("dvfqn");

var $evY07 = parcelRequire("evY07");

var $ebK4m = parcelRequire("ebK4m");
$evY07(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2a8aa737cafaf360$var$_indexOf = $3Npdz((parcelRequire("eOZH4")));

var $2a8aa737cafaf360$var$_promise = $3Npdz((parcelRequire("bCWDe")));

var $2a8aa737cafaf360$var$_slicedToArray2 = $3Npdz((parcelRequire("5kSp4")));

var $2a8aa737cafaf360$var$_asyncToGenerator2 = $3Npdz((parcelRequire("iqZS2")));

var $2a8aa737cafaf360$var$_EventEmitter = $3Npdz((parcelRequire("8bVl8")));

var $2a8aa737cafaf360$var$_LiveQueryClient = $3Npdz((parcelRequire("ktcBb")));

var $2a8aa737cafaf360$var$_CoreManager = $3Npdz((parcelRequire("465CW")));
function $2a8aa737cafaf360$var$_regeneratorRuntime() {
    "use strict";
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ $2a8aa737cafaf360$var$_regeneratorRuntime = function() {
        return exports1;
    };
    var exports1 = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof $ebK4m ? $ebK4m : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return $evY07(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = $dvfqn(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return generator._invoke = function(innerFn, self, context) {
            var state = "suspendedStart";
            return function(method, arg) {
                if ("executing" === state) throw new Error("Generator is already running");
                if ("completed" === state) {
                    if ("throw" === method) throw arg;
                    return doneResult();
                }
                for(context.method = method, context.arg = arg;;){
                    var delegate = context.delegate;
                    if (delegate) {
                        var delegateResult = maybeInvokeDelegate(delegate, context);
                        if (delegateResult) {
                            if (delegateResult === ContinueSentinel) continue;
                            return delegateResult;
                        }
                    }
                    if ("next" === context.method) context.sent = context._sent = context.arg;
                    else if ("throw" === context.method) {
                        if ("suspendedStart" === state) throw state = "completed", context.arg;
                        context.dispatchException(context.arg);
                    } else "return" === context.method && context.abrupt("return", context.arg);
                    state = "executing";
                    var record = tryCatch(innerFn, self, context);
                    if ("normal" === record.type) {
                        if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                        return {
                            value: record.arg,
                            done: context.done
                        };
                    }
                    "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
                }
            };
        }(innerFn, self, context), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports1.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = $cO2y8, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = $dvfqn(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        var _context4;
        $jZGC2(_context4 = [
            "next",
            "throw",
            "return"
        ]).call(_context4, function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == $akViX(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        this._invoke = function(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];
        if (undefined === method) {
            if (context.delegate = null, "throw" === context.method) {
                if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
                context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], $jZGC2(tryLocsList).call(tryLocsList, pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;){
                        if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    }
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports1.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports1.mark = function(genFun) {
        return $iWJ3a ? $iWJ3a(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = $dvfqn(Gp), genFun;
    }, exports1.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports1.AsyncIterator = AsyncIterator, exports1.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = (parcelRequire("bCWDe")));
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports1.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports1.keys = function(object) {
        var keys = [];
        for(var key in object)keys.push(key);
        return $iY2ec(keys).call(keys), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports1.values = values, Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            var _context5;
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, $jZGC2(_context5 = this.tryEntries).call(_context5, resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+$fG1Ke(name).call(name, 1)) && (this[name] = undefined);
        },
        stop: function() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports1;
}
function $2a8aa737cafaf360$var$getLiveQueryClient() /*: LiveQueryClient*/ {
    return $2a8aa737cafaf360$var$_CoreManager.default.getLiveQueryController().getDefaultLiveQueryClient();
}
/**
 * We expose three events to help you monitor the status of the WebSocket connection:
 *
 * <p>Open - When we establish the WebSocket connection to the LiveQuery server, you'll get this event.
 *
 * <pre>
 * Parse.LiveQuery.on('open', () => {
 *
 * });</pre></p>
 *
 * <p>Close - When we lose the WebSocket connection to the LiveQuery server, you'll get this event.
 *
 * <pre>
 * Parse.LiveQuery.on('close', () => {
 *
 * });</pre></p>
 *
 * <p>Error - When some network error or LiveQuery server error happens, you'll get this event.
 *
 * <pre>
 * Parse.LiveQuery.on('error', (error) => {
 *
 * });</pre></p>
 *
 * @class Parse.LiveQuery
 * @static
 */ var $2a8aa737cafaf360$var$LiveQuery = new $2a8aa737cafaf360$var$_EventEmitter.default();
/**
 * After open is called, the LiveQuery will try to send a connect request
 * to the LiveQuery server.
 */ $2a8aa737cafaf360$var$LiveQuery.open = /*#__PURE__*/ (0, $2a8aa737cafaf360$var$_asyncToGenerator2.default)(/*#__PURE__*/ $2a8aa737cafaf360$var$_regeneratorRuntime().mark(function _callee() {
    var liveQueryClient;
    return $2a8aa737cafaf360$var$_regeneratorRuntime().wrap(function _callee$(_context) {
        while(true)switch(_context.prev = _context.next){
            case 0:
                _context.next = 2;
                return $2a8aa737cafaf360$var$getLiveQueryClient();
            case 2:
                liveQueryClient = _context.sent;
                liveQueryClient.open();
            case 4:
            case "end":
                return _context.stop();
        }
    }, _callee);
}));
/**
 * When you're done using LiveQuery, you can call Parse.LiveQuery.close().
 * This function will close the WebSocket connection to the LiveQuery server,
 * cancel the auto reconnect, and unsubscribe all subscriptions based on it.
 * If you call query.subscribe() after this, we'll create a new WebSocket
 * connection to the LiveQuery server.
 */ $2a8aa737cafaf360$var$LiveQuery.close = /*#__PURE__*/ (0, $2a8aa737cafaf360$var$_asyncToGenerator2.default)(/*#__PURE__*/ $2a8aa737cafaf360$var$_regeneratorRuntime().mark(function _callee2() {
    var liveQueryClient;
    return $2a8aa737cafaf360$var$_regeneratorRuntime().wrap(function _callee2$(_context2) {
        while(true)switch(_context2.prev = _context2.next){
            case 0:
                _context2.next = 2;
                return $2a8aa737cafaf360$var$getLiveQueryClient();
            case 2:
                liveQueryClient = _context2.sent;
                liveQueryClient.close();
            case 4:
            case "end":
                return _context2.stop();
        }
    }, _callee2);
})); // Register a default onError callback to make sure we do not crash on error
$2a8aa737cafaf360$var$LiveQuery.on("error", function() {});
var $2a8aa737cafaf360$var$_default = $2a8aa737cafaf360$var$LiveQuery;
module.exports.default = $2a8aa737cafaf360$var$_default;
var $2a8aa737cafaf360$var$defaultLiveQueryClient;
var $2a8aa737cafaf360$var$DefaultLiveQueryController = {
    setDefaultLiveQueryClient: function setDefaultLiveQueryClient(liveQueryClient) {
        $2a8aa737cafaf360$var$defaultLiveQueryClient = liveQueryClient;
    },
    getDefaultLiveQueryClient: function getDefaultLiveQueryClient() /*: Promise<LiveQueryClient>*/ {
        return (0, $2a8aa737cafaf360$var$_asyncToGenerator2.default)(/*#__PURE__*/ $2a8aa737cafaf360$var$_regeneratorRuntime().mark(function _callee3() {
            var _yield$Promise$all, _yield$Promise$all2, currentUser, installationId, sessionToken, liveQueryServerURL, serverURL, protocol, host, applicationId, javascriptKey, masterKey;
            return $2a8aa737cafaf360$var$_regeneratorRuntime().wrap(function _callee3$(_context3) {
                while(true)switch(_context3.prev = _context3.next){
                    case 0:
                        if (!$2a8aa737cafaf360$var$defaultLiveQueryClient) {
                            _context3.next = 2;
                            break;
                        }
                        return _context3.abrupt("return", $2a8aa737cafaf360$var$defaultLiveQueryClient);
                    case 2:
                        _context3.next = 4;
                        return $2a8aa737cafaf360$var$_promise.default.all([
                            $2a8aa737cafaf360$var$_CoreManager.default.getUserController().currentUserAsync(),
                            $2a8aa737cafaf360$var$_CoreManager.default.getInstallationController().currentInstallationId()
                        ]);
                    case 4:
                        _yield$Promise$all = _context3.sent;
                        _yield$Promise$all2 = (0, $2a8aa737cafaf360$var$_slicedToArray2.default)(_yield$Promise$all, 2);
                        currentUser = _yield$Promise$all2[0];
                        installationId = _yield$Promise$all2[1];
                        sessionToken = currentUser ? currentUser.getSessionToken() : undefined;
                        liveQueryServerURL = $2a8aa737cafaf360$var$_CoreManager.default.get("LIVEQUERY_SERVER_URL");
                        if (!(liveQueryServerURL && (0, $2a8aa737cafaf360$var$_indexOf.default)(liveQueryServerURL).call(liveQueryServerURL, "ws") !== 0)) {
                            _context3.next = 12;
                            break;
                        }
                        throw new Error("You need to set a proper Parse LiveQuery server url before using LiveQueryClient");
                    case 12:
                        // If we can not find Parse.liveQueryServerURL, we try to extract it from Parse.serverURL
                        if (!liveQueryServerURL) {
                            serverURL = $2a8aa737cafaf360$var$_CoreManager.default.get("SERVER_URL");
                            protocol = (0, $2a8aa737cafaf360$var$_indexOf.default)(serverURL).call(serverURL, "https") === 0 ? "wss://" : "ws://";
                            host = serverURL.replace(/^https?:\/\//, "");
                            liveQueryServerURL = protocol + host;
                            $2a8aa737cafaf360$var$_CoreManager.default.set("LIVEQUERY_SERVER_URL", liveQueryServerURL);
                        }
                        applicationId = $2a8aa737cafaf360$var$_CoreManager.default.get("APPLICATION_ID");
                        javascriptKey = $2a8aa737cafaf360$var$_CoreManager.default.get("JAVASCRIPT_KEY");
                        masterKey = $2a8aa737cafaf360$var$_CoreManager.default.get("MASTER_KEY");
                        $2a8aa737cafaf360$var$defaultLiveQueryClient = new $2a8aa737cafaf360$var$_LiveQueryClient.default({
                            applicationId: applicationId,
                            serverURL: liveQueryServerURL,
                            javascriptKey: javascriptKey,
                            masterKey: masterKey,
                            sessionToken: sessionToken,
                            installationId: installationId
                        });
                        $2a8aa737cafaf360$var$defaultLiveQueryClient.on("error", function(error) {
                            $2a8aa737cafaf360$var$LiveQuery.emit("error", error);
                        });
                        $2a8aa737cafaf360$var$defaultLiveQueryClient.on("open", function() {
                            $2a8aa737cafaf360$var$LiveQuery.emit("open");
                        });
                        $2a8aa737cafaf360$var$defaultLiveQueryClient.on("close", function() {
                            $2a8aa737cafaf360$var$LiveQuery.emit("close");
                        });
                        return _context3.abrupt("return", $2a8aa737cafaf360$var$defaultLiveQueryClient);
                    case 21:
                    case "end":
                        return _context3.stop();
                }
            }, _callee3);
        }))();
    },
    _clearCachedDefaultClient: function _clearCachedDefaultClient() {
        $2a8aa737cafaf360$var$defaultLiveQueryClient = null;
    }
};
$2a8aa737cafaf360$var$_CoreManager.default.setLiveQueryController($2a8aa737cafaf360$var$DefaultLiveQueryController);

});
parcelRequire.register("8bVl8", function(module, exports) {
"use strict";

/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * This is a simple wrapper to unify EventEmitter implementations across platforms.
 */ module.exports = (parcelRequire("dG33B")).EventEmitter;
var $5f6bd44f93570546$var$EventEmitter;

});
parcelRequire.register("dG33B", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $9f5191ad6e142a03$var$R = typeof Reflect === "object" ? Reflect : null;
var $9f5191ad6e142a03$var$ReflectApply = $9f5191ad6e142a03$var$R && typeof $9f5191ad6e142a03$var$R.apply === "function" ? $9f5191ad6e142a03$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $9f5191ad6e142a03$var$ReflectOwnKeys;
if ($9f5191ad6e142a03$var$R && typeof $9f5191ad6e142a03$var$R.ownKeys === "function") $9f5191ad6e142a03$var$ReflectOwnKeys = $9f5191ad6e142a03$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $9f5191ad6e142a03$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $9f5191ad6e142a03$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $9f5191ad6e142a03$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $9f5191ad6e142a03$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $9f5191ad6e142a03$var$EventEmitter() {
    $9f5191ad6e142a03$var$EventEmitter.init.call(this);
}
module.exports = $9f5191ad6e142a03$var$EventEmitter;
module.exports.once = $9f5191ad6e142a03$var$once;
// Backwards-compat with node 0.10.x
$9f5191ad6e142a03$var$EventEmitter.EventEmitter = $9f5191ad6e142a03$var$EventEmitter;
$9f5191ad6e142a03$var$EventEmitter.prototype._events = undefined;
$9f5191ad6e142a03$var$EventEmitter.prototype._eventsCount = 0;
$9f5191ad6e142a03$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $9f5191ad6e142a03$var$defaultMaxListeners = 10;
function $9f5191ad6e142a03$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($9f5191ad6e142a03$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $9f5191ad6e142a03$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $9f5191ad6e142a03$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $9f5191ad6e142a03$var$defaultMaxListeners = arg;
    }
});
$9f5191ad6e142a03$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$9f5191ad6e142a03$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $9f5191ad6e142a03$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $9f5191ad6e142a03$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $9f5191ad6e142a03$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$9f5191ad6e142a03$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $9f5191ad6e142a03$var$_getMaxListeners(this);
};
$9f5191ad6e142a03$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $9f5191ad6e142a03$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $9f5191ad6e142a03$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$9f5191ad6e142a03$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $9f5191ad6e142a03$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $9f5191ad6e142a03$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $9f5191ad6e142a03$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $9f5191ad6e142a03$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$9f5191ad6e142a03$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $9f5191ad6e142a03$var$_addListener(this, type, listener, false);
};
$9f5191ad6e142a03$var$EventEmitter.prototype.on = $9f5191ad6e142a03$var$EventEmitter.prototype.addListener;
$9f5191ad6e142a03$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $9f5191ad6e142a03$var$_addListener(this, type, listener, true);
};
function $9f5191ad6e142a03$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $9f5191ad6e142a03$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $9f5191ad6e142a03$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$9f5191ad6e142a03$var$EventEmitter.prototype.once = function once(type, listener) {
    $9f5191ad6e142a03$var$checkListener(listener);
    this.on(type, $9f5191ad6e142a03$var$_onceWrap(this, type, listener));
    return this;
};
$9f5191ad6e142a03$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $9f5191ad6e142a03$var$checkListener(listener);
    this.prependListener(type, $9f5191ad6e142a03$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$9f5191ad6e142a03$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $9f5191ad6e142a03$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $9f5191ad6e142a03$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$9f5191ad6e142a03$var$EventEmitter.prototype.off = $9f5191ad6e142a03$var$EventEmitter.prototype.removeListener;
$9f5191ad6e142a03$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $9f5191ad6e142a03$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $9f5191ad6e142a03$var$unwrapListeners(evlistener) : $9f5191ad6e142a03$var$arrayClone(evlistener, evlistener.length);
}
$9f5191ad6e142a03$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $9f5191ad6e142a03$var$_listeners(this, type, true);
};
$9f5191ad6e142a03$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $9f5191ad6e142a03$var$_listeners(this, type, false);
};
$9f5191ad6e142a03$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $9f5191ad6e142a03$var$listenerCount.call(emitter, type);
};
$9f5191ad6e142a03$var$EventEmitter.prototype.listenerCount = $9f5191ad6e142a03$var$listenerCount;
function $9f5191ad6e142a03$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$9f5191ad6e142a03$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $9f5191ad6e142a03$var$ReflectOwnKeys(this._events) : [];
};
function $9f5191ad6e142a03$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $9f5191ad6e142a03$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $9f5191ad6e142a03$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $9f5191ad6e142a03$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $9f5191ad6e142a03$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $9f5191ad6e142a03$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $9f5191ad6e142a03$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $9f5191ad6e142a03$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $9f5191ad6e142a03$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});


parcelRequire.register("ktcBb", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $evY07 = parcelRequire("evY07");

var $i0kCX = parcelRequire("i0kCX");

var $liESz = parcelRequire("liESz");

var $ebK4m = parcelRequire("ebK4m");

var $5hSqA = parcelRequire("5hSqA");

var $fG1Ke = parcelRequire("fG1Ke");

var $dwGVc = parcelRequire("dwGVc");
$evY07(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ee7049e7b958a826$var$_typeof2 = $3Npdz((parcelRequire("akViX")));

var $ee7049e7b958a826$var$_bind = $3Npdz((parcelRequire("dgLYW")));

var $ee7049e7b958a826$var$_setTimeout2 = $3Npdz((parcelRequire("i3aqT")));

var $ee7049e7b958a826$var$_values = $3Npdz((parcelRequire("2qTSH")));

var $ee7049e7b958a826$var$_forEach = $3Npdz((parcelRequire("jZGC2")));

var $ee7049e7b958a826$var$_stringify = $3Npdz((parcelRequire("O2sNs")));

var $ee7049e7b958a826$var$_keys = $3Npdz((parcelRequire("gKrgO")));

var $ee7049e7b958a826$var$_map = $3Npdz((parcelRequire("jIsi7")));

var $ee7049e7b958a826$var$_indexOf = $3Npdz((parcelRequire("eOZH4")));

var $ee7049e7b958a826$var$_classCallCheck2 = $3Npdz((parcelRequire("9pQKE")));

var $ee7049e7b958a826$var$_createClass2 = $3Npdz((parcelRequire("eZYdV")));

var $ee7049e7b958a826$var$_assertThisInitialized2 = $3Npdz((parcelRequire("73Ztd")));

var $ee7049e7b958a826$var$_inherits2 = $3Npdz((parcelRequire("4QWF4")));

var $ee7049e7b958a826$var$_possibleConstructorReturn2 = $3Npdz((parcelRequire("kTHGs")));

var $ee7049e7b958a826$var$_getPrototypeOf2 = $3Npdz((parcelRequire("6MmOk")));

var $ee7049e7b958a826$var$_defineProperty2 = $3Npdz((parcelRequire("bci6G")));

var $ee7049e7b958a826$var$_CoreManager = $3Npdz((parcelRequire("465CW")));

var $ee7049e7b958a826$var$_EventEmitter2 = $3Npdz((parcelRequire("8bVl8")));

var $ee7049e7b958a826$var$_ParseObject = $3Npdz((parcelRequire("2HIpX")));

var $ee7049e7b958a826$var$_LiveQuerySubscription = $3Npdz((parcelRequire("ej4Vg")));

var $j0i6P = parcelRequire("j0i6P");
function $ee7049e7b958a826$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof $ebK4m !== "undefined" && $liESz(o) || o["@@iterator"];
    if (!it) {
        if ($i0kCX(o) || (it = $ee7049e7b958a826$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function() {};
            return {
                s: F,
                n: function() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function() {
            it = it.call(o);
        },
        n: function() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $ee7049e7b958a826$var$_unsupportedIterableToArray(o, minLen) {
    var _context6;
    if (!o) return;
    if (typeof o === "string") return $ee7049e7b958a826$var$_arrayLikeToArray(o, minLen);
    var n = $fG1Ke(_context6 = Object.prototype.toString.call(o)).call(_context6, 8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return $5hSqA(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ee7049e7b958a826$var$_arrayLikeToArray(o, minLen);
}
function $ee7049e7b958a826$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ee7049e7b958a826$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $ee7049e7b958a826$var$_isNativeReflectConstruct();
    return function() {
        var Super = (0, $ee7049e7b958a826$var$_getPrototypeOf2.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $ee7049e7b958a826$var$_getPrototypeOf2.default)(this).constructor;
            result = $dwGVc(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $ee7049e7b958a826$var$_possibleConstructorReturn2.default)(this, result);
    };
}
function $ee7049e7b958a826$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !$dwGVc) return false;
    if ($dwGVc.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($dwGVc(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
} // The LiveQuery client inner state
var $ee7049e7b958a826$var$CLIENT_STATE = {
    INITIALIZED: "initialized",
    CONNECTING: "connecting",
    CONNECTED: "connected",
    CLOSED: "closed",
    RECONNECTING: "reconnecting",
    DISCONNECTED: "disconnected"
}; // The event type the LiveQuery client should sent to server
var $ee7049e7b958a826$var$OP_TYPES = {
    CONNECT: "connect",
    SUBSCRIBE: "subscribe",
    UNSUBSCRIBE: "unsubscribe",
    ERROR: "error"
}; // The event we get back from LiveQuery server
var $ee7049e7b958a826$var$OP_EVENTS = {
    CONNECTED: "connected",
    SUBSCRIBED: "subscribed",
    UNSUBSCRIBED: "unsubscribed",
    ERROR: "error",
    CREATE: "create",
    UPDATE: "update",
    ENTER: "enter",
    LEAVE: "leave",
    DELETE: "delete"
}; // The event the LiveQuery client should emit
var $ee7049e7b958a826$var$CLIENT_EMMITER_TYPES = {
    CLOSE: "close",
    ERROR: "error",
    OPEN: "open"
}; // The event the LiveQuery subscription should emit
var $ee7049e7b958a826$var$SUBSCRIPTION_EMMITER_TYPES = {
    OPEN: "open",
    CLOSE: "close",
    ERROR: "error",
    CREATE: "create",
    UPDATE: "update",
    ENTER: "enter",
    LEAVE: "leave",
    DELETE: "delete"
};
var $ee7049e7b958a826$var$generateInterval = function(k) {
    return Math.random() * Math.min(30, Math.pow(2, k) - 1) * 1000;
};
/**
 * Creates a new LiveQueryClient.
 * Extends events.EventEmitter
 * <a href="https://nodejs.org/api/events.html#events_class_eventemitter">cloud functions</a>.
 *
 * A wrapper of a standard WebSocket client. We add several useful methods to
 * help you connect/disconnect to LiveQueryServer, subscribe/unsubscribe a ParseQuery easily.
 *
 * javascriptKey and masterKey are used for verifying the LiveQueryClient when it tries
 * to connect to the LiveQuery server
 *
 * We expose three events to help you monitor the status of the LiveQueryClient.
 *
 * <pre>
 * let Parse = require('parse/node');
 * let LiveQueryClient = Parse.LiveQueryClient;
 * let client = new LiveQueryClient({
 *   applicationId: '',
 *   serverURL: '',
 *   javascriptKey: '',
 *   masterKey: ''
 *  });
 * </pre>
 *
 * Open - When we establish the WebSocket connection to the LiveQuery server, you'll get this event.
 * <pre>
 * client.on('open', () => {
 *
 * });</pre>
 *
 * Close - When we lose the WebSocket connection to the LiveQuery server, you'll get this event.
 * <pre>
 * client.on('close', () => {
 *
 * });</pre>
 *
 * Error - When some network error or LiveQuery server error happens, you'll get this event.
 * <pre>
 * client.on('error', (error) => {
 *
 * });</pre>
 *
 * @alias Parse.LiveQueryClient
 */ var $ee7049e7b958a826$var$LiveQueryClient = /*#__PURE__*/ function(_EventEmitter) {
    (0, $ee7049e7b958a826$var$_inherits2.default)(LiveQueryClient, _EventEmitter);
    var _super = $ee7049e7b958a826$var$_createSuper(LiveQueryClient);
    /**
   * @param {object} options
   * @param {string} options.applicationId - applicationId of your Parse app
   * @param {string} options.serverURL - <b>the URL of your LiveQuery server</b>
   * @param {string} options.javascriptKey (optional)
   * @param {string} options.masterKey (optional) Your Parse Master Key. (Node.js only!)
   * @param {string} options.sessionToken (optional)
   * @param {string} options.installationId (optional)
   */ function LiveQueryClient(_ref) {
        var _this;
        var applicationId = _ref.applicationId, serverURL = _ref.serverURL, javascriptKey = _ref.javascriptKey, masterKey = _ref.masterKey, sessionToken = _ref.sessionToken, installationId = _ref.installationId;
        (0, $ee7049e7b958a826$var$_classCallCheck2.default)(this, LiveQueryClient);
        _this = _super.call(this);
        (0, $ee7049e7b958a826$var$_defineProperty2.default)((0, $ee7049e7b958a826$var$_assertThisInitialized2.default)(_this), "attempts", void 0);
        (0, $ee7049e7b958a826$var$_defineProperty2.default)((0, $ee7049e7b958a826$var$_assertThisInitialized2.default)(_this), "id", void 0);
        (0, $ee7049e7b958a826$var$_defineProperty2.default)((0, $ee7049e7b958a826$var$_assertThisInitialized2.default)(_this), "requestId", void 0);
        (0, $ee7049e7b958a826$var$_defineProperty2.default)((0, $ee7049e7b958a826$var$_assertThisInitialized2.default)(_this), "applicationId", void 0);
        (0, $ee7049e7b958a826$var$_defineProperty2.default)((0, $ee7049e7b958a826$var$_assertThisInitialized2.default)(_this), "serverURL", void 0);
        (0, $ee7049e7b958a826$var$_defineProperty2.default)((0, $ee7049e7b958a826$var$_assertThisInitialized2.default)(_this), "javascriptKey", void 0);
        (0, $ee7049e7b958a826$var$_defineProperty2.default)((0, $ee7049e7b958a826$var$_assertThisInitialized2.default)(_this), "masterKey", void 0);
        (0, $ee7049e7b958a826$var$_defineProperty2.default)((0, $ee7049e7b958a826$var$_assertThisInitialized2.default)(_this), "sessionToken", void 0);
        (0, $ee7049e7b958a826$var$_defineProperty2.default)((0, $ee7049e7b958a826$var$_assertThisInitialized2.default)(_this), "installationId", void 0);
        (0, $ee7049e7b958a826$var$_defineProperty2.default)((0, $ee7049e7b958a826$var$_assertThisInitialized2.default)(_this), "additionalProperties", void 0);
        (0, $ee7049e7b958a826$var$_defineProperty2.default)((0, $ee7049e7b958a826$var$_assertThisInitialized2.default)(_this), "connectPromise", void 0);
        (0, $ee7049e7b958a826$var$_defineProperty2.default)((0, $ee7049e7b958a826$var$_assertThisInitialized2.default)(_this), "subscriptions", void 0);
        (0, $ee7049e7b958a826$var$_defineProperty2.default)((0, $ee7049e7b958a826$var$_assertThisInitialized2.default)(_this), "socket", void 0);
        (0, $ee7049e7b958a826$var$_defineProperty2.default)((0, $ee7049e7b958a826$var$_assertThisInitialized2.default)(_this), "state", void 0);
        if (!serverURL || (0, $ee7049e7b958a826$var$_indexOf.default)(serverURL).call(serverURL, "ws") !== 0) throw new Error("You need to set a proper Parse LiveQuery server url before using LiveQueryClient");
        _this.reconnectHandle = null;
        _this.attempts = 1;
        _this.id = 0;
        _this.requestId = 1;
        _this.serverURL = serverURL;
        _this.applicationId = applicationId;
        _this.javascriptKey = javascriptKey || undefined;
        _this.masterKey = masterKey || undefined;
        _this.sessionToken = sessionToken || undefined;
        _this.installationId = installationId || undefined;
        _this.additionalProperties = true;
        _this.connectPromise = (0, $j0i6P.resolvingPromise)();
        _this.subscriptions = new $ee7049e7b958a826$var$_map.default();
        _this.state = $ee7049e7b958a826$var$CLIENT_STATE.INITIALIZED; // adding listener so process does not crash
        // best practice is for developer to register their own listener
        _this.on("error", function() {});
        return _this;
    }
    (0, $ee7049e7b958a826$var$_createClass2.default)(LiveQueryClient, [
        {
            key: "shouldOpen",
            value: function() /*: any*/ {
                return this.state === $ee7049e7b958a826$var$CLIENT_STATE.INITIALIZED || this.state === $ee7049e7b958a826$var$CLIENT_STATE.DISCONNECTED;
            }
        },
        {
            key: "subscribe",
            value: function(query, sessionToken) /*: LiveQuerySubscription*/ {
                var _this2 = this;
                if (!query) return;
                var className = query.className;
                var queryJSON = query.toJSON();
                var where = queryJSON.where;
                var fields = (0, $ee7049e7b958a826$var$_keys.default)(queryJSON) ? (0, $ee7049e7b958a826$var$_keys.default)(queryJSON).split(",") : undefined;
                var subscribeRequest = {
                    op: $ee7049e7b958a826$var$OP_TYPES.SUBSCRIBE,
                    requestId: this.requestId,
                    query: {
                        className: className,
                        where: where,
                        fields: fields
                    }
                };
                if (sessionToken) subscribeRequest.sessionToken = sessionToken;
                var subscription = new $ee7049e7b958a826$var$_LiveQuerySubscription.default(this.requestId, query, sessionToken);
                this.subscriptions.set(this.requestId, subscription);
                this.requestId += 1;
                this.connectPromise.then(function() {
                    _this2.socket.send((0, $ee7049e7b958a826$var$_stringify.default)(subscribeRequest));
                });
                return subscription;
            }
        },
        {
            key: "unsubscribe",
            value: function(subscription) {
                var _this3 = this;
                if (!subscription) return;
                this.subscriptions.delete(subscription.id);
                var unsubscribeRequest = {
                    op: $ee7049e7b958a826$var$OP_TYPES.UNSUBSCRIBE,
                    requestId: subscription.id
                };
                this.connectPromise.then(function() {
                    _this3.socket.send((0, $ee7049e7b958a826$var$_stringify.default)(unsubscribeRequest));
                });
            }
        },
        {
            key: "open",
            value: function() {
                var _this4 = this;
                var WebSocketImplementation = $ee7049e7b958a826$var$_CoreManager.default.getWebSocketController();
                if (!WebSocketImplementation) {
                    this.emit($ee7049e7b958a826$var$CLIENT_EMMITER_TYPES.ERROR, "Can not find WebSocket implementation");
                    return;
                }
                if (this.state !== $ee7049e7b958a826$var$CLIENT_STATE.RECONNECTING) this.state = $ee7049e7b958a826$var$CLIENT_STATE.CONNECTING;
                this.socket = new WebSocketImplementation(this.serverURL); // Bind WebSocket callbacks
                this.socket.onopen = function() {
                    _this4._handleWebSocketOpen();
                };
                this.socket.onmessage = function(event) {
                    _this4._handleWebSocketMessage(event);
                };
                this.socket.onclose = function() {
                    _this4._handleWebSocketClose();
                };
                this.socket.onerror = function(error) {
                    _this4._handleWebSocketError(error);
                };
            }
        },
        {
            key: "resubscribe",
            value: function() {
                var _context, _this5 = this;
                (0, $ee7049e7b958a826$var$_forEach.default)(_context = this.subscriptions).call(_context, function(subscription, requestId) {
                    var query = subscription.query;
                    var queryJSON = query.toJSON();
                    var where = queryJSON.where;
                    var fields = (0, $ee7049e7b958a826$var$_keys.default)(queryJSON) ? (0, $ee7049e7b958a826$var$_keys.default)(queryJSON).split(",") : undefined;
                    var className = query.className;
                    var sessionToken = subscription.sessionToken;
                    var subscribeRequest = {
                        op: $ee7049e7b958a826$var$OP_TYPES.SUBSCRIBE,
                        requestId: requestId,
                        query: {
                            className: className,
                            where: where,
                            fields: fields
                        }
                    };
                    if (sessionToken) subscribeRequest.sessionToken = sessionToken;
                    _this5.connectPromise.then(function() {
                        _this5.socket.send((0, $ee7049e7b958a826$var$_stringify.default)(subscribeRequest));
                    });
                });
            }
        },
        {
            key: "close",
            value: function() {
                var _context2;
                if (this.state === $ee7049e7b958a826$var$CLIENT_STATE.INITIALIZED || this.state === $ee7049e7b958a826$var$CLIENT_STATE.DISCONNECTED) return;
                this.state = $ee7049e7b958a826$var$CLIENT_STATE.DISCONNECTED;
                this.socket.close(); // Notify each subscription about the close
                var _iterator = $ee7049e7b958a826$var$_createForOfIteratorHelper((0, $ee7049e7b958a826$var$_values.default)(_context2 = this.subscriptions).call(_context2)), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var subscription = _step.value;
                        subscription.subscribed = false;
                        subscription.emit($ee7049e7b958a826$var$SUBSCRIPTION_EMMITER_TYPES.CLOSE);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                this._handleReset();
                this.emit($ee7049e7b958a826$var$CLIENT_EMMITER_TYPES.CLOSE);
            } // ensure we start with valid state if connect is called again after close
        },
        {
            key: "_handleReset",
            value: function() {
                this.attempts = 1;
                this.id = 0;
                this.requestId = 1;
                this.connectPromise = (0, $j0i6P.resolvingPromise)();
                this.subscriptions = new $ee7049e7b958a826$var$_map.default();
            }
        },
        {
            key: "_handleWebSocketOpen",
            value: function() {
                this.attempts = 1;
                var connectRequest = {
                    op: $ee7049e7b958a826$var$OP_TYPES.CONNECT,
                    applicationId: this.applicationId,
                    javascriptKey: this.javascriptKey,
                    masterKey: this.masterKey,
                    sessionToken: this.sessionToken
                };
                if (this.additionalProperties) connectRequest.installationId = this.installationId;
                this.socket.send((0, $ee7049e7b958a826$var$_stringify.default)(connectRequest));
            }
        },
        {
            key: "_handleWebSocketMessage",
            value: function(event) {
                var data = event.data;
                if (typeof data === "string") data = JSON.parse(data);
                var subscription = null;
                if (data.requestId) subscription = this.subscriptions.get(data.requestId);
                var response = {
                    clientId: data.clientId,
                    installationId: data.installationId
                };
                switch(data.op){
                    case $ee7049e7b958a826$var$OP_EVENTS.CONNECTED:
                        if (this.state === $ee7049e7b958a826$var$CLIENT_STATE.RECONNECTING) this.resubscribe();
                        this.emit($ee7049e7b958a826$var$CLIENT_EMMITER_TYPES.OPEN);
                        this.id = data.clientId;
                        this.connectPromise.resolve();
                        this.state = $ee7049e7b958a826$var$CLIENT_STATE.CONNECTED;
                        break;
                    case $ee7049e7b958a826$var$OP_EVENTS.SUBSCRIBED:
                        if (subscription) {
                            subscription.subscribed = true;
                            subscription.subscribePromise.resolve();
                            (0, $ee7049e7b958a826$var$_setTimeout2.default)(function() {
                                return subscription.emit($ee7049e7b958a826$var$SUBSCRIPTION_EMMITER_TYPES.OPEN, response);
                            }, 200);
                        }
                        break;
                    case $ee7049e7b958a826$var$OP_EVENTS.ERROR:
                        if (data.requestId) {
                            if (subscription) {
                                subscription.subscribePromise.resolve();
                                (0, $ee7049e7b958a826$var$_setTimeout2.default)(function() {
                                    return subscription.emit($ee7049e7b958a826$var$SUBSCRIPTION_EMMITER_TYPES.ERROR, data.error);
                                }, 200);
                            }
                        } else this.emit($ee7049e7b958a826$var$CLIENT_EMMITER_TYPES.ERROR, data.error);
                        if (data.error === "Additional properties not allowed") this.additionalProperties = false;
                        if (data.reconnect) this._handleReconnect();
                        break;
                    case $ee7049e7b958a826$var$OP_EVENTS.UNSUBSCRIBED:
                        break;
                    default:
                        // create, update, enter, leave, delete cases
                        if (!subscription) break;
                        var override = false;
                        if (data.original) {
                            override = true;
                            delete data.original.__type; // Check for removed fields
                            for(var field in data.original)if (!(field in data.object)) data.object[field] = undefined;
                            data.original = $ee7049e7b958a826$var$_ParseObject.default.fromJSON(data.original, false);
                        }
                        delete data.object.__type;
                        var parseObject = $ee7049e7b958a826$var$_ParseObject.default.fromJSON(data.object, !(subscription.query && subscription.query._select) ? override : false);
                        if (data.original) subscription.emit(data.op, parseObject, data.original, response);
                        else subscription.emit(data.op, parseObject, response);
                        var localDatastore = $ee7049e7b958a826$var$_CoreManager.default.getLocalDatastore();
                        if (override && localDatastore.isEnabled) localDatastore._updateObjectIfPinned(parseObject).then(function() {});
                }
            }
        },
        {
            key: "_handleWebSocketClose",
            value: function() {
                var _context3;
                if (this.state === $ee7049e7b958a826$var$CLIENT_STATE.DISCONNECTED) return;
                this.state = $ee7049e7b958a826$var$CLIENT_STATE.CLOSED;
                this.emit($ee7049e7b958a826$var$CLIENT_EMMITER_TYPES.CLOSE); // Notify each subscription about the close
                var _iterator2 = $ee7049e7b958a826$var$_createForOfIteratorHelper((0, $ee7049e7b958a826$var$_values.default)(_context3 = this.subscriptions).call(_context3)), _step2;
                try {
                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                        var subscription = _step2.value;
                        subscription.emit($ee7049e7b958a826$var$SUBSCRIPTION_EMMITER_TYPES.CLOSE);
                    }
                } catch (err) {
                    _iterator2.e(err);
                } finally{
                    _iterator2.f();
                }
                this._handleReconnect();
            }
        },
        {
            key: "_handleWebSocketError",
            value: function(error) {
                var _context4;
                this.emit($ee7049e7b958a826$var$CLIENT_EMMITER_TYPES.ERROR, error);
                var _iterator3 = $ee7049e7b958a826$var$_createForOfIteratorHelper((0, $ee7049e7b958a826$var$_values.default)(_context4 = this.subscriptions).call(_context4)), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var subscription = _step3.value;
                        subscription.emit($ee7049e7b958a826$var$SUBSCRIPTION_EMMITER_TYPES.ERROR, error);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
                this._handleReconnect();
            }
        },
        {
            key: "_handleReconnect",
            value: function() {
                var _context5, _this6 = this; // if closed or currently reconnecting we stop attempting to reconnect
                if (this.state === $ee7049e7b958a826$var$CLIENT_STATE.DISCONNECTED) return;
                this.state = $ee7049e7b958a826$var$CLIENT_STATE.RECONNECTING;
                var time = $ee7049e7b958a826$var$generateInterval(this.attempts); // handle case when both close/error occur at frequent rates we ensure we do not reconnect unnecessarily.
                // we're unable to distinguish different between close/error when we're unable to reconnect therefore
                // we try to reconnect in both cases
                // server side ws and browser WebSocket behave differently in when close/error get triggered
                if (this.reconnectHandle) clearTimeout(this.reconnectHandle);
                this.reconnectHandle = (0, $ee7049e7b958a826$var$_setTimeout2.default)((0, $ee7049e7b958a826$var$_bind.default)(_context5 = function() {
                    _this6.attempts++;
                    _this6.connectPromise = (0, $j0i6P.resolvingPromise)();
                    _this6.open();
                }).call(_context5, this), time);
            }
        }
    ]);
    return LiveQueryClient;
}($ee7049e7b958a826$var$_EventEmitter2.default);
$ee7049e7b958a826$var$_CoreManager.default.setWebSocketController(typeof WebSocket === "function" || (typeof WebSocket === "undefined" ? "undefined" : (0, $ee7049e7b958a826$var$_typeof2.default)(WebSocket)) === "object" ? WebSocket : null);
var $ee7049e7b958a826$var$_default = $ee7049e7b958a826$var$LiveQueryClient;
module.exports.default = $ee7049e7b958a826$var$_default;

});
parcelRequire.register("dgLYW", function(module, exports) {

module.exports = (parcelRequire("c0ccY"));

});

parcelRequire.register("2qTSH", function(module, exports) {

module.exports = (parcelRequire("lRXHY"));

});
parcelRequire.register("lRXHY", function(module, exports) {
parcelRequire("4YdnW");

var $3mH0O = parcelRequire("3mH0O");

var $dydfX = parcelRequire("dydfX");

var $5L8hR = parcelRequire("5L8hR");

var $aNpAp = parcelRequire("aNpAp");
var $febcdd09f947da57$var$ArrayPrototype = Array.prototype;
var $febcdd09f947da57$var$DOMIterables = {
    DOMTokenList: true,
    NodeList: true
};
module.exports = function(it) {
    var own = it.values;
    return it === $febcdd09f947da57$var$ArrayPrototype || $5L8hR($febcdd09f947da57$var$ArrayPrototype, it) && own === $febcdd09f947da57$var$ArrayPrototype.values || $dydfX($febcdd09f947da57$var$DOMIterables, $3mH0O(it)) ? $aNpAp : own;
};

});
parcelRequire.register("aNpAp", function(module, exports) {

var $5QpV7 = parcelRequire("5QpV7");
module.exports = $5QpV7;

});
parcelRequire.register("5QpV7", function(module, exports) {
parcelRequire("4IarS");
parcelRequire("edOxo");

var $hESIr = parcelRequire("hESIr");
module.exports = $hESIr("Array").values;

});




parcelRequire.register("ej4Vg", function(module, exports) {
"use strict";

var $3Npdz = parcelRequire("3Npdz");

var $evY07 = parcelRequire("evY07");

var $dwGVc = parcelRequire("dwGVc");
$evY07(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a6a6a890f925af65$var$_classCallCheck2 = $3Npdz((parcelRequire("9pQKE")));

var $a6a6a890f925af65$var$_createClass2 = $3Npdz((parcelRequire("eZYdV")));

var $a6a6a890f925af65$var$_inherits2 = $3Npdz((parcelRequire("4QWF4")));

var $a6a6a890f925af65$var$_possibleConstructorReturn2 = $3Npdz((parcelRequire("kTHGs")));

var $a6a6a890f925af65$var$_getPrototypeOf2 = $3Npdz((parcelRequire("6MmOk")));

var $a6a6a890f925af65$var$_EventEmitter2 = $3Npdz((parcelRequire("8bVl8")));

var $a6a6a890f925af65$var$_CoreManager = $3Npdz((parcelRequire("465CW")));

var $j0i6P = parcelRequire("j0i6P");
function $a6a6a890f925af65$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $a6a6a890f925af65$var$_isNativeReflectConstruct();
    return function() {
        var Super = (0, $a6a6a890f925af65$var$_getPrototypeOf2.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $a6a6a890f925af65$var$_getPrototypeOf2.default)(this).constructor;
            result = $dwGVc(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $a6a6a890f925af65$var$_possibleConstructorReturn2.default)(this, result);
    };
}
function $a6a6a890f925af65$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !$dwGVc) return false;
    if ($dwGVc.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($dwGVc(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Creates a new LiveQuery Subscription.
 * Extends events.EventEmitter
 * <a href="https://nodejs.org/api/events.html#events_class_eventemitter">cloud functions</a>.
 *
 * <p>Response Object - Contains data from the client that made the request
 * <ul>
 * <li>clientId</li>
 * <li>installationId - requires Parse Server 4.0.0+</li>
 * </ul>
 * </p>
 *
 * <p>Open Event - When you call query.subscribe(), we send a subscribe request to
 * the LiveQuery server, when we get the confirmation from the LiveQuery server,
 * this event will be emitted. When the client loses WebSocket connection to the
 * LiveQuery server, we will try to auto reconnect the LiveQuery server. If we
 * reconnect the LiveQuery server and successfully resubscribe the ParseQuery,
 * you'll also get this event.
 *
 * <pre>
 * subscription.on('open', (response) => {
 *
 * });</pre></p>
 *
 * <p>Create Event - When a new ParseObject is created and it fulfills the ParseQuery you subscribe,
 * you'll get this event. The object is the ParseObject which is created.
 *
 * <pre>
 * subscription.on('create', (object, response) => {
 *
 * });</pre></p>
 *
 * <p>Update Event - When an existing ParseObject (original) which fulfills the ParseQuery you subscribe
 * is updated (The ParseObject fulfills the ParseQuery before and after changes),
 * you'll get this event. The object is the ParseObject which is updated.
 * Its content is the latest value of the ParseObject.
 *
 * Parse-Server 3.1.3+ Required for original object parameter
 *
 * <pre>
 * subscription.on('update', (object, original, response) => {
 *
 * });</pre></p>
 *
 * <p>Enter Event - When an existing ParseObject's (original) old value doesn't fulfill the ParseQuery
 * but its new value fulfills the ParseQuery, you'll get this event. The object is the
 * ParseObject which enters the ParseQuery. Its content is the latest value of the ParseObject.
 *
 * Parse-Server 3.1.3+ Required for original object parameter
 *
 * <pre>
 * subscription.on('enter', (object, original, response) => {
 *
 * });</pre></p>
 *
 *
 * <p>Update Event - When an existing ParseObject's old value fulfills the ParseQuery but its new value
 * doesn't fulfill the ParseQuery, you'll get this event. The object is the ParseObject
 * which leaves the ParseQuery. Its content is the latest value of the ParseObject.
 *
 * <pre>
 * subscription.on('leave', (object, response) => {
 *
 * });</pre></p>
 *
 *
 * <p>Delete Event - When an existing ParseObject which fulfills the ParseQuery is deleted, you'll
 * get this event. The object is the ParseObject which is deleted.
 *
 * <pre>
 * subscription.on('delete', (object, response) => {
 *
 * });</pre></p>
 *
 *
 * <p>Close Event - When the client loses the WebSocket connection to the LiveQuery
 * server and we stop receiving events, you'll get this event.
 *
 * <pre>
 * subscription.on('close', () => {
 *
 * });</pre></p>
 *
 * @alias Parse.LiveQuerySubscription
 */ var $a6a6a890f925af65$var$Subscription = /*#__PURE__*/ function(_EventEmitter) {
    (0, $a6a6a890f925af65$var$_inherits2.default)(Subscription, _EventEmitter);
    var _super = $a6a6a890f925af65$var$_createSuper(Subscription);
    /*
   * @param {string} id - subscription id
   * @param {string} query - query to subscribe to
   * @param {string} sessionToken - optional session token
   */ function Subscription(id, query, sessionToken) {
        var _this;
        (0, $a6a6a890f925af65$var$_classCallCheck2.default)(this, Subscription);
        _this = _super.call(this);
        _this.id = id;
        _this.query = query;
        _this.sessionToken = sessionToken;
        _this.subscribePromise = (0, $j0i6P.resolvingPromise)();
        _this.subscribed = false; // adding listener so process does not crash
        // best practice is for developer to register their own listener
        _this.on("error", function() {});
        return _this;
    }
    /**
   * Close the subscription
   *
   * @returns {Promise}
   */ (0, $a6a6a890f925af65$var$_createClass2.default)(Subscription, [
        {
            key: "unsubscribe",
            value: function() /*: Promise*/ {
                var _this2 = this;
                return $a6a6a890f925af65$var$_CoreManager.default.getLiveQueryController().getDefaultLiveQueryClient().then(function(liveQueryClient) {
                    liveQueryClient.unsubscribe(_this2);
                    _this2.emit("close");
                });
            }
        }
    ]);
    return Subscription;
}($a6a6a890f925af65$var$_EventEmitter2.default);
var $a6a6a890f925af65$var$_default = $a6a6a890f925af65$var$Subscription;
module.exports.default = $a6a6a890f925af65$var$_default;

});



parcelRequire.register("ekY3G", function(module, exports) {
"use strict";

var $gKrgO = parcelRequire("gKrgO");

var $k17XC = parcelRequire("k17XC");
/**
 * @flow
 */ /* global window */ if (typeof window !== "undefined" && window.indexedDB) {
    var $a7018546150449c7$var$ParseStore = (0, $k17XC.createStore)("parseDB", "parseStore");
    var $a7018546150449c7$var$IndexedDBStorageController = {
        async: 1,
        getItemAsync: function(path) {
            return (0, $k17XC.get)(path, $a7018546150449c7$var$ParseStore);
        },
        setItemAsync: function(path, value) {
            return (0, $k17XC.set)(path, value, $a7018546150449c7$var$ParseStore);
        },
        removeItemAsync: function(path) {
            return (0, $k17XC.del)(path, $a7018546150449c7$var$ParseStore);
        },
        getAllKeysAsync: function() {
            return $gKrgO($k17XC)($a7018546150449c7$var$ParseStore);
        },
        clear: function() {
            return (0, $k17XC.clear)($a7018546150449c7$var$ParseStore);
        }
    };
    module.exports = $a7018546150449c7$var$IndexedDBStorageController;
} else // IndexedDB not supported
module.exports = undefined;

});
parcelRequire.register("k17XC", function(module, exports) {

$parcel$export(module.exports, "promisifyRequest", function () { return $e92a13782f6c06ba$export$b327150396135fe7; });
$parcel$export(module.exports, "createStore", function () { return $e92a13782f6c06ba$export$f51a9068ac82ea43; });
$parcel$export(module.exports, "get", function () { return $e92a13782f6c06ba$export$3988ae62b71be9a3; });
$parcel$export(module.exports, "set", function () { return $e92a13782f6c06ba$export$adaa4cf7ef1b65be; });
$parcel$export(module.exports, "setMany", function () { return $e92a13782f6c06ba$export$daa0a5170277c7a8; });
$parcel$export(module.exports, "getMany", function () { return $e92a13782f6c06ba$export$5df405cccea42673; });
$parcel$export(module.exports, "update", function () { return $e92a13782f6c06ba$export$722fbec263ad908a; });
$parcel$export(module.exports, "del", function () { return $e92a13782f6c06ba$export$1d2f21e549771e67; });
$parcel$export(module.exports, "delMany", function () { return $e92a13782f6c06ba$export$c8aa84257229cac8; });
$parcel$export(module.exports, "clear", function () { return $e92a13782f6c06ba$export$42ffd38884aecdac; });
$parcel$export(module.exports, "keys", function () { return $e92a13782f6c06ba$export$ed97f33186d4b816; });
$parcel$export(module.exports, "values", function () { return $e92a13782f6c06ba$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "entries", function () { return $e92a13782f6c06ba$export$3e9f948b41964866; });

var $9fOF9 = parcelRequire("9fOF9");
function $e92a13782f6c06ba$export$b327150396135fe7(request) {
    return new Promise(function(resolve, reject) {
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = function() {
            return resolve(request.result);
        }; // @ts-ignore - file size hacks
        request.onabort = request.onerror = function() {
            return reject(request.error);
        };
    });
}
function $e92a13782f6c06ba$export$f51a9068ac82ea43(dbName, storeName) {
    var dbp = (0, $9fOF9.default)().then(function() {
        var request = indexedDB.open(dbName);
        request.onupgradeneeded = function() {
            return request.result.createObjectStore(storeName);
        };
        return $e92a13782f6c06ba$export$b327150396135fe7(request);
    });
    return function(txMode, callback) {
        return dbp.then(function(db) {
            return callback(db.transaction(storeName, txMode).objectStore(storeName));
        });
    };
}
var $e92a13782f6c06ba$var$defaultGetStoreFunc;
function $e92a13782f6c06ba$var$defaultGetStore() {
    if (!$e92a13782f6c06ba$var$defaultGetStoreFunc) $e92a13782f6c06ba$var$defaultGetStoreFunc = $e92a13782f6c06ba$export$f51a9068ac82ea43("keyval-store", "keyval");
    return $e92a13782f6c06ba$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e92a13782f6c06ba$export$3988ae62b71be9a3(key) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $e92a13782f6c06ba$var$defaultGetStore();
    return customStore("readonly", function(store) {
        return $e92a13782f6c06ba$export$b327150396135fe7(store.get(key));
    });
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e92a13782f6c06ba$export$adaa4cf7ef1b65be(key, value) {
    var customStore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $e92a13782f6c06ba$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        store.put(value, key);
        return $e92a13782f6c06ba$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e92a13782f6c06ba$export$daa0a5170277c7a8(entries) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $e92a13782f6c06ba$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        entries.forEach(function(entry) {
            return store.put(entry[1], entry[0]);
        });
        return $e92a13782f6c06ba$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e92a13782f6c06ba$export$5df405cccea42673(keys) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $e92a13782f6c06ba$var$defaultGetStore();
    return customStore("readonly", function(store) {
        return Promise.all(keys.map(function(key) {
            return $e92a13782f6c06ba$export$b327150396135fe7(store.get(key));
        }));
    });
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e92a13782f6c06ba$export$722fbec263ad908a(key, updater) {
    var customStore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $e92a13782f6c06ba$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        return(// If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise(function(resolve, reject) {
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($e92a13782f6c06ba$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
    });
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e92a13782f6c06ba$export$1d2f21e549771e67(key) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $e92a13782f6c06ba$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        store.delete(key);
        return $e92a13782f6c06ba$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e92a13782f6c06ba$export$c8aa84257229cac8(keys) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $e92a13782f6c06ba$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        keys.forEach(function(key) {
            return store.delete(key);
        });
        return $e92a13782f6c06ba$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e92a13782f6c06ba$export$42ffd38884aecdac() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $e92a13782f6c06ba$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        store.clear();
        return $e92a13782f6c06ba$export$b327150396135fe7(store.transaction);
    });
}
function $e92a13782f6c06ba$var$eachCursor(customStore, callback) {
    return customStore("readonly", function(store) {
        // This would be store.getAllKeys(), but it isn't supported by Edge or Safari.
        // And openKeyCursor isn't supported by Safari.
        store.openCursor().onsuccess = function() {
            if (!this.result) return;
            callback(this.result);
            this.result.continue();
        };
        return $e92a13782f6c06ba$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e92a13782f6c06ba$export$ed97f33186d4b816() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $e92a13782f6c06ba$var$defaultGetStore();
    var items = [];
    return $e92a13782f6c06ba$var$eachCursor(customStore, function(cursor) {
        return items.push(cursor.key);
    }).then(function() {
        return items;
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e92a13782f6c06ba$export$68c286be0e7e55b7() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $e92a13782f6c06ba$var$defaultGetStore();
    var items = [];
    return $e92a13782f6c06ba$var$eachCursor(customStore, function(cursor) {
        return items.push(cursor.value);
    }).then(function() {
        return items;
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e92a13782f6c06ba$export$3e9f948b41964866() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $e92a13782f6c06ba$var$defaultGetStore();
    var items = [];
    return $e92a13782f6c06ba$var$eachCursor(customStore, function(cursor) {
        return items.push([
            cursor.key,
            cursor.value
        ]);
    }).then(function() {
        return items;
    });
}

});
parcelRequire.register("9fOF9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6bccd0509728121e$export$2e2bcd8739ae039; });
/**
 * Work around Safari 14 IndexedDB open bug.
 *
 * Safari has a horrible bug where IDB requests can hang while the browser is starting up. https://bugs.webkit.org/show_bug.cgi?id=226547
 * The only solution is to keep nudging it until it's awake.
 */ function $6bccd0509728121e$var$idbReady() {
    var isSafari = !navigator.userAgentData && /Safari\//.test(navigator.userAgent) && !/Chrom(e|ium)\//.test(navigator.userAgent);
    // No point putting other browsers or older versions of Safari through this mess.
    if (!isSafari || !indexedDB.databases) return Promise.resolve();
    var intervalId;
    return new Promise(function(resolve) {
        var tryIdb = function() {
            return indexedDB.databases().finally(resolve);
        };
        intervalId = setInterval(tryIdb, 100);
        tryIdb();
    }).finally(function() {
        return clearInterval(intervalId);
    });
}
var $6bccd0509728121e$export$2e2bcd8739ae039 = $6bccd0509728121e$var$idbReady;

});





})();
//# sourceMappingURL=youshouldnotbehere.22918078.js.map
